(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire12de"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire12de"] = parcelRequire;
}
parcelRequire.register("6ObR8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $4f509bf21ce2142e$export$ffb0004e005737fa; }, function (v) { return $4f509bf21ce2142e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $4f509bf21ce2142e$export$34b9dba7ce09269b; }, function (v) { return $4f509bf21ce2142e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $4f509bf21ce2142e$export$25062201e9e25d76; }, function (v) { return $4f509bf21ce2142e$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4f509bf21ce2142e$export$ffb0004e005737fa;
var $4f509bf21ce2142e$export$34b9dba7ce09269b;
var $4f509bf21ce2142e$export$25062201e9e25d76;
"use strict";

var $exYeM = parcelRequire("exYeM");
var $4f509bf21ce2142e$var$k = Symbol.for("react.element"), $4f509bf21ce2142e$var$l = Symbol.for("react.fragment"), $4f509bf21ce2142e$var$m = Object.prototype.hasOwnProperty, $4f509bf21ce2142e$var$n = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $4f509bf21ce2142e$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4f509bf21ce2142e$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$4f509bf21ce2142e$var$m.call(a, b) && !$4f509bf21ce2142e$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $4f509bf21ce2142e$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $4f509bf21ce2142e$var$n.current
    };
}
$4f509bf21ce2142e$export$ffb0004e005737fa = $4f509bf21ce2142e$var$l;
$4f509bf21ce2142e$export$34b9dba7ce09269b = $4f509bf21ce2142e$var$q;
$4f509bf21ce2142e$export$25062201e9e25d76 = $4f509bf21ce2142e$var$q;

});
parcelRequire.register("exYeM", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bzfnW"));

});
parcelRequire.register("bzfnW", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $86bee5c140ae1e47$export$dca3b0875bd9a954; }, function (v) { return $86bee5c140ae1e47$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $86bee5c140ae1e47$export$16fa2f45be04daa8; }, function (v) { return $86bee5c140ae1e47$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $86bee5c140ae1e47$export$ffb0004e005737fa; }, function (v) { return $86bee5c140ae1e47$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $86bee5c140ae1e47$export$e2c29f18771995cb; }, function (v) { return $86bee5c140ae1e47$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $86bee5c140ae1e47$export$221d75b3f55bb0bd; }, function (v) { return $86bee5c140ae1e47$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $86bee5c140ae1e47$export$5f8d39834fd61797; }, function (v) { return $86bee5c140ae1e47$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $86bee5c140ae1e47$export$74bf444e3cd11ea5; }, function (v) { return $86bee5c140ae1e47$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $86bee5c140ae1e47$export$ae55be85d98224ed; }, function (v) { return $86bee5c140ae1e47$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $86bee5c140ae1e47$export$e530037191fcd5d7; }, function (v) { return $86bee5c140ae1e47$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $86bee5c140ae1e47$export$fd42f52fd3ae1109; }, function (v) { return $86bee5c140ae1e47$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $86bee5c140ae1e47$export$c8a8987d4410bf2d; }, function (v) { return $86bee5c140ae1e47$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $86bee5c140ae1e47$export$d38cd72104c1f0e9; }, function (v) { return $86bee5c140ae1e47$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43; }, function (v) { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $86bee5c140ae1e47$export$257a8862b851cb5b; }, function (v) { return $86bee5c140ae1e47$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $86bee5c140ae1e47$export$a8257692ac88316c; }, function (v) { return $86bee5c140ae1e47$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $86bee5c140ae1e47$export$488013bae63b21da; }, function (v) { return $86bee5c140ae1e47$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $86bee5c140ae1e47$export$7c73462e0d25e514; }, function (v) { return $86bee5c140ae1e47$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $86bee5c140ae1e47$export$7568632d0d33d16d; }, function (v) { return $86bee5c140ae1e47$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $86bee5c140ae1e47$export$88948ce120ea2619; }, function (v) { return $86bee5c140ae1e47$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $86bee5c140ae1e47$export$35808ee640e87ca7; }, function (v) { return $86bee5c140ae1e47$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $86bee5c140ae1e47$export$fae74005e78b1a27; }, function (v) { return $86bee5c140ae1e47$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e; }, function (v) { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf; }, function (v) { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $86bee5c140ae1e47$export$6d9c69b0de29b591; }, function (v) { return $86bee5c140ae1e47$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $86bee5c140ae1e47$export$f680877a34711e37; }, function (v) { return $86bee5c140ae1e47$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $86bee5c140ae1e47$export$d5a552a76deda3c2; }, function (v) { return $86bee5c140ae1e47$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $86bee5c140ae1e47$export$aaabe4eda9ed9969; }, function (v) { return $86bee5c140ae1e47$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $86bee5c140ae1e47$export$e5c5a5f917a5871c; }, function (v) { return $86bee5c140ae1e47$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $86bee5c140ae1e47$export$1538c33de8887b59; }, function (v) { return $86bee5c140ae1e47$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $86bee5c140ae1e47$export$13e3392192263954; }, function (v) { return $86bee5c140ae1e47$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $86bee5c140ae1e47$export$b8f5890fc79d6aca; }, function (v) { return $86bee5c140ae1e47$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $86bee5c140ae1e47$export$60241385465d0a34; }, function (v) { return $86bee5c140ae1e47$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $86bee5c140ae1e47$export$306c0aa65ff9ec16; }, function (v) { return $86bee5c140ae1e47$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $86bee5c140ae1e47$export$7b286972b8d8ccbf; }, function (v) { return $86bee5c140ae1e47$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $86bee5c140ae1e47$export$83d89fbfd8236492; }, function (v) { return $86bee5c140ae1e47$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $86bee5c140ae1e47$export$dca3b0875bd9a954;
var $86bee5c140ae1e47$export$16fa2f45be04daa8;
var $86bee5c140ae1e47$export$ffb0004e005737fa;
var $86bee5c140ae1e47$export$e2c29f18771995cb;
var $86bee5c140ae1e47$export$221d75b3f55bb0bd;
var $86bee5c140ae1e47$export$5f8d39834fd61797;
var $86bee5c140ae1e47$export$74bf444e3cd11ea5;
var $86bee5c140ae1e47$export$ae55be85d98224ed;
var $86bee5c140ae1e47$export$e530037191fcd5d7;
var $86bee5c140ae1e47$export$fd42f52fd3ae1109;
var $86bee5c140ae1e47$export$c8a8987d4410bf2d;
var $86bee5c140ae1e47$export$d38cd72104c1f0e9;
var $86bee5c140ae1e47$export$7d1e3a5e95ceca43;
var $86bee5c140ae1e47$export$257a8862b851cb5b;
var $86bee5c140ae1e47$export$a8257692ac88316c;
var $86bee5c140ae1e47$export$488013bae63b21da;
var $86bee5c140ae1e47$export$7c73462e0d25e514;
var $86bee5c140ae1e47$export$7568632d0d33d16d;
var $86bee5c140ae1e47$export$88948ce120ea2619;
var $86bee5c140ae1e47$export$35808ee640e87ca7;
var $86bee5c140ae1e47$export$fae74005e78b1a27;
var $86bee5c140ae1e47$export$dc8fbce3eb94dc1e;
var $86bee5c140ae1e47$export$6a7bc4e911dc01cf;
var $86bee5c140ae1e47$export$6d9c69b0de29b591;
var $86bee5c140ae1e47$export$f680877a34711e37;
var $86bee5c140ae1e47$export$d5a552a76deda3c2;
var $86bee5c140ae1e47$export$aaabe4eda9ed9969;
var $86bee5c140ae1e47$export$e5c5a5f917a5871c;
var $86bee5c140ae1e47$export$1538c33de8887b59;
var $86bee5c140ae1e47$export$13e3392192263954;
var $86bee5c140ae1e47$export$b8f5890fc79d6aca;
var $86bee5c140ae1e47$export$60241385465d0a34;
var $86bee5c140ae1e47$export$306c0aa65ff9ec16;
var $86bee5c140ae1e47$export$7b286972b8d8ccbf;
var $86bee5c140ae1e47$export$83d89fbfd8236492;
"use strict";
var $86bee5c140ae1e47$var$l = Symbol.for("react.element"), $86bee5c140ae1e47$var$n = Symbol.for("react.portal"), $86bee5c140ae1e47$var$p = Symbol.for("react.fragment"), $86bee5c140ae1e47$var$q = Symbol.for("react.strict_mode"), $86bee5c140ae1e47$var$r = Symbol.for("react.profiler"), $86bee5c140ae1e47$var$t = Symbol.for("react.provider"), $86bee5c140ae1e47$var$u = Symbol.for("react.context"), $86bee5c140ae1e47$var$v = Symbol.for("react.forward_ref"), $86bee5c140ae1e47$var$w = Symbol.for("react.suspense"), $86bee5c140ae1e47$var$x = Symbol.for("react.memo"), $86bee5c140ae1e47$var$y = Symbol.for("react.lazy"), $86bee5c140ae1e47$var$z = Symbol.iterator;
function $86bee5c140ae1e47$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $86bee5c140ae1e47$var$z && a[$86bee5c140ae1e47$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $86bee5c140ae1e47$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $86bee5c140ae1e47$var$C = Object.assign, $86bee5c140ae1e47$var$D = {};
function $86bee5c140ae1e47$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
$86bee5c140ae1e47$var$E.prototype.isReactComponent = {};
$86bee5c140ae1e47$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$86bee5c140ae1e47$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $86bee5c140ae1e47$var$F() {}
$86bee5c140ae1e47$var$F.prototype = $86bee5c140ae1e47$var$E.prototype;
function $86bee5c140ae1e47$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
var $86bee5c140ae1e47$var$H = $86bee5c140ae1e47$var$G.prototype = new $86bee5c140ae1e47$var$F;
$86bee5c140ae1e47$var$H.constructor = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$var$C($86bee5c140ae1e47$var$H, $86bee5c140ae1e47$var$E.prototype);
$86bee5c140ae1e47$var$H.isPureReactComponent = !0;
var $86bee5c140ae1e47$var$I = Array.isArray, $86bee5c140ae1e47$var$J = Object.prototype.hasOwnProperty, $86bee5c140ae1e47$var$K = {
    current: null
}, $86bee5c140ae1e47$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $86bee5c140ae1e47$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$86bee5c140ae1e47$var$J.call(b, d) && !$86bee5c140ae1e47$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $86bee5c140ae1e47$var$K.current
    };
}
function $86bee5c140ae1e47$var$N(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $86bee5c140ae1e47$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $86bee5c140ae1e47$var$l;
}
function $86bee5c140ae1e47$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $86bee5c140ae1e47$var$P = /\/+/g;
function $86bee5c140ae1e47$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $86bee5c140ae1e47$var$escape("" + a.key) : b.toString(36);
}
function $86bee5c140ae1e47$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $86bee5c140ae1e47$var$l:
                case $86bee5c140ae1e47$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $86bee5c140ae1e47$var$Q(h, 0) : d, $86bee5c140ae1e47$var$I(c) ? (e = "", null != a && (e = a.replace($86bee5c140ae1e47$var$P, "$&/") + "/"), $86bee5c140ae1e47$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($86bee5c140ae1e47$var$O(c) && (c = $86bee5c140ae1e47$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($86bee5c140ae1e47$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($86bee5c140ae1e47$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $86bee5c140ae1e47$var$Q(k, g);
        h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    }
    else if (f = $86bee5c140ae1e47$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $86bee5c140ae1e47$var$Q(k, g++), h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $86bee5c140ae1e47$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $86bee5c140ae1e47$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $86bee5c140ae1e47$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $86bee5c140ae1e47$var$U = {
    current: null
}, $86bee5c140ae1e47$var$V = {
    transition: null
}, $86bee5c140ae1e47$var$W = {
    ReactCurrentDispatcher: $86bee5c140ae1e47$var$U,
    ReactCurrentBatchConfig: $86bee5c140ae1e47$var$V,
    ReactCurrentOwner: $86bee5c140ae1e47$var$K
};
$86bee5c140ae1e47$export$dca3b0875bd9a954 = {
    map: $86bee5c140ae1e47$var$S,
    forEach: function(a, b, e) {
        $86bee5c140ae1e47$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $86bee5c140ae1e47$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $86bee5c140ae1e47$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$86bee5c140ae1e47$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$86bee5c140ae1e47$export$16fa2f45be04daa8 = $86bee5c140ae1e47$var$E;
$86bee5c140ae1e47$export$ffb0004e005737fa = $86bee5c140ae1e47$var$p;
$86bee5c140ae1e47$export$e2c29f18771995cb = $86bee5c140ae1e47$var$r;
$86bee5c140ae1e47$export$221d75b3f55bb0bd = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$export$5f8d39834fd61797 = $86bee5c140ae1e47$var$q;
$86bee5c140ae1e47$export$74bf444e3cd11ea5 = $86bee5c140ae1e47$var$w;
$86bee5c140ae1e47$export$ae55be85d98224ed = $86bee5c140ae1e47$var$W;
$86bee5c140ae1e47$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $86bee5c140ae1e47$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $86bee5c140ae1e47$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$86bee5c140ae1e47$var$J.call(b, f) && !$86bee5c140ae1e47$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$86bee5c140ae1e47$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $86bee5c140ae1e47$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $86bee5c140ae1e47$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$86bee5c140ae1e47$export$c8a8987d4410bf2d = $86bee5c140ae1e47$var$M;
$86bee5c140ae1e47$export$d38cd72104c1f0e9 = function(a) {
    var b = $86bee5c140ae1e47$var$M.bind(null, a);
    b.type = a;
    return b;
};
$86bee5c140ae1e47$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$86bee5c140ae1e47$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$v,
        render: a
    };
};
$86bee5c140ae1e47$export$a8257692ac88316c = $86bee5c140ae1e47$var$O;
$86bee5c140ae1e47$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $86bee5c140ae1e47$var$T
    };
};
$86bee5c140ae1e47$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$86bee5c140ae1e47$export$7568632d0d33d16d = function(a) {
    var b = $86bee5c140ae1e47$var$V.transition;
    $86bee5c140ae1e47$var$V.transition = {};
    try {
        a();
    } finally{
        $86bee5c140ae1e47$var$V.transition = b;
    }
};
$86bee5c140ae1e47$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$86bee5c140ae1e47$export$35808ee640e87ca7 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useCallback(a, b);
};
$86bee5c140ae1e47$export$fae74005e78b1a27 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useContext(a);
};
$86bee5c140ae1e47$export$dc8fbce3eb94dc1e = function() {};
$86bee5c140ae1e47$export$6a7bc4e911dc01cf = function(a) {
    return $86bee5c140ae1e47$var$U.current.useDeferredValue(a);
};
$86bee5c140ae1e47$export$6d9c69b0de29b591 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useEffect(a, b);
};
$86bee5c140ae1e47$export$f680877a34711e37 = function() {
    return $86bee5c140ae1e47$var$U.current.useId();
};
$86bee5c140ae1e47$export$d5a552a76deda3c2 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useImperativeHandle(a, b, e);
};
$86bee5c140ae1e47$export$aaabe4eda9ed9969 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useInsertionEffect(a, b);
};
$86bee5c140ae1e47$export$e5c5a5f917a5871c = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useLayoutEffect(a, b);
};
$86bee5c140ae1e47$export$1538c33de8887b59 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useMemo(a, b);
};
$86bee5c140ae1e47$export$13e3392192263954 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useReducer(a, b, e);
};
$86bee5c140ae1e47$export$b8f5890fc79d6aca = function(a) {
    return $86bee5c140ae1e47$var$U.current.useRef(a);
};
$86bee5c140ae1e47$export$60241385465d0a34 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useState(a);
};
$86bee5c140ae1e47$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useSyncExternalStore(a, b, e);
};
$86bee5c140ae1e47$export$7b286972b8d8ccbf = function() {
    return $86bee5c140ae1e47$var$U.current.useTransition();
};
$86bee5c140ae1e47$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("h8vP0", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c79bde28d689cb05$export$ae55be85d98224ed; }, function (v) { return $c79bde28d689cb05$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $c79bde28d689cb05$export$d39a5bbd09211389; }, function (v) { return $c79bde28d689cb05$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $c79bde28d689cb05$export$882461b6382ed46c; }, function (v) { return $c79bde28d689cb05$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $c79bde28d689cb05$export$466bfc07425424d5; }, function (v) { return $c79bde28d689cb05$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c79bde28d689cb05$export$cd75ccfd720a3cd4; }, function (v) { return $c79bde28d689cb05$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $c79bde28d689cb05$export$fa8d919ba61d84db; }, function (v) { return $c79bde28d689cb05$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c79bde28d689cb05$export$757ceba2d55c277e; }, function (v) { return $c79bde28d689cb05$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $c79bde28d689cb05$export$b3890eb0ae9dca99; }, function (v) { return $c79bde28d689cb05$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $c79bde28d689cb05$export$502457920280e6be; }, function (v) { return $c79bde28d689cb05$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c79bde28d689cb05$export$c78a37762a8d58e1; }, function (v) { return $c79bde28d689cb05$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $c79bde28d689cb05$export$dc54d992c10e8a18; }, function (v) { return $c79bde28d689cb05$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $c79bde28d689cb05$export$83d89fbfd8236492; }, function (v) { return $c79bde28d689cb05$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c79bde28d689cb05$export$ae55be85d98224ed;
var $c79bde28d689cb05$export$d39a5bbd09211389;
var $c79bde28d689cb05$export$882461b6382ed46c;
var $c79bde28d689cb05$export$466bfc07425424d5;
var $c79bde28d689cb05$export$cd75ccfd720a3cd4;
var $c79bde28d689cb05$export$fa8d919ba61d84db;
var $c79bde28d689cb05$export$757ceba2d55c277e;
var $c79bde28d689cb05$export$b3890eb0ae9dca99;
var $c79bde28d689cb05$export$502457920280e6be;
var $c79bde28d689cb05$export$c78a37762a8d58e1;
var $c79bde28d689cb05$export$dc54d992c10e8a18;
var $c79bde28d689cb05$export$83d89fbfd8236492;
"use strict";

var $exYeM = parcelRequire("exYeM");

var $ibqfJ = parcelRequire("ibqfJ");
function $c79bde28d689cb05$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c79bde28d689cb05$var$da = new Set, $c79bde28d689cb05$var$ea = {};
function $c79bde28d689cb05$var$fa(a, b) {
    $c79bde28d689cb05$var$ha(a, b);
    $c79bde28d689cb05$var$ha(a + "Capture", b);
}
function $c79bde28d689cb05$var$ha(a, b) {
    $c79bde28d689cb05$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$da.add(b[a]);
}
var $c79bde28d689cb05$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c79bde28d689cb05$var$ja = Object.prototype.hasOwnProperty, $c79bde28d689cb05$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c79bde28d689cb05$var$la = {}, $c79bde28d689cb05$var$ma = {};
function $c79bde28d689cb05$var$oa(a) {
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$ma, a)) return !0;
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$la, a)) return !1;
    if ($c79bde28d689cb05$var$ka.test(a)) return $c79bde28d689cb05$var$ma[a] = !0;
    $c79bde28d689cb05$var$la[a] = !0;
    return !1;
}
function $c79bde28d689cb05$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c79bde28d689cb05$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c79bde28d689cb05$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c79bde28d689cb05$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c79bde28d689cb05$var$ra = /[\-:]([a-z])/g;
function $c79bde28d689cb05$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c79bde28d689cb05$var$z.xlinkHref = new $c79bde28d689cb05$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c79bde28d689cb05$var$ta(a, b, c, d) {
    var e = $c79bde28d689cb05$var$z.hasOwnProperty(b) ? $c79bde28d689cb05$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c79bde28d689cb05$var$qa(b, c, e, d) && (c = null), d || null === e ? $c79bde28d689cb05$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c79bde28d689cb05$var$ua = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c79bde28d689cb05$var$va = Symbol.for("react.element"), $c79bde28d689cb05$var$wa = Symbol.for("react.portal"), $c79bde28d689cb05$var$ya = Symbol.for("react.fragment"), $c79bde28d689cb05$var$za = Symbol.for("react.strict_mode"), $c79bde28d689cb05$var$Aa = Symbol.for("react.profiler"), $c79bde28d689cb05$var$Ba = Symbol.for("react.provider"), $c79bde28d689cb05$var$Ca = Symbol.for("react.context"), $c79bde28d689cb05$var$Da = Symbol.for("react.forward_ref"), $c79bde28d689cb05$var$Ea = Symbol.for("react.suspense"), $c79bde28d689cb05$var$Fa = Symbol.for("react.suspense_list"), $c79bde28d689cb05$var$Ga = Symbol.for("react.memo"), $c79bde28d689cb05$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c79bde28d689cb05$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c79bde28d689cb05$var$Ja = Symbol.iterator;
function $c79bde28d689cb05$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c79bde28d689cb05$var$Ja && a[$c79bde28d689cb05$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c79bde28d689cb05$var$A = Object.assign, $c79bde28d689cb05$var$La;
function $c79bde28d689cb05$var$Ma(a) {
    if (void 0 === $c79bde28d689cb05$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c79bde28d689cb05$var$La = b && b[1] || "";
    }
    return "\n" + $c79bde28d689cb05$var$La + a;
}
var $c79bde28d689cb05$var$Na = !1;
function $c79bde28d689cb05$var$Oa(a, b) {
    if (!a || $c79bde28d689cb05$var$Na) return "";
    $c79bde28d689cb05$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c79bde28d689cb05$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c79bde28d689cb05$var$Ma(a) : "";
}
function $c79bde28d689cb05$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c79bde28d689cb05$var$Ma(a.type);
        case 16:
            return $c79bde28d689cb05$var$Ma("Lazy");
        case 13:
            return $c79bde28d689cb05$var$Ma("Suspense");
        case 19:
            return $c79bde28d689cb05$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c79bde28d689cb05$var$Oa(a.type, !1), a;
        case 11:
            return a = $c79bde28d689cb05$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c79bde28d689cb05$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c79bde28d689cb05$var$ya:
            return "Fragment";
        case $c79bde28d689cb05$var$wa:
            return "Portal";
        case $c79bde28d689cb05$var$Aa:
            return "Profiler";
        case $c79bde28d689cb05$var$za:
            return "StrictMode";
        case $c79bde28d689cb05$var$Ea:
            return "Suspense";
        case $c79bde28d689cb05$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c79bde28d689cb05$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c79bde28d689cb05$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c79bde28d689cb05$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c79bde28d689cb05$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c79bde28d689cb05$var$Qa(a.type) || "Memo";
        case $c79bde28d689cb05$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c79bde28d689cb05$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c79bde28d689cb05$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c79bde28d689cb05$var$Qa(b);
        case 8:
            return b === $c79bde28d689cb05$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c79bde28d689cb05$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c79bde28d689cb05$var$Ua(a) {
    var b = $c79bde28d689cb05$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c79bde28d689cb05$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c79bde28d689cb05$var$Ua(a));
}
function $c79bde28d689cb05$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c79bde28d689cb05$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c79bde28d689cb05$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c79bde28d689cb05$var$Ya(a, b) {
    var c = b.checked;
    return $c79bde28d689cb05$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c79bde28d689cb05$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c79bde28d689cb05$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c79bde28d689cb05$var$ab(a, b) {
    b = b.checked;
    null != b && $c79bde28d689cb05$var$ta(a, "checked", b, !1);
}
function $c79bde28d689cb05$var$bb(a, b) {
    $c79bde28d689cb05$var$ab(a, b);
    var c = $c79bde28d689cb05$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c79bde28d689cb05$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c79bde28d689cb05$var$cb(a, b.type, $c79bde28d689cb05$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c79bde28d689cb05$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c79bde28d689cb05$var$cb(a, b, c) {
    if ("number" !== b || $c79bde28d689cb05$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c79bde28d689cb05$var$eb = Array.isArray;
function $c79bde28d689cb05$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c79bde28d689cb05$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c79bde28d689cb05$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c79bde28d689cb05$var$p(91));
    return $c79bde28d689cb05$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c79bde28d689cb05$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c79bde28d689cb05$var$p(92));
            if ($c79bde28d689cb05$var$eb(c)) {
                if (1 < c.length) throw Error($c79bde28d689cb05$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c79bde28d689cb05$var$Sa(c)
    };
}
function $c79bde28d689cb05$var$ib(a, b) {
    var c = $c79bde28d689cb05$var$Sa(b.value), d = $c79bde28d689cb05$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c79bde28d689cb05$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c79bde28d689cb05$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c79bde28d689cb05$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c79bde28d689cb05$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c79bde28d689cb05$var$mb, $c79bde28d689cb05$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c79bde28d689cb05$var$mb = $c79bde28d689cb05$var$mb || document.createElement("div");
        $c79bde28d689cb05$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c79bde28d689cb05$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c79bde28d689cb05$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c79bde28d689cb05$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c79bde28d689cb05$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c79bde28d689cb05$var$pb).forEach(function(a) {
    $c79bde28d689cb05$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c79bde28d689cb05$var$pb[b] = $c79bde28d689cb05$var$pb[a];
    });
});
function $c79bde28d689cb05$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c79bde28d689cb05$var$pb.hasOwnProperty(a) && $c79bde28d689cb05$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c79bde28d689cb05$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c79bde28d689cb05$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c79bde28d689cb05$var$tb = $c79bde28d689cb05$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c79bde28d689cb05$var$ub(a, b) {
    if (b) {
        if ($c79bde28d689cb05$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c79bde28d689cb05$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c79bde28d689cb05$var$p(62));
    }
}
function $c79bde28d689cb05$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c79bde28d689cb05$var$wb = null;
function $c79bde28d689cb05$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c79bde28d689cb05$var$yb = null, $c79bde28d689cb05$var$zb = null, $c79bde28d689cb05$var$Ab = null;
function $c79bde28d689cb05$var$Bb(a) {
    if (a = $c79bde28d689cb05$var$Cb(a)) {
        if ("function" !== typeof $c79bde28d689cb05$var$yb) throw Error($c79bde28d689cb05$var$p(280));
        var b = a.stateNode;
        b && (b = $c79bde28d689cb05$var$Db(b), $c79bde28d689cb05$var$yb(a.stateNode, a.type, b));
    }
}
function $c79bde28d689cb05$var$Eb(a) {
    $c79bde28d689cb05$var$zb ? $c79bde28d689cb05$var$Ab ? $c79bde28d689cb05$var$Ab.push(a) : $c79bde28d689cb05$var$Ab = [
        a
    ] : $c79bde28d689cb05$var$zb = a;
}
function $c79bde28d689cb05$var$Fb() {
    if ($c79bde28d689cb05$var$zb) {
        var a = $c79bde28d689cb05$var$zb, b = $c79bde28d689cb05$var$Ab;
        $c79bde28d689cb05$var$Ab = $c79bde28d689cb05$var$zb = null;
        $c79bde28d689cb05$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$Bb(b[a]);
    }
}
function $c79bde28d689cb05$var$Gb(a, b) {
    return a(b);
}
function $c79bde28d689cb05$var$Hb() {}
var $c79bde28d689cb05$var$Ib = !1;
function $c79bde28d689cb05$var$Jb(a, b, c) {
    if ($c79bde28d689cb05$var$Ib) return a(b, c);
    $c79bde28d689cb05$var$Ib = !0;
    try {
        return $c79bde28d689cb05$var$Gb(a, b, c);
    } finally{
        if ($c79bde28d689cb05$var$Ib = !1, null !== $c79bde28d689cb05$var$zb || null !== $c79bde28d689cb05$var$Ab) $c79bde28d689cb05$var$Hb(), $c79bde28d689cb05$var$Fb();
    }
}
function $c79bde28d689cb05$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c79bde28d689cb05$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c79bde28d689cb05$var$p(231, b, typeof c));
    return c;
}
var $c79bde28d689cb05$var$Lb = !1;
if ($c79bde28d689cb05$var$ia) try {
    var $c79bde28d689cb05$var$Mb = {};
    Object.defineProperty($c79bde28d689cb05$var$Mb, "passive", {
        get: function() {
            $c79bde28d689cb05$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
    window.removeEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
} catch (a) {
    $c79bde28d689cb05$var$Lb = !1;
}
function $c79bde28d689cb05$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $c79bde28d689cb05$var$Ob = !1, $c79bde28d689cb05$var$Pb = null, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, $c79bde28d689cb05$var$Sb = {
    onError: function(a) {
        $c79bde28d689cb05$var$Ob = !0;
        $c79bde28d689cb05$var$Pb = a;
    }
};
function $c79bde28d689cb05$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Ob = !1;
    $c79bde28d689cb05$var$Pb = null;
    $c79bde28d689cb05$var$Nb.apply($c79bde28d689cb05$var$Sb, arguments);
}
function $c79bde28d689cb05$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Tb.apply(this, arguments);
    if ($c79bde28d689cb05$var$Ob) {
        if ($c79bde28d689cb05$var$Ob) {
            var l = $c79bde28d689cb05$var$Pb;
            $c79bde28d689cb05$var$Ob = !1;
            $c79bde28d689cb05$var$Pb = null;
        } else throw Error($c79bde28d689cb05$var$p(198));
        $c79bde28d689cb05$var$Qb || ($c79bde28d689cb05$var$Qb = !0, $c79bde28d689cb05$var$Rb = l);
    }
}
function $c79bde28d689cb05$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c79bde28d689cb05$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c79bde28d689cb05$var$Xb(a) {
    if ($c79bde28d689cb05$var$Vb(a) !== a) throw Error($c79bde28d689cb05$var$p(188));
}
function $c79bde28d689cb05$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c79bde28d689cb05$var$Vb(a);
        if (null === b) throw Error($c79bde28d689cb05$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c79bde28d689cb05$var$Xb(e), a;
                if (f === d) return $c79bde28d689cb05$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c79bde28d689cb05$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c79bde28d689cb05$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c79bde28d689cb05$var$p(190));
    }
    if (3 !== c.tag) throw Error($c79bde28d689cb05$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c79bde28d689cb05$var$Zb(a) {
    a = $c79bde28d689cb05$var$Yb(a);
    return null !== a ? $c79bde28d689cb05$var$$b(a) : null;
}
function $c79bde28d689cb05$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c79bde28d689cb05$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$ac = $ibqfJ.unstable_scheduleCallback, $c79bde28d689cb05$var$bc = $ibqfJ.unstable_cancelCallback, $c79bde28d689cb05$var$cc = $ibqfJ.unstable_shouldYield, $c79bde28d689cb05$var$dc = $ibqfJ.unstable_requestPaint, $c79bde28d689cb05$var$B = $ibqfJ.unstable_now, $c79bde28d689cb05$var$ec = $ibqfJ.unstable_getCurrentPriorityLevel, $c79bde28d689cb05$var$fc = $ibqfJ.unstable_ImmediatePriority, $c79bde28d689cb05$var$gc = $ibqfJ.unstable_UserBlockingPriority, $c79bde28d689cb05$var$hc = $ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$ic = $ibqfJ.unstable_LowPriority, $c79bde28d689cb05$var$jc = $ibqfJ.unstable_IdlePriority, $c79bde28d689cb05$var$kc = null, $c79bde28d689cb05$var$lc = null;
function $c79bde28d689cb05$var$mc(a) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberRoot) try {
        $c79bde28d689cb05$var$lc.onCommitFiberRoot($c79bde28d689cb05$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $c79bde28d689cb05$var$oc = Math.clz32 ? Math.clz32 : $c79bde28d689cb05$var$nc, $c79bde28d689cb05$var$pc = Math.log, $c79bde28d689cb05$var$qc = Math.LN2;
function $c79bde28d689cb05$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c79bde28d689cb05$var$pc(a) / $c79bde28d689cb05$var$qc | 0) | 0;
}
var $c79bde28d689cb05$var$rc = 64, $c79bde28d689cb05$var$sc = 4194304;
function $c79bde28d689cb05$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c79bde28d689cb05$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c79bde28d689cb05$var$tc(h) : (f &= g, 0 !== f && (d = $c79bde28d689cb05$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $c79bde28d689cb05$var$tc(g) : 0 !== f && (d = $c79bde28d689cb05$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c79bde28d689cb05$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c79bde28d689cb05$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c79bde28d689cb05$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c79bde28d689cb05$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c79bde28d689cb05$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c79bde28d689cb05$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c79bde28d689cb05$var$yc() {
    var a = $c79bde28d689cb05$var$rc;
    $c79bde28d689cb05$var$rc <<= 1;
    0 === ($c79bde28d689cb05$var$rc & 4194240) && ($c79bde28d689cb05$var$rc = 64);
    return a;
}
function $c79bde28d689cb05$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c79bde28d689cb05$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c79bde28d689cb05$var$oc(b);
    a[b] = c;
}
function $c79bde28d689cb05$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c79bde28d689cb05$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c79bde28d689cb05$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c79bde28d689cb05$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $c79bde28d689cb05$var$C = 0;
function $c79bde28d689cb05$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c79bde28d689cb05$var$Ec, $c79bde28d689cb05$var$Fc, $c79bde28d689cb05$var$Gc, $c79bde28d689cb05$var$Hc, $c79bde28d689cb05$var$Ic, $c79bde28d689cb05$var$Jc = !1, $c79bde28d689cb05$var$Kc = [], $c79bde28d689cb05$var$Lc = null, $c79bde28d689cb05$var$Mc = null, $c79bde28d689cb05$var$Nc = null, $c79bde28d689cb05$var$Oc = new Map, $c79bde28d689cb05$var$Pc = new Map, $c79bde28d689cb05$var$Qc = [], $c79bde28d689cb05$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c79bde28d689cb05$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c79bde28d689cb05$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c79bde28d689cb05$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $c79bde28d689cb05$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $c79bde28d689cb05$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c79bde28d689cb05$var$Pc.delete(b.pointerId);
    }
}
function $c79bde28d689cb05$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c79bde28d689cb05$var$Cb(b), null !== b && $c79bde28d689cb05$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c79bde28d689cb05$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c79bde28d689cb05$var$Lc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $c79bde28d689cb05$var$Mc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $c79bde28d689cb05$var$Nc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c79bde28d689cb05$var$Oc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c79bde28d689cb05$var$Pc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c79bde28d689cb05$var$Vc(a) {
    var b = $c79bde28d689cb05$var$Wc(a.target);
    if (null !== b) {
        var c = $c79bde28d689cb05$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c79bde28d689cb05$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c79bde28d689cb05$var$Ic(a.priority, function() {
                        $c79bde28d689cb05$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c79bde28d689cb05$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c79bde28d689cb05$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c79bde28d689cb05$var$wb = d;
            c.target.dispatchEvent(d);
            $c79bde28d689cb05$var$wb = null;
        } else return b = $c79bde28d689cb05$var$Cb(c), null !== b && $c79bde28d689cb05$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c79bde28d689cb05$var$Zc(a, b, c) {
    $c79bde28d689cb05$var$Xc(a) && c.delete(b);
}
function $c79bde28d689cb05$var$$c() {
    $c79bde28d689cb05$var$Jc = !1;
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Lc) && ($c79bde28d689cb05$var$Lc = null);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Mc) && ($c79bde28d689cb05$var$Mc = null);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Nc) && ($c79bde28d689cb05$var$Nc = null);
    $c79bde28d689cb05$var$Oc.forEach($c79bde28d689cb05$var$Zc);
    $c79bde28d689cb05$var$Pc.forEach($c79bde28d689cb05$var$Zc);
}
function $c79bde28d689cb05$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c79bde28d689cb05$var$Jc || ($c79bde28d689cb05$var$Jc = !0, $ibqfJ.unstable_scheduleCallback($ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$$c)));
}
function $c79bde28d689cb05$var$bd(a) {
    function b(b) {
        return $c79bde28d689cb05$var$ad(b, a);
    }
    if (0 < $c79bde28d689cb05$var$Kc.length) {
        $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Kc[0], a);
        for(var c = 1; c < $c79bde28d689cb05$var$Kc.length; c++){
            var d = $c79bde28d689cb05$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Lc, a);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Mc, a);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Nc, a);
    $c79bde28d689cb05$var$Oc.forEach(b);
    $c79bde28d689cb05$var$Pc.forEach(b);
    for(c = 0; c < $c79bde28d689cb05$var$Qc.length; c++)d = $c79bde28d689cb05$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c79bde28d689cb05$var$Qc.length && (c = $c79bde28d689cb05$var$Qc[0], null === c.blockedOn);)$c79bde28d689cb05$var$Vc(c), null === c.blockedOn && $c79bde28d689cb05$var$Qc.shift();
}
var $c79bde28d689cb05$var$cd = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$dd = !0;
function $c79bde28d689cb05$var$ed(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$gd(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 4, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$fd(a, b, c, d) {
    if ($c79bde28d689cb05$var$dd) {
        var e = $c79bde28d689cb05$var$Yc(a, b, c, d);
        if (null === e) $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c), $c79bde28d689cb05$var$Sc(a, d);
        else if ($c79bde28d689cb05$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($c79bde28d689cb05$var$Sc(a, d), b & 4 && -1 < $c79bde28d689cb05$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $c79bde28d689cb05$var$Cb(e);
                null !== f && $c79bde28d689cb05$var$Ec(f);
                f = $c79bde28d689cb05$var$Yc(a, b, c, d);
                null === f && $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c79bde28d689cb05$var$hd(a, b, d, null, c);
    }
}
var $c79bde28d689cb05$var$id = null;
function $c79bde28d689cb05$var$Yc(a, b, c, d) {
    $c79bde28d689cb05$var$id = null;
    a = $c79bde28d689cb05$var$xb(d);
    a = $c79bde28d689cb05$var$Wc(a);
    if (null !== a) {
        if (b = $c79bde28d689cb05$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c79bde28d689cb05$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c79bde28d689cb05$var$id = a;
    return null;
}
function $c79bde28d689cb05$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c79bde28d689cb05$var$ec()){
                case $c79bde28d689cb05$var$fc:
                    return 1;
                case $c79bde28d689cb05$var$gc:
                    return 4;
                case $c79bde28d689cb05$var$hc:
                case $c79bde28d689cb05$var$ic:
                    return 16;
                case $c79bde28d689cb05$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ld = null, $c79bde28d689cb05$var$md = null;
function $c79bde28d689cb05$var$nd() {
    if ($c79bde28d689cb05$var$md) return $c79bde28d689cb05$var$md;
    var a, b = $c79bde28d689cb05$var$ld, c = b.length, d, e = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c79bde28d689cb05$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c79bde28d689cb05$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c79bde28d689cb05$var$pd() {
    return !0;
}
function $c79bde28d689cb05$var$qd() {
    return !1;
}
function $c79bde28d689cb05$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c79bde28d689cb05$var$pd : $c79bde28d689cb05$var$qd;
        this.isPropagationStopped = $c79bde28d689cb05$var$qd;
        return this;
    }
    $c79bde28d689cb05$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $c79bde28d689cb05$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $c79bde28d689cb05$var$pd);
        },
        persist: function() {},
        isPersistent: $c79bde28d689cb05$var$pd
    });
    return b;
}
var $c79bde28d689cb05$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c79bde28d689cb05$var$td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$sd), $c79bde28d689cb05$var$ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    view: 0,
    detail: 0
}), $c79bde28d689cb05$var$vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$ud), $c79bde28d689cb05$var$wd, $c79bde28d689cb05$var$xd, $c79bde28d689cb05$var$yd, $c79bde28d689cb05$var$Ad = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c79bde28d689cb05$var$yd && ($c79bde28d689cb05$var$yd && "mousemove" === a.type ? ($c79bde28d689cb05$var$wd = a.screenX - $c79bde28d689cb05$var$yd.screenX, $c79bde28d689cb05$var$xd = a.screenY - $c79bde28d689cb05$var$yd.screenY) : $c79bde28d689cb05$var$xd = $c79bde28d689cb05$var$wd = 0, $c79bde28d689cb05$var$yd = a);
        return $c79bde28d689cb05$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $c79bde28d689cb05$var$xd;
    }
}), $c79bde28d689cb05$var$Bd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ad), $c79bde28d689cb05$var$Cd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    dataTransfer: 0
}), $c79bde28d689cb05$var$Dd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Cd), $c79bde28d689cb05$var$Ed = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    relatedTarget: 0
}), $c79bde28d689cb05$var$Fd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ed), $c79bde28d689cb05$var$Gd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Hd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Gd), $c79bde28d689cb05$var$Id = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c79bde28d689cb05$var$Jd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Id), $c79bde28d689cb05$var$Kd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    data: 0
}), $c79bde28d689cb05$var$Ld = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Kd), $c79bde28d689cb05$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c79bde28d689cb05$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c79bde28d689cb05$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c79bde28d689cb05$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c79bde28d689cb05$var$Od[a]) ? !!b[a] : !1;
}
function $c79bde28d689cb05$var$zd() {
    return $c79bde28d689cb05$var$Pd;
}
var $c79bde28d689cb05$var$Qd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $c79bde28d689cb05$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c79bde28d689cb05$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c79bde28d689cb05$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c79bde28d689cb05$var$Rd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Qd), $c79bde28d689cb05$var$Sd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c79bde28d689cb05$var$Td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Sd), $c79bde28d689cb05$var$Ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd
}), $c79bde28d689cb05$var$Vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ud), $c79bde28d689cb05$var$Wd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Xd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Wd), $c79bde28d689cb05$var$Yd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c79bde28d689cb05$var$Zd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Yd), $c79bde28d689cb05$var$$d = [
    9,
    13,
    27,
    32
], $c79bde28d689cb05$var$ae = $c79bde28d689cb05$var$ia && "CompositionEvent" in window, $c79bde28d689cb05$var$be = null;
$c79bde28d689cb05$var$ia && "documentMode" in document && ($c79bde28d689cb05$var$be = document.documentMode);
var $c79bde28d689cb05$var$ce = $c79bde28d689cb05$var$ia && "TextEvent" in window && !$c79bde28d689cb05$var$be, $c79bde28d689cb05$var$de = $c79bde28d689cb05$var$ia && (!$c79bde28d689cb05$var$ae || $c79bde28d689cb05$var$be && 8 < $c79bde28d689cb05$var$be && 11 >= $c79bde28d689cb05$var$be), $c79bde28d689cb05$var$ee = String.fromCharCode(32), $c79bde28d689cb05$var$fe = !1;
function $c79bde28d689cb05$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c79bde28d689cb05$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c79bde28d689cb05$var$ie = !1;
function $c79bde28d689cb05$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $c79bde28d689cb05$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c79bde28d689cb05$var$fe = !0;
            return $c79bde28d689cb05$var$ee;
        case "textInput":
            return a = b.data, a === $c79bde28d689cb05$var$ee && $c79bde28d689cb05$var$fe ? null : a;
        default:
            return null;
    }
}
function $c79bde28d689cb05$var$ke(a, b) {
    if ($c79bde28d689cb05$var$ie) return "compositionend" === a || !$c79bde28d689cb05$var$ae && $c79bde28d689cb05$var$ge(a, b) ? (a = $c79bde28d689cb05$var$nd(), $c79bde28d689cb05$var$md = $c79bde28d689cb05$var$ld = $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c79bde28d689cb05$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c79bde28d689cb05$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c79bde28d689cb05$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $c79bde28d689cb05$var$ne(a, b, c, d) {
    $c79bde28d689cb05$var$Eb(d);
    b = $c79bde28d689cb05$var$oe(b, "onChange");
    0 < b.length && (c = new $c79bde28d689cb05$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c79bde28d689cb05$var$pe = null, $c79bde28d689cb05$var$qe = null;
function $c79bde28d689cb05$var$re(a) {
    $c79bde28d689cb05$var$se(a, 0);
}
function $c79bde28d689cb05$var$te(a) {
    var b = $c79bde28d689cb05$var$ue(a);
    if ($c79bde28d689cb05$var$Wa(b)) return a;
}
function $c79bde28d689cb05$var$ve(a, b) {
    if ("change" === a) return b;
}
var $c79bde28d689cb05$var$we = !1;
if ($c79bde28d689cb05$var$ia) {
    var $c79bde28d689cb05$var$xe;
    if ($c79bde28d689cb05$var$ia) {
        var $c79bde28d689cb05$var$ye = "oninput" in document;
        if (!$c79bde28d689cb05$var$ye) {
            var $c79bde28d689cb05$var$ze = document.createElement("div");
            $c79bde28d689cb05$var$ze.setAttribute("oninput", "return;");
            $c79bde28d689cb05$var$ye = "function" === typeof $c79bde28d689cb05$var$ze.oninput;
        }
        $c79bde28d689cb05$var$xe = $c79bde28d689cb05$var$ye;
    } else $c79bde28d689cb05$var$xe = !1;
    $c79bde28d689cb05$var$we = $c79bde28d689cb05$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $c79bde28d689cb05$var$Ae() {
    $c79bde28d689cb05$var$pe && ($c79bde28d689cb05$var$pe.detachEvent("onpropertychange", $c79bde28d689cb05$var$Be), $c79bde28d689cb05$var$qe = $c79bde28d689cb05$var$pe = null);
}
function $c79bde28d689cb05$var$Be(a) {
    if ("value" === a.propertyName && $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe)) {
        var b = [];
        $c79bde28d689cb05$var$ne(b, $c79bde28d689cb05$var$qe, a, $c79bde28d689cb05$var$xb(a));
        $c79bde28d689cb05$var$Jb($c79bde28d689cb05$var$re, b);
    }
}
function $c79bde28d689cb05$var$Ce(a, b, c) {
    "focusin" === a ? ($c79bde28d689cb05$var$Ae(), $c79bde28d689cb05$var$pe = b, $c79bde28d689cb05$var$qe = c, $c79bde28d689cb05$var$pe.attachEvent("onpropertychange", $c79bde28d689cb05$var$Be)) : "focusout" === a && $c79bde28d689cb05$var$Ae();
}
function $c79bde28d689cb05$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe);
}
function $c79bde28d689cb05$var$Ee(a, b) {
    if ("click" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c79bde28d689cb05$var$He = "function" === typeof Object.is ? Object.is : $c79bde28d689cb05$var$Ge;
function $c79bde28d689cb05$var$Ie(a, b) {
    if ($c79bde28d689cb05$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c79bde28d689cb05$var$ja.call(b, e) || !$c79bde28d689cb05$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $c79bde28d689cb05$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c79bde28d689cb05$var$Ke(a, b) {
    var c = $c79bde28d689cb05$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c79bde28d689cb05$var$Je(c);
    }
}
function $c79bde28d689cb05$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c79bde28d689cb05$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c79bde28d689cb05$var$Me() {
    for(var a = window, b = $c79bde28d689cb05$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c79bde28d689cb05$var$Xa(a.document);
    }
    return b;
}
function $c79bde28d689cb05$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c79bde28d689cb05$var$Oe(a) {
    var b = $c79bde28d689cb05$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c79bde28d689cb05$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c79bde28d689cb05$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c79bde28d689cb05$var$Ke(c, f);
                var g = $c79bde28d689cb05$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c79bde28d689cb05$var$Pe = $c79bde28d689cb05$var$ia && "documentMode" in document && 11 >= document.documentMode, $c79bde28d689cb05$var$Qe = null, $c79bde28d689cb05$var$Re = null, $c79bde28d689cb05$var$Se = null, $c79bde28d689cb05$var$Te = !1;
function $c79bde28d689cb05$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c79bde28d689cb05$var$Te || null == $c79bde28d689cb05$var$Qe || $c79bde28d689cb05$var$Qe !== $c79bde28d689cb05$var$Xa(d) || (d = $c79bde28d689cb05$var$Qe, "selectionStart" in d && $c79bde28d689cb05$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c79bde28d689cb05$var$Se && $c79bde28d689cb05$var$Ie($c79bde28d689cb05$var$Se, d) || ($c79bde28d689cb05$var$Se = d, d = $c79bde28d689cb05$var$oe($c79bde28d689cb05$var$Re, "onSelect"), 0 < d.length && (b = new $c79bde28d689cb05$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c79bde28d689cb05$var$Qe)));
}
function $c79bde28d689cb05$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c79bde28d689cb05$var$We = {
    animationend: $c79bde28d689cb05$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $c79bde28d689cb05$var$Ve("Animation", "AnimationIteration"),
    animationstart: $c79bde28d689cb05$var$Ve("Animation", "AnimationStart"),
    transitionend: $c79bde28d689cb05$var$Ve("Transition", "TransitionEnd")
}, $c79bde28d689cb05$var$Xe = {}, $c79bde28d689cb05$var$Ye = {};
$c79bde28d689cb05$var$ia && ($c79bde28d689cb05$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $c79bde28d689cb05$var$We.animationend.animation, delete $c79bde28d689cb05$var$We.animationiteration.animation, delete $c79bde28d689cb05$var$We.animationstart.animation), "TransitionEvent" in window || delete $c79bde28d689cb05$var$We.transitionend.transition);
function $c79bde28d689cb05$var$Ze(a) {
    if ($c79bde28d689cb05$var$Xe[a]) return $c79bde28d689cb05$var$Xe[a];
    if (!$c79bde28d689cb05$var$We[a]) return a;
    var b = $c79bde28d689cb05$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c79bde28d689cb05$var$Ye) return $c79bde28d689cb05$var$Xe[a] = b[c];
    return a;
}
var $c79bde28d689cb05$var$$e = $c79bde28d689cb05$var$Ze("animationend"), $c79bde28d689cb05$var$af = $c79bde28d689cb05$var$Ze("animationiteration"), $c79bde28d689cb05$var$bf = $c79bde28d689cb05$var$Ze("animationstart"), $c79bde28d689cb05$var$cf = $c79bde28d689cb05$var$Ze("transitionend"), $c79bde28d689cb05$var$df = new Map, $c79bde28d689cb05$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c79bde28d689cb05$var$ff(a, b) {
    $c79bde28d689cb05$var$df.set(a, b);
    $c79bde28d689cb05$var$fa(b, [
        a
    ]);
}
for(var $c79bde28d689cb05$var$gf = 0; $c79bde28d689cb05$var$gf < $c79bde28d689cb05$var$ef.length; $c79bde28d689cb05$var$gf++){
    var $c79bde28d689cb05$var$hf = $c79bde28d689cb05$var$ef[$c79bde28d689cb05$var$gf], $c79bde28d689cb05$var$jf = $c79bde28d689cb05$var$hf.toLowerCase(), $c79bde28d689cb05$var$kf = $c79bde28d689cb05$var$hf[0].toUpperCase() + $c79bde28d689cb05$var$hf.slice(1);
    $c79bde28d689cb05$var$ff($c79bde28d689cb05$var$jf, "on" + $c79bde28d689cb05$var$kf);
}
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$$e, "onAnimationEnd");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$af, "onAnimationIteration");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$bf, "onAnimationStart");
$c79bde28d689cb05$var$ff("dblclick", "onDoubleClick");
$c79bde28d689cb05$var$ff("focusin", "onFocus");
$c79bde28d689cb05$var$ff("focusout", "onBlur");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$cf, "onTransitionEnd");
$c79bde28d689cb05$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c79bde28d689cb05$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c79bde28d689cb05$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c79bde28d689cb05$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($c79bde28d689cb05$var$lf));
function $c79bde28d689cb05$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c79bde28d689cb05$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c79bde28d689cb05$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($c79bde28d689cb05$var$Qb) throw a = $c79bde28d689cb05$var$Rb, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, a;
}
function $c79bde28d689cb05$var$D(a, b) {
    var c = b[$c79bde28d689cb05$var$of];
    void 0 === c && (c = b[$c79bde28d689cb05$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c79bde28d689cb05$var$pf(b, a, 2, !1), c.add(d));
}
function $c79bde28d689cb05$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c79bde28d689cb05$var$pf(c, a, d, b);
}
var $c79bde28d689cb05$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $c79bde28d689cb05$var$sf(a) {
    if (!a[$c79bde28d689cb05$var$rf]) {
        a[$c79bde28d689cb05$var$rf] = !0;
        $c79bde28d689cb05$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c79bde28d689cb05$var$mf.has(b) || $c79bde28d689cb05$var$qf(b, !1, a), $c79bde28d689cb05$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c79bde28d689cb05$var$rf] || (b[$c79bde28d689cb05$var$rf] = !0, $c79bde28d689cb05$var$qf("selectionchange", !1, b));
    }
}
function $c79bde28d689cb05$var$pf(a, b, c, d) {
    switch($c79bde28d689cb05$var$jd(b)){
        case 1:
            var e = $c79bde28d689cb05$var$ed;
            break;
        case 4:
            e = $c79bde28d689cb05$var$gd;
            break;
        default:
            e = $c79bde28d689cb05$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c79bde28d689cb05$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c79bde28d689cb05$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c79bde28d689cb05$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c79bde28d689cb05$var$Jb(function() {
        var d = f, e = $c79bde28d689cb05$var$xb(c), g = [];
        a: {
            var h = $c79bde28d689cb05$var$df.get(a);
            if (void 0 !== h) {
                var k = $c79bde28d689cb05$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $c79bde28d689cb05$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c79bde28d689cb05$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c79bde28d689cb05$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c79bde28d689cb05$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c79bde28d689cb05$var$Vd;
                        break;
                    case $c79bde28d689cb05$var$$e:
                    case $c79bde28d689cb05$var$af:
                    case $c79bde28d689cb05$var$bf:
                        k = $c79bde28d689cb05$var$Hd;
                        break;
                    case $c79bde28d689cb05$var$cf:
                        k = $c79bde28d689cb05$var$Xd;
                        break;
                    case "scroll":
                        k = $c79bde28d689cb05$var$vd;
                        break;
                    case "wheel":
                        k = $c79bde28d689cb05$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c79bde28d689cb05$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c79bde28d689cb05$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $c79bde28d689cb05$var$Kb(w, x), null != F && t.push($c79bde28d689cb05$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c79bde28d689cb05$var$wb && (n = c.relatedTarget || c.fromElement) && ($c79bde28d689cb05$var$Wc(n) || n[$c79bde28d689cb05$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $c79bde28d689cb05$var$Wc(n) : null, null !== n && (J = $c79bde28d689cb05$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $c79bde28d689cb05$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $c79bde28d689cb05$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $c79bde28d689cb05$var$ue(k);
                        u = null == n ? h : $c79bde28d689cb05$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $c79bde28d689cb05$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $c79bde28d689cb05$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $c79bde28d689cb05$var$vf(F))u++;
                            for(; 0 < w - u;)t = $c79bde28d689cb05$var$vf(t), w--;
                            for(; 0 < u - w;)x = $c79bde28d689cb05$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $c79bde28d689cb05$var$vf(t);
                                x = $c79bde28d689cb05$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $c79bde28d689cb05$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $c79bde28d689cb05$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $c79bde28d689cb05$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $c79bde28d689cb05$var$ve;
                else if ($c79bde28d689cb05$var$me(h)) {
                    if ($c79bde28d689cb05$var$we) na = $c79bde28d689cb05$var$Fe;
                    else {
                        na = $c79bde28d689cb05$var$De;
                        var xa = $c79bde28d689cb05$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $c79bde28d689cb05$var$Ee);
                if (na && (na = na(a, d))) {
                    $c79bde28d689cb05$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $c79bde28d689cb05$var$cb(h, "number", h.value);
            }
            xa = d ? $c79bde28d689cb05$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($c79bde28d689cb05$var$me(xa) || "true" === xa.contentEditable) $c79bde28d689cb05$var$Qe = xa, $c79bde28d689cb05$var$Re = d, $c79bde28d689cb05$var$Se = null;
                    break;
                case "focusout":
                    $c79bde28d689cb05$var$Se = $c79bde28d689cb05$var$Re = $c79bde28d689cb05$var$Qe = null;
                    break;
                case "mousedown":
                    $c79bde28d689cb05$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c79bde28d689cb05$var$Te = !1;
                    $c79bde28d689cb05$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($c79bde28d689cb05$var$Pe) break;
                case "keydown":
                case "keyup":
                    $c79bde28d689cb05$var$Ue(g, c, e);
            }
            var $a;
            if ($c79bde28d689cb05$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $c79bde28d689cb05$var$ie ? $c79bde28d689cb05$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($c79bde28d689cb05$var$de && "ko" !== c.locale && ($c79bde28d689cb05$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $c79bde28d689cb05$var$ie && ($a = $c79bde28d689cb05$var$nd()) : ($c79bde28d689cb05$var$kd = e, $c79bde28d689cb05$var$ld = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, $c79bde28d689cb05$var$ie = !0)), xa = $c79bde28d689cb05$var$oe(d, ba), 0 < xa.length && (ba = new $c79bde28d689cb05$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $c79bde28d689cb05$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $c79bde28d689cb05$var$ce ? $c79bde28d689cb05$var$je(a, c) : $c79bde28d689cb05$var$ke(a, c)) d = $c79bde28d689cb05$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $c79bde28d689cb05$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $c79bde28d689cb05$var$se(g, b);
    });
}
function $c79bde28d689cb05$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c79bde28d689cb05$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c79bde28d689cb05$var$Kb(a, c), null != f && d.unshift($c79bde28d689cb05$var$tf(a, f, e)), f = $c79bde28d689cb05$var$Kb(a, b), null != f && d.push($c79bde28d689cb05$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c79bde28d689cb05$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c79bde28d689cb05$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.unshift($c79bde28d689cb05$var$tf(c, k, h))) : e || (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.push($c79bde28d689cb05$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c79bde28d689cb05$var$xf = /\r\n?/g, $c79bde28d689cb05$var$yf = /\u0000|\uFFFD/g;
function $c79bde28d689cb05$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c79bde28d689cb05$var$xf, "\n").replace($c79bde28d689cb05$var$yf, "");
}
function $c79bde28d689cb05$var$Af(a, b, c) {
    b = $c79bde28d689cb05$var$zf(b);
    if ($c79bde28d689cb05$var$zf(a) !== b && c) throw Error($c79bde28d689cb05$var$p(425));
}
function $c79bde28d689cb05$var$Bf() {}
var $c79bde28d689cb05$var$Cf = null, $c79bde28d689cb05$var$Df = null;
function $c79bde28d689cb05$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c79bde28d689cb05$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $c79bde28d689cb05$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c79bde28d689cb05$var$Hf = "function" === typeof Promise ? Promise : void 0, $c79bde28d689cb05$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c79bde28d689cb05$var$Hf ? function(a) {
    return $c79bde28d689cb05$var$Hf.resolve(null).then(a).catch($c79bde28d689cb05$var$If);
} : $c79bde28d689cb05$var$Ff;
function $c79bde28d689cb05$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c79bde28d689cb05$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c79bde28d689cb05$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c79bde28d689cb05$var$bd(b);
}
function $c79bde28d689cb05$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c79bde28d689cb05$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nf = Math.random().toString(36).slice(2), $c79bde28d689cb05$var$Of = "__reactFiber$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Pf = "__reactProps$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$uf = "__reactContainer$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$of = "__reactEvents$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Qf = "__reactListeners$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Rf = "__reactHandles$" + $c79bde28d689cb05$var$Nf;
function $c79bde28d689cb05$var$Wc(a) {
    var b = a[$c79bde28d689cb05$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c79bde28d689cb05$var$uf] || c[$c79bde28d689cb05$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c79bde28d689cb05$var$Mf(a); null !== a;){
                if (c = a[$c79bde28d689cb05$var$Of]) return c;
                a = $c79bde28d689cb05$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c79bde28d689cb05$var$Cb(a) {
    a = a[$c79bde28d689cb05$var$Of] || a[$c79bde28d689cb05$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c79bde28d689cb05$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c79bde28d689cb05$var$p(33));
}
function $c79bde28d689cb05$var$Db(a) {
    return a[$c79bde28d689cb05$var$Pf] || null;
}
var $c79bde28d689cb05$var$Sf = [], $c79bde28d689cb05$var$Tf = -1;
function $c79bde28d689cb05$var$Uf(a) {
    return {
        current: a
    };
}
function $c79bde28d689cb05$var$E(a) {
    0 > $c79bde28d689cb05$var$Tf || (a.current = $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf], $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = null, $c79bde28d689cb05$var$Tf--);
}
function $c79bde28d689cb05$var$G(a, b) {
    $c79bde28d689cb05$var$Tf++;
    $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = a.current;
    a.current = b;
}
var $c79bde28d689cb05$var$Vf = {}, $c79bde28d689cb05$var$H = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Vf), $c79bde28d689cb05$var$Wf = $c79bde28d689cb05$var$Uf(!1), $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$Vf;
function $c79bde28d689cb05$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c79bde28d689cb05$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c79bde28d689cb05$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c79bde28d689cb05$var$$f() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
}
function $c79bde28d689cb05$var$ag(a, b, c) {
    if ($c79bde28d689cb05$var$H.current !== $c79bde28d689cb05$var$Vf) throw Error($c79bde28d689cb05$var$p(168));
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
function $c79bde28d689cb05$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c79bde28d689cb05$var$p(108, $c79bde28d689cb05$var$Ra(a) || "Unknown", e));
    return $c79bde28d689cb05$var$A({}, c, d);
}
function $c79bde28d689cb05$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c79bde28d689cb05$var$Vf;
    $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$H.current;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, $c79bde28d689cb05$var$Wf.current);
    return !0;
}
function $c79bde28d689cb05$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c79bde28d689cb05$var$p(169));
    c ? (a = $c79bde28d689cb05$var$bg(a, b, $c79bde28d689cb05$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a)) : $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
var $c79bde28d689cb05$var$eg = null, $c79bde28d689cb05$var$fg = !1, $c79bde28d689cb05$var$gg = !1;
function $c79bde28d689cb05$var$hg(a) {
    null === $c79bde28d689cb05$var$eg ? $c79bde28d689cb05$var$eg = [
        a
    ] : $c79bde28d689cb05$var$eg.push(a);
}
function $c79bde28d689cb05$var$ig(a) {
    $c79bde28d689cb05$var$fg = !0;
    $c79bde28d689cb05$var$hg(a);
}
function $c79bde28d689cb05$var$jg() {
    if (!$c79bde28d689cb05$var$gg && null !== $c79bde28d689cb05$var$eg) {
        $c79bde28d689cb05$var$gg = !0;
        var a = 0, b = $c79bde28d689cb05$var$C;
        try {
            var c = $c79bde28d689cb05$var$eg;
            for($c79bde28d689cb05$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c79bde28d689cb05$var$eg = null;
            $c79bde28d689cb05$var$fg = !1;
        } catch (e) {
            throw null !== $c79bde28d689cb05$var$eg && ($c79bde28d689cb05$var$eg = $c79bde28d689cb05$var$eg.slice(a + 1)), $c79bde28d689cb05$var$ac($c79bde28d689cb05$var$fc, $c79bde28d689cb05$var$jg), e;
        } finally{
            $c79bde28d689cb05$var$C = b, $c79bde28d689cb05$var$gg = !1;
        }
    }
    return null;
}
var $c79bde28d689cb05$var$kg = [], $c79bde28d689cb05$var$lg = 0, $c79bde28d689cb05$var$mg = null, $c79bde28d689cb05$var$ng = 0, $c79bde28d689cb05$var$og = [], $c79bde28d689cb05$var$pg = 0, $c79bde28d689cb05$var$qg = null, $c79bde28d689cb05$var$rg = 1, $c79bde28d689cb05$var$sg = "";
function $c79bde28d689cb05$var$tg(a, b) {
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$ng;
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$mg;
    $c79bde28d689cb05$var$mg = a;
    $c79bde28d689cb05$var$ng = b;
}
function $c79bde28d689cb05$var$ug(a, b, c) {
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg;
    $c79bde28d689cb05$var$qg = a;
    var d = $c79bde28d689cb05$var$rg;
    a = $c79bde28d689cb05$var$sg;
    var e = 32 - $c79bde28d689cb05$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c79bde28d689cb05$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c79bde28d689cb05$var$rg = 1 << 32 - $c79bde28d689cb05$var$oc(b) + e | c << e | d;
        $c79bde28d689cb05$var$sg = f + a;
    } else $c79bde28d689cb05$var$rg = 1 << f | c << e | d, $c79bde28d689cb05$var$sg = a;
}
function $c79bde28d689cb05$var$vg(a) {
    null !== a.return && ($c79bde28d689cb05$var$tg(a, 1), $c79bde28d689cb05$var$ug(a, 1, 0));
}
function $c79bde28d689cb05$var$wg(a) {
    for(; a === $c79bde28d689cb05$var$mg;)$c79bde28d689cb05$var$mg = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null, $c79bde28d689cb05$var$ng = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null;
    for(; a === $c79bde28d689cb05$var$qg;)$c79bde28d689cb05$var$qg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$sg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$rg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null;
}
var $c79bde28d689cb05$var$xg = null, $c79bde28d689cb05$var$yg = null, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$zg = null;
function $c79bde28d689cb05$var$Ag(a, b) {
    var c = $c79bde28d689cb05$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c79bde28d689cb05$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c79bde28d689cb05$var$qg ? {
                id: $c79bde28d689cb05$var$rg,
                overflow: $c79bde28d689cb05$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c79bde28d689cb05$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c79bde28d689cb05$var$Eg(a) {
    if ($c79bde28d689cb05$var$I) {
        var b = $c79bde28d689cb05$var$yg;
        if (b) {
            var c = b;
            if (!$c79bde28d689cb05$var$Cg(a, b)) {
                if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
                b = $c79bde28d689cb05$var$Lf(c.nextSibling);
                var d = $c79bde28d689cb05$var$xg;
                b && $c79bde28d689cb05$var$Cg(a, b) ? $c79bde28d689cb05$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$xg = a);
            }
        } else {
            if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c79bde28d689cb05$var$I = !1;
            $c79bde28d689cb05$var$xg = a;
        }
    }
}
function $c79bde28d689cb05$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c79bde28d689cb05$var$xg = a;
}
function $c79bde28d689cb05$var$Gg(a) {
    if (a !== $c79bde28d689cb05$var$xg) return !1;
    if (!$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$Fg(a), $c79bde28d689cb05$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c79bde28d689cb05$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $c79bde28d689cb05$var$yg)) {
        if ($c79bde28d689cb05$var$Dg(a)) throw $c79bde28d689cb05$var$Hg(), Error($c79bde28d689cb05$var$p(418));
        for(; b;)$c79bde28d689cb05$var$Ag(a, b), b = $c79bde28d689cb05$var$Lf(b.nextSibling);
    }
    $c79bde28d689cb05$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c79bde28d689cb05$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c79bde28d689cb05$var$yg = null;
        }
    } else $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg ? $c79bde28d689cb05$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c79bde28d689cb05$var$Hg() {
    for(var a = $c79bde28d689cb05$var$yg; a;)a = $c79bde28d689cb05$var$Lf(a.nextSibling);
}
function $c79bde28d689cb05$var$Ig() {
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg = null;
    $c79bde28d689cb05$var$I = !1;
}
function $c79bde28d689cb05$var$Jg(a) {
    null === $c79bde28d689cb05$var$zg ? $c79bde28d689cb05$var$zg = [
        a
    ] : $c79bde28d689cb05$var$zg.push(a);
}
var $c79bde28d689cb05$var$Kg = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig;
function $c79bde28d689cb05$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $c79bde28d689cb05$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $c79bde28d689cb05$var$Mg = $c79bde28d689cb05$var$Uf(null), $c79bde28d689cb05$var$Ng = null, $c79bde28d689cb05$var$Og = null, $c79bde28d689cb05$var$Pg = null;
function $c79bde28d689cb05$var$Qg() {
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Ng = null;
}
function $c79bde28d689cb05$var$Rg(a) {
    var b = $c79bde28d689cb05$var$Mg.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Mg);
    a._currentValue = b;
}
function $c79bde28d689cb05$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c79bde28d689cb05$var$Tg(a, b) {
    $c79bde28d689cb05$var$Ng = a;
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c79bde28d689cb05$var$Ug = !0), a.firstContext = null);
}
function $c79bde28d689cb05$var$Vg(a) {
    var b = a._currentValue;
    if ($c79bde28d689cb05$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c79bde28d689cb05$var$Og) {
            if (null === $c79bde28d689cb05$var$Ng) throw Error($c79bde28d689cb05$var$p(308));
            $c79bde28d689cb05$var$Og = a;
            $c79bde28d689cb05$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Og.next = a;
    }
    return b;
}
var $c79bde28d689cb05$var$Wg = null;
function $c79bde28d689cb05$var$Xg(a) {
    null === $c79bde28d689cb05$var$Wg ? $c79bde28d689cb05$var$Wg = [
        a
    ] : $c79bde28d689cb05$var$Wg.push(a);
}
function $c79bde28d689cb05$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c79bde28d689cb05$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c79bde28d689cb05$var$Zg(a, d);
}
function $c79bde28d689cb05$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c79bde28d689cb05$var$$g = !1;
function $c79bde28d689cb05$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c79bde28d689cb05$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c79bde28d689cb05$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c79bde28d689cb05$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c79bde28d689cb05$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c79bde28d689cb05$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c79bde28d689cb05$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c79bde28d689cb05$var$Zg(a, c);
}
function $c79bde28d689cb05$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
function $c79bde28d689cb05$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c79bde28d689cb05$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $c79bde28d689cb05$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $c79bde28d689cb05$var$A({}, q, r);
                            break a;
                        case 2:
                            $c79bde28d689cb05$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c79bde28d689cb05$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c79bde28d689cb05$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c79bde28d689cb05$var$p(191, e));
            e.call(d);
        }
    }
}
var $c79bde28d689cb05$var$jh = (new $exYeM.Component).refs;
function $c79bde28d689cb05$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c79bde28d689cb05$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c79bde28d689cb05$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $c79bde28d689cb05$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $c79bde28d689cb05$var$L(), d = $c79bde28d689cb05$var$lh(a), e = $c79bde28d689cb05$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c79bde28d689cb05$var$dh(a, e, d);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, d, c), $c79bde28d689cb05$var$eh(b, a, d));
    }
};
function $c79bde28d689cb05$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c79bde28d689cb05$var$Ie(c, d) || !$c79bde28d689cb05$var$Ie(e, f) : !0;
}
function $c79bde28d689cb05$var$ph(a, b, c) {
    var d = !1, e = $c79bde28d689cb05$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c79bde28d689cb05$var$Vg(f) : (e = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c79bde28d689cb05$var$Yf(a, e) : $c79bde28d689cb05$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c79bde28d689cb05$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c79bde28d689cb05$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c79bde28d689cb05$var$nh.enqueueReplaceState(b, b.state, null);
}
function $c79bde28d689cb05$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $c79bde28d689cb05$var$jh;
    $c79bde28d689cb05$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c79bde28d689cb05$var$Vg(f) : (f = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, e.context = $c79bde28d689cb05$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c79bde28d689cb05$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c79bde28d689cb05$var$nh.enqueueReplaceState(e, e.state, null), $c79bde28d689cb05$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c79bde28d689cb05$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c79bde28d689cb05$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c79bde28d689cb05$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $c79bde28d689cb05$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c79bde28d689cb05$var$p(284));
        if (!c._owner) throw Error($c79bde28d689cb05$var$p(290, a));
    }
    return a;
}
function $c79bde28d689cb05$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c79bde28d689cb05$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c79bde28d689cb05$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $c79bde28d689cb05$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c79bde28d689cb05$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c79bde28d689cb05$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c79bde28d689cb05$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $c79bde28d689cb05$var$sh(a, b, c), d.return = a, d;
        d = $c79bde28d689cb05$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c79bde28d689cb05$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c79bde28d689cb05$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c79bde28d689cb05$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c79bde28d689cb05$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c = $c79bde28d689cb05$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $c79bde28d689cb05$var$sh(a, null, b), c.return = a, c;
                case $c79bde28d689cb05$var$wa:
                    return b = $c79bde28d689cb05$var$zh(b, a.mode, c), b.return = a, b;
                case $c79bde28d689cb05$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c79bde28d689cb05$var$eb(b) || $c79bde28d689cb05$var$Ka(b)) return b = $c79bde28d689cb05$var$Ah(b, a.mode, c, null), b.return = a, b;
            $c79bde28d689cb05$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c79bde28d689cb05$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c79bde28d689cb05$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c79bde28d689cb05$var$eb(c) || $c79bde28d689cb05$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $c79bde28d689cb05$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c79bde28d689cb05$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c79bde28d689cb05$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($c79bde28d689cb05$var$eb(d) || $c79bde28d689cb05$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $c79bde28d689cb05$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $c79bde28d689cb05$var$Ka(h);
        if ("function" !== typeof l) throw Error($c79bde28d689cb05$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c79bde28d689cb05$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $c79bde28d689cb05$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $c79bde28d689cb05$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c79bde28d689cb05$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c79bde28d689cb05$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c79bde28d689cb05$var$ya ? (d = $c79bde28d689cb05$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c79bde28d689cb05$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $c79bde28d689cb05$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c79bde28d689cb05$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c79bde28d689cb05$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c79bde28d689cb05$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($c79bde28d689cb05$var$eb(f)) return n(a, d, f, h);
            if ($c79bde28d689cb05$var$Ka(f)) return t(a, d, f, h);
            $c79bde28d689cb05$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c79bde28d689cb05$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $c79bde28d689cb05$var$Bh = $c79bde28d689cb05$var$vh(!0), $c79bde28d689cb05$var$Ch = $c79bde28d689cb05$var$vh(!1), $c79bde28d689cb05$var$Dh = {}, $c79bde28d689cb05$var$Eh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Fh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Gh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh);
function $c79bde28d689cb05$var$Hh(a) {
    if (a === $c79bde28d689cb05$var$Dh) throw Error($c79bde28d689cb05$var$p(174));
    return a;
}
function $c79bde28d689cb05$var$Ih(a, b) {
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Gh, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, $c79bde28d689cb05$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c79bde28d689cb05$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c79bde28d689cb05$var$lb(b, a);
    }
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, b);
}
function $c79bde28d689cb05$var$Jh() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Gh);
}
function $c79bde28d689cb05$var$Kh(a) {
    $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
    var b = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
    var c = $c79bde28d689cb05$var$lb(b, a.type);
    b !== c && ($c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, c));
}
function $c79bde28d689cb05$var$Lh(a) {
    $c79bde28d689cb05$var$Fh.current === a && ($c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh));
}
var $c79bde28d689cb05$var$M = $c79bde28d689cb05$var$Uf(0);
function $c79bde28d689cb05$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nh = [];
function $c79bde28d689cb05$var$Oh() {
    for(var a = 0; a < $c79bde28d689cb05$var$Nh.length; a++)$c79bde28d689cb05$var$Nh[a]._workInProgressVersionPrimary = null;
    $c79bde28d689cb05$var$Nh.length = 0;
}
var $c79bde28d689cb05$var$Ph = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$Qh = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$Rh = 0, $c79bde28d689cb05$var$N = null, $c79bde28d689cb05$var$O = null, $c79bde28d689cb05$var$P = null, $c79bde28d689cb05$var$Sh = !1, $c79bde28d689cb05$var$Th = !1, $c79bde28d689cb05$var$Uh = 0, $c79bde28d689cb05$var$Vh = 0;
function $c79bde28d689cb05$var$Q() {
    throw Error($c79bde28d689cb05$var$p(321));
}
function $c79bde28d689cb05$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c79bde28d689cb05$var$He(a[c], b[c])) return !1;
    return !0;
}
function $c79bde28d689cb05$var$Xh(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$Rh = f;
    $c79bde28d689cb05$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c79bde28d689cb05$var$Ph.current = null === a || null === a.memoizedState ? $c79bde28d689cb05$var$Yh : $c79bde28d689cb05$var$Zh;
    a = c(d, e);
    if ($c79bde28d689cb05$var$Th) {
        f = 0;
        do {
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            if (25 <= f) throw Error($c79bde28d689cb05$var$p(301));
            f += 1;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = null;
            b.updateQueue = null;
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$$h;
            a = c(d, e);
        }while ($c79bde28d689cb05$var$Th);
    }
    $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
    b = null !== $c79bde28d689cb05$var$O && null !== $c79bde28d689cb05$var$O.next;
    $c79bde28d689cb05$var$Rh = 0;
    $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
    $c79bde28d689cb05$var$Sh = !1;
    if (b) throw Error($c79bde28d689cb05$var$p(300));
    return a;
}
function $c79bde28d689cb05$var$bi() {
    var a = 0 !== $c79bde28d689cb05$var$Uh;
    $c79bde28d689cb05$var$Uh = 0;
    return a;
}
function $c79bde28d689cb05$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$di() {
    if (null === $c79bde28d689cb05$var$O) {
        var a = $c79bde28d689cb05$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c79bde28d689cb05$var$O.next;
    var b = null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState : $c79bde28d689cb05$var$P.next;
    if (null !== b) $c79bde28d689cb05$var$P = b, $c79bde28d689cb05$var$O = a;
    else {
        if (null === a) throw Error($c79bde28d689cb05$var$p(310));
        $c79bde28d689cb05$var$O = a;
        a = {
            memoizedState: $c79bde28d689cb05$var$O.memoizedState,
            baseState: $c79bde28d689cb05$var$O.baseState,
            baseQueue: $c79bde28d689cb05$var$O.baseQueue,
            queue: $c79bde28d689cb05$var$O.queue,
            next: null
        };
        null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    }
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c79bde28d689cb05$var$fi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c79bde28d689cb05$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($c79bde28d689cb05$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c79bde28d689cb05$var$N.lanes |= m;
                $c79bde28d689cb05$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c79bde28d689cb05$var$He(d, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c79bde28d689cb05$var$N.lanes |= f, $c79bde28d689cb05$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c79bde28d689cb05$var$gi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c79bde28d689cb05$var$He(f, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c79bde28d689cb05$var$hi() {}
function $c79bde28d689cb05$var$ii(a, b) {
    var c = $c79bde28d689cb05$var$N, d = $c79bde28d689cb05$var$di(), e = b(), f = !$c79bde28d689cb05$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $c79bde28d689cb05$var$Ug = !0);
    d = d.queue;
    $c79bde28d689cb05$var$ji($c79bde28d689cb05$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c79bde28d689cb05$var$P && $c79bde28d689cb05$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
        0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(c, b, e);
    }
    return e;
}
function $c79bde28d689cb05$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c79bde28d689cb05$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
}
function $c79bde28d689cb05$var$ki(a, b, c) {
    return c(function() {
        $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
    });
}
function $c79bde28d689cb05$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c79bde28d689cb05$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $c79bde28d689cb05$var$pi(a) {
    var b = $c79bde28d689cb05$var$Zg(a, 1);
    null !== b && $c79bde28d689cb05$var$mh(b, a, 1, -1);
}
function $c79bde28d689cb05$var$qi(a) {
    var b = $c79bde28d689cb05$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c79bde28d689cb05$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c79bde28d689cb05$var$ri.bind(null, $c79bde28d689cb05$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c79bde28d689cb05$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c79bde28d689cb05$var$si() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$ti(a, b, c, d) {
    var e = $c79bde28d689cb05$var$ci();
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c79bde28d689cb05$var$ui(a, b, c, d) {
    var e = $c79bde28d689cb05$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c79bde28d689cb05$var$O) {
        var g = $c79bde28d689cb05$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $c79bde28d689cb05$var$Wh(d, g.deps)) {
            e.memoizedState = $c79bde28d689cb05$var$li(b, c, f, d);
            return;
        }
    }
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, f, d);
}
function $c79bde28d689cb05$var$vi(a, b) {
    return $c79bde28d689cb05$var$ti(8390656, 8, a, b);
}
function $c79bde28d689cb05$var$ji(a, b) {
    return $c79bde28d689cb05$var$ui(2048, 8, a, b);
}
function $c79bde28d689cb05$var$wi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 2, a, b);
}
function $c79bde28d689cb05$var$xi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 4, a, b);
}
function $c79bde28d689cb05$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c79bde28d689cb05$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c79bde28d689cb05$var$ui(4, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
}
function $c79bde28d689cb05$var$Ai() {}
function $c79bde28d689cb05$var$Bi(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Ci(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Di(a, b, c) {
    if (0 === ($c79bde28d689cb05$var$Rh & 21)) return a.baseState && (a.baseState = !1, $c79bde28d689cb05$var$Ug = !0), a.memoizedState = c;
    $c79bde28d689cb05$var$He(c, b) || (c = $c79bde28d689cb05$var$yc(), $c79bde28d689cb05$var$N.lanes |= c, $c79bde28d689cb05$var$hh |= c, a.baseState = !0);
    return b;
}
function $c79bde28d689cb05$var$Ei(a, b) {
    var c = $c79bde28d689cb05$var$C;
    $c79bde28d689cb05$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c79bde28d689cb05$var$Qh.transition;
    $c79bde28d689cb05$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$Qh.transition = d;
    }
}
function $c79bde28d689cb05$var$Fi() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$Gi(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, c);
    else if (c = $c79bde28d689cb05$var$Yg(a, b, c, d), null !== c) {
        var e = $c79bde28d689cb05$var$L();
        $c79bde28d689cb05$var$mh(c, a, d, e);
        $c79bde28d689cb05$var$Ji(c, b, d);
    }
}
function $c79bde28d689cb05$var$ri(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c79bde28d689cb05$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c79bde28d689cb05$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c79bde28d689cb05$var$Yg(a, b, e, d);
        null !== c && (e = $c79bde28d689cb05$var$L(), $c79bde28d689cb05$var$mh(c, a, d, e), $c79bde28d689cb05$var$Ji(c, b, d));
    }
}
function $c79bde28d689cb05$var$Hi(a) {
    var b = a.alternate;
    return a === $c79bde28d689cb05$var$N || null !== b && b === $c79bde28d689cb05$var$N;
}
function $c79bde28d689cb05$var$Ii(a, b) {
    $c79bde28d689cb05$var$Th = $c79bde28d689cb05$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c79bde28d689cb05$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
var $c79bde28d689cb05$var$ai = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Q,
    useContext: $c79bde28d689cb05$var$Q,
    useEffect: $c79bde28d689cb05$var$Q,
    useImperativeHandle: $c79bde28d689cb05$var$Q,
    useInsertionEffect: $c79bde28d689cb05$var$Q,
    useLayoutEffect: $c79bde28d689cb05$var$Q,
    useMemo: $c79bde28d689cb05$var$Q,
    useReducer: $c79bde28d689cb05$var$Q,
    useRef: $c79bde28d689cb05$var$Q,
    useState: $c79bde28d689cb05$var$Q,
    useDebugValue: $c79bde28d689cb05$var$Q,
    useDeferredValue: $c79bde28d689cb05$var$Q,
    useTransition: $c79bde28d689cb05$var$Q,
    useMutableSource: $c79bde28d689cb05$var$Q,
    useSyncExternalStore: $c79bde28d689cb05$var$Q,
    useId: $c79bde28d689cb05$var$Q,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Yh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: function(a, b) {
        $c79bde28d689cb05$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c79bde28d689cb05$var$ti(4194308, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $c79bde28d689cb05$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $c79bde28d689cb05$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c79bde28d689cb05$var$Gi.bind(null, $c79bde28d689cb05$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $c79bde28d689cb05$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c79bde28d689cb05$var$qi,
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        return $c79bde28d689cb05$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$qi(!1), b = a[0];
        a = $c79bde28d689cb05$var$Ei.bind(null, a[1]);
        $c79bde28d689cb05$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $c79bde28d689cb05$var$N, e = $c79bde28d689cb05$var$ci();
        if ($c79bde28d689cb05$var$I) {
            if (void 0 === c) throw Error($c79bde28d689cb05$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
            0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c79bde28d689cb05$var$vi($c79bde28d689cb05$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $c79bde28d689cb05$var$ci(), b = $c79bde28d689cb05$var$R.identifierPrefix;
        if ($c79bde28d689cb05$var$I) {
            var c = $c79bde28d689cb05$var$sg;
            var d = $c79bde28d689cb05$var$rg;
            c = (d & ~(1 << 32 - $c79bde28d689cb05$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c79bde28d689cb05$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c79bde28d689cb05$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Zh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$fi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$$h = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$gi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return null === $c79bde28d689cb05$var$O ? b.memoizedState = a : $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
};
function $c79bde28d689cb05$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $c79bde28d689cb05$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c79bde28d689cb05$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c79bde28d689cb05$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c79bde28d689cb05$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $c79bde28d689cb05$var$Oi(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c79bde28d689cb05$var$Pi || ($c79bde28d689cb05$var$Pi = !0, $c79bde28d689cb05$var$Qi = d);
        $c79bde28d689cb05$var$Mi(a, b);
    };
    return c;
}
function $c79bde28d689cb05$var$Ri(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c79bde28d689cb05$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c79bde28d689cb05$var$Mi(a, b);
        "function" !== typeof d && (null === $c79bde28d689cb05$var$Si ? $c79bde28d689cb05$var$Si = new Set([
            this
        ]) : $c79bde28d689cb05$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $c79bde28d689cb05$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c79bde28d689cb05$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $c79bde28d689cb05$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $c79bde28d689cb05$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c79bde28d689cb05$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c79bde28d689cb05$var$ch(-1, 1), b.tag = 2, $c79bde28d689cb05$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c79bde28d689cb05$var$Xi = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$Ug = !1;
function $c79bde28d689cb05$var$Yi(a, b, c, d) {
    b.child = null === a ? $c79bde28d689cb05$var$Ch(b, null, c, d) : $c79bde28d689cb05$var$Bh(b, a.child, c, d);
}
function $c79bde28d689cb05$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c79bde28d689cb05$var$Tg(b, e);
    d = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    c = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && c && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, d, e);
    return b.child;
}
function $c79bde28d689cb05$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c79bde28d689cb05$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c79bde28d689cb05$var$cj(a, b, f, d, e);
        a = $c79bde28d689cb05$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c79bde28d689cb05$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $c79bde28d689cb05$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $c79bde28d689cb05$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c79bde28d689cb05$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c79bde28d689cb05$var$Ie(f, d) && a.ref === b.ref) {
            if ($c79bde28d689cb05$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c79bde28d689cb05$var$Ug = !0);
            else return b.lanes = a.lanes, $c79bde28d689cb05$var$$i(a, b, e);
        }
    }
    return $c79bde28d689cb05$var$dj(a, b, c, d, e);
}
function $c79bde28d689cb05$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj);
            $c79bde28d689cb05$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= d;
    $c79bde28d689cb05$var$Yi(a, b, e, c);
    return b.child;
}
function $c79bde28d689cb05$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c79bde28d689cb05$var$dj(a, b, c, d, e) {
    var f = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current;
    f = $c79bde28d689cb05$var$Yf(b, f);
    $c79bde28d689cb05$var$Tg(b, e);
    c = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    d = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && d && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, c, e);
    return b.child;
}
function $c79bde28d689cb05$var$ij(a, b, c, d, e) {
    if ($c79bde28d689cb05$var$Zf(c)) {
        var f = !0;
        $c79bde28d689cb05$var$cg(b);
    } else f = !1;
    $c79bde28d689cb05$var$Tg(b, e);
    if (null === b.stateNode) $c79bde28d689cb05$var$jj(a, b), $c79bde28d689cb05$var$ph(b, c, d), $c79bde28d689cb05$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c79bde28d689cb05$var$Vg(l) : (l = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, l = $c79bde28d689cb05$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c79bde28d689cb05$var$qh(b, g, d, l);
        $c79bde28d689cb05$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof m && ($c79bde28d689cb05$var$kh(b, c, m, d), k = b.memoizedState), (h = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c79bde28d689cb05$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c79bde28d689cb05$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $c79bde28d689cb05$var$Vg(k) : (k = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, k = $c79bde28d689cb05$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c79bde28d689cb05$var$qh(b, g, d, k);
        $c79bde28d689cb05$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof y && ($c79bde28d689cb05$var$kh(b, c, y, d), n = b.memoizedState), (l = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c79bde28d689cb05$var$kj(a, b, c, d, f, e);
}
function $c79bde28d689cb05$var$kj(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c79bde28d689cb05$var$dg(b, c, !1), $c79bde28d689cb05$var$$i(a, b, f);
    d = b.stateNode;
    $c79bde28d689cb05$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $c79bde28d689cb05$var$Bh(b, a.child, null, f), b.child = $c79bde28d689cb05$var$Bh(b, null, h, f)) : $c79bde28d689cb05$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $c79bde28d689cb05$var$dg(b, c, !0);
    return b.child;
}
function $c79bde28d689cb05$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c79bde28d689cb05$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c79bde28d689cb05$var$ag(a, b.context, !1);
    $c79bde28d689cb05$var$Ih(a, b.containerInfo);
}
function $c79bde28d689cb05$var$mj(a, b, c, d, e) {
    $c79bde28d689cb05$var$Ig();
    $c79bde28d689cb05$var$Jg(e);
    b.flags |= 256;
    $c79bde28d689cb05$var$Yi(a, b, c, d);
    return b.child;
}
var $c79bde28d689cb05$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c79bde28d689cb05$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c79bde28d689cb05$var$pj(a, b, c) {
    var d = b.pendingProps, e = $c79bde28d689cb05$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, e & 1);
    if (null === a) {
        $c79bde28d689cb05$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $c79bde28d689cb05$var$qj(g, d, 0, null), a = $c79bde28d689cb05$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c79bde28d689cb05$var$oj(c), b.memoizedState = $c79bde28d689cb05$var$nj, a) : $c79bde28d689cb05$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c79bde28d689cb05$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $c79bde28d689cb05$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c79bde28d689cb05$var$wh(h, f) : (f = $c79bde28d689cb05$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c79bde28d689cb05$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c79bde28d689cb05$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c79bde28d689cb05$var$rj(a, b) {
    b = $c79bde28d689cb05$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c79bde28d689cb05$var$tj(a, b, c, d) {
    null !== d && $c79bde28d689cb05$var$Jg(d);
    $c79bde28d689cb05$var$Bh(b, a.child, null, c);
    a = $c79bde28d689cb05$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c79bde28d689cb05$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(422))), $c79bde28d689cb05$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c79bde28d689cb05$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c79bde28d689cb05$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c79bde28d689cb05$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $c79bde28d689cb05$var$oj(g);
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c79bde28d689cb05$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c79bde28d689cb05$var$p(419));
        d = $c79bde28d689cb05$var$Li(f, d, void 0);
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c79bde28d689cb05$var$Ug || h) {
        d = $c79bde28d689cb05$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c79bde28d689cb05$var$Zg(a, e), $c79bde28d689cb05$var$mh(d, a, e, -1));
        }
        $c79bde28d689cb05$var$uj();
        d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(421)));
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c79bde28d689cb05$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(e.nextSibling);
    $c79bde28d689cb05$var$xg = b;
    $c79bde28d689cb05$var$I = !0;
    $c79bde28d689cb05$var$zg = null;
    null !== a && ($c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg, $c79bde28d689cb05$var$rg = a.id, $c79bde28d689cb05$var$sg = a.overflow, $c79bde28d689cb05$var$qg = b);
    b = $c79bde28d689cb05$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c79bde28d689cb05$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c79bde28d689cb05$var$Sg(a.return, b, c);
}
function $c79bde28d689cb05$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c79bde28d689cb05$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c79bde28d689cb05$var$Yi(a, b, d.children, c);
    d = $c79bde28d689cb05$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c79bde28d689cb05$var$wj(a, c, b);
            else if (19 === a.tag) $c79bde28d689cb05$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c79bde28d689cb05$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c79bde28d689cb05$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c79bde28d689cb05$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c79bde28d689cb05$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $c79bde28d689cb05$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c79bde28d689cb05$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c79bde28d689cb05$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c79bde28d689cb05$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c79bde28d689cb05$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c79bde28d689cb05$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $c79bde28d689cb05$var$lj(b);
            $c79bde28d689cb05$var$Ig();
            break;
        case 5:
            $c79bde28d689cb05$var$Kh(b);
            break;
        case 1:
            $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$cg(b);
            break;
        case 4:
            $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c79bde28d689cb05$var$pj(a, b, c);
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
                a = $c79bde28d689cb05$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c79bde28d689cb05$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c79bde28d689cb05$var$ej(a, b, c);
    }
    return $c79bde28d689cb05$var$$i(a, b, c);
}
var $c79bde28d689cb05$var$Aj, $c79bde28d689cb05$var$Bj, $c79bde28d689cb05$var$Cj, $c79bde28d689cb05$var$Dj;
$c79bde28d689cb05$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c79bde28d689cb05$var$Bj = function() {};
$c79bde28d689cb05$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $c79bde28d689cb05$var$Ya(a, e);
                d = $c79bde28d689cb05$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c79bde28d689cb05$var$A({}, e, {
                    value: void 0
                });
                d = $c79bde28d689cb05$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c79bde28d689cb05$var$gb(a, e);
                d = $c79bde28d689cb05$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
        }
        $c79bde28d689cb05$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c79bde28d689cb05$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c79bde28d689cb05$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c79bde28d689cb05$var$Ej(a, b) {
    if (!$c79bde28d689cb05$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c79bde28d689cb05$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c79bde28d689cb05$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c79bde28d689cb05$var$S(b), null;
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c79bde28d689cb05$var$Jh();
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
            $c79bde28d689cb05$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c79bde28d689cb05$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null));
            $c79bde28d689cb05$var$Bj(a, b);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 5:
            $c79bde28d689cb05$var$Lh(b);
            var e = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c79bde28d689cb05$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                    $c79bde28d689cb05$var$S(b);
                    return null;
                }
                a = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    d[$c79bde28d689cb05$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $c79bde28d689cb05$var$D("cancel", d);
                            $c79bde28d689cb05$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], d);
                            break;
                        case "source":
                            $c79bde28d689cb05$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c79bde28d689cb05$var$D("error", d);
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "details":
                            $c79bde28d689cb05$var$D("toggle", d);
                            break;
                        case "input":
                            $c79bde28d689cb05$var$Za(d, f);
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$hb(d, f), $c79bde28d689cb05$var$D("invalid", d);
                    }
                    $c79bde28d689cb05$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $c79bde28d689cb05$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c79bde28d689cb05$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $c79bde28d689cb05$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c79bde28d689cb05$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c79bde28d689cb05$var$Of] = b;
                    a[$c79bde28d689cb05$var$Pf] = d;
                    $c79bde28d689cb05$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c79bde28d689cb05$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c79bde28d689cb05$var$D("cancel", a);
                                $c79bde28d689cb05$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c79bde28d689cb05$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c79bde28d689cb05$var$D("error", a);
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $c79bde28d689cb05$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c79bde28d689cb05$var$Za(a, d);
                                e = $c79bde28d689cb05$var$Ya(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c79bde28d689cb05$var$A({}, d, {
                                    value: void 0
                                });
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$hb(a, d);
                                e = $c79bde28d689cb05$var$gb(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c79bde28d689cb05$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c79bde28d689cb05$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c79bde28d689cb05$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c79bde28d689cb05$var$ob(a, k) : "number" === typeof k && $c79bde28d689cb05$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c79bde28d689cb05$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c79bde28d689cb05$var$D("scroll", a) : null != k && $c79bde28d689cb05$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c79bde28d689cb05$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c79bde28d689cb05$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c79bde28d689cb05$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c79bde28d689cb05$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                c = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
                $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $c79bde28d689cb05$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$c79bde28d689cb05$var$Of] = b, b.stateNode = d;
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c79bde28d689cb05$var$I && null !== $c79bde28d689cb05$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c79bde28d689cb05$var$Hg(), $c79bde28d689cb05$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $c79bde28d689cb05$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c79bde28d689cb05$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c79bde28d689cb05$var$p(317));
                        f[$c79bde28d689cb05$var$Of] = b;
                    } else $c79bde28d689cb05$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $c79bde28d689cb05$var$S(b);
                    f = !1;
                } else null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c79bde28d689cb05$var$M.current & 1) ? 0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 3) : $c79bde28d689cb05$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$Bj(a, b), null === a && $c79bde28d689cb05$var$sf(b.stateNode.containerInfo), $c79bde28d689cb05$var$S(b), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), $c79bde28d689cb05$var$S(b), null;
        case 17:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 19:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            f = b.memoizedState;
            if (null === f) return $c79bde28d689cb05$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c79bde28d689cb05$var$Ej(f, !1);
                else {
                    if (0 !== $c79bde28d689cb05$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c79bde28d689cb05$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c79bde28d689cb05$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c79bde28d689cb05$var$B() > $c79bde28d689cb05$var$Hj && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c79bde28d689cb05$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $c79bde28d689cb05$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$S(b), null;
                    } else 2 * $c79bde28d689cb05$var$B() - f.renderingStartTime > $c79bde28d689cb05$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c79bde28d689cb05$var$B(), b.sibling = null, c = $c79bde28d689cb05$var$M.current, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d ? c & 1 | 2 : c & 1), b;
            $c79bde28d689cb05$var$S(b);
            return null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c79bde28d689cb05$var$gj & 1073741824) && ($c79bde28d689cb05$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c79bde28d689cb05$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
}
function $c79bde28d689cb05$var$Jj(a, b) {
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c79bde28d689cb05$var$Lh(b), null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c79bde28d689cb05$var$p(340));
                $c79bde28d689cb05$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M), null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$Kj = !1, $c79bde28d689cb05$var$U = !1, $c79bde28d689cb05$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $c79bde28d689cb05$var$V = null;
function $c79bde28d689cb05$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $c79bde28d689cb05$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c79bde28d689cb05$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $c79bde28d689cb05$var$W(a, b, d);
    }
}
var $c79bde28d689cb05$var$Oj = !1;
function $c79bde28d689cb05$var$Pj(a, b) {
    $c79bde28d689cb05$var$Cf = $c79bde28d689cb05$var$dd;
    a = $c79bde28d689cb05$var$Me();
    if ($c79bde28d689cb05$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c79bde28d689cb05$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $c79bde28d689cb05$var$dd = !1;
    for($c79bde28d689cb05$var$V = b; null !== $c79bde28d689cb05$var$V;)if (b = $c79bde28d689cb05$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c79bde28d689cb05$var$V = a;
    else for(; null !== $c79bde28d689cb05$var$V;){
        b = $c79bde28d689cb05$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $c79bde28d689cb05$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(163));
            }
        } catch (F) {
            $c79bde28d689cb05$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c79bde28d689cb05$var$V = a;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
    n = $c79bde28d689cb05$var$Oj;
    $c79bde28d689cb05$var$Oj = !1;
    return n;
}
function $c79bde28d689cb05$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $c79bde28d689cb05$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c79bde28d689cb05$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c79bde28d689cb05$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $c79bde28d689cb05$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c79bde28d689cb05$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c79bde28d689cb05$var$Of], delete b[$c79bde28d689cb05$var$Pf], delete b[$c79bde28d689cb05$var$of], delete b[$c79bde28d689cb05$var$Qf], delete b[$c79bde28d689cb05$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c79bde28d689cb05$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c79bde28d689cb05$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c79bde28d689cb05$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c79bde28d689cb05$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c79bde28d689cb05$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling;
}
function $c79bde28d689cb05$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling;
}
var $c79bde28d689cb05$var$X = null, $c79bde28d689cb05$var$Yj = !1;
function $c79bde28d689cb05$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$c79bde28d689cb05$var$ak(a, b, c), c = c.sibling;
}
function $c79bde28d689cb05$var$ak(a, b, c) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberUnmount) try {
        $c79bde28d689cb05$var$lc.onCommitFiberUnmount($c79bde28d689cb05$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Mj(c, b);
        case 6:
            var d = $c79bde28d689cb05$var$X, e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c79bde28d689cb05$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? $c79bde28d689cb05$var$Kf(a.parentNode, c) : 1 === a.nodeType && $c79bde28d689cb05$var$Kf(a, c), $c79bde28d689cb05$var$bd(a)) : $c79bde28d689cb05$var$Kf($c79bde28d689cb05$var$X, c.stateNode));
            break;
        case 4:
            d = $c79bde28d689cb05$var$X;
            e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = c.stateNode.containerInfo;
            $c79bde28d689cb05$var$Yj = !0;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c79bde28d689cb05$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c79bde28d689cb05$var$Nj(c, b, g) : 0 !== (f & 4) && $c79bde28d689cb05$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 1:
            if (!$c79bde28d689cb05$var$U && ($c79bde28d689cb05$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $c79bde28d689cb05$var$W(c, b, h);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 21:
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c79bde28d689cb05$var$U = (d = $c79bde28d689cb05$var$U) || null !== c.memoizedState, $c79bde28d689cb05$var$Zj(a, b, c), $c79bde28d689cb05$var$U = d) : $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        default:
            $c79bde28d689cb05$var$Zj(a, b, c);
    }
}
function $c79bde28d689cb05$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c79bde28d689cb05$var$Lj);
        b.forEach(function(b) {
            var d = $c79bde28d689cb05$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $c79bde28d689cb05$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c79bde28d689cb05$var$X = h.stateNode;
                        $c79bde28d689cb05$var$Yj = !1;
                        break a;
                    case 3:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                    case 4:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c79bde28d689cb05$var$X) throw Error($c79bde28d689cb05$var$p(160));
            $c79bde28d689cb05$var$ak(f, g, e);
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c79bde28d689cb05$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c79bde28d689cb05$var$ek(b, a), b = b.sibling;
}
function $c79bde28d689cb05$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                try {
                    $c79bde28d689cb05$var$Qj(3, a, a.return), $c79bde28d689cb05$var$Rj(3, a);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
                try {
                    $c79bde28d689cb05$var$Qj(5, a, a.return);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            break;
        case 5:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c79bde28d689cb05$var$ob(e, "");
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c79bde28d689cb05$var$ab(e, f);
                    $c79bde28d689cb05$var$vb(h, g);
                    var l = $c79bde28d689cb05$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $c79bde28d689cb05$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $c79bde28d689cb05$var$nb(e, q) : "children" === m ? $c79bde28d689cb05$var$ob(e, q) : $c79bde28d689cb05$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $c79bde28d689cb05$var$bb(e, f);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $c79bde28d689cb05$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c79bde28d689cb05$var$fb(e, !!f.multiple, f.defaultValue, !0) : $c79bde28d689cb05$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c79bde28d689cb05$var$Pf] = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c79bde28d689cb05$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c79bde28d689cb05$var$bd(b.containerInfo);
            } catch (t) {
                $c79bde28d689cb05$var$W(a, a.return, t);
            }
            break;
        case 4:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            break;
        case 13:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c79bde28d689cb05$var$gk = $c79bde28d689cb05$var$B()));
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c79bde28d689cb05$var$U = (l = $c79bde28d689cb05$var$U) || m, $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$U = l) : $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($c79bde28d689cb05$var$V = a, m = a.child; null !== m;){
                    for(q = $c79bde28d689cb05$var$V = m; null !== $c79bde28d689cb05$var$V;){
                        r = $c79bde28d689cb05$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $c79bde28d689cb05$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $c79bde28d689cb05$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c79bde28d689cb05$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $c79bde28d689cb05$var$V = y) : $c79bde28d689cb05$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c79bde28d689cb05$var$rb("display", g));
                            } catch (t) {
                                $c79bde28d689cb05$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $c79bde28d689cb05$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 21:
            break;
        default:
            $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$fk(a);
    }
}
function $c79bde28d689cb05$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c79bde28d689cb05$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c79bde28d689cb05$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c79bde28d689cb05$var$ob(e, ""), d.flags &= -33);
                    var f = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(161));
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c79bde28d689cb05$var$ik(a, b, c) {
    $c79bde28d689cb05$var$V = a;
    $c79bde28d689cb05$var$jk(a, b, c);
}
function $c79bde28d689cb05$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c79bde28d689cb05$var$V;){
        var e = $c79bde28d689cb05$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c79bde28d689cb05$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c79bde28d689cb05$var$U;
                h = $c79bde28d689cb05$var$Kj;
                var l = $c79bde28d689cb05$var$U;
                $c79bde28d689cb05$var$Kj = g;
                if (($c79bde28d689cb05$var$U = k) && !l) for($c79bde28d689cb05$var$V = e; null !== $c79bde28d689cb05$var$V;)g = $c79bde28d689cb05$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c79bde28d689cb05$var$kk(e) : null !== k ? (k.return = g, $c79bde28d689cb05$var$V = k) : $c79bde28d689cb05$var$kk(e);
                for(; null !== f;)$c79bde28d689cb05$var$V = f, $c79bde28d689cb05$var$jk(f, b, c), f = f.sibling;
                $c79bde28d689cb05$var$V = e;
                $c79bde28d689cb05$var$Kj = h;
                $c79bde28d689cb05$var$U = l;
            }
            $c79bde28d689cb05$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c79bde28d689cb05$var$V = f) : $c79bde28d689cb05$var$lk(a, b, c);
    }
}
function $c79bde28d689cb05$var$lk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c79bde28d689cb05$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c79bde28d689cb05$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $c79bde28d689cb05$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $c79bde28d689cb05$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $c79bde28d689cb05$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c79bde28d689cb05$var$p(163));
                }
                $c79bde28d689cb05$var$U || b.flags & 512 && $c79bde28d689cb05$var$Sj(b);
            } catch (r) {
                $c79bde28d689cb05$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$hk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$kk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $c79bde28d689cb05$var$Rj(4, b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $c79bde28d689cb05$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(b, b.return, k);
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $c79bde28d689cb05$var$V = h;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
var $c79bde28d689cb05$var$mk = Math.ceil, $c79bde28d689cb05$var$nk = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$ok = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$pk = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$K = 0, $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Y = null, $c79bde28d689cb05$var$Z = 0, $c79bde28d689cb05$var$gj = 0, $c79bde28d689cb05$var$fj = $c79bde28d689cb05$var$Uf(0), $c79bde28d689cb05$var$T = 0, $c79bde28d689cb05$var$qk = null, $c79bde28d689cb05$var$hh = 0, $c79bde28d689cb05$var$rk = 0, $c79bde28d689cb05$var$sk = 0, $c79bde28d689cb05$var$tk = null, $c79bde28d689cb05$var$uk = null, $c79bde28d689cb05$var$gk = 0, $c79bde28d689cb05$var$Hj = Infinity, $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Pi = !1, $c79bde28d689cb05$var$Qi = null, $c79bde28d689cb05$var$Si = null, $c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = null, $c79bde28d689cb05$var$yk = 0, $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, $c79bde28d689cb05$var$Bk = -1, $c79bde28d689cb05$var$Ck = 0;
function $c79bde28d689cb05$var$L() {
    return 0 !== ($c79bde28d689cb05$var$K & 6) ? $c79bde28d689cb05$var$B() : -1 !== $c79bde28d689cb05$var$Bk ? $c79bde28d689cb05$var$Bk : $c79bde28d689cb05$var$Bk = $c79bde28d689cb05$var$B();
}
function $c79bde28d689cb05$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c79bde28d689cb05$var$K & 2) && 0 !== $c79bde28d689cb05$var$Z) return $c79bde28d689cb05$var$Z & -$c79bde28d689cb05$var$Z;
    if (null !== $c79bde28d689cb05$var$Kg.transition) return 0 === $c79bde28d689cb05$var$Ck && ($c79bde28d689cb05$var$Ck = $c79bde28d689cb05$var$yc()), $c79bde28d689cb05$var$Ck;
    a = $c79bde28d689cb05$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c79bde28d689cb05$var$jd(a.type);
    return a;
}
function $c79bde28d689cb05$var$mh(a, b, c, d) {
    if (50 < $c79bde28d689cb05$var$zk) throw $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, Error($c79bde28d689cb05$var$p(185));
    $c79bde28d689cb05$var$Ac(a, c, d);
    if (0 === ($c79bde28d689cb05$var$K & 2) || a !== $c79bde28d689cb05$var$R) a === $c79bde28d689cb05$var$R && (0 === ($c79bde28d689cb05$var$K & 2) && ($c79bde28d689cb05$var$rk |= c), 4 === $c79bde28d689cb05$var$T && $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$Z)), $c79bde28d689cb05$var$Ek(a, d), 1 === c && 0 === $c79bde28d689cb05$var$K && 0 === (b.mode & 1) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
}
function $c79bde28d689cb05$var$Ek(a, b) {
    var c = a.callbackNode;
    $c79bde28d689cb05$var$wc(a, b);
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) null !== c && $c79bde28d689cb05$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c79bde28d689cb05$var$bc(c);
        if (1 === b) 0 === a.tag ? $c79bde28d689cb05$var$ig($c79bde28d689cb05$var$Fk.bind(null, a)) : $c79bde28d689cb05$var$hg($c79bde28d689cb05$var$Fk.bind(null, a)), $c79bde28d689cb05$var$Jf(function() {
            0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
        }), c = null;
        else {
            switch($c79bde28d689cb05$var$Dc(d)){
                case 1:
                    c = $c79bde28d689cb05$var$fc;
                    break;
                case 4:
                    c = $c79bde28d689cb05$var$gc;
                    break;
                case 16:
                    c = $c79bde28d689cb05$var$hc;
                    break;
                case 536870912:
                    c = $c79bde28d689cb05$var$jc;
                    break;
                default:
                    c = $c79bde28d689cb05$var$hc;
            }
            c = $c79bde28d689cb05$var$Gk(c, $c79bde28d689cb05$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c79bde28d689cb05$var$Hk(a, b) {
    $c79bde28d689cb05$var$Bk = -1;
    $c79bde28d689cb05$var$Ck = 0;
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    var c = a.callbackNode;
    if ($c79bde28d689cb05$var$Ik() && a.callbackNode !== c) return null;
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c79bde28d689cb05$var$Jk(a, d);
    else {
        b = d;
        var e = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 2;
        var f = $c79bde28d689cb05$var$Kk();
        if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$Lk(a, b);
        for(;;)try {
            $c79bde28d689cb05$var$Mk();
            break;
        } catch (h) {
            $c79bde28d689cb05$var$Nk(a, h);
        }
        $c79bde28d689cb05$var$Qg();
        $c79bde28d689cb05$var$nk.current = f;
        $c79bde28d689cb05$var$K = e;
        null !== $c79bde28d689cb05$var$Y ? b = 0 : ($c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0, b = $c79bde28d689cb05$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c79bde28d689cb05$var$xc(a), 0 !== e && (d = e, b = $c79bde28d689cb05$var$Ok(a, e)));
        if (1 === b) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
        if (6 === b) $c79bde28d689cb05$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c79bde28d689cb05$var$Pk(e) && (b = $c79bde28d689cb05$var$Jk(a, d), 2 === b && (f = $c79bde28d689cb05$var$xc(a), 0 !== f && (d = f, b = $c79bde28d689cb05$var$Ok(a, f))), 1 === b)) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c79bde28d689cb05$var$p(345));
                case 2:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 3:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $c79bde28d689cb05$var$gk + 500 - $c79bde28d689cb05$var$B(), 10 < b)) {
                        if (0 !== $c79bde28d689cb05$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c79bde28d689cb05$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), b);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 4:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $c79bde28d689cb05$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $c79bde28d689cb05$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c79bde28d689cb05$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), d);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 5:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(329));
            }
        }
    }
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return a.callbackNode === c ? $c79bde28d689cb05$var$Hk.bind(null, a) : null;
}
function $c79bde28d689cb05$var$Ok(a, b) {
    var c = $c79bde28d689cb05$var$tk;
    a.current.memoizedState.isDehydrated && ($c79bde28d689cb05$var$Lk(a, b).flags |= 256);
    a = $c79bde28d689cb05$var$Jk(a, b);
    2 !== a && (b = $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$uk = c, null !== b && $c79bde28d689cb05$var$Gj(b));
    return a;
}
function $c79bde28d689cb05$var$Gj(a) {
    null === $c79bde28d689cb05$var$uk ? $c79bde28d689cb05$var$uk = a : $c79bde28d689cb05$var$uk.push.apply($c79bde28d689cb05$var$uk, a);
}
function $c79bde28d689cb05$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c79bde28d689cb05$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c79bde28d689cb05$var$Dk(a, b) {
    b &= ~$c79bde28d689cb05$var$sk;
    b &= ~$c79bde28d689cb05$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c79bde28d689cb05$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c79bde28d689cb05$var$Fk(a) {
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$uc(a, 0);
    if (0 === (b & 1)) return $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), null;
    var c = $c79bde28d689cb05$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c79bde28d689cb05$var$xc(a);
        0 !== d && (b = d, c = $c79bde28d689cb05$var$Ok(a, d));
    }
    if (1 === c) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, b), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
    if (6 === c) throw Error($c79bde28d689cb05$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return null;
}
function $c79bde28d689cb05$var$Rk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c79bde28d689cb05$var$K = c, 0 === $c79bde28d689cb05$var$K && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
    }
}
function $c79bde28d689cb05$var$Sk(a) {
    null !== $c79bde28d689cb05$var$xk && 0 === $c79bde28d689cb05$var$xk.tag && 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    var c = $c79bde28d689cb05$var$pk.transition, d = $c79bde28d689cb05$var$C;
    try {
        if ($c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, a) return a();
    } finally{
        $c79bde28d689cb05$var$C = d, $c79bde28d689cb05$var$pk.transition = c, $c79bde28d689cb05$var$K = b, 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
    }
}
function $c79bde28d689cb05$var$Ij() {
    $c79bde28d689cb05$var$gj = $c79bde28d689cb05$var$fj.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$fj);
}
function $c79bde28d689cb05$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c79bde28d689cb05$var$Gf(c));
    if (null !== $c79bde28d689cb05$var$Y) for(c = $c79bde28d689cb05$var$Y.return; null !== c;){
        var d = c;
        $c79bde28d689cb05$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c79bde28d689cb05$var$$f();
                break;
            case 3:
                $c79bde28d689cb05$var$Jh();
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
                $c79bde28d689cb05$var$Oh();
                break;
            case 5:
                $c79bde28d689cb05$var$Lh(d);
                break;
            case 4:
                $c79bde28d689cb05$var$Jh();
                break;
            case 13:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 19:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 10:
                $c79bde28d689cb05$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $c79bde28d689cb05$var$Ij();
        }
        c = c.return;
    }
    $c79bde28d689cb05$var$R = a;
    $c79bde28d689cb05$var$Y = a = $c79bde28d689cb05$var$wh(a.current, null);
    $c79bde28d689cb05$var$Z = $c79bde28d689cb05$var$gj = b;
    $c79bde28d689cb05$var$T = 0;
    $c79bde28d689cb05$var$qk = null;
    $c79bde28d689cb05$var$sk = $c79bde28d689cb05$var$rk = $c79bde28d689cb05$var$hh = 0;
    $c79bde28d689cb05$var$uk = $c79bde28d689cb05$var$tk = null;
    if (null !== $c79bde28d689cb05$var$Wg) {
        for(b = 0; b < $c79bde28d689cb05$var$Wg.length; b++)if (c = $c79bde28d689cb05$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c79bde28d689cb05$var$Wg = null;
    }
    return a;
}
function $c79bde28d689cb05$var$Nk(a, b) {
    do {
        var c = $c79bde28d689cb05$var$Y;
        try {
            $c79bde28d689cb05$var$Qg();
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
            if ($c79bde28d689cb05$var$Sh) {
                for(var d = $c79bde28d689cb05$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c79bde28d689cb05$var$Sh = !1;
            }
            $c79bde28d689cb05$var$Rh = 0;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            $c79bde28d689cb05$var$ok.current = null;
            if (null === c || null === c.return) {
                $c79bde28d689cb05$var$T = 1;
                $c79bde28d689cb05$var$qk = b;
                $c79bde28d689cb05$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $c79bde28d689cb05$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $c79bde28d689cb05$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $c79bde28d689cb05$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $c79bde28d689cb05$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c79bde28d689cb05$var$Ti(f, l, b);
                            $c79bde28d689cb05$var$uj();
                            break a;
                        }
                        k = Error($c79bde28d689cb05$var$p(426));
                    }
                } else if ($c79bde28d689cb05$var$I && h.mode & 1) {
                    var J = $c79bde28d689cb05$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $c79bde28d689cb05$var$Wi(J, g, h, f, b);
                        $c79bde28d689cb05$var$Jg($c79bde28d689cb05$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $c79bde28d689cb05$var$Ki(k, h);
                4 !== $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 2);
                null === $c79bde28d689cb05$var$tk ? $c79bde28d689cb05$var$tk = [
                    f
                ] : $c79bde28d689cb05$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $c79bde28d689cb05$var$Oi(f, k, b);
                            $c79bde28d689cb05$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $c79bde28d689cb05$var$Ri(f, h, b);
                                $c79bde28d689cb05$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $c79bde28d689cb05$var$Tk(c);
        } catch (na) {
            b = na;
            $c79bde28d689cb05$var$Y === c && null !== c && ($c79bde28d689cb05$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c79bde28d689cb05$var$Kk() {
    var a = $c79bde28d689cb05$var$nk.current;
    $c79bde28d689cb05$var$nk.current = $c79bde28d689cb05$var$ai;
    return null === a ? $c79bde28d689cb05$var$ai : a;
}
function $c79bde28d689cb05$var$uj() {
    if (0 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T || 2 === $c79bde28d689cb05$var$T) $c79bde28d689cb05$var$T = 4;
    null === $c79bde28d689cb05$var$R || 0 === ($c79bde28d689cb05$var$hh & 268435455) && 0 === ($c79bde28d689cb05$var$rk & 268435455) || $c79bde28d689cb05$var$Dk($c79bde28d689cb05$var$R, $c79bde28d689cb05$var$Z);
}
function $c79bde28d689cb05$var$Jk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 2;
    var d = $c79bde28d689cb05$var$Kk();
    if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Lk(a, b);
    for(;;)try {
        $c79bde28d689cb05$var$Uk();
        break;
    } catch (e) {
        $c79bde28d689cb05$var$Nk(a, e);
    }
    $c79bde28d689cb05$var$Qg();
    $c79bde28d689cb05$var$K = c;
    $c79bde28d689cb05$var$nk.current = d;
    if (null !== $c79bde28d689cb05$var$Y) throw Error($c79bde28d689cb05$var$p(261));
    $c79bde28d689cb05$var$R = null;
    $c79bde28d689cb05$var$Z = 0;
    return $c79bde28d689cb05$var$T;
}
function $c79bde28d689cb05$var$Uk() {
    for(; null !== $c79bde28d689cb05$var$Y;)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Mk() {
    for(; null !== $c79bde28d689cb05$var$Y && !$c79bde28d689cb05$var$cc();)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Vk(a) {
    var b = $c79bde28d689cb05$var$Wk(a.alternate, a, $c79bde28d689cb05$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c79bde28d689cb05$var$Tk(a) : $c79bde28d689cb05$var$Y = b;
    $c79bde28d689cb05$var$ok.current = null;
}
function $c79bde28d689cb05$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $c79bde28d689cb05$var$Fj(c, b, $c79bde28d689cb05$var$gj), null !== c) {
                $c79bde28d689cb05$var$Y = c;
                return;
            }
        } else {
            c = $c79bde28d689cb05$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c79bde28d689cb05$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c79bde28d689cb05$var$T = 6;
                $c79bde28d689cb05$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c79bde28d689cb05$var$Y = b;
            return;
        }
        $c79bde28d689cb05$var$Y = b = a;
    }while (null !== b);
    0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 5);
}
function $c79bde28d689cb05$var$Qk(a, b, c) {
    var d = $c79bde28d689cb05$var$C, e = $c79bde28d689cb05$var$pk.transition;
    try {
        $c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$Xk(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$pk.transition = e, $c79bde28d689cb05$var$C = d;
    }
    return null;
}
function $c79bde28d689cb05$var$Xk(a, b, c, d) {
    do $c79bde28d689cb05$var$Ik();
    while (null !== $c79bde28d689cb05$var$xk);
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c79bde28d689cb05$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c79bde28d689cb05$var$Bc(a, f);
    a === $c79bde28d689cb05$var$R && ($c79bde28d689cb05$var$Y = $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c79bde28d689cb05$var$wk || ($c79bde28d689cb05$var$wk = !0, $c79bde28d689cb05$var$Gk($c79bde28d689cb05$var$hc, function() {
        $c79bde28d689cb05$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c79bde28d689cb05$var$pk.transition;
        $c79bde28d689cb05$var$pk.transition = null;
        var g = $c79bde28d689cb05$var$C;
        $c79bde28d689cb05$var$C = 1;
        var h = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 4;
        $c79bde28d689cb05$var$ok.current = null;
        $c79bde28d689cb05$var$Pj(a, c);
        $c79bde28d689cb05$var$ek(c, a);
        $c79bde28d689cb05$var$Oe($c79bde28d689cb05$var$Df);
        $c79bde28d689cb05$var$dd = !!$c79bde28d689cb05$var$Cf;
        $c79bde28d689cb05$var$Df = $c79bde28d689cb05$var$Cf = null;
        a.current = c;
        $c79bde28d689cb05$var$ik(c, a, e);
        $c79bde28d689cb05$var$dc();
        $c79bde28d689cb05$var$K = h;
        $c79bde28d689cb05$var$C = g;
        $c79bde28d689cb05$var$pk.transition = f;
    } else a.current = c;
    $c79bde28d689cb05$var$wk && ($c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = a, $c79bde28d689cb05$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($c79bde28d689cb05$var$Si = null);
    $c79bde28d689cb05$var$mc(c.stateNode, d);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c79bde28d689cb05$var$Pi) throw $c79bde28d689cb05$var$Pi = !1, a = $c79bde28d689cb05$var$Qi, $c79bde28d689cb05$var$Qi = null, a;
    0 !== ($c79bde28d689cb05$var$yk & 1) && 0 !== a.tag && $c79bde28d689cb05$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $c79bde28d689cb05$var$Ak ? $c79bde28d689cb05$var$zk++ : ($c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = a) : $c79bde28d689cb05$var$zk = 0;
    $c79bde28d689cb05$var$jg();
    return null;
}
function $c79bde28d689cb05$var$Ik() {
    if (null !== $c79bde28d689cb05$var$xk) {
        var a = $c79bde28d689cb05$var$Dc($c79bde28d689cb05$var$yk), b = $c79bde28d689cb05$var$pk.transition, c = $c79bde28d689cb05$var$C;
        try {
            $c79bde28d689cb05$var$pk.transition = null;
            $c79bde28d689cb05$var$C = 16 > a ? 16 : a;
            if (null === $c79bde28d689cb05$var$xk) var d = !1;
            else {
                a = $c79bde28d689cb05$var$xk;
                $c79bde28d689cb05$var$xk = null;
                $c79bde28d689cb05$var$yk = 0;
                if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(331));
                var e = $c79bde28d689cb05$var$K;
                $c79bde28d689cb05$var$K |= 4;
                for($c79bde28d689cb05$var$V = a.current; null !== $c79bde28d689cb05$var$V;){
                    var f = $c79bde28d689cb05$var$V, g = f.child;
                    if (0 !== ($c79bde28d689cb05$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c79bde28d689cb05$var$V = l; null !== $c79bde28d689cb05$var$V;){
                                    var m = $c79bde28d689cb05$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $c79bde28d689cb05$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $c79bde28d689cb05$var$V = q;
                                    else for(; null !== $c79bde28d689cb05$var$V;){
                                        m = $c79bde28d689cb05$var$V;
                                        var r = m.sibling, y = m.return;
                                        $c79bde28d689cb05$var$Tj(m);
                                        if (m === l) {
                                            $c79bde28d689cb05$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $c79bde28d689cb05$var$V = r;
                                            break;
                                        }
                                        $c79bde28d689cb05$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $c79bde28d689cb05$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c79bde28d689cb05$var$V = g;
                    else b: for(; null !== $c79bde28d689cb05$var$V;){
                        f = $c79bde28d689cb05$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $c79bde28d689cb05$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $c79bde28d689cb05$var$V = x;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = f.return;
                    }
                }
                var w = a.current;
                for($c79bde28d689cb05$var$V = w; null !== $c79bde28d689cb05$var$V;){
                    g = $c79bde28d689cb05$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $c79bde28d689cb05$var$V = u;
                    else b: for(g = w; null !== $c79bde28d689cb05$var$V;){
                        h = $c79bde28d689cb05$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $c79bde28d689cb05$var$Rj(9, h);
                            }
                        } catch (na) {
                            $c79bde28d689cb05$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $c79bde28d689cb05$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $c79bde28d689cb05$var$V = F;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = h.return;
                    }
                }
                $c79bde28d689cb05$var$K = e;
                $c79bde28d689cb05$var$jg();
                if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onPostCommitFiberRoot) try {
                    $c79bde28d689cb05$var$lc.onPostCommitFiberRoot($c79bde28d689cb05$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$pk.transition = b;
        }
    }
    return !1;
}
function $c79bde28d689cb05$var$Yk(a, b, c) {
    b = $c79bde28d689cb05$var$Ki(c, b);
    b = $c79bde28d689cb05$var$Oi(a, b, 1);
    a = $c79bde28d689cb05$var$dh(a, b, 1);
    b = $c79bde28d689cb05$var$L();
    null !== a && ($c79bde28d689cb05$var$Ac(a, 1, b), $c79bde28d689cb05$var$Ek(a, b));
}
function $c79bde28d689cb05$var$W(a, b, c) {
    if (3 === a.tag) $c79bde28d689cb05$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c79bde28d689cb05$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(d))) {
                a = $c79bde28d689cb05$var$Ki(c, a);
                a = $c79bde28d689cb05$var$Ri(b, a, 1);
                b = $c79bde28d689cb05$var$dh(b, a, 1);
                a = $c79bde28d689cb05$var$L();
                null !== b && ($c79bde28d689cb05$var$Ac(b, 1, a), $c79bde28d689cb05$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c79bde28d689cb05$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c79bde28d689cb05$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $c79bde28d689cb05$var$R === a && ($c79bde28d689cb05$var$Z & c) === c && (4 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$Z & 130023424) === $c79bde28d689cb05$var$Z && 500 > $c79bde28d689cb05$var$B() - $c79bde28d689cb05$var$gk ? $c79bde28d689cb05$var$Lk(a, 0) : $c79bde28d689cb05$var$sk |= c);
    $c79bde28d689cb05$var$Ek(a, b);
}
function $c79bde28d689cb05$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c79bde28d689cb05$var$sc, $c79bde28d689cb05$var$sc <<= 1, 0 === ($c79bde28d689cb05$var$sc & 130023424) && ($c79bde28d689cb05$var$sc = 4194304)));
    var c = $c79bde28d689cb05$var$L();
    a = $c79bde28d689cb05$var$Zg(a, b);
    null !== a && ($c79bde28d689cb05$var$Ac(a, b, c), $c79bde28d689cb05$var$Ek(a, c));
}
function $c79bde28d689cb05$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c79bde28d689cb05$var$Zk(a, c);
}
function $c79bde28d689cb05$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c79bde28d689cb05$var$p(314));
    }
    null !== d && d.delete(b);
    $c79bde28d689cb05$var$Zk(a, c);
}
var $c79bde28d689cb05$var$Wk;
$c79bde28d689cb05$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c79bde28d689cb05$var$Wf.current) $c79bde28d689cb05$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$zj(a, b, c);
            $c79bde28d689cb05$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$I && 0 !== (b.flags & 1048576) && $c79bde28d689cb05$var$ug(b, $c79bde28d689cb05$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c79bde28d689cb05$var$jj(a, b);
            a = b.pendingProps;
            var e = $c79bde28d689cb05$var$Yf(b, $c79bde28d689cb05$var$H.current);
            $c79bde28d689cb05$var$Tg(b, c);
            e = $c79bde28d689cb05$var$Xh(null, b, d, a, e, c);
            var f = $c79bde28d689cb05$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c79bde28d689cb05$var$Zf(d) ? (f = !0, $c79bde28d689cb05$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c79bde28d689cb05$var$ah(b), e.updater = $c79bde28d689cb05$var$nh, b.stateNode = e, e._reactInternals = b, $c79bde28d689cb05$var$rh(b, d, a, c), b = $c79bde28d689cb05$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $c79bde28d689cb05$var$I && f && $c79bde28d689cb05$var$vg(b), $c79bde28d689cb05$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c79bde28d689cb05$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c79bde28d689cb05$var$$k(d);
                a = $c79bde28d689cb05$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $c79bde28d689cb05$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c79bde28d689cb05$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c79bde28d689cb05$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c79bde28d689cb05$var$aj(null, b, d, $c79bde28d689cb05$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($c79bde28d689cb05$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $c79bde28d689cb05$var$lj(b);
                if (null === a) throw Error($c79bde28d689cb05$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c79bde28d689cb05$var$bh(a, b);
                $c79bde28d689cb05$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(423)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(424)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else for($c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.stateNode.containerInfo.firstChild), $c79bde28d689cb05$var$xg = b, $c79bde28d689cb05$var$I = !0, $c79bde28d689cb05$var$zg = null, c = $c79bde28d689cb05$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c79bde28d689cb05$var$Ig();
                    if (d === e) {
                        b = $c79bde28d689cb05$var$$i(a, b, c);
                        break a;
                    }
                    $c79bde28d689cb05$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c79bde28d689cb05$var$Kh(b), null === a && $c79bde28d689cb05$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c79bde28d689cb05$var$Ef(d, e) ? g = null : null !== f && $c79bde28d689cb05$var$Ef(d, f) && (b.flags |= 32), $c79bde28d689cb05$var$hj(a, b), $c79bde28d689cb05$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $c79bde28d689cb05$var$Eg(b), null;
        case 13:
            return $c79bde28d689cb05$var$pj(a, b, c);
        case 4:
            return $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c79bde28d689cb05$var$Bh(b, null, d, c) : $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$Zi(a, b, d, e, c);
        case 7:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c79bde28d689cb05$var$He(f.value, g)) {
                        if (f.children === e.children && !$c79bde28d689cb05$var$Wf.current) {
                            b = $c79bde28d689cb05$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $c79bde28d689cb05$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $c79bde28d689cb05$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($c79bde28d689cb05$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $c79bde28d689cb05$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $c79bde28d689cb05$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c79bde28d689cb05$var$Tg(b, c), e = $c79bde28d689cb05$var$Vg(e), d = d(e), b.flags |= 1, $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c79bde28d689cb05$var$Lg(d, b.pendingProps), e = $c79bde28d689cb05$var$Lg(d.type, e), $c79bde28d689cb05$var$aj(a, b, d, e, c);
        case 15:
            return $c79bde28d689cb05$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$jj(a, b), b.tag = 1, $c79bde28d689cb05$var$Zf(d) ? (a = !0, $c79bde28d689cb05$var$cg(b)) : a = !1, $c79bde28d689cb05$var$Tg(b, c), $c79bde28d689cb05$var$ph(b, d, e), $c79bde28d689cb05$var$rh(b, d, e, c), $c79bde28d689cb05$var$kj(null, b, d, !0, a, c);
        case 19:
            return $c79bde28d689cb05$var$yj(a, b, c);
        case 22:
            return $c79bde28d689cb05$var$ej(a, b, c);
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
};
function $c79bde28d689cb05$var$Gk(a, b) {
    return $c79bde28d689cb05$var$ac(a, b);
}
function $c79bde28d689cb05$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c79bde28d689cb05$var$Bg(a, b, c, d) {
    return new $c79bde28d689cb05$var$al(a, b, c, d);
}
function $c79bde28d689cb05$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c79bde28d689cb05$var$$k(a) {
    if ("function" === typeof a) return $c79bde28d689cb05$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c79bde28d689cb05$var$Da) return 11;
        if (a === $c79bde28d689cb05$var$Ga) return 14;
    }
    return 2;
}
function $c79bde28d689cb05$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $c79bde28d689cb05$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $c79bde28d689cb05$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c79bde28d689cb05$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c79bde28d689cb05$var$ya:
            return $c79bde28d689cb05$var$Ah(c.children, e, f, b);
        case $c79bde28d689cb05$var$za:
            g = 8;
            e |= 8;
            break;
        case $c79bde28d689cb05$var$Aa:
            return a = $c79bde28d689cb05$var$Bg(12, c, b, e | 2), a.elementType = $c79bde28d689cb05$var$Aa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ea:
            return a = $c79bde28d689cb05$var$Bg(13, c, b, e), a.elementType = $c79bde28d689cb05$var$Ea, a.lanes = f, a;
        case $c79bde28d689cb05$var$Fa:
            return a = $c79bde28d689cb05$var$Bg(19, c, b, e), a.elementType = $c79bde28d689cb05$var$Fa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ia:
            return $c79bde28d689cb05$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c79bde28d689cb05$var$Ba:
                    g = 10;
                    break a;
                case $c79bde28d689cb05$var$Ca:
                    g = 9;
                    break a;
                case $c79bde28d689cb05$var$Da:
                    g = 11;
                    break a;
                case $c79bde28d689cb05$var$Ga:
                    g = 14;
                    break a;
                case $c79bde28d689cb05$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c79bde28d689cb05$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $c79bde28d689cb05$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c79bde28d689cb05$var$Ah(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$qj(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(22, a, d, b);
    a.elementType = $c79bde28d689cb05$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c79bde28d689cb05$var$xh(a, b, c) {
    a = $c79bde28d689cb05$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$zh(a, b, c) {
    b = $c79bde28d689cb05$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c79bde28d689cb05$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c79bde28d689cb05$var$zc(0);
    this.expirationTimes = $c79bde28d689cb05$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c79bde28d689cb05$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $c79bde28d689cb05$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $c79bde28d689cb05$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $c79bde28d689cb05$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c79bde28d689cb05$var$ah(f);
    return a;
}
function $c79bde28d689cb05$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c79bde28d689cb05$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c79bde28d689cb05$var$el(a) {
    if (!a) return $c79bde28d689cb05$var$Vf;
    a = a._reactInternals;
    a: {
        if ($c79bde28d689cb05$var$Vb(a) !== a || 1 !== a.tag) throw Error($c79bde28d689cb05$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c79bde28d689cb05$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c79bde28d689cb05$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c79bde28d689cb05$var$Zf(c)) return $c79bde28d689cb05$var$bg(a, c, b);
    }
    return b;
}
function $c79bde28d689cb05$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $c79bde28d689cb05$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $c79bde28d689cb05$var$el(null);
    c = a.current;
    d = $c79bde28d689cb05$var$L();
    e = $c79bde28d689cb05$var$lh(c);
    f = $c79bde28d689cb05$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c79bde28d689cb05$var$dh(c, f, e);
    a.current.lanes = e;
    $c79bde28d689cb05$var$Ac(a, e, d);
    $c79bde28d689cb05$var$Ek(a, d);
    return a;
}
function $c79bde28d689cb05$var$gl(a, b, c, d) {
    var e = b.current, f = $c79bde28d689cb05$var$L(), g = $c79bde28d689cb05$var$lh(e);
    c = $c79bde28d689cb05$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c79bde28d689cb05$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c79bde28d689cb05$var$dh(e, b, g);
    null !== a && ($c79bde28d689cb05$var$mh(a, e, g, f), $c79bde28d689cb05$var$eh(a, e, g));
    return g;
}
function $c79bde28d689cb05$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c79bde28d689cb05$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c79bde28d689cb05$var$jl(a, b) {
    $c79bde28d689cb05$var$il(a, b);
    (a = a.alternate) && $c79bde28d689cb05$var$il(a, b);
}
function $c79bde28d689cb05$var$kl() {
    return null;
}
var $c79bde28d689cb05$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $c79bde28d689cb05$var$ml(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.render = $c79bde28d689cb05$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c79bde28d689cb05$var$p(409));
    $c79bde28d689cb05$var$gl(a, b, null, null);
};
$c79bde28d689cb05$var$nl.prototype.unmount = $c79bde28d689cb05$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c79bde28d689cb05$var$Sk(function() {
            $c79bde28d689cb05$var$gl(null, a, null, null);
        });
        b[$c79bde28d689cb05$var$uf] = null;
    }
};
function $c79bde28d689cb05$var$nl(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c79bde28d689cb05$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c79bde28d689cb05$var$Qc.length && 0 !== b && b < $c79bde28d689cb05$var$Qc[c].priority; c++);
        $c79bde28d689cb05$var$Qc.splice(c, 0, a);
        0 === c && $c79bde28d689cb05$var$Vc(a);
    }
};
function $c79bde28d689cb05$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c79bde28d689cb05$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c79bde28d689cb05$var$ql() {}
function $c79bde28d689cb05$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                f.call(a);
            };
        }
        var g = $c79bde28d689cb05$var$fl(b, d, a, 0, null, !1, !1, "", $c79bde28d689cb05$var$ql);
        a._reactRootContainer = g;
        a[$c79bde28d689cb05$var$uf] = g.current;
        $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
        $c79bde28d689cb05$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $c79bde28d689cb05$var$hl(k);
            h.call(a);
        };
    }
    var k = $c79bde28d689cb05$var$cl(a, 0, !1, null, null, !1, !1, "", $c79bde28d689cb05$var$ql);
    a._reactRootContainer = k;
    a[$c79bde28d689cb05$var$uf] = k.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    $c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$gl(b, k, c, d);
    });
    return k;
}
function $c79bde28d689cb05$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                h.call(a);
            };
        }
        $c79bde28d689cb05$var$gl(b, g, a, e);
    } else g = $c79bde28d689cb05$var$rl(c, b, a, e, d);
    return $c79bde28d689cb05$var$hl(g);
}
$c79bde28d689cb05$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c79bde28d689cb05$var$tc(b.pendingLanes);
                0 !== c && ($c79bde28d689cb05$var$Cc(b, c | 1), $c79bde28d689cb05$var$Ek(b, $c79bde28d689cb05$var$B()), 0 === ($c79bde28d689cb05$var$K & 6) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$jg()));
            }
            break;
        case 13:
            $c79bde28d689cb05$var$Sk(function() {
                var b = $c79bde28d689cb05$var$Zg(a, 1);
                if (null !== b) {
                    var c = $c79bde28d689cb05$var$L();
                    $c79bde28d689cb05$var$mh(b, a, 1, c);
                }
            }), $c79bde28d689cb05$var$jl(a, 1);
    }
};
$c79bde28d689cb05$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(b, a, 134217728, c);
        }
        $c79bde28d689cb05$var$jl(a, 134217728);
    }
};
$c79bde28d689cb05$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$lh(a), c = $c79bde28d689cb05$var$Zg(a, b);
        if (null !== c) {
            var d = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(c, a, b, d);
        }
        $c79bde28d689cb05$var$jl(a, b);
    }
};
$c79bde28d689cb05$var$Hc = function() {
    return $c79bde28d689cb05$var$C;
};
$c79bde28d689cb05$var$Ic = function(a, b) {
    var c = $c79bde28d689cb05$var$C;
    try {
        return $c79bde28d689cb05$var$C = a, b();
    } finally{
        $c79bde28d689cb05$var$C = c;
    }
};
$c79bde28d689cb05$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $c79bde28d689cb05$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c79bde28d689cb05$var$Db(d);
                        if (!e) throw Error($c79bde28d689cb05$var$p(90));
                        $c79bde28d689cb05$var$Wa(d);
                        $c79bde28d689cb05$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c79bde28d689cb05$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $c79bde28d689cb05$var$fb(a, !!c.multiple, b, !1);
    }
};
$c79bde28d689cb05$var$Gb = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$var$Hb = $c79bde28d689cb05$var$Sk;
var $c79bde28d689cb05$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $c79bde28d689cb05$var$Cb,
        $c79bde28d689cb05$var$ue,
        $c79bde28d689cb05$var$Db,
        $c79bde28d689cb05$var$Eb,
        $c79bde28d689cb05$var$Fb,
        $c79bde28d689cb05$var$Rk
    ]
}, $c79bde28d689cb05$var$ul = {
    findFiberByHostInstance: $c79bde28d689cb05$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $c79bde28d689cb05$var$vl = {
    bundleType: $c79bde28d689cb05$var$ul.bundleType,
    version: $c79bde28d689cb05$var$ul.version,
    rendererPackageName: $c79bde28d689cb05$var$ul.rendererPackageName,
    rendererConfig: $c79bde28d689cb05$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c79bde28d689cb05$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $c79bde28d689cb05$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c79bde28d689cb05$var$ul.findFiberByHostInstance || $c79bde28d689cb05$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c79bde28d689cb05$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c79bde28d689cb05$var$wl.isDisabled && $c79bde28d689cb05$var$wl.supportsFiber) try {
        $c79bde28d689cb05$var$kc = $c79bde28d689cb05$var$wl.inject($c79bde28d689cb05$var$vl), $c79bde28d689cb05$var$lc = $c79bde28d689cb05$var$wl;
    } catch (a) {}
}
$c79bde28d689cb05$export$ae55be85d98224ed = $c79bde28d689cb05$var$tl;
$c79bde28d689cb05$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c79bde28d689cb05$var$ol(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$dl(a, b, null, c);
};
$c79bde28d689cb05$export$882461b6382ed46c = function(a, b) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(299));
    var c = !1, d = "", e = $c79bde28d689cb05$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c79bde28d689cb05$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $c79bde28d689cb05$var$ml(b);
};
$c79bde28d689cb05$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c79bde28d689cb05$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c79bde28d689cb05$var$p(268, a));
    }
    a = $c79bde28d689cb05$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c79bde28d689cb05$export$cd75ccfd720a3cd4 = function(a) {
    return $c79bde28d689cb05$var$Sk(a);
};
$c79bde28d689cb05$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !0, c);
};
$c79bde28d689cb05$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c79bde28d689cb05$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c79bde28d689cb05$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c79bde28d689cb05$var$nl(b);
};
$c79bde28d689cb05$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !1, c);
};
$c79bde28d689cb05$export$502457920280e6be = function(a) {
    if (!$c79bde28d689cb05$var$pl(a)) throw Error($c79bde28d689cb05$var$p(40));
    return a._reactRootContainer ? ($c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c79bde28d689cb05$var$uf] = null;
        });
    }), !0) : !1;
};
$c79bde28d689cb05$export$c78a37762a8d58e1 = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c79bde28d689cb05$var$pl(c)) throw Error($c79bde28d689cb05$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c79bde28d689cb05$var$p(38));
    return $c79bde28d689cb05$var$sl(a, b, c, !1, d);
};
$c79bde28d689cb05$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("ibqfJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dnqd8"));

});
parcelRequire.register("dnqd8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9bd1c1496009b220$export$c4744153514ff05d; }, function (v) { return $9bd1c1496009b220$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7; }, function (v) { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9bd1c1496009b220$export$e26fe2ed2fa76875; }, function (v) { return $9bd1c1496009b220$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9bd1c1496009b220$export$502329bbf4b505b1; }, function (v) { return $9bd1c1496009b220$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9bd1c1496009b220$export$6e3807111c4874c4; }, function (v) { return $9bd1c1496009b220$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9bd1c1496009b220$export$c27134553091fb3a; }, function (v) { return $9bd1c1496009b220$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9bd1c1496009b220$export$33ee1acdc04fd2a2; }, function (v) { return $9bd1c1496009b220$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9bd1c1496009b220$export$b00a404bbd5edef2; }, function (v) { return $9bd1c1496009b220$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9bd1c1496009b220$export$8352ce38b91d0c62; }, function (v) { return $9bd1c1496009b220$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9bd1c1496009b220$export$d66a1c1c77bd778b; }, function (v) { return $9bd1c1496009b220$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9bd1c1496009b220$export$d3dfb8e4810cb555; }, function (v) { return $9bd1c1496009b220$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9bd1c1496009b220$export$839f9183b0465a69; }, function (v) { return $9bd1c1496009b220$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9bd1c1496009b220$export$72fdf0e06517287b; }, function (v) { return $9bd1c1496009b220$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9bd1c1496009b220$export$4b844e58a3e414b4; }, function (v) { return $9bd1c1496009b220$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9bd1c1496009b220$export$816d2913ae6b83b1; }, function (v) { return $9bd1c1496009b220$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9bd1c1496009b220$export$61bcfe829111a1d0; }, function (v) { return $9bd1c1496009b220$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9bd1c1496009b220$export$7ee8c9beb337bc3f; }, function (v) { return $9bd1c1496009b220$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9bd1c1496009b220$export$b5836b71941fa3ed; }, function (v) { return $9bd1c1496009b220$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9bd1c1496009b220$export$cf845f2c119da08a; }, function (v) { return $9bd1c1496009b220$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9bd1c1496009b220$export$c4744153514ff05d;
var $9bd1c1496009b220$export$3e506c1ccc9cc1a7;
var $9bd1c1496009b220$export$e26fe2ed2fa76875;
var $9bd1c1496009b220$export$502329bbf4b505b1;
var $9bd1c1496009b220$export$6e3807111c4874c4;
var $9bd1c1496009b220$export$c27134553091fb3a;
var $9bd1c1496009b220$export$33ee1acdc04fd2a2;
var $9bd1c1496009b220$export$b00a404bbd5edef2;
var $9bd1c1496009b220$export$8352ce38b91d0c62;
var $9bd1c1496009b220$export$d66a1c1c77bd778b;
var $9bd1c1496009b220$export$d3dfb8e4810cb555;
var $9bd1c1496009b220$export$839f9183b0465a69;
var $9bd1c1496009b220$export$72fdf0e06517287b;
var $9bd1c1496009b220$export$4b844e58a3e414b4;
var $9bd1c1496009b220$export$816d2913ae6b83b1;
var $9bd1c1496009b220$export$61bcfe829111a1d0;
var $9bd1c1496009b220$export$7ee8c9beb337bc3f;
var $9bd1c1496009b220$export$b5836b71941fa3ed;
var $9bd1c1496009b220$export$cf845f2c119da08a;
"use strict";
function $9bd1c1496009b220$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9bd1c1496009b220$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9bd1c1496009b220$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9bd1c1496009b220$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9bd1c1496009b220$var$g(C, c)) n < e && 0 > $9bd1c1496009b220$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9bd1c1496009b220$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9bd1c1496009b220$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9bd1c1496009b220$var$l = performance;
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$l.now();
    };
} else {
    var $9bd1c1496009b220$var$p = Date, $9bd1c1496009b220$var$q = $9bd1c1496009b220$var$p.now();
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$p.now() - $9bd1c1496009b220$var$q;
    };
}
var $9bd1c1496009b220$var$r = [], $9bd1c1496009b220$var$t = [], $9bd1c1496009b220$var$u = 1, $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = 3, $9bd1c1496009b220$var$z = !1, $9bd1c1496009b220$var$A = !1, $9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$D = "function" === typeof setTimeout ? setTimeout : null, $9bd1c1496009b220$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9bd1c1496009b220$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9bd1c1496009b220$var$G(a) {
    for(var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t); null !== b;){
        if (null === b.callback) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t);
        else if (b.startTime <= a) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t), b.sortIndex = b.expirationTime, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, b);
        else break;
        b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
    }
}
function $9bd1c1496009b220$var$H(a) {
    $9bd1c1496009b220$var$B = !1;
    $9bd1c1496009b220$var$G(a);
    if (!$9bd1c1496009b220$var$A) {
        if (null !== $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r)) $9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J);
        else {
            var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== b && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, b.startTime - a);
        }
    }
}
function $9bd1c1496009b220$var$J(a, b) {
    $9bd1c1496009b220$var$A = !1;
    $9bd1c1496009b220$var$B && ($9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1);
    $9bd1c1496009b220$var$z = !0;
    var c = $9bd1c1496009b220$var$y;
    try {
        $9bd1c1496009b220$var$G(b);
        for($9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r); null !== $9bd1c1496009b220$var$v && (!($9bd1c1496009b220$var$v.expirationTime > b) || a && !$9bd1c1496009b220$var$M());){
            var d = $9bd1c1496009b220$var$v.callback;
            if ("function" === typeof d) {
                $9bd1c1496009b220$var$v.callback = null;
                $9bd1c1496009b220$var$y = $9bd1c1496009b220$var$v.priorityLevel;
                var e = d($9bd1c1496009b220$var$v.expirationTime <= b);
                b = $9bd1c1496009b220$export$c4744153514ff05d();
                "function" === typeof e ? $9bd1c1496009b220$var$v.callback = e : $9bd1c1496009b220$var$v === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
                $9bd1c1496009b220$var$G(b);
            } else $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
            $9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
        }
        if (null !== $9bd1c1496009b220$var$v) var w = !0;
        else {
            var m = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== m && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = c, $9bd1c1496009b220$var$z = !1;
    }
}
var $9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null, $9bd1c1496009b220$var$L = -1, $9bd1c1496009b220$var$P = 5, $9bd1c1496009b220$var$Q = -1;
function $9bd1c1496009b220$var$M() {
    return $9bd1c1496009b220$export$c4744153514ff05d() - $9bd1c1496009b220$var$Q < $9bd1c1496009b220$var$P ? !1 : !0;
}
function $9bd1c1496009b220$var$R() {
    if (null !== $9bd1c1496009b220$var$O) {
        var a = $9bd1c1496009b220$export$c4744153514ff05d();
        $9bd1c1496009b220$var$Q = a;
        var b = !0;
        try {
            b = $9bd1c1496009b220$var$O(!0, a);
        } finally{
            b ? $9bd1c1496009b220$var$S() : ($9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null);
        }
    } else $9bd1c1496009b220$var$N = !1;
}
var $9bd1c1496009b220$var$S;
if ("function" === typeof $9bd1c1496009b220$var$F) $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$F($9bd1c1496009b220$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9bd1c1496009b220$var$T = new MessageChannel, $9bd1c1496009b220$var$U = $9bd1c1496009b220$var$T.port2;
    $9bd1c1496009b220$var$T.port1.onmessage = $9bd1c1496009b220$var$R;
    $9bd1c1496009b220$var$S = function() {
        $9bd1c1496009b220$var$U.postMessage(null);
    };
} else $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$D($9bd1c1496009b220$var$R, 0);
};
function $9bd1c1496009b220$var$I(a) {
    $9bd1c1496009b220$var$O = a;
    $9bd1c1496009b220$var$N || ($9bd1c1496009b220$var$N = !0, $9bd1c1496009b220$var$S());
}
function $9bd1c1496009b220$var$K(a, b) {
    $9bd1c1496009b220$var$L = $9bd1c1496009b220$var$D(function() {
        a($9bd1c1496009b220$export$c4744153514ff05d());
    }, b);
}
$9bd1c1496009b220$export$3e506c1ccc9cc1a7 = 5;
$9bd1c1496009b220$export$e26fe2ed2fa76875 = 1;
$9bd1c1496009b220$export$502329bbf4b505b1 = 4;
$9bd1c1496009b220$export$6e3807111c4874c4 = 3;
$9bd1c1496009b220$export$c27134553091fb3a = null;
$9bd1c1496009b220$export$33ee1acdc04fd2a2 = 2;
$9bd1c1496009b220$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9bd1c1496009b220$export$8352ce38b91d0c62 = function() {
    $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J));
};
$9bd1c1496009b220$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9bd1c1496009b220$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9bd1c1496009b220$export$d3dfb8e4810cb555 = function() {
    return $9bd1c1496009b220$var$y;
};
$9bd1c1496009b220$export$839f9183b0465a69 = function() {
    return $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
};
$9bd1c1496009b220$export$72fdf0e06517287b = function(a) {
    switch($9bd1c1496009b220$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9bd1c1496009b220$var$y;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = b;
    try {
        return a();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$4b844e58a3e414b4 = function() {};
$9bd1c1496009b220$export$816d2913ae6b83b1 = function() {};
$9bd1c1496009b220$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = a;
    try {
        return b();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9bd1c1496009b220$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9bd1c1496009b220$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$t, a), null === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && a === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t) && ($9bd1c1496009b220$var$B ? ($9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1) : $9bd1c1496009b220$var$B = !0, $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, c - d))) : (a.sortIndex = e, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, a), $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J)));
    return a;
};
$9bd1c1496009b220$export$b5836b71941fa3ed = $9bd1c1496009b220$var$M;
$9bd1c1496009b220$export$cf845f2c119da08a = function(a) {
    var b = $9bd1c1496009b220$var$y;
    return function() {
        var c = $9bd1c1496009b220$var$y;
        $9bd1c1496009b220$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9bd1c1496009b220$var$y = c;
        }
    };
};

});



parcelRequire.register("3U6by", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d7b665dfc4c324e$export$2e2bcd8739ae039; });

var $3xeCd = parcelRequire("3xeCd");
var $2d7b665dfc4c324e$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $2d7b665dfc4c324e$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $3xeCd.default)(function(prop) {
    return $2d7b665dfc4c324e$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRequire.register("3xeCd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $292fca7ef59d5404$export$2e2bcd8739ae039; });
function $292fca7ef59d5404$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRequire.register("8dQlw", function(module, exports) {



module.exports = (parcelRequire("4WKyX"))((parcelRequire("aNJCr")).getBundleURL("EVgbq") + (parcelRequire("iE7OH")).resolve("1wpzf")).then(()=>parcelRequire("4BrO7"));

});
parcelRequire.register("4WKyX", function(module, exports) {
"use strict";

var $2prpb = parcelRequire("2prpb");
module.exports = $2prpb(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRequire.register("2prpb", function(module, exports) {
"use strict";
var $1c132cac09cd18d9$var$cachedBundles = {};
var $1c132cac09cd18d9$var$cachedPreloads = {};
var $1c132cac09cd18d9$var$cachedPrefetches = {};
function $1c132cac09cd18d9$var$getCache(type) {
    switch(type){
        case "preload":
            return $1c132cac09cd18d9$var$cachedPreloads;
        case "prefetch":
            return $1c132cac09cd18d9$var$cachedPrefetches;
        default:
            return $1c132cac09cd18d9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1c132cac09cd18d9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRequire.register("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});


var $7ead0b1397a835ed$exports = {};
"use strict";

$7ead0b1397a835ed$exports = (parcelRequire("6ObR8"));


parcelRequire("exYeM");
var $7bd215913159ea08$export$882461b6382ed46c;
var $7bd215913159ea08$export$757ceba2d55c277e;
"use strict";
var $97dc602bd7e23afa$exports = {};
"use strict";
function $97dc602bd7e23afa$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($97dc602bd7e23afa$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$97dc602bd7e23afa$var$checkDCE();

$97dc602bd7e23afa$exports = (parcelRequire("h8vP0"));


var $7bd215913159ea08$var$i;
$7bd215913159ea08$export$882461b6382ed46c = $97dc602bd7e23afa$exports.createRoot;
$7bd215913159ea08$export$757ceba2d55c277e = $97dc602bd7e23afa$exports.hydrateRoot;





var $exYeM = parcelRequire("exYeM");
var $55016c398784f6a3$export$38e42c68cf43b5d4;
var $55016c398784f6a3$export$385906a4ef528034;
var $55016c398784f6a3$export$69d0d1846105bbd3;
var $55016c398784f6a3$export$a4e0ccd0af956942;
$55016c398784f6a3$export$38e42c68cf43b5d4 = `MqZHCq_header`;
$55016c398784f6a3$export$385906a4ef528034 = `MqZHCq_headerSuccess`;
$55016c398784f6a3$export$69d0d1846105bbd3 = `MqZHCq_invisiblePlaceholder`;
$55016c398784f6a3$export$a4e0ccd0af956942 = `MqZHCq_nothingFake1234`;




var $exYeM = parcelRequire("exYeM");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $a488b22f0ec4487a$var$extendStatics = function(d, b) {
    $a488b22f0ec4487a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a488b22f0ec4487a$var$extendStatics(d, b);
};
function $a488b22f0ec4487a$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a488b22f0ec4487a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a488b22f0ec4487a$export$18ce0697a983be9b = function() {
    $a488b22f0ec4487a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a488b22f0ec4487a$export$18ce0697a983be9b.apply(this, arguments);
};
function $a488b22f0ec4487a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a488b22f0ec4487a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a488b22f0ec4487a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a488b22f0ec4487a$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a488b22f0ec4487a$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a488b22f0ec4487a$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $a488b22f0ec4487a$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a488b22f0ec4487a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a488b22f0ec4487a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a488b22f0ec4487a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a488b22f0ec4487a$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a488b22f0ec4487a$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a488b22f0ec4487a$export$45d3717a4c69092e(o, m, p);
}
function $a488b22f0ec4487a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a488b22f0ec4487a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a488b22f0ec4487a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a488b22f0ec4487a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a488b22f0ec4487a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a488b22f0ec4487a$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a488b22f0ec4487a$export$10c90e4f7922046c(v) {
    return this instanceof $a488b22f0ec4487a$export$10c90e4f7922046c ? (this.v = v, this) : new $a488b22f0ec4487a$export$10c90e4f7922046c(v);
}
function $a488b22f0ec4487a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a488b22f0ec4487a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a488b22f0ec4487a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a488b22f0ec4487a$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a488b22f0ec4487a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a488b22f0ec4487a$export$19a8beecd37a4c45 === "function" ? $a488b22f0ec4487a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a488b22f0ec4487a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a488b22f0ec4487a$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $a488b22f0ec4487a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a488b22f0ec4487a$export$45d3717a4c69092e(result, mod, k);
    }
    $a488b22f0ec4487a$var$__setModuleDefault(result, mod);
    return result;
}
function $a488b22f0ec4487a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a488b22f0ec4487a$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a488b22f0ec4487a$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a488b22f0ec4487a$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a488b22f0ec4487a$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a488b22f0ec4487a$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a488b22f0ec4487a$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a488b22f0ec4487a$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $a488b22f0ec4487a$export$2e2bcd8739ae039 = {
    __extends: $a488b22f0ec4487a$export$a8ba968b8961cb8a,
    __assign: $a488b22f0ec4487a$export$18ce0697a983be9b,
    __rest: $a488b22f0ec4487a$export$3c9a16f847548506,
    __decorate: $a488b22f0ec4487a$export$29e00dfd3077644b,
    __param: $a488b22f0ec4487a$export$d5ad3fd78186038f,
    __metadata: $a488b22f0ec4487a$export$f1db080c865becb9,
    __awaiter: $a488b22f0ec4487a$export$1050f835b63b671e,
    __generator: $a488b22f0ec4487a$export$67ebef60e6f28a6,
    __createBinding: $a488b22f0ec4487a$export$45d3717a4c69092e,
    __exportStar: $a488b22f0ec4487a$export$f33643c0debef087,
    __values: $a488b22f0ec4487a$export$19a8beecd37a4c45,
    __read: $a488b22f0ec4487a$export$8d051b38c9118094,
    __spread: $a488b22f0ec4487a$export$afc72e2116322959,
    __spreadArrays: $a488b22f0ec4487a$export$6388937ca91ccae8,
    __spreadArray: $a488b22f0ec4487a$export$1216008129fb82ed,
    __await: $a488b22f0ec4487a$export$10c90e4f7922046c,
    __asyncGenerator: $a488b22f0ec4487a$export$e427f37a30a4de9b,
    __asyncDelegator: $a488b22f0ec4487a$export$bbd80228419bb833,
    __asyncValues: $a488b22f0ec4487a$export$e3b29a3d6162315f,
    __makeTemplateObject: $a488b22f0ec4487a$export$4fb47efe1390b86f,
    __importStar: $a488b22f0ec4487a$export$c21735bcef00d192,
    __importDefault: $a488b22f0ec4487a$export$da59b14a69baef04,
    __classPrivateFieldGet: $a488b22f0ec4487a$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a488b22f0ec4487a$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a488b22f0ec4487a$export$81fdc39f203e4e04,
    __addDisposableResource: $a488b22f0ec4487a$export$88ac25d8e944e405,
    __disposeResources: $a488b22f0ec4487a$export$8f076105dc360e92
};


parcelRequire("3U6by");

var $exYeM = parcelRequire("exYeM");
var $031c5e26b7af07bf$exports = {};
//
$031c5e26b7af07bf$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $98c7a0c432789d27$export$71ad59f2e432cfe8 = "-ms-";
var $98c7a0c432789d27$export$2c0f367103c8d01c = "-moz-";
var $98c7a0c432789d27$export$39dfd62a25e0fe93 = "-webkit-";
var $98c7a0c432789d27$export$a29989082612d0d9 = "comm";
var $98c7a0c432789d27$export$aa3a2e812ca8570d = "rule";
var $98c7a0c432789d27$export$527d108ccf083c2b = "decl";
var $98c7a0c432789d27$export$d3d35020fa5b54f0 = "@page";
var $98c7a0c432789d27$export$500415a86c544f73 = "@media";
var $98c7a0c432789d27$export$a763edbf796b780a = "@import";
var $98c7a0c432789d27$export$2790aeb8b4e5c826 = "@charset";
var $98c7a0c432789d27$export$1cc683e23b84b133 = "@viewport";
var $98c7a0c432789d27$export$9447a5efea57e862 = "@supports";
var $98c7a0c432789d27$export$ef011b4e114b1fba = "@document";
var $98c7a0c432789d27$export$6aad947bda0f3f46 = "@namespace";
var $98c7a0c432789d27$export$b44a8529a35fcb60 = "@keyframes";
var $98c7a0c432789d27$export$2c16de31893252e6 = "@font-face";
var $98c7a0c432789d27$export$3d846dd52e150c6f = "@counter-style";
var $98c7a0c432789d27$export$22314bfbb57653fe = "@font-feature-values";
var $98c7a0c432789d27$export$d773506282b3cfe6 = "@layer";
var $98c7a0c432789d27$export$1c5a554c78c0cd12 = "@scope";
var $98c7a0c432789d27$export$2335f513bbd82c6d = Math.abs;
var $98c7a0c432789d27$export$6788812c4e6611e6 = String.fromCharCode;
var $98c7a0c432789d27$export$e6e34fd1f2686227 = Object.assign;
function $98c7a0c432789d27$export$d6af199866bfb566(e, r) {
    return $98c7a0c432789d27$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 0)) << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 1)) << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 2)) << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 3) : 0;
}
function $98c7a0c432789d27$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $98c7a0c432789d27$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $98c7a0c432789d27$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $98c7a0c432789d27$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $98c7a0c432789d27$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $98c7a0c432789d27$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $98c7a0c432789d27$export$36776f635604f274(e) {
    return e.length;
}
function $98c7a0c432789d27$export$f9084667e487ed46(e) {
    return e.length;
}
function $98c7a0c432789d27$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $98c7a0c432789d27$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $98c7a0c432789d27$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$98c7a0c432789d27$export$4659b591c19bdf3d(e, r);
    });
}
var $98c7a0c432789d27$export$53f1d5ea8de3d7c = 1;
var $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1;
var $98c7a0c432789d27$export$f24224f1c91d8156 = 0;
var $98c7a0c432789d27$export$5880b8b5730aff45 = 0;
var $98c7a0c432789d27$export$c0306caf338ac095 = 0;
var $98c7a0c432789d27$export$30a86d91af8ff6e6 = "";
function $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $98c7a0c432789d27$export$53f1d5ea8de3d7c,
        column: $98c7a0c432789d27$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $98c7a0c432789d27$export$784d13d8ee351f07(e, r) {
    return $98c7a0c432789d27$export$e6e34fd1f2686227($98c7a0c432789d27$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $98c7a0c432789d27$export$590e8b2c435046d9(e) {
    while(e.root)e = $98c7a0c432789d27$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $98c7a0c432789d27$export$10d8903dec122b9d(e, e.siblings);
}
function $98c7a0c432789d27$export$eba6f6f03b0a92e7() {
    return $98c7a0c432789d27$export$c0306caf338ac095;
}
function $98c7a0c432789d27$export$232faf9add678146() {
    $98c7a0c432789d27$export$c0306caf338ac095 = $98c7a0c432789d27$export$5880b8b5730aff45 > 0 ? $98c7a0c432789d27$export$a9db5e087081082d($98c7a0c432789d27$export$30a86d91af8ff6e6, --$98c7a0c432789d27$export$5880b8b5730aff45) : 0;
    if ($98c7a0c432789d27$export$4e0c71f277ca26b3--, $98c7a0c432789d27$export$c0306caf338ac095 === 10) $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1, $98c7a0c432789d27$export$53f1d5ea8de3d7c--;
    return $98c7a0c432789d27$export$c0306caf338ac095;
}
function $98c7a0c432789d27$export$48cfd1e771a65c4f() {
    $98c7a0c432789d27$export$c0306caf338ac095 = $98c7a0c432789d27$export$5880b8b5730aff45 < $98c7a0c432789d27$export$f24224f1c91d8156 ? $98c7a0c432789d27$export$a9db5e087081082d($98c7a0c432789d27$export$30a86d91af8ff6e6, $98c7a0c432789d27$export$5880b8b5730aff45++) : 0;
    if ($98c7a0c432789d27$export$4e0c71f277ca26b3++, $98c7a0c432789d27$export$c0306caf338ac095 === 10) $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1, $98c7a0c432789d27$export$53f1d5ea8de3d7c++;
    return $98c7a0c432789d27$export$c0306caf338ac095;
}
function $98c7a0c432789d27$export$4d3fb11e950abb9e() {
    return $98c7a0c432789d27$export$a9db5e087081082d($98c7a0c432789d27$export$30a86d91af8ff6e6, $98c7a0c432789d27$export$5880b8b5730aff45);
}
function $98c7a0c432789d27$export$e88cb2efb12ae807() {
    return $98c7a0c432789d27$export$5880b8b5730aff45;
}
function $98c7a0c432789d27$export$58adb3bec8346d0f(e, r) {
    return $98c7a0c432789d27$export$2f35ab04d2335697($98c7a0c432789d27$export$30a86d91af8ff6e6, e, r);
}
function $98c7a0c432789d27$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $98c7a0c432789d27$export$2de70f21292aac9e(e) {
    return $98c7a0c432789d27$export$53f1d5ea8de3d7c = $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1, $98c7a0c432789d27$export$f24224f1c91d8156 = $98c7a0c432789d27$export$36776f635604f274($98c7a0c432789d27$export$30a86d91af8ff6e6 = e), $98c7a0c432789d27$export$5880b8b5730aff45 = 0, [];
}
function $98c7a0c432789d27$export$45918ac1574455b1(e) {
    return $98c7a0c432789d27$export$30a86d91af8ff6e6 = "", e;
}
function $98c7a0c432789d27$export$410ac95b9ec204b8(e) {
    return $98c7a0c432789d27$export$87c2784dc9fc4ab($98c7a0c432789d27$export$58adb3bec8346d0f($98c7a0c432789d27$export$5880b8b5730aff45 - 1, $98c7a0c432789d27$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $98c7a0c432789d27$export$660b2ee2d4fb4eff(e) {
    return $98c7a0c432789d27$export$45918ac1574455b1($98c7a0c432789d27$export$5f8c09e3ae6f64e1($98c7a0c432789d27$export$2de70f21292aac9e(e)));
}
function $98c7a0c432789d27$export$7af1228ff777d175(e) {
    while($98c7a0c432789d27$export$c0306caf338ac095 = $98c7a0c432789d27$export$4d3fb11e950abb9e())if ($98c7a0c432789d27$export$c0306caf338ac095 < 33) $98c7a0c432789d27$export$48cfd1e771a65c4f();
    else break;
    return $98c7a0c432789d27$export$9e1725a4cfeada27(e) > 2 || $98c7a0c432789d27$export$9e1725a4cfeada27($98c7a0c432789d27$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $98c7a0c432789d27$export$5f8c09e3ae6f64e1(e) {
    while($98c7a0c432789d27$export$48cfd1e771a65c4f())switch($98c7a0c432789d27$export$9e1725a4cfeada27($98c7a0c432789d27$export$c0306caf338ac095)){
        case 0:
            $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$c2ab62c7bf24634($98c7a0c432789d27$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$410ac95b9ec204b8($98c7a0c432789d27$export$c0306caf338ac095), e);
            break;
        default:
            $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$6788812c4e6611e6($98c7a0c432789d27$export$c0306caf338ac095), e);
    }
    return e;
}
function $98c7a0c432789d27$export$955ba06d119e085e(e, r) {
    while(--r && $98c7a0c432789d27$export$48cfd1e771a65c4f())if ($98c7a0c432789d27$export$c0306caf338ac095 < 48 || $98c7a0c432789d27$export$c0306caf338ac095 > 102 || $98c7a0c432789d27$export$c0306caf338ac095 > 57 && $98c7a0c432789d27$export$c0306caf338ac095 < 65 || $98c7a0c432789d27$export$c0306caf338ac095 > 70 && $98c7a0c432789d27$export$c0306caf338ac095 < 97) break;
    return $98c7a0c432789d27$export$58adb3bec8346d0f(e, $98c7a0c432789d27$export$e88cb2efb12ae807() + (r < 6 && $98c7a0c432789d27$export$4d3fb11e950abb9e() == 32 && $98c7a0c432789d27$export$48cfd1e771a65c4f() == 32));
}
function $98c7a0c432789d27$export$c889f2fcc19dbf12(e) {
    while($98c7a0c432789d27$export$48cfd1e771a65c4f())switch($98c7a0c432789d27$export$c0306caf338ac095){
        case e:
            return $98c7a0c432789d27$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $98c7a0c432789d27$export$c889f2fcc19dbf12($98c7a0c432789d27$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $98c7a0c432789d27$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $98c7a0c432789d27$export$48cfd1e771a65c4f();
            break;
    }
    return $98c7a0c432789d27$export$5880b8b5730aff45;
}
function $98c7a0c432789d27$export$4254d4e2b3745c4c(e, r) {
    while($98c7a0c432789d27$export$48cfd1e771a65c4f())if (e + $98c7a0c432789d27$export$c0306caf338ac095 === 57) break;
    else if (e + $98c7a0c432789d27$export$c0306caf338ac095 === 84 && $98c7a0c432789d27$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $98c7a0c432789d27$export$58adb3bec8346d0f(r, $98c7a0c432789d27$export$5880b8b5730aff45 - 1) + "*" + $98c7a0c432789d27$export$6788812c4e6611e6(e === 47 ? e : $98c7a0c432789d27$export$48cfd1e771a65c4f());
}
function $98c7a0c432789d27$export$c2ab62c7bf24634(e) {
    while(!$98c7a0c432789d27$export$9e1725a4cfeada27($98c7a0c432789d27$export$4d3fb11e950abb9e()))$98c7a0c432789d27$export$48cfd1e771a65c4f();
    return $98c7a0c432789d27$export$58adb3bec8346d0f(e, $98c7a0c432789d27$export$5880b8b5730aff45);
}
function $98c7a0c432789d27$export$ef7acd7185315e22(e) {
    return $98c7a0c432789d27$export$45918ac1574455b1($98c7a0c432789d27$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $98c7a0c432789d27$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $98c7a0c432789d27$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $98c7a0c432789d27$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $98c7a0c432789d27$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($98c7a0c432789d27$export$f8e21b1e77979a08(z += $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $98c7a0c432789d27$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $98c7a0c432789d27$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $98c7a0c432789d27$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $98c7a0c432789d27$export$955ba06d119e085e($98c7a0c432789d27$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($98c7a0c432789d27$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$4a34f930e789283c($98c7a0c432789d27$export$4254d4e2b3745c4c($98c7a0c432789d27$export$48cfd1e771a65c4f(), $98c7a0c432789d27$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $98c7a0c432789d27$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $98c7a0c432789d27$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $98c7a0c432789d27$export$36776f635604f274(z) - l) $98c7a0c432789d27$export$10d8903dec122b9d(p > 32 ? $98c7a0c432789d27$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $98c7a0c432789d27$export$f8483753829ec8f3($98c7a0c432789d27$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $98c7a0c432789d27$export$10d8903dec122b9d(j = $98c7a0c432789d27$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $98c7a0c432789d27$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $98c7a0c432789d27$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $98c7a0c432789d27$export$98e6a39c04603d36(e, j, j, n && $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $98c7a0c432789d27$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $98c7a0c432789d27$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $98c7a0c432789d27$export$232faf9add678146() == 125) continue;
            }
            switch(z += $98c7a0c432789d27$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($98c7a0c432789d27$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($98c7a0c432789d27$export$4d3fb11e950abb9e() === 45) z += $98c7a0c432789d27$export$410ac95b9ec204b8($98c7a0c432789d27$export$48cfd1e771a65c4f());
                    v = $98c7a0c432789d27$export$4d3fb11e950abb9e(), o = l = $98c7a0c432789d27$export$36776f635604f274(k = z += $98c7a0c432789d27$export$c2ab62c7bf24634($98c7a0c432789d27$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $98c7a0c432789d27$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $98c7a0c432789d27$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $98c7a0c432789d27$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $98c7a0c432789d27$export$2f35ab04d2335697(e, p + 1, p = $98c7a0c432789d27$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $98c7a0c432789d27$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $98c7a0c432789d27$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, s === 0 ? $98c7a0c432789d27$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $98c7a0c432789d27$export$4a34f930e789283c(e, r, a, c) {
    return $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, $98c7a0c432789d27$export$a29989082612d0d9, $98c7a0c432789d27$export$6788812c4e6611e6($98c7a0c432789d27$export$eba6f6f03b0a92e7()), $98c7a0c432789d27$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $98c7a0c432789d27$export$f8483753829ec8f3(e, r, a, n, c) {
    return $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, $98c7a0c432789d27$export$527d108ccf083c2b, $98c7a0c432789d27$export$2f35ab04d2335697(e, 0, n), $98c7a0c432789d27$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $98c7a0c432789d27$export$82e9f45cca5ba907(n, c, s) {
    switch($98c7a0c432789d27$export$d6af199866bfb566(n, c)){
        case 5103:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $98c7a0c432789d27$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$2c0f367103c8d01c + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($98c7a0c432789d27$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "box-$1$2" + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-item-" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$98c7a0c432789d27$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $98c7a0c432789d27$export$71ad59f2e432cfe8 + "grid-row-" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-line-pack" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + "box-" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-grow", "") + $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "box-pack:$3" + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$98c7a0c432789d27$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $98c7a0c432789d27$export$71ad59f2e432cfe8 + "grid-column-align" + $98c7a0c432789d27$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $98c7a0c432789d27$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$98c7a0c432789d27$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$98c7a0c432789d27$export$f8e21b1e77979a08(s, "span", 0) ? $98c7a0c432789d27$export$4659b591c19bdf3d(s, /\d+/) : +$98c7a0c432789d27$export$4659b591c19bdf3d(s, /\d+/) - +$98c7a0c432789d27$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $98c7a0c432789d27$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($98c7a0c432789d27$export$36776f635604f274(n) - 1 - c > 6) switch($98c7a0c432789d27$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($98c7a0c432789d27$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $98c7a0c432789d27$export$2c0f367103c8d01c + ($98c7a0c432789d27$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$98c7a0c432789d27$export$f8e21b1e77979a08(n, "stretch", 0) ? $98c7a0c432789d27$export$82e9f45cca5ba907($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $98c7a0c432789d27$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $98c7a0c432789d27$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($98c7a0c432789d27$export$a9db5e087081082d(n, c + 6) === 121) return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, ":", ":" + $98c7a0c432789d27$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($98c7a0c432789d27$export$a9db5e087081082d(n, $98c7a0c432789d27$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + ($98c7a0c432789d27$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, ":", ":" + $98c7a0c432789d27$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $98c7a0c432789d27$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $98c7a0c432789d27$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $98c7a0c432789d27$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $98c7a0c432789d27$export$a763edbf796b780a:
        case $98c7a0c432789d27$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $98c7a0c432789d27$export$a29989082612d0d9:
            return "";
        case $98c7a0c432789d27$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $98c7a0c432789d27$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $98c7a0c432789d27$export$aa3a2e812ca8570d:
            if (!$98c7a0c432789d27$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $98c7a0c432789d27$export$36776f635604f274(a = $98c7a0c432789d27$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $98c7a0c432789d27$export$5a7767152ae0305f(e) {
    var r = $98c7a0c432789d27$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $98c7a0c432789d27$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $98c7a0c432789d27$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $98c7a0c432789d27$export$527d108ccf083c2b:
                n.return = $98c7a0c432789d27$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $98c7a0c432789d27$export$b44a8529a35fcb60:
                return $98c7a0c432789d27$export$dfdc1655ccc5b9cb([
                    $98c7a0c432789d27$export$784d13d8ee351f07(n, {
                        value: $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $98c7a0c432789d27$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $98c7a0c432789d27$export$aa3a2e812ca8570d:
                if (n.length) return $98c7a0c432789d27$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($98c7a0c432789d27$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $98c7a0c432789d27$export$590e8b2c435046d9($98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                props: [
                                    $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $98c7a0c432789d27$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $98c7a0c432789d27$export$590e8b2c435046d9($98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $98c7a0c432789d27$export$e6e34fd1f2686227(n, {
                                props: $98c7a0c432789d27$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $98c7a0c432789d27$export$590e8b2c435046d9($98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                props: [
                                    $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $98c7a0c432789d27$export$590e8b2c435046d9($98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                props: [
                                    $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $98c7a0c432789d27$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $98c7a0c432789d27$export$590e8b2c435046d9($98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                props: [
                                    $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $98c7a0c432789d27$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $98c7a0c432789d27$export$590e8b2c435046d9($98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $98c7a0c432789d27$export$e6e34fd1f2686227(n, {
                                props: $98c7a0c432789d27$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $98c7a0c432789d27$export$76a88f7de6507443(e) {
    switch(e.type){
        case $98c7a0c432789d27$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $98c7a0c432789d27$export$1be1fc439b849fdf($98c7a0c432789d27$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($98c7a0c432789d27$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $98c7a0c432789d27$export$2f35ab04d2335697(r, 1, $98c7a0c432789d27$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $98c7a0c432789d27$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $98c7a0c432789d27$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $98c7a0c432789d27$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $d9cd8dcf50c5790f$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $4acf49f6c3e67aec$exports = {};
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = $4acf49f6c3e67aec$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = "browser";
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ""; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return "/";
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};


var $93948c98236af5c1$var$f = ("undefined" != typeof $4acf49f6c3e67aec$exports && void 0 !== $4acf49f6c3e67aec$exports.env && undefined, "data-styled"), $93948c98236af5c1$var$m = "active", $93948c98236af5c1$var$y = "data-styled-version", $93948c98236af5c1$export$83d89fbfd8236492 = "6.1.13", $93948c98236af5c1$var$g = "/*!sc*/\n", $93948c98236af5c1$var$S = "undefined" != typeof window && "HTMLElement" in window, $93948c98236af5c1$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $4acf49f6c3e67aec$exports && $4acf49f6c3e67aec$exports.env, "undefined" != typeof $4acf49f6c3e67aec$exports && $4acf49f6c3e67aec$exports.env, false)), $93948c98236af5c1$var$b = {}, $93948c98236af5c1$var$E = /invalid hook call/i, $93948c98236af5c1$var$N = new Set, $93948c98236af5c1$var$P = function(t, n) {
    var o, s, i, a, e;
}, $93948c98236af5c1$var$_ = Object.freeze([]), $93948c98236af5c1$var$C = Object.freeze({});
function $93948c98236af5c1$var$I(e, t, n) {
    return void 0 === n && (n = $93948c98236af5c1$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $93948c98236af5c1$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $93948c98236af5c1$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $93948c98236af5c1$var$D = /(^-|-$)/g;
function $93948c98236af5c1$var$R(e) {
    return e.replace($93948c98236af5c1$var$O, "-").replace($93948c98236af5c1$var$D, "");
}
var $93948c98236af5c1$var$T = /(a)(d)/gi, $93948c98236af5c1$var$k = 52, $93948c98236af5c1$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $93948c98236af5c1$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $93948c98236af5c1$var$k; t = t / $93948c98236af5c1$var$k | 0)n = $93948c98236af5c1$var$j(t % $93948c98236af5c1$var$k) + n;
    return ($93948c98236af5c1$var$j(t % $93948c98236af5c1$var$k) + n).replace($93948c98236af5c1$var$T, "$1-$2");
}
var $93948c98236af5c1$var$V, $93948c98236af5c1$var$F = 5381, $93948c98236af5c1$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $93948c98236af5c1$var$z = function(e) {
    return $93948c98236af5c1$var$M($93948c98236af5c1$var$F, e);
};
function $93948c98236af5c1$var$$(e) {
    return $93948c98236af5c1$var$x($93948c98236af5c1$var$z(e) >>> 0);
}
function $93948c98236af5c1$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $93948c98236af5c1$var$L(e) {
    return "string" == typeof e && true;
}
var $93948c98236af5c1$var$G = "function" == typeof Symbol && Symbol.for, $93948c98236af5c1$var$Y = $93948c98236af5c1$var$G ? Symbol.for("react.memo") : 60115, $93948c98236af5c1$var$W = $93948c98236af5c1$var$G ? Symbol.for("react.forward_ref") : 60112, $93948c98236af5c1$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $93948c98236af5c1$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $93948c98236af5c1$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $93948c98236af5c1$var$J = (($93948c98236af5c1$var$V = {})[$93948c98236af5c1$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $93948c98236af5c1$var$V[$93948c98236af5c1$var$Y] = $93948c98236af5c1$var$U, $93948c98236af5c1$var$V);
function $93948c98236af5c1$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $93948c98236af5c1$var$Y ? $93948c98236af5c1$var$U : "$$typeof" in e ? $93948c98236af5c1$var$J[e.$$typeof] : $93948c98236af5c1$var$q;
}
var $93948c98236af5c1$var$Z = Object.defineProperty, $93948c98236af5c1$var$K = Object.getOwnPropertyNames, $93948c98236af5c1$var$Q = Object.getOwnPropertySymbols, $93948c98236af5c1$var$ee = Object.getOwnPropertyDescriptor, $93948c98236af5c1$var$te = Object.getPrototypeOf, $93948c98236af5c1$var$ne = Object.prototype;
function $93948c98236af5c1$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($93948c98236af5c1$var$ne) {
            var o = $93948c98236af5c1$var$te(t);
            o && o !== $93948c98236af5c1$var$ne && $93948c98236af5c1$var$oe(e, o, n);
        }
        var r = $93948c98236af5c1$var$K(t);
        $93948c98236af5c1$var$Q && (r = r.concat($93948c98236af5c1$var$Q(t)));
        for(var s = $93948c98236af5c1$var$X(e), i = $93948c98236af5c1$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $93948c98236af5c1$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $93948c98236af5c1$var$ee(t, c);
                try {
                    $93948c98236af5c1$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $93948c98236af5c1$var$re(e) {
    return "function" == typeof e;
}
function $93948c98236af5c1$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $93948c98236af5c1$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $93948c98236af5c1$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $93948c98236af5c1$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $93948c98236af5c1$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$93948c98236af5c1$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $93948c98236af5c1$var$le(e[o], t[o]);
    else if ($93948c98236af5c1$var$ce(t)) for(var o in t)e[o] = $93948c98236af5c1$var$le(e[o], t[o]);
    return e;
}
function $93948c98236af5c1$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $93948c98236af5c1$var$pe = {};
function $93948c98236af5c1$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $93948c98236af5c1$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $93948c98236af5c1$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $93948c98236af5c1$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($93948c98236af5c1$var$g);
        return t;
    }, e;
}(), $93948c98236af5c1$var$me = 1073741824, $93948c98236af5c1$var$ye = new Map, $93948c98236af5c1$var$ve = new Map, $93948c98236af5c1$var$ge = 1, $93948c98236af5c1$var$Se = function(e) {
    if ($93948c98236af5c1$var$ye.has(e)) return $93948c98236af5c1$var$ye.get(e);
    for(; $93948c98236af5c1$var$ve.has($93948c98236af5c1$var$ge);)$93948c98236af5c1$var$ge++;
    var t = $93948c98236af5c1$var$ge++;
    return $93948c98236af5c1$var$ye.set(e, t), $93948c98236af5c1$var$ve.set(t, e), t;
}, $93948c98236af5c1$var$we = function(e, t) {
    $93948c98236af5c1$var$ge = t + 1, $93948c98236af5c1$var$ye.set(e, t), $93948c98236af5c1$var$ve.set(t, e);
}, $93948c98236af5c1$var$be = "style[".concat($93948c98236af5c1$var$f, "][").concat($93948c98236af5c1$var$y, '="').concat($93948c98236af5c1$export$83d89fbfd8236492, '"]'), $93948c98236af5c1$var$Ee = new RegExp("^".concat($93948c98236af5c1$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $93948c98236af5c1$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $93948c98236af5c1$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($93948c98236af5c1$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($93948c98236af5c1$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($93948c98236af5c1$var$we(u, l), $93948c98236af5c1$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $93948c98236af5c1$var$_e = function(e) {
    for(var t = document.querySelectorAll($93948c98236af5c1$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($93948c98236af5c1$var$f) !== $93948c98236af5c1$var$m && ($93948c98236af5c1$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $93948c98236af5c1$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $93948c98236af5c1$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($93948c98236af5c1$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($93948c98236af5c1$var$f, $93948c98236af5c1$var$m), o.setAttribute($93948c98236af5c1$var$y, $93948c98236af5c1$export$83d89fbfd8236492);
    var i = $93948c98236af5c1$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $93948c98236af5c1$var$Ae = function() {
    function e(e) {
        this.element = $93948c98236af5c1$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $93948c98236af5c1$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $93948c98236af5c1$var$Oe = function() {
    function e(e) {
        this.element = $93948c98236af5c1$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $93948c98236af5c1$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $93948c98236af5c1$var$Re = $93948c98236af5c1$var$S, $93948c98236af5c1$var$Te = {
    isServer: !$93948c98236af5c1$var$S,
    useCSSOMInjection: !$93948c98236af5c1$var$w
}, $93948c98236af5c1$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $93948c98236af5c1$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $a488b22f0ec4487a$export$18ce0697a983be9b)((0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, $93948c98236af5c1$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $93948c98236af5c1$var$S && $93948c98236af5c1$var$Re && ($93948c98236af5c1$var$Re = !1, $93948c98236af5c1$var$_e(this)), $93948c98236af5c1$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $93948c98236af5c1$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($93948c98236af5c1$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($93948c98236af5c1$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $93948c98236af5c1$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $93948c98236af5c1$var$S && $93948c98236af5c1$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $a488b22f0ec4487a$export$18ce0697a983be9b)((0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $93948c98236af5c1$var$De(n) : t ? new $93948c98236af5c1$var$Ae(n) : new $93948c98236af5c1$var$Oe(n);
        }(this.options), new $93948c98236af5c1$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($93948c98236af5c1$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($93948c98236af5c1$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($93948c98236af5c1$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $93948c98236af5c1$var$je = /&/g, $93948c98236af5c1$var$xe = /^\s*\/\/.*$/gm;
function $93948c98236af5c1$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $93948c98236af5c1$var$Ve(e.children, t)), e;
    });
}
function $93948c98236af5c1$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $93948c98236af5c1$var$C : e, s = r.options, i = void 0 === s ? $93948c98236af5c1$var$C : s, a = r.plugins, c = void 0 === a ? $93948c98236af5c1$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $98c7a0c432789d27$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($93948c98236af5c1$var$je, n).replace(o, l));
    }), i.prefix && u.push($98c7a0c432789d27$export$e08c7d021b829b7a), u.push($98c7a0c432789d27$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($93948c98236af5c1$var$xe, ""), l = $98c7a0c432789d27$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $93948c98236af5c1$var$Ve(l, i.namespace));
        var p = [];
        return $98c7a0c432789d27$export$dfdc1655ccc5b9cb(l, $98c7a0c432789d27$export$5a7767152ae0305f(u.concat($98c7a0c432789d27$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $93948c98236af5c1$var$he(15), $93948c98236af5c1$var$M(e, t.name);
    }, $93948c98236af5c1$var$F).toString() : "", p;
}
var $93948c98236af5c1$var$Me = new $93948c98236af5c1$var$ke, $93948c98236af5c1$var$ze = $93948c98236af5c1$var$Fe(), $93948c98236af5c1$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $93948c98236af5c1$var$Me,
    stylis: $93948c98236af5c1$var$ze
}), $93948c98236af5c1$export$91317688fc694efa = $93948c98236af5c1$export$8c190ef828af4c86.Consumer, $93948c98236af5c1$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(void 0);
function $93948c98236af5c1$var$Ge() {
    return (0, $exYeM.useContext)($93948c98236af5c1$export$8c190ef828af4c86);
}
function $93948c98236af5c1$export$a473771da2f0ff7c(e) {
    var t = (0, $exYeM.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $93948c98236af5c1$var$Ge().styleSheet, l = (0, $exYeM.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $exYeM.useMemo)(function() {
        return $93948c98236af5c1$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $exYeM.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($031c5e26b7af07bf$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $exYeM.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($93948c98236af5c1$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($93948c98236af5c1$var$Le.Provider, {
        value: u
    }, e.children));
}
var $93948c98236af5c1$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $93948c98236af5c1$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $93948c98236af5c1$var$ue(this, function() {
            throw $93948c98236af5c1$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $93948c98236af5c1$var$ze), this.name + e.hash;
    }, e;
}(), $93948c98236af5c1$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $93948c98236af5c1$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $93948c98236af5c1$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $93948c98236af5c1$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $93948c98236af5c1$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$93948c98236af5c1$var$Ue(i) && (Array.isArray(i) && i.isCss || $93948c98236af5c1$var$re(i) ? r.push("".concat($93948c98236af5c1$var$He(s), ":"), i, ";") : $93948c98236af5c1$var$ce(i) ? r.push.apply(r, (0, $a488b22f0ec4487a$export$1216008129fb82ed)((0, $a488b22f0ec4487a$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $93948c98236af5c1$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($93948c98236af5c1$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $d9cd8dcf50c5790f$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $93948c98236af5c1$var$Xe(e, t, n, o) {
    if ($93948c98236af5c1$var$Ue(e)) return [];
    if ($93948c98236af5c1$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($93948c98236af5c1$var$re(e)) {
        if (!$93948c98236af5c1$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $93948c98236af5c1$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $93948c98236af5c1$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $93948c98236af5c1$var$ce(e) ? $93948c98236af5c1$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($93948c98236af5c1$var$_, e.map(function(e) {
        return $93948c98236af5c1$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $93948c98236af5c1$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($93948c98236af5c1$var$re(n) && !$93948c98236af5c1$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $93948c98236af5c1$var$Ke = $93948c98236af5c1$var$z($93948c98236af5c1$export$83d89fbfd8236492), $93948c98236af5c1$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $93948c98236af5c1$var$Ze(e), this.componentId = t, this.baseHash = $93948c98236af5c1$var$M($93948c98236af5c1$var$Ke, t), this.baseStyle = n, $93948c98236af5c1$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $93948c98236af5c1$var$ie(o, this.staticRulesId);
            else {
                var r = $93948c98236af5c1$var$ae($93948c98236af5c1$var$Xe(this.rules, e, t, n)), s = $93948c98236af5c1$var$x($93948c98236af5c1$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $93948c98236af5c1$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $93948c98236af5c1$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $93948c98236af5c1$var$ae($93948c98236af5c1$var$Xe(u, e, t, n));
                    a = $93948c98236af5c1$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $93948c98236af5c1$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $93948c98236af5c1$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $93948c98236af5c1$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(void 0), $93948c98236af5c1$export$b631efc24e9d5e2f = $93948c98236af5c1$export$2c657da244d00bd6.Consumer;
function $93948c98236af5c1$export$93d4e7f90805808f() {
    var e = (0, $exYeM.useContext)($93948c98236af5c1$export$2c657da244d00bd6);
    if (!e) throw $93948c98236af5c1$var$he(18);
    return e;
}
function $93948c98236af5c1$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($93948c98236af5c1$export$2c657da244d00bd6), r = (0, $exYeM.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $93948c98236af5c1$var$he(14);
            if ($93948c98236af5c1$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $93948c98236af5c1$var$he(8);
            return n ? (0, $a488b22f0ec4487a$export$18ce0697a983be9b)((0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($93948c98236af5c1$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $93948c98236af5c1$var$rt = {}, $93948c98236af5c1$var$st = new Set;
function $93948c98236af5c1$var$it(e, r, s) {
    var i = $93948c98236af5c1$export$7ba318d8d2f06c76(e), a = e, c = !$93948c98236af5c1$var$L(e), p = r.attrs, d = void 0 === p ? $93948c98236af5c1$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $93948c98236af5c1$var$R(e);
        $93948c98236af5c1$var$rt[n] = ($93948c98236af5c1$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($93948c98236af5c1$var$$($93948c98236af5c1$export$83d89fbfd8236492 + n + $93948c98236af5c1$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $93948c98236af5c1$var$L(e) ? "styled.".concat(e) : "Styled(".concat($93948c98236af5c1$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($93948c98236af5c1$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $93948c98236af5c1$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($93948c98236af5c1$export$2c657da244d00bd6), m = $93948c98236af5c1$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $93948c98236af5c1$var$I(r, f, c) || $93948c98236af5c1$var$C, g = function(e, n, o) {
                for(var r, s = (0, $a488b22f0ec4487a$export$18ce0697a983be9b)((0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $93948c98236af5c1$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $93948c98236af5c1$var$ie(s[c], a[c]) : "style" === c ? (0, $a488b22f0ec4487a$export$18ce0697a983be9b)((0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $93948c98236af5c1$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $93948c98236af5c1$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $93948c98236af5c1$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$93948c98236af5c1$var$L(S) && !$93948c98236af5c1$var$A.has(S) ? "class" : "className"] = N, w.ref = s, (0, $exYeM.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $93948c98236af5c1$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$93948c98236af5c1$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $93948c98236af5c1$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $93948c98236af5c1$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $93948c98236af5c1$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $93948c98236af5c1$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $93948c98236af5c1$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($93948c98236af5c1$var$re(t) || $93948c98236af5c1$var$ce(t)) return $93948c98236af5c1$var$ct($93948c98236af5c1$var$Xe($93948c98236af5c1$var$at($93948c98236af5c1$var$_, (0, $a488b22f0ec4487a$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $93948c98236af5c1$var$Xe(r) : $93948c98236af5c1$var$ct($93948c98236af5c1$var$Xe($93948c98236af5c1$var$at(r, n)));
}
function $93948c98236af5c1$var$ut(n, o, r) {
    if (void 0 === r && (r = $93948c98236af5c1$var$C), !o) throw $93948c98236af5c1$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $93948c98236af5c1$export$dbf350e5966cf602.apply(void 0, (0, $a488b22f0ec4487a$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $93948c98236af5c1$var$ut(n, o, (0, $a488b22f0ec4487a$export$18ce0697a983be9b)((0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $93948c98236af5c1$var$ut(n, o, (0, $a488b22f0ec4487a$export$18ce0697a983be9b)((0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $93948c98236af5c1$var$pt = function(e) {
    return $93948c98236af5c1$var$ut($93948c98236af5c1$var$it, e);
}, $93948c98236af5c1$export$2e2bcd8739ae039 = $93948c98236af5c1$var$pt;
$93948c98236af5c1$var$A.forEach(function(e) {
    $93948c98236af5c1$export$2e2bcd8739ae039[e] = $93948c98236af5c1$var$pt(e);
});
var $93948c98236af5c1$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $93948c98236af5c1$var$Ze(e), $93948c98236af5c1$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($93948c98236af5c1$var$ae($93948c98236af5c1$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $93948c98236af5c1$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $93948c98236af5c1$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $93948c98236af5c1$export$dbf350e5966cf602.apply(void 0, (0, $a488b22f0ec4487a$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($93948c98236af5c1$var$$(JSON.stringify(i))), c = new $93948c98236af5c1$var$ht(i, a);
    var l = function(e) {
        var t = $93948c98236af5c1$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($93948c98236af5c1$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $93948c98236af5c1$var$b, o, s);
        else {
            var i = (0, $a488b22f0ec4487a$export$18ce0697a983be9b)((0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, n), {
                theme: $93948c98236af5c1$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(l);
}
function $93948c98236af5c1$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $93948c98236af5c1$var$ae($93948c98236af5c1$export$dbf350e5966cf602.apply(void 0, (0, $a488b22f0ec4487a$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $93948c98236af5c1$var$$(r);
    return new $93948c98236af5c1$var$We(s, r);
}
function $93948c98236af5c1$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(function(n, r) {
        var s = $93948c98236af5c1$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($93948c98236af5c1$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(e, (0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($93948c98236af5c1$var$B(e), ")"), $93948c98236af5c1$var$oe(n, e);
}
var $93948c98236af5c1$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $93948c98236af5c1$var$Ce(), o = $93948c98236af5c1$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($93948c98236af5c1$var$f, '="true"'),
                "".concat($93948c98236af5c1$var$y, '="').concat($93948c98236af5c1$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $93948c98236af5c1$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $93948c98236af5c1$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$93948c98236af5c1$var$f] = "", n[$93948c98236af5c1$var$y] = $93948c98236af5c1$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $93948c98236af5c1$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("style", (0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $93948c98236af5c1$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $93948c98236af5c1$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($93948c98236af5c1$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $93948c98236af5c1$var$he(3);
    }, e;
}(), $93948c98236af5c1$export$5c87cfe6c475f500 = {
    StyleSheet: $93948c98236af5c1$var$ke,
    mainSheet: $93948c98236af5c1$var$Me
};
var $93948c98236af5c1$var$St = "__sc-".concat($93948c98236af5c1$var$f, "__");


/**
 * @license
 * Copyright (c) 2023, Jeff Hlywa (jhlywa@gmail.com)
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice,
 *    this list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */ const $aa246c147a5ff844$export$29814851e0aa981f = "w";
const $aa246c147a5ff844$export$7a91b0fde7ec420f = "b";
const $aa246c147a5ff844$export$4c32fd1f222ff2b0 = "p";
const $aa246c147a5ff844$export$ce32bc8c2a29bae6 = "n";
const $aa246c147a5ff844$export$54a167f801c5dba3 = "b";
const $aa246c147a5ff844$export$68d4c913908dc245 = "r";
const $aa246c147a5ff844$export$36a8946792f13ec9 = "q";
const $aa246c147a5ff844$export$42387107bb0d6206 = "k";
const $aa246c147a5ff844$export$1264a6620073cfaa = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1";
const $aa246c147a5ff844$var$EMPTY = -1;
const $aa246c147a5ff844$var$FLAGS = {
    NORMAL: "n",
    CAPTURE: "c",
    BIG_PAWN: "b",
    EP_CAPTURE: "e",
    PROMOTION: "p",
    KSIDE_CASTLE: "k",
    QSIDE_CASTLE: "q"
};
const $aa246c147a5ff844$export$5fc67852ab417150 = [
    "a8",
    "b8",
    "c8",
    "d8",
    "e8",
    "f8",
    "g8",
    "h8",
    "a7",
    "b7",
    "c7",
    "d7",
    "e7",
    "f7",
    "g7",
    "h7",
    "a6",
    "b6",
    "c6",
    "d6",
    "e6",
    "f6",
    "g6",
    "h6",
    "a5",
    "b5",
    "c5",
    "d5",
    "e5",
    "f5",
    "g5",
    "h5",
    "a4",
    "b4",
    "c4",
    "d4",
    "e4",
    "f4",
    "g4",
    "h4",
    "a3",
    "b3",
    "c3",
    "d3",
    "e3",
    "f3",
    "g3",
    "h3",
    "a2",
    "b2",
    "c2",
    "d2",
    "e2",
    "f2",
    "g2",
    "h2",
    "a1",
    "b1",
    "c1",
    "d1",
    "e1",
    "f1",
    "g1",
    "h1"
];
const $aa246c147a5ff844$var$BITS = {
    NORMAL: 1,
    CAPTURE: 2,
    BIG_PAWN: 4,
    EP_CAPTURE: 8,
    PROMOTION: 16,
    KSIDE_CASTLE: 32,
    QSIDE_CASTLE: 64
};
/*
 * NOTES ABOUT 0x88 MOVE GENERATION ALGORITHM
 * ----------------------------------------------------------------------------
 * From https://github.com/jhlywa/chess.js/issues/230
 *
 * A lot of people are confused when they first see the internal representation
 * of chess.js. It uses the 0x88 Move Generation Algorithm which internally
 * stores the board as an 8x16 array. This is purely for efficiency but has a
 * couple of interesting benefits:
 *
 * 1. 0x88 offers a very inexpensive "off the board" check. Bitwise AND (&) any
 *    square with 0x88, if the result is non-zero then the square is off the
 *    board. For example, assuming a knight square A8 (0 in 0x88 notation),
 *    there are 8 possible directions in which the knight can move. These
 *    directions are relative to the 8x16 board and are stored in the
 *    PIECE_OFFSETS map. One possible move is A8 - 18 (up one square, and two
 *    squares to the left - which is off the board). 0 - 18 = -18 & 0x88 = 0x88
 *    (because of two-complement representation of -18). The non-zero result
 *    means the square is off the board and the move is illegal. Take the
 *    opposite move (from A8 to C7), 0 + 18 = 18 & 0x88 = 0. A result of zero
 *    means the square is on the board.
 *
 * 2. The relative distance (or difference) between two squares on a 8x16 board
 *    is unique and can be used to inexpensively determine if a piece on a
 *    square can attack any other arbitrary square. For example, let's see if a
 *    pawn on E7 can attack E2. The difference between E7 (20) - E2 (100) is
 *    -80. We add 119 to make the ATTACKS array index non-negative (because the
 *    worst case difference is A8 - H1 = -119). The ATTACKS array contains a
 *    bitmask of pieces that can attack from that distance and direction.
 *    ATTACKS[-80 + 119=39] gives us 24 or 0b11000 in binary. Look at the
 *    PIECE_MASKS map to determine the mask for a given piece type. In our pawn
 *    example, we would check to see if 24 & 0x1 is non-zero, which it is
 *    not. So, naturally, a pawn on E7 can't attack a piece on E2. However, a
 *    rook can since 24 & 0x8 is non-zero. The only thing left to check is that
 *    there are no blocking pieces between E7 and E2. That's where the RAYS
 *    array comes in. It provides an offset (in this case 16) to add to E7 (20)
 *    to check for blocking pieces. E7 (20) + 16 = E6 (36) + 16 = E5 (52) etc.
 */ // prettier-ignore
// eslint-disable-next-line
const $aa246c147a5ff844$var$Ox88 = {
    a8: 0,
    b8: 1,
    c8: 2,
    d8: 3,
    e8: 4,
    f8: 5,
    g8: 6,
    h8: 7,
    a7: 16,
    b7: 17,
    c7: 18,
    d7: 19,
    e7: 20,
    f7: 21,
    g7: 22,
    h7: 23,
    a6: 32,
    b6: 33,
    c6: 34,
    d6: 35,
    e6: 36,
    f6: 37,
    g6: 38,
    h6: 39,
    a5: 48,
    b5: 49,
    c5: 50,
    d5: 51,
    e5: 52,
    f5: 53,
    g5: 54,
    h5: 55,
    a4: 64,
    b4: 65,
    c4: 66,
    d4: 67,
    e4: 68,
    f4: 69,
    g4: 70,
    h4: 71,
    a3: 80,
    b3: 81,
    c3: 82,
    d3: 83,
    e3: 84,
    f3: 85,
    g3: 86,
    h3: 87,
    a2: 96,
    b2: 97,
    c2: 98,
    d2: 99,
    e2: 100,
    f2: 101,
    g2: 102,
    h2: 103,
    a1: 112,
    b1: 113,
    c1: 114,
    d1: 115,
    e1: 116,
    f1: 117,
    g1: 118,
    h1: 119
};
const $aa246c147a5ff844$var$PAWN_OFFSETS = {
    b: [
        16,
        32,
        17,
        15
    ],
    w: [
        -16,
        -32,
        -17,
        -15
    ]
};
const $aa246c147a5ff844$var$PIECE_OFFSETS = {
    n: [
        -18,
        -33,
        -31,
        -14,
        18,
        33,
        31,
        14
    ],
    b: [
        -17,
        -15,
        17,
        15
    ],
    r: [
        -16,
        1,
        16,
        -1
    ],
    q: [
        -17,
        -16,
        -15,
        1,
        17,
        16,
        15,
        -1
    ],
    k: [
        -17,
        -16,
        -15,
        1,
        17,
        16,
        15,
        -1
    ]
};
// prettier-ignore
const $aa246c147a5ff844$var$ATTACKS = [
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    24,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    2,
    24,
    2,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    53,
    56,
    53,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    24,
    24,
    24,
    24,
    24,
    56,
    0,
    56,
    24,
    24,
    24,
    24,
    24,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    53,
    56,
    53,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    2,
    24,
    2,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    24,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    20
];
// prettier-ignore
const $aa246c147a5ff844$var$RAYS = [
    17,
    0,
    0,
    0,
    0,
    0,
    0,
    16,
    0,
    0,
    0,
    0,
    0,
    0,
    15,
    0,
    0,
    17,
    0,
    0,
    0,
    0,
    0,
    16,
    0,
    0,
    0,
    0,
    0,
    15,
    0,
    0,
    0,
    0,
    17,
    0,
    0,
    0,
    0,
    16,
    0,
    0,
    0,
    0,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    17,
    0,
    0,
    0,
    16,
    0,
    0,
    0,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    17,
    0,
    0,
    16,
    0,
    0,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    17,
    0,
    16,
    0,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    17,
    16,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    -16,
    -17,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    0,
    -16,
    0,
    -17,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    0,
    0,
    -16,
    0,
    0,
    -17,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    0,
    0,
    0,
    -16,
    0,
    0,
    0,
    -17,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    0,
    0,
    0,
    0,
    -16,
    0,
    0,
    0,
    0,
    -17,
    0,
    0,
    0,
    0,
    -15,
    0,
    0,
    0,
    0,
    0,
    -16,
    0,
    0,
    0,
    0,
    0,
    -17,
    0,
    0,
    -15,
    0,
    0,
    0,
    0,
    0,
    0,
    -16,
    0,
    0,
    0,
    0,
    0,
    0,
    -17
];
const $aa246c147a5ff844$var$PIECE_MASKS = {
    p: 0x1,
    n: 0x2,
    b: 0x4,
    r: 0x8,
    q: 0x10,
    k: 0x20
};
const $aa246c147a5ff844$var$SYMBOLS = "pnbrqkPNBRQK";
const $aa246c147a5ff844$var$PROMOTIONS = [
    $aa246c147a5ff844$export$ce32bc8c2a29bae6,
    $aa246c147a5ff844$export$54a167f801c5dba3,
    $aa246c147a5ff844$export$68d4c913908dc245,
    $aa246c147a5ff844$export$36a8946792f13ec9
];
const $aa246c147a5ff844$var$RANK_1 = 7;
const $aa246c147a5ff844$var$RANK_2 = 6;
/*
 * const RANK_3 = 5
 * const RANK_4 = 4
 * const RANK_5 = 3
 * const RANK_6 = 2
 */ const $aa246c147a5ff844$var$RANK_7 = 1;
const $aa246c147a5ff844$var$RANK_8 = 0;
const $aa246c147a5ff844$var$SIDES = {
    [$aa246c147a5ff844$export$42387107bb0d6206]: $aa246c147a5ff844$var$BITS.KSIDE_CASTLE,
    [$aa246c147a5ff844$export$36a8946792f13ec9]: $aa246c147a5ff844$var$BITS.QSIDE_CASTLE
};
const $aa246c147a5ff844$var$ROOKS = {
    w: [
        {
            square: $aa246c147a5ff844$var$Ox88.a1,
            flag: $aa246c147a5ff844$var$BITS.QSIDE_CASTLE
        },
        {
            square: $aa246c147a5ff844$var$Ox88.h1,
            flag: $aa246c147a5ff844$var$BITS.KSIDE_CASTLE
        }
    ],
    b: [
        {
            square: $aa246c147a5ff844$var$Ox88.a8,
            flag: $aa246c147a5ff844$var$BITS.QSIDE_CASTLE
        },
        {
            square: $aa246c147a5ff844$var$Ox88.h8,
            flag: $aa246c147a5ff844$var$BITS.KSIDE_CASTLE
        }
    ]
};
const $aa246c147a5ff844$var$SECOND_RANK = {
    b: $aa246c147a5ff844$var$RANK_7,
    w: $aa246c147a5ff844$var$RANK_2
};
const $aa246c147a5ff844$var$TERMINATION_MARKERS = [
    "1-0",
    "0-1",
    "1/2-1/2",
    "*"
];
// Extracts the zero-based rank of an 0x88 square.
function $aa246c147a5ff844$var$rank(square) {
    return square >> 4;
}
// Extracts the zero-based file of an 0x88 square.
function $aa246c147a5ff844$var$file(square) {
    return square & 0xf;
}
function $aa246c147a5ff844$var$isDigit(c) {
    return "0123456789".indexOf(c) !== -1;
}
// Converts a 0x88 square to algebraic notation.
function $aa246c147a5ff844$var$algebraic(square) {
    const f = $aa246c147a5ff844$var$file(square);
    const r = $aa246c147a5ff844$var$rank(square);
    return "abcdefgh".substring(f, f + 1) + "87654321".substring(r, r + 1);
}
function $aa246c147a5ff844$var$swapColor(color) {
    return color === $aa246c147a5ff844$export$29814851e0aa981f ? $aa246c147a5ff844$export$7a91b0fde7ec420f : $aa246c147a5ff844$export$29814851e0aa981f;
}
function $aa246c147a5ff844$export$d9e02ca3a6185312(fen) {
    // 1st criterion: 6 space-seperated fields?
    const tokens = fen.split(/\s+/);
    if (tokens.length !== 6) return {
        ok: false,
        error: "Invalid FEN: must contain six space-delimited fields"
    };
    // 2nd criterion: move number field is a integer value > 0?
    const moveNumber = parseInt(tokens[5], 10);
    if (isNaN(moveNumber) || moveNumber <= 0) return {
        ok: false,
        error: "Invalid FEN: move number must be a positive integer"
    };
    // 3rd criterion: half move counter is an integer >= 0?
    const halfMoves = parseInt(tokens[4], 10);
    if (isNaN(halfMoves) || halfMoves < 0) return {
        ok: false,
        error: "Invalid FEN: half move counter number must be a non-negative integer"
    };
    // 4th criterion: 4th field is a valid e.p.-string?
    if (!/^(-|[abcdefgh][36])$/.test(tokens[3])) return {
        ok: false,
        error: "Invalid FEN: en-passant square is invalid"
    };
    // 5th criterion: 3th field is a valid castle-string?
    if (/[^kKqQ-]/.test(tokens[2])) return {
        ok: false,
        error: "Invalid FEN: castling availability is invalid"
    };
    // 6th criterion: 2nd field is "w" (white) or "b" (black)?
    if (!/^(w|b)$/.test(tokens[1])) return {
        ok: false,
        error: "Invalid FEN: side-to-move is invalid"
    };
    // 7th criterion: 1st field contains 8 rows?
    const rows = tokens[0].split("/");
    if (rows.length !== 8) return {
        ok: false,
        error: "Invalid FEN: piece data does not contain 8 '/'-delimited rows"
    };
    // 8th criterion: every row is valid?
    for(let i = 0; i < rows.length; i++){
        // check for right sum of fields AND not two numbers in succession
        let sumFields = 0;
        let previousWasNumber = false;
        for(let k = 0; k < rows[i].length; k++)if ($aa246c147a5ff844$var$isDigit(rows[i][k])) {
            if (previousWasNumber) return {
                ok: false,
                error: "Invalid FEN: piece data is invalid (consecutive number)"
            };
            sumFields += parseInt(rows[i][k], 10);
            previousWasNumber = true;
        } else {
            if (!/^[prnbqkPRNBQK]$/.test(rows[i][k])) return {
                ok: false,
                error: "Invalid FEN: piece data is invalid (invalid piece)"
            };
            sumFields += 1;
            previousWasNumber = false;
        }
        if (sumFields !== 8) return {
            ok: false,
            error: "Invalid FEN: piece data is invalid (too many squares in rank)"
        };
    }
    // 9th criterion: is en-passant square legal?
    if (tokens[3][1] == "3" && tokens[1] == "w" || tokens[3][1] == "6" && tokens[1] == "b") return {
        ok: false,
        error: "Invalid FEN: illegal en-passant square"
    };
    // 10th criterion: does chess position contain exact two kings?
    const kings = [
        {
            color: "white",
            regex: /K/g
        },
        {
            color: "black",
            regex: /k/g
        }
    ];
    for (const { color: color , regex: regex  } of kings){
        if (!regex.test(tokens[0])) return {
            ok: false,
            error: `Invalid FEN: missing ${color} king`
        };
        if ((tokens[0].match(regex) || []).length > 1) return {
            ok: false,
            error: `Invalid FEN: too many ${color} kings`
        };
    }
    // 11th criterion: are any pawns on the first or eighth rows?
    if (Array.from(rows[0] + rows[7]).some((char)=>char.toUpperCase() === "P")) return {
        ok: false,
        error: "Invalid FEN: some pawns are on the edge rows"
    };
    return {
        ok: true
    };
}
// this function is used to uniquely identify ambiguous moves
function $aa246c147a5ff844$var$getDisambiguator(move, moves) {
    const from = move.from;
    const to = move.to;
    const piece = move.piece;
    let ambiguities = 0;
    let sameRank = 0;
    let sameFile = 0;
    for(let i = 0, len = moves.length; i < len; i++){
        const ambigFrom = moves[i].from;
        const ambigTo = moves[i].to;
        const ambigPiece = moves[i].piece;
        /*
         * if a move of the same piece type ends on the same to square, we'll need
         * to add a disambiguator to the algebraic notation
         */ if (piece === ambigPiece && from !== ambigFrom && to === ambigTo) {
            ambiguities++;
            if ($aa246c147a5ff844$var$rank(from) === $aa246c147a5ff844$var$rank(ambigFrom)) sameRank++;
            if ($aa246c147a5ff844$var$file(from) === $aa246c147a5ff844$var$file(ambigFrom)) sameFile++;
        }
    }
    if (ambiguities > 0) {
        if (sameRank > 0 && sameFile > 0) /*
             * if there exists a similar moving piece on the same rank and file as
             * the move in question, use the square as the disambiguator
             */ return $aa246c147a5ff844$var$algebraic(from);
        else if (sameFile > 0) /*
             * if the moving piece rests on the same file, use the rank symbol as the
             * disambiguator
             */ return $aa246c147a5ff844$var$algebraic(from).charAt(1);
        else // else use the file symbol
        return $aa246c147a5ff844$var$algebraic(from).charAt(0);
    }
    return "";
}
function $aa246c147a5ff844$var$addMove(moves, color, from, to, piece, captured, flags = $aa246c147a5ff844$var$BITS.NORMAL) {
    const r = $aa246c147a5ff844$var$rank(to);
    if (piece === $aa246c147a5ff844$export$4c32fd1f222ff2b0 && (r === $aa246c147a5ff844$var$RANK_1 || r === $aa246c147a5ff844$var$RANK_8)) for(let i = 0; i < $aa246c147a5ff844$var$PROMOTIONS.length; i++){
        const promotion = $aa246c147a5ff844$var$PROMOTIONS[i];
        moves.push({
            color: color,
            from: from,
            to: to,
            piece: piece,
            captured: captured,
            promotion: promotion,
            flags: flags | $aa246c147a5ff844$var$BITS.PROMOTION
        });
    }
    else moves.push({
        color: color,
        from: from,
        to: to,
        piece: piece,
        captured: captured,
        flags: flags
    });
}
function $aa246c147a5ff844$var$inferPieceType(san) {
    let pieceType = san.charAt(0);
    if (pieceType >= "a" && pieceType <= "h") {
        const matches = san.match(/[a-h]\d.*[a-h]\d/);
        if (matches) return undefined;
        return $aa246c147a5ff844$export$4c32fd1f222ff2b0;
    }
    pieceType = pieceType.toLowerCase();
    if (pieceType === "o") return $aa246c147a5ff844$export$42387107bb0d6206;
    return pieceType;
}
// parses all of the decorators out of a SAN string
function $aa246c147a5ff844$var$strippedSan(move) {
    return move.replace(/=/, "").replace(/[+#]?[?!]*$/, "");
}
function $aa246c147a5ff844$var$trimFen(fen) {
    /*
     * remove last two fields in FEN string as they're not needed when checking
     * for repetition
     */ return fen.split(" ").slice(0, 4).join(" ");
}
class $aa246c147a5ff844$export$a4d6ea685c300d39 {
    _board = new Array(128);
    _turn = $aa246c147a5ff844$export$29814851e0aa981f;
    _header = {};
    _kings = {
        w: $aa246c147a5ff844$var$EMPTY,
        b: $aa246c147a5ff844$var$EMPTY
    };
    _epSquare = -1;
    _halfMoves = 0;
    _moveNumber = 0;
    _history = [];
    _comments = {};
    _castling = {
        w: 0,
        b: 0
    };
    // tracks number of times a position has been seen for repetition checking
    _positionCount = {};
    constructor(fen = $aa246c147a5ff844$export$1264a6620073cfaa){
        this.load(fen);
    }
    clear({ preserveHeaders: preserveHeaders = false  } = {}) {
        this._board = new Array(128);
        this._kings = {
            w: $aa246c147a5ff844$var$EMPTY,
            b: $aa246c147a5ff844$var$EMPTY
        };
        this._turn = $aa246c147a5ff844$export$29814851e0aa981f;
        this._castling = {
            w: 0,
            b: 0
        };
        this._epSquare = $aa246c147a5ff844$var$EMPTY;
        this._halfMoves = 0;
        this._moveNumber = 1;
        this._history = [];
        this._comments = {};
        this._header = preserveHeaders ? this._header : {};
        this._positionCount = {};
        /*
         * Delete the SetUp and FEN headers (if preserved), the board is empty and
         * these headers don't make sense in this state. They'll get added later
         * via .load() or .put()
         */ delete this._header["SetUp"];
        delete this._header["FEN"];
    }
    removeHeader(key) {
        if (key in this._header) delete this._header[key];
    }
    load(fen, { skipValidation: skipValidation = false , preserveHeaders: preserveHeaders = false  } = {}) {
        let tokens = fen.split(/\s+/);
        // append commonly omitted fen tokens
        if (tokens.length >= 2 && tokens.length < 6) {
            const adjustments = [
                "-",
                "-",
                "0",
                "1"
            ];
            fen = tokens.concat(adjustments.slice(-(6 - tokens.length))).join(" ");
        }
        tokens = fen.split(/\s+/);
        if (!skipValidation) {
            const { ok: ok , error: error  } = $aa246c147a5ff844$export$d9e02ca3a6185312(fen);
            if (!ok) throw new Error(error);
        }
        const position = tokens[0];
        let square = 0;
        this.clear({
            preserveHeaders: preserveHeaders
        });
        for(let i = 0; i < position.length; i++){
            const piece = position.charAt(i);
            if (piece === "/") square += 8;
            else if ($aa246c147a5ff844$var$isDigit(piece)) square += parseInt(piece, 10);
            else {
                const color = piece < "a" ? $aa246c147a5ff844$export$29814851e0aa981f : $aa246c147a5ff844$export$7a91b0fde7ec420f;
                this._put({
                    type: piece.toLowerCase(),
                    color: color
                }, $aa246c147a5ff844$var$algebraic(square));
                square++;
            }
        }
        this._turn = tokens[1];
        if (tokens[2].indexOf("K") > -1) this._castling.w |= $aa246c147a5ff844$var$BITS.KSIDE_CASTLE;
        if (tokens[2].indexOf("Q") > -1) this._castling.w |= $aa246c147a5ff844$var$BITS.QSIDE_CASTLE;
        if (tokens[2].indexOf("k") > -1) this._castling.b |= $aa246c147a5ff844$var$BITS.KSIDE_CASTLE;
        if (tokens[2].indexOf("q") > -1) this._castling.b |= $aa246c147a5ff844$var$BITS.QSIDE_CASTLE;
        this._epSquare = tokens[3] === "-" ? $aa246c147a5ff844$var$EMPTY : $aa246c147a5ff844$var$Ox88[tokens[3]];
        this._halfMoves = parseInt(tokens[4], 10);
        this._moveNumber = parseInt(tokens[5], 10);
        this._updateSetup(fen);
        this._incPositionCount(fen);
    }
    fen() {
        let empty = 0;
        let fen = "";
        for(let i = $aa246c147a5ff844$var$Ox88.a8; i <= $aa246c147a5ff844$var$Ox88.h1; i++){
            if (this._board[i]) {
                if (empty > 0) {
                    fen += empty;
                    empty = 0;
                }
                const { color: color , type: piece  } = this._board[i];
                fen += color === $aa246c147a5ff844$export$29814851e0aa981f ? piece.toUpperCase() : piece.toLowerCase();
            } else empty++;
            if (i + 1 & 0x88) {
                if (empty > 0) fen += empty;
                if (i !== $aa246c147a5ff844$var$Ox88.h1) fen += "/";
                empty = 0;
                i += 8;
            }
        }
        let castling = "";
        if (this._castling[$aa246c147a5ff844$export$29814851e0aa981f] & $aa246c147a5ff844$var$BITS.KSIDE_CASTLE) castling += "K";
        if (this._castling[$aa246c147a5ff844$export$29814851e0aa981f] & $aa246c147a5ff844$var$BITS.QSIDE_CASTLE) castling += "Q";
        if (this._castling[$aa246c147a5ff844$export$7a91b0fde7ec420f] & $aa246c147a5ff844$var$BITS.KSIDE_CASTLE) castling += "k";
        if (this._castling[$aa246c147a5ff844$export$7a91b0fde7ec420f] & $aa246c147a5ff844$var$BITS.QSIDE_CASTLE) castling += "q";
        // do we have an empty castling flag?
        castling = castling || "-";
        let epSquare = "-";
        /*
         * only print the ep square if en passant is a valid move (pawn is present
         * and ep capture is not pinned)
         */ if (this._epSquare !== $aa246c147a5ff844$var$EMPTY) {
            const bigPawnSquare = this._epSquare + (this._turn === $aa246c147a5ff844$export$29814851e0aa981f ? 16 : -16);
            const squares = [
                bigPawnSquare + 1,
                bigPawnSquare - 1
            ];
            for (const square of squares){
                // is the square off the board?
                if (square & 0x88) continue;
                const color = this._turn;
                // is there a pawn that can capture the epSquare?
                if (this._board[square]?.color === color && this._board[square]?.type === $aa246c147a5ff844$export$4c32fd1f222ff2b0) {
                    // if the pawn makes an ep capture, does it leave it's king in check?
                    this._makeMove({
                        color: color,
                        from: square,
                        to: this._epSquare,
                        piece: $aa246c147a5ff844$export$4c32fd1f222ff2b0,
                        captured: $aa246c147a5ff844$export$4c32fd1f222ff2b0,
                        flags: $aa246c147a5ff844$var$BITS.EP_CAPTURE
                    });
                    const isLegal = !this._isKingAttacked(color);
                    this._undoMove();
                    // if ep is legal, break and set the ep square in the FEN output
                    if (isLegal) {
                        epSquare = $aa246c147a5ff844$var$algebraic(this._epSquare);
                        break;
                    }
                }
            }
        }
        return [
            fen,
            this._turn,
            castling,
            epSquare,
            this._halfMoves,
            this._moveNumber
        ].join(" ");
    }
    /*
     * Called when the initial board setup is changed with put() or remove().
     * modifies the SetUp and FEN properties of the header object. If the FEN
     * is equal to the default position, the SetUp and FEN are deleted the setup
     * is only updated if history.length is zero, ie moves haven't been made.
     */ _updateSetup(fen) {
        if (this._history.length > 0) return;
        if (fen !== $aa246c147a5ff844$export$1264a6620073cfaa) {
            this._header["SetUp"] = "1";
            this._header["FEN"] = fen;
        } else {
            delete this._header["SetUp"];
            delete this._header["FEN"];
        }
    }
    reset() {
        this.load($aa246c147a5ff844$export$1264a6620073cfaa);
    }
    get(square) {
        return this._board[$aa246c147a5ff844$var$Ox88[square]] || false;
    }
    put({ type: type , color: color  }, square) {
        if (this._put({
            type: type,
            color: color
        }, square)) {
            this._updateCastlingRights();
            this._updateEnPassantSquare();
            this._updateSetup(this.fen());
            return true;
        }
        return false;
    }
    _put({ type: type , color: color  }, square) {
        // check for piece
        if ($aa246c147a5ff844$var$SYMBOLS.indexOf(type.toLowerCase()) === -1) return false;
        // check for valid square
        if (!(square in $aa246c147a5ff844$var$Ox88)) return false;
        const sq = $aa246c147a5ff844$var$Ox88[square];
        // don't let the user place more than one king
        if (type == $aa246c147a5ff844$export$42387107bb0d6206 && !(this._kings[color] == $aa246c147a5ff844$var$EMPTY || this._kings[color] == sq)) return false;
        const currentPieceOnSquare = this._board[sq];
        // if one of the kings will be replaced by the piece from args, set the `_kings` respective entry to `EMPTY`
        if (currentPieceOnSquare && currentPieceOnSquare.type === $aa246c147a5ff844$export$42387107bb0d6206) this._kings[currentPieceOnSquare.color] = $aa246c147a5ff844$var$EMPTY;
        this._board[sq] = {
            type: type,
            color: color
        };
        if (type === $aa246c147a5ff844$export$42387107bb0d6206) this._kings[color] = sq;
        return true;
    }
    remove(square) {
        const piece = this.get(square);
        delete this._board[$aa246c147a5ff844$var$Ox88[square]];
        if (piece && piece.type === $aa246c147a5ff844$export$42387107bb0d6206) this._kings[piece.color] = $aa246c147a5ff844$var$EMPTY;
        this._updateCastlingRights();
        this._updateEnPassantSquare();
        this._updateSetup(this.fen());
        return piece;
    }
    _updateCastlingRights() {
        const whiteKingInPlace = this._board[$aa246c147a5ff844$var$Ox88.e1]?.type === $aa246c147a5ff844$export$42387107bb0d6206 && this._board[$aa246c147a5ff844$var$Ox88.e1]?.color === $aa246c147a5ff844$export$29814851e0aa981f;
        const blackKingInPlace = this._board[$aa246c147a5ff844$var$Ox88.e8]?.type === $aa246c147a5ff844$export$42387107bb0d6206 && this._board[$aa246c147a5ff844$var$Ox88.e8]?.color === $aa246c147a5ff844$export$7a91b0fde7ec420f;
        if (!whiteKingInPlace || this._board[$aa246c147a5ff844$var$Ox88.a1]?.type !== $aa246c147a5ff844$export$68d4c913908dc245 || this._board[$aa246c147a5ff844$var$Ox88.a1]?.color !== $aa246c147a5ff844$export$29814851e0aa981f) this._castling.w &= ~$aa246c147a5ff844$var$BITS.QSIDE_CASTLE;
        if (!whiteKingInPlace || this._board[$aa246c147a5ff844$var$Ox88.h1]?.type !== $aa246c147a5ff844$export$68d4c913908dc245 || this._board[$aa246c147a5ff844$var$Ox88.h1]?.color !== $aa246c147a5ff844$export$29814851e0aa981f) this._castling.w &= ~$aa246c147a5ff844$var$BITS.KSIDE_CASTLE;
        if (!blackKingInPlace || this._board[$aa246c147a5ff844$var$Ox88.a8]?.type !== $aa246c147a5ff844$export$68d4c913908dc245 || this._board[$aa246c147a5ff844$var$Ox88.a8]?.color !== $aa246c147a5ff844$export$7a91b0fde7ec420f) this._castling.b &= ~$aa246c147a5ff844$var$BITS.QSIDE_CASTLE;
        if (!blackKingInPlace || this._board[$aa246c147a5ff844$var$Ox88.h8]?.type !== $aa246c147a5ff844$export$68d4c913908dc245 || this._board[$aa246c147a5ff844$var$Ox88.h8]?.color !== $aa246c147a5ff844$export$7a91b0fde7ec420f) this._castling.b &= ~$aa246c147a5ff844$var$BITS.KSIDE_CASTLE;
    }
    _updateEnPassantSquare() {
        if (this._epSquare === $aa246c147a5ff844$var$EMPTY) return;
        const startSquare = this._epSquare + (this._turn === $aa246c147a5ff844$export$29814851e0aa981f ? -16 : 16);
        const currentSquare = this._epSquare + (this._turn === $aa246c147a5ff844$export$29814851e0aa981f ? 16 : -16);
        const attackers = [
            currentSquare + 1,
            currentSquare - 1
        ];
        if (this._board[startSquare] !== null || this._board[this._epSquare] !== null || this._board[currentSquare]?.color !== $aa246c147a5ff844$var$swapColor(this._turn) || this._board[currentSquare]?.type !== $aa246c147a5ff844$export$4c32fd1f222ff2b0) {
            this._epSquare = $aa246c147a5ff844$var$EMPTY;
            return;
        }
        const canCapture = (square)=>!(square & 0x88) && this._board[square]?.color === this._turn && this._board[square]?.type === $aa246c147a5ff844$export$4c32fd1f222ff2b0;
        if (!attackers.some(canCapture)) this._epSquare = $aa246c147a5ff844$var$EMPTY;
    }
    _attacked(color, square) {
        for(let i = $aa246c147a5ff844$var$Ox88.a8; i <= $aa246c147a5ff844$var$Ox88.h1; i++){
            // did we run off the end of the board
            if (i & 0x88) {
                i += 7;
                continue;
            }
            // if empty square or wrong color
            if (this._board[i] === undefined || this._board[i].color !== color) continue;
            const piece = this._board[i];
            const difference = i - square;
            // skip - to/from square are the same
            if (difference === 0) continue;
            const index = difference + 119;
            if ($aa246c147a5ff844$var$ATTACKS[index] & $aa246c147a5ff844$var$PIECE_MASKS[piece.type]) {
                if (piece.type === $aa246c147a5ff844$export$4c32fd1f222ff2b0) {
                    if (difference > 0) {
                        if (piece.color === $aa246c147a5ff844$export$29814851e0aa981f) return true;
                    } else {
                        if (piece.color === $aa246c147a5ff844$export$7a91b0fde7ec420f) return true;
                    }
                    continue;
                }
                // if the piece is a knight or a king
                if (piece.type === "n" || piece.type === "k") return true;
                const offset = $aa246c147a5ff844$var$RAYS[index];
                let j = i + offset;
                let blocked = false;
                while(j !== square){
                    if (this._board[j] != null) {
                        blocked = true;
                        break;
                    }
                    j += offset;
                }
                if (!blocked) return true;
            }
        }
        return false;
    }
    _isKingAttacked(color) {
        const square = this._kings[color];
        return square === -1 ? false : this._attacked($aa246c147a5ff844$var$swapColor(color), square);
    }
    isAttacked(square, attackedBy) {
        return this._attacked(attackedBy, $aa246c147a5ff844$var$Ox88[square]);
    }
    isCheck() {
        return this._isKingAttacked(this._turn);
    }
    inCheck() {
        return this.isCheck();
    }
    isCheckmate() {
        return this.isCheck() && this._moves().length === 0;
    }
    isStalemate() {
        return !this.isCheck() && this._moves().length === 0;
    }
    isInsufficientMaterial() {
        /*
         * k.b. vs k.b. (of opposite colors) with mate in 1:
         * 8/8/8/8/1b6/8/B1k5/K7 b - - 0 1
         *
         * k.b. vs k.n. with mate in 1:
         * 8/8/8/8/1n6/8/B7/K1k5 b - - 2 1
         */ const pieces = {
            b: 0,
            n: 0,
            r: 0,
            q: 0,
            k: 0,
            p: 0
        };
        const bishops = [];
        let numPieces = 0;
        let squareColor = 0;
        for(let i = $aa246c147a5ff844$var$Ox88.a8; i <= $aa246c147a5ff844$var$Ox88.h1; i++){
            squareColor = (squareColor + 1) % 2;
            if (i & 0x88) {
                i += 7;
                continue;
            }
            const piece = this._board[i];
            if (piece) {
                pieces[piece.type] = piece.type in pieces ? pieces[piece.type] + 1 : 1;
                if (piece.type === $aa246c147a5ff844$export$54a167f801c5dba3) bishops.push(squareColor);
                numPieces++;
            }
        }
        // k vs. k
        if (numPieces === 2) return true;
        else if (// k vs. kn .... or .... k vs. kb
        numPieces === 3 && (pieces[$aa246c147a5ff844$export$54a167f801c5dba3] === 1 || pieces[$aa246c147a5ff844$export$ce32bc8c2a29bae6] === 1)) return true;
        else if (numPieces === pieces[$aa246c147a5ff844$export$54a167f801c5dba3] + 2) {
            // kb vs. kb where any number of bishops are all on the same color
            let sum = 0;
            const len = bishops.length;
            for(let i = 0; i < len; i++)sum += bishops[i];
            if (sum === 0 || sum === len) return true;
        }
        return false;
    }
    isThreefoldRepetition() {
        return this._getPositionCount(this.fen()) >= 3;
    }
    isDraw() {
        return this._halfMoves >= 100 || // 50 moves per side = 100 half moves
        this.isStalemate() || this.isInsufficientMaterial() || this.isThreefoldRepetition();
    }
    isGameOver() {
        return this.isCheckmate() || this.isStalemate() || this.isDraw();
    }
    moves({ verbose: verbose = false , square: square , piece: piece  } = {}) {
        const moves = this._moves({
            square: square,
            piece: piece
        });
        if (verbose) return moves.map((move)=>this._makePretty(move));
        else return moves.map((move)=>this._moveToSan(move, moves));
    }
    _moves({ legal: legal = true , piece: piece , square: square  } = {}) {
        const forSquare = square ? square.toLowerCase() : undefined;
        const forPiece = piece?.toLowerCase();
        const moves = [];
        const us = this._turn;
        const them = $aa246c147a5ff844$var$swapColor(us);
        let firstSquare = $aa246c147a5ff844$var$Ox88.a8;
        let lastSquare = $aa246c147a5ff844$var$Ox88.h1;
        let singleSquare = false;
        // are we generating moves for a single square?
        if (forSquare) {
            // illegal square, return empty moves
            if (!(forSquare in $aa246c147a5ff844$var$Ox88)) return [];
            else {
                firstSquare = lastSquare = $aa246c147a5ff844$var$Ox88[forSquare];
                singleSquare = true;
            }
        }
        for(let from = firstSquare; from <= lastSquare; from++){
            // did we run off the end of the board
            if (from & 0x88) {
                from += 7;
                continue;
            }
            // empty square or opponent, skip
            if (!this._board[from] || this._board[from].color === them) continue;
            const { type: type  } = this._board[from];
            let to;
            if (type === $aa246c147a5ff844$export$4c32fd1f222ff2b0) {
                if (forPiece && forPiece !== type) continue;
                // single square, non-capturing
                to = from + $aa246c147a5ff844$var$PAWN_OFFSETS[us][0];
                if (!this._board[to]) {
                    $aa246c147a5ff844$var$addMove(moves, us, from, to, $aa246c147a5ff844$export$4c32fd1f222ff2b0);
                    // double square
                    to = from + $aa246c147a5ff844$var$PAWN_OFFSETS[us][1];
                    if ($aa246c147a5ff844$var$SECOND_RANK[us] === $aa246c147a5ff844$var$rank(from) && !this._board[to]) $aa246c147a5ff844$var$addMove(moves, us, from, to, $aa246c147a5ff844$export$4c32fd1f222ff2b0, undefined, $aa246c147a5ff844$var$BITS.BIG_PAWN);
                }
                // pawn captures
                for(let j = 2; j < 4; j++){
                    to = from + $aa246c147a5ff844$var$PAWN_OFFSETS[us][j];
                    if (to & 0x88) continue;
                    if (this._board[to]?.color === them) $aa246c147a5ff844$var$addMove(moves, us, from, to, $aa246c147a5ff844$export$4c32fd1f222ff2b0, this._board[to].type, $aa246c147a5ff844$var$BITS.CAPTURE);
                    else if (to === this._epSquare) $aa246c147a5ff844$var$addMove(moves, us, from, to, $aa246c147a5ff844$export$4c32fd1f222ff2b0, $aa246c147a5ff844$export$4c32fd1f222ff2b0, $aa246c147a5ff844$var$BITS.EP_CAPTURE);
                }
            } else {
                if (forPiece && forPiece !== type) continue;
                for(let j = 0, len = $aa246c147a5ff844$var$PIECE_OFFSETS[type].length; j < len; j++){
                    const offset = $aa246c147a5ff844$var$PIECE_OFFSETS[type][j];
                    to = from;
                    while(true){
                        to += offset;
                        if (to & 0x88) break;
                        if (!this._board[to]) $aa246c147a5ff844$var$addMove(moves, us, from, to, type);
                        else {
                            // own color, stop loop
                            if (this._board[to].color === us) break;
                            $aa246c147a5ff844$var$addMove(moves, us, from, to, type, this._board[to].type, $aa246c147a5ff844$var$BITS.CAPTURE);
                            break;
                        }
                        /* break, if knight or king */ if (type === $aa246c147a5ff844$export$ce32bc8c2a29bae6 || type === $aa246c147a5ff844$export$42387107bb0d6206) break;
                    }
                }
            }
        }
        /*
         * check for castling if we're:
         *   a) generating all moves, or
         *   b) doing single square move generation on the king's square
         */ if (forPiece === undefined || forPiece === $aa246c147a5ff844$export$42387107bb0d6206) {
            if (!singleSquare || lastSquare === this._kings[us]) {
                // king-side castling
                if (this._castling[us] & $aa246c147a5ff844$var$BITS.KSIDE_CASTLE) {
                    const castlingFrom = this._kings[us];
                    const castlingTo = castlingFrom + 2;
                    if (!this._board[castlingFrom + 1] && !this._board[castlingTo] && !this._attacked(them, this._kings[us]) && !this._attacked(them, castlingFrom + 1) && !this._attacked(them, castlingTo)) $aa246c147a5ff844$var$addMove(moves, us, this._kings[us], castlingTo, $aa246c147a5ff844$export$42387107bb0d6206, undefined, $aa246c147a5ff844$var$BITS.KSIDE_CASTLE);
                }
                // queen-side castling
                if (this._castling[us] & $aa246c147a5ff844$var$BITS.QSIDE_CASTLE) {
                    const castlingFrom = this._kings[us];
                    const castlingTo = castlingFrom - 2;
                    if (!this._board[castlingFrom - 1] && !this._board[castlingFrom - 2] && !this._board[castlingFrom - 3] && !this._attacked(them, this._kings[us]) && !this._attacked(them, castlingFrom - 1) && !this._attacked(them, castlingTo)) $aa246c147a5ff844$var$addMove(moves, us, this._kings[us], castlingTo, $aa246c147a5ff844$export$42387107bb0d6206, undefined, $aa246c147a5ff844$var$BITS.QSIDE_CASTLE);
                }
            }
        }
        /*
         * return all pseudo-legal moves (this includes moves that allow the king
         * to be captured)
         */ if (!legal || this._kings[us] === -1) return moves;
        // filter out illegal moves
        const legalMoves = [];
        for(let i = 0, len = moves.length; i < len; i++){
            this._makeMove(moves[i]);
            if (!this._isKingAttacked(us)) legalMoves.push(moves[i]);
            this._undoMove();
        }
        return legalMoves;
    }
    move(move, { strict: strict = false  } = {}) {
        /*
         * The move function can be called with in the following parameters:
         *
         * .move('Nxb7')       <- argument is a case-sensitive SAN string
         *
         * .move({ from: 'h7', <- argument is a move object
         *         to :'h8',
         *         promotion: 'q' })
         *
         *
         * An optional strict argument may be supplied to tell chess.js to
         * strictly follow the SAN specification.
         */ let moveObj = null;
        if (typeof move === "string") moveObj = this._moveFromSan(move, strict);
        else if (typeof move === "object") {
            const moves = this._moves();
            // convert the pretty move object to an ugly move object
            for(let i = 0, len = moves.length; i < len; i++)if (move.from === $aa246c147a5ff844$var$algebraic(moves[i].from) && move.to === $aa246c147a5ff844$var$algebraic(moves[i].to) && (!("promotion" in moves[i]) || move.promotion === moves[i].promotion)) {
                moveObj = moves[i];
                break;
            }
        }
        // failed to find move
        if (!moveObj) {
            if (typeof move === "string") throw new Error(`Invalid move: ${move}`);
            else throw new Error(`Invalid move: ${JSON.stringify(move)}`);
        }
        /*
         * need to make a copy of move because we can't generate SAN after the move
         * is made
         */ const prettyMove = this._makePretty(moveObj);
        this._makeMove(moveObj);
        this._incPositionCount(prettyMove.after);
        return prettyMove;
    }
    _push(move) {
        this._history.push({
            move: move,
            kings: {
                b: this._kings.b,
                w: this._kings.w
            },
            turn: this._turn,
            castling: {
                b: this._castling.b,
                w: this._castling.w
            },
            epSquare: this._epSquare,
            halfMoves: this._halfMoves,
            moveNumber: this._moveNumber
        });
    }
    _makeMove(move) {
        const us = this._turn;
        const them = $aa246c147a5ff844$var$swapColor(us);
        this._push(move);
        this._board[move.to] = this._board[move.from];
        delete this._board[move.from];
        // if ep capture, remove the captured pawn
        if (move.flags & $aa246c147a5ff844$var$BITS.EP_CAPTURE) {
            if (this._turn === $aa246c147a5ff844$export$7a91b0fde7ec420f) delete this._board[move.to - 16];
            else delete this._board[move.to + 16];
        }
        // if pawn promotion, replace with new piece
        if (move.promotion) this._board[move.to] = {
            type: move.promotion,
            color: us
        };
        // if we moved the king
        if (this._board[move.to].type === $aa246c147a5ff844$export$42387107bb0d6206) {
            this._kings[us] = move.to;
            // if we castled, move the rook next to the king
            if (move.flags & $aa246c147a5ff844$var$BITS.KSIDE_CASTLE) {
                const castlingTo = move.to - 1;
                const castlingFrom = move.to + 1;
                this._board[castlingTo] = this._board[castlingFrom];
                delete this._board[castlingFrom];
            } else if (move.flags & $aa246c147a5ff844$var$BITS.QSIDE_CASTLE) {
                const castlingTo = move.to + 1;
                const castlingFrom = move.to - 2;
                this._board[castlingTo] = this._board[castlingFrom];
                delete this._board[castlingFrom];
            }
            // turn off castling
            this._castling[us] = 0;
        }
        // turn off castling if we move a rook
        if (this._castling[us]) {
            for(let i = 0, len = $aa246c147a5ff844$var$ROOKS[us].length; i < len; i++)if (move.from === $aa246c147a5ff844$var$ROOKS[us][i].square && this._castling[us] & $aa246c147a5ff844$var$ROOKS[us][i].flag) {
                this._castling[us] ^= $aa246c147a5ff844$var$ROOKS[us][i].flag;
                break;
            }
        }
        // turn off castling if we capture a rook
        if (this._castling[them]) {
            for(let i = 0, len = $aa246c147a5ff844$var$ROOKS[them].length; i < len; i++)if (move.to === $aa246c147a5ff844$var$ROOKS[them][i].square && this._castling[them] & $aa246c147a5ff844$var$ROOKS[them][i].flag) {
                this._castling[them] ^= $aa246c147a5ff844$var$ROOKS[them][i].flag;
                break;
            }
        }
        // if big pawn move, update the en passant square
        if (move.flags & $aa246c147a5ff844$var$BITS.BIG_PAWN) {
            if (us === $aa246c147a5ff844$export$7a91b0fde7ec420f) this._epSquare = move.to - 16;
            else this._epSquare = move.to + 16;
        } else this._epSquare = $aa246c147a5ff844$var$EMPTY;
        // reset the 50 move counter if a pawn is moved or a piece is captured
        if (move.piece === $aa246c147a5ff844$export$4c32fd1f222ff2b0) this._halfMoves = 0;
        else if (move.flags & ($aa246c147a5ff844$var$BITS.CAPTURE | $aa246c147a5ff844$var$BITS.EP_CAPTURE)) this._halfMoves = 0;
        else this._halfMoves++;
        if (us === $aa246c147a5ff844$export$7a91b0fde7ec420f) this._moveNumber++;
        this._turn = them;
    }
    undo() {
        const move = this._undoMove();
        if (move) {
            const prettyMove = this._makePretty(move);
            this._decPositionCount(prettyMove.after);
            return prettyMove;
        }
        return null;
    }
    _undoMove() {
        const old = this._history.pop();
        if (old === undefined) return null;
        const move = old.move;
        this._kings = old.kings;
        this._turn = old.turn;
        this._castling = old.castling;
        this._epSquare = old.epSquare;
        this._halfMoves = old.halfMoves;
        this._moveNumber = old.moveNumber;
        const us = this._turn;
        const them = $aa246c147a5ff844$var$swapColor(us);
        this._board[move.from] = this._board[move.to];
        this._board[move.from].type = move.piece; // to undo any promotions
        delete this._board[move.to];
        if (move.captured) {
            if (move.flags & $aa246c147a5ff844$var$BITS.EP_CAPTURE) {
                // en passant capture
                let index;
                if (us === $aa246c147a5ff844$export$7a91b0fde7ec420f) index = move.to - 16;
                else index = move.to + 16;
                this._board[index] = {
                    type: $aa246c147a5ff844$export$4c32fd1f222ff2b0,
                    color: them
                };
            } else // regular capture
            this._board[move.to] = {
                type: move.captured,
                color: them
            };
        }
        if (move.flags & ($aa246c147a5ff844$var$BITS.KSIDE_CASTLE | $aa246c147a5ff844$var$BITS.QSIDE_CASTLE)) {
            let castlingTo, castlingFrom;
            if (move.flags & $aa246c147a5ff844$var$BITS.KSIDE_CASTLE) {
                castlingTo = move.to + 1;
                castlingFrom = move.to - 1;
            } else {
                castlingTo = move.to - 2;
                castlingFrom = move.to + 1;
            }
            this._board[castlingTo] = this._board[castlingFrom];
            delete this._board[castlingFrom];
        }
        return move;
    }
    pgn({ newline: newline = "\n" , maxWidth: maxWidth = 0  } = {}) {
        /*
         * using the specification from http://www.chessclub.com/help/PGN-spec
         * example for html usage: .pgn({ max_width: 72, newline_char: "<br />" })
         */ const result = [];
        let headerExists = false;
        /* add the PGN header information */ for(const i in this._header){
            /*
             * TODO: order of enumerated properties in header object is not
             * guaranteed, see ECMA-262 spec (section 12.6.4)
             */ result.push("[" + i + ' "' + this._header[i] + '"]' + newline);
            headerExists = true;
        }
        if (headerExists && this._history.length) result.push(newline);
        const appendComment = (moveString)=>{
            const comment = this._comments[this.fen()];
            if (typeof comment !== "undefined") {
                const delimiter = moveString.length > 0 ? " " : "";
                moveString = `${moveString}${delimiter}{${comment}}`;
            }
            return moveString;
        };
        // pop all of history onto reversed_history
        const reversedHistory = [];
        while(this._history.length > 0)reversedHistory.push(this._undoMove());
        const moves = [];
        let moveString = "";
        // special case of a commented starting position with no moves
        if (reversedHistory.length === 0) moves.push(appendComment(""));
        // build the list of moves.  a move_string looks like: "3. e3 e6"
        while(reversedHistory.length > 0){
            moveString = appendComment(moveString);
            const move = reversedHistory.pop();
            // make TypeScript stop complaining about move being undefined
            if (!move) break;
            // if the position started with black to move, start PGN with #. ...
            if (!this._history.length && move.color === "b") {
                const prefix = `${this._moveNumber}. ...`;
                // is there a comment preceding the first move?
                moveString = moveString ? `${moveString} ${prefix}` : prefix;
            } else if (move.color === "w") {
                // store the previous generated move_string if we have one
                if (moveString.length) moves.push(moveString);
                moveString = this._moveNumber + ".";
            }
            moveString = moveString + " " + this._moveToSan(move, this._moves({
                legal: true
            }));
            this._makeMove(move);
        }
        // are there any other leftover moves?
        if (moveString.length) moves.push(appendComment(moveString));
        // is there a result?
        if (typeof this._header.Result !== "undefined") moves.push(this._header.Result);
        /*
         * history should be back to what it was before we started generating PGN,
         * so join together moves
         */ if (maxWidth === 0) return result.join("") + moves.join(" ");
        // TODO (jah): huh?
        const strip = function() {
            if (result.length > 0 && result[result.length - 1] === " ") {
                result.pop();
                return true;
            }
            return false;
        };
        // NB: this does not preserve comment whitespace.
        const wrapComment = function(width, move) {
            for (const token of move.split(" ")){
                if (!token) continue;
                if (width + token.length > maxWidth) {
                    while(strip())width--;
                    result.push(newline);
                    width = 0;
                }
                result.push(token);
                width += token.length;
                result.push(" ");
                width++;
            }
            if (strip()) width--;
            return width;
        };
        // wrap the PGN output at max_width
        let currentWidth = 0;
        for(let i = 0; i < moves.length; i++){
            if (currentWidth + moves[i].length > maxWidth) {
                if (moves[i].includes("{")) {
                    currentWidth = wrapComment(currentWidth, moves[i]);
                    continue;
                }
            }
            // if the current move will push past max_width
            if (currentWidth + moves[i].length > maxWidth && i !== 0) {
                // don't end the line with whitespace
                if (result[result.length - 1] === " ") result.pop();
                result.push(newline);
                currentWidth = 0;
            } else if (i !== 0) {
                result.push(" ");
                currentWidth++;
            }
            result.push(moves[i]);
            currentWidth += moves[i].length;
        }
        return result.join("");
    }
    header(...args) {
        for(let i = 0; i < args.length; i += 2)if (typeof args[i] === "string" && typeof args[i + 1] === "string") this._header[args[i]] = args[i + 1];
        return this._header;
    }
    loadPgn(pgn, { strict: strict = false , newlineChar: newlineChar = "\r?\n"  } = {}) {
        function mask(str) {
            return str.replace(/\\/g, "\\");
        }
        function parsePgnHeader(header) {
            const headerObj = {};
            const headers = header.split(new RegExp(mask(newlineChar)));
            let key = "";
            let value = "";
            for(let i = 0; i < headers.length; i++){
                const regex = /^\s*\[\s*([A-Za-z]+)\s*"(.*)"\s*\]\s*$/;
                key = headers[i].replace(regex, "$1");
                value = headers[i].replace(regex, "$2");
                if (key.trim().length > 0) headerObj[key] = value;
            }
            return headerObj;
        }
        // strip whitespace from head/tail of PGN block
        pgn = pgn.trim();
        /*
         * RegExp to split header. Takes advantage of the fact that header and movetext
         * will always have a blank line between them (ie, two newline_char's). Handles
         * case where movetext is empty by matching newlineChar until end of string is
         * matched - effectively trimming from the end extra newlineChar.
         *
         * With default newline_char, will equal:
         * /^(\[((?:\r?\n)|.)*\])((?:\s*\r?\n){2}|(?:\s*\r?\n)*$)/
         */ const headerRegex = new RegExp("^(\\[((?:" + mask(newlineChar) + ")|.)*\\])" + "((?:\\s*" + mask(newlineChar) + "){2}|(?:\\s*" + mask(newlineChar) + ")*$)");
        // If no header given, begin with moves.
        const headerRegexResults = headerRegex.exec(pgn);
        const headerString = headerRegexResults ? headerRegexResults.length >= 2 ? headerRegexResults[1] : "" : "";
        // Put the board in the starting position
        this.reset();
        // parse PGN header
        const headers = parsePgnHeader(headerString);
        let fen = "";
        for(const key in headers){
            // check to see user is including fen (possibly with wrong tag case)
            if (key.toLowerCase() === "fen") fen = headers[key];
            this.header(key, headers[key]);
        }
        /*
         * the permissive parser should attempt to load a fen tag, even if it's the
         * wrong case and doesn't include a corresponding [SetUp "1"] tag
         */ if (!strict) {
            if (fen) this.load(fen, {
                preserveHeaders: true
            });
        } else /*
             * strict parser - load the starting position indicated by [Setup '1']
             * and [FEN position]
             */ if (headers["SetUp"] === "1") {
            if (!("FEN" in headers)) throw new Error("Invalid PGN: FEN tag must be supplied with SetUp tag");
            // don't clear the headers when loading
            this.load(headers["FEN"], {
                preserveHeaders: true
            });
        }
        /*
         * NB: the regexes below that delete move numbers, recursive annotations,
         * and numeric annotation glyphs may also match text in comments. To
         * prevent this, we transform comments by hex-encoding them in place and
         * decoding them again after the other tokens have been deleted.
         *
         * While the spec states that PGN files should be ASCII encoded, we use
         * {en,de}codeURIComponent here to support arbitrary UTF8 as a convenience
         * for modern users
         */ function toHex(s) {
            return Array.from(s).map(function(c) {
                /*
                 * encodeURI doesn't transform most ASCII characters, so we handle
                 * these ourselves
                 */ return c.charCodeAt(0) < 128 ? c.charCodeAt(0).toString(16) : encodeURIComponent(c).replace(/%/g, "").toLowerCase();
            }).join("");
        }
        function fromHex(s) {
            return s.length == 0 ? "" : decodeURIComponent("%" + (s.match(/.{1,2}/g) || []).join("%"));
        }
        const encodeComment = function(s) {
            s = s.replace(new RegExp(mask(newlineChar), "g"), " ");
            return `{${toHex(s.slice(1, s.length - 1))}}`;
        };
        const decodeComment = function(s) {
            if (s.startsWith("{") && s.endsWith("}")) return fromHex(s.slice(1, s.length - 1));
        };
        // delete header to get the moves
        let ms = pgn.replace(headerString, "").replace(// encode comments so they don't get deleted below
        new RegExp(`({[^}]*})+?|;([^${mask(newlineChar)}]*)`, "g"), function(_match, bracket, semicolon) {
            return bracket !== undefined ? encodeComment(bracket) : " " + encodeComment(`{${semicolon.slice(1)}}`);
        }).replace(new RegExp(mask(newlineChar), "g"), " ");
        // delete recursive annotation variations
        const ravRegex = /(\([^()]+\))+?/g;
        while(ravRegex.test(ms))ms = ms.replace(ravRegex, "");
        // delete move numbers
        ms = ms.replace(/\d+\.(\.\.)?/g, "");
        // delete ... indicating black to move
        ms = ms.replace(/\.\.\./g, "");
        /* delete numeric annotation glyphs */ ms = ms.replace(/\$\d+/g, "");
        // trim and get array of moves
        let moves = ms.trim().split(new RegExp(/\s+/));
        // delete empty entries
        moves = moves.filter((move)=>move !== "");
        let result = "";
        for(let halfMove = 0; halfMove < moves.length; halfMove++){
            const comment = decodeComment(moves[halfMove]);
            if (comment !== undefined) {
                this._comments[this.fen()] = comment;
                continue;
            }
            const move = this._moveFromSan(moves[halfMove], strict);
            // invalid move
            if (move == null) {
                // was the move an end of game marker
                if ($aa246c147a5ff844$var$TERMINATION_MARKERS.indexOf(moves[halfMove]) > -1) result = moves[halfMove];
                else throw new Error(`Invalid move in PGN: ${moves[halfMove]}`);
            } else {
                // reset the end of game marker if making a valid move
                result = "";
                this._makeMove(move);
                this._incPositionCount(this.fen());
            }
        }
        /*
         * Per section 8.2.6 of the PGN spec, the Result tag pair must match match
         * the termination marker. Only do this when headers are present, but the
         * result tag is missing
         */ if (result && Object.keys(this._header).length && !this._header["Result"]) this.header("Result", result);
    }
    /*
     * Convert a move from 0x88 coordinates to Standard Algebraic Notation
     * (SAN)
     *
     * @param {boolean} strict Use the strict SAN parser. It will throw errors
     * on overly disambiguated moves (see below):
     *
     * r1bqkbnr/ppp2ppp/2n5/1B1pP3/4P3/8/PPPP2PP/RNBQK1NR b KQkq - 2 4
     * 4. ... Nge7 is overly disambiguated because the knight on c6 is pinned
     * 4. ... Ne7 is technically the valid SAN
     */ _moveToSan(move, moves) {
        let output = "";
        if (move.flags & $aa246c147a5ff844$var$BITS.KSIDE_CASTLE) output = "O-O";
        else if (move.flags & $aa246c147a5ff844$var$BITS.QSIDE_CASTLE) output = "O-O-O";
        else {
            if (move.piece !== $aa246c147a5ff844$export$4c32fd1f222ff2b0) {
                const disambiguator = $aa246c147a5ff844$var$getDisambiguator(move, moves);
                output += move.piece.toUpperCase() + disambiguator;
            }
            if (move.flags & ($aa246c147a5ff844$var$BITS.CAPTURE | $aa246c147a5ff844$var$BITS.EP_CAPTURE)) {
                if (move.piece === $aa246c147a5ff844$export$4c32fd1f222ff2b0) output += $aa246c147a5ff844$var$algebraic(move.from)[0];
                output += "x";
            }
            output += $aa246c147a5ff844$var$algebraic(move.to);
            if (move.promotion) output += "=" + move.promotion.toUpperCase();
        }
        this._makeMove(move);
        if (this.isCheck()) {
            if (this.isCheckmate()) output += "#";
            else output += "+";
        }
        this._undoMove();
        return output;
    }
    // convert a move from Standard Algebraic Notation (SAN) to 0x88 coordinates
    _moveFromSan(move, strict = false) {
        // strip off any move decorations: e.g Nf3+?! becomes Nf3
        const cleanMove = $aa246c147a5ff844$var$strippedSan(move);
        let pieceType = $aa246c147a5ff844$var$inferPieceType(cleanMove);
        let moves = this._moves({
            legal: true,
            piece: pieceType
        });
        // strict parser
        for(let i = 0, len = moves.length; i < len; i++){
            if (cleanMove === $aa246c147a5ff844$var$strippedSan(this._moveToSan(moves[i], moves))) return moves[i];
        }
        // the strict parser failed
        if (strict) return null;
        let piece = undefined;
        let matches = undefined;
        let from = undefined;
        let to = undefined;
        let promotion = undefined;
        /*
         * The default permissive (non-strict) parser allows the user to parse
         * non-standard chess notations. This parser is only run after the strict
         * Standard Algebraic Notation (SAN) parser has failed.
         *
         * When running the permissive parser, we'll run a regex to grab the piece, the
         * to/from square, and an optional promotion piece. This regex will
         * parse common non-standard notation like: Pe2-e4, Rc1c4, Qf3xf7,
         * f7f8q, b1c3
         *
         * NOTE: Some positions and moves may be ambiguous when using the permissive
         * parser. For example, in this position: 6k1/8/8/B7/8/8/8/BN4K1 w - - 0 1,
         * the move b1c3 may be interpreted as Nc3 or B1c3 (a disambiguated bishop
         * move). In these cases, the permissive parser will default to the most
         * basic interpretation (which is b1c3 parsing to Nc3).
         */ let overlyDisambiguated = false;
        matches = cleanMove.match(/([pnbrqkPNBRQK])?([a-h][1-8])x?-?([a-h][1-8])([qrbnQRBN])?/);
        if (matches) {
            piece = matches[1];
            from = matches[2];
            to = matches[3];
            promotion = matches[4];
            if (from.length == 1) overlyDisambiguated = true;
        } else {
            /*
             * The [a-h]?[1-8]? portion of the regex below handles moves that may be
             * overly disambiguated (e.g. Nge7 is unnecessary and non-standard when
             * there is one legal knight move to e7). In this case, the value of
             * 'from' variable will be a rank or file, not a square.
             */ matches = cleanMove.match(/([pnbrqkPNBRQK])?([a-h]?[1-8]?)x?-?([a-h][1-8])([qrbnQRBN])?/);
            if (matches) {
                piece = matches[1];
                from = matches[2];
                to = matches[3];
                promotion = matches[4];
                if (from.length == 1) overlyDisambiguated = true;
            }
        }
        pieceType = $aa246c147a5ff844$var$inferPieceType(cleanMove);
        moves = this._moves({
            legal: true,
            piece: piece ? piece : pieceType
        });
        if (!to) return null;
        for(let i = 0, len = moves.length; i < len; i++){
            if (!from) {
                // if there is no from square, it could be just 'x' missing from a capture
                if (cleanMove === $aa246c147a5ff844$var$strippedSan(this._moveToSan(moves[i], moves)).replace("x", "")) return moves[i];
            // hand-compare move properties with the results from our permissive regex
            } else if ((!piece || piece.toLowerCase() == moves[i].piece) && $aa246c147a5ff844$var$Ox88[from] == moves[i].from && $aa246c147a5ff844$var$Ox88[to] == moves[i].to && (!promotion || promotion.toLowerCase() == moves[i].promotion)) return moves[i];
            else if (overlyDisambiguated) {
                /*
                 * SPECIAL CASE: we parsed a move string that may have an unneeded
                 * rank/file disambiguator (e.g. Nge7).  The 'from' variable will
                 */ const square = $aa246c147a5ff844$var$algebraic(moves[i].from);
                if ((!piece || piece.toLowerCase() == moves[i].piece) && $aa246c147a5ff844$var$Ox88[to] == moves[i].to && (from == square[0] || from == square[1]) && (!promotion || promotion.toLowerCase() == moves[i].promotion)) return moves[i];
            }
        }
        return null;
    }
    ascii() {
        let s = "   +------------------------+\n";
        for(let i = $aa246c147a5ff844$var$Ox88.a8; i <= $aa246c147a5ff844$var$Ox88.h1; i++){
            // display the rank
            if ($aa246c147a5ff844$var$file(i) === 0) s += " " + "87654321"[$aa246c147a5ff844$var$rank(i)] + " |";
            if (this._board[i]) {
                const piece = this._board[i].type;
                const color = this._board[i].color;
                const symbol = color === $aa246c147a5ff844$export$29814851e0aa981f ? piece.toUpperCase() : piece.toLowerCase();
                s += " " + symbol + " ";
            } else s += " . ";
            if (i + 1 & 0x88) {
                s += "|\n";
                i += 8;
            }
        }
        s += "   +------------------------+\n";
        s += "     a  b  c  d  e  f  g  h";
        return s;
    }
    perft(depth) {
        const moves = this._moves({
            legal: false
        });
        let nodes = 0;
        const color = this._turn;
        for(let i = 0, len = moves.length; i < len; i++){
            this._makeMove(moves[i]);
            if (!this._isKingAttacked(color)) {
                if (depth - 1 > 0) nodes += this.perft(depth - 1);
                else nodes++;
            }
            this._undoMove();
        }
        return nodes;
    }
    // pretty = external move object
    _makePretty(uglyMove) {
        const { color: color , piece: piece , from: from , to: to , flags: flags , captured: captured , promotion: promotion  } = uglyMove;
        let prettyFlags = "";
        for(const flag in $aa246c147a5ff844$var$BITS)if ($aa246c147a5ff844$var$BITS[flag] & flags) prettyFlags += $aa246c147a5ff844$var$FLAGS[flag];
        const fromAlgebraic = $aa246c147a5ff844$var$algebraic(from);
        const toAlgebraic = $aa246c147a5ff844$var$algebraic(to);
        const move = {
            color: color,
            piece: piece,
            from: fromAlgebraic,
            to: toAlgebraic,
            san: this._moveToSan(uglyMove, this._moves({
                legal: true
            })),
            flags: prettyFlags,
            lan: fromAlgebraic + toAlgebraic,
            before: this.fen(),
            after: ""
        };
        // generate the FEN for the 'after' key
        this._makeMove(uglyMove);
        move.after = this.fen();
        this._undoMove();
        if (captured) move.captured = captured;
        if (promotion) {
            move.promotion = promotion;
            move.lan += promotion;
        }
        return move;
    }
    turn() {
        return this._turn;
    }
    board() {
        const output = [];
        let row = [];
        for(let i = $aa246c147a5ff844$var$Ox88.a8; i <= $aa246c147a5ff844$var$Ox88.h1; i++){
            if (this._board[i] == null) row.push(null);
            else row.push({
                square: $aa246c147a5ff844$var$algebraic(i),
                type: this._board[i].type,
                color: this._board[i].color
            });
            if (i + 1 & 0x88) {
                output.push(row);
                row = [];
                i += 8;
            }
        }
        return output;
    }
    squareColor(square) {
        if (square in $aa246c147a5ff844$var$Ox88) {
            const sq = $aa246c147a5ff844$var$Ox88[square];
            return ($aa246c147a5ff844$var$rank(sq) + $aa246c147a5ff844$var$file(sq)) % 2 === 0 ? "light" : "dark";
        }
        return null;
    }
    history({ verbose: verbose = false  } = {}) {
        const reversedHistory = [];
        const moveHistory = [];
        while(this._history.length > 0)reversedHistory.push(this._undoMove());
        while(true){
            const move = reversedHistory.pop();
            if (!move) break;
            if (verbose) moveHistory.push(this._makePretty(move));
            else moveHistory.push(this._moveToSan(move, this._moves()));
            this._makeMove(move);
        }
        return moveHistory;
    }
    /*
     * Keeps track of position occurrence counts for the purpose of repetition
     * checking. All three methods (`_inc`, `_dec`, and `_get`) trim the
     * irrelevent information from the fen, initialising new positions, and
     * removing old positions from the record if their counts are reduced to 0.
     */ _getPositionCount(fen) {
        const trimmedFen = $aa246c147a5ff844$var$trimFen(fen);
        return this._positionCount[trimmedFen] || 0;
    }
    _incPositionCount(fen) {
        const trimmedFen = $aa246c147a5ff844$var$trimFen(fen);
        if (this._positionCount[trimmedFen] === undefined) this._positionCount[trimmedFen] = 0;
        this._positionCount[trimmedFen] += 1;
    }
    _decPositionCount(fen) {
        const trimmedFen = $aa246c147a5ff844$var$trimFen(fen);
        if (this._positionCount[trimmedFen] === 1) delete this._positionCount[trimmedFen];
        else this._positionCount[trimmedFen] -= 1;
    }
    _pruneComments() {
        const reversedHistory = [];
        const currentComments = {};
        const copyComment = (fen)=>{
            if (fen in this._comments) currentComments[fen] = this._comments[fen];
        };
        while(this._history.length > 0)reversedHistory.push(this._undoMove());
        copyComment(this.fen());
        while(true){
            const move = reversedHistory.pop();
            if (!move) break;
            this._makeMove(move);
            copyComment(this.fen());
        }
        this._comments = currentComments;
    }
    getComment() {
        return this._comments[this.fen()];
    }
    setComment(comment) {
        this._comments[this.fen()] = comment.replace("{", "[").replace("}", "]");
    }
    deleteComment() {
        const comment = this._comments[this.fen()];
        delete this._comments[this.fen()];
        return comment;
    }
    getComments() {
        this._pruneComments();
        return Object.keys(this._comments).map((fen)=>{
            return {
                fen: fen,
                comment: this._comments[fen]
            };
        });
    }
    deleteComments() {
        this._pruneComments();
        return Object.keys(this._comments).map((fen)=>{
            const comment = this._comments[fen];
            delete this._comments[fen];
            return {
                fen: fen,
                comment: comment
            };
        });
    }
    setCastlingRights(color, rights) {
        for (const side of [
            $aa246c147a5ff844$export$42387107bb0d6206,
            $aa246c147a5ff844$export$36a8946792f13ec9
        ])if (rights[side] !== undefined) {
            if (rights[side]) this._castling[color] |= $aa246c147a5ff844$var$SIDES[side];
            else this._castling[color] &= ~$aa246c147a5ff844$var$SIDES[side];
        }
        this._updateCastlingRights();
        const result = this.getCastlingRights(color);
        return (rights[$aa246c147a5ff844$export$42387107bb0d6206] === undefined || rights[$aa246c147a5ff844$export$42387107bb0d6206] === result[$aa246c147a5ff844$export$42387107bb0d6206]) && (rights[$aa246c147a5ff844$export$36a8946792f13ec9] === undefined || rights[$aa246c147a5ff844$export$36a8946792f13ec9] === result[$aa246c147a5ff844$export$36a8946792f13ec9]);
    }
    getCastlingRights(color) {
        return {
            [$aa246c147a5ff844$export$42387107bb0d6206]: (this._castling[color] & $aa246c147a5ff844$var$SIDES[$aa246c147a5ff844$export$42387107bb0d6206]) !== 0,
            [$aa246c147a5ff844$export$36a8946792f13ec9]: (this._castling[color] & $aa246c147a5ff844$var$SIDES[$aa246c147a5ff844$export$36a8946792f13ec9]) !== 0
        };
    }
    moveNumber() {
        return this._moveNumber;
    }
}


const $b0893505d0f7ae16$export$58d75f9829cbe158 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext();
const $b0893505d0f7ae16$var$ENDPOINT = "https://[TODO_ADD_API_HERE].execute-api.us-east-1.amazonaws.com/dev/";
function $b0893505d0f7ae16$var$DataProvider({ children: children  }) {
    const randomItem = "random item";
    const [chess] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(new (0, $aa246c147a5ff844$export$a4d6ea685c300d39)());
    const [positionFen, setPositionFen] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(chess.fen());
    const [items, setItems] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState([]);
    const [apiWasRequested, setApiWasRequested] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(true);
    const [requestWasHandled, setRequestWasHandled] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [tags, setTags] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const [toggle, setToggle] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("training");
    const [notes, setNotes] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const [isPlanningMode, setIsPlanningMode] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [isMistake, setIsMistake] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [playerSolvedExercise, setPlayerSolvedExercise] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [playerFailedExercise, setPlayerFailedExercise] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [numCorrectExercisePlan, setNumCorrectExercisePlan] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(0);
    const [exercisePlans, setExercisePlans] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState([]);
    const [moveHistory, setMoveHistory] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState([]);
    const [selectedMove, setSelectedMove] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    function resetAll() {
        // setTags('');
        setToggle("training");
        setNotes("");
        setPlayerSolvedExercise(false);
        setPlayerFailedExercise(false);
        setNumCorrectExercisePlan(0);
        setExercisePlans([]);
    }
    // React.useEffect(() => {
    //   async function fetchData() {
    //     const URL = ENDPOINT + 'last-tag';
    //     const request = new Request(URL, {
    //       method: 'GET',
    //       headers: {
    //         'Content-Type': 'application/json',
    //         Authorization: token,
    //       },
    //       timeout: 100000,
    //     });
    //     console.log(`API Was Requested!`);
    //     console.log(`${URL}`);
    //     const response = await fetch(request);
    //     const json = await response.json();
    //     const data = json.data;
    //     const lastTag = data.LAST_TAG;
    //     setTags(lastTag);
    //     console.log(`json=${JSON.stringify(json)}`);
    //     return json;
    //   }
    //   if (apiWasRequested && !requestWasHandled && token) {
    //     fetchData();
    //     setApiWasRequested(false);
    //     setRequestWasHandled(true);
    //   }
    // }, [apiWasRequested, requestWasHandled, token]);
    function createItem(content, variant) {
        const nextItems = [
            ...items,
            {
                id: crypto.randomUUID(),
                content: content,
                variant: variant
            }
        ];
        setItems(nextItems);
    }
    function clearItem(id) {
        const nextItems = items.filter((item)=>{
            return item.id !== id;
        });
        setItems(nextItems);
    }
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($b0893505d0f7ae16$export$58d75f9829cbe158.Provider, {
        value: {
            items: items,
            createItem: createItem,
            clearItem: clearItem,
            randomItem: randomItem,
            setApiWasRequested: setApiWasRequested,
            setRequestWasHandled: setRequestWasHandled,
            tags: tags,
            setTags: setTags,
            resetAll: resetAll,
            toggle: toggle,
            setToggle: setToggle,
            notes: notes,
            setNotes: setNotes,
            isPlanningMode: isPlanningMode,
            isMistake: isMistake,
            setIsPlanningMode: setIsPlanningMode,
            setIsMistake: setIsMistake,
            playerSolvedExercise: playerSolvedExercise,
            setPlayerSolvedExercise: setPlayerSolvedExercise,
            playerFailedExercise: playerFailedExercise,
            setPlayerFailedExercise: setPlayerFailedExercise,
            numCorrectExercisePlan: numCorrectExercisePlan,
            setNumCorrectExercisePlan: setNumCorrectExercisePlan,
            exercisePlans: exercisePlans,
            setExercisePlans: setExercisePlans,
            moveHistory: moveHistory,
            setMoveHistory: setMoveHistory,
            selectedMove: selectedMove,
            setSelectedMove: setSelectedMove,
            chess: chess,
            positionFen: positionFen,
            setPositionFen: setPositionFen
        },
        children: children
    });
}
var $b0893505d0f7ae16$export$2e2bcd8739ae039 = $b0893505d0f7ae16$var$DataProvider;
const $b0893505d0f7ae16$var$CheckboxLabel = (0, $93948c98236af5c1$export$2e2bcd8739ae039).label`
  display: block;
  margin: 10px 0;
`;
const $b0893505d0f7ae16$var$Checkbox = (0, $93948c98236af5c1$export$2e2bcd8739ae039).input`
  width: 20px;
  height: 20px;
  margin-right: 5px;
`;






var $exYeM = parcelRequire("exYeM");



var $exYeM = parcelRequire("exYeM");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Logging constants
const $29d15a9b4d4d0d9f$export$13470c6f1642bbce = "Logging";
const $29d15a9b4d4d0d9f$export$16032fc466434892 = "x-amz-user-agent";
// Error exception code constants
const $29d15a9b4d4d0d9f$export$86d53207c3c20049 = "NoHubcallbackProvidedException";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $343e229b8fad8cda$export$a0472aa3a356446c;
(function(LogType) {
    LogType["DEBUG"] = "DEBUG";
    LogType["ERROR"] = "ERROR";
    LogType["INFO"] = "INFO";
    LogType["WARN"] = "WARN";
    LogType["VERBOSE"] = "VERBOSE";
    LogType["NONE"] = "NONE";
})($343e229b8fad8cda$export$a0472aa3a356446c || ($343e229b8fad8cda$export$a0472aa3a356446c = {}));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $cda4d9e419200573$var$LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5,
    NONE: 6
};
/**
 * Write logs
 * @class Logger
 */ class $cda4d9e419200573$export$ba6a9c7ac8291f7f {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ constructor(name, level = (0, $343e229b8fad8cda$export$a0472aa3a356446c).WARN){
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
    _padding(n) {
        return n < 10 ? "0" + n : "" + n;
    }
    _ts() {
        const dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(":") + "." + dt.getMilliseconds();
    }
    configure(config) {
        if (!config) return this._config;
        this._config = config;
        return this._config;
    }
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LogType|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ _log(type, ...msg) {
        let loggerLevelName = this.level;
        if ($cda4d9e419200573$export$ba6a9c7ac8291f7f.LOG_LEVEL) loggerLevelName = $cda4d9e419200573$export$ba6a9c7ac8291f7f.LOG_LEVEL;
        if (typeof window !== "undefined" && window.LOG_LEVEL) loggerLevelName = window.LOG_LEVEL;
        const loggerLevel = $cda4d9e419200573$var$LOG_LEVELS[loggerLevelName];
        const typeLevel = $cda4d9e419200573$var$LOG_LEVELS[type];
        if (!(typeLevel >= loggerLevel)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        let log = console.log.bind(console);
        if (type === (0, $343e229b8fad8cda$export$a0472aa3a356446c).ERROR && console.error) log = console.error.bind(console);
        if (type === (0, $343e229b8fad8cda$export$a0472aa3a356446c).WARN && console.warn) log = console.warn.bind(console);
        if ($cda4d9e419200573$export$ba6a9c7ac8291f7f.BIND_ALL_LOG_LEVELS) {
            if (type === (0, $343e229b8fad8cda$export$a0472aa3a356446c).INFO && console.info) log = console.info.bind(console);
            if (type === (0, $343e229b8fad8cda$export$a0472aa3a356446c).DEBUG && console.debug) log = console.debug.bind(console);
        }
        const prefix = `[${type}] ${this._ts()} ${this.name}`;
        let message = "";
        if (msg.length === 1 && typeof msg[0] === "string") {
            message = `${prefix} - ${msg[0]}`;
            log(message);
        } else if (msg.length === 1) {
            message = `${prefix} ${msg[0]}`;
            log(prefix, msg[0]);
        } else if (typeof msg[0] === "string") {
            let obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            message = `${prefix} - ${msg[0]} ${obj}`;
            log(`${prefix} - ${msg[0]}`, obj);
        } else {
            message = `${prefix} ${msg}`;
            log(prefix, msg);
        }
        for (const plugin of this._pluggables){
            const logEvent = {
                message: message,
                timestamp: Date.now()
            };
            plugin.pushLogs([
                logEvent
            ]);
        }
    }
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ log(...msg) {
        this._log((0, $343e229b8fad8cda$export$a0472aa3a356446c).INFO, ...msg);
    }
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ info(...msg) {
        this._log((0, $343e229b8fad8cda$export$a0472aa3a356446c).INFO, ...msg);
    }
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ warn(...msg) {
        this._log((0, $343e229b8fad8cda$export$a0472aa3a356446c).WARN, ...msg);
    }
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ error(...msg) {
        this._log((0, $343e229b8fad8cda$export$a0472aa3a356446c).ERROR, ...msg);
    }
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ debug(...msg) {
        this._log((0, $343e229b8fad8cda$export$a0472aa3a356446c).DEBUG, ...msg);
    }
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ verbose(...msg) {
        this._log((0, $343e229b8fad8cda$export$a0472aa3a356446c).VERBOSE, ...msg);
    }
    addPluggable(pluggable) {
        if (pluggable && pluggable.getCategoryName() === (0, $29d15a9b4d4d0d9f$export$13470c6f1642bbce)) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    }
    listPluggables() {
        return this._pluggables;
    }
}
$cda4d9e419200573$export$ba6a9c7ac8291f7f.LOG_LEVEL = null;
$cda4d9e419200573$export$ba6a9c7ac8291f7f.BIND_ALL_LOG_LEVELS = false;



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $05b2dc7abeec3af3$export$37321a6dace1881c extends Error {
    /**
     *  Constructs an AmplifyError.
     *
     * @param message text that describes the main problem.
     * @param underlyingError the underlying cause of the error.
     * @param recoverySuggestion suggestion to recover from the error.
     *
     */ constructor({ message: message , name: name , recoverySuggestion: recoverySuggestion , underlyingError: underlyingError  }){
        super(message);
        this.name = name;
        this.underlyingError = underlyingError;
        this.recoverySuggestion = recoverySuggestion;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $05b2dc7abeec3af3$export$37321a6dace1881c;
        Object.setPrototypeOf(this, $05b2dc7abeec3af3$export$37321a6dace1881c.prototype);
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c9802061728ce106$export$aadf71dd9875dd20 = typeof Symbol !== "undefined" ? Symbol("amplify_default") : "@@amplify_default";
const $c9802061728ce106$var$logger = new (0, $cda4d9e419200573$export$ba6a9c7ac8291f7f)("Hub");
class $c9802061728ce106$export$6b38ef2be9abbbb9 {
    constructor(name){
        this.listeners = new Map();
        this.protectedChannels = [
            "core",
            "auth",
            "api",
            "analytics",
            "interactions",
            "pubsub",
            "storage",
            "ui",
            "xr"
        ];
        this.name = name;
    }
    /**
     * Used internally to remove a Hub listener.
     *
     * @remarks
     * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
     */ _remove(channel, listener) {
        const holder = this.listeners.get(channel);
        if (!holder) {
            $c9802061728ce106$var$logger.warn(`No listeners for ${channel}`);
            return;
        }
        this.listeners.set(channel, [
            ...holder.filter(({ callback: callback  })=>callback !== listener)
        ]);
    }
    dispatch(channel, payload, source, ampSymbol) {
        if (typeof channel === "string" && this.protectedChannels.indexOf(channel) > -1) {
            const hasAccess = ampSymbol === $c9802061728ce106$export$aadf71dd9875dd20;
            if (!hasAccess) $c9802061728ce106$var$logger.warn(`WARNING: ${channel} is protected and dispatching on it can have unintended consequences`);
        }
        const capsule = {
            channel: channel,
            payload: {
                ...payload
            },
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            $c9802061728ce106$var$logger.error(e);
        }
    }
    listen(channel, callback, listenerName = "noname") {
        let cb;
        if (typeof callback !== "function") throw new (0, $05b2dc7abeec3af3$export$37321a6dace1881c)({
            name: (0, $29d15a9b4d4d0d9f$export$86d53207c3c20049),
            message: "No callback supplied to Hub"
        });
        else // Needs to be casted as a more generic type
        cb = callback;
        let holder = this.listeners.get(channel);
        if (!holder) {
            holder = [];
            this.listeners.set(channel, holder);
        }
        holder.push({
            name: listenerName,
            callback: cb
        });
        return ()=>{
            this._remove(channel, cb);
        };
    }
    _toListeners(capsule) {
        const { channel: channel , payload: payload  } = capsule;
        const holder = this.listeners.get(channel);
        if (holder) holder.forEach((listener)=>{
            $c9802061728ce106$var$logger.debug(`Dispatching to ${channel} with `, payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                $c9802061728ce106$var$logger.error(e);
            }
        });
    }
}
/* We export a __default__ instance of HubClass to use it as a
pseudo Singleton for the main messaging bus, however you can still create
your own instance of HubClass() for a separate "private bus" of events. */ const $c9802061728ce106$export$8c41bb232f1008b1 = new $c9802061728ce106$export$6b38ef2be9abbbb9("__default__");
/**
 * @internal
 *
 * Internal hub used for core Amplify functionality. Not intended for use outside of Amplify.
 *
 */ const $c9802061728ce106$export$45dde0743a4c8d6e = new $c9802061728ce106$export$6b38ef2be9abbbb9("internal-hub");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3040204a38b40487$export$7e32b29e1cb162e1 = (object)=>{
    const propNames = Reflect.ownKeys(object);
    for (const name of propNames){
        const value = object[name];
        if (value && typeof value === "object" || typeof value === "function") $3040204a38b40487$export$7e32b29e1cb162e1(value);
    }
    return Object.freeze(object);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $6b6ce34dcf385dec$export$35210b3191d26437 = Symbol("oauth-listener");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9e9ebeb6d3af43c3$var$logger = new (0, $cda4d9e419200573$export$ba6a9c7ac8291f7f)("parseAWSExports");
const $9e9ebeb6d3af43c3$var$authTypeMapping = {
    API_KEY: "apiKey",
    AWS_IAM: "iam",
    AMAZON_COGNITO_USER_POOLS: "userPool",
    OPENID_CONNECT: "oidc",
    NONE: "none",
    AWS_LAMBDA: "lambda",
    // `LAMBDA` is an incorrect value that was added during the v6 rewrite.
    // Keeping it as a valid value until v7 to prevent breaking customers who might
    // be relying on it as a workaround.
    // ref: https://github.com/aws-amplify/amplify-js/pull/12922
    // TODO: @v7 remove next line
    LAMBDA: "lambda"
};
/**
 * Converts the object imported from `aws-exports.js` or `amplifyconfiguration.json` files generated by
 * the Amplify CLI into an object that conforms to the {@link ResourcesConfig}.
 *
 * @param config A configuration object imported  from `aws-exports.js` or `amplifyconfiguration.json`.
 *
 * @returns An object that conforms to the {@link ResourcesConfig} .
 */ const $9e9ebeb6d3af43c3$export$1ef2e9c2da492d = (config = {})=>{
    if (!Object.prototype.hasOwnProperty.call(config, "aws_project_region")) throw new (0, $05b2dc7abeec3af3$export$37321a6dace1881c)({
        name: "InvalidParameterException",
        message: "Invalid config parameter.",
        recoverySuggestion: "Ensure passing the config object imported from  `amplifyconfiguration.json`."
    });
    const { aws_appsync_apiKey: aws_appsync_apiKey , aws_appsync_authenticationType: aws_appsync_authenticationType , aws_appsync_graphqlEndpoint: aws_appsync_graphqlEndpoint , aws_appsync_region: aws_appsync_region , aws_bots_config: aws_bots_config , aws_cognito_identity_pool_id: aws_cognito_identity_pool_id , aws_cognito_sign_up_verification_method: aws_cognito_sign_up_verification_method , aws_cognito_mfa_configuration: aws_cognito_mfa_configuration , aws_cognito_mfa_types: aws_cognito_mfa_types , aws_cognito_password_protection_settings: aws_cognito_password_protection_settings , aws_cognito_verification_mechanisms: aws_cognito_verification_mechanisms , aws_cognito_signup_attributes: aws_cognito_signup_attributes , aws_cognito_social_providers: aws_cognito_social_providers , aws_cognito_username_attributes: aws_cognito_username_attributes , aws_mandatory_sign_in: aws_mandatory_sign_in , aws_mobile_analytics_app_id: aws_mobile_analytics_app_id , aws_mobile_analytics_app_region: aws_mobile_analytics_app_region , aws_user_files_s3_bucket: aws_user_files_s3_bucket , aws_user_files_s3_bucket_region: aws_user_files_s3_bucket_region , aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing , aws_user_pools_id: aws_user_pools_id , aws_user_pools_web_client_id: aws_user_pools_web_client_id , geo: geo , oauth: oauth , predictions: predictions , aws_cloud_logic_custom: aws_cloud_logic_custom , Notifications: Notifications , modelIntrospection: modelIntrospection  } = config;
    const amplifyConfig = {};
    // Analytics
    if (aws_mobile_analytics_app_id) amplifyConfig.Analytics = {
        Pinpoint: {
            appId: aws_mobile_analytics_app_id,
            region: aws_mobile_analytics_app_region
        }
    };
    // Notifications
    const { InAppMessaging: InAppMessaging , Push: Push  } = Notifications ?? {};
    if (InAppMessaging?.AWSPinpoint || Push?.AWSPinpoint) {
        if (InAppMessaging?.AWSPinpoint) {
            const { appId: appId , region: region  } = InAppMessaging.AWSPinpoint;
            amplifyConfig.Notifications = {
                InAppMessaging: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            };
        }
        if (Push?.AWSPinpoint) {
            const { appId: appId , region: region  } = Push.AWSPinpoint;
            amplifyConfig.Notifications = {
                ...amplifyConfig.Notifications,
                PushNotification: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            };
        }
    }
    // Interactions
    if (Array.isArray(aws_bots_config)) amplifyConfig.Interactions = {
        LexV1: Object.fromEntries(aws_bots_config.map((bot)=>[
                bot.name,
                bot
            ]))
    };
    // API
    if (aws_appsync_graphqlEndpoint) {
        const defaultAuthMode = $9e9ebeb6d3af43c3$var$authTypeMapping[aws_appsync_authenticationType];
        if (!defaultAuthMode) $9e9ebeb6d3af43c3$var$logger.debug(`Invalid authentication type ${aws_appsync_authenticationType}. Falling back to IAM.`);
        amplifyConfig.API = {
            GraphQL: {
                endpoint: aws_appsync_graphqlEndpoint,
                apiKey: aws_appsync_apiKey,
                region: aws_appsync_region,
                defaultAuthMode: defaultAuthMode ?? "iam"
            }
        };
        if (modelIntrospection) amplifyConfig.API.GraphQL.modelIntrospection = modelIntrospection;
    }
    // Auth
    const mfaConfig = aws_cognito_mfa_configuration ? {
        status: aws_cognito_mfa_configuration && aws_cognito_mfa_configuration.toLowerCase(),
        totpEnabled: aws_cognito_mfa_types?.includes("TOTP") ?? false,
        smsEnabled: aws_cognito_mfa_types?.includes("SMS") ?? false
    } : undefined;
    const passwordFormatConfig = aws_cognito_password_protection_settings ? {
        minLength: aws_cognito_password_protection_settings.passwordPolicyMinLength,
        requireLowercase: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_LOWERCASE") ?? false,
        requireUppercase: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_UPPERCASE") ?? false,
        requireNumbers: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_NUMBERS") ?? false,
        requireSpecialCharacters: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_SYMBOLS") ?? false
    } : undefined;
    const mergedUserAttributes = Array.from(new Set([
        ...aws_cognito_verification_mechanisms ?? [],
        ...aws_cognito_signup_attributes ?? []
    ]));
    const userAttributes = mergedUserAttributes.reduce((attributes, key)=>({
            ...attributes,
            // All user attributes generated by the CLI are required
            [key.toLowerCase()]: {
                required: true
            }
        }), {});
    const loginWithEmailEnabled = aws_cognito_username_attributes?.includes("EMAIL") ?? false;
    const loginWithPhoneEnabled = aws_cognito_username_attributes?.includes("PHONE_NUMBER") ?? false;
    if (aws_cognito_identity_pool_id || aws_user_pools_id) amplifyConfig.Auth = {
        Cognito: {
            identityPoolId: aws_cognito_identity_pool_id,
            allowGuestAccess: aws_mandatory_sign_in !== "enable",
            signUpVerificationMethod: aws_cognito_sign_up_verification_method,
            userAttributes: userAttributes,
            userPoolClientId: aws_user_pools_web_client_id,
            userPoolId: aws_user_pools_id,
            mfa: mfaConfig,
            passwordFormat: passwordFormatConfig,
            loginWith: {
                username: !(loginWithEmailEnabled || loginWithPhoneEnabled),
                email: loginWithEmailEnabled,
                phone: loginWithPhoneEnabled
            }
        }
    };
    const hasOAuthConfig = oauth ? Object.keys(oauth).length > 0 : false;
    const hasSocialProviderConfig = aws_cognito_social_providers ? aws_cognito_social_providers.length > 0 : false;
    if (amplifyConfig.Auth && hasOAuthConfig) amplifyConfig.Auth.Cognito.loginWith = {
        ...amplifyConfig.Auth.Cognito.loginWith,
        oauth: {
            ...$9e9ebeb6d3af43c3$var$getOAuthConfig(oauth),
            ...hasSocialProviderConfig && {
                providers: $9e9ebeb6d3af43c3$var$parseSocialProviders(aws_cognito_social_providers)
            }
        }
    };
    // Storage
    if (aws_user_files_s3_bucket) amplifyConfig.Storage = {
        S3: {
            bucket: aws_user_files_s3_bucket,
            region: aws_user_files_s3_bucket_region,
            dangerouslyConnectToHttpEndpointForTesting: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing
        }
    };
    // Geo
    if (geo) {
        const { amazon_location_service: amazon_location_service  } = geo;
        amplifyConfig.Geo = {
            LocationService: {
                maps: amazon_location_service.maps,
                geofenceCollections: amazon_location_service.geofenceCollections,
                searchIndices: amazon_location_service.search_indices,
                region: amazon_location_service.region
            }
        };
    }
    // REST API
    if (aws_cloud_logic_custom) amplifyConfig.API = {
        ...amplifyConfig.API,
        REST: aws_cloud_logic_custom.reduce((acc, api)=>{
            const { name: name , endpoint: endpoint , region: region , service: service  } = api;
            return {
                ...acc,
                [name]: {
                    endpoint: endpoint,
                    ...service ? {
                        service: service
                    } : undefined,
                    ...region ? {
                        region: region
                    } : undefined
                }
            };
        }, {})
    };
    // Predictions
    if (predictions) {
        // map VoiceId from speechGenerator defaults to voiceId
        const { VoiceId: voiceId  } = predictions?.convert?.speechGenerator?.defaults ?? {};
        amplifyConfig.Predictions = voiceId ? {
            ...predictions,
            convert: {
                ...predictions.convert,
                speechGenerator: {
                    ...predictions.convert.speechGenerator,
                    defaults: {
                        voiceId: voiceId
                    }
                }
            }
        } : predictions;
    }
    return amplifyConfig;
};
const $9e9ebeb6d3af43c3$var$getRedirectUrl = (redirectStr)=>redirectStr?.split(",") ?? [];
const $9e9ebeb6d3af43c3$var$getOAuthConfig = ({ domain: domain , scope: scope , redirectSignIn: redirectSignIn , redirectSignOut: redirectSignOut , responseType: responseType  })=>({
        domain: domain,
        scopes: scope,
        redirectSignIn: $9e9ebeb6d3af43c3$var$getRedirectUrl(redirectSignIn),
        redirectSignOut: $9e9ebeb6d3af43c3$var$getRedirectUrl(redirectSignOut),
        responseType: responseType
    });
const $9e9ebeb6d3af43c3$var$parseSocialProviders = (aws_cognito_social_providers)=>{
    return aws_cognito_social_providers.map((provider)=>{
        const updatedProvider = provider.toLowerCase();
        return updatedProvider.charAt(0).toUpperCase() + updatedProvider.slice(1);
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $961c2883822cc512$export$99bf765e6322c00(config) {
    // version format initially will be '1' but is expected to be something like x.y where x is major and y minor version
    const { version: version  } = config;
    if (!version) return false;
    return version.startsWith("1");
}
function $961c2883822cc512$var$parseStorage(amplifyOutputsStorageProperties) {
    if (!amplifyOutputsStorageProperties) return undefined;
    const { bucket_name: bucket_name , aws_region: aws_region , buckets: buckets  } = amplifyOutputsStorageProperties;
    return {
        S3: {
            bucket: bucket_name,
            region: aws_region,
            buckets: buckets && $961c2883822cc512$var$createBucketInfoMap(buckets)
        }
    };
}
function $961c2883822cc512$var$parseAuth(amplifyOutputsAuthProperties) {
    if (!amplifyOutputsAuthProperties) return undefined;
    const { user_pool_id: user_pool_id , user_pool_client_id: user_pool_client_id , identity_pool_id: identity_pool_id , password_policy: password_policy , mfa_configuration: mfa_configuration , mfa_methods: mfa_methods , unauthenticated_identities_enabled: unauthenticated_identities_enabled , oauth: oauth , username_attributes: username_attributes , standard_required_attributes: standard_required_attributes , groups: groups  } = amplifyOutputsAuthProperties;
    const authConfig = {
        Cognito: {
            userPoolId: user_pool_id,
            userPoolClientId: user_pool_client_id,
            groups: groups
        }
    };
    if (identity_pool_id) authConfig.Cognito = {
        ...authConfig.Cognito,
        identityPoolId: identity_pool_id
    };
    if (password_policy) authConfig.Cognito.passwordFormat = {
        requireLowercase: password_policy.require_lowercase,
        requireNumbers: password_policy.require_numbers,
        requireUppercase: password_policy.require_uppercase,
        requireSpecialCharacters: password_policy.require_symbols,
        minLength: password_policy.min_length ?? 6
    };
    if (mfa_configuration) authConfig.Cognito.mfa = {
        status: $961c2883822cc512$var$getMfaStatus(mfa_configuration),
        smsEnabled: mfa_methods?.includes("SMS"),
        totpEnabled: mfa_methods?.includes("TOTP")
    };
    if (unauthenticated_identities_enabled) authConfig.Cognito.allowGuestAccess = unauthenticated_identities_enabled;
    if (oauth) authConfig.Cognito.loginWith = {
        oauth: {
            domain: oauth.domain,
            redirectSignIn: oauth.redirect_sign_in_uri,
            redirectSignOut: oauth.redirect_sign_out_uri,
            responseType: oauth.response_type === "token" ? "token" : "code",
            scopes: oauth.scopes,
            providers: $961c2883822cc512$var$getOAuthProviders(oauth.identity_providers)
        }
    };
    if (username_attributes) authConfig.Cognito.loginWith = {
        ...authConfig.Cognito.loginWith,
        email: username_attributes.includes("email"),
        phone: username_attributes.includes("phone_number"),
        // Signing in with a username is not currently supported in Gen2, this should always evaluate to false
        username: username_attributes.includes("username")
    };
    if (standard_required_attributes) authConfig.Cognito.userAttributes = standard_required_attributes.reduce((acc, curr)=>({
            ...acc,
            [curr]: {
                required: true
            }
        }), {});
    return authConfig;
}
function $961c2883822cc512$export$fbb0a2a08db9629a(amplifyOutputsAnalyticsProperties) {
    if (!amplifyOutputsAnalyticsProperties?.amazon_pinpoint) return undefined;
    const { amazon_pinpoint: amazon_pinpoint  } = amplifyOutputsAnalyticsProperties;
    return {
        Pinpoint: {
            appId: amazon_pinpoint.app_id,
            region: amazon_pinpoint.aws_region
        }
    };
}
function $961c2883822cc512$var$parseGeo(amplifyOutputsAnalyticsProperties) {
    if (!amplifyOutputsAnalyticsProperties) return undefined;
    const { aws_region: aws_region , geofence_collections: geofence_collections , maps: maps , search_indices: search_indices  } = amplifyOutputsAnalyticsProperties;
    return {
        LocationService: {
            region: aws_region,
            searchIndices: search_indices,
            geofenceCollections: geofence_collections,
            maps: maps
        }
    };
}
function $961c2883822cc512$var$parseData(amplifyOutputsDataProperties) {
    if (!amplifyOutputsDataProperties) return undefined;
    const { aws_region: aws_region , default_authorization_type: default_authorization_type , url: url , api_key: api_key , model_introspection: model_introspection  } = amplifyOutputsDataProperties;
    const GraphQL = {
        endpoint: url,
        defaultAuthMode: $961c2883822cc512$var$getGraphQLAuthMode(default_authorization_type),
        region: aws_region,
        apiKey: api_key,
        modelIntrospection: model_introspection
    };
    return {
        GraphQL: GraphQL
    };
}
function $961c2883822cc512$var$parseCustom(amplifyOutputsCustomProperties) {
    if (!amplifyOutputsCustomProperties?.events) return undefined;
    const { url: url , aws_region: aws_region , api_key: api_key , default_authorization_type: default_authorization_type  } = amplifyOutputsCustomProperties.events;
    const Events = {
        endpoint: url,
        defaultAuthMode: $961c2883822cc512$var$getGraphQLAuthMode(default_authorization_type),
        region: aws_region,
        apiKey: api_key
    };
    return {
        Events: Events
    };
}
function $961c2883822cc512$var$parseNotifications(amplifyOutputsNotificationsProperties) {
    if (!amplifyOutputsNotificationsProperties) return undefined;
    const { aws_region: aws_region , channels: channels , amazon_pinpoint_app_id: amazon_pinpoint_app_id  } = amplifyOutputsNotificationsProperties;
    const hasInAppMessaging = channels.includes("IN_APP_MESSAGING");
    const hasPushNotification = channels.includes("APNS") || channels.includes("FCM");
    if (!(hasInAppMessaging || hasPushNotification)) return undefined;
    // At this point, we know the Amplify outputs contains at least one supported channel
    const notificationsConfig = {};
    if (hasInAppMessaging) notificationsConfig.InAppMessaging = {
        Pinpoint: {
            appId: amazon_pinpoint_app_id,
            region: aws_region
        }
    };
    if (hasPushNotification) notificationsConfig.PushNotification = {
        Pinpoint: {
            appId: amazon_pinpoint_app_id,
            region: aws_region
        }
    };
    return notificationsConfig;
}
function $961c2883822cc512$export$11d0da171d17ab63(amplifyOutputs) {
    const resourcesConfig = {};
    if (amplifyOutputs.storage) resourcesConfig.Storage = $961c2883822cc512$var$parseStorage(amplifyOutputs.storage);
    if (amplifyOutputs.auth) resourcesConfig.Auth = $961c2883822cc512$var$parseAuth(amplifyOutputs.auth);
    if (amplifyOutputs.analytics) resourcesConfig.Analytics = $961c2883822cc512$export$fbb0a2a08db9629a(amplifyOutputs.analytics);
    if (amplifyOutputs.geo) resourcesConfig.Geo = $961c2883822cc512$var$parseGeo(amplifyOutputs.geo);
    if (amplifyOutputs.data) resourcesConfig.API = $961c2883822cc512$var$parseData(amplifyOutputs.data);
    if (amplifyOutputs.custom) {
        const customConfig = $961c2883822cc512$var$parseCustom(amplifyOutputs.custom);
        if (customConfig && "Events" in customConfig) resourcesConfig.API = {
            ...resourcesConfig.API,
            ...customConfig
        };
    }
    if (amplifyOutputs.notifications) resourcesConfig.Notifications = $961c2883822cc512$var$parseNotifications(amplifyOutputs.notifications);
    return resourcesConfig;
}
const $961c2883822cc512$var$authModeNames = {
    AMAZON_COGNITO_USER_POOLS: "userPool",
    API_KEY: "apiKey",
    AWS_IAM: "iam",
    AWS_LAMBDA: "lambda",
    OPENID_CONNECT: "oidc"
};
function $961c2883822cc512$var$getGraphQLAuthMode(authType) {
    return $961c2883822cc512$var$authModeNames[authType];
}
const $961c2883822cc512$var$providerNames = {
    GOOGLE: "Google",
    LOGIN_WITH_AMAZON: "Amazon",
    FACEBOOK: "Facebook",
    SIGN_IN_WITH_APPLE: "Apple"
};
function $961c2883822cc512$var$getOAuthProviders(providers = []) {
    return providers.reduce((oAuthProviders, provider)=>{
        if ($961c2883822cc512$var$providerNames[provider] !== undefined) oAuthProviders.push($961c2883822cc512$var$providerNames[provider]);
        return oAuthProviders;
    }, []);
}
function $961c2883822cc512$var$getMfaStatus(mfaConfiguration) {
    if (mfaConfiguration === "OPTIONAL") return "optional";
    if (mfaConfiguration === "REQUIRED") return "on";
    return "off";
}
function $961c2883822cc512$var$createBucketInfoMap(buckets) {
    const mappedBuckets = {};
    buckets.forEach(({ name: name , bucket_name: bucketName , aws_region: region , paths: paths  })=>{
        if (name in mappedBuckets) throw new Error(`Duplicate friendly name found: ${name}. Name must be unique.`);
        mappedBuckets[name] = {
            bucketName: bucketName,
            region: region,
            paths: paths
        };
    });
    return mappedBuckets;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Parses the variety of configuration shapes that Amplify can accept into a ResourcesConfig.
 *
 * @param amplifyConfig An Amplify configuration object conforming to one of the supported schemas.
 * @return A ResourcesConfig for the provided configuration object.
 */ const $c617356b2a6163e9$export$f101a69cd6dc6202 = (amplifyConfig)=>{
    if (Object.keys(amplifyConfig).some((key)=>key.startsWith("aws_"))) return (0, $9e9ebeb6d3af43c3$export$1ef2e9c2da492d)(amplifyConfig);
    else if ((0, $961c2883822cc512$export$99bf765e6322c00)(amplifyConfig)) return (0, $961c2883822cc512$export$11d0da171d17ab63)(amplifyConfig);
    else return amplifyConfig;
};





function $2a776d17fcab286a$export$b007d77a962aa175({ expiresAt: expiresAt , clockDrift: clockDrift  }) {
    const currentTime = Date.now();
    return currentTime + clockDrift > expiresAt;
}
class $2a776d17fcab286a$export$eeff9d1a8b8c057b {
    /**
     * Configure Auth category
     *
     * @internal
     *
     * @param authResourcesConfig - Resources configurations required by Auth providers.
     * @param authOptions - Client options used by library
     *
     * @returns void
     */ configure(authResourcesConfig, authOptions) {
        this.authConfig = authResourcesConfig;
        this.authOptions = authOptions;
    }
    /**
     * Fetch the auth tokens, and the temporary AWS credentials and identity if they are configured. By default it
     * does not refresh the auth tokens or credentials if they are loaded in storage already. You can force a refresh
     * with `{ forceRefresh: true }` input.
     *
     * @param options - Options configuring the fetch behavior.
     *
     * @returns Promise of current auth session {@link AuthSession}.
     */ async fetchAuthSession(options = {}) {
        let credentialsAndIdentityId;
        let userSub;
        // Get tokens will throw if session cannot be refreshed (network or service error) or return null if not available
        const tokens = await this.getTokens(options);
        if (tokens) {
            userSub = tokens.accessToken?.payload?.sub;
            // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
            credentialsAndIdentityId = await this.authOptions?.credentialsProvider?.getCredentialsAndIdentityId({
                authConfig: this.authConfig,
                tokens: tokens,
                authenticated: true,
                forceRefresh: options.forceRefresh
            });
        } else // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
        credentialsAndIdentityId = await this.authOptions?.credentialsProvider?.getCredentialsAndIdentityId({
            authConfig: this.authConfig,
            authenticated: false,
            forceRefresh: options.forceRefresh
        });
        return {
            tokens: tokens,
            credentials: credentialsAndIdentityId?.credentials,
            identityId: credentialsAndIdentityId?.identityId,
            userSub: userSub
        };
    }
    async clearCredentials() {
        await this.authOptions?.credentialsProvider?.clearCredentialsAndIdentityId();
    }
    async getTokens(options) {
        return await this.authOptions?.tokenProvider?.getTokens(options) ?? undefined;
    }
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $3433e5a3eb89c040$var$extendStatics = function(d, b) {
    $3433e5a3eb89c040$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3433e5a3eb89c040$var$extendStatics(d, b);
};
function $3433e5a3eb89c040$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3433e5a3eb89c040$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3433e5a3eb89c040$export$18ce0697a983be9b = function() {
    $3433e5a3eb89c040$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3433e5a3eb89c040$export$18ce0697a983be9b.apply(this, arguments);
};
function $3433e5a3eb89c040$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3433e5a3eb89c040$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3433e5a3eb89c040$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3433e5a3eb89c040$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $3433e5a3eb89c040$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $3433e5a3eb89c040$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $3433e5a3eb89c040$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $3433e5a3eb89c040$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3433e5a3eb89c040$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3433e5a3eb89c040$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3433e5a3eb89c040$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3433e5a3eb89c040$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3433e5a3eb89c040$export$45d3717a4c69092e(o, m, p);
}
function $3433e5a3eb89c040$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3433e5a3eb89c040$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3433e5a3eb89c040$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3433e5a3eb89c040$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3433e5a3eb89c040$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3433e5a3eb89c040$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $3433e5a3eb89c040$export$10c90e4f7922046c(v) {
    return this instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? (this.v = v, this) : new $3433e5a3eb89c040$export$10c90e4f7922046c(v);
}
function $3433e5a3eb89c040$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3433e5a3eb89c040$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3433e5a3eb89c040$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $3433e5a3eb89c040$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3433e5a3eb89c040$export$19a8beecd37a4c45 === "function" ? $3433e5a3eb89c040$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3433e5a3eb89c040$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3433e5a3eb89c040$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $3433e5a3eb89c040$var$ownKeys = function(o) {
    $3433e5a3eb89c040$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $3433e5a3eb89c040$var$ownKeys(o);
};
function $3433e5a3eb89c040$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $3433e5a3eb89c040$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $3433e5a3eb89c040$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $3433e5a3eb89c040$var$__setModuleDefault(result, mod);
    return result;
}
function $3433e5a3eb89c040$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3433e5a3eb89c040$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3433e5a3eb89c040$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $3433e5a3eb89c040$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $3433e5a3eb89c040$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $3433e5a3eb89c040$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $3433e5a3eb89c040$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $3433e5a3eb89c040$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $3433e5a3eb89c040$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $3433e5a3eb89c040$export$2e2bcd8739ae039 = {
    __extends: $3433e5a3eb89c040$export$a8ba968b8961cb8a,
    __assign: $3433e5a3eb89c040$export$18ce0697a983be9b,
    __rest: $3433e5a3eb89c040$export$3c9a16f847548506,
    __decorate: $3433e5a3eb89c040$export$29e00dfd3077644b,
    __param: $3433e5a3eb89c040$export$d5ad3fd78186038f,
    __esDecorate: $3433e5a3eb89c040$export$3a84e1ae4e97e9b0,
    __runInitializers: $3433e5a3eb89c040$export$d831c04e792af3d,
    __propKey: $3433e5a3eb89c040$export$6a2a36740a146cb8,
    __setFunctionName: $3433e5a3eb89c040$export$d1a06452d3489bc7,
    __metadata: $3433e5a3eb89c040$export$f1db080c865becb9,
    __awaiter: $3433e5a3eb89c040$export$1050f835b63b671e,
    __generator: $3433e5a3eb89c040$export$67ebef60e6f28a6,
    __createBinding: $3433e5a3eb89c040$export$45d3717a4c69092e,
    __exportStar: $3433e5a3eb89c040$export$f33643c0debef087,
    __values: $3433e5a3eb89c040$export$19a8beecd37a4c45,
    __read: $3433e5a3eb89c040$export$8d051b38c9118094,
    __spread: $3433e5a3eb89c040$export$afc72e2116322959,
    __spreadArrays: $3433e5a3eb89c040$export$6388937ca91ccae8,
    __spreadArray: $3433e5a3eb89c040$export$1216008129fb82ed,
    __await: $3433e5a3eb89c040$export$10c90e4f7922046c,
    __asyncGenerator: $3433e5a3eb89c040$export$e427f37a30a4de9b,
    __asyncDelegator: $3433e5a3eb89c040$export$bbd80228419bb833,
    __asyncValues: $3433e5a3eb89c040$export$e3b29a3d6162315f,
    __makeTemplateObject: $3433e5a3eb89c040$export$4fb47efe1390b86f,
    __importStar: $3433e5a3eb89c040$export$c21735bcef00d192,
    __importDefault: $3433e5a3eb89c040$export$da59b14a69baef04,
    __classPrivateFieldGet: $3433e5a3eb89c040$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $3433e5a3eb89c040$export$d40a35129aaff81f,
    __classPrivateFieldIn: $3433e5a3eb89c040$export$81fdc39f203e4e04,
    __addDisposableResource: $3433e5a3eb89c040$export$88ac25d8e944e405,
    __disposeResources: $3433e5a3eb89c040$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $3433e5a3eb89c040$export$889dfb5d17574b0b
};


/**
 * @internal
 */ var $d9144f7f7c3aa451$export$b2e3d6d444266a5c = 64;
var $d9144f7f7c3aa451$export$d7bd469488748c5f = 32;
var $d9144f7f7c3aa451$export$7167c830cefcb6b5 = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
var $d9144f7f7c3aa451$export$d788bc089976c004 = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var $d9144f7f7c3aa451$export$856b3d11dc447b50 = Math.pow(2, 53) - 1;



/**
 * @internal
 */ var $7828a6c727c01d6d$export$aab6bc1ad3c77a42 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from((0, $d9144f7f7c3aa451$export$d788bc089976c004));
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > (0, $d9144f7f7c3aa451$export$856b3d11dc447b50)) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === (0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % (0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c) >= (0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c) - 8) {
                for(var i = this.bufferLength; i < (0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c); i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < (0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c) - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32((0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c) - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32((0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c) - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array((0, $d9144f7f7c3aa451$export$d7bd469488748c5f));
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < (0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c); i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ((0, $d9144f7f7c3aa451$export$7167c830cefcb6b5)[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f5bb4d6da7c611e5$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);



const $2c7ea32d3382c998$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $f5bb4d6da7c611e5$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};


const $0277c7bea634f036$export$b4b216764bb846eb = (input)=>new TextDecoder("utf-8").decode(input);




/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $24f87a6f86a8996f$export$a143d493d941bafc;
var $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a;
var $24f87a6f86a8996f$export$f99ded8fe4b79145;
var $24f87a6f86a8996f$export$599f31c3813fae4d;
"use strict";
var $3caef5c332c7293f$export$a48f0734ac7c2329;
var $3caef5c332c7293f$export$d622b2ad8d90c771;
var $3caef5c332c7293f$export$6100ba28696e12de;
"use strict";
$3caef5c332c7293f$export$a48f0734ac7c2329 = $3caef5c332c7293f$var$byteLength;
$3caef5c332c7293f$export$d622b2ad8d90c771 = $3caef5c332c7293f$var$toByteArray;
$3caef5c332c7293f$export$6100ba28696e12de = $3caef5c332c7293f$var$fromByteArray;
var $3caef5c332c7293f$var$lookup = [];
var $3caef5c332c7293f$var$revLookup = [];
var $3caef5c332c7293f$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $3caef5c332c7293f$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $3caef5c332c7293f$var$i = 0, $3caef5c332c7293f$var$len = $3caef5c332c7293f$var$code.length; $3caef5c332c7293f$var$i < $3caef5c332c7293f$var$len; ++$3caef5c332c7293f$var$i){
    $3caef5c332c7293f$var$lookup[$3caef5c332c7293f$var$i] = $3caef5c332c7293f$var$code[$3caef5c332c7293f$var$i];
    $3caef5c332c7293f$var$revLookup[$3caef5c332c7293f$var$code.charCodeAt($3caef5c332c7293f$var$i)] = $3caef5c332c7293f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3caef5c332c7293f$var$revLookup["-".charCodeAt(0)] = 62;
$3caef5c332c7293f$var$revLookup["_".charCodeAt(0)] = 63;
function $3caef5c332c7293f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3caef5c332c7293f$var$byteLength(b64) {
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$toByteArray(b64) {
    var tmp;
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3caef5c332c7293f$var$Arr($3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 18 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 2 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 10 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3caef5c332c7293f$var$tripletToBase64(num) {
    return $3caef5c332c7293f$var$lookup[num >> 18 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 12 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 6 & 0x3F] + $3caef5c332c7293f$var$lookup[num & 0x3F];
}
function $3caef5c332c7293f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3caef5c332c7293f$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $3caef5c332c7293f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3caef5c332c7293f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 2] + $3caef5c332c7293f$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 10] + $3caef5c332c7293f$var$lookup[tmp >> 4 & 0x3F] + $3caef5c332c7293f$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $56a54f6ebabce67d$export$aafa59e2e03f2942;
var $56a54f6ebabce67d$export$68d8715fc104d294;
$56a54f6ebabce67d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$56a54f6ebabce67d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $24f87a6f86a8996f$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$24f87a6f86a8996f$export$a143d493d941bafc = $24f87a6f86a8996f$var$Buffer;
$24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = $24f87a6f86a8996f$var$SlowBuffer;
$24f87a6f86a8996f$export$f99ded8fe4b79145 = 50;
const $24f87a6f86a8996f$var$K_MAX_LENGTH = 0x7fffffff;
$24f87a6f86a8996f$export$599f31c3813fae4d = $24f87a6f86a8996f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT = $24f87a6f86a8996f$var$typedArraySupport();
if (!$24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $24f87a6f86a8996f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $24f87a6f86a8996f$var$createBuffer(length) {
    if (length > $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $24f87a6f86a8996f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $24f87a6f86a8996f$var$allocUnsafe(arg);
    }
    return $24f87a6f86a8996f$var$from(arg, encodingOrOffset, length);
}
$24f87a6f86a8996f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $24f87a6f86a8996f$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $24f87a6f86a8996f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $24f87a6f86a8996f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($24f87a6f86a8996f$var$isInstance(value, ArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, ArrayBuffer)) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($24f87a6f86a8996f$var$isInstance(value, SharedArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, SharedArrayBuffer))) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $24f87a6f86a8996f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $24f87a6f86a8996f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $24f87a6f86a8996f$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $24f87a6f86a8996f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $24f87a6f86a8996f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer, Uint8Array);
function $24f87a6f86a8996f$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $24f87a6f86a8996f$var$alloc(size, fill, encoding) {
    $24f87a6f86a8996f$var$assertSize(size);
    if (size <= 0) return $24f87a6f86a8996f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $24f87a6f86a8996f$var$createBuffer(size).fill(fill, encoding) : $24f87a6f86a8996f$var$createBuffer(size).fill(fill);
    return $24f87a6f86a8996f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $24f87a6f86a8996f$var$Buffer.alloc = function(size, fill, encoding) {
    return $24f87a6f86a8996f$var$alloc(size, fill, encoding);
};
function $24f87a6f86a8996f$var$allocUnsafe(size) {
    $24f87a6f86a8996f$var$assertSize(size);
    return $24f87a6f86a8996f$var$createBuffer(size < 0 ? 0 : $24f87a6f86a8996f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $24f87a6f86a8996f$var$Buffer.allocUnsafe = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $24f87a6f86a8996f$var$Buffer.allocUnsafeSlow = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
function $24f87a6f86a8996f$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $24f87a6f86a8996f$var$byteLength(string, encoding) | 0;
    let buf = $24f87a6f86a8996f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $24f87a6f86a8996f$var$checked(array.length) | 0;
    const buf = $24f87a6f86a8996f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayView(arrayView) {
    if ($24f87a6f86a8996f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $24f87a6f86a8996f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $24f87a6f86a8996f$var$fromArrayLike(arrayView);
}
function $24f87a6f86a8996f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
function $24f87a6f86a8996f$var$fromObject(obj) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(obj)) {
        const len = $24f87a6f86a8996f$var$checked(obj.length) | 0;
        const buf = $24f87a6f86a8996f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $24f87a6f86a8996f$var$numberIsNaN(obj.length)) return $24f87a6f86a8996f$var$createBuffer(0);
        return $24f87a6f86a8996f$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $24f87a6f86a8996f$var$fromArrayLike(obj.data);
}
function $24f87a6f86a8996f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $24f87a6f86a8996f$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $24f87a6f86a8996f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $24f87a6f86a8996f$var$Buffer.alloc(+length);
}
$24f87a6f86a8996f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $24f87a6f86a8996f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$24f87a6f86a8996f$var$Buffer.compare = function compare(a, b) {
    if ($24f87a6f86a8996f$var$isInstance(a, Uint8Array)) a = $24f87a6f86a8996f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($24f87a6f86a8996f$var$isInstance(b, Uint8Array)) b = $24f87a6f86a8996f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(a) || !$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$24f87a6f86a8996f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$24f87a6f86a8996f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $24f87a6f86a8996f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $24f87a6f86a8996f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($24f87a6f86a8996f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) buf = $24f87a6f86a8996f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $24f87a6f86a8996f$var$byteLength(string, encoding) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $24f87a6f86a8996f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $24f87a6f86a8996f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $24f87a6f86a8996f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$24f87a6f86a8996f$var$Buffer.byteLength = $24f87a6f86a8996f$var$byteLength;
function $24f87a6f86a8996f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Slice(this, start, end);
        case "ascii":
            return $24f87a6f86a8996f$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$latin1Slice(this, start, end);
        case "base64":
            return $24f87a6f86a8996f$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$24f87a6f86a8996f$var$Buffer.prototype._isBuffer = true;
function $24f87a6f86a8996f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$24f87a6f86a8996f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$24f87a6f86a8996f$var$swap(this, i, i + 1);
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $24f87a6f86a8996f$var$swap(this, i, i + 3);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $24f87a6f86a8996f$var$swap(this, i, i + 7);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 6);
        $24f87a6f86a8996f$var$swap(this, i + 2, i + 5);
        $24f87a6f86a8996f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $24f87a6f86a8996f$var$utf8Slice(this, 0, length);
    return $24f87a6f86a8996f$var$slowToString.apply(this, arguments);
};
$24f87a6f86a8996f$var$Buffer.prototype.toLocaleString = $24f87a6f86a8996f$var$Buffer.prototype.toString;
$24f87a6f86a8996f$var$Buffer.prototype.equals = function equals(b) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $24f87a6f86a8996f$var$Buffer.compare(this, b) === 0;
};
$24f87a6f86a8996f$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $24f87a6f86a8996f$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($24f87a6f86a8996f$var$customInspectSymbol) $24f87a6f86a8996f$var$Buffer.prototype[$24f87a6f86a8996f$var$customInspectSymbol] = $24f87a6f86a8996f$var$Buffer.prototype.inspect;
$24f87a6f86a8996f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($24f87a6f86a8996f$var$isInstance(target, Uint8Array)) target = $24f87a6f86a8996f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $24f87a6f86a8996f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($24f87a6f86a8996f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $24f87a6f86a8996f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $24f87a6f86a8996f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$24f87a6f86a8996f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$24f87a6f86a8996f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $24f87a6f86a8996f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($24f87a6f86a8996f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $24f87a6f86a8996f$var$utf8Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $24f87a6f86a8996f$var$asciiWrite(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$asciiToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$base64Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$base64ToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$ucs2Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$24f87a6f86a8996f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $24f87a6f86a8996f$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$24f87a6f86a8996f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $24f87a6f86a8996f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3caef5c332c7293f$export$6100ba28696e12de(buf);
    else return $3caef5c332c7293f$export$6100ba28696e12de(buf.slice(start, end));
}
function $24f87a6f86a8996f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $24f87a6f86a8996f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $24f87a6f86a8996f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $24f87a6f86a8996f$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $24f87a6f86a8996f$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $24f87a6f86a8996f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $24f87a6f86a8996f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $24f87a6f86a8996f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$24f87a6f86a8996f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $24f87a6f86a8996f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $24f87a6f86a8996f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$24f87a6f86a8996f$var$Buffer.prototype.readUintLE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUintBE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint8 = $24f87a6f86a8996f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$24f87a6f86a8996f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$24f87a6f86a8996f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $24f87a6f86a8996f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$24f87a6f86a8996f$var$Buffer.prototype.writeUintLE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUintBE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint8 = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $24f87a6f86a8996f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $24f87a6f86a8996f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $24f87a6f86a8996f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $56a54f6ebabce67d$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, false, noAssert);
};
function $24f87a6f86a8996f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $56a54f6ebabce67d$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$24f87a6f86a8996f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$24f87a6f86a8996f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $24f87a6f86a8996f$var$Buffer.isBuffer(val) ? val : $24f87a6f86a8996f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $24f87a6f86a8996f$var$errors = {};
function $24f87a6f86a8996f$var$E(sym, getMessage, Base) {
    $24f87a6f86a8996f$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$24f87a6f86a8996f$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$24f87a6f86a8996f$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$24f87a6f86a8996f$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $24f87a6f86a8996f$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $24f87a6f86a8996f$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $24f87a6f86a8996f$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength) {
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $24f87a6f86a8996f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength);
}
function $24f87a6f86a8996f$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $24f87a6f86a8996f$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $24f87a6f86a8996f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $24f87a6f86a8996f$var$validateNumber(value, type);
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $24f87a6f86a8996f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $24f87a6f86a8996f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $24f87a6f86a8996f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($24f87a6f86a8996f$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $24f87a6f86a8996f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $24f87a6f86a8996f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $24f87a6f86a8996f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $24f87a6f86a8996f$var$base64ToBytes(str) {
    return $3caef5c332c7293f$export$d622b2ad8d90c771($24f87a6f86a8996f$var$base64clean(str));
}
function $24f87a6f86a8996f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $24f87a6f86a8996f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $24f87a6f86a8996f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $24f87a6f86a8996f$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $24f87a6f86a8996f$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $24f87a6f86a8996f$var$BufferBigIntNotDefined : fn;
}
function $24f87a6f86a8996f$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $e3285af2e8ff8ec8$require$Buffer = $24f87a6f86a8996f$export$a143d493d941bafc;
// Quick polyfill
var $e3285af2e8ff8ec8$var$fromUtf8 = typeof $e3285af2e8ff8ec8$require$Buffer !== "undefined" && $e3285af2e8ff8ec8$require$Buffer.from ? function(input) {
    return $e3285af2e8ff8ec8$require$Buffer.from(input, "utf8");
} : (0, $f5bb4d6da7c611e5$export$c7c5cef950a4d2fc);
function $e3285af2e8ff8ec8$export$4f21f20c2f1a9063(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $e3285af2e8ff8ec8$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $ec17c84f9779bd2d$export$ea55f474a468804e(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $8eb81ef908238557$export$2527dfa2a193fcfa(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// IE 11 does not support Array.from, so we do it manually
function $5d5f2e4933e14701$export$b6739cd5a63159f9(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}




var $475efd9fa7b1a9cc$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new (0, $7828a6c727c01d6d$export$aab6bc1ad3c77a42)();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $ec17c84f9779bd2d$export$ea55f474a468804e)(toHash) || this.error) return;
        try {
            this.hash.update((0, $e3285af2e8ff8ec8$export$4f21f20c2f1a9063)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $3433e5a3eb89c040$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $3433e5a3eb89c040$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new (0, $7828a6c727c01d6d$export$aab6bc1ad3c77a42)();
        if (this.secret) {
            this.outer = new (0, $7828a6c727c01d6d$export$aab6bc1ad3c77a42)();
            var inner = $475efd9fa7b1a9cc$var$bufferFromSecret(this.secret);
            var outer = new Uint8Array((0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c));
            outer.set(inner);
            for(var i = 0; i < (0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c); i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
function $475efd9fa7b1a9cc$var$bufferFromSecret(secret) {
    var input = (0, $e3285af2e8ff8ec8$export$4f21f20c2f1a9063)(secret);
    if (input.byteLength > (0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c)) {
        var bufferHash = new (0, $7828a6c727c01d6d$export$aab6bc1ad3c77a42)();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array((0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c));
    buffer.set(input);
    return buffer;
}




const $dbfeacb0e3f6e6ba$var$SHORT_TO_HEX = {};
const $dbfeacb0e3f6e6ba$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $dbfeacb0e3f6e6ba$var$SHORT_TO_HEX[i] = encodedByte;
    $dbfeacb0e3f6e6ba$var$HEX_TO_SHORT[encodedByte] = i;
}
function $dbfeacb0e3f6e6ba$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $dbfeacb0e3f6e6ba$var$HEX_TO_SHORT) out[i / 2] = $dbfeacb0e3f6e6ba$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $dbfeacb0e3f6e6ba$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $dbfeacb0e3f6e6ba$var$SHORT_TO_HEX[bytes[i]];
    return out;
}







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $d9009b35813b573c$export$b412d755cfa0136 {
    constructor(){
        this.oAuthListener = undefined;
        this.resourcesConfig = {};
        this.libraryOptions = {};
        this.Auth = new (0, $2a776d17fcab286a$export$eeff9d1a8b8c057b)();
    }
    /**
     * Configures Amplify for use with your back-end resources.
     *
     * @remarks
     * This API does not perform any merging of either `resourcesConfig` or `libraryOptions`. The most recently
     * provided values will be used after configuration.
     *
     * @remarks
     * `configure` can be used to specify additional library options where available for supported categories.
     *
     * @param resourceConfig - Back-end resource configuration. Typically provided via the `aws-exports.js` file.
     * @param libraryOptions - Additional options for customizing the behavior of the library.
     */ configure(resourcesConfig, libraryOptions) {
        const resolvedResourceConfig = (0, $c617356b2a6163e9$export$f101a69cd6dc6202)(resourcesConfig);
        this.resourcesConfig = resolvedResourceConfig;
        if (libraryOptions) this.libraryOptions = libraryOptions;
        // Make resource config immutable
        this.resourcesConfig = (0, $3040204a38b40487$export$7e32b29e1cb162e1)(this.resourcesConfig);
        this.Auth.configure(this.resourcesConfig.Auth, this.libraryOptions.Auth);
        (0, $c9802061728ce106$export$8c41bb232f1008b1).dispatch("core", {
            event: "configure",
            data: this.resourcesConfig
        }, "Configure", (0, $c9802061728ce106$export$aadf71dd9875dd20));
        this.notifyOAuthListener();
    }
    /**
     * Provides access to the current back-end resource configuration for the Library.
     *
     * @returns Returns the immutable back-end resource configuration.
     */ getConfig() {
        return this.resourcesConfig;
    }
    /** @internal */ [(0, $6b6ce34dcf385dec$export$35210b3191d26437)](listener) {
        if (this.resourcesConfig.Auth?.Cognito.loginWith?.oauth) // when Amplify has been configured with a valid OAuth config while adding the listener, run it directly
        listener(this.resourcesConfig.Auth?.Cognito);
        else // otherwise register the listener and run it later when Amplify gets configured with a valid oauth config
        this.oAuthListener = listener;
    }
    notifyOAuthListener() {
        if (!this.resourcesConfig.Auth?.Cognito.loginWith?.oauth || !this.oAuthListener) return;
        this.oAuthListener(this.resourcesConfig.Auth?.Cognito);
        // the listener should only be notified once with a valid oauth config
        this.oAuthListener = undefined;
    }
}
/**
 * The `Amplify` utility is used to configure the library.
 *
 * @remarks
 * `Amplify` orchestrates cross-category communication within the library.
 */ const $d9009b35813b573c$export$a3858a9a153cffc7 = new $d9009b35813b573c$export$b412d755cfa0136();

var $39b3979787198c97$exports = {};
(function(global, factory) {
    $39b3979787198c97$exports = factory();
})($39b3979787198c97$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $19002707866b8978$export$dae7d845015939d5 {
    constructor(data = {}){
        const { path: path , domain: domain , expires: expires , sameSite: sameSite , secure: secure  } = data;
        this.domain = domain;
        this.path = path || "/";
        this.expires = Object.prototype.hasOwnProperty.call(data, "expires") ? expires : 365;
        this.secure = Object.prototype.hasOwnProperty.call(data, "secure") ? secure : true;
        if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
            if (!sameSite || ![
                "strict",
                "lax",
                "none"
            ].includes(sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = sameSite;
        }
    }
    async setItem(key, value) {
        (0, (/*@__PURE__*/$parcel$interopDefault($39b3979787198c97$exports))).set(key, value, this.getData());
    }
    async getItem(key) {
        const item = (0, (/*@__PURE__*/$parcel$interopDefault($39b3979787198c97$exports))).get(key);
        return item ?? null;
    }
    async removeItem(key) {
        (0, (/*@__PURE__*/$parcel$interopDefault($39b3979787198c97$exports))).remove(key, this.getData());
    }
    async clear() {
        const cookie = (0, (/*@__PURE__*/$parcel$interopDefault($39b3979787198c97$exports))).get();
        const promises = Object.keys(cookie).map((key)=>this.removeItem(key));
        await Promise.all(promises);
    }
    getData() {
        return {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure,
            ...this.sameSite && {
                sameSite: this.sameSite
            }
        };
    }
}

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $e4876bf018e81b36$export$4e712df6b850c8d0;
(function(AmplifyErrorCode) {
    AmplifyErrorCode["NoEndpointId"] = "NoEndpointId";
    AmplifyErrorCode["PlatformNotSupported"] = "PlatformNotSupported";
    AmplifyErrorCode["Unknown"] = "Unknown";
    AmplifyErrorCode["NetworkError"] = "NetworkError";
})($e4876bf018e81b36$export$4e712df6b850c8d0 || ($e4876bf018e81b36$export$4e712df6b850c8d0 = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $fc284bac6252ec64$export$f5362e8a6666a455 extends (0, $05b2dc7abeec3af3$export$37321a6dace1881c) {
    constructor(){
        super({
            name: (0, $e4876bf018e81b36$export$4e712df6b850c8d0).PlatformNotSupported,
            message: "Function not supported on current platform"
        });
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $4970eef2b985f880$export$8536778e426ddf92 {
    constructor(storage){
        this.storage = storage;
    }
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ async setItem(key, value) {
        if (!this.storage) throw new (0, $fc284bac6252ec64$export$f5362e8a6666a455)();
        this.storage.setItem(key, value);
    }
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ async getItem(key) {
        if (!this.storage) throw new (0, $fc284bac6252ec64$export$f5362e8a6666a455)();
        return this.storage.getItem(key);
    }
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ async removeItem(key) {
        if (!this.storage) throw new (0, $fc284bac6252ec64$export$f5362e8a6666a455)();
        this.storage.removeItem(key);
    }
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ async clear() {
        if (!this.storage) throw new (0, $fc284bac6252ec64$export$f5362e8a6666a455)();
        this.storage.clear();
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $f760777b4ecb21d0$export$e4315e25b840a0ea {
    constructor(){
        this.storage = new Map();
    }
    get length() {
        return this.storage.size;
    }
    key(index) {
        if (index > this.length - 1) return null;
        return Array.from(this.storage.keys())[index];
    }
    setItem(key, value) {
        this.storage.set(key, value);
    }
    getItem(key) {
        return this.storage.get(key) ?? null;
    }
    removeItem(key) {
        this.storage.delete(key);
    }
    clear() {
        this.storage.clear();
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 * @returns Either a reference to window.localStorage or an in-memory storage as fallback
 */ const $77335959be8d0fb9$var$logger = new (0, $cda4d9e419200573$export$ba6a9c7ac8291f7f)("CoreStorageUtils");
const $77335959be8d0fb9$export$5d9abaf8ff62cd65 = ()=>{
    try {
        // Attempt to use localStorage directly
        if (typeof window !== "undefined" && window.localStorage) return window.localStorage;
    } catch (e) {
        // Handle any errors related to localStorage access
        $77335959be8d0fb9$var$logger.info("localStorage not found. InMemoryStorage is used as a fallback.");
    }
    // Return in-memory storage as a fallback if localStorage is not accessible
    return new (0, $f760777b4ecb21d0$export$e4315e25b840a0ea)();
};
/**
 * @internal
 * @returns Either a reference to window.sessionStorage or an in-memory storage as fallback
 */ const $77335959be8d0fb9$export$518dcc1598f87b = ()=>{
    try {
        // Attempt to use sessionStorage directly
        if (typeof window !== "undefined" && window.sessionStorage) {
            // Verify we can actually use it by testing access
            window.sessionStorage.getItem("test");
            return window.sessionStorage;
        }
        throw new Error("sessionStorage is not defined");
    } catch (e) {
        // Handle any errors related to sessionStorage access
        $77335959be8d0fb9$var$logger.info("sessionStorage not found. InMemoryStorage is used as a fallback.");
        return new (0, $f760777b4ecb21d0$export$e4315e25b840a0ea)();
    }
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $2165b74f660a7d7f$export$bec45e7703e93690 extends (0, $4970eef2b985f880$export$8536778e426ddf92) {
    constructor(){
        super((0, $77335959be8d0fb9$export$5d9abaf8ff62cd65)());
    }
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $b9254a1066f71a36$export$2c4b17e1c2e0931 extends (0, $4970eef2b985f880$export$8536778e426ddf92) {
    constructor(){
        super((0, $77335959be8d0fb9$export$518dcc1598f87b)());
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $a69d5872d006e876$export$f7640313c5d17c27 {
    constructor(storage){
        this._storage = storage;
    }
    get storage() {
        if (!this._storage) throw new (0, $fc284bac6252ec64$export$f5362e8a6666a455)();
        return this._storage;
    }
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ setItem(key, value) {
        this.storage.setItem(key, value);
    }
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ getItem(key) {
        return this.storage.getItem(key);
    }
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ removeItem(key) {
        this.storage.removeItem(key);
    }
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ clear() {
        this.storage.clear();
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $e5c12039e9598a89$export$eb7b875b75a2c8df extends (0, $a69d5872d006e876$export$f7640313c5d17c27) {
    constructor(){
        super((0, $77335959be8d0fb9$export$518dcc1598f87b)());
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c1a7077392f3b8b2$export$586b30dcaeecb901 = new (0, $2165b74f660a7d7f$export$bec45e7703e93690)();
const $c1a7077392f3b8b2$export$f119d83aa936d634 = new (0, $b9254a1066f71a36$export$2c4b17e1c2e0931)();
const $c1a7077392f3b8b2$export$9015f19b74348a18 = new (0, $e5c12039e9598a89$export$eb7b875b75a2c8df)();
const $c1a7077392f3b8b2$export$41feb988b3a84f03 = new (0, $4970eef2b985f880$export$8536778e426ddf92)(new (0, $f760777b4ecb21d0$export$e4315e25b840a0ea)());








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $75891aafa6b8443f$export$e003cc239f955cb6 = ()=>{
    if (typeof window === "object" && typeof window.crypto === "object") return window.crypto;
    // Next.js global polyfill
    if (typeof crypto === "object") return crypto;
    throw new (0, $05b2dc7abeec3af3$export$37321a6dace1881c)({
        name: "MissingPolyfill",
        message: "Cannot resolve the `crypto` function from the environment."
    });
};
const $75891aafa6b8443f$export$94f295707b435c6d = ()=>{
    // browser
    if (typeof window !== "undefined" && typeof window.btoa === "function") return window.btoa;
    // Next.js global polyfill
    if (typeof btoa === "function") return btoa;
    throw new (0, $05b2dc7abeec3af3$export$37321a6dace1881c)({
        name: "Base64EncoderError",
        message: "Cannot resolve the `btoa` function from the environment."
    });
};
const $75891aafa6b8443f$export$ea737e7700106b27 = ()=>{
    // browser
    if (typeof window !== "undefined" && typeof window.atob === "function") return window.atob;
    // Next.js global polyfill
    if (typeof atob === "function") return atob;
    throw new (0, $05b2dc7abeec3af3$export$37321a6dace1881c)({
        name: "Base64EncoderError",
        message: "Cannot resolve the `atob` function from the environment."
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ef7237a6eb0adc7d$export$1e303d38dab7b376 = {
    convert (input, options) {
        let inputStr = input;
        // urlSafe character replacement options conform to the base64 url spec
        // https://datatracker.ietf.org/doc/html/rfc4648#page-7
        if (options?.urlSafe) inputStr = inputStr.replace(/-/g, "+").replace(/_/g, "/");
        return (0, $75891aafa6b8443f$export$ea737e7700106b27)()(inputStr);
    }
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2923b69a4f2b8c7f$export$5cb8fc27ccbe9d40 = (errorMap, AssertionError = (0, $05b2dc7abeec3af3$export$37321a6dace1881c))=>(assertion, name, additionalContext)=>{
        const { message: message , recoverySuggestion: recoverySuggestion  } = errorMap[name];
        if (!assertion) throw new AssertionError({
            name: name,
            message: additionalContext ? `${message} ${additionalContext}` : message,
            recoverySuggestion: recoverySuggestion
        });
    };




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $35f97ba24e00c443$export$7b5c8b570ea8407;
(function(AuthConfigurationErrorCode) {
    AuthConfigurationErrorCode["AuthTokenConfigException"] = "AuthTokenConfigException";
    AuthConfigurationErrorCode["AuthUserPoolAndIdentityPoolException"] = "AuthUserPoolAndIdentityPoolException";
    AuthConfigurationErrorCode["AuthUserPoolException"] = "AuthUserPoolException";
    AuthConfigurationErrorCode["InvalidIdentityPoolIdException"] = "InvalidIdentityPoolIdException";
    AuthConfigurationErrorCode["OAuthNotConfigureException"] = "OAuthNotConfigureException";
})($35f97ba24e00c443$export$7b5c8b570ea8407 || ($35f97ba24e00c443$export$7b5c8b570ea8407 = {}));
const $35f97ba24e00c443$var$authConfigurationErrorMap = {
    [$35f97ba24e00c443$export$7b5c8b570ea8407.AuthTokenConfigException]: {
        message: "Auth Token Provider not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app."
    },
    [$35f97ba24e00c443$export$7b5c8b570ea8407.AuthUserPoolAndIdentityPoolException]: {
        message: "Auth UserPool or IdentityPool not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app with UserPoolId and IdentityPoolId."
    },
    [$35f97ba24e00c443$export$7b5c8b570ea8407.AuthUserPoolException]: {
        message: "Auth UserPool not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app with userPoolId and userPoolClientId."
    },
    [$35f97ba24e00c443$export$7b5c8b570ea8407.InvalidIdentityPoolIdException]: {
        message: "Invalid identity pool id provided.",
        recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    },
    [$35f97ba24e00c443$export$7b5c8b570ea8407.OAuthNotConfigureException]: {
        message: "oauth param not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure with oauth parameter in your app."
    }
};
const $35f97ba24e00c443$export$a7a9523472993e97 = (0, $2923b69a4f2b8c7f$export$5cb8fc27ccbe9d40)($35f97ba24e00c443$var$authConfigurationErrorMap);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $d0b404dc65adc192$export$80c92581e59ed502(cognitoConfig) {
    let assertionValid = true; // assume valid until otherwise proveed
    if (!cognitoConfig) assertionValid = false;
    else assertionValid = !!cognitoConfig.userPoolId && !!cognitoConfig.userPoolClientId;
    (0, $35f97ba24e00c443$export$a7a9523472993e97)(assertionValid, (0, $35f97ba24e00c443$export$7b5c8b570ea8407).AuthUserPoolException);
}
function $d0b404dc65adc192$export$c13e6dbaf90a8e5f(cognitoConfig) {
    const validOAuthConfig = !!cognitoConfig?.loginWith?.oauth?.domain && !!cognitoConfig?.loginWith?.oauth?.redirectSignOut && !!cognitoConfig?.loginWith?.oauth?.redirectSignIn && !!cognitoConfig?.loginWith?.oauth?.responseType;
    (0, $35f97ba24e00c443$export$a7a9523472993e97)(validOAuthConfig, (0, $35f97ba24e00c443$export$7b5c8b570ea8407).OAuthNotConfigureException);
}
function $d0b404dc65adc192$export$8a2f5318ea3215e3(cognitoConfig) {
    const validConfig = !!cognitoConfig?.identityPoolId;
    (0, $35f97ba24e00c443$export$a7a9523472993e97)(validConfig, (0, $35f97ba24e00c443$export$7b5c8b570ea8407).InvalidIdentityPoolIdException);
}
/**
 * Decodes payload of JWT token
 *
 * @param {String} token A string representing a token to be decoded
 * @throws {@link Error} - Throws error when token is invalid or payload malformed.
 */ function $d0b404dc65adc192$export$9a62e6c0a30e00bc(token) {
    const tokenParts = token.split(".");
    if (tokenParts.length !== 3) throw new Error("Invalid token");
    try {
        const base64WithUrlSafe = tokenParts[1];
        const base64 = base64WithUrlSafe.replace(/-/g, "+").replace(/_/g, "/");
        const jsonStr = decodeURIComponent((0, $ef7237a6eb0adc7d$export$1e303d38dab7b376).convert(base64).split("").map((char)=>`%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`).join(""));
        const payload = JSON.parse(jsonStr);
        return {
            toString: ()=>token,
            payload: payload
        };
    } catch (err) {
        throw new Error("Invalid token payload");
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $68efb77f62f1efb5$export$145273558d58e0ac extends (0, $05b2dc7abeec3af3$export$37321a6dace1881c) {
    constructor(params){
        super(params);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $68efb77f62f1efb5$export$145273558d58e0ac;
        Object.setPrototypeOf(this, $68efb77f62f1efb5$export$145273558d58e0ac.prototype);
    }
}


const $e75e7ee74a72b3de$export$b8429d1428aad8ba = {
    accessToken: "accessToken",
    idToken: "idToken",
    oidcProvider: "oidcProvider",
    clockDrift: "clockDrift",
    refreshToken: "refreshToken",
    deviceKey: "deviceKey",
    randomPasswordKey: "randomPasswordKey",
    deviceGroupKey: "deviceGroupKey",
    signInDetails: "signInDetails",
    oauthMetadata: "oauthMetadata"
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $2cef52a724b824ad$export$cc5909720f29144;
(function(TokenProviderErrorCode) {
    TokenProviderErrorCode["InvalidAuthTokens"] = "InvalidAuthTokens";
})($2cef52a724b824ad$export$cc5909720f29144 || ($2cef52a724b824ad$export$cc5909720f29144 = {}));
const $2cef52a724b824ad$var$tokenValidationErrorMap = {
    [$2cef52a724b824ad$export$cc5909720f29144.InvalidAuthTokens]: {
        message: "Invalid tokens.",
        recoverySuggestion: "Make sure the tokens are valid."
    }
};
const $2cef52a724b824ad$export$a7a9523472993e97 = (0, $2923b69a4f2b8c7f$export$5cb8fc27ccbe9d40)($2cef52a724b824ad$var$tokenValidationErrorMap);


class $62bb7d16e56984d5$export$a36be852d43d512 {
    constructor(){
        this.name = "CognitoIdentityServiceProvider"; // To be backwards compatible with V5, no migration needed
    }
    getKeyValueStorage() {
        if (!this.keyValueStorage) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: "KeyValueStorageNotFoundException",
            message: "KeyValueStorage was not found in TokenStore"
        });
        return this.keyValueStorage;
    }
    setKeyValueStorage(keyValueStorage) {
        this.keyValueStorage = keyValueStorage;
    }
    setAuthConfig(authConfig) {
        this.authConfig = authConfig;
    }
    async loadTokens() {
        // TODO(v6): migration logic should be here
        // Reading V5 tokens old format
        try {
            const authKeys = await this.getAuthKeys();
            const accessTokenString = await this.getKeyValueStorage().getItem(authKeys.accessToken);
            if (!accessTokenString) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
                name: "NoSessionFoundException",
                message: "Auth session was not found. Make sure to call signIn."
            });
            const accessToken = (0, $d0b404dc65adc192$export$9a62e6c0a30e00bc)(accessTokenString);
            const itString = await this.getKeyValueStorage().getItem(authKeys.idToken);
            const idToken = itString ? (0, $d0b404dc65adc192$export$9a62e6c0a30e00bc)(itString) : undefined;
            const refreshToken = await this.getKeyValueStorage().getItem(authKeys.refreshToken) ?? undefined;
            const clockDriftString = await this.getKeyValueStorage().getItem(authKeys.clockDrift) ?? "0";
            const clockDrift = Number.parseInt(clockDriftString);
            const signInDetails = await this.getKeyValueStorage().getItem(authKeys.signInDetails);
            const tokens = {
                accessToken: accessToken,
                idToken: idToken,
                refreshToken: refreshToken,
                deviceMetadata: await this.getDeviceMetadata() ?? undefined,
                clockDrift: clockDrift,
                username: await this.getLastAuthUser()
            };
            if (signInDetails) tokens.signInDetails = JSON.parse(signInDetails);
            return tokens;
        } catch (err) {
            return null;
        }
    }
    async storeTokens(tokens) {
        (0, $2cef52a724b824ad$export$a7a9523472993e97)(tokens !== undefined, (0, $2cef52a724b824ad$export$cc5909720f29144).InvalidAuthTokens);
        await this.clearTokens();
        const lastAuthUser = tokens.username;
        await this.getKeyValueStorage().setItem(this.getLastAuthUserKey(), lastAuthUser);
        const authKeys = await this.getAuthKeys();
        await this.getKeyValueStorage().setItem(authKeys.accessToken, tokens.accessToken.toString());
        if (tokens.idToken) await this.getKeyValueStorage().setItem(authKeys.idToken, tokens.idToken.toString());
        if (tokens.refreshToken) await this.getKeyValueStorage().setItem(authKeys.refreshToken, tokens.refreshToken);
        if (tokens.deviceMetadata) {
            if (tokens.deviceMetadata.deviceKey) await this.getKeyValueStorage().setItem(authKeys.deviceKey, tokens.deviceMetadata.deviceKey);
            if (tokens.deviceMetadata.deviceGroupKey) await this.getKeyValueStorage().setItem(authKeys.deviceGroupKey, tokens.deviceMetadata.deviceGroupKey);
            await this.getKeyValueStorage().setItem(authKeys.randomPasswordKey, tokens.deviceMetadata.randomPassword);
        }
        if (tokens.signInDetails) await this.getKeyValueStorage().setItem(authKeys.signInDetails, JSON.stringify(tokens.signInDetails));
        await this.getKeyValueStorage().setItem(authKeys.clockDrift, `${tokens.clockDrift}`);
    }
    async clearTokens() {
        const authKeys = await this.getAuthKeys();
        // Not calling clear because it can remove data that is not managed by AuthTokenStore
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.accessToken),
            this.getKeyValueStorage().removeItem(authKeys.idToken),
            this.getKeyValueStorage().removeItem(authKeys.clockDrift),
            this.getKeyValueStorage().removeItem(authKeys.refreshToken),
            this.getKeyValueStorage().removeItem(authKeys.signInDetails),
            this.getKeyValueStorage().removeItem(this.getLastAuthUserKey()),
            this.getKeyValueStorage().removeItem(authKeys.oauthMetadata)
        ]);
    }
    async getDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        const deviceKey = await this.getKeyValueStorage().getItem(authKeys.deviceKey);
        const deviceGroupKey = await this.getKeyValueStorage().getItem(authKeys.deviceGroupKey);
        const randomPassword = await this.getKeyValueStorage().getItem(authKeys.randomPasswordKey);
        return randomPassword && deviceGroupKey && deviceKey ? {
            deviceKey: deviceKey,
            deviceGroupKey: deviceGroupKey,
            randomPassword: randomPassword
        } : null;
    }
    async clearDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.deviceKey),
            this.getKeyValueStorage().removeItem(authKeys.deviceGroupKey),
            this.getKeyValueStorage().removeItem(authKeys.randomPasswordKey)
        ]);
    }
    async getAuthKeys(username) {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.authConfig?.Cognito);
        const lastAuthUser = username ?? await this.getLastAuthUser();
        return $62bb7d16e56984d5$export$4647c72f6828a74d(this.name, `${this.authConfig.Cognito.userPoolClientId}.${lastAuthUser}`);
    }
    getLastAuthUserKey() {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.authConfig?.Cognito);
        const identifier = this.authConfig.Cognito.userPoolClientId;
        return `${this.name}.${identifier}.LastAuthUser`;
    }
    async getLastAuthUser() {
        const lastAuthUser = await this.getKeyValueStorage().getItem(this.getLastAuthUserKey()) ?? "username";
        return lastAuthUser;
    }
    async setOAuthMetadata(metadata) {
        const { oauthMetadata: oauthMetadataKey  } = await this.getAuthKeys();
        await this.getKeyValueStorage().setItem(oauthMetadataKey, JSON.stringify(metadata));
    }
    async getOAuthMetadata() {
        const { oauthMetadata: oauthMetadataKey  } = await this.getAuthKeys();
        const oauthMetadata = await this.getKeyValueStorage().getItem(oauthMetadataKey);
        return oauthMetadata && JSON.parse(oauthMetadata);
    }
}
const $62bb7d16e56984d5$export$4647c72f6828a74d = (provider, identifier)=>{
    return $62bb7d16e56984d5$export$dfb8da757ca62eed((0, $e75e7ee74a72b3de$export$b8429d1428aad8ba))(`${provider}`, identifier);
};
function $62bb7d16e56984d5$export$dfb8da757ca62eed(authKeys) {
    const keys = Object.values({
        ...authKeys
    });
    return (prefix, identifier)=>keys.reduce((acc, authKey)=>({
                ...acc,
                [authKey]: `${prefix}.${identifier}.${authKey}`
            }), {});
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $88802c4070901871$export$dad1700b96c3a835 = {
    identityId: "identityId"
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $bb88847e241335cc$var$logger = new (0, $cda4d9e419200573$export$ba6a9c7ac8291f7f)("DefaultIdentityIdStore");
class $bb88847e241335cc$export$3e97b78667a539a0 {
    setAuthConfig(authConfigParam) {
        (0, $d0b404dc65adc192$export$8a2f5318ea3215e3)(authConfigParam.Cognito);
        this.authConfig = authConfigParam;
        this._authKeys = $bb88847e241335cc$var$createKeysForAuthStorage("Cognito", authConfigParam.Cognito.identityPoolId);
    }
    constructor(keyValueStorage){
        this._authKeys = {};
        this._hasGuestIdentityId = false;
        this.keyValueStorage = keyValueStorage;
    }
    async loadIdentityId() {
        (0, $d0b404dc65adc192$export$8a2f5318ea3215e3)(this.authConfig?.Cognito);
        try {
            if (this._primaryIdentityId) return {
                id: this._primaryIdentityId,
                type: "primary"
            };
            else {
                const storedIdentityId = await this.keyValueStorage.getItem(this._authKeys.identityId);
                if (storedIdentityId) {
                    this._hasGuestIdentityId = true;
                    return {
                        id: storedIdentityId,
                        type: "guest"
                    };
                }
                return null;
            }
        } catch (err) {
            $bb88847e241335cc$var$logger.log("Error getting stored IdentityId.", err);
            return null;
        }
    }
    async storeIdentityId(identity) {
        (0, $d0b404dc65adc192$export$8a2f5318ea3215e3)(this.authConfig?.Cognito);
        if (identity.type === "guest") {
            this.keyValueStorage.setItem(this._authKeys.identityId, identity.id);
            // Clear in-memory storage of primary identityId
            this._primaryIdentityId = undefined;
            this._hasGuestIdentityId = true;
        } else {
            this._primaryIdentityId = identity.id;
            // Clear locally stored guest id
            if (this._hasGuestIdentityId) {
                this.keyValueStorage.removeItem(this._authKeys.identityId);
                this._hasGuestIdentityId = false;
            }
        }
    }
    async clearIdentityId() {
        this._primaryIdentityId = undefined;
        await this.keyValueStorage.removeItem(this._authKeys.identityId);
    }
}
const $bb88847e241335cc$var$createKeysForAuthStorage = (provider, identifier)=>{
    return (0, $62bb7d16e56984d5$export$dfb8da757ca62eed)((0, $88802c4070901871$export$dad1700b96c3a835))(`com.amplify.${provider}`, identifier);
};








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $706f3dc369998648$export$978f9418fe0cb26c = (response)=>{
    const { headers: headers , statusCode: statusCode  } = response;
    return {
        ...$706f3dc369998648$var$isMetadataBearer(response) ? response.$metadata : {},
        httpStatusCode: statusCode,
        requestId: headers["x-amzn-requestid"] ?? headers["x-amzn-request-id"] ?? headers["x-amz-request-id"],
        extendedRequestId: headers["x-amz-id-2"],
        cfId: headers["x-amz-cf-id"]
    };
};
const $706f3dc369998648$var$isMetadataBearer = (response)=>typeof response?.$metadata === "object";



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Utility functions for serializing and deserializing of JSON protocol in general(including: REST-JSON, JSON-RPC, etc.)
 */ /**
 * Error parser for AWS JSON protocol.
 */ const $209f6e497b3a00cd$export$be467dfcc0538e25 = async (response)=>{
    if (!response || response.statusCode < 300) return;
    const body = await $209f6e497b3a00cd$export$759bcb35b0d1bf81(response);
    const sanitizeErrorCode = (rawValue)=>{
        const [cleanValue] = rawValue.toString().split(/[,:]+/);
        if (cleanValue.includes("#")) return cleanValue.split("#")[1];
        return cleanValue;
    };
    const code = sanitizeErrorCode(response.headers["x-amzn-errortype"] ?? body.code ?? body.__type ?? "UnknownError");
    const message = body.message ?? body.Message ?? "Unknown error";
    const error = new Error(message);
    return Object.assign(error, {
        name: code,
        $metadata: (0, $706f3dc369998648$export$978f9418fe0cb26c)(response)
    });
};
/**
 * Parse JSON response body to JavaScript object.
 */ const $209f6e497b3a00cd$export$759bcb35b0d1bf81 = async (response)=>{
    if (!response.body) throw new Error("Missing response payload");
    const output = await response.body.json();
    return Object.assign(output, {
        $metadata: (0, $706f3dc369998648$export$978f9418fe0cb26c)(response)
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a service API handler that accepts input as defined shape and responds conforming to defined output shape.
 * A service API handler is composed with:
 * * A transfer handler
 * * A serializer function
 * * A deserializer function
 * * A default config object
 *
 * The returned service API handler, when called, will trigger the following workflow:
 * 1. When calling the service API handler function, the default config object is merged into the input config
 * object to assign the default values of some omitted configs, resulting to a resolved config object.
 * 2. The `endpointResolver` function from the default config object will be invoked with the resolved config object and
 * API input object resulting to an endpoint instance.
 * 3. The serializer function is invoked with API input object and the endpoint instance resulting to an HTTP request
 * instance.
 * 4. The HTTP request instance and the resolved config object is passed to the transfer handler function.
 * 5. The transfer handler function resolves to an HTTP response instance(can be either successful or failed status code).
 * 6. The deserializer function is invoked with the HTTP response instance resulting to the API output object, and
 * return to the caller.
 *
 *
 * @param transferHandler Async function for dispatching HTTP requests and returning HTTP response.
 * @param serializer  Async function for converting object in defined input shape into HTTP request targeting a given
 * 	endpoint.
 * @param deserializer Async function for converting HTTP response into output object in defined output shape, or error
 * 	shape.
 * @param defaultConfig  object containing default options to be consumed by transfer handler, serializer and
 *  deserializer.
 * @returns a async service API handler function that accepts a config object and input object in defined shape, returns
 * 	an output object in defined shape. It may also throw error instance in defined shape in deserializer. The config
 *  object type is composed with options type of transferHandler, endpointResolver function as well as endpointResolver
 *  function's input options type, region string. The config object property will be marked as optional if it's also
 * 	defined in defaultConfig.
 *
 * @internal
 */ const $f3f8f97d845c2fa1$export$880429a8ae983d4d = (transferHandler, serializer, deserializer, defaultConfig)=>{
    return async (config, input)=>{
        const resolvedConfig = {
            ...defaultConfig,
            ...config
        };
        // We need to allow different endpoints based on both given config(other than region) and input.
        // However for most of non-S3 services, region is the only input for endpoint resolver.
        const endpoint = await resolvedConfig.endpointResolver(resolvedConfig, input);
        // Unlike AWS SDK clients, a serializer should NOT populate the `host` or `content-length` headers.
        // Both of these headers are prohibited per Spec(https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name).
        // They will be populated automatically by browser, or node-fetch polyfill.
        const request = await serializer(input, endpoint);
        const response = await transferHandler(request, {
            ...resolvedConfig
        });
        return deserializer(response);
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Default partition for AWS services. This is used when the region is not provided or the region is not recognized.
 *
 * @internal
 */ const $536c8e8dca0d7a6d$export$72f3cee421ee8a74 = {
    id: "aws",
    outputs: {
        dnsSuffix: "amazonaws.com"
    },
    regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
    regions: [
        "aws-global"
    ]
};
/**
 * This data is adapted from the partition file from AWS SDK shared utilities but remove some contents for bundle size
 * concern. Information removed are `dualStackDnsSuffix`, `supportDualStack`, `supportFIPS`, restricted partitions, and
 * list of regions for each partition other than global regions.
 *
 * * Ref: https://docs.aws.amazon.com/general/latest/gr/rande.html#regional-endpoints
 * * Ref: https://github.com/aws/aws-sdk-js-v3/blob/0201baef03c2379f1f6f7150b9d401d4b230d488/packages/util-endpoints/src/lib/aws/partitions.json#L1
 *
 * @internal
 */ const $536c8e8dca0d7a6d$export$d7c12af0c0f12206 = {
    partitions: [
        $536c8e8dca0d7a6d$export$72f3cee421ee8a74,
        {
            id: "aws-cn",
            outputs: {
                dnsSuffix: "amazonaws.com.cn"
            },
            regionRegex: "^cn\\-\\w+\\-\\d+$",
            regions: [
                "aws-cn-global"
            ]
        }
    ]
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get the AWS Services endpoint URL's DNS suffix for a given region. A typical AWS regional service endpoint URL will
 * follow this pattern: {endpointPrefix}.{region}.{dnsSuffix}. For example, the endpoint URL for Cognito Identity in
 * us-east-1 will be cognito-identity.us-east-1.amazonaws.com. Here the DnsSuffix is `amazonaws.com`.
 *
 * @param region
 * @returns The DNS suffix
 *
 * @internal
 */ const $83f0685006e72a3c$export$1c28e37cdcc37f6d = (region)=>{
    const { partitions: partitions  } = (0, $536c8e8dca0d7a6d$export$d7c12af0c0f12206);
    for (const { regions: regions , outputs: outputs , regionRegex: regionRegex  } of partitions){
        const regex = new RegExp(regionRegex);
        if (regions.includes(region) || regex.test(region)) return outputs.dnsSuffix;
    }
    return (0, $536c8e8dca0d7a6d$export$72f3cee421ee8a74).outputs.dnsSuffix;
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7930ce1b6e24c566$var$DEFAULT_RETRY_ATTEMPTS = 3;
/**
 * Retry middleware
 */ const $7930ce1b6e24c566$export$72f002d3da1a429f = ({ maxAttempts: maxAttempts = $7930ce1b6e24c566$var$DEFAULT_RETRY_ATTEMPTS , retryDecider: retryDecider , computeDelay: computeDelay , abortSignal: abortSignal  })=>{
    if (maxAttempts < 1) throw new Error("maxAttempts must be greater than 0");
    return (next, context)=>async function retryMiddleware(request) {
            let error;
            let attemptsCount = context.attemptsCount ?? 0;
            let response;
            // When retry is not needed or max attempts is reached, either error or response will be set. This function handles either cases.
            const handleTerminalErrorOrResponse = ()=>{
                if (response) {
                    $7930ce1b6e24c566$var$addOrIncrementMetadataAttempts(response, attemptsCount);
                    return response;
                } else {
                    $7930ce1b6e24c566$var$addOrIncrementMetadataAttempts(error, attemptsCount);
                    throw error;
                }
            };
            while(!abortSignal?.aborted && attemptsCount < maxAttempts){
                try {
                    response = await next(request);
                    error = undefined;
                } catch (e) {
                    error = e;
                    response = undefined;
                }
                // context.attemptsCount may be updated after calling next handler which may retry the request by itself.
                attemptsCount = (context.attemptsCount ?? 0) > attemptsCount ? context.attemptsCount ?? 0 : attemptsCount + 1;
                context.attemptsCount = attemptsCount;
                const { isCredentialsExpiredError: isCredentialsExpiredError , retryable: retryable  } = await retryDecider(response, error, context);
                if (retryable) {
                    // Setting isCredentialsInvalid flag to notify signing middleware to forceRefresh credentials provider.
                    context.isCredentialsExpired = !!isCredentialsExpiredError;
                    if (!abortSignal?.aborted && attemptsCount < maxAttempts) {
                        // prevent sleep for last attempt or cancelled request;
                        const delay = computeDelay(attemptsCount);
                        await $7930ce1b6e24c566$var$cancellableSleep(delay, abortSignal);
                    }
                    continue;
                } else return handleTerminalErrorOrResponse();
            }
            if (abortSignal?.aborted) throw new Error("Request aborted.");
            else return handleTerminalErrorOrResponse();
        };
};
const $7930ce1b6e24c566$var$cancellableSleep = (timeoutMs, abortSignal)=>{
    if (abortSignal?.aborted) return Promise.resolve();
    let timeoutId;
    let sleepPromiseResolveFn;
    const sleepPromise = new Promise((resolve)=>{
        sleepPromiseResolveFn = resolve;
        timeoutId = setTimeout(resolve, timeoutMs);
    });
    abortSignal?.addEventListener("abort", function cancelSleep(_) {
        clearTimeout(timeoutId);
        abortSignal?.removeEventListener("abort", cancelSleep);
        sleepPromiseResolveFn();
    });
    return sleepPromise;
};
const $7930ce1b6e24c566$var$addOrIncrementMetadataAttempts = (nextHandlerOutput, attempts)=>{
    if (Object.prototype.toString.call(nextHandlerOutput) !== "[object Object]") return;
    nextHandlerOutput.$metadata = {
        ...nextHandlerOutput.$metadata ?? {},
        attempts: attempts
    };
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware injects user agent string to specified header(default to 'x-amz-user-agent'),
 * if the header is not set already.
 *
 * TODO: incorporate new user agent design
 */ const $78db0a64bb1e3bda$export$ff28171a05413bc5 = ({ userAgentHeader: userAgentHeader = "x-amz-user-agent" , userAgentValue: userAgentValue = ""  })=>(next)=>{
        return async function userAgentMiddleware(request) {
            if (userAgentValue.trim().length === 0) {
                const result = await next(request);
                return result;
            } else {
                const headerName = userAgentHeader.toLowerCase();
                request.headers[headerName] = request.headers[headerName] ? `${request.headers[headerName]} ${userAgentValue}` : userAgentValue;
                const response = await next(request);
                return response;
            }
        };
    };


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a transfer handler with a core transfer handler and a list of middleware.
 * @param coreHandler Core transfer handler
 * @param middleware	List of middleware
 * @returns A transfer handler whose option type is the union of the core
 * 	transfer handler's option type and the middleware's option type.
 * @internal
 */ const $e4148c4bd51790db$export$f074d76e52925468 = (coreHandler, middleware)=>(request, options)=>{
        const context = {};
        let composedHandler = (composeHandlerRequest)=>coreHandler(composeHandlerRequest, options);
        for(let i = middleware.length - 1; i >= 0; i--){
            const m = middleware[i];
            const resolvedMiddleware = m(options);
            composedHandler = resolvedMiddleware(composedHandler, context);
        }
        return composedHandler(request);
    };





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cache the payload of a response body. It allows multiple calls to the body,
 * for example, when reading the body in both retry decider and error deserializer.
 * Caching body is allowed here because we call the body accessor(blob(), json(),
 * etc.) when body is small or streaming implementation is not available(RN).
 *
 * @internal
 */ const $277c56c6bc847e76$export$580ad1ce15092b15 = (payloadAccessor)=>{
    let cached;
    return ()=>{
        if (!cached) // Explicitly not awaiting. Intermediate await would add overhead and
        // introduce a possible race in the event that this wrapper is called
        // again before the first `payloadAccessor` call resolves.
        cached = payloadAccessor();
        return cached;
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $99aca15d9a40e265$var$shouldSendBody = (method)=>![
        "HEAD",
        "GET",
        "DELETE"
    ].includes(method.toUpperCase());
// TODO[AllanZhengYP]: we need to provide isCanceledError utility
const $99aca15d9a40e265$export$d2573baf35521e4c = async ({ url: url , method: method , headers: headers , body: body  }, { abortSignal: abortSignal , cache: cache , withCrossDomainCredentials: withCrossDomainCredentials  })=>{
    let resp;
    try {
        resp = await fetch(url, {
            method: method,
            headers: headers,
            body: $99aca15d9a40e265$var$shouldSendBody(method) ? body : undefined,
            signal: abortSignal,
            cache: cache,
            credentials: withCrossDomainCredentials ? "include" : "same-origin"
        });
    } catch (e) {
        if (e instanceof TypeError) throw new (0, $05b2dc7abeec3af3$export$37321a6dace1881c)({
            name: (0, $e4876bf018e81b36$export$4e712df6b850c8d0).NetworkError,
            message: "A network error has occurred.",
            underlyingError: e
        });
        throw e;
    }
    const responseHeaders = {};
    resp.headers?.forEach((value, key)=>{
        responseHeaders[key.toLowerCase()] = value;
    });
    const httpResponse = {
        statusCode: resp.status,
        headers: responseHeaders,
        body: null
    };
    // resp.body is a ReadableStream according to Fetch API spec, but React Native
    // does not implement it.
    const bodyWithMixin = Object.assign(resp.body ?? {}, {
        text: (0, $277c56c6bc847e76$export$580ad1ce15092b15)(()=>resp.text()),
        blob: (0, $277c56c6bc847e76$export$580ad1ce15092b15)(()=>resp.blob()),
        json: (0, $277c56c6bc847e76$export$580ad1ce15092b15)(()=>resp.json())
    });
    return {
        ...httpResponse,
        body: bodyWithMixin
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c35e4257eb1069ca$export$ed7e1ccf00f39c4a = (0, $e4148c4bd51790db$export$f074d76e52925468)((0, $99aca15d9a40e265$export$d2573baf35521e4c), [
    (0, $78db0a64bb1e3bda$export$ff28171a05413bc5),
    (0, $7930ce1b6e24c566$export$72f002d3da1a429f)
]);



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $68e475df1f6104a0$export$76041b1400befb8b = 300000;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private
 * Internal use of Amplify only
 */ function $24fc84ed0122c4cd$export$caea50bde345f648(maxDelayMs = (0, $68e475df1f6104a0$export$76041b1400befb8b)) {
    const BASE_TIME_MS = 100;
    const JITTER_FACTOR = 100;
    return (attempt)=>{
        const delay = 2 ** attempt * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: [v6] The separate retry utility is used by Data packages now and will replaced by retry middleware.
const $3d87caf0cda2471c$var$DEFAULT_MAX_DELAY_MS = 300000;
const $3d87caf0cda2471c$export$caea50bde345f648 = (attempt)=>{
    const delayFunction = (0, $24fc84ed0122c4cd$export$caea50bde345f648)($3d87caf0cda2471c$var$DEFAULT_MAX_DELAY_MS);
    const delay = delayFunction(attempt);
    // The delayFunction returns false when the delay is greater than the max delay(5 mins).
    // In this case, the retry middleware will delay 5 mins instead, as a ceiling of the delay.
    return delay === false ? $3d87caf0cda2471c$var$DEFAULT_MAX_DELAY_MS : delay;
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// via https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L8
const $541acb6b4e50c7ee$var$CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch",
    "BadRequestException"
];
/**
 * Given an error code, returns true if it is related to a clock skew error.
 *
 * @param errorCode String representation of some error.
 * @returns True if given error is present in `CLOCK_SKEW_ERROR_CODES`, false otherwise.
 *
 * @internal
 */ const $541acb6b4e50c7ee$export$7b87435661177a94 = (errorCode)=>!!errorCode && $541acb6b4e50c7ee$var$CLOCK_SKEW_ERROR_CODES.includes(errorCode);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get retry decider function
 * @param errorParser Function to load JavaScript error from HTTP response
 */ const $d6ccf8c3d159d43b$export$b919d98317a7685f = (errorParser)=>async (response, error)=>{
        const parsedError = error ?? await errorParser(response) ?? undefined;
        const errorCode = parsedError?.code || parsedError?.name;
        const statusCode = response?.statusCode;
        const isRetryable = $d6ccf8c3d159d43b$var$isConnectionError(error) || $d6ccf8c3d159d43b$var$isThrottlingError(statusCode, errorCode) || (0, $541acb6b4e50c7ee$export$7b87435661177a94)(errorCode) || $d6ccf8c3d159d43b$var$isServerSideError(statusCode, errorCode);
        return {
            retryable: isRetryable
        };
    };
// reference: https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L22-L37
const $d6ccf8c3d159d43b$var$THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException"
];
const $d6ccf8c3d159d43b$var$TIMEOUT_ERROR_CODES = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
const $d6ccf8c3d159d43b$var$isThrottlingError = (statusCode, errorCode)=>statusCode === 429 || !!errorCode && $d6ccf8c3d159d43b$var$THROTTLING_ERROR_CODES.includes(errorCode);
const $d6ccf8c3d159d43b$var$isConnectionError = (error)=>[
        (0, $e4876bf018e81b36$export$4e712df6b850c8d0).NetworkError,
        // TODO(vNext): unify the error code `ERR_NETWORK` used by the Storage XHR handler
        "ERR_NETWORK"
    ].includes(error?.name);
const $d6ccf8c3d159d43b$var$isServerSideError = (statusCode, errorCode)=>!!statusCode && [
        500,
        502,
        503,
        504
    ].includes(statusCode) || !!errorCode && $d6ccf8c3d159d43b$var$TIMEOUT_ERROR_CODES.includes(errorCode);




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3415b1d6f221136c$export$beb82d9d9136c16e = URL;
const $3415b1d6f221136c$export$4ea7bbdac595b5fb = URLSearchParams;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $3c92cd7927458afb$export$638889172ebce0c4;
(function(Framework) {
    // < 100 - Web frameworks
    Framework["WebUnknown"] = "0";
    Framework["React"] = "1";
    Framework["NextJs"] = "2";
    Framework["Angular"] = "3";
    Framework["VueJs"] = "4";
    Framework["Nuxt"] = "5";
    Framework["Svelte"] = "6";
    // 100s - Server side frameworks
    Framework["ServerSideUnknown"] = "100";
    Framework["ReactSSR"] = "101";
    Framework["NextJsSSR"] = "102";
    Framework["AngularSSR"] = "103";
    Framework["VueJsSSR"] = "104";
    Framework["NuxtSSR"] = "105";
    Framework["SvelteSSR"] = "106";
    // 200s - Mobile framework
    Framework["ReactNative"] = "201";
    Framework["Expo"] = "202";
})($3c92cd7927458afb$export$638889172ebce0c4 || ($3c92cd7927458afb$export$638889172ebce0c4 = {}));
var $3c92cd7927458afb$export$3a8840c5b2ecf003;
(function(Category) {
    Category["AI"] = "ai";
    Category["API"] = "api";
    Category["Auth"] = "auth";
    Category["Analytics"] = "analytics";
    Category["DataStore"] = "datastore";
    Category["Geo"] = "geo";
    Category["InAppMessaging"] = "inappmessaging";
    Category["Interactions"] = "interactions";
    Category["Predictions"] = "predictions";
    Category["PubSub"] = "pubsub";
    Category["PushNotification"] = "pushnotification";
    Category["Storage"] = "storage";
})($3c92cd7927458afb$export$3a8840c5b2ecf003 || ($3c92cd7927458afb$export$3a8840c5b2ecf003 = {}));
var $3c92cd7927458afb$export$89656a7f296a8665;
(function(AiAction) {
    AiAction["CreateConversation"] = "1";
    AiAction["GetConversation"] = "2";
    AiAction["ListConversations"] = "3";
    AiAction["DeleteConversation"] = "4";
    AiAction["SendMessage"] = "5";
    AiAction["ListMessages"] = "6";
    AiAction["OnMessage"] = "7";
    AiAction["Generation"] = "8";
    AiAction["UpdateConversation"] = "9";
})($3c92cd7927458afb$export$89656a7f296a8665 || ($3c92cd7927458afb$export$89656a7f296a8665 = {}));
var $3c92cd7927458afb$export$30c16f5c43437fd7;
(function(AnalyticsAction) {
    AnalyticsAction["Record"] = "1";
    AnalyticsAction["IdentifyUser"] = "2";
})($3c92cd7927458afb$export$30c16f5c43437fd7 || ($3c92cd7927458afb$export$30c16f5c43437fd7 = {}));
var $3c92cd7927458afb$export$126e20fdc0f0d34b;
(function(ApiAction) {
    ApiAction["GraphQl"] = "1";
    ApiAction["Get"] = "2";
    ApiAction["Post"] = "3";
    ApiAction["Put"] = "4";
    ApiAction["Patch"] = "5";
    ApiAction["Del"] = "6";
    ApiAction["Head"] = "7";
})($3c92cd7927458afb$export$126e20fdc0f0d34b || ($3c92cd7927458afb$export$126e20fdc0f0d34b = {}));
var $3c92cd7927458afb$export$900b1436d7e65f4;
(function(AuthAction) {
    AuthAction["SignUp"] = "1";
    AuthAction["ConfirmSignUp"] = "2";
    AuthAction["ResendSignUpCode"] = "3";
    AuthAction["SignIn"] = "4";
    AuthAction["FetchMFAPreference"] = "6";
    AuthAction["UpdateMFAPreference"] = "7";
    AuthAction["SetUpTOTP"] = "10";
    AuthAction["VerifyTOTPSetup"] = "11";
    AuthAction["ConfirmSignIn"] = "12";
    AuthAction["DeleteUserAttributes"] = "15";
    AuthAction["DeleteUser"] = "16";
    AuthAction["UpdateUserAttributes"] = "17";
    AuthAction["FetchUserAttributes"] = "18";
    AuthAction["ConfirmUserAttribute"] = "22";
    AuthAction["SignOut"] = "26";
    AuthAction["UpdatePassword"] = "27";
    AuthAction["ResetPassword"] = "28";
    AuthAction["ConfirmResetPassword"] = "29";
    AuthAction["FederatedSignIn"] = "30";
    AuthAction["RememberDevice"] = "32";
    AuthAction["ForgetDevice"] = "33";
    AuthAction["FetchDevices"] = "34";
    AuthAction["SendUserAttributeVerificationCode"] = "35";
    AuthAction["SignInWithRedirect"] = "36";
    AuthAction["StartWebAuthnRegistration"] = "37";
    AuthAction["CompleteWebAuthnRegistration"] = "38";
    AuthAction["ListWebAuthnCredentials"] = "39";
    AuthAction["DeleteWebAuthnCredential"] = "40";
})($3c92cd7927458afb$export$900b1436d7e65f4 || ($3c92cd7927458afb$export$900b1436d7e65f4 = {}));
var $3c92cd7927458afb$export$2f5a715aba4cde93;
(function(DataStoreAction) {
    DataStoreAction["Subscribe"] = "1";
    DataStoreAction["GraphQl"] = "2";
})($3c92cd7927458afb$export$2f5a715aba4cde93 || ($3c92cd7927458afb$export$2f5a715aba4cde93 = {}));
var $3c92cd7927458afb$export$afafab3eb8fc6fef;
(function(GeoAction) {
    GeoAction["SearchByText"] = "0";
    GeoAction["SearchByCoordinates"] = "1";
    GeoAction["SearchForSuggestions"] = "2";
    GeoAction["SearchByPlaceId"] = "3";
    GeoAction["SaveGeofences"] = "4";
    GeoAction["GetGeofence"] = "5";
    GeoAction["ListGeofences"] = "6";
    GeoAction["DeleteGeofences"] = "7";
})($3c92cd7927458afb$export$afafab3eb8fc6fef || ($3c92cd7927458afb$export$afafab3eb8fc6fef = {}));
var $3c92cd7927458afb$export$c01a8c16ffda791e;
(function(InAppMessagingAction) {
    InAppMessagingAction["SyncMessages"] = "1";
    InAppMessagingAction["IdentifyUser"] = "2";
    InAppMessagingAction["NotifyMessageInteraction"] = "3";
})($3c92cd7927458afb$export$c01a8c16ffda791e || ($3c92cd7927458afb$export$c01a8c16ffda791e = {}));
var $3c92cd7927458afb$export$68e0695a774ab7fa;
(function(InteractionsAction) {
    InteractionsAction["None"] = "0";
})($3c92cd7927458afb$export$68e0695a774ab7fa || ($3c92cd7927458afb$export$68e0695a774ab7fa = {}));
var $3c92cd7927458afb$export$aa89b4c447a07cee;
(function(PredictionsAction) {
    PredictionsAction["Convert"] = "1";
    PredictionsAction["Identify"] = "2";
    PredictionsAction["Interpret"] = "3";
})($3c92cd7927458afb$export$aa89b4c447a07cee || ($3c92cd7927458afb$export$aa89b4c447a07cee = {}));
var $3c92cd7927458afb$export$ade48b30f1e78672;
(function(PubSubAction) {
    PubSubAction["Subscribe"] = "1";
})($3c92cd7927458afb$export$ade48b30f1e78672 || ($3c92cd7927458afb$export$ade48b30f1e78672 = {}));
var $3c92cd7927458afb$export$2c5ee06ab9fa5040;
(function(PushNotificationAction) {
    PushNotificationAction["InitializePushNotifications"] = "1";
    PushNotificationAction["IdentifyUser"] = "2";
})($3c92cd7927458afb$export$2c5ee06ab9fa5040 || ($3c92cd7927458afb$export$2c5ee06ab9fa5040 = {}));
var $3c92cd7927458afb$export$d4f3c54b808b00ce;
(function(StorageAction) {
    StorageAction["UploadData"] = "1";
    StorageAction["DownloadData"] = "2";
    StorageAction["List"] = "3";
    StorageAction["Copy"] = "4";
    StorageAction["Remove"] = "5";
    StorageAction["GetProperties"] = "6";
    StorageAction["GetUrl"] = "7";
    StorageAction["GetDataAccess"] = "8";
    StorageAction["ListCallerAccessGrants"] = "9";
})($3c92cd7927458afb$export$d4f3c54b808b00ce || ($3c92cd7927458afb$export$d4f3c54b808b00ce = {}));


// generated by genversion
const $6283134e3d15f982$export$83d89fbfd8236492 = "6.11.0";




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $bcd50ea5d1d053e5$export$a15eed0e463030a9 = ()=>{
    return typeof $parcel$global !== "undefined";
};
const $bcd50ea5d1d053e5$export$a5e7eb32e5221222 = ()=>{
    return typeof globalThis !== "undefined";
};
const $bcd50ea5d1d053e5$export$daba2802a1a41c1f = ()=>{
    return typeof window !== "undefined";
};
const $bcd50ea5d1d053e5$export$b949ebcb877faa59 = ()=>{
    return typeof document !== "undefined";
};
const $bcd50ea5d1d053e5$export$ba10401363d0f7f6 = ()=>{
    return typeof $4acf49f6c3e67aec$exports !== "undefined";
};
const $bcd50ea5d1d053e5$export$252f88727cff70c7 = (object, prefix)=>{
    return !!Object.keys(object).find((key)=>key.startsWith(prefix));
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react 18.2 - built using Vite
function $f76ed8322b6112f5$export$ba3f37c54f0f7805() {
    const elementKeyPrefixedWithReact = (key)=>{
        return key.startsWith("_react") || key.startsWith("__react");
    };
    const elementIsReactEnabled = (element)=>{
        return Object.keys(element).find(elementKeyPrefixedWithReact);
    };
    const allElementsWithId = ()=>Array.from(document.querySelectorAll("[id]"));
    return (0, $bcd50ea5d1d053e5$export$b949ebcb877faa59)() && allElementsWithId().some(elementIsReactEnabled);
}
function $f76ed8322b6112f5$export$86269c582305790() {
    return (0, $bcd50ea5d1d053e5$export$ba10401363d0f7f6)() && typeof $4acf49f6c3e67aec$exports.env !== "undefined" && !!Object.keys($4acf49f6c3e67aec$exports.env).find((key)=>key.includes("react"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with vue 3.3.2
function $98a2a6d8e59bc551$export$d91d90d62b78936d() {
    return (0, $bcd50ea5d1d053e5$export$daba2802a1a41c1f)() && (0, $bcd50ea5d1d053e5$export$252f88727cff70c7)(window, "__VUE");
}
function $98a2a6d8e59bc551$export$257a4c0f8294a101() {
    return (0, $bcd50ea5d1d053e5$export$a15eed0e463030a9)() && (0, $bcd50ea5d1d053e5$export$252f88727cff70c7)($parcel$global, "__VUE");
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with svelte 3.59
function $33fe5b712fd6ea7f$export$6dafc32a94edaed3() {
    return (0, $bcd50ea5d1d053e5$export$daba2802a1a41c1f)() && (0, $bcd50ea5d1d053e5$export$252f88727cff70c7)(window, "__SVELTE");
}
function $33fe5b712fd6ea7f$export$819dcb7fe144d8b0() {
    return (0, $bcd50ea5d1d053e5$export$ba10401363d0f7f6)() && typeof $4acf49f6c3e67aec$exports.env !== "undefined" && !!Object.keys($4acf49f6c3e67aec$exports.env).find((key)=>key.includes("svelte"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with next 13.4 / react 18.2
function $e0ec3dcfa395bd6f$export$f8462bcf03110eff() {
    return (0, $bcd50ea5d1d053e5$export$daba2802a1a41c1f)() && window.next && typeof window.next === "object";
}
function $e0ec3dcfa395bd6f$export$61c08ed144a5d4ca() {
    return (0, $bcd50ea5d1d053e5$export$a15eed0e463030a9)() && ((0, $bcd50ea5d1d053e5$export$252f88727cff70c7)($parcel$global, "__next") || (0, $bcd50ea5d1d053e5$export$252f88727cff70c7)($parcel$global, "__NEXT"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with nuxt 2.15 / vue 2.7
function $77c2761ae348e7c6$export$bed54a4e6d9d25fb() {
    return (0, $bcd50ea5d1d053e5$export$daba2802a1a41c1f)() && (window.__NUXT__ !== undefined || window.$nuxt !== undefined);
}
function $77c2761ae348e7c6$export$fb3ce982948d27e8() {
    return (0, $bcd50ea5d1d053e5$export$a15eed0e463030a9)() && typeof $parcel$global.__NUXT_PATHS__ !== "undefined";
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with @angular/core 16.0.0
function $eb8dc834355ce742$export$b5a20bd39eb02ba0() {
    const angularVersionSetInDocument = Boolean((0, $bcd50ea5d1d053e5$export$b949ebcb877faa59)() && document.querySelector("[ng-version]"));
    const angularContentSetInWindow = Boolean((0, $bcd50ea5d1d053e5$export$daba2802a1a41c1f)() && typeof window.ng !== "undefined");
    return angularVersionSetInDocument || angularContentSetInWindow;
}
function $eb8dc834355ce742$export$8ab518c8987c870f() {
    return (0, $bcd50ea5d1d053e5$export$ba10401363d0f7f6)() && typeof $4acf49f6c3e67aec$exports.env === "object" && undefined?.startsWith("ng ") || false;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react-native 0.17.7
function $aa4d36e220d6a82b$export$1c8414c1859e3748() {
    return typeof navigator !== "undefined" && typeof navigator.product !== "undefined" && navigator.product === "ReactNative";
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with expo 48 / react-native 0.71.3
function $d142b08e8972a60f$export$85fd46d5e29a4f7e() {
    return (0, $bcd50ea5d1d053e5$export$a15eed0e463030a9)() && typeof $parcel$global.expo !== "undefined";
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $e3843c4666559957$export$41b1270b988065fb() {
    return (0, $bcd50ea5d1d053e5$export$daba2802a1a41c1f)();
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// These are in the order of detection where when both are detectable, the early Framework will be reported
const $ff29f6127d654378$var$detectionMap = [
    // First, detect mobile
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).Expo,
        detectionMethod: (0, $d142b08e8972a60f$export$85fd46d5e29a4f7e)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).ReactNative,
        detectionMethod: (0, $aa4d36e220d6a82b$export$1c8414c1859e3748)
    },
    // Next, detect web frameworks
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).NextJs,
        detectionMethod: (0, $e0ec3dcfa395bd6f$export$f8462bcf03110eff)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).Nuxt,
        detectionMethod: (0, $77c2761ae348e7c6$export$bed54a4e6d9d25fb)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).Angular,
        detectionMethod: (0, $eb8dc834355ce742$export$b5a20bd39eb02ba0)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).React,
        detectionMethod: (0, $f76ed8322b6112f5$export$ba3f37c54f0f7805)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).VueJs,
        detectionMethod: (0, $98a2a6d8e59bc551$export$d91d90d62b78936d)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).Svelte,
        detectionMethod: (0, $33fe5b712fd6ea7f$export$6dafc32a94edaed3)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).WebUnknown,
        detectionMethod: (0, $e3843c4666559957$export$41b1270b988065fb)
    },
    // Last, detect ssr frameworks
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).NextJsSSR,
        detectionMethod: (0, $e0ec3dcfa395bd6f$export$61c08ed144a5d4ca)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).NuxtSSR,
        detectionMethod: (0, $77c2761ae348e7c6$export$fb3ce982948d27e8)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).ReactSSR,
        detectionMethod: (0, $f76ed8322b6112f5$export$86269c582305790)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).VueJsSSR,
        detectionMethod: (0, $98a2a6d8e59bc551$export$257a4c0f8294a101)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).AngularSSR,
        detectionMethod: (0, $eb8dc834355ce742$export$8ab518c8987c870f)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).SvelteSSR,
        detectionMethod: (0, $33fe5b712fd6ea7f$export$819dcb7fe144d8b0)
    }
];
function $ff29f6127d654378$export$17b446b869dad473() {
    return $ff29f6127d654378$var$detectionMap.find((detectionEntry)=>detectionEntry.detectionMethod())?.platform || (0, $3c92cd7927458afb$export$638889172ebce0c4).ServerSideUnknown;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// We want to cache detection since the framework won't change
let $ab1822ffbc37c551$var$frameworkCache;
const $ab1822ffbc37c551$export$d56891f33aa26edc = [];
// Setup the detection reset tracking / timeout delays
let $ab1822ffbc37c551$var$resetTriggered = false;
const $ab1822ffbc37c551$var$SSR_RESET_TIMEOUT = 10; // ms
const $ab1822ffbc37c551$var$WEB_RESET_TIMEOUT = 10; // ms
const $ab1822ffbc37c551$var$PRIME_FRAMEWORK_DELAY = 1000; // ms
const $ab1822ffbc37c551$export$9ce73e459ec93b6a = ()=>{
    if (!$ab1822ffbc37c551$var$frameworkCache) {
        $ab1822ffbc37c551$var$frameworkCache = (0, $ff29f6127d654378$export$17b446b869dad473)();
        if ($ab1822ffbc37c551$var$resetTriggered) // The final run of detectFramework:
        // Starting from this point, the `frameworkCache` becomes "final".
        // So we don't need to notify the observers again so the observer
        // can be removed after the final notice.
        while($ab1822ffbc37c551$export$d56891f33aa26edc.length)$ab1822ffbc37c551$export$d56891f33aa26edc.pop()?.();
        else // The first run of detectFramework:
        // Every time we update the cache, call each observer function
        $ab1822ffbc37c551$export$d56891f33aa26edc.forEach((fcn)=>{
            fcn();
        });
        // Retry once for either Unknown type after a delay (explained below)
        $ab1822ffbc37c551$var$resetTimeout((0, $3c92cd7927458afb$export$638889172ebce0c4).ServerSideUnknown, $ab1822ffbc37c551$var$SSR_RESET_TIMEOUT);
        $ab1822ffbc37c551$var$resetTimeout((0, $3c92cd7927458afb$export$638889172ebce0c4).WebUnknown, $ab1822ffbc37c551$var$WEB_RESET_TIMEOUT);
    }
    return $ab1822ffbc37c551$var$frameworkCache;
};
/**
 * @internal Setup observer callback that will be called everytime the framework changes
 */ const $ab1822ffbc37c551$export$5d5c467ce0b213f = (fcn)=>{
    // When the `frameworkCache` won't be updated again, we ignore all incoming
    // observers.
    if ($ab1822ffbc37c551$var$resetTriggered) return;
    $ab1822ffbc37c551$export$d56891f33aa26edc.push(fcn);
};
function $ab1822ffbc37c551$export$d2adf65b87e47523() {
    $ab1822ffbc37c551$var$frameworkCache = undefined;
}
// For a framework type and a delay amount, setup the event to re-detect
//   During the runtime boot, it is possible that framework detection will
//   be triggered before the framework has made modifications to the
//   global/window/etc needed for detection. When no framework is detected
//   we will reset and try again to ensure we don't use a cached
//   non-framework detection result for all requests.
function $ab1822ffbc37c551$var$resetTimeout(framework, delay) {
    if ($ab1822ffbc37c551$var$frameworkCache === framework && !$ab1822ffbc37c551$var$resetTriggered) setTimeout(()=>{
        $ab1822ffbc37c551$export$d2adf65b87e47523();
        $ab1822ffbc37c551$var$resetTriggered = true;
        setTimeout($ab1822ffbc37c551$export$9ce73e459ec93b6a, $ab1822ffbc37c551$var$PRIME_FRAMEWORK_DELAY);
    }, delay);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Maintains custom user-agent state set by external consumers.
const $180c43f7f36cc759$var$customUserAgentState = {};
/**
 * Sets custom user agent state which will be appended to applicable requests. Returns a function that can be used to
 * clean up any custom state set with this API.
 *
 * @note
 * This API operates globally. Calling this API multiple times will result in the most recently set values for a
 * particular API being used.
 *
 * @note
 * This utility IS NOT compatible with SSR.
 *
 * @param input - SetCustomUserAgentInput that defines custom state to apply to the specified APIs.
 */ const $180c43f7f36cc759$export$20cd2fa9001e90da = (input)=>{
    // Save custom user-agent state & increment reference counter
    // TODO Remove `any` when we upgrade to TypeScript 5.2, see: https://github.com/microsoft/TypeScript/issues/44373
    $180c43f7f36cc759$var$customUserAgentState[input.category] = input.apis.reduce((acc, api)=>({
            ...acc,
            [api]: {
                refCount: acc[api]?.refCount ? acc[api].refCount + 1 : 1,
                additionalDetails: input.additionalDetails
            }
        }), $180c43f7f36cc759$var$customUserAgentState[input.category] ?? {});
    // Callback that cleans up state for APIs recorded by this call
    let cleanUpCallbackCalled = false;
    const cleanUpCallback = ()=>{
        // Only allow the cleanup callback to be called once
        if (cleanUpCallbackCalled) return;
        cleanUpCallbackCalled = true;
        input.apis.forEach((api)=>{
            const apiRefCount = $180c43f7f36cc759$var$customUserAgentState[input.category][api].refCount;
            if (apiRefCount > 1) $180c43f7f36cc759$var$customUserAgentState[input.category][api].refCount = apiRefCount - 1;
            else {
                delete $180c43f7f36cc759$var$customUserAgentState[input.category][api];
                // Clean up category if no more APIs set
                if (!Object.keys($180c43f7f36cc759$var$customUserAgentState[input.category]).length) delete $180c43f7f36cc759$var$customUserAgentState[input.category];
            }
        });
    };
    return cleanUpCallback;
};
const $180c43f7f36cc759$export$e399dbcfd99a2928 = (category, api)=>$180c43f7f36cc759$var$customUserAgentState[category]?.[api]?.additionalDetails;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $94d73b8725ccf9a9$var$BASE_USER_AGENT = `aws-amplify`;
/** Sanitize Amplify version string be removing special character + and character post the special character  */ const $94d73b8725ccf9a9$export$b8f78c57ec316f83 = (amplifyVersion)=>amplifyVersion.replace(/\+.*/, "");
class $94d73b8725ccf9a9$var$PlatformBuilder {
    constructor(){
        this.userAgent = `${$94d73b8725ccf9a9$var$BASE_USER_AGENT}/${$94d73b8725ccf9a9$export$b8f78c57ec316f83((0, $6283134e3d15f982$export$83d89fbfd8236492))}`;
    }
    get framework() {
        return (0, $ab1822ffbc37c551$export$9ce73e459ec93b6a)();
    }
    get isReactNative() {
        return this.framework === (0, $3c92cd7927458afb$export$638889172ebce0c4).ReactNative || this.framework === (0, $3c92cd7927458afb$export$638889172ebce0c4).Expo;
    }
    observeFrameworkChanges(fcn) {
        (0, $ab1822ffbc37c551$export$5d5c467ce0b213f)(fcn);
    }
}
const $94d73b8725ccf9a9$export$2dffd0b5373a4389 = new $94d73b8725ccf9a9$var$PlatformBuilder();
const $94d73b8725ccf9a9$export$7d201307d8979e21 = ({ category: category , action: action  } = {})=>{
    const userAgent = [
        [
            $94d73b8725ccf9a9$var$BASE_USER_AGENT,
            $94d73b8725ccf9a9$export$b8f78c57ec316f83((0, $6283134e3d15f982$export$83d89fbfd8236492))
        ]
    ];
    if (category) userAgent.push([
        category,
        action
    ]);
    userAgent.push([
        "framework",
        (0, $ab1822ffbc37c551$export$9ce73e459ec93b6a)()
    ]);
    if (category && action) {
        const customState = (0, $180c43f7f36cc759$export$e399dbcfd99a2928)(category, action);
        if (customState) customState.forEach((state)=>{
            userAgent.push(state);
        });
    }
    return userAgent;
};
const $94d73b8725ccf9a9$export$ede38edb26c0bfdf = (customUserAgentDetails)=>{
    const userAgent = $94d73b8725ccf9a9$export$7d201307d8979e21(customUserAgentDetails);
    const userAgentString = userAgent.map(([agentKey, agentValue])=>agentKey && agentValue ? `${agentKey}/${agentValue}` : agentKey).join(" ");
    return userAgentString;
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $ed2c57ee51bb104b$var$SERVICE_NAME = "cognito-identity";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ const $ed2c57ee51bb104b$var$endpointResolver = ({ region: region  })=>({
        url: new (0, $3415b1d6f221136c$export$beb82d9d9136c16e)(`https://cognito-identity.${region}.${(0, $83f0685006e72a3c$export$1c28e37cdcc37f6d)(region)}`)
    });
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $ed2c57ee51bb104b$var$disableCacheMiddlewareFactory = ()=>(next)=>async function disableCacheMiddleware(request) {
            request.headers["cache-control"] = "no-store";
            return next(request);
        };
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $ed2c57ee51bb104b$export$8029646671d2c482 = (0, $e4148c4bd51790db$export$f074d76e52925468)((0, $c35e4257eb1069ca$export$ed7e1ccf00f39c4a), [
    $ed2c57ee51bb104b$var$disableCacheMiddlewareFactory
]);
/**
 * @internal
 */ const $ed2c57ee51bb104b$export$f84bd70098573c5c = {
    service: $ed2c57ee51bb104b$var$SERVICE_NAME,
    endpointResolver: $ed2c57ee51bb104b$var$endpointResolver,
    retryDecider: (0, $d6ccf8c3d159d43b$export$b919d98317a7685f)((0, $209f6e497b3a00cd$export$be467dfcc0538e25)),
    computeDelay: (0, $3d87caf0cda2471c$export$caea50bde345f648),
    userAgentValue: (0, $94d73b8725ccf9a9$export$ede38edb26c0bfdf)(),
    cache: "no-store"
};
(0, $ab1822ffbc37c551$export$5d5c467ce0b213f)(()=>{
    $ed2c57ee51bb104b$export$f84bd70098573c5c.userAgentValue = (0, $94d73b8725ccf9a9$export$ede38edb26c0bfdf)();
});
/**
 * @internal
 */ const $ed2c57ee51bb104b$export$a46bbeaba09f7285 = (operation)=>({
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `AWSCognitoIdentityService.${operation}`
    });
/**
 * @internal
 */ const $ed2c57ee51bb104b$export$a692bdb7eb624f96 = ({ url: url  }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    });


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $edb2ac2ae5c1ecb4$var$getCredentialsForIdentitySerializer = (input, endpoint)=>{
    const headers = (0, $ed2c57ee51bb104b$export$a46bbeaba09f7285)("GetCredentialsForIdentity");
    const body = JSON.stringify(input);
    return (0, $ed2c57ee51bb104b$export$a692bdb7eb624f96)(endpoint, headers, body);
};
const $edb2ac2ae5c1ecb4$var$getCredentialsForIdentityDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $209f6e497b3a00cd$export$be467dfcc0538e25)(response);
        throw error;
    } else {
        const body = await (0, $209f6e497b3a00cd$export$759bcb35b0d1bf81)(response);
        return {
            IdentityId: body.IdentityId,
            Credentials: $edb2ac2ae5c1ecb4$var$deserializeCredentials(body.Credentials),
            $metadata: (0, $706f3dc369998648$export$978f9418fe0cb26c)(response)
        };
    }
};
const $edb2ac2ae5c1ecb4$var$deserializeCredentials = ({ AccessKeyId: AccessKeyId , SecretKey: SecretKey , SessionToken: SessionToken , Expiration: Expiration  } = {})=>{
    return {
        AccessKeyId: AccessKeyId,
        SecretKey: SecretKey,
        SessionToken: SessionToken,
        Expiration: Expiration && new Date(Expiration * 1000)
    };
};
/**
 * @internal
 */ const $edb2ac2ae5c1ecb4$export$a49c1c173ab96b58 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $ed2c57ee51bb104b$export$8029646671d2c482), $edb2ac2ae5c1ecb4$var$getCredentialsForIdentitySerializer, $edb2ac2ae5c1ecb4$var$getCredentialsForIdentityDeserializer, (0, $ed2c57ee51bb104b$export$f84bd70098573c5c));





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $e76389a51923234d$export$5f7eb9761ac2d0d9(userPoolId) {
    const region = userPoolId?.split("_")[0];
    if (!userPoolId || userPoolId.indexOf("_") < 0 || !region || typeof region !== "string") throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: "InvalidUserPoolId",
        message: "Invalid user pool id provided."
    });
    return region;
}
function $e76389a51923234d$export$8fb32fba519c460(identityPoolId) {
    if (!identityPoolId || !identityPoolId.includes(":")) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: "InvalidIdentityPoolIdException",
        message: "Invalid identity pool id provided.",
        recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    });
    return identityPoolId.split(":")[0];
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $d78d124ef376faa5$export$d29d1996d6b6f5e3 = "UserUnAuthenticatedException";
const $d78d124ef376faa5$export$bdd0e7e9babcd5c8 = "UserAlreadyAuthenticatedException";
const $d78d124ef376faa5$export$740e7000ac27ebf3 = "DeviceMetadataNotFoundException";
const $d78d124ef376faa5$export$fe46a12932d2550a = "AutoSignInException";
const $d78d124ef376faa5$export$36f9d08d6bc647dd = "InvalidRedirectException";
const $d78d124ef376faa5$export$a2095d473f418f40 = "InvalidAppSchemeException";
const $d78d124ef376faa5$export$818bb4aeac915442 = "InvalidPreferredRedirectUrlException";
const $d78d124ef376faa5$export$60b68b138a52e5ae = new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
    name: $d78d124ef376faa5$export$36f9d08d6bc647dd,
    message: "signInRedirect or signOutRedirect had an invalid format or was not found.",
    recoverySuggestion: "Please make sure the signIn/Out redirect in your oauth config is valid."
});
const $d78d124ef376faa5$export$c1829c2a0b9b2e21 = new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
    name: $d78d124ef376faa5$export$a2095d473f418f40,
    message: "A valid non-http app scheme was not found in the config.",
    recoverySuggestion: "Please make sure a valid custom app scheme is present in the config."
});
const $d78d124ef376faa5$export$41a56a70fc1a4962 = new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
    name: $d78d124ef376faa5$export$818bb4aeac915442,
    message: "The given preferredRedirectUrl does not match any items in the redirectSignOutUrls array from the config.",
    recoverySuggestion: "Please make sure a matching preferredRedirectUrl is provided."
});
const $d78d124ef376faa5$export$27ddc47447101bcf = "InvalidOriginException";
const $d78d124ef376faa5$export$c01b4acd6291e035 = new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
    name: $d78d124ef376faa5$export$27ddc47447101bcf,
    message: "redirect is coming from a different origin. The oauth flow needs to be initiated from the same origin",
    recoverySuggestion: "Please call signInWithRedirect from the same origin."
});
const $d78d124ef376faa5$export$625255707e22459c = "OAuthSignOutException";
const $d78d124ef376faa5$export$a0a904daf48e2c33 = "TokenRefreshException";
const $d78d124ef376faa5$export$606cffc85964c24b = "UnexpectedSignInInterruptionException";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $45fe96cf99d947f4$export$d76f9f8544dc304d(authConfig) {
    if (authConfig && authConfig.Cognito.userPoolId && authConfig.Cognito.userPoolClientId) return true;
    return false;
}
function $45fe96cf99d947f4$export$77712ea5882cac9f(tokens) {
    if (!tokens || !tokens.accessToken) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: (0, $d78d124ef376faa5$export$d29d1996d6b6f5e3),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
function $45fe96cf99d947f4$export$f4d99632f0717a4b(tokens) {
    if (!tokens || !tokens.idToken) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: (0, $d78d124ef376faa5$export$d29d1996d6b6f5e3),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
const $45fe96cf99d947f4$export$31fce2aaeafa4b60 = new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
    name: (0, $d78d124ef376faa5$export$a0a904daf48e2c33),
    message: `Token refresh is not supported when authenticated with the 'implicit grant' (token) oauth flow. 
	Please change your oauth configuration to use 'code grant' flow.`,
    recoverySuggestion: `Please logout and change your Amplify configuration to use "code grant" flow. 
	E.g { responseType: 'code' }`
});
const $45fe96cf99d947f4$export$35cfa8cbd2d5bcdd = new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
    name: (0, $d78d124ef376faa5$export$d29d1996d6b6f5e3),
    message: "User needs to be authenticated to call this API.",
    recoverySuggestion: "Sign in before calling this API again."
});
function $45fe96cf99d947f4$export$be38b2d22222d505(tokens) {
    if ($45fe96cf99d947f4$var$isAuthenticatedWithImplicitOauthFlow(tokens)) throw $45fe96cf99d947f4$export$31fce2aaeafa4b60;
    if (!$45fe96cf99d947f4$var$isAuthenticatedWithRefreshToken(tokens)) throw $45fe96cf99d947f4$export$35cfa8cbd2d5bcdd;
}
function $45fe96cf99d947f4$export$b6f03be79626ab0f(deviceMetadata) {
    if (!deviceMetadata || !deviceMetadata.deviceKey || !deviceMetadata.deviceGroupKey || !deviceMetadata.randomPassword) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: (0, $d78d124ef376faa5$export$740e7000ac27ebf3),
        message: "Either deviceKey, deviceGroupKey or secretPassword were not found during the sign-in process.",
        recoverySuggestion: "Make sure to not clear storage after calling the signIn API."
    });
}
const $45fe96cf99d947f4$export$3820b4ff343394ea = {
    inflightOAuth: "inflightOAuth",
    oauthSignIn: "oauthSignIn",
    oauthPKCE: "oauthPKCE",
    oauthState: "oauthState"
};
function $45fe96cf99d947f4$var$isAuthenticated(tokens) {
    return tokens?.accessToken || tokens?.idToken;
}
function $45fe96cf99d947f4$var$isAuthenticatedWithRefreshToken(tokens) {
    return $45fe96cf99d947f4$var$isAuthenticated(tokens) && tokens?.refreshToken;
}
function $45fe96cf99d947f4$var$isAuthenticatedWithImplicitOauthFlow(tokens) {
    return $45fe96cf99d947f4$var$isAuthenticated(tokens) && !tokens?.refreshToken;
}












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a249ed39c095f0d6$var$getIdSerializer = (input, endpoint)=>{
    const headers = (0, $ed2c57ee51bb104b$export$a46bbeaba09f7285)("GetId");
    const body = JSON.stringify(input);
    return (0, $ed2c57ee51bb104b$export$a692bdb7eb624f96)(endpoint, headers, body);
};
const $a249ed39c095f0d6$var$getIdDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $209f6e497b3a00cd$export$be467dfcc0538e25)(response);
        throw error;
    } else {
        const body = await (0, $209f6e497b3a00cd$export$759bcb35b0d1bf81)(response);
        return {
            IdentityId: body.IdentityId,
            $metadata: (0, $706f3dc369998648$export$978f9418fe0cb26c)(response)
        };
    }
};
/**
 * @internal
 */ const $a249ed39c095f0d6$export$218c8c3169c024d2 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $ed2c57ee51bb104b$export$8029646671d2c482), $a249ed39c095f0d6$var$getIdSerializer, $a249ed39c095f0d6$var$getIdDeserializer, (0, $ed2c57ee51bb104b$export$f84bd70098573c5c));






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $4b5a2b344a373c19$export$edfb13e85a2c0dc4(idToken) {
    const issuer = (0, $d0b404dc65adc192$export$9a62e6c0a30e00bc)(idToken).payload.iss;
    const res = {};
    if (!issuer) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: "InvalidIdTokenException",
        message: "Invalid Idtoken."
    });
    const domainName = issuer.replace(/(^\w+:|^)\/\//, "");
    res[domainName] = idToken;
    return res;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2aa3236ba3e3e288$var$logger = new (0, $cda4d9e419200573$export$ba6a9c7ac8291f7f)("CognitoIdentityIdProvider");
/**
 * Provides a Cognito identityId
 *
 * @param tokens - The AuthTokens received after SignIn
 * @returns string
 * @throws configuration exceptions: `InvalidIdentityPoolIdException`
 *  - Auth errors that may arise from misconfiguration.
 * @throws service exceptions: {@link GetIdException }
 */ async function $2aa3236ba3e3e288$export$7c3e576630d5e301({ tokens: tokens , authConfig: authConfig , identityIdStore: identityIdStore  }) {
    identityIdStore.setAuthConfig({
        Cognito: authConfig
    });
    // will return null only if there is no identityId cached or if there is an error retrieving it
    let identityId = await identityIdStore.loadIdentityId();
    // Tokens are available so return primary identityId
    if (tokens) {
        // If there is existing primary identityId in-memory return that
        if (identityId && identityId.type === "primary") return identityId.id;
        else {
            const logins = tokens.idToken ? (0, $4b5a2b344a373c19$export$edfb13e85a2c0dc4)(tokens.idToken.toString()) : {};
            const generatedIdentityId = await $2aa3236ba3e3e288$var$generateIdentityId(logins, authConfig);
            if (identityId && identityId.id === generatedIdentityId) $2aa3236ba3e3e288$var$logger.debug(`The guest identity ${identityId.id} has become the primary identity.`);
            identityId = {
                id: generatedIdentityId,
                type: "primary"
            };
        }
    } else {
        // If there is existing guest identityId cached return that
        if (identityId && identityId.type === "guest") return identityId.id;
        else identityId = {
            id: await $2aa3236ba3e3e288$var$generateIdentityId({}, authConfig),
            type: "guest"
        };
    }
    // Store in-memory or local storage depending on guest or primary identityId
    identityIdStore.storeIdentityId(identityId);
    return identityId.id;
}
async function $2aa3236ba3e3e288$var$generateIdentityId(logins, authConfig) {
    const identityPoolId = authConfig?.identityPoolId;
    const region = (0, $e76389a51923234d$export$8fb32fba519c460)(identityPoolId);
    // IdentityId is absent so get it using IdentityPoolId with Cognito's GetId API
    const idResult = // for a first-time user, this will return a brand new identity
    // for a returning user, this will retrieve the previous identity assocaited with the logins
    (await (0, $a249ed39c095f0d6$export$218c8c3169c024d2)({
        region: region
    }, {
        IdentityPoolId: identityPoolId,
        Logins: logins
    })).IdentityId;
    if (!idResult) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: "GetIdResponseException",
        message: "Received undefined response from getId operation",
        recoverySuggestion: "Make sure to pass a valid identityPoolId in the configuration."
    });
    return idResult;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $944bc1f68a1ebd42$var$logger = new (0, $cda4d9e419200573$export$ba6a9c7ac8291f7f)("CognitoCredentialsProvider");
const $944bc1f68a1ebd42$var$CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
class $944bc1f68a1ebd42$export$be6550e37264dc26 {
    constructor(identityIdStore){
        this._nextCredentialsRefresh = 0;
        this._identityIdStore = identityIdStore;
    }
    async clearCredentialsAndIdentityId() {
        $944bc1f68a1ebd42$var$logger.debug("Clearing out credentials and identityId");
        this._credentialsAndIdentityId = undefined;
        await this._identityIdStore.clearIdentityId();
    }
    async clearCredentials() {
        $944bc1f68a1ebd42$var$logger.debug("Clearing out in-memory credentials");
        this._credentialsAndIdentityId = undefined;
    }
    async getCredentialsAndIdentityId(getCredentialsOptions) {
        const isAuthenticated = getCredentialsOptions.authenticated;
        const { tokens: tokens  } = getCredentialsOptions;
        const { authConfig: authConfig  } = getCredentialsOptions;
        try {
            (0, $d0b404dc65adc192$export$8a2f5318ea3215e3)(authConfig?.Cognito);
        } catch  {
            // No identity pool configured, skipping
            return;
        }
        if (!isAuthenticated && !authConfig.Cognito.allowGuestAccess) // TODO(V6): return partial result like Native platforms
        return;
        const { forceRefresh: forceRefresh  } = getCredentialsOptions;
        const tokenHasChanged = this.hasTokenChanged(tokens);
        const identityId = await (0, $2aa3236ba3e3e288$export$7c3e576630d5e301)({
            tokens: tokens,
            authConfig: authConfig.Cognito,
            identityIdStore: this._identityIdStore
        });
        // Clear cached credentials when forceRefresh is true OR the cache token has changed
        if (forceRefresh || tokenHasChanged) this.clearCredentials();
        if (!isAuthenticated) return this.getGuestCredentials(identityId, authConfig.Cognito);
        else {
            (0, $45fe96cf99d947f4$export$f4d99632f0717a4b)(tokens);
            return this.credsForOIDCTokens(authConfig.Cognito, tokens, identityId);
        }
    }
    async getGuestCredentials(identityId, authConfig) {
        // Return existing in-memory cached credentials only if it exists, is not past it's lifetime and is unauthenticated credentials
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === false) {
            $944bc1f68a1ebd42$var$logger.info("returning stored credentials as they neither past TTL nor expired.");
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any authenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const region = (0, $e76389a51923234d$export$8fb32fba519c460)(authConfig.identityPoolId);
        // use identityId to obtain guest credentials
        // save credentials in-memory
        // No logins params should be passed for guest creds:
        // https://docs.aws.amazon.com/cognitoidentity/latest/APIReference/API_GetCredentialsForIdentity.html
        const clientResult = await (0, $edb2ac2ae5c1ecb4$export$a49c1c173ab96b58)({
            region: region
        }, {
            IdentityId: identityId
        });
        if (clientResult.Credentials && clientResult.Credentials.AccessKeyId && clientResult.Credentials.SecretKey) {
            this._nextCredentialsRefresh = new Date().getTime() + $944bc1f68a1ebd42$var$CREDENTIALS_TTL;
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            const identityIdRes = clientResult.IdentityId;
            if (identityIdRes) {
                res.identityId = identityIdRes;
                this._identityIdStore.storeIdentityId({
                    id: identityIdRes,
                    type: "guest"
                });
            }
            this._credentialsAndIdentityId = {
                ...res,
                isAuthenticatedCreds: false
            };
            return res;
        } else throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: "CredentialsNotFoundException",
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    async credsForOIDCTokens(authConfig, authTokens, identityId) {
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === true) {
            $944bc1f68a1ebd42$var$logger.debug("returning stored credentials as they neither past TTL nor expired.");
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any unauthenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const logins = authTokens.idToken ? (0, $4b5a2b344a373c19$export$edfb13e85a2c0dc4)(authTokens.idToken.toString()) : {};
        const region = (0, $e76389a51923234d$export$8fb32fba519c460)(authConfig.identityPoolId);
        const clientResult = await (0, $edb2ac2ae5c1ecb4$export$a49c1c173ab96b58)({
            region: region
        }, {
            IdentityId: identityId,
            Logins: logins
        });
        if (clientResult.Credentials && clientResult.Credentials.AccessKeyId && clientResult.Credentials.SecretKey) {
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            // Store the credentials in-memory along with the expiration
            this._credentialsAndIdentityId = {
                ...res,
                isAuthenticatedCreds: true,
                associatedIdToken: authTokens.idToken?.toString()
            };
            this._nextCredentialsRefresh = new Date().getTime() + $944bc1f68a1ebd42$var$CREDENTIALS_TTL;
            const identityIdRes = clientResult.IdentityId;
            if (identityIdRes) {
                res.identityId = identityIdRes;
                this._identityIdStore.storeIdentityId({
                    id: identityIdRes,
                    type: "primary"
                });
            }
            return res;
        } else throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: "CredentialsException",
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    isPastTTL() {
        return this._nextCredentialsRefresh === undefined ? true : this._nextCredentialsRefresh <= Date.now();
    }
    hasTokenChanged(tokens) {
        return !!tokens && !!this._credentialsAndIdentityId?.associatedIdToken && tokens.idToken?.toString() !== this._credentialsAndIdentityId.associatedIdToken;
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cognito specific implmentation of the CredentialsProvider interface
 * that manages setting and getting of AWS Credentials.
 *
 * @throws configuration expections: `InvalidIdentityPoolIdException`
 *  - Auth errors that may arise from misconfiguration.
 * @throws service expections: {@link GetCredentialsForIdentityException}, {@link GetIdException}
 *
 */ const $bdeddb1a422eb307$export$be43b753aec531e2 = new (0, $944bc1f68a1ebd42$export$be6550e37264dc26)(new (0, $bb88847e241335cc$export$3e97b78667a539a0)((0, $c1a7077392f3b8b2$export$586b30dcaeecb901)));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * returns in-flight promise if there is one
 *
 * @param asyncFunction - asyncFunction to be deduped.
 * @returns - the return type of the callback
 */ const $21fb99b99f7fb41a$export$cd8d22e3dc00ae5a = (asyncFunction)=>{
    let inflightPromise;
    return async (...args)=>{
        if (inflightPromise) return inflightPromise;
        inflightPromise = new Promise((resolve, reject)=>{
            asyncFunction(...args).then((result)=>{
                resolve(result);
            }).catch((error)=>{
                reject(error);
            }).finally(()=>{
                inflightPromise = undefined;
            });
        });
        return inflightPromise;
    };
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $644eb7a063c0ce65$export$1113413e6e842bef = (operation)=>(input, endpoint)=>{
        const headers = $644eb7a063c0ce65$var$getSharedHeaders(operation);
        const body = JSON.stringify(input);
        return $644eb7a063c0ce65$var$buildHttpRpcRequest(endpoint, headers, body);
    };
const $644eb7a063c0ce65$var$getSharedHeaders = (operation)=>({
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `AWSCognitoIdentityProviderService.${operation}`
    });
const $644eb7a063c0ce65$var$buildHttpRpcRequest = ({ url: url  }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    });





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $609100932f10eceb$export$5b3890f50cd4853f(error) {
    if (!error || error.name === "Error" || error instanceof TypeError) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: (0, $e4876bf018e81b36$export$4e712df6b850c8d0).Unknown,
        message: "An unknown error has occurred.",
        underlyingError: error
    });
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $70b030255b6cf783$export$8159795418a3e796 = ()=>async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, $209f6e497b3a00cd$export$be467dfcc0538e25)(response);
            (0, $609100932f10eceb$export$5b3890f50cd4853f)(error);
            throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
                name: error.name,
                message: error.message
            });
        }
        return (0, $209f6e497b3a00cd$export$759bcb35b0d1bf81)(response);
    };






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $2c989c9ee9688ddf$var$disableCacheMiddlewareFactory = ()=>(next, _)=>async function disableCacheMiddleware(request) {
            request.headers["cache-control"] = "no-store";
            return next(request);
        };
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $2c989c9ee9688ddf$export$10f11e95d7a96f7b = (0, $e4148c4bd51790db$export$f074d76e52925468)((0, $c35e4257eb1069ca$export$ed7e1ccf00f39c4a), [
    $2c989c9ee9688ddf$var$disableCacheMiddlewareFactory
]);




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $71846e7400bebc95$export$a0efffb4b0c72e04 = "cognito-idp";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ab5c45a15b3ed82d$export$22a3716e7860147a = {
    service: (0, $71846e7400bebc95$export$a0efffb4b0c72e04),
    retryDecider: (0, $d6ccf8c3d159d43b$export$b919d98317a7685f)((0, $209f6e497b3a00cd$export$be467dfcc0538e25)),
    computeDelay: (0, $3d87caf0cda2471c$export$caea50bde345f648),
    userAgentValue: (0, $94d73b8725ccf9a9$export$ede38edb26c0bfdf)(),
    cache: "no-store"
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $74a589de9a455739$export$91f349d78bea7765 = (config)=>(0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $2c989c9ee9688ddf$export$10f11e95d7a96f7b), (0, $644eb7a063c0ce65$export$1113413e6e842bef)("InitiateAuth"), (0, $70b030255b6cf783$export$8159795418a3e796)(), {
        ...(0, $ab5c45a15b3ed82d$export$22a3716e7860147a),
        ...config
    });













// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e8e2a0f646733b4e$export$54dd9d9496cb66b9 = ({ region: region  })=>({
        url: new (0, $3415b1d6f221136c$export$beb82d9d9136c16e)(`https://${(0, $71846e7400bebc95$export$a0efffb4b0c72e04)}.${region}.${(0, $83f0685006e72a3c$export$1c28e37cdcc37f6d)(region)}`)
    });


const $c09f0e38e47b8a60$export$9fc8f7dceefe00a6 = ({ endpointOverride: endpointOverride  })=>(input)=>{
        if (endpointOverride) return {
            url: new (0, $3415b1d6f221136c$export$beb82d9d9136c16e)(endpointOverride)
        };
        return (0, $e8e2a0f646733b4e$export$54dd9d9496cb66b9)(input);
    };


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $931df5209d775015$export$b6e6cdd1f90faa62({ username: username , userPoolId: userPoolId , userPoolClientId: userPoolClientId  }) {
    if (typeof window === "undefined") return undefined;
    const amazonCognitoAdvancedSecurityData = window.AmazonCognitoAdvancedSecurityData;
    if (typeof amazonCognitoAdvancedSecurityData === "undefined") return undefined;
    const advancedSecurityData = amazonCognitoAdvancedSecurityData.getData(username, userPoolId, userPoolClientId);
    if (advancedSecurityData) {
        const userContextData = {
            EncodedData: advancedSecurityData
        };
        return userContextData;
    }
    return {};
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $180f57fe422b6b7f$var$refreshAuthTokensFunction = async ({ tokens: tokens , authConfig: authConfig , username: username  })=>{
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig?.Cognito);
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = authConfig.Cognito;
    const region = (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId);
    (0, $45fe96cf99d947f4$export$be38b2d22222d505)(tokens);
    const refreshTokenString = tokens.refreshToken;
    const AuthParameters = {
        REFRESH_TOKEN: refreshTokenString
    };
    if (tokens.deviceMetadata?.deviceKey) AuthParameters.DEVICE_KEY = tokens.deviceMetadata.deviceKey;
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const initiateAuth = (0, $74a589de9a455739$export$91f349d78bea7765)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { AuthenticationResult: AuthenticationResult  } = await initiateAuth({
        region: region
    }, {
        ClientId: userPoolClientId,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: AuthParameters,
        UserContextData: UserContextData
    });
    const accessToken = (0, $d0b404dc65adc192$export$9a62e6c0a30e00bc)(AuthenticationResult?.AccessToken ?? "");
    const idToken = AuthenticationResult?.IdToken ? (0, $d0b404dc65adc192$export$9a62e6c0a30e00bc)(AuthenticationResult.IdToken) : undefined;
    const { iat: iat  } = accessToken.payload;
    // This should never happen. If it does, it's a bug from the service.
    if (!iat) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: "iatNotFoundException",
        message: "iat not found in access token"
    });
    const clockDrift = iat * 1000 - new Date().getTime();
    return {
        accessToken: accessToken,
        idToken: idToken,
        clockDrift: clockDrift,
        refreshToken: refreshTokenString,
        username: username
    };
};
const $180f57fe422b6b7f$export$ab413c2cb4a135d9 = (0, $21fb99b99f7fb41a$export$cd8d22e3dc00ae5a)($180f57fe422b6b7f$var$refreshAuthTokensFunction);
const $180f57fe422b6b7f$export$d5c14381105da273 = $180f57fe422b6b7f$var$refreshAuthTokensFunction;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $667590a172222acf$export$4e09c449d6c407f7 = ()=>typeof window !== "undefined" && typeof window.document !== "undefined";








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $52c2ee4fd5af8dee$var$V5_HOSTED_UI_KEY = "amplify-signin-with-hostedUI";
const $52c2ee4fd5af8dee$var$name = "CognitoIdentityServiceProvider";
class $52c2ee4fd5af8dee$export$9b2cef5d94f9b6e8 {
    constructor(keyValueStorage){
        this.keyValueStorage = keyValueStorage;
    }
    async clearOAuthInflightData() {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        await Promise.all([
            this.keyValueStorage.removeItem(authKeys.inflightOAuth),
            this.keyValueStorage.removeItem(authKeys.oauthPKCE),
            this.keyValueStorage.removeItem(authKeys.oauthState)
        ]);
    }
    async clearOAuthData() {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        await this.clearOAuthInflightData();
        await this.keyValueStorage.removeItem($52c2ee4fd5af8dee$var$V5_HOSTED_UI_KEY); // remove in case a customer migrated an App from v5 to v6
        return this.keyValueStorage.removeItem(authKeys.oauthSignIn);
    }
    loadOAuthState() {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthState);
    }
    storeOAuthState(state) {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthState, state);
    }
    loadPKCE() {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthPKCE);
    }
    storePKCE(pkce) {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthPKCE, pkce);
    }
    setAuthConfig(authConfigParam) {
        this.cognitoConfig = authConfigParam;
    }
    async loadOAuthInFlight() {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        return await this.keyValueStorage.getItem(authKeys.inflightOAuth) === "true";
    }
    async storeOAuthInFlight(inflight) {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        await this.keyValueStorage.setItem(authKeys.inflightOAuth, `${inflight}`);
    }
    async loadOAuthSignIn() {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        const isLegacyHostedUISignIn = await this.keyValueStorage.getItem($52c2ee4fd5af8dee$var$V5_HOSTED_UI_KEY);
        const [isOAuthSignIn, preferPrivateSession] = (await this.keyValueStorage.getItem(authKeys.oauthSignIn))?.split(",") ?? [];
        return {
            isOAuthSignIn: isOAuthSignIn === "true" || isLegacyHostedUISignIn === "true",
            preferPrivateSession: preferPrivateSession === "true"
        };
    }
    async storeOAuthSignIn(oauthSignIn, preferPrivateSession = false) {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        await this.keyValueStorage.setItem(authKeys.oauthSignIn, `${oauthSignIn},${preferPrivateSession}`);
    }
}
const $52c2ee4fd5af8dee$var$createKeysForAuthStorage = (provider, identifier)=>{
    return (0, $62bb7d16e56984d5$export$dfb8da757ca62eed)((0, $45fe96cf99d947f4$export$3820b4ff343394ea))(provider, identifier);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $67460d2d430d09f6$export$2ed0ec267eb6cb1c = new (0, $52c2ee4fd5af8dee$export$9b2cef5d94f9b6e8)((0, $c1a7077392f3b8b2$export$586b30dcaeecb901));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $d6f902f31e3139f0$var$inflightPromises = [];
const $d6f902f31e3139f0$export$c55b09e0e9be0d04 = (resolver)=>{
    $d6f902f31e3139f0$var$inflightPromises.push(resolver);
};
const $d6f902f31e3139f0$export$bcb0b7a105a5df59 = ()=>{
    while($d6f902f31e3139f0$var$inflightPromises.length)$d6f902f31e3139f0$var$inflightPromises.pop()?.();
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $ce02cb698cdbaab3$export$ba2f3fbc8979d2e6 {
    constructor(){
        this.waitForInflightOAuth = (0, $667590a172222acf$export$4e09c449d6c407f7)() ? async ()=>{
            if (!await (0, $67460d2d430d09f6$export$2ed0ec267eb6cb1c).loadOAuthInFlight()) return;
            if (this.inflightPromise) return this.inflightPromise;
            // when there is valid oauth config and there is an inflight oauth flow, try
            // to block async calls that require fetching tokens before the oauth flow completes
            // e.g. getCurrentUser, fetchAuthSession etc.
            this.inflightPromise = new Promise((resolve, _reject)=>{
                (0, $d6f902f31e3139f0$export$c55b09e0e9be0d04)(resolve);
            });
            return this.inflightPromise;
        } : async ()=>{
        // no-op for non-browser environments
        };
    }
    setAuthConfig(authConfig) {
        (0, $67460d2d430d09f6$export$2ed0ec267eb6cb1c).setAuthConfig(authConfig.Cognito);
        this.authConfig = authConfig;
    }
    setTokenRefresher(tokenRefresher) {
        this.tokenRefresher = tokenRefresher;
    }
    setAuthTokenStore(tokenStore) {
        this.tokenStore = tokenStore;
    }
    getTokenStore() {
        if (!this.tokenStore) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: "EmptyTokenStoreException",
            message: "TokenStore not set"
        });
        return this.tokenStore;
    }
    getTokenRefresher() {
        if (!this.tokenRefresher) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: "EmptyTokenRefresherException",
            message: "TokenRefresher not set"
        });
        return this.tokenRefresher;
    }
    async getTokens(options) {
        let tokens;
        try {
            (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.authConfig?.Cognito);
        } catch (_err) {
            // Token provider not configured
            return null;
        }
        await this.waitForInflightOAuth();
        this.inflightPromise = undefined;
        tokens = await this.getTokenStore().loadTokens();
        const username = await this.getTokenStore().getLastAuthUser();
        if (tokens === null) return null;
        const idTokenExpired = !!tokens?.idToken && (0, $2a776d17fcab286a$export$b007d77a962aa175)({
            expiresAt: (tokens.idToken?.payload?.exp ?? 0) * 1000,
            clockDrift: tokens.clockDrift ?? 0
        });
        const accessTokenExpired = (0, $2a776d17fcab286a$export$b007d77a962aa175)({
            expiresAt: (tokens.accessToken?.payload?.exp ?? 0) * 1000,
            clockDrift: tokens.clockDrift ?? 0
        });
        if (options?.forceRefresh || idTokenExpired || accessTokenExpired) {
            tokens = await this.refreshTokens({
                tokens: tokens,
                username: username
            });
            if (tokens === null) return null;
        }
        return {
            accessToken: tokens?.accessToken,
            idToken: tokens?.idToken,
            signInDetails: tokens?.signInDetails
        };
    }
    async refreshTokens({ tokens: tokens , username: username  }) {
        try {
            const { signInDetails: signInDetails  } = tokens;
            const newTokens = await this.getTokenRefresher()({
                tokens: tokens,
                authConfig: this.authConfig,
                username: username
            });
            newTokens.signInDetails = signInDetails;
            await this.setTokens({
                tokens: newTokens
            });
            (0, $c9802061728ce106$export$8c41bb232f1008b1).dispatch("auth", {
                event: "tokenRefresh"
            }, "Auth", (0, $c9802061728ce106$export$aadf71dd9875dd20));
            return newTokens;
        } catch (err) {
            return this.handleErrors(err);
        }
    }
    handleErrors(err) {
        (0, $609100932f10eceb$export$5b3890f50cd4853f)(err);
        if (err.name !== (0, $e4876bf018e81b36$export$4e712df6b850c8d0).NetworkError) // TODO(v6): Check errors on client
        this.clearTokens();
        (0, $c9802061728ce106$export$8c41bb232f1008b1).dispatch("auth", {
            event: "tokenRefresh_failure",
            data: {
                error: err
            }
        }, "Auth", (0, $c9802061728ce106$export$aadf71dd9875dd20));
        if (err.name.startsWith("NotAuthorizedException")) return null;
        throw err;
    }
    async setTokens({ tokens: tokens  }) {
        return this.getTokenStore().storeTokens(tokens);
    }
    async clearTokens() {
        return this.getTokenStore().clearTokens();
    }
    getDeviceMetadata(username) {
        return this.getTokenStore().getDeviceMetadata(username);
    }
    clearDeviceMetadata(username) {
        return this.getTokenStore().clearDeviceMetadata(username);
    }
    setOAuthMetadata(metadata) {
        return this.getTokenStore().setOAuthMetadata(metadata);
    }
    getOAuthMetadata() {
        return this.getTokenStore().getOAuthMetadata();
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $884faf73974cd31a$export$85b743bbda58cb6c {
    constructor(){
        this.authTokenStore = new (0, $62bb7d16e56984d5$export$a36be852d43d512)();
        this.authTokenStore.setKeyValueStorage((0, $c1a7077392f3b8b2$export$586b30dcaeecb901));
        this.tokenOrchestrator = new (0, $ce02cb698cdbaab3$export$ba2f3fbc8979d2e6)();
        this.tokenOrchestrator.setAuthTokenStore(this.authTokenStore);
        this.tokenOrchestrator.setTokenRefresher((0, $180f57fe422b6b7f$export$ab413c2cb4a135d9));
    }
    getTokens({ forceRefresh: forceRefresh  } = {
        forceRefresh: false
    }) {
        return this.tokenOrchestrator.getTokens({
            forceRefresh: forceRefresh
        });
    }
    setKeyValueStorage(keyValueStorage) {
        this.authTokenStore.setKeyValueStorage(keyValueStorage);
    }
    setAuthConfig(authConfig) {
        this.authTokenStore.setAuthConfig(authConfig);
        this.tokenOrchestrator.setAuthConfig(authConfig);
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The default provider for the JWT access token and ID token issued from the configured Cognito user pool. It manages
 * the refresh and storage of the tokens. It stores the tokens in `window.localStorage` if available, and falls back to
 * in-memory storage if not.
 */ const $8165b6923e40c4bf$export$18e158b80aac31a7 = new (0, $884faf73974cd31a$export$85b743bbda58cb6c)();
const { tokenOrchestrator: $8165b6923e40c4bf$export$66561e66d62991d0  } = $8165b6923e40c4bf$export$18e158b80aac31a7;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $15c60452aaf7d22d$export$11ac3725994bec7b = {
    /**
     * Configures Amplify with the {@link resourceConfig} and {@link libraryOptions}.
     *
     * @param resourceConfig The {@link ResourcesConfig} object that is typically imported from the
     * `amplifyconfiguration.json` file. It can also be an object literal created inline when calling `Amplify.configure`.
     * @param libraryOptions The {@link LibraryOptions} additional options for the library.
     *
     * @example
     * import config from './amplifyconfiguration.json';
     *
     * Amplify.configure(config);
     */ configure (resourceConfig, libraryOptions) {
        const resolvedResourceConfig = (0, $c617356b2a6163e9$export$f101a69cd6dc6202)(resourceConfig);
        // If no Auth config is provided, no special handling will be required, configure as is.
        // Otherwise, we can assume an Auth config is provided from here on.
        if (!resolvedResourceConfig.Auth) {
            (0, $d9009b35813b573c$export$a3858a9a153cffc7).configure(resolvedResourceConfig, libraryOptions);
            return;
        }
        // If Auth options are provided, always just configure as is.
        // Otherwise, we can assume no Auth libraryOptions were provided from here on.
        if (libraryOptions?.Auth) {
            (0, $d9009b35813b573c$export$a3858a9a153cffc7).configure(resolvedResourceConfig, libraryOptions);
            return;
        }
        // If no Auth libraryOptions were previously configured, then always add default providers.
        if (!(0, $d9009b35813b573c$export$a3858a9a153cffc7).libraryOptions.Auth) {
            (0, $8165b6923e40c4bf$export$18e158b80aac31a7).setAuthConfig(resolvedResourceConfig.Auth);
            (0, $8165b6923e40c4bf$export$18e158b80aac31a7).setKeyValueStorage(// TODO: allow configure with a public interface
            libraryOptions?.ssr ? new (0, $19002707866b8978$export$dae7d845015939d5)({
                sameSite: "lax"
            }) : (0, $c1a7077392f3b8b2$export$586b30dcaeecb901));
            (0, $d9009b35813b573c$export$a3858a9a153cffc7).configure(resolvedResourceConfig, {
                ...libraryOptions,
                Auth: {
                    tokenProvider: (0, $8165b6923e40c4bf$export$18e158b80aac31a7),
                    credentialsProvider: (0, $bdeddb1a422eb307$export$be43b753aec531e2)
                }
            });
            return;
        }
        // At this point, Auth libraryOptions would have been previously configured and no overriding
        // Auth options were given, so we should preserve the currently configured Auth libraryOptions.
        if (libraryOptions) {
            // If ssr is provided through libraryOptions, we should respect the intentional reconfiguration.
            if (libraryOptions.ssr !== undefined) (0, $8165b6923e40c4bf$export$18e158b80aac31a7).setKeyValueStorage(// TODO: allow configure with a public interface
            libraryOptions.ssr ? new (0, $19002707866b8978$export$dae7d845015939d5)({
                sameSite: "lax"
            }) : (0, $c1a7077392f3b8b2$export$586b30dcaeecb901));
            (0, $d9009b35813b573c$export$a3858a9a153cffc7).configure(resolvedResourceConfig, {
                Auth: (0, $d9009b35813b573c$export$a3858a9a153cffc7).libraryOptions.Auth,
                ...libraryOptions
            });
            return;
        }
        // Finally, if there were no libraryOptions given at all, we should simply not touch the currently
        // configured libraryOptions.
        (0, $d9009b35813b573c$export$a3858a9a153cffc7).configure(resolvedResourceConfig);
    },
    /**
     * Returns the {@link ResourcesConfig} object passed in as the `resourceConfig` parameter when calling
     * `Amplify.configure`.
     *
     * @returns An {@link ResourcesConfig} object.
     */ getConfig () {
        return (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig();
    }
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $37d361b81fa35812$export$12d5c695b2213c4a;
(function(AuthValidationErrorCode) {
    AuthValidationErrorCode["EmptySignInUsername"] = "EmptySignInUsername";
    AuthValidationErrorCode["EmptySignInPassword"] = "EmptySignInPassword";
    AuthValidationErrorCode["CustomAuthSignInPassword"] = "CustomAuthSignInPassword";
    AuthValidationErrorCode["EmptySignUpUsername"] = "EmptySignUpUsername";
    AuthValidationErrorCode["EmptySignUpPassword"] = "EmptySignUpPassword";
    AuthValidationErrorCode["EmptyConfirmSignUpUsername"] = "EmptyConfirmSignUpUsername";
    AuthValidationErrorCode["EmptyConfirmSignUpCode"] = "EmptyConfirmSignUpCode";
    AuthValidationErrorCode["EmptyResendSignUpCodeUsername"] = "EmptyresendSignUpCodeUsername";
    AuthValidationErrorCode["EmptyChallengeResponse"] = "EmptyChallengeResponse";
    AuthValidationErrorCode["EmptyConfirmResetPasswordUsername"] = "EmptyConfirmResetPasswordUsername";
    AuthValidationErrorCode["EmptyConfirmResetPasswordNewPassword"] = "EmptyConfirmResetPasswordNewPassword";
    AuthValidationErrorCode["EmptyConfirmResetPasswordConfirmationCode"] = "EmptyConfirmResetPasswordConfirmationCode";
    AuthValidationErrorCode["EmptyResetPasswordUsername"] = "EmptyResetPasswordUsername";
    AuthValidationErrorCode["EmptyVerifyTOTPSetupCode"] = "EmptyVerifyTOTPSetupCode";
    AuthValidationErrorCode["EmptyConfirmUserAttributeCode"] = "EmptyConfirmUserAttributeCode";
    AuthValidationErrorCode["IncorrectMFAMethod"] = "IncorrectMFAMethod";
    AuthValidationErrorCode["EmptyUpdatePassword"] = "EmptyUpdatePassword";
})($37d361b81fa35812$export$12d5c695b2213c4a || ($37d361b81fa35812$export$12d5c695b2213c4a = {}));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7ccba6b199ab94b3$export$195137955146d376 = {
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyChallengeResponse]: {
        message: "challengeResponse is required to confirmSignIn"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyConfirmResetPasswordUsername]: {
        message: "username is required to confirmResetPassword"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyConfirmSignUpCode]: {
        message: "code is required to confirmSignUp"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyConfirmSignUpUsername]: {
        message: "username is required to confirmSignUp"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyConfirmResetPasswordConfirmationCode]: {
        message: "confirmationCode is required to confirmResetPassword"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyConfirmResetPasswordNewPassword]: {
        message: "newPassword is required to confirmResetPassword"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyResendSignUpCodeUsername]: {
        message: "username is required to confirmSignUp"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyResetPasswordUsername]: {
        message: "username is required to resetPassword"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInPassword]: {
        message: "password is required to signIn"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInUsername]: {
        message: "username is required to signIn"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignUpPassword]: {
        message: "password is required to signUp"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignUpUsername]: {
        message: "username is required to signUp"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).CustomAuthSignInPassword]: {
        message: "A password is not needed when signing in with CUSTOM_WITHOUT_SRP",
        recoverySuggestion: "Do not include a password in your signIn call."
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).IncorrectMFAMethod]: {
        message: "Incorrect MFA method was chosen. It should be either SMS, TOTP, or EMAIL",
        recoverySuggestion: "Try to pass SMS, TOTP, or EMAIL as the challengeResponse"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyVerifyTOTPSetupCode]: {
        message: "code is required to verifyTotpSetup"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyUpdatePassword]: {
        message: "oldPassword and newPassword are required to changePassword"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyConfirmUserAttributeCode]: {
        message: "confirmation code is required to confirmUserAttribute"
    }
};
// TODO: delete this code when the Auth class is removed.
var $7ccba6b199ab94b3$export$c3070468b9d65120;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
    AuthErrorStrings["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
    AuthErrorStrings["OAUTH_ERROR"] = "Couldn't finish OAuth flow, check your User Pool HostedUI settings";
})($7ccba6b199ab94b3$export$c3070468b9d65120 || ($7ccba6b199ab94b3$export$c3070468b9d65120 = {}));
var $7ccba6b199ab94b3$export$473ab0b56598aacd;
(function(AuthErrorCodes) {
    AuthErrorCodes["SignInException"] = "SignInException";
    AuthErrorCodes["OAuthSignInError"] = "OAuthSignInException";
})($7ccba6b199ab94b3$export$473ab0b56598aacd || ($7ccba6b199ab94b3$export$473ab0b56598aacd = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $5dfe0da1f6ddb527$export$45936001d12f9b53(assertion, name) {
    const { message: message , recoverySuggestion: recoverySuggestion  } = (0, $7ccba6b199ab94b3$export$195137955146d376)[name];
    if (!assertion) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: name,
        message: message,
        recoverySuggestion: recoverySuggestion
    });
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $d85f0aaaaf37a11b$export$d6cd780379f37dae = (action, customUserAgentDetails)=>(0, $94d73b8725ccf9a9$export$ede38edb26c0bfdf)({
        category: (0, $3c92cd7927458afb$export$3a8840c5b2ecf003).Auth,
        action: action,
        ...customUserAgentDetails
    });
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $13d8e76b3137ea39$export$f182f73f82c5c23a = (config)=>(0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $2c989c9ee9688ddf$export$10f11e95d7a96f7b), (0, $644eb7a063c0ce65$export$1113413e6e842bef)("ConfirmSignUp"), (0, $70b030255b6cf783$export$8159795418a3e796)(), {
        ...(0, $ab5c45a15b3ed82d$export$22a3716e7860147a),
        ...config
    });



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $da6c6b387e94c6c2$var$defaultState() {
    return {
        active: false
    };
}
const $da6c6b387e94c6c2$var$autoSignInReducer = (state, action)=>{
    switch(action.type){
        case "SET_USERNAME":
            return {
                ...state,
                username: action.value
            };
        case "SET_SESSION":
            return {
                ...state,
                session: action.value
            };
        case "START":
            return {
                ...state,
                active: true
            };
        case "RESET":
            return $da6c6b387e94c6c2$var$defaultState();
        default:
            return state;
    }
};
const $da6c6b387e94c6c2$var$createAutoSignInStore = (reducer)=>{
    let currentState = reducer($da6c6b387e94c6c2$var$defaultState(), {
        type: "RESET"
    });
    return {
        getState: ()=>currentState,
        dispatch: (action)=>{
            currentState = reducer(currentState, action);
        }
    };
};
const $da6c6b387e94c6c2$export$ef87a9980a3566ca = $da6c6b387e94c6c2$var$createAutoSignInStore($da6c6b387e94c6c2$var$autoSignInReducer);







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $84ab96e5fb6bfc37$var$initialAutoSignIn = async ()=>{
    throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: (0, $d78d124ef376faa5$export$fe46a12932d2550a),
        message: "The autoSignIn flow has not started, or has been cancelled/completed.",
        recoverySuggestion: "Please try to use the signIn API or log out before starting a new autoSignIn flow."
    });
};
/**
 * Signs a user in automatically after finishing the sign-up process.
 *
 * This API will automatically sign a user in if the autoSignIn flow has been completed in the following cases:
 * - User confirmed their account with a verification code sent to their phone or email (default option).
 * - User confirmed their account with a verification link sent to their phone or email. In order to
 * enable this option you need to go to the Amazon Cognito [console](https://aws.amazon.com/pm/cognito),
 * look for your userpool, then go to the `Messaging` tab and enable `link` mode inside the `Verification message` option.
 * Finally you need to define the `signUpVerificationMethod` in your `Auth` config.
 *
 * @example
 * ```typescript
 *  Amplify.configure({
 *    Auth: {
 *     Cognito: {
 *    ...cognitoConfig,
 *    signUpVerificationMethod: "link" // the default value is "code"
 *   }
 *	}});
 * ```
 *
 * @throws AutoSignInException - Thrown when the autoSignIn flow has not started, or has been cancelled/completed.
 * @returns The signInOutput.
 *
 * @example
 * ```typescript
 *  // handleSignUp.ts
 * async function handleSignUp(
 *   username:string,
 *   password:string
 * ){
 *   try {
 *     const { nextStep } = await signUp({
 *       username,
 *       password,
 *       options: {
 *         userAttributes:{ email:'email@email.com'},
 *         autoSignIn: true // This enables the auto sign-in flow.
 *       },
 *     });
 *
 *     handleSignUpStep(nextStep);
 *
 *   } catch (error) {
 *     console.log(error);
 *   }
 * }
 *
 * // handleConfirmSignUp.ts
 * async function handleConfirmSignUp(username:string, confirmationCode:string) {
 *   try {
 *     const { nextStep } = await confirmSignUp({
 *       username,
 *       confirmationCode,
 *     });
 *
 *     handleSignUpStep(nextStep);
 *   } catch (error) {
 *     console.log(error);
 *   }
 * }
 *
 * // signUpUtils.ts
 * async function handleSignUpStep( step: SignUpOutput["nextStep"]) {
 * switch (step.signUpStep) {
 *   case "CONFIRM_SIGN_UP":
 *
 *    // Redirect end-user to confirm-sign up screen.
 *
 *   case "COMPLETE_AUTO_SIGN_IN":
 *	   const codeDeliveryDetails = step.codeDeliveryDetails;
 *     if (codeDeliveryDetails) {
 *      // Redirect user to confirm-sign-up with link screen.
 *     }
 *     const signInOutput = await autoSignIn();
 *   // handle sign-in steps
 * }
 *
 * ```
 */ // TODO(Eslint): can this be refactored not using `let` on exported member?
// eslint-disable-next-line import/no-mutable-exports
let $84ab96e5fb6bfc37$export$c5378dc7d6787fa5 = $84ab96e5fb6bfc37$var$initialAutoSignIn;
/**
 * Sets the context of autoSignIn at run time.
 * @internal
 */ function $84ab96e5fb6bfc37$export$7dcbf67a23c27835(callback) {
    $84ab96e5fb6bfc37$export$c5378dc7d6787fa5 = callback;
}
/**
 * Resets the context
 *
 * @internal
 */ function $84ab96e5fb6bfc37$export$1ffa2742ce5c589b(resetCallback = true) {
    if (resetCallback) $84ab96e5fb6bfc37$export$c5378dc7d6787fa5 = $84ab96e5fb6bfc37$var$initialAutoSignIn;
    (0, $da6c6b387e94c6c2$export$ef87a9980a3566ca).dispatch({
        type: "RESET"
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Confirms a new user account.
 *
 * @param input -  The ConfirmSignUpInput object.
 * @returns ConfirmSignUpOutput
 * @throws -{@link ConfirmSignUpException }
 * Thrown due to an invalid confirmation code.
 * @throws -{@link AuthValidationErrorCode }
 * Thrown due to an empty confirmation code
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $e8e960606449d760$export$2ce39ab6662e8c24(input) {
    const { username: username , confirmationCode: confirmationCode , options: options  } = input;
    const authConfig = (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = authConfig;
    const clientMetadata = options?.clientMetadata;
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!username, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyConfirmSignUpUsername);
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!confirmationCode, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyConfirmSignUpCode);
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const confirmSignUpClient = (0, $13d8e76b3137ea39$export$f182f73f82c5c23a)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { Session: session  } = await confirmSignUpClient({
        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(authConfig.userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).ConfirmSignUp)
    }, {
        Username: username,
        ConfirmationCode: confirmationCode,
        ClientMetadata: clientMetadata,
        ForceAliasCreation: options?.forceAliasCreation,
        ClientId: authConfig.userPoolClientId,
        UserContextData: UserContextData
    });
    return new Promise((resolve, reject)=>{
        try {
            const signUpOut = {
                isSignUpComplete: true,
                nextStep: {
                    signUpStep: "DONE"
                }
            };
            const autoSignInStoreState = (0, $da6c6b387e94c6c2$export$ef87a9980a3566ca).getState();
            if (!autoSignInStoreState.active || autoSignInStoreState.username !== username) {
                resolve(signUpOut);
                (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)();
                return;
            }
            (0, $da6c6b387e94c6c2$export$ef87a9980a3566ca).dispatch({
                type: "SET_SESSION",
                value: session
            });
            const stopListener = (0, $c9802061728ce106$export$45dde0743a4c8d6e).listen("auth-internal", ({ payload: payload  })=>{
                switch(payload.event){
                    case "autoSignIn":
                        resolve({
                            isSignUpComplete: true,
                            nextStep: {
                                signUpStep: "COMPLETE_AUTO_SIGN_IN"
                            }
                        });
                        stopListener();
                }
            });
            (0, $c9802061728ce106$export$45dde0743a4c8d6e).dispatch("auth-internal", {
                event: "confirmSignUp",
                data: signUpOut
            });
        } catch (error) {
            reject(error);
        }
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $6a3d0165c96d8b3d$export$39430dfe49142ae = (amplify, options)=>{
    return amplify.Auth.fetchAuthSession(options);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Fetch the auth session including the tokens and credentials if they are available. By default it
 * does not refresh the auth tokens or credentials if they are loaded in storage already. You can force a refresh
 * with `{ forceRefresh: true }` input.
 *
 * @param options - Options configuring the fetch behavior.
 * @throws {@link AuthError} - Throws error when session information cannot be refreshed.
 * @returns Promise<AuthSession>
 */ const $56b943a689c803eb$export$39430dfe49142ae = (options)=>{
    return (0, $6a3d0165c96d8b3d$export$39430dfe49142ae)((0, $d9009b35813b573c$export$a3858a9a153cffc7), options);
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Transforms a user attributes object into an array of AttributeType objects.
 * @param attributes user attributes to be mapped to AttributeType objects.
 * @returns an array of AttributeType objects.
 */ function $26de5e277ff0a29a$export$720a7caa078a04b0(attributes) {
    return Object.entries(attributes).map(([key, value])=>({
            Name: key,
            Value: value
        }));
}
/**
 * Transforms an array of AttributeType objects into a user attributes object.
 *
 * @param attributes - an array of AttributeType objects.
 * @returns AuthUserAttributes object.
 */ function $26de5e277ff0a29a$export$1b975641d03f3b17(attributes) {
    const userAttributes = {};
    attributes?.forEach((attribute)=>{
        if (attribute.Name) userAttributes[attribute.Name] = attribute.Value;
    });
    return userAttributes;
}

















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $22b2d293989648d9$export$9b3b12a535efe659 = (config)=>(0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $2c989c9ee9688ddf$export$10f11e95d7a96f7b), (0, $644eb7a063c0ce65$export$1113413e6e842bef)("GetUser"), (0, $70b030255b6cf783$export$8159795418a3e796)(), {
        ...(0, $ab5c45a15b3ed82d$export$22a3716e7860147a),
        ...config
    });



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9f6fe7a2e637c67f$export$5dc95ecf3f16c6c9 = async (amplify)=>{
    const authConfig = amplify.getConfig().Auth?.Cognito;
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    const { userPoolEndpoint: userPoolEndpoint , userPoolId: userPoolId  } = authConfig;
    const { tokens: tokens  } = await (0, $6a3d0165c96d8b3d$export$39430dfe49142ae)(amplify, {
        forceRefresh: false
    });
    (0, $45fe96cf99d947f4$export$77712ea5882cac9f)(tokens);
    const getUser = (0, $22b2d293989648d9$export$9b3b12a535efe659)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { UserAttributes: UserAttributes  } = await getUser({
        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).FetchUserAttributes)
    }, {
        AccessToken: tokens.accessToken.toString()
    });
    return (0, $26de5e277ff0a29a$export$1b975641d03f3b17)(UserAttributes);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Fetches the current user attributes while authenticated.
 *
 * @throws - {@link GetUserException} - Cognito service errors thrown when the service is not able to get the user.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $d5dec7a857031cfa$export$5dc95ecf3f16c6c9 = ()=>{
    return (0, $9f6fe7a2e637c67f$export$5dc95ecf3f16c6c9)((0, $d9009b35813b573c$export$a3858a9a153cffc7));
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e259644c3d1dc6cd$export$e5432d4c8eb97ea7 = async (amplify)=>{
    const authConfig = amplify.getConfig().Auth?.Cognito;
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    const tokens = await amplify.Auth.getTokens({
        forceRefresh: false
    });
    (0, $45fe96cf99d947f4$export$77712ea5882cac9f)(tokens);
    const { "cognito:username": username , sub: sub  } = tokens.idToken?.payload ?? {};
    const authUser = {
        username: username,
        userId: sub
    };
    const signInDetails = $e259644c3d1dc6cd$var$getSignInDetailsFromTokens(tokens);
    if (signInDetails) authUser.signInDetails = signInDetails;
    return authUser;
};
function $e259644c3d1dc6cd$var$getSignInDetailsFromTokens(tokens) {
    return tokens?.signInDetails;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Gets the current user from the idToken.
 *
 * @param input -  The GetCurrentUserInput object.
 * @returns GetCurrentUserOutput
 * @throws - {@link InitiateAuthException} - Thrown when the service fails to refresh the tokens.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $06d09becd613c1b3$export$e5432d4c8eb97ea7 = async ()=>{
    return (0, $e259644c3d1dc6cd$export$e5432d4c8eb97ea7)((0, $d9009b35813b573c$export$a3858a9a153cffc7));
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $9ed36e63af9e9ee7$export$7c746b75f47c9c7d(input) {
    return Array.from(input, (byte)=>String.fromCodePoint(byte)).join("");
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0f87662804872ba2$export$695b149896bd3e2a = {
    /**
     * Convert input to base64-encoded string
     * @param input - string to convert to base64
     * @param options - encoding options that can optionally produce a base64url string
     * @returns base64-encoded string
     */ convert (input, options = {
        urlSafe: false,
        skipPadding: false
    }) {
        const inputStr = typeof input === "string" ? input : (0, $9ed36e63af9e9ee7$export$7c746b75f47c9c7d)(input);
        let encodedStr = (0, $75891aafa6b8443f$export$94f295707b435c6d)()(inputStr);
        // urlSafe char replacement and skipPadding options conform to the base64url spec
        // https://datatracker.ietf.org/doc/html/rfc4648#section-5
        if (options.urlSafe) encodedStr = encodedStr.replace(/\+/g, "-").replace(/\//g, "_");
        if (options.skipPadding) encodedStr = encodedStr.replace(/=/g, "");
        return encodedStr;
    }
};

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Retrieves the device name using the User-Agent Client Hints API if available,
 * falling back to the traditional userAgent string if not.
 *
 * @returns {Promise<string>} A promise that resolves with a string representing the device name.
 *
 * Example Output:
 * navigator.userAgentData:
 *   'macOS 14.2.1 arm macOS Not A(Brand/99.0.0.0;Google Chrome/121.0.6167.160;Chromium/121.0.6167.160'
 * navigator.userAgent:
 *   'Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:109.0) Gecko/20100101 Firefox/115.0'
 */ const $6751c708615ca735$export$98f0aedb14d75123 = async ()=>{
    const { userAgentData: userAgentData  } = navigator;
    if (!userAgentData) return navigator.userAgent;
    const { platform: platform = "" , platformVersion: platformVersion = "" , model: model = "" , architecture: architecture = "" , fullVersionList: fullVersionList = []  } = await userAgentData.getHighEntropyValues([
        "platform",
        "platformVersion",
        "architecture",
        "model",
        "fullVersionList"
    ]);
    const versionList = fullVersionList.map((v)=>`${v.brand}/${v.version}`).join(";");
    const deviceName = [
        platform,
        platformVersion,
        architecture,
        model,
        platform,
        versionList
    ].filter((value)=>value).join(" ");
    return deviceName;
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $c13b5be9426121ff$export$3cc5c71ef5f25e57;
(function(AssociateSoftwareTokenException) {
    AssociateSoftwareTokenException["ConcurrentModificationException"] = "ConcurrentModificationException";
    AssociateSoftwareTokenException["ForbiddenException"] = "ForbiddenException";
    AssociateSoftwareTokenException["InternalErrorException"] = "InternalErrorException";
    AssociateSoftwareTokenException["InvalidParameterException"] = "InvalidParameterException";
    AssociateSoftwareTokenException["NotAuthorizedException"] = "NotAuthorizedException";
    AssociateSoftwareTokenException["ResourceNotFoundException"] = "ResourceNotFoundException";
    AssociateSoftwareTokenException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
})($c13b5be9426121ff$export$3cc5c71ef5f25e57 || ($c13b5be9426121ff$export$3cc5c71ef5f25e57 = {}));
var $c13b5be9426121ff$export$4327725e8bb80c51;
(function(ChangePasswordException) {
    ChangePasswordException["ForbiddenException"] = "ForbiddenException";
    ChangePasswordException["InternalErrorException"] = "InternalErrorException";
    ChangePasswordException["InvalidParameterException"] = "InvalidParameterException";
    ChangePasswordException["InvalidPasswordException"] = "InvalidPasswordException";
    ChangePasswordException["LimitExceededException"] = "LimitExceededException";
    ChangePasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ChangePasswordException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ChangePasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ChangePasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ChangePasswordException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ChangePasswordException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$4327725e8bb80c51 || ($c13b5be9426121ff$export$4327725e8bb80c51 = {}));
var $c13b5be9426121ff$export$87a956d0b1b725a1;
(function(ConfirmDeviceException) {
    ConfirmDeviceException["ForbiddenException"] = "ForbiddenException";
    ConfirmDeviceException["InternalErrorException"] = "InternalErrorException";
    ConfirmDeviceException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmDeviceException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmDeviceException["InvalidPasswordException"] = "InvalidPasswordException";
    ConfirmDeviceException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ConfirmDeviceException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmDeviceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ConfirmDeviceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmDeviceException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmDeviceException["UsernameExistsException"] = "UsernameExistsException";
    ConfirmDeviceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ConfirmDeviceException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$87a956d0b1b725a1 || ($c13b5be9426121ff$export$87a956d0b1b725a1 = {}));
var $c13b5be9426121ff$export$b86a388af82085af;
(function(ConfirmForgotPasswordException) {
    ConfirmForgotPasswordException["CodeMismatchException"] = "CodeMismatchException";
    ConfirmForgotPasswordException["ExpiredCodeException"] = "ExpiredCodeException";
    ConfirmForgotPasswordException["ForbiddenException"] = "ForbiddenException";
    ConfirmForgotPasswordException["InternalErrorException"] = "InternalErrorException";
    ConfirmForgotPasswordException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmForgotPasswordException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmForgotPasswordException["InvalidPasswordException"] = "InvalidPasswordException";
    ConfirmForgotPasswordException["LimitExceededException"] = "LimitExceededException";
    ConfirmForgotPasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmForgotPasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmForgotPasswordException["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    ConfirmForgotPasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmForgotPasswordException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ConfirmForgotPasswordException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ConfirmForgotPasswordException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ConfirmForgotPasswordException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$b86a388af82085af || ($c13b5be9426121ff$export$b86a388af82085af = {}));
var $c13b5be9426121ff$export$2ec29642a27fd055;
(function(ConfirmSignUpException) {
    ConfirmSignUpException["AliasExistsException"] = "AliasExistsException";
    ConfirmSignUpException["CodeMismatchException"] = "CodeMismatchException";
    ConfirmSignUpException["ExpiredCodeException"] = "ExpiredCodeException";
    ConfirmSignUpException["ForbiddenException"] = "ForbiddenException";
    ConfirmSignUpException["InternalErrorException"] = "InternalErrorException";
    ConfirmSignUpException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmSignUpException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmSignUpException["LimitExceededException"] = "LimitExceededException";
    ConfirmSignUpException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmSignUpException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmSignUpException["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    ConfirmSignUpException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmSignUpException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ConfirmSignUpException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ConfirmSignUpException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$2ec29642a27fd055 || ($c13b5be9426121ff$export$2ec29642a27fd055 = {}));
var $c13b5be9426121ff$export$c6d546f0ab5ecb26;
(function(DeleteUserAttributesException) {
    DeleteUserAttributesException["ForbiddenException"] = "ForbiddenException";
    DeleteUserAttributesException["InternalErrorException"] = "InternalErrorException";
    DeleteUserAttributesException["InvalidParameterException"] = "InvalidParameterException";
    DeleteUserAttributesException["NotAuthorizedException"] = "NotAuthorizedException";
    DeleteUserAttributesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    DeleteUserAttributesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    DeleteUserAttributesException["TooManyRequestsException"] = "TooManyRequestsException";
    DeleteUserAttributesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    DeleteUserAttributesException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$c6d546f0ab5ecb26 || ($c13b5be9426121ff$export$c6d546f0ab5ecb26 = {}));
var $c13b5be9426121ff$export$315864c77a135492;
(function(DeleteUserException) {
    DeleteUserException["ForbiddenException"] = "ForbiddenException";
    DeleteUserException["InternalErrorException"] = "InternalErrorException";
    DeleteUserException["InvalidParameterException"] = "InvalidParameterException";
    DeleteUserException["NotAuthorizedException"] = "NotAuthorizedException";
    DeleteUserException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    DeleteUserException["ResourceNotFoundException"] = "ResourceNotFoundException";
    DeleteUserException["TooManyRequestsException"] = "TooManyRequestsException";
    DeleteUserException["UserNotConfirmedException"] = "UserNotConfirmedException";
    DeleteUserException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$315864c77a135492 || ($c13b5be9426121ff$export$315864c77a135492 = {}));
var $c13b5be9426121ff$export$622cff54bc9a0bb0;
(function(ForgetDeviceException) {
    ForgetDeviceException["ForbiddenException"] = "ForbiddenException";
    ForgetDeviceException["InternalErrorException"] = "InternalErrorException";
    ForgetDeviceException["InvalidParameterException"] = "InvalidParameterException";
    ForgetDeviceException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ForgetDeviceException["NotAuthorizedException"] = "NotAuthorizedException";
    ForgetDeviceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ForgetDeviceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ForgetDeviceException["TooManyRequestsException"] = "TooManyRequestsException";
    ForgetDeviceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ForgetDeviceException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$622cff54bc9a0bb0 || ($c13b5be9426121ff$export$622cff54bc9a0bb0 = {}));
var $c13b5be9426121ff$export$cedaef1e1242f8be;
(function(ForgotPasswordException) {
    ForgotPasswordException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    ForgotPasswordException["ForbiddenException"] = "ForbiddenException";
    ForgotPasswordException["InternalErrorException"] = "InternalErrorException";
    ForgotPasswordException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    ForgotPasswordException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ForgotPasswordException["InvalidParameterException"] = "InvalidParameterException";
    ForgotPasswordException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    ForgotPasswordException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    ForgotPasswordException["LimitExceededException"] = "LimitExceededException";
    ForgotPasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ForgotPasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ForgotPasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ForgotPasswordException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ForgotPasswordException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ForgotPasswordException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$cedaef1e1242f8be || ($c13b5be9426121ff$export$cedaef1e1242f8be = {}));
var $c13b5be9426121ff$export$8d5b6b7a140e0c94;
(function(GetUserException) {
    GetUserException["ForbiddenException"] = "ForbiddenException";
    GetUserException["InternalErrorException"] = "InternalErrorException";
    GetUserException["InvalidParameterException"] = "InvalidParameterException";
    GetUserException["NotAuthorizedException"] = "NotAuthorizedException";
    GetUserException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GetUserException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetUserException["TooManyRequestsException"] = "TooManyRequestsException";
    GetUserException["UserNotConfirmedException"] = "UserNotConfirmedException";
    GetUserException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$8d5b6b7a140e0c94 || ($c13b5be9426121ff$export$8d5b6b7a140e0c94 = {}));
var $c13b5be9426121ff$export$506f117795ed2bb2;
(function(GetIdException) {
    GetIdException["ExternalServiceException"] = "ExternalServiceException";
    GetIdException["InternalErrorException"] = "InternalErrorException";
    GetIdException["InvalidParameterException"] = "InvalidParameterException";
    GetIdException["LimitExceededException"] = "LimitExceededException";
    GetIdException["NotAuthorizedException"] = "NotAuthorizedException";
    GetIdException["ResourceConflictException"] = "ResourceConflictException";
    GetIdException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetIdException["TooManyRequestsException"] = "TooManyRequestsException";
})($c13b5be9426121ff$export$506f117795ed2bb2 || ($c13b5be9426121ff$export$506f117795ed2bb2 = {}));
var $c13b5be9426121ff$export$9bff15c85d75f437;
(function(GetCredentialsForIdentityException) {
    GetCredentialsForIdentityException["ExternalServiceException"] = "ExternalServiceException";
    GetCredentialsForIdentityException["InternalErrorException"] = "InternalErrorException";
    GetCredentialsForIdentityException["InvalidIdentityPoolConfigurationException"] = "InvalidIdentityPoolConfigurationException";
    GetCredentialsForIdentityException["InvalidParameterException"] = "InvalidParameterException";
    GetCredentialsForIdentityException["NotAuthorizedException"] = "NotAuthorizedException";
    GetCredentialsForIdentityException["ResourceConflictException"] = "ResourceConflictException";
    GetCredentialsForIdentityException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetCredentialsForIdentityException["TooManyRequestsException"] = "TooManyRequestsException";
})($c13b5be9426121ff$export$9bff15c85d75f437 || ($c13b5be9426121ff$export$9bff15c85d75f437 = {}));
var $c13b5be9426121ff$export$2a6bba23fbf84d1b;
(function(GetUserAttributeVerificationException) {
    GetUserAttributeVerificationException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    GetUserAttributeVerificationException["ForbiddenException"] = "ForbiddenException";
    GetUserAttributeVerificationException["InternalErrorException"] = "InternalErrorException";
    GetUserAttributeVerificationException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    GetUserAttributeVerificationException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    GetUserAttributeVerificationException["InvalidParameterException"] = "InvalidParameterException";
    GetUserAttributeVerificationException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    GetUserAttributeVerificationException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    GetUserAttributeVerificationException["LimitExceededException"] = "LimitExceededException";
    GetUserAttributeVerificationException["NotAuthorizedException"] = "NotAuthorizedException";
    GetUserAttributeVerificationException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GetUserAttributeVerificationException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetUserAttributeVerificationException["TooManyRequestsException"] = "TooManyRequestsException";
    GetUserAttributeVerificationException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    GetUserAttributeVerificationException["UserLambdaValidationException"] = "UserLambdaValidationException";
    GetUserAttributeVerificationException["UserNotConfirmedException"] = "UserNotConfirmedException";
    GetUserAttributeVerificationException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$2a6bba23fbf84d1b || ($c13b5be9426121ff$export$2a6bba23fbf84d1b = {}));
var $c13b5be9426121ff$export$3f7e490ba4e0b71e;
(function(GlobalSignOutException) {
    GlobalSignOutException["ForbiddenException"] = "ForbiddenException";
    GlobalSignOutException["InternalErrorException"] = "InternalErrorException";
    GlobalSignOutException["InvalidParameterException"] = "InvalidParameterException";
    GlobalSignOutException["NotAuthorizedException"] = "NotAuthorizedException";
    GlobalSignOutException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GlobalSignOutException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GlobalSignOutException["TooManyRequestsException"] = "TooManyRequestsException";
    GlobalSignOutException["UserNotConfirmedException"] = "UserNotConfirmedException";
})($c13b5be9426121ff$export$3f7e490ba4e0b71e || ($c13b5be9426121ff$export$3f7e490ba4e0b71e = {}));
var $c13b5be9426121ff$export$43ac0110dfdad33b;
(function(InitiateAuthException) {
    InitiateAuthException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    InitiateAuthException["ForbiddenException"] = "ForbiddenException";
    InitiateAuthException["InternalErrorException"] = "InternalErrorException";
    InitiateAuthException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    InitiateAuthException["InvalidParameterException"] = "InvalidParameterException";
    InitiateAuthException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    InitiateAuthException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    InitiateAuthException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    InitiateAuthException["NotAuthorizedException"] = "NotAuthorizedException";
    InitiateAuthException["ResourceNotFoundException"] = "ResourceNotFoundException";
    InitiateAuthException["TooManyRequestsException"] = "TooManyRequestsException";
    InitiateAuthException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    InitiateAuthException["UserLambdaValidationException"] = "UserLambdaValidationException";
    InitiateAuthException["UserNotConfirmedException"] = "UserNotConfirmedException";
    InitiateAuthException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$43ac0110dfdad33b || ($c13b5be9426121ff$export$43ac0110dfdad33b = {}));
var $c13b5be9426121ff$export$8807b62ddb0e4d9d;
(function(ResendConfirmationException) {
    ResendConfirmationException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    ResendConfirmationException["ForbiddenException"] = "ForbiddenException";
    ResendConfirmationException["InternalErrorException"] = "InternalErrorException";
    ResendConfirmationException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    ResendConfirmationException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ResendConfirmationException["InvalidParameterException"] = "InvalidParameterException";
    ResendConfirmationException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    ResendConfirmationException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    ResendConfirmationException["LimitExceededException"] = "LimitExceededException";
    ResendConfirmationException["NotAuthorizedException"] = "NotAuthorizedException";
    ResendConfirmationException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ResendConfirmationException["TooManyRequestsException"] = "TooManyRequestsException";
    ResendConfirmationException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ResendConfirmationException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ResendConfirmationException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$8807b62ddb0e4d9d || ($c13b5be9426121ff$export$8807b62ddb0e4d9d = {}));
var $c13b5be9426121ff$export$da9908386393628f;
(function(RespondToAuthChallengeException) {
    RespondToAuthChallengeException["AliasExistsException"] = "AliasExistsException";
    RespondToAuthChallengeException["CodeMismatchException"] = "CodeMismatchException";
    RespondToAuthChallengeException["ExpiredCodeException"] = "ExpiredCodeException";
    RespondToAuthChallengeException["ForbiddenException"] = "ForbiddenException";
    RespondToAuthChallengeException["InternalErrorException"] = "InternalErrorException";
    RespondToAuthChallengeException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    RespondToAuthChallengeException["InvalidParameterException"] = "InvalidParameterException";
    RespondToAuthChallengeException["InvalidPasswordException"] = "InvalidPasswordException";
    RespondToAuthChallengeException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    RespondToAuthChallengeException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    RespondToAuthChallengeException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    RespondToAuthChallengeException["MFAMethodNotFoundException"] = "MFAMethodNotFoundException";
    RespondToAuthChallengeException["NotAuthorizedException"] = "NotAuthorizedException";
    RespondToAuthChallengeException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    RespondToAuthChallengeException["ResourceNotFoundException"] = "ResourceNotFoundException";
    RespondToAuthChallengeException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
    RespondToAuthChallengeException["TooManyRequestsException"] = "TooManyRequestsException";
    RespondToAuthChallengeException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    RespondToAuthChallengeException["UserLambdaValidationException"] = "UserLambdaValidationException";
    RespondToAuthChallengeException["UserNotConfirmedException"] = "UserNotConfirmedException";
    RespondToAuthChallengeException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$da9908386393628f || ($c13b5be9426121ff$export$da9908386393628f = {}));
var $c13b5be9426121ff$export$23ea34859d89459d;
(function(SetUserMFAPreferenceException) {
    SetUserMFAPreferenceException["ForbiddenException"] = "ForbiddenException";
    SetUserMFAPreferenceException["InternalErrorException"] = "InternalErrorException";
    SetUserMFAPreferenceException["InvalidParameterException"] = "InvalidParameterException";
    SetUserMFAPreferenceException["NotAuthorizedException"] = "NotAuthorizedException";
    SetUserMFAPreferenceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    SetUserMFAPreferenceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    SetUserMFAPreferenceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    SetUserMFAPreferenceException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$23ea34859d89459d || ($c13b5be9426121ff$export$23ea34859d89459d = {}));
var $c13b5be9426121ff$export$d0816902ed99fce6;
(function(SignUpException) {
    SignUpException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    SignUpException["InternalErrorException"] = "InternalErrorException";
    SignUpException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    SignUpException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    SignUpException["InvalidParameterException"] = "InvalidParameterException";
    SignUpException["InvalidPasswordException"] = "InvalidPasswordException";
    SignUpException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    SignUpException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    SignUpException["NotAuthorizedException"] = "NotAuthorizedException";
    SignUpException["ResourceNotFoundException"] = "ResourceNotFoundException";
    SignUpException["TooManyRequestsException"] = "TooManyRequestsException";
    SignUpException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    SignUpException["UserLambdaValidationException"] = "UserLambdaValidationException";
    SignUpException["UsernameExistsException"] = "UsernameExistsException";
})($c13b5be9426121ff$export$d0816902ed99fce6 || ($c13b5be9426121ff$export$d0816902ed99fce6 = {}));
var $c13b5be9426121ff$export$44cb15f260897376;
(function(UpdateUserAttributesException) {
    UpdateUserAttributesException["AliasExistsException"] = "AliasExistsException";
    UpdateUserAttributesException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    UpdateUserAttributesException["CodeMismatchException"] = "CodeMismatchException";
    UpdateUserAttributesException["ExpiredCodeException"] = "ExpiredCodeException";
    UpdateUserAttributesException["ForbiddenException"] = "ForbiddenException";
    UpdateUserAttributesException["InternalErrorException"] = "InternalErrorException";
    UpdateUserAttributesException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    UpdateUserAttributesException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    UpdateUserAttributesException["InvalidParameterException"] = "InvalidParameterException";
    UpdateUserAttributesException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    UpdateUserAttributesException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    UpdateUserAttributesException["NotAuthorizedException"] = "NotAuthorizedException";
    UpdateUserAttributesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    UpdateUserAttributesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    UpdateUserAttributesException["TooManyRequestsException"] = "TooManyRequestsException";
    UpdateUserAttributesException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    UpdateUserAttributesException["UserLambdaValidationException"] = "UserLambdaValidationException";
    UpdateUserAttributesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    UpdateUserAttributesException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$44cb15f260897376 || ($c13b5be9426121ff$export$44cb15f260897376 = {}));
var $c13b5be9426121ff$export$a974f64d24be573a;
(function(VerifySoftwareTokenException) {
    VerifySoftwareTokenException["CodeMismatchException"] = "CodeMismatchException";
    VerifySoftwareTokenException["EnableSoftwareTokenMFAException"] = "EnableSoftwareTokenMFAException";
    VerifySoftwareTokenException["ForbiddenException"] = "ForbiddenException";
    VerifySoftwareTokenException["InternalErrorException"] = "InternalErrorException";
    VerifySoftwareTokenException["InvalidParameterException"] = "InvalidParameterException";
    VerifySoftwareTokenException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    VerifySoftwareTokenException["NotAuthorizedException"] = "NotAuthorizedException";
    VerifySoftwareTokenException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    VerifySoftwareTokenException["ResourceNotFoundException"] = "ResourceNotFoundException";
    VerifySoftwareTokenException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
    VerifySoftwareTokenException["TooManyRequestsException"] = "TooManyRequestsException";
    VerifySoftwareTokenException["UserNotConfirmedException"] = "UserNotConfirmedException";
    VerifySoftwareTokenException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$a974f64d24be573a || ($c13b5be9426121ff$export$a974f64d24be573a = {}));
var $c13b5be9426121ff$export$527caabb62d14fe3;
(function(VerifyUserAttributeException) {
    VerifyUserAttributeException["AliasExistsException"] = "AliasExistsException";
    VerifyUserAttributeException["CodeMismatchException"] = "CodeMismatchException";
    VerifyUserAttributeException["ExpiredCodeException"] = "ExpiredCodeException";
    VerifyUserAttributeException["ForbiddenException"] = "ForbiddenException";
    VerifyUserAttributeException["InternalErrorException"] = "InternalErrorException";
    VerifyUserAttributeException["InvalidParameterException"] = "InvalidParameterException";
    VerifyUserAttributeException["LimitExceededException"] = "LimitExceededException";
    VerifyUserAttributeException["NotAuthorizedException"] = "NotAuthorizedException";
    VerifyUserAttributeException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    VerifyUserAttributeException["ResourceNotFoundException"] = "ResourceNotFoundException";
    VerifyUserAttributeException["TooManyRequestsException"] = "TooManyRequestsException";
    VerifyUserAttributeException["UserNotConfirmedException"] = "UserNotConfirmedException";
    VerifyUserAttributeException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$527caabb62d14fe3 || ($c13b5be9426121ff$export$527caabb62d14fe3 = {}));
var $c13b5be9426121ff$export$de57be1863bdb9d6;
(function(UpdateDeviceStatusException) {
    UpdateDeviceStatusException["ForbiddenException"] = "ForbiddenException";
    UpdateDeviceStatusException["InternalErrorException"] = "InternalErrorException";
    UpdateDeviceStatusException["InvalidParameterException"] = "InvalidParameterException";
    UpdateDeviceStatusException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    UpdateDeviceStatusException["NotAuthorizedException"] = "NotAuthorizedException";
    UpdateDeviceStatusException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    UpdateDeviceStatusException["ResourceNotFoundException"] = "ResourceNotFoundException";
    UpdateDeviceStatusException["TooManyRequestsException"] = "TooManyRequestsException";
    UpdateDeviceStatusException["UserNotConfirmedException"] = "UserNotConfirmedException";
    UpdateDeviceStatusException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$de57be1863bdb9d6 || ($c13b5be9426121ff$export$de57be1863bdb9d6 = {}));
var $c13b5be9426121ff$export$eb8cb06bdb07bf0c;
(function(ListDevicesException) {
    ListDevicesException["ForbiddenException"] = "ForbiddenException";
    ListDevicesException["InternalErrorException"] = "InternalErrorException";
    ListDevicesException["InvalidParameterException"] = "InvalidParameterException";
    ListDevicesException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ListDevicesException["NotAuthorizedException"] = "NotAuthorizedException";
    ListDevicesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ListDevicesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ListDevicesException["TooManyRequestsException"] = "TooManyRequestsException";
    ListDevicesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ListDevicesException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$eb8cb06bdb07bf0c || ($c13b5be9426121ff$export$eb8cb06bdb07bf0c = {}));
const $c13b5be9426121ff$export$ecd3eb1722b48d26 = "SetUpTOTPException";




















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $1592ec11dd7f6ec9$export$11329f5ae466ab5d = (config)=>(0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $2c989c9ee9688ddf$export$10f11e95d7a96f7b), (0, $644eb7a063c0ce65$export$1113413e6e842bef)("RespondToAuthChallenge"), (0, $70b030255b6cf783$export$8159795418a3e796)(), {
        ...(0, $ab5c45a15b3ed82d$export$22a3716e7860147a),
        ...config
    });









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8cd905d9735a558c$export$cf5dd9429415aa98 = (config)=>(0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $2c989c9ee9688ddf$export$10f11e95d7a96f7b), (0, $644eb7a063c0ce65$export$1113413e6e842bef)("VerifySoftwareToken"), (0, $70b030255b6cf783$export$8159795418a3e796)(), {
        ...(0, $ab5c45a15b3ed82d$export$22a3716e7860147a),
        ...config
    });









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $013d14f6ec1bab3a$export$6bff32634453de2a = (config)=>(0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $2c989c9ee9688ddf$export$10f11e95d7a96f7b), (0, $644eb7a063c0ce65$export$1113413e6e842bef)("AssociateSoftwareToken"), (0, $70b030255b6cf783$export$8159795418a3e796)(), {
        ...(0, $ab5c45a15b3ed82d$export$22a3716e7860147a),
        ...config
    });









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $27402b0d0d11528d$export$d88a63af6351a7c3 = (config)=>(0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $2c989c9ee9688ddf$export$10f11e95d7a96f7b), (0, $644eb7a063c0ce65$export$1113413e6e842bef)("ConfirmDevice"), (0, $70b030255b6cf783$export$8159795418a3e796)(), {
        ...(0, $ab5c45a15b3ed82d$export$22a3716e7860147a),
        ...config
    });



















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function $f111a020d487e86b$export$729df6fdd19b8b0d(AuthenticationResult) {
    if (AuthenticationResult.AccessToken) {
        const accessToken = (0, $d0b404dc65adc192$export$9a62e6c0a30e00bc)(AuthenticationResult.AccessToken);
        const accessTokenIssuedAtInMillis = (accessToken.payload.iat || 0) * 1000;
        const currentTime = new Date().getTime();
        const clockDrift = accessTokenIssuedAtInMillis > 0 ? accessTokenIssuedAtInMillis - currentTime : 0;
        let idToken;
        let refreshToken;
        let deviceMetadata;
        if (AuthenticationResult.RefreshToken) refreshToken = AuthenticationResult.RefreshToken;
        if (AuthenticationResult.IdToken) idToken = (0, $d0b404dc65adc192$export$9a62e6c0a30e00bc)(AuthenticationResult.IdToken);
        if (AuthenticationResult?.NewDeviceMetadata) deviceMetadata = AuthenticationResult.NewDeviceMetadata;
        const tokens = {
            accessToken: accessToken,
            idToken: idToken,
            refreshToken: refreshToken,
            clockDrift: clockDrift,
            deviceMetadata: deviceMetadata,
            username: AuthenticationResult.username
        };
        if (AuthenticationResult?.signInDetails) tokens.signInDetails = AuthenticationResult.signInDetails;
        await (0, $8165b6923e40c4bf$export$66561e66d62991d0).setTokens({
            tokens: tokens
        });
    } else // This would be a service error
    throw new (0, $05b2dc7abeec3af3$export$37321a6dace1881c)({
        message: "Invalid tokens",
        name: "InvalidTokens",
        recoverySuggestion: "Check Cognito UserPool settings"
    });
}







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e91f0cfaaf120c70$export$3f27bc10068ef877 = "Unable to get user session following successful sign-in.";
const $e91f0cfaaf120c70$export$4d78d2ee899572ab = async ()=>{
    try {
        (0, $c9802061728ce106$export$8c41bb232f1008b1).dispatch("auth", {
            event: "signedIn",
            data: await (0, $06d09becd613c1b3$export$e5432d4c8eb97ea7)()
        }, "Auth", (0, $c9802061728ce106$export$aadf71dd9875dd20));
    } catch (error) {
        if (error.name === (0, $d78d124ef376faa5$export$d29d1996d6b6f5e3)) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: (0, $d78d124ef376faa5$export$606cffc85964c24b),
            message: $e91f0cfaaf120c70$export$3f27bc10068ef877,
            recoverySuggestion: "This most likely is due to auth tokens not being persisted. If you are using cookie store, please ensure cookies can be correctly set from your server."
        });
        throw error;
    }
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Minutes until stored session invalidates
const $af24ca9998616e43$var$MS_TO_EXPIRY = 180000; // 3 mins
const $af24ca9998616e43$var$TGT_STATE = "CognitoSignInState";
const $af24ca9998616e43$var$SIGN_IN_STATE_KEYS = {
    username: `${$af24ca9998616e43$var$TGT_STATE}.username`,
    challengeName: `${$af24ca9998616e43$var$TGT_STATE}.challengeName`,
    signInSession: `${$af24ca9998616e43$var$TGT_STATE}.signInSession`,
    expiry: `${$af24ca9998616e43$var$TGT_STATE}.expiry`
};
const $af24ca9998616e43$var$signInReducer = (state, action)=>{
    switch(action.type){
        case "SET_SIGN_IN_SESSION":
            $af24ca9998616e43$export$f0d4bc0f1640c562({
                signInSession: action.value
            });
            return {
                ...state,
                signInSession: action.value
            };
        case "SET_SIGN_IN_STATE":
            $af24ca9998616e43$export$f0d4bc0f1640c562(action.value);
            return {
                ...action.value
            };
        case "SET_CHALLENGE_NAME":
            $af24ca9998616e43$export$f0d4bc0f1640c562({
                challengeName: action.value
            });
            return {
                ...state,
                challengeName: action.value
            };
        case "SET_USERNAME":
            $af24ca9998616e43$export$f0d4bc0f1640c562({
                username: action.value
            });
            return {
                ...state,
                username: action.value
            };
        case "SET_INITIAL_STATE":
            return $af24ca9998616e43$var$getInitialState();
        case "RESET_STATE":
            $af24ca9998616e43$var$clearPersistedSignInState();
            return $af24ca9998616e43$var$getDefaultState();
        // this state is never reachable
        default:
            return state;
    }
};
const $af24ca9998616e43$var$isExpired = (expiryDate)=>{
    const expiryTimestamp = Number(expiryDate);
    const currentTimestamp = Date.now();
    return expiryTimestamp <= currentTimestamp;
};
const $af24ca9998616e43$export$ddfd5a0262ce9df3 = ()=>{
    $af24ca9998616e43$export$390d5da4c63a4a41.dispatch({
        type: "RESET_STATE"
    });
};
const $af24ca9998616e43$var$clearPersistedSignInState = ()=>{
    for (const stateKey of Object.values($af24ca9998616e43$var$SIGN_IN_STATE_KEYS))(0, $c1a7077392f3b8b2$export$9015f19b74348a18).removeItem(stateKey);
};
const $af24ca9998616e43$var$getDefaultState = ()=>({
        username: undefined,
        challengeName: undefined,
        signInSession: undefined
    });
// Hydrate signInStore from syncSessionStorage
const $af24ca9998616e43$var$getInitialState = ()=>{
    const expiry = (0, $c1a7077392f3b8b2$export$9015f19b74348a18).getItem($af24ca9998616e43$var$SIGN_IN_STATE_KEYS.expiry);
    if (!expiry || $af24ca9998616e43$var$isExpired(expiry)) {
        $af24ca9998616e43$var$clearPersistedSignInState();
        return $af24ca9998616e43$var$getDefaultState();
    }
    const username = (0, $c1a7077392f3b8b2$export$9015f19b74348a18).getItem($af24ca9998616e43$var$SIGN_IN_STATE_KEYS.username) ?? undefined;
    const challengeName = (0, $c1a7077392f3b8b2$export$9015f19b74348a18).getItem($af24ca9998616e43$var$SIGN_IN_STATE_KEYS.challengeName) ?? undefined;
    const signInSession = (0, $c1a7077392f3b8b2$export$9015f19b74348a18).getItem($af24ca9998616e43$var$SIGN_IN_STATE_KEYS.signInSession) ?? undefined;
    return {
        username: username,
        challengeName: challengeName,
        signInSession: signInSession
    };
};
const $af24ca9998616e43$var$createStore = (reducer)=>{
    let currentState = reducer($af24ca9998616e43$var$getDefaultState(), {
        type: "SET_INITIAL_STATE"
    });
    return {
        getState: ()=>currentState,
        dispatch: (action)=>{
            currentState = reducer(currentState, action);
        }
    };
};
const $af24ca9998616e43$export$390d5da4c63a4a41 = $af24ca9998616e43$var$createStore($af24ca9998616e43$var$signInReducer);
function $af24ca9998616e43$export$bae72361b690e075(state) {
    $af24ca9998616e43$export$390d5da4c63a4a41.dispatch({
        type: "SET_SIGN_IN_STATE",
        value: state
    });
}
// Save local state into Session Storage
const $af24ca9998616e43$export$f0d4bc0f1640c562 = ({ challengeName: challengeName , signInSession: signInSession , username: username  })=>{
    username && (0, $c1a7077392f3b8b2$export$9015f19b74348a18).setItem($af24ca9998616e43$var$SIGN_IN_STATE_KEYS.username, username);
    challengeName && (0, $c1a7077392f3b8b2$export$9015f19b74348a18).setItem($af24ca9998616e43$var$SIGN_IN_STATE_KEYS.challengeName, challengeName);
    if (signInSession) {
        (0, $c1a7077392f3b8b2$export$9015f19b74348a18).setItem($af24ca9998616e43$var$SIGN_IN_STATE_KEYS.signInSession, signInSession);
        // Updates expiry when session is passed
        (0, $c1a7077392f3b8b2$export$9015f19b74348a18).setItem($af24ca9998616e43$var$SIGN_IN_STATE_KEYS.expiry, String(Date.now() + $af24ca9998616e43$var$MS_TO_EXPIRY));
    }
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $2dc1f5091ed86e53$export$bf0fd5fd31fb5a90 extends (0, $05b2dc7abeec3af3$export$37321a6dace1881c) {
    constructor(params){
        super(params);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $2dc1f5091ed86e53$export$bf0fd5fd31fb5a90;
        Object.setPrototypeOf(this, $2dc1f5091ed86e53$export$bf0fd5fd31fb5a90.prototype);
    }
}
var $2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e;
(function(PasskeyErrorCode) {
    // not supported
    PasskeyErrorCode["PasskeyNotSupported"] = "PasskeyNotSupported";
    // duplicate passkey
    PasskeyErrorCode["PasskeyAlreadyExists"] = "PasskeyAlreadyExists";
    // misconfigurations
    PasskeyErrorCode["InvalidPasskeyRegistrationOptions"] = "InvalidPasskeyRegistrationOptions";
    PasskeyErrorCode["InvalidPasskeyAuthenticationOptions"] = "InvalidPasskeyAuthenticationOptions";
    PasskeyErrorCode["RelyingPartyMismatch"] = "RelyingPartyMismatch";
    // failed credential creation / retrieval
    PasskeyErrorCode["PasskeyRegistrationFailed"] = "PasskeyRegistrationFailed";
    PasskeyErrorCode["PasskeyRetrievalFailed"] = "PasskeyRetrievalFailed";
    // cancel / aborts
    PasskeyErrorCode["PasskeyRegistrationCanceled"] = "PasskeyRegistrationCanceled";
    PasskeyErrorCode["PasskeyAuthenticationCanceled"] = "PasskeyAuthenticationCanceled";
    PasskeyErrorCode["PasskeyOperationAborted"] = "PasskeyOperationAborted";
})($2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e || ($2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e = {}));
const $2dc1f5091ed86e53$var$notSupportedRecoverySuggestion = "Passkeys may not be supported on this device. Ensure your application is running in a secure context (HTTPS) and Web Authentication API is supported.";
const $2dc1f5091ed86e53$var$abortOrCancelRecoverySuggestion = "User may have canceled the ceremony or another interruption has occurred. Check underlying error for details.";
const $2dc1f5091ed86e53$var$misconfigurationRecoverySuggestion = "Ensure your user pool is configured to support the WEB_AUTHN as an authentication factor.";
const $2dc1f5091ed86e53$var$passkeyErrorMap = {
    [$2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.PasskeyNotSupported]: {
        message: "Passkeys may not be supported on this device.",
        recoverySuggestion: $2dc1f5091ed86e53$var$notSupportedRecoverySuggestion
    },
    [$2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.InvalidPasskeyRegistrationOptions]: {
        message: "Invalid passkey registration options.",
        recoverySuggestion: $2dc1f5091ed86e53$var$misconfigurationRecoverySuggestion
    },
    [$2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.InvalidPasskeyAuthenticationOptions]: {
        message: "Invalid passkey authentication options.",
        recoverySuggestion: $2dc1f5091ed86e53$var$misconfigurationRecoverySuggestion
    },
    [$2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.PasskeyRegistrationFailed]: {
        message: "Device failed to create passkey.",
        recoverySuggestion: $2dc1f5091ed86e53$var$notSupportedRecoverySuggestion
    },
    [$2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.PasskeyRetrievalFailed]: {
        message: "Device failed to retrieve passkey.",
        recoverySuggestion: "Passkeys may not be available on this device. Try an alternative authentication factor like PASSWORD, EMAIL_OTP, or SMS_OTP."
    },
    [$2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.PasskeyAlreadyExists]: {
        message: "Passkey already exists in authenticator.",
        recoverySuggestion: "Proceed with existing passkey or try again after deleting the credential."
    },
    [$2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.PasskeyRegistrationCanceled]: {
        message: "Passkey registration ceremony has been canceled.",
        recoverySuggestion: $2dc1f5091ed86e53$var$abortOrCancelRecoverySuggestion
    },
    [$2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.PasskeyAuthenticationCanceled]: {
        message: "Passkey authentication ceremony has been canceled.",
        recoverySuggestion: $2dc1f5091ed86e53$var$abortOrCancelRecoverySuggestion
    },
    [$2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.PasskeyOperationAborted]: {
        message: "Passkey operation has been aborted.",
        recoverySuggestion: $2dc1f5091ed86e53$var$abortOrCancelRecoverySuggestion
    },
    [$2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.RelyingPartyMismatch]: {
        message: "Relying party does not match current domain.",
        recoverySuggestion: "Ensure relying party identifier matches current domain."
    }
};
const $2dc1f5091ed86e53$export$3145abf24cf8a54e = (0, $2923b69a4f2b8c7f$export$5cb8fc27ccbe9d40)($2dc1f5091ed86e53$var$passkeyErrorMap, $2dc1f5091ed86e53$export$bf0fd5fd31fb5a90);
/**
 * Handle Passkey Authentication Errors
 * https://w3c.github.io/webauthn/#sctn-get-request-exceptions
 *
 * @param err unknown
 * @returns PasskeyError
 */ const $2dc1f5091ed86e53$export$6abde9ceb8dfddc0 = (err)=>{
    if (err instanceof $2dc1f5091ed86e53$export$bf0fd5fd31fb5a90) return err;
    if (err instanceof Error) {
        if (err.name === "NotAllowedError") {
            const { message: message , recoverySuggestion: recoverySuggestion  } = $2dc1f5091ed86e53$var$passkeyErrorMap[$2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.PasskeyAuthenticationCanceled];
            return new $2dc1f5091ed86e53$export$bf0fd5fd31fb5a90({
                name: $2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.PasskeyAuthenticationCanceled,
                message: message,
                recoverySuggestion: recoverySuggestion,
                underlyingError: err
            });
        }
    }
    return $2dc1f5091ed86e53$var$handlePasskeyError(err);
};
/**
 * Handle Passkey Registration Errors
 * https://w3c.github.io/webauthn/#sctn-create-request-exceptions
 *
 * @param err unknown
 * @returns PasskeyError
 */ const $2dc1f5091ed86e53$export$7460eb590a766e24 = (err)=>{
    if (err instanceof $2dc1f5091ed86e53$export$bf0fd5fd31fb5a90) return err;
    if (err instanceof Error) {
        // Duplicate Passkey
        if (err.name === "InvalidStateError") {
            const { message: message , recoverySuggestion: recoverySuggestion  } = $2dc1f5091ed86e53$var$passkeyErrorMap[$2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.PasskeyAlreadyExists];
            return new $2dc1f5091ed86e53$export$bf0fd5fd31fb5a90({
                name: $2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.PasskeyAlreadyExists,
                message: message,
                recoverySuggestion: recoverySuggestion,
                underlyingError: err
            });
        }
        // User Cancels Ceremony / Generic Catch All
        if (err.name === "NotAllowedError") {
            const { message: message , recoverySuggestion: recoverySuggestion  } = $2dc1f5091ed86e53$var$passkeyErrorMap[$2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.PasskeyRegistrationCanceled];
            return new $2dc1f5091ed86e53$export$bf0fd5fd31fb5a90({
                name: $2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.PasskeyRegistrationCanceled,
                message: message,
                recoverySuggestion: recoverySuggestion,
                underlyingError: err
            });
        }
    }
    return $2dc1f5091ed86e53$var$handlePasskeyError(err);
};
/**
 * Handles Overlapping Passkey Errors Between Registration & Authentication
 * https://w3c.github.io/webauthn/#sctn-create-request-exceptions
 * https://w3c.github.io/webauthn/#sctn-get-request-exceptions
 *
 * @param err unknown
 * @returns PasskeyError
 */ const $2dc1f5091ed86e53$var$handlePasskeyError = (err)=>{
    if (err instanceof Error) {
        // Passkey Operation Aborted
        if (err.name === "AbortError") {
            const { message: message , recoverySuggestion: recoverySuggestion  } = $2dc1f5091ed86e53$var$passkeyErrorMap[$2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.PasskeyOperationAborted];
            return new $2dc1f5091ed86e53$export$bf0fd5fd31fb5a90({
                name: $2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.PasskeyOperationAborted,
                message: message,
                recoverySuggestion: recoverySuggestion,
                underlyingError: err
            });
        }
        // Relying Party / Domain Mismatch
        if (err.name === "SecurityError") {
            const { message: message , recoverySuggestion: recoverySuggestion  } = $2dc1f5091ed86e53$var$passkeyErrorMap[$2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.RelyingPartyMismatch];
            return new $2dc1f5091ed86e53$export$bf0fd5fd31fb5a90({
                name: $2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e.RelyingPartyMismatch,
                message: message,
                recoverySuggestion: recoverySuggestion,
                underlyingError: err
            });
        }
    }
    return new $2dc1f5091ed86e53$export$bf0fd5fd31fb5a90({
        name: (0, $e4876bf018e81b36$export$4e712df6b850c8d0).Unknown,
        message: "An unknown error has occurred.",
        underlyingError: err
    });
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Determines if passkey is supported in current context
 * Will return false if executed in non-secure context
 * @returns boolean
 */ const $1794b9e7b00a434a$export$3b0e0bb0e9c22c1a = ()=>{
    return (0, $667590a172222acf$export$4e09c449d6c407f7)() && window.isSecureContext && "credentials" in navigator && typeof window.PublicKeyCredential === "function";
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// https://datatracker.ietf.org/doc/html/rfc4648#page-7
/**
 * Converts an ArrayBuffer to a base64url encoded string
 * @param buffer - the ArrayBuffer instance of a Uint8Array
 * @returns string - a base64url encoded string
 */ const $3e89dd29a231aaa3$export$442d4feb149fcd32 = (buffer)=>{
    return (0, $0f87662804872ba2$export$695b149896bd3e2a).convert(new Uint8Array(buffer), {
        urlSafe: true,
        skipPadding: true
    });
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a base64url encoded string to an ArrayBuffer
 * @param base64url - a base64url encoded string
 * @returns ArrayBuffer
 */ const $5f766079c4e90177$export$9cebd483a59f0168 = (base64url)=>{
    return Uint8Array.from((0, $ef7237a6eb0adc7d$export$1e303d38dab7b376).convert(base64url, {
        urlSafe: true
    }), (x)=>x.charCodeAt(0)).buffer;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Deserializes Public Key Credential Creation Options JSON
 * @param input PasskeyCreateOptionsJson
 * @returns PublicKeyCredentialCreationOptions
 */ const $39d803693cb8502c$export$a8f43933ee13e976 = (input)=>{
    const userIdBuffer = (0, $5f766079c4e90177$export$9cebd483a59f0168)(input.user.id);
    const challengeBuffer = (0, $5f766079c4e90177$export$9cebd483a59f0168)(input.challenge);
    const excludeCredentialsWithBuffer = (input.excludeCredentials || []).map((excludeCred)=>({
            ...excludeCred,
            id: (0, $5f766079c4e90177$export$9cebd483a59f0168)(excludeCred.id)
        }));
    return {
        ...input,
        excludeCredentials: excludeCredentialsWithBuffer,
        challenge: challengeBuffer,
        user: {
            ...input.user,
            id: userIdBuffer
        }
    };
};
/**
 * Serializes a Public Key Credential With Attestation to JSON
 * @param input PasskeyCreateResult
 * @returns PasskeyCreateResultJson
 */ const $39d803693cb8502c$export$f686d838e2fa9da3 = (input)=>{
    const response = {
        clientDataJSON: (0, $3e89dd29a231aaa3$export$442d4feb149fcd32)(input.response.clientDataJSON),
        attestationObject: (0, $3e89dd29a231aaa3$export$442d4feb149fcd32)(input.response.attestationObject),
        transports: input.response.getTransports(),
        publicKeyAlgorithm: input.response.getPublicKeyAlgorithm(),
        authenticatorData: (0, $3e89dd29a231aaa3$export$442d4feb149fcd32)(input.response.getAuthenticatorData())
    };
    const publicKey = input.response.getPublicKey();
    if (publicKey) response.publicKey = (0, $3e89dd29a231aaa3$export$442d4feb149fcd32)(publicKey);
    const resultJson = {
        type: input.type,
        id: input.id,
        rawId: (0, $3e89dd29a231aaa3$export$442d4feb149fcd32)(input.rawId),
        clientExtensionResults: input.getClientExtensionResults(),
        response: response
    };
    if (input.authenticatorAttachment) resultJson.authenticatorAttachment = input.authenticatorAttachment;
    return resultJson;
};
/**
 * Deserializes Public Key Credential Get Options JSON
 * @param input PasskeyGetOptionsJson
 * @returns PublicKeyCredentialRequestOptions
 */ const $39d803693cb8502c$export$d3f47ce866c52e8e = (input)=>{
    const challengeBuffer = (0, $5f766079c4e90177$export$9cebd483a59f0168)(input.challenge);
    const allowedCredentialsWithBuffer = (input.allowCredentials || []).map((allowedCred)=>({
            ...allowedCred,
            id: (0, $5f766079c4e90177$export$9cebd483a59f0168)(allowedCred.id)
        }));
    return {
        ...input,
        challenge: challengeBuffer,
        allowCredentials: allowedCredentialsWithBuffer
    };
};
/**
 * Serializes a Public Key Credential With Attestation to JSON
 * @param input PasskeyGetResult
 * @returns PasskeyGetResultJson
 */ const $39d803693cb8502c$export$1f22b133ac0d2a5 = (input)=>{
    const response = {
        clientDataJSON: (0, $3e89dd29a231aaa3$export$442d4feb149fcd32)(input.response.clientDataJSON),
        authenticatorData: (0, $3e89dd29a231aaa3$export$442d4feb149fcd32)(input.response.authenticatorData),
        signature: (0, $3e89dd29a231aaa3$export$442d4feb149fcd32)(input.response.signature)
    };
    if (input.response.userHandle) response.userHandle = (0, $3e89dd29a231aaa3$export$442d4feb149fcd32)(input.response.userHandle);
    const resultJson = {
        id: input.id,
        rawId: (0, $3e89dd29a231aaa3$export$442d4feb149fcd32)(input.rawId),
        type: input.type,
        clientExtensionResults: input.getClientExtensionResults(),
        response: response
    };
    if (input.authenticatorAttachment) resultJson.authenticatorAttachment = input.authenticatorAttachment;
    return resultJson;
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $616af16f301da208$export$c7806094d9c936a2(credential) {
    (0, $2dc1f5091ed86e53$export$3145abf24cf8a54e)(credential && credential instanceof PublicKeyCredential && credential.response instanceof AuthenticatorAttestationResponse, (0, $2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e).PasskeyRegistrationFailed);
}
function $616af16f301da208$export$4f19e511a89efed7(credential) {
    (0, $2dc1f5091ed86e53$export$3145abf24cf8a54e)(credential && credential instanceof PublicKeyCredential && credential.response instanceof AuthenticatorAssertionResponse, (0, $2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e).PasskeyRetrievalFailed);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $274306103ff3b444$export$d7f92bd7f1e366c1 = async (input)=>{
    try {
        const isPasskeySupported = (0, $1794b9e7b00a434a$export$3b0e0bb0e9c22c1a)();
        (0, $2dc1f5091ed86e53$export$3145abf24cf8a54e)(isPasskeySupported, (0, $2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e).PasskeyNotSupported);
        const passkeyGetOptions = (0, $39d803693cb8502c$export$d3f47ce866c52e8e)(input);
        const credential = await navigator.credentials.get({
            publicKey: passkeyGetOptions
        });
        (0, $616af16f301da208$export$4f19e511a89efed7)(credential);
        return (0, $39d803693cb8502c$export$1f22b133ac0d2a5)(credential);
    } catch (err) {
        throw (0, $2dc1f5091ed86e53$export$6abde9ceb8dfddc0)(err);
    }
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function $15550a31f4f7a21e$export$77701654924537aa(challengeParameters) {
    const authConfig = (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    const { username: username , signInSession: signInSession , signInDetails: signInDetails , challengeName: challengeName  } = (0, $af24ca9998616e43$export$390d5da4c63a4a41).getState();
    if (challengeName !== "WEB_AUTHN" || !username) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: (0, $7ccba6b199ab94b3$export$473ab0b56598aacd).SignInException,
        message: "Unable to proceed due to invalid sign in state."
    });
    const { CREDENTIAL_REQUEST_OPTIONS: credentialRequestOptions  } = challengeParameters;
    (0, $2dc1f5091ed86e53$export$3145abf24cf8a54e)(!!credentialRequestOptions, (0, $2dc1f5091ed86e53$export$8c9a5e3ce7fcf74e).InvalidPasskeyAuthenticationOptions);
    const cred = await (0, $274306103ff3b444$export$d7f92bd7f1e366c1)(JSON.parse(credentialRequestOptions));
    const respondToAuthChallenge = (0, $1592ec11dd7f6ec9$export$11329f5ae466ab5d)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: authConfig.userPoolEndpoint
        })
    });
    const { ChallengeName: nextChallengeName , ChallengeParameters: nextChallengeParameters , AuthenticationResult: authenticationResult , Session: nextSession  } = await respondToAuthChallenge({
        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(authConfig.userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        ChallengeName: "WEB_AUTHN",
        ChallengeResponses: {
            USERNAME: username,
            CREDENTIAL: JSON.stringify(cred)
        },
        ClientId: authConfig.userPoolClientId,
        Session: signInSession
    });
    (0, $af24ca9998616e43$export$bae72361b690e075)({
        signInSession: nextSession,
        username: username,
        challengeName: nextChallengeName,
        signInDetails: signInDetails
    });
    if (authenticationResult) {
        await (0, $f111a020d487e86b$export$729df6fdd19b8b0d)({
            ...authenticationResult,
            username: username,
            NewDeviceMetadata: await (0, $1ca9fe6154565c83$export$548ed8ad974a8b30)({
                userPoolId: authConfig.userPoolId,
                userPoolEndpoint: authConfig.userPoolEndpoint,
                newDeviceMetadata: authenticationResult.NewDeviceMetadata,
                accessToken: authenticationResult.AccessToken
            }),
            signInDetails: signInDetails
        });
        (0, $af24ca9998616e43$export$390d5da4c63a4a41).dispatch({
            type: "RESET_STATE"
        });
        await (0, $e91f0cfaaf120c70$export$4d78d2ee899572ab)();
        return {
            isSignedIn: true,
            nextStep: {
                signInStep: "DONE"
            }
        };
    }
    if (nextChallengeName === "WEB_AUTHN") throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: (0, $7ccba6b199ab94b3$export$473ab0b56598aacd).SignInException,
        message: "Sequential WEB_AUTHN challenges returned from underlying service cannot be handled."
    });
    return (0, $1ca9fe6154565c83$export$cf152400b58b8e65)({
        challengeName: nextChallengeName,
        challengeParameters: nextChallengeParameters
    });
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8afd980693d9bf70$export$f5d75491a17f02c = {
    convert (input) {
        return new TextEncoder().encode(input);
    }
};


/* eslint-disable */ // @ts-nocheck -> BigInteger is already a vended utility
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $839faf96146888f4$export$2e2bcd8739ae039(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function $839faf96146888f4$var$nbi() {
    return new $839faf96146888f4$export$2e2bcd8739ae039(null, null);
}
// Bits per digit
let $839faf96146888f4$var$dbits;
// JavaScript engine analysis
const $839faf96146888f4$var$canary = 0xdeadbeefcafe;
const $839faf96146888f4$var$j_lm = ($839faf96146888f4$var$canary & 0xffffff) === 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $839faf96146888f4$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        const v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $839faf96146888f4$var$am2(i, x, w, j, c, n) {
    const xl = x & 0x7fff;
    const xh = x >> 15;
    while(--n >= 0){
        let l = this[i] & 0x7fff;
        const h = this[i++] >> 15;
        const m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $839faf96146888f4$var$am3(i, x, w, j, c, n) {
    const xl = x & 0x3fff;
    const xh = x >> 14;
    while(--n >= 0){
        let l = this[i] & 0x3fff;
        const h = this[i++] >> 14;
        const m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
const $839faf96146888f4$var$inBrowser = typeof navigator !== "undefined";
if ($839faf96146888f4$var$inBrowser && $839faf96146888f4$var$j_lm && navigator.appName === "Microsoft Internet Explorer") {
    $839faf96146888f4$export$2e2bcd8739ae039.prototype.am = $839faf96146888f4$var$am2;
    $839faf96146888f4$var$dbits = 30;
} else if ($839faf96146888f4$var$inBrowser && $839faf96146888f4$var$j_lm && navigator.appName !== "Netscape") {
    $839faf96146888f4$export$2e2bcd8739ae039.prototype.am = $839faf96146888f4$var$am1;
    $839faf96146888f4$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $839faf96146888f4$export$2e2bcd8739ae039.prototype.am = $839faf96146888f4$var$am3;
    $839faf96146888f4$var$dbits = 28;
}
$839faf96146888f4$export$2e2bcd8739ae039.prototype.DB = $839faf96146888f4$var$dbits;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.DM = (1 << $839faf96146888f4$var$dbits) - 1;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.DV = 1 << $839faf96146888f4$var$dbits;
const $839faf96146888f4$var$BI_FP = 52;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.FV = Math.pow(2, $839faf96146888f4$var$BI_FP);
$839faf96146888f4$export$2e2bcd8739ae039.prototype.F1 = $839faf96146888f4$var$BI_FP - $839faf96146888f4$var$dbits;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.F2 = 2 * $839faf96146888f4$var$dbits - $839faf96146888f4$var$BI_FP;
// Digit conversions
const $839faf96146888f4$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
const $839faf96146888f4$var$BI_RC = [];
let $839faf96146888f4$var$rr, $839faf96146888f4$var$vv;
$839faf96146888f4$var$rr = "0".charCodeAt(0);
for($839faf96146888f4$var$vv = 0; $839faf96146888f4$var$vv <= 9; ++$839faf96146888f4$var$vv)$839faf96146888f4$var$BI_RC[$839faf96146888f4$var$rr++] = $839faf96146888f4$var$vv;
$839faf96146888f4$var$rr = "a".charCodeAt(0);
for($839faf96146888f4$var$vv = 10; $839faf96146888f4$var$vv < 36; ++$839faf96146888f4$var$vv)$839faf96146888f4$var$BI_RC[$839faf96146888f4$var$rr++] = $839faf96146888f4$var$vv;
$839faf96146888f4$var$rr = "A".charCodeAt(0);
for($839faf96146888f4$var$vv = 10; $839faf96146888f4$var$vv < 36; ++$839faf96146888f4$var$vv)$839faf96146888f4$var$BI_RC[$839faf96146888f4$var$rr++] = $839faf96146888f4$var$vv;
function $839faf96146888f4$var$int2char(n) {
    return $839faf96146888f4$var$BI_RM.charAt(n);
}
function $839faf96146888f4$var$intAt(s, i) {
    const c = $839faf96146888f4$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $839faf96146888f4$var$bnpCopyTo(r) {
    for(let i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $839faf96146888f4$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $839faf96146888f4$var$nbv(i) {
    const r = $839faf96146888f4$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $839faf96146888f4$var$bnpFromString(s, b) {
    let k;
    if (b === 16) k = 4;
    else if (b === 8) k = 3;
    else if (b === 2) k = 1;
    else if (b === 32) k = 5;
    else if (b === 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    let i = s.length;
    let mi = false;
    let sh = 0;
    while(--i >= 0){
        const x = $839faf96146888f4$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) === "-") mi = true;
            continue;
        }
        mi = false;
        if (sh === 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $839faf96146888f4$export$2e2bcd8739ae039.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $839faf96146888f4$var$bnpClamp() {
    const c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $839faf96146888f4$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    let k;
    if (b == 16) k = 4;
    else if (b === 8) k = 3;
    else if (b === 2) k = 1;
    else if (b === 32) k = 5;
    else if (b === 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    const km = (1 << k) - 1;
    let d;
    let m = false;
    let r = "";
    let i = this.t;
    let p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $839faf96146888f4$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $839faf96146888f4$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $839faf96146888f4$var$bnNegate() {
    const r = $839faf96146888f4$var$nbi();
    $839faf96146888f4$export$2e2bcd8739ae039.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $839faf96146888f4$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $839faf96146888f4$var$bnCompareTo(a) {
    let r = this.s - a.s;
    if (r != 0) return r;
    let i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $839faf96146888f4$var$nbits(x) {
    let r = 1;
    let t;
    if ((t = x >>> 16) !== 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) !== 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) !== 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) !== 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) !== 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $839faf96146888f4$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $839faf96146888f4$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $839faf96146888f4$var$bnpDLShiftTo(n, r) {
    let i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $839faf96146888f4$var$bnpDRShiftTo(n, r) {
    for(let i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $839faf96146888f4$var$bnpLShiftTo(n, r) {
    const bs = n % this.DB;
    const cbs = this.DB - bs;
    const bm = (1 << cbs) - 1;
    const ds = Math.floor(n / this.DB);
    let c = this.s << bs & this.DM;
    let i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $839faf96146888f4$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    const ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    const bs = n % this.DB;
    const cbs = this.DB - bs;
    const bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(let i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $839faf96146888f4$var$bnpSubTo(a, r) {
    let i = 0;
    let c = 0;
    const m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $839faf96146888f4$var$bnpMultiplyTo(a, r) {
    const x = this.abs();
    const y = a.abs();
    let i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s !== a.s) $839faf96146888f4$export$2e2bcd8739ae039.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $839faf96146888f4$var$bnpSquareTo(r) {
    const x = this.abs();
    let i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        const c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $839faf96146888f4$var$bnpDivRemTo(m, q, r) {
    const pm = m.abs();
    if (pm.t <= 0) return;
    const pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r === null) r = $839faf96146888f4$var$nbi();
    const y = $839faf96146888f4$var$nbi();
    const ts = this.s;
    const ms = m.s;
    const nsh = this.DB - $839faf96146888f4$var$nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    const ys = y.t;
    const y0 = y[ys - 1];
    if (y0 === 0) return;
    const yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    const d1 = this.FV / yt;
    const d2 = (1 << this.F1) / yt;
    const e = 1 << this.F2;
    let i = r.t;
    let j = i - ys;
    const t = q === null ? $839faf96146888f4$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $839faf96146888f4$export$2e2bcd8739ae039.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        let qd = r[--i] === y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q !== null) {
        r.drShiftTo(ys, q);
        if (ts !== ms) $839faf96146888f4$export$2e2bcd8739ae039.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) $839faf96146888f4$export$2e2bcd8739ae039.ZERO.subTo(r, r);
}
// (public) this mod a
function $839faf96146888f4$var$bnMod(a) {
    const r = $839faf96146888f4$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($839faf96146888f4$export$2e2bcd8739ae039.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $839faf96146888f4$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    const x = this[0];
    if ((x & 1) === 0) return 0;
    let y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $839faf96146888f4$var$bnEquals(a) {
    return this.compareTo(a) === 0;
}
// (protected) r = this + a
function $839faf96146888f4$var$bnpAddTo(a, r) {
    let i = 0;
    let c = 0;
    const m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $839faf96146888f4$var$bnAdd(a) {
    const r = $839faf96146888f4$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $839faf96146888f4$var$bnSubtract(a) {
    const r = $839faf96146888f4$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $839faf96146888f4$var$bnMultiply(a) {
    const r = $839faf96146888f4$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function $839faf96146888f4$var$bnDivide(a) {
    const r = $839faf96146888f4$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function $839faf96146888f4$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $839faf96146888f4$var$montConvert(x) {
    const r = $839faf96146888f4$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($839faf96146888f4$export$2e2bcd8739ae039.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $839faf96146888f4$var$montRevert(x) {
    const r = $839faf96146888f4$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $839faf96146888f4$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(let i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        let j = x[i] & 0x7fff;
        const u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $839faf96146888f4$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $839faf96146888f4$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$839faf96146888f4$var$Montgomery.prototype.convert = $839faf96146888f4$var$montConvert;
$839faf96146888f4$var$Montgomery.prototype.revert = $839faf96146888f4$var$montRevert;
$839faf96146888f4$var$Montgomery.prototype.reduce = $839faf96146888f4$var$montReduce;
$839faf96146888f4$var$Montgomery.prototype.mulTo = $839faf96146888f4$var$montMulTo;
$839faf96146888f4$var$Montgomery.prototype.sqrTo = $839faf96146888f4$var$montSqrTo;
// (public) this^e % m (HAC 14.85)
function $839faf96146888f4$var$bnModPow(e, m, callback) {
    let i = e.bitLength();
    let k;
    let r = $839faf96146888f4$var$nbv(1);
    const z = new $839faf96146888f4$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    const g = [];
    let n = 3;
    const k1 = k - 1;
    const km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        const g2 = $839faf96146888f4$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $839faf96146888f4$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    let j = e.t - 1;
    let w;
    let is1 = true;
    let r2 = $839faf96146888f4$var$nbi();
    let t;
    i = $839faf96146888f4$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) === 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) === 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    const result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
$839faf96146888f4$export$2e2bcd8739ae039.prototype.copyTo = $839faf96146888f4$var$bnpCopyTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.fromInt = $839faf96146888f4$var$bnpFromInt;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.fromString = $839faf96146888f4$var$bnpFromString;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.clamp = $839faf96146888f4$var$bnpClamp;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.dlShiftTo = $839faf96146888f4$var$bnpDLShiftTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.drShiftTo = $839faf96146888f4$var$bnpDRShiftTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.lShiftTo = $839faf96146888f4$var$bnpLShiftTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.rShiftTo = $839faf96146888f4$var$bnpRShiftTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.subTo = $839faf96146888f4$var$bnpSubTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.multiplyTo = $839faf96146888f4$var$bnpMultiplyTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.squareTo = $839faf96146888f4$var$bnpSquareTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.divRemTo = $839faf96146888f4$var$bnpDivRemTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.invDigit = $839faf96146888f4$var$bnpInvDigit;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.addTo = $839faf96146888f4$var$bnpAddTo;
// public
$839faf96146888f4$export$2e2bcd8739ae039.prototype.toString = $839faf96146888f4$var$bnToString;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.negate = $839faf96146888f4$var$bnNegate;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.abs = $839faf96146888f4$var$bnAbs;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.compareTo = $839faf96146888f4$var$bnCompareTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.bitLength = $839faf96146888f4$var$bnBitLength;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.mod = $839faf96146888f4$var$bnMod;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.equals = $839faf96146888f4$var$bnEquals;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.add = $839faf96146888f4$var$bnAdd;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.subtract = $839faf96146888f4$var$bnSubtract;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.multiply = $839faf96146888f4$var$bnMultiply;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.divide = $839faf96146888f4$var$bnDivide;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.modPow = $839faf96146888f4$var$bnModPow;
// "constants"
$839faf96146888f4$export$2e2bcd8739ae039.ZERO = $839faf96146888f4$var$nbv(0);
$839faf96146888f4$export$2e2bcd8739ae039.ONE = $839faf96146888f4$var$nbv(1);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $04b7fba5022fa024$export$f7340100dd3acd38 = async ({ a: a , g: g , k: k , x: x , B: B , N: N , U: U  })=>{
    return new Promise((resolve, reject)=>{
        g.modPow(x, N, (outerErr, outerResult)=>{
            if (outerErr) {
                reject(outerErr);
                return;
            }
            B.subtract(k.multiply(outerResult)).modPow(a.add(U.multiply(x)), N, (innerErr, innerResult)=>{
                if (innerErr) {
                    reject(innerErr);
                    return;
                }
                resolve(innerResult.mod(N));
            });
        });
    });
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $54a0e8e62b1cf7be$export$baab4dd8c7240846 = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
const $54a0e8e62b1cf7be$export$a0f75f7d2f3bd702 = {};
const $54a0e8e62b1cf7be$export$fcb552daf117d7e3 = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $54a0e8e62b1cf7be$export$a0f75f7d2f3bd702[i] = encodedByte;
    $54a0e8e62b1cf7be$export$fcb552daf117d7e3[encodedByte] = i;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a hexadecimal encoded string to a Uint8Array of bytes.
 *
 * @param encoded The hexadecimal encoded string
 */ const $d9c2f17b8749cd84$export$b772e43c3daf2e7a = (encoded)=>{
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in (0, $54a0e8e62b1cf7be$export$fcb552daf117d7e3)) out[i / 2] = (0, $54a0e8e62b1cf7be$export$fcb552daf117d7e3)[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a Uint8Array of binary data to a hexadecimal encoded string.
 *
 * @param bytes The binary data to encode
 */ const $9a5292c2de1a98b1$export$22a20ab34c1d7a2b = (bytes)=>{
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += (0, $54a0e8e62b1cf7be$export$a0f75f7d2f3bd702)[bytes[i]];
    return out;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculate a hash from a `SourceData`
 * @param {SourceData} data Value to hash.
 * @returns {string} Hex-encoded hash.
 * @private
 */ const $b8d29a2e181619db$export$629ee8d7d3ebacd1 = (data)=>{
    const sha256 = new (0, $475efd9fa7b1a9cc$export$3b58ea8124ac5e28)();
    sha256.update(data);
    const hashedData = sha256.digestSync();
    const hashHexFromUint8 = (0, $9a5292c2de1a98b1$export$22a20ab34c1d7a2b)(hashedData);
    return new Array(64 - hashHexFromUint8.length).join("0") + hashHexFromUint8;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculate a hash from a hex string
 * @param {string} hexStr Value to hash.
 * @returns {string} Hex-encoded hash.
 * @private
 */ const $131acfb31ddfe2fb$export$8b112e065a8843a = (hexStr)=>(0, $b8d29a2e181619db$export$629ee8d7d3ebacd1)((0, $d9c2f17b8749cd84$export$b772e43c3daf2e7a)(hexStr));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ const $7e835c3efa00f07a$var$HEX_MSB_REGEX = /^[89a-f]/i;
/**
 * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
 *
 * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
 * byte array containing the two's-complement representation of a BigInteger. The array contains
 * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
 *
 * Examples showing how ambiguity is avoided by left padding with:
 * 	"00" (for positive values where the most-significant-bit is set)
 *  "FF" (for negative values where the most-significant-bit is set)
 *
 * padHex(bigInteger.fromInt(-236))  === "FF14"
 * padHex(bigInteger.fromInt(20))    === "14"
 *
 * padHex(bigInteger.fromInt(-200))  === "FF38"
 * padHex(bigInteger.fromInt(56))    === "38"
 *
 * padHex(bigInteger.fromInt(-20))   === "EC"
 * padHex(bigInteger.fromInt(236))   === "00EC"
 *
 * padHex(bigInteger.fromInt(-56))   === "C8"
 * padHex(bigInteger.fromInt(200))   === "00C8"
 *
 * @param {AuthBigInteger} bigInt Number to encode.
 * @returns {String} even-length hex string of the two's complement encoding.
 */ const $7e835c3efa00f07a$export$35d4ea07514a0402 = (bigInt)=>{
    if (!(bigInt instanceof (0, $839faf96146888f4$export$2e2bcd8739ae039))) throw new Error("Not a BigInteger");
    const isNegative = bigInt.compareTo((0, $839faf96146888f4$export$2e2bcd8739ae039).ZERO) < 0;
    /* Get a hex string for abs(bigInt) */ let hexStr = bigInt.abs().toString(16);
    /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? `0${hexStr}` : hexStr;
    /* Prepend "00" if the most significant bit is set */ hexStr = $7e835c3efa00f07a$var$HEX_MSB_REGEX.test(hexStr) ? `00${hexStr}` : hexStr;
    if (isNegative) {
        /* Flip the bits of the representation */ const invertedNibbles = hexStr.split("").map((x)=>{
            const invertedNibble = ~parseInt(x, 16) & 0xf;
            return "0123456789ABCDEF".charAt(invertedNibble);
        }).join("");
        /* After flipping the bits, add one to get the 2's complement representation */ const flippedBitsBI = new (0, $839faf96146888f4$export$2e2bcd8739ae039)(invertedNibbles, 16).add((0, $839faf96146888f4$export$2e2bcd8739ae039).ONE);
        hexStr = flippedBitsBI.toString(16);
        /*
        For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128

        Any sequence of '1' bits on the left can always be substituted with a single '1' bit
        without changing the represented value.

        This only happens in the case when the input is 80...00
        */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
    }
    return hexStr;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $76d0b69b01ecb24b$export$e2f40082638513e7 = ({ A: A , B: B  })=>{
    const U = new (0, $839faf96146888f4$export$2e2bcd8739ae039)((0, $131acfb31ddfe2fb$export$8b112e065a8843a)((0, $7e835c3efa00f07a$export$35d4ea07514a0402)(A) + (0, $7e835c3efa00f07a$export$35d4ea07514a0402)(B)), 16);
    if (U.equals((0, $839faf96146888f4$export$2e2bcd8739ae039).ZERO)) throw new Error("U cannot be zero.");
    return U;
};







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Standard HKDF algorithm.
 *
 * @param {Uint8Array} ikm Input key material.
 * @param {Uint8Array} salt Salt value.
 * @param {Uint8Array} info Context and application specific info.
 *
 * @returns {Uint8Array} Strong key material.
 *
 * @internal
 */ const $873de60f2b95e3e2$export$295a0a5429217d03 = (ikm, salt, info)=>{
    const awsCryptoHash = new (0, $475efd9fa7b1a9cc$export$3b58ea8124ac5e28)(salt);
    awsCryptoHash.update(ikm);
    const resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
    const awsCryptoHashHmac = new (0, $475efd9fa7b1a9cc$export$3b58ea8124ac5e28)(resultFromAWSCryptoPrk);
    awsCryptoHashHmac.update(info);
    const resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
    const hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
    return hashHexFromAWSCrypto.slice(0, 16);
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/*
 * Cryptographically secure pseudorandom number generator
 * As Math.random() is cryptographically not safe to use
 */ function $21c9035b228450bc$export$d265930babe23ca5() {
    const crypto = (0, $75891aafa6b8443f$export$e003cc239f955cb6)();
    const randomResult = crypto.getRandomValues(new Uint32Array(1))[0];
    return randomResult;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $6de7f9f1e1bbc4c2$var$hexStringify(wordArray) {
    // Shortcuts
    const { words: words  } = wordArray;
    const { sigBytes: sigBytes  } = wordArray;
    // Convert
    const hexChars = [];
    for(let i = 0; i < sigBytes; i++){
        const bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
class $6de7f9f1e1bbc4c2$export$4cd4919e303276a6 {
    constructor(words, sigBytes){
        this.words = [];
        let Words = words;
        Words = this.words = Words || [];
        if (sigBytes !== undefined) this.sigBytes = sigBytes;
        else this.sigBytes = Words.length * 4;
    }
    random(nBytes) {
        const words = [];
        for(let i = 0; i < nBytes; i += 4)words.push((0, $21c9035b228450bc$export$d265930babe23ca5)());
        return new $6de7f9f1e1bbc4c2$export$4cd4919e303276a6(words, nBytes);
    }
    toString() {
        return $6de7f9f1e1bbc4c2$var$hexStringify(this);
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a Uint8Array with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Uint8Array} fixed-length sequence of random bytes
 */ const $25ea71e06c11381c$export$763d6fc7c4b5dc52 = (nBytes)=>{
    const str = new (0, $6de7f9f1e1bbc4c2$export$4cd4919e303276a6)().random(nBytes).toString();
    return (0, $d9c2f17b8749cd84$export$b772e43c3daf2e7a)(str);
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Helper function to generate a random string
 * @returns {string} a random value.
 *
 * @internal
 */ const $ba71225bb85e6075$export$8c487394e1c35fbe = ()=>(0, $0f87662804872ba2$export$695b149896bd3e2a).convert((0, $25ea71e06c11381c$export$763d6fc7c4b5dc52)(40));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** @class */ class $beaf1a34a8aa7752$export$2e2bcd8739ae039 {
    constructor({ userPoolName: userPoolName , a: a , g: g , A: A , N: N  }){
        this.encoder = (0, $8afd980693d9bf70$export$f5d75491a17f02c);
        this.userPoolName = userPoolName;
        this.a = a;
        this.g = g;
        this.A = A;
        this.N = N;
        this.k = new (0, $839faf96146888f4$export$2e2bcd8739ae039)((0, $131acfb31ddfe2fb$export$8b112e065a8843a)(`${(0, $7e835c3efa00f07a$export$35d4ea07514a0402)(N)}${(0, $7e835c3efa00f07a$export$35d4ea07514a0402)(g)}`), 16);
    }
    /**
     * @returns {string} Generated random value included in password hash.
     */ getRandomPassword() {
        if (!this.randomPassword) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: "EmptyBigIntegerRandomPassword",
            message: "random password is empty"
        });
        return this.randomPassword;
    }
    /**
     * @returns {string} Generated random value included in devices hash.
     */ getSaltToHashDevices() {
        if (!this.saltToHashDevices) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: "EmptyBigIntegersaltToHashDevices",
            message: "saltToHashDevices is empty"
        });
        return this.saltToHashDevices;
    }
    /**
     * @returns {string} Value used to verify devices.
     */ getVerifierDevices() {
        if (!this.verifierDevices) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: "EmptyBigIntegerVerifierDevices",
            message: "verifyDevices is empty"
        });
        return this.verifierDevices;
    }
    /**
     * Generate salts and compute verifier.
     *
     * @param {string} deviceGroupKey Devices to generate verifier for.
     * @param {string} username User to generate verifier for.
     *
     * @returns {Promise<void>}
     */ async generateHashDevice(deviceGroupKey, username) {
        this.randomPassword = (0, $ba71225bb85e6075$export$8c487394e1c35fbe)();
        const combinedString = `${deviceGroupKey}${username}:${this.randomPassword}`;
        const hashedString = (0, $b8d29a2e181619db$export$629ee8d7d3ebacd1)(combinedString);
        const hexRandom = (0, $9a5292c2de1a98b1$export$22a20ab34c1d7a2b)((0, $25ea71e06c11381c$export$763d6fc7c4b5dc52)(16));
        // The random hex will be unambiguously represented as a postive integer
        this.saltToHashDevices = (0, $7e835c3efa00f07a$export$35d4ea07514a0402)(new (0, $839faf96146888f4$export$2e2bcd8739ae039)(hexRandom, 16));
        return new Promise((resolve, reject)=>{
            this.g.modPow(new (0, $839faf96146888f4$export$2e2bcd8739ae039)((0, $131acfb31ddfe2fb$export$8b112e065a8843a)(this.saltToHashDevices + hashedString), 16), this.N, (err, result)=>{
                if (err) {
                    reject(err);
                    return;
                }
                this.verifierDevices = (0, $7e835c3efa00f07a$export$35d4ea07514a0402)(result);
                resolve();
            });
        });
    }
    /**
     * Calculates the final HKDF key based on computed S value, computed U value and the key
     *
     * @param {String} username Username.
     * @param {String} password Password.
     * @param {AuthBigInteger} B Server B value.
     * @param {AuthBigInteger} salt Generated salt.
     */ async getPasswordAuthenticationKey({ username: username , password: password , serverBValue: serverBValue , salt: salt  }) {
        if (serverBValue.mod(this.N).equals((0, $839faf96146888f4$export$2e2bcd8739ae039).ZERO)) throw new Error("B cannot be zero.");
        const U = (0, $76d0b69b01ecb24b$export$e2f40082638513e7)({
            A: this.A,
            B: serverBValue
        });
        const usernamePassword = `${this.userPoolName}${username}:${password}`;
        const usernamePasswordHash = (0, $b8d29a2e181619db$export$629ee8d7d3ebacd1)(usernamePassword);
        const x = new (0, $839faf96146888f4$export$2e2bcd8739ae039)((0, $131acfb31ddfe2fb$export$8b112e065a8843a)((0, $7e835c3efa00f07a$export$35d4ea07514a0402)(salt) + usernamePasswordHash), 16);
        const S = await (0, $04b7fba5022fa024$export$f7340100dd3acd38)({
            a: this.a,
            g: this.g,
            k: this.k,
            x: x,
            B: serverBValue,
            N: this.N,
            U: U
        });
        const context = this.encoder.convert("Caldera Derived Key");
        const spacer = this.encoder.convert(String.fromCharCode(1));
        const info = new Uint8Array(context.byteLength + spacer.byteLength);
        info.set(context, 0);
        info.set(spacer, context.byteLength);
        const hkdfKey = (0, $873de60f2b95e3e2$export$295a0a5429217d03)((0, $d9c2f17b8749cd84$export$b772e43c3daf2e7a)((0, $7e835c3efa00f07a$export$35d4ea07514a0402)(S)), (0, $d9c2f17b8749cd84$export$b772e43c3daf2e7a)((0, $7e835c3efa00f07a$export$35d4ea07514a0402)(U)), info);
        return hkdfKey;
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $088c16dd8980815f$export$53a55138f9e96c65 = async ({ a: a , g: g , N: N  })=>{
    return new Promise((resolve, reject)=>{
        g.modPow(a, N, (err, A)=>{
            if (err) {
                reject(err);
                return;
            }
            if (A.mod(N).equals((0, $839faf96146888f4$export$2e2bcd8739ae039).ZERO)) {
                reject(new Error("Illegal parameter. A mod N cannot be 0."));
                return;
            }
            resolve(A);
        });
    });
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a new {@link AuthenticationHelper} instance with randomly generated BigInteger seed
 *
 * @param userPoolName Cognito user pool name.
 * @returns An {@link AuthenticationHelper} instance.
 *
 * @internal
 */ const $4b165f329812d8bd$export$47560e2dc89f678c = async (userPoolName)=>{
    const N = new (0, $839faf96146888f4$export$2e2bcd8739ae039)((0, $54a0e8e62b1cf7be$export$baab4dd8c7240846), 16);
    const g = new (0, $839faf96146888f4$export$2e2bcd8739ae039)("2", 16);
    const a = $4b165f329812d8bd$var$generateRandomBigInteger();
    const A = await (0, $088c16dd8980815f$export$53a55138f9e96c65)({
        a: a,
        g: g,
        N: N
    });
    return new (0, $beaf1a34a8aa7752$export$2e2bcd8739ae039)({
        userPoolName: userPoolName,
        a: a,
        g: g,
        A: A,
        N: N
    });
};
/**
 * Generates a random BigInteger.
 *
 * @returns {BigInteger} a random value.
 */ const $4b165f329812d8bd$var$generateRandomBigInteger = ()=>{
    // This will be interpreted as a postive 128-bit integer
    const hexRandom = (0, $9a5292c2de1a98b1$export$22a20ab34c1d7a2b)((0, $25ea71e06c11381c$export$763d6fc7c4b5dc52)(128));
    // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
    return new (0, $839faf96146888f4$export$2e2bcd8739ae039)(hexRandom, 16);
};
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the Password SRP (Secure Remote Password) authentication flow.
 * This function can be used with both USER_SRP_AUTH and USER_AUTH flows.
 *
 * @param {Object} params - The parameters for the Password SRP authentication
 * @param {string} params.username - The username for authentication
 * @param {string} params.password - The user's password
 * @param {ClientMetadata} [params.clientMetadata] - Optional metadata to be sent with auth requests
 * @param {CognitoUserPoolConfig} params.config - Cognito User Pool configuration
 * @param {AuthTokenOrchestrator} params.tokenOrchestrator - Token orchestrator for managing auth tokens
 * @param {AuthFlowType} params.authFlow - The type of authentication flow ('USER_SRP_AUTH' or 'USER_AUTH')
 * @param {AuthFactorType} [params.preferredChallenge] - Optional preferred challenge type when using USER_AUTH flow
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The authentication response
 */ async function $fcfe8914aa5d6201$export$169bd15774e46c56({ username: username , password: password , clientMetadata: clientMetadata , config: config , tokenOrchestrator: tokenOrchestrator , authFlow: authFlow , preferredChallenge: preferredChallenge  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    const userPoolName = userPoolId?.split("_")[1] || "";
    const authenticationHelper = await (0, $4b165f329812d8bd$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16)
    };
    if (authFlow === "USER_AUTH" && preferredChallenge) authParameters.PREFERRED_CHALLENGE = preferredChallenge;
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: authFlow,
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const initiateAuth = (0, $74a589de9a455739$export$91f349d78bea7765)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const resp = await initiateAuth({
        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const { ChallengeParameters: challengeParameters , Session: session  } = resp;
    const activeUsername = challengeParameters?.USERNAME ?? username;
    (0, $1ca9fe6154565c83$export$fecfbc200868d412)(activeUsername);
    if (resp.ChallengeName === "PASSWORD_VERIFIER") return (0, $1ca9fe6154565c83$export$30f932fe98713ccc)((0, $1ca9fe6154565c83$export$7f7b64167822fe34), [
        password,
        challengeParameters,
        clientMetadata,
        session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
    return resp;
}














// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the SELECT_CHALLENGE response for authentication.
 * Initiates the selected authentication challenge based on user choice.
 *
 * @param {Object} params - The parameters for handling the selected challenge
 * @param {string} params.username - The username for authentication
 * @param {string} params.session - The current authentication session token
 * @param {string} params.selectedChallenge - The challenge type selected by the user
 * @param {CognitoUserPoolConfig} params.config - Cognito User Pool configuration
 * @param {ClientMetadata} [params.clientMetadata] - Optional metadata to be sent with auth requests
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The challenge response
 */ async function $1808779ad5b776df$export$4eb37109154e77c1({ username: username , session: session , selectedChallenge: selectedChallenge , config: config , clientMetadata: clientMetadata  }) {
    const respondToAuthChallenge = (0, $1592ec11dd7f6ec9$export$11329f5ae466ab5d)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: config.userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(config.userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        ChallengeName: "SELECT_CHALLENGE",
        ChallengeResponses: {
            USERNAME: username,
            ANSWER: selectedChallenge
        },
        ClientId: config.userPoolClientId,
        Session: session,
        ClientMetadata: clientMetadata
    });
}
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the SELECT_CHALLENGE response specifically for Password authentication.
 * This function combines the SELECT_CHALLENGE flow with standard password authentication.
 *
 * @param {string} username - The username for authentication
 * @param {string} password - The user's password
 * @param {ClientMetadata} [clientMetadata] - Optional metadata to be sent with auth requests
 * @param {CognitoUserPoolConfig} config - Cognito User Pool configuration
 * @param {string} session - The current authentication session token
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The challenge response
 */ async function $e49d51f717e3b241$export$cca550d6560f23b8(username, password, clientMetadata, config, session) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    const authParameters = {
        ANSWER: "PASSWORD",
        USERNAME: username,
        PASSWORD: password
    };
    const userContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const respondToAuthChallenge = (0, $1592ec11dd7f6ec9$export$11329f5ae466ab5d)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        ChallengeName: "SELECT_CHALLENGE",
        ChallengeResponses: authParameters,
        ClientId: userPoolClientId,
        ClientMetadata: clientMetadata,
        Session: session,
        UserContextData: userContextData
    });
    const activeUsername = response.ChallengeParameters?.USERNAME ?? username;
    (0, $1ca9fe6154565c83$export$fecfbc200868d412)(activeUsername);
    return response;
}



















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the SELECT_CHALLENGE response specifically for Password SRP authentication.
 * This function combines the SELECT_CHALLENGE flow with Password SRP protocol.
 *
 * @param {string} username - The username for authentication
 * @param {string} password - The user's password
 * @param {ClientMetadata} [clientMetadata] - Optional metadata to be sent with auth requests
 * @param {CognitoUserPoolConfig} config - Cognito User Pool configuration
 * @param {string} session - The current authentication session token
 * @param {AuthTokenOrchestrator} tokenOrchestrator - Token orchestrator for managing auth tokens
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The challenge response
 */ async function $74a6cee00c2fbc5c$export$e496ff225fdec499(username, password, clientMetadata, config, session, tokenOrchestrator) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    const userPoolName = userPoolId.split("_")[1] || "";
    const authenticationHelper = await (0, $4b165f329812d8bd$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        ANSWER: "PASSWORD_SRP",
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16)
    };
    const userContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const respondToAuthChallenge = (0, $1592ec11dd7f6ec9$export$11329f5ae466ab5d)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        ChallengeName: "SELECT_CHALLENGE",
        ChallengeResponses: authParameters,
        ClientId: userPoolClientId,
        ClientMetadata: clientMetadata,
        Session: session,
        UserContextData: userContextData
    });
    const activeUsername = response.ChallengeParameters?.USERNAME ?? username;
    (0, $1ca9fe6154565c83$export$fecfbc200868d412)(activeUsername);
    if (response.ChallengeName === "PASSWORD_VERIFIER") return (0, $1ca9fe6154565c83$export$30f932fe98713ccc)((0, $1ca9fe6154565c83$export$7f7b64167822fe34), [
        password,
        response.ChallengeParameters,
        clientMetadata,
        response.Session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
    return response;
}







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $04399cc05aa3ed90$var$MONTH_NAMES = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $04399cc05aa3ed90$var$WEEK_NAMES = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $04399cc05aa3ed90$export$218a6e05f05aec48 = ()=>{
    const now = new Date();
    const weekDay = $04399cc05aa3ed90$var$WEEK_NAMES[now.getUTCDay()];
    const month = $04399cc05aa3ed90$var$MONTH_NAMES[now.getUTCMonth()];
    const day = now.getUTCDate();
    let hours = now.getUTCHours();
    if (hours < 10) hours = `0${hours}`;
    let minutes = now.getUTCMinutes();
    if (minutes < 10) minutes = `0${minutes}`;
    let seconds = now.getUTCSeconds();
    if (seconds < 10) seconds = `0${seconds}`;
    const year = now.getUTCFullYear();
    // ddd MMM D HH:mm:ss UTC YYYY
    const dateNow = `${weekDay} ${month} ${day} ${hours}:${minutes}:${seconds} UTC ${year}`;
    return dateNow;
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $650c859408628344$export$577b7d8a4f1b23fd = ({ userPoolName: userPoolName , username: username , challengeParameters: challengeParameters , dateNow: dateNow , hkdf: hkdf  })=>{
    const bufUPIDaToB = (0, $8afd980693d9bf70$export$f5d75491a17f02c).convert(userPoolName);
    const bufUNaToB = (0, $8afd980693d9bf70$export$f5d75491a17f02c).convert(username);
    const bufSBaToB = $650c859408628344$var$urlB64ToUint8Array(challengeParameters.SECRET_BLOCK);
    const bufDNaToB = (0, $8afd980693d9bf70$export$f5d75491a17f02c).convert(dateNow);
    const bufConcat = new Uint8Array(bufUPIDaToB.byteLength + bufUNaToB.byteLength + bufSBaToB.byteLength + bufDNaToB.byteLength);
    bufConcat.set(bufUPIDaToB, 0);
    bufConcat.set(bufUNaToB, bufUPIDaToB.byteLength);
    bufConcat.set(bufSBaToB, bufUPIDaToB.byteLength + bufUNaToB.byteLength);
    bufConcat.set(bufDNaToB, bufUPIDaToB.byteLength + bufUNaToB.byteLength + bufSBaToB.byteLength);
    const awsCryptoHash = new (0, $475efd9fa7b1a9cc$export$3b58ea8124ac5e28)(hkdf);
    awsCryptoHash.update(bufConcat);
    const resultFromAWSCrypto = awsCryptoHash.digestSync();
    const signatureString = (0, $0f87662804872ba2$export$695b149896bd3e2a).convert(resultFromAWSCrypto);
    return signatureString;
};
const $650c859408628344$var$urlB64ToUint8Array = (base64String)=>{
    const padding = "=".repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const rawData = (0, $ef7237a6eb0adc7d$export$1e303d38dab7b376).convert(base64);
    const outputArray = new Uint8Array(rawData.length);
    for(let i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $1ca9fe6154565c83$var$USER_ATTRIBUTES = "userAttributes.";
async function $1ca9fe6154565c83$export$6fe6331471b54d26({ challengeResponse: challengeResponse , clientMetadata: clientMetadata , session: session , username: username , config: config , tokenOrchestrator: tokenOrchestrator  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    const challengeResponses = {
        USERNAME: username,
        ANSWER: challengeResponse
    };
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "CUSTOM_CHALLENGE",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $1592ec11dd7f6ec9$export$11329f5ae466ab5d)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $1ca9fe6154565c83$var$handleDeviceSRPAuth({
        username: username,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $1ca9fe6154565c83$export$9b78cd405a35bccd({ challengeResponse: challengeResponse , username: username , clientMetadata: clientMetadata , session: session , deviceName: deviceName , config: config  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    if (challengeResponse === "EMAIL") return {
        ChallengeName: "MFA_SETUP",
        Session: session,
        ChallengeParameters: {
            MFAS_CAN_SETUP: '["EMAIL_OTP"]'
        },
        $metadata: {}
    };
    if (challengeResponse === "TOTP") return {
        ChallengeName: "MFA_SETUP",
        Session: session,
        ChallengeParameters: {
            MFAS_CAN_SETUP: '["SOFTWARE_TOKEN_MFA"]'
        },
        $metadata: {}
    };
    const challengeResponses = {
        USERNAME: username
    };
    const isTOTPCode = /^\d+$/.test(challengeResponse);
    if (isTOTPCode) {
        const verifySoftwareToken = (0, $8cd905d9735a558c$export$cf5dd9429415aa98)({
            endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        const { Session: Session  } = await verifySoftwareToken({
            region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId),
            userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).ConfirmSignIn)
        }, {
            UserCode: challengeResponse,
            Session: session,
            FriendlyDeviceName: deviceName
        });
        (0, $af24ca9998616e43$export$390d5da4c63a4a41).dispatch({
            type: "SET_SIGN_IN_SESSION",
            value: Session
        });
        const jsonReq = {
            ChallengeName: "MFA_SETUP",
            ChallengeResponses: challengeResponses,
            Session: Session,
            ClientMetadata: clientMetadata,
            ClientId: userPoolClientId
        };
        const respondToAuthChallenge = (0, $1592ec11dd7f6ec9$export$11329f5ae466ab5d)({
            endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        return respondToAuthChallenge({
            region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId),
            userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).ConfirmSignIn)
        }, jsonReq);
    }
    const isEmail = challengeResponse.includes("@");
    if (isEmail) {
        challengeResponses.EMAIL = challengeResponse;
        const jsonReq = {
            ChallengeName: "MFA_SETUP",
            ChallengeResponses: challengeResponses,
            Session: session,
            ClientMetadata: clientMetadata,
            ClientId: userPoolClientId
        };
        const respondToAuthChallenge = (0, $1592ec11dd7f6ec9$export$11329f5ae466ab5d)({
            endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        return respondToAuthChallenge({
            region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId),
            userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).ConfirmSignIn)
        }, jsonReq);
    }
    throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: (0, $7ccba6b199ab94b3$export$473ab0b56598aacd).SignInException,
        message: `Cannot proceed with MFA setup using challengeResponse: ${challengeResponse}`,
        recoverySuggestion: 'Try passing "EMAIL", "TOTP", a valid email, or OTP code as the challengeResponse.'
    });
}
async function $1ca9fe6154565c83$export$f0699fc2b71f49c0({ challengeResponse: challengeResponse , username: username , clientMetadata: clientMetadata , session: session , config: config  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(challengeResponse === "TOTP" || challengeResponse === "SMS" || challengeResponse === "EMAIL", (0, $37d361b81fa35812$export$12d5c695b2213c4a).IncorrectMFAMethod);
    const challengeResponses = {
        USERNAME: username,
        ANSWER: $1ca9fe6154565c83$export$7e7902092e38fcff(challengeResponse)
    };
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "SELECT_MFA_TYPE",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $1592ec11dd7f6ec9$export$11329f5ae466ab5d)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $1ca9fe6154565c83$export$df3f8a8c68da6a2e({ challengeResponse: challengeResponse , clientMetadata: clientMetadata , session: session , username: username , requiredAttributes: requiredAttributes , config: config  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    const challengeResponses = {
        ...$1ca9fe6154565c83$export$c7c9603a6b1fd815(requiredAttributes),
        NEW_PASSWORD: challengeResponse,
        USERNAME: username
    };
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "NEW_PASSWORD_REQUIRED",
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $1592ec11dd7f6ec9$export$11329f5ae466ab5d)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $1ca9fe6154565c83$export$29fb48d356e16a7(username, password, clientMetadata, config, tokenOrchestrator) {
    const { userPoolClientId: userPoolClientId , userPoolId: userPoolId , userPoolEndpoint: userPoolEndpoint  } = config;
    const authParameters = {
        USERNAME: username,
        PASSWORD: password
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) authParameters.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "USER_PASSWORD_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const initiateAuth = (0, $74a589de9a455739$export$91f349d78bea7765)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await initiateAuth({
        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = response.ChallengeParameters?.USERNAME ?? response.ChallengeParameters?.USER_ID_FOR_SRP ?? username;
    $1ca9fe6154565c83$export$fecfbc200868d412(activeUsername);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $1ca9fe6154565c83$var$handleDeviceSRPAuth({
        username: activeUsername,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $1ca9fe6154565c83$export$13a3ef5ef8cac338(username, password, clientMetadata, config, tokenOrchestrator) {
    return (0, $fcfe8914aa5d6201$export$169bd15774e46c56)({
        username: username,
        password: password,
        clientMetadata: clientMetadata,
        config: config,
        tokenOrchestrator: tokenOrchestrator,
        authFlow: "USER_SRP_AUTH"
    });
}
async function $1ca9fe6154565c83$export$1a654dcab55e0de5(username, clientMetadata, config, tokenOrchestrator) {
    const { userPoolClientId: userPoolClientId , userPoolId: userPoolId , userPoolEndpoint: userPoolEndpoint  } = config;
    const authParameters = {
        USERNAME: username
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) authParameters.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "CUSTOM_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const initiateAuth = (0, $74a589de9a455739$export$91f349d78bea7765)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await initiateAuth({
        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = response.ChallengeParameters?.USERNAME ?? username;
    $1ca9fe6154565c83$export$fecfbc200868d412(activeUsername);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $1ca9fe6154565c83$var$handleDeviceSRPAuth({
        username: activeUsername,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $1ca9fe6154565c83$export$9ce9dd351616104c(username, password, clientMetadata, config, tokenOrchestrator) {
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(config);
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    const userPoolName = userPoolId?.split("_")[1] || "";
    const authenticationHelper = await (0, $4b165f329812d8bd$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16),
        CHALLENGE_NAME: "SRP_A"
    };
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "CUSTOM_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const initiateAuth = (0, $74a589de9a455739$export$91f349d78bea7765)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { ChallengeParameters: challengeParameters , Session: session  } = await initiateAuth({
        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = challengeParameters?.USERNAME ?? username;
    $1ca9fe6154565c83$export$fecfbc200868d412(activeUsername);
    return $1ca9fe6154565c83$export$30f932fe98713ccc($1ca9fe6154565c83$export$7f7b64167822fe34, [
        password,
        challengeParameters,
        clientMetadata,
        session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
}
async function $1ca9fe6154565c83$var$handleDeviceSRPAuth({ username: username , config: config , clientMetadata: clientMetadata , session: session , tokenOrchestrator: tokenOrchestrator  }) {
    const { userPoolId: userPoolId , userPoolEndpoint: userPoolEndpoint  } = config;
    const clientId = config.userPoolClientId;
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    (0, $45fe96cf99d947f4$export$b6f03be79626ab0f)(deviceMetadata);
    const authenticationHelper = await (0, $4b165f329812d8bd$export$47560e2dc89f678c)(deviceMetadata.deviceGroupKey);
    const challengeResponses = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16),
        DEVICE_KEY: deviceMetadata.deviceKey
    };
    const jsonReqResponseChallenge = {
        ChallengeName: "DEVICE_SRP_AUTH",
        ClientId: clientId,
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session
    };
    const respondToAuthChallenge = (0, $1592ec11dd7f6ec9$export$11329f5ae466ab5d)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { ChallengeParameters: respondedChallengeParameters , Session: Session  } = await respondToAuthChallenge({
        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId)
    }, jsonReqResponseChallenge);
    return $1ca9fe6154565c83$var$handleDevicePasswordVerifier(username, respondedChallengeParameters, clientMetadata, Session, authenticationHelper, config, tokenOrchestrator);
}
async function $1ca9fe6154565c83$var$handleDevicePasswordVerifier(username, challengeParameters, clientMetadata, session, authenticationHelper, { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  }, tokenOrchestrator) {
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    (0, $45fe96cf99d947f4$export$b6f03be79626ab0f)(deviceMetadata);
    const serverBValue = new (0, $839faf96146888f4$export$2e2bcd8739ae039)(challengeParameters?.SRP_B, 16);
    const salt = new (0, $839faf96146888f4$export$2e2bcd8739ae039)(challengeParameters?.SALT, 16);
    const { deviceKey: deviceKey  } = deviceMetadata;
    const { deviceGroupKey: deviceGroupKey  } = deviceMetadata;
    const hkdf = await authenticationHelper.getPasswordAuthenticationKey({
        username: deviceMetadata.deviceKey,
        password: deviceMetadata.randomPassword,
        serverBValue: serverBValue,
        salt: salt
    });
    const dateNow = (0, $04399cc05aa3ed90$export$218a6e05f05aec48)();
    const challengeResponses = {
        USERNAME: challengeParameters?.USERNAME ?? username,
        PASSWORD_CLAIM_SECRET_BLOCK: challengeParameters?.SECRET_BLOCK,
        TIMESTAMP: dateNow,
        PASSWORD_CLAIM_SIGNATURE: (0, $650c859408628344$export$577b7d8a4f1b23fd)({
            username: deviceKey,
            userPoolName: deviceGroupKey,
            challengeParameters: challengeParameters,
            dateNow: dateNow,
            hkdf: hkdf
        }),
        DEVICE_KEY: deviceKey
    };
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReqResponseChallenge = {
        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
        ClientId: userPoolClientId,
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $1592ec11dd7f6ec9$export$11329f5ae466ab5d)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId)
    }, jsonReqResponseChallenge);
}
async function $1ca9fe6154565c83$export$7f7b64167822fe34(password, challengeParameters, clientMetadata, session, authenticationHelper, config, tokenOrchestrator) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    const userPoolName = userPoolId?.split("_")[1] || "";
    const serverBValue = new (0, $839faf96146888f4$export$2e2bcd8739ae039)(challengeParameters?.SRP_B, 16);
    const salt = new (0, $839faf96146888f4$export$2e2bcd8739ae039)(challengeParameters?.SALT, 16);
    const username = challengeParameters?.USER_ID_FOR_SRP;
    if (!username) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: "EmptyUserIdForSRPException",
        message: "USER_ID_FOR_SRP was not found in challengeParameters"
    });
    const hkdf = await authenticationHelper.getPasswordAuthenticationKey({
        username: username,
        password: password,
        serverBValue: serverBValue,
        salt: salt
    });
    const dateNow = (0, $04399cc05aa3ed90$export$218a6e05f05aec48)();
    const challengeResponses = {
        USERNAME: username,
        PASSWORD_CLAIM_SECRET_BLOCK: challengeParameters?.SECRET_BLOCK,
        TIMESTAMP: dateNow,
        PASSWORD_CLAIM_SIGNATURE: (0, $650c859408628344$export$577b7d8a4f1b23fd)({
            username: username,
            userPoolName: userPoolName,
            challengeParameters: challengeParameters,
            dateNow: dateNow,
            hkdf: hkdf
        })
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReqResponseChallenge = {
        ChallengeName: "PASSWORD_VERIFIER",
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $1592ec11dd7f6ec9$export$11329f5ae466ab5d)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId)
    }, jsonReqResponseChallenge);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $1ca9fe6154565c83$var$handleDeviceSRPAuth({
        username: username,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $1ca9fe6154565c83$export$cf152400b58b8e65(params) {
    const { challengeName: challengeName , challengeParameters: challengeParameters , availableChallenges: availableChallenges  } = params;
    const authConfig = (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    switch(challengeName){
        case "CUSTOM_CHALLENGE":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE",
                    additionalInfo: challengeParameters
                }
            };
        case "MFA_SETUP":
            {
                const { signInSession: signInSession , username: username  } = (0, $af24ca9998616e43$export$390d5da4c63a4a41).getState();
                const mfaSetupTypes = $1ca9fe6154565c83$export$d70c792e078766ea($1ca9fe6154565c83$export$4055ded9e78438ba(challengeParameters.MFAS_CAN_SETUP)) || [];
                const allowedMfaSetupTypes = $1ca9fe6154565c83$export$343435e7c7c3ff0f(mfaSetupTypes);
                const isTotpMfaSetupAvailable = allowedMfaSetupTypes.includes("TOTP");
                const isEmailMfaSetupAvailable = allowedMfaSetupTypes.includes("EMAIL");
                if (isTotpMfaSetupAvailable && isEmailMfaSetupAvailable) return {
                    isSignedIn: false,
                    nextStep: {
                        signInStep: "CONTINUE_SIGN_IN_WITH_MFA_SETUP_SELECTION",
                        allowedMFATypes: allowedMfaSetupTypes
                    }
                };
                if (isEmailMfaSetupAvailable) return {
                    isSignedIn: false,
                    nextStep: {
                        signInStep: "CONTINUE_SIGN_IN_WITH_EMAIL_SETUP"
                    }
                };
                if (isTotpMfaSetupAvailable) {
                    const associateSoftwareToken = (0, $013d14f6ec1bab3a$export$6bff32634453de2a)({
                        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
                            endpointOverride: authConfig.userPoolEndpoint
                        })
                    });
                    const { Session: Session , SecretCode: secretCode  } = await associateSoftwareToken({
                        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(authConfig.userPoolId)
                    }, {
                        Session: signInSession
                    });
                    (0, $af24ca9998616e43$export$390d5da4c63a4a41).dispatch({
                        type: "SET_SIGN_IN_SESSION",
                        value: Session
                    });
                    return {
                        isSignedIn: false,
                        nextStep: {
                            signInStep: "CONTINUE_SIGN_IN_WITH_TOTP_SETUP",
                            totpSetupDetails: $1ca9fe6154565c83$export$b105c3e8e4f5ce91(secretCode, username)
                        }
                    };
                }
                throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
                    name: (0, $7ccba6b199ab94b3$export$473ab0b56598aacd).SignInException,
                    message: `Cannot initiate MFA setup from available types: ${mfaSetupTypes}`
                });
            }
        case "NEW_PASSWORD_REQUIRED":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
                    missingAttributes: $1ca9fe6154565c83$export$fbe550151e406473(challengeParameters.requiredAttributes)
                }
            };
        case "SELECT_MFA_TYPE":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONTINUE_SIGN_IN_WITH_MFA_SELECTION",
                    allowedMFATypes: $1ca9fe6154565c83$export$d70c792e078766ea($1ca9fe6154565c83$export$4055ded9e78438ba(challengeParameters.MFAS_CAN_CHOOSE))
                }
            };
        case "SMS_OTP":
        case "SMS_MFA":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_SMS_CODE",
                    codeDeliveryDetails: {
                        deliveryMedium: challengeParameters.CODE_DELIVERY_DELIVERY_MEDIUM,
                        destination: challengeParameters.CODE_DELIVERY_DESTINATION
                    }
                }
            };
        case "SOFTWARE_TOKEN_MFA":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
                }
            };
        case "EMAIL_OTP":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_EMAIL_CODE",
                    codeDeliveryDetails: {
                        deliveryMedium: challengeParameters.CODE_DELIVERY_DELIVERY_MEDIUM,
                        destination: challengeParameters.CODE_DELIVERY_DESTINATION
                    }
                }
            };
        case "WEB_AUTHN":
            return (0, $15550a31f4f7a21e$export$77701654924537aa)(challengeParameters);
        case "PASSWORD":
        case "PASSWORD_SRP":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_PASSWORD"
                }
            };
        case "SELECT_CHALLENGE":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONTINUE_SIGN_IN_WITH_FIRST_FACTOR_SELECTION",
                    availableChallenges: availableChallenges
                }
            };
    }
    // TODO: remove this error message for production apps
    throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: (0, $7ccba6b199ab94b3$export$473ab0b56598aacd).SignInException,
        message: "An error occurred during the sign in process. " + `${challengeName} challengeName returned by the underlying service was not addressed.`
    });
}
function $1ca9fe6154565c83$export$b105c3e8e4f5ce91(secretCode, username) {
    return {
        sharedSecret: secretCode,
        getSetupUri: (appName, accountName)=>{
            const totpUri = `otpauth://totp/${appName}:${accountName ?? username}?secret=${secretCode}&issuer=${appName}`;
            return new (0, $3415b1d6f221136c$export$beb82d9d9136c16e)(totpUri);
        }
    };
}
function $1ca9fe6154565c83$export$cafe99bb44d49edb(errorName) {
    if (errorName === (0, $c13b5be9426121ff$export$43ac0110dfdad33b).PasswordResetRequiredException) return {
        isSignedIn: false,
        nextStep: {
            signInStep: "RESET_PASSWORD"
        }
    };
    else if (errorName === (0, $c13b5be9426121ff$export$43ac0110dfdad33b).UserNotConfirmedException) return {
        isSignedIn: false,
        nextStep: {
            signInStep: "CONFIRM_SIGN_UP"
        }
    };
}
function $1ca9fe6154565c83$export$fbe550151e406473(attributes) {
    if (!attributes) return [];
    const parsedAttributes = JSON.parse(attributes).map((att)=>att.includes($1ca9fe6154565c83$var$USER_ATTRIBUTES) ? att.replace($1ca9fe6154565c83$var$USER_ATTRIBUTES, "") : att);
    return parsedAttributes;
}
function $1ca9fe6154565c83$export$c7c9603a6b1fd815(attributes) {
    if (!attributes) return {};
    const newAttributes = {};
    Object.entries(attributes).forEach(([key, value])=>{
        if (value) newAttributes[`${$1ca9fe6154565c83$var$USER_ATTRIBUTES}${key}`] = value;
    });
    return newAttributes;
}
async function $1ca9fe6154565c83$export$cfd8b50d0f78e4fa(username, challengeName, session, challengeResponse, config, tokenOrchestrator, clientMetadata, options) {
    const userAttributes = options?.userAttributes;
    const deviceName = options?.friendlyDeviceName;
    switch(challengeName){
        case "WEB_AUTHN":
        case "SELECT_CHALLENGE":
            if (challengeResponse === "PASSWORD_SRP" || challengeResponse === "PASSWORD") return {
                ChallengeName: challengeResponse,
                Session: session,
                $metadata: {}
            };
            return (0, $1808779ad5b776df$export$4eb37109154e77c1)({
                username: username,
                session: session,
                selectedChallenge: challengeResponse,
                config: config,
                clientMetadata: clientMetadata
            });
        case "SELECT_MFA_TYPE":
            return $1ca9fe6154565c83$export$f0699fc2b71f49c0({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config
            });
        case "MFA_SETUP":
            return $1ca9fe6154565c83$export$9b78cd405a35bccd({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                deviceName: deviceName,
                config: config
            });
        case "NEW_PASSWORD_REQUIRED":
            return $1ca9fe6154565c83$export$df3f8a8c68da6a2e({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                requiredAttributes: userAttributes,
                config: config
            });
        case "CUSTOM_CHALLENGE":
            return $1ca9fe6154565c83$export$30f932fe98713ccc($1ca9fe6154565c83$export$6fe6331471b54d26, [
                {
                    challengeResponse: challengeResponse,
                    clientMetadata: clientMetadata,
                    session: session,
                    username: username,
                    config: config,
                    tokenOrchestrator: tokenOrchestrator
                }
            ], username, tokenOrchestrator);
        case "SMS_MFA":
        case "SOFTWARE_TOKEN_MFA":
        case "SMS_OTP":
        case "EMAIL_OTP":
            return $1ca9fe6154565c83$export$1ec196d12cb921db({
                challengeName: challengeName,
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config
            });
        case "PASSWORD":
            return (0, $e49d51f717e3b241$export$cca550d6560f23b8)(username, challengeResponse, clientMetadata, config, session);
        case "PASSWORD_SRP":
            return (0, $74a6cee00c2fbc5c$export$e496ff225fdec499)(username, challengeResponse, clientMetadata, config, session, tokenOrchestrator);
    }
    // TODO: remove this error message for production apps
    throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: (0, $7ccba6b199ab94b3$export$473ab0b56598aacd).SignInException,
        message: `An error occurred during the sign in process.
		${challengeName} challengeName returned by the underlying service was not addressed.`
    });
}
function $1ca9fe6154565c83$export$7e7902092e38fcff(mfa) {
    let mfaType = "SMS_MFA";
    if (mfa === "TOTP") mfaType = "SOFTWARE_TOKEN_MFA";
    if (mfa === "EMAIL") mfaType = "EMAIL_OTP";
    return mfaType;
}
function $1ca9fe6154565c83$export$6ce04ce89055b1fe(type) {
    if (type === "SMS_MFA") return "SMS";
    if (type === "SOFTWARE_TOKEN_MFA") return "TOTP";
    if (type === "EMAIL_OTP") return "EMAIL";
// TODO: log warning for unknown MFA type
}
function $1ca9fe6154565c83$export$d70c792e078766ea(types) {
    if (!types) return undefined;
    return types.map($1ca9fe6154565c83$export$6ce04ce89055b1fe).filter(Boolean);
}
function $1ca9fe6154565c83$export$4055ded9e78438ba(mfa) {
    if (!mfa) return [];
    return JSON.parse(mfa);
}
function $1ca9fe6154565c83$export$343435e7c7c3ff0f(availableMfaSetupTypes) {
    return availableMfaSetupTypes.filter((authMfaType)=>authMfaType === "EMAIL" || authMfaType === "TOTP");
}
async function $1ca9fe6154565c83$export$8061cd07f982ef08() {
    let authUser;
    try {
        authUser = await (0, $06d09becd613c1b3$export$e5432d4c8eb97ea7)();
    } catch (error) {}
    if (authUser && authUser.userId && authUser.username) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: (0, $d78d124ef376faa5$export$bdd0e7e9babcd5c8),
        message: "There is already a signed in user.",
        recoverySuggestion: "Call signOut before calling signIn again."
    });
}
/**
 * This function is used to kick off the device management flow.
 *
 * If an error is thrown while generating a hash device or calling the `ConfirmDevice`
 * client, then this API will ignore the error and return undefined. Otherwise the authentication
 * flow will not complete and the user won't be able to be signed in.
 *
 * @returns DeviceMetadata | undefined
 */ async function $1ca9fe6154565c83$export$548ed8ad974a8b30({ userPoolId: userPoolId , userPoolEndpoint: userPoolEndpoint , newDeviceMetadata: newDeviceMetadata , accessToken: accessToken  }) {
    if (!newDeviceMetadata) return undefined;
    const userPoolName = userPoolId.split("_")[1] || "";
    const authenticationHelper = await (0, $4b165f329812d8bd$export$47560e2dc89f678c)(userPoolName);
    const deviceKey = newDeviceMetadata?.DeviceKey;
    const deviceGroupKey = newDeviceMetadata?.DeviceGroupKey;
    try {
        await authenticationHelper.generateHashDevice(deviceGroupKey ?? "", deviceKey ?? "");
    } catch (errGenHash) {
        // TODO: log error here
        return undefined;
    }
    const deviceSecretVerifierConfig = {
        Salt: (0, $0f87662804872ba2$export$695b149896bd3e2a).convert((0, $d9c2f17b8749cd84$export$b772e43c3daf2e7a)(authenticationHelper.getSaltToHashDevices())),
        PasswordVerifier: (0, $0f87662804872ba2$export$695b149896bd3e2a).convert((0, $d9c2f17b8749cd84$export$b772e43c3daf2e7a)(authenticationHelper.getVerifierDevices()))
    };
    const randomPassword = authenticationHelper.getRandomPassword();
    try {
        const confirmDevice = (0, $27402b0d0d11528d$export$d88a63af6351a7c3)({
            endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        await confirmDevice({
            region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId)
        }, {
            AccessToken: accessToken,
            DeviceName: await (0, $6751c708615ca735$export$98f0aedb14d75123)(),
            DeviceKey: newDeviceMetadata?.DeviceKey,
            DeviceSecretVerifierConfig: deviceSecretVerifierConfig
        });
        return {
            deviceKey: deviceKey,
            deviceGroupKey: deviceGroupKey,
            randomPassword: randomPassword
        };
    } catch (error) {
        // TODO: log error here
        return undefined;
    }
}
/**
 * It will retry the function if the error is a `ResourceNotFoundException` and
 * will clean the device keys stored in the storage mechanism.
 *
 */ async function $1ca9fe6154565c83$export$30f932fe98713ccc(func, args, username, tokenOrchestrator) {
    try {
        return await func(...args);
    } catch (error) {
        if (error instanceof (0, $68efb77f62f1efb5$export$145273558d58e0ac) && error.name === "ResourceNotFoundException" && error.message.includes("Device does not exist.")) {
            await tokenOrchestrator.clearDeviceMetadata(username);
            return func(...args);
        }
        throw error;
    }
}
function $1ca9fe6154565c83$export$fecfbc200868d412(username) {
    const { dispatch: dispatch  } = (0, $af24ca9998616e43$export$390d5da4c63a4a41);
    dispatch({
        type: "SET_USERNAME",
        value: username
    });
}
function $1ca9fe6154565c83$export$cc3585de146a51be(username) {
    const state = (0, $af24ca9998616e43$export$390d5da4c63a4a41).getState();
    return state.username ?? username;
}
async function $1ca9fe6154565c83$export$1ec196d12cb921db({ challengeName: challengeName , challengeResponse: challengeResponse , clientMetadata: clientMetadata , session: session , username: username , config: config  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    const challengeResponses = {
        USERNAME: username
    };
    if (challengeName === "EMAIL_OTP") challengeResponses.EMAIL_OTP_CODE = challengeResponse;
    if (challengeName === "SMS_MFA") challengeResponses.SMS_MFA_CODE = challengeResponse;
    if (challengeName === "SMS_OTP") challengeResponses.SMS_OTP_CODE = challengeResponse;
    if (challengeName === "SOFTWARE_TOKEN_MFA") challengeResponses.SOFTWARE_TOKEN_MFA_CODE = challengeResponse;
    const userContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: challengeName,
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: userContextData
    };
    const respondToAuthChallenge = (0, $1592ec11dd7f6ec9$export$11329f5ae466ab5d)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using a custom authentication flow without password
 *
 * @param input -  The SignInWithCustomAuthInput object
 * @returns AuthSignInResult
 * @throws service: {@link InitiateAuthException } - Cognito service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws SignInWithCustomAuthOutput - Thrown when the token provider config is invalid.
 */ async function $c97fbb3fa2c54de2$export$7f948971bcf643ff(input) {
    const authConfig = (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    const { username: username , password: password , options: options  } = input;
    const signInDetails = {
        loginId: username,
        authFlowType: "CUSTOM_WITHOUT_SRP"
    };
    const metadata = options?.clientMetadata;
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!username, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!password, (0, $37d361b81fa35812$export$12d5c695b2213c4a).CustomAuthSignInPassword);
    try {
        const { ChallengeName: retriedChallengeName , ChallengeParameters: retiredChallengeParameters , AuthenticationResult: AuthenticationResult , Session: Session  } = await (0, $1ca9fe6154565c83$export$30f932fe98713ccc)((0, $1ca9fe6154565c83$export$1a654dcab55e0de5), [
            username,
            metadata,
            authConfig,
            (0, $8165b6923e40c4bf$export$66561e66d62991d0)
        ], username, (0, $8165b6923e40c4bf$export$66561e66d62991d0));
        const activeUsername = (0, $1ca9fe6154565c83$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $af24ca9998616e43$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: retriedChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $f111a020d487e86b$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $1ca9fe6154565c83$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            });
            (0, $af24ca9998616e43$export$ddfd5a0262ce9df3)();
            await (0, $e91f0cfaaf120c70$export$4d78d2ee899572ab)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $1ca9fe6154565c83$export$cf152400b58b8e65)({
            challengeName: retriedChallengeName,
            challengeParameters: retiredChallengeParameters
        });
    } catch (error) {
        (0, $af24ca9998616e43$export$ddfd5a0262ce9df3)();
        (0, $609100932f10eceb$export$5b3890f50cd4853f)(error);
        const result = (0, $1ca9fe6154565c83$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using a custom authentication flow with SRP
 *
 * @param input -  The SignInWithCustomSRPAuthInput object
 * @returns SignInWithCustomSRPAuthOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito
 * service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $eea874a375b73269$export$2c0317ed1bbb0787(input) {
    const { username: username , password: password , options: options  } = input;
    const signInDetails = {
        loginId: username,
        authFlowType: "CUSTOM_WITH_SRP"
    };
    const authConfig = (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    const metadata = options?.clientMetadata;
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!username, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!password, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: handledChallengeName , ChallengeParameters: handledChallengeParameters , AuthenticationResult: AuthenticationResult , Session: Session  } = await (0, $1ca9fe6154565c83$export$9ce9dd351616104c)(username, password, metadata, authConfig, (0, $8165b6923e40c4bf$export$66561e66d62991d0));
        const activeUsername = (0, $1ca9fe6154565c83$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $af24ca9998616e43$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: handledChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $f111a020d487e86b$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $1ca9fe6154565c83$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            });
            (0, $af24ca9998616e43$export$ddfd5a0262ce9df3)();
            await (0, $e91f0cfaaf120c70$export$4d78d2ee899572ab)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $1ca9fe6154565c83$export$cf152400b58b8e65)({
            challengeName: handledChallengeName,
            challengeParameters: handledChallengeParameters
        });
    } catch (error) {
        (0, $af24ca9998616e43$export$ddfd5a0262ce9df3)();
        (0, $609100932f10eceb$export$5b3890f50cd4853f)(error);
        const result = (0, $1ca9fe6154565c83$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in
 *
 * @param input - The SignInWithSRPInput object
 * @returns SignInWithSRPOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito service errors
 * thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $23eafbcadeebb6d2$export$728178cf826a5ab9(input) {
    const { username: username , password: password  } = input;
    const authConfig = (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: "USER_SRP_AUTH"
    };
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    const clientMetaData = input.options?.clientMetadata;
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!username, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!password, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: handledChallengeName , ChallengeParameters: handledChallengeParameters , AuthenticationResult: AuthenticationResult , Session: Session  } = await (0, $1ca9fe6154565c83$export$13a3ef5ef8cac338)(username, password, clientMetaData, authConfig, (0, $8165b6923e40c4bf$export$66561e66d62991d0));
        const activeUsername = (0, $1ca9fe6154565c83$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $af24ca9998616e43$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: handledChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $f111a020d487e86b$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $1ca9fe6154565c83$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            });
            (0, $af24ca9998616e43$export$ddfd5a0262ce9df3)();
            await (0, $e91f0cfaaf120c70$export$4d78d2ee899572ab)();
            (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $1ca9fe6154565c83$export$cf152400b58b8e65)({
            challengeName: handledChallengeName,
            challengeParameters: handledChallengeParameters
        });
    } catch (error) {
        (0, $af24ca9998616e43$export$ddfd5a0262ce9df3)();
        (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)();
        (0, $609100932f10eceb$export$5b3890f50cd4853f)(error);
        const result = (0, $1ca9fe6154565c83$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using USER_PASSWORD_AUTH AuthFlowType
 *
 * @param input - The SignInWithUserPasswordInput object
 * @returns SignInWithUserPasswordOutput
 * @throws service: {@link InitiateAuthException } - Cognito service error thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $dd2292507d1980a8$export$200af5a623414b2b(input) {
    const { username: username , password: password , options: options  } = input;
    const authConfig = (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: "USER_PASSWORD_AUTH"
    };
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    const metadata = options?.clientMetadata;
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!username, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!password, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: retiredChallengeName , ChallengeParameters: retriedChallengeParameters , AuthenticationResult: AuthenticationResult , Session: Session  } = await (0, $1ca9fe6154565c83$export$30f932fe98713ccc)((0, $1ca9fe6154565c83$export$29fb48d356e16a7), [
            username,
            password,
            metadata,
            authConfig,
            (0, $8165b6923e40c4bf$export$66561e66d62991d0)
        ], username, (0, $8165b6923e40c4bf$export$66561e66d62991d0));
        const activeUsername = (0, $1ca9fe6154565c83$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $af24ca9998616e43$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: retiredChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $f111a020d487e86b$export$729df6fdd19b8b0d)({
                ...AuthenticationResult,
                username: activeUsername,
                NewDeviceMetadata: await (0, $1ca9fe6154565c83$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            });
            (0, $af24ca9998616e43$export$ddfd5a0262ce9df3)();
            await (0, $e91f0cfaaf120c70$export$4d78d2ee899572ab)();
            (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $1ca9fe6154565c83$export$cf152400b58b8e65)({
            challengeName: retiredChallengeName,
            challengeParameters: retriedChallengeParameters
        });
    } catch (error) {
        (0, $af24ca9998616e43$export$ddfd5a0262ce9df3)();
        (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)();
        (0, $609100932f10eceb$export$5b3890f50cd4853f)(error);
        const result = (0, $1ca9fe6154565c83$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}
































// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles user authentication flow with configurable challenge preferences.
 * Supports AuthFactorType challenges through the USER_AUTH flow.
 *
 * @param {HandleUserAuthFlowInput} params - Authentication flow parameters
 * @param {string} params.username - The username for authentication
 * @param {Record<string, string>} [params.clientMetadata] - Optional metadata to pass to authentication service
 * @param {CognitoUserPoolConfig} params.config - Cognito User Pool configuration
 * @param {AuthTokenOrchestrator} params.tokenOrchestrator - Manages authentication tokens and device tracking
 * @param {AuthFactorType} [params.preferredChallenge] - Optional preferred authentication method
 * @param {string} [params.password] - Required when preferredChallenge is 'PASSWORD' or 'PASSWORD_SRP'
 *
 * @returns {Promise<InitiateAuthCommandOutput>} The authentication response from Cognito
 */ async function $c2933fbf04a2a8af$export$f21455679019a68e({ username: username , clientMetadata: clientMetadata , config: config , tokenOrchestrator: tokenOrchestrator , preferredChallenge: preferredChallenge , password: password , session: session  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = config;
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const authParameters = {
        USERNAME: username
    };
    if (preferredChallenge) {
        if (preferredChallenge === "PASSWORD_SRP") {
            (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!password, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInPassword);
            return (0, $fcfe8914aa5d6201$export$169bd15774e46c56)({
                username: username,
                password: password,
                clientMetadata: clientMetadata,
                config: config,
                tokenOrchestrator: tokenOrchestrator,
                authFlow: "USER_AUTH",
                preferredChallenge: preferredChallenge
            });
        }
        if (preferredChallenge === "PASSWORD") {
            (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!password, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInPassword);
            authParameters.PASSWORD = password;
        }
        authParameters.PREFERRED_CHALLENGE = preferredChallenge;
    }
    const jsonReq = {
        AuthFlow: "USER_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    if (session) jsonReq.Session = session;
    const initiateAuth = (0, $74a589de9a455739$export$91f349d78bea7765)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await initiateAuth({
        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    // Set the active username immediately after successful authentication attempt
    // If a user starts a new sign-in while another sign-in is incomplete,
    // this ensures we're tracking the correct user for subsequent auth challenges.
    (0, $1ca9fe6154565c83$export$fecfbc200868d412)(username);
    return response;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in through a registered email or phone number without a password by by receiving and entering an OTP.
 *
 * @param input - The SignInWithUserAuthInput object
 * @returns SignInWithUserAuthOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito service errors
 * thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password -- needs to change
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $277b04e5e6d5a136$export$fcfa00cf0f5ec937(input) {
    const { username: username , password: password , options: options  } = input;
    const authConfig = (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: "USER_AUTH"
    };
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    const clientMetaData = options?.clientMetadata;
    const preferredChallenge = options?.preferredChallenge;
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!username, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInUsername);
    try {
        const handleUserAuthFlowInput = {
            username: username,
            config: authConfig,
            tokenOrchestrator: $8165b6923e40c4bf$export$66561e66d62991d0,
            clientMetadata: clientMetaData,
            preferredChallenge: preferredChallenge,
            password: password
        };
        const autoSignInStoreState = (0, $da6c6b387e94c6c2$export$ef87a9980a3566ca).getState();
        if (autoSignInStoreState.active && autoSignInStoreState.username === username) handleUserAuthFlowInput.session = autoSignInStoreState.session;
        const response = await (0, $c2933fbf04a2a8af$export$f21455679019a68e)(handleUserAuthFlowInput);
        const activeUsername = (0, $1ca9fe6154565c83$export$cc3585de146a51be)(username);
        (0, $af24ca9998616e43$export$bae72361b690e075)({
            signInSession: response.Session,
            username: activeUsername,
            challengeName: response.ChallengeName,
            signInDetails: signInDetails
        });
        if (response.AuthenticationResult) {
            await (0, $f111a020d487e86b$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...response.AuthenticationResult,
                NewDeviceMetadata: await (0, $1ca9fe6154565c83$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: response.AuthenticationResult.NewDeviceMetadata,
                    accessToken: response.AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            });
            (0, $af24ca9998616e43$export$ddfd5a0262ce9df3)();
            await (0, $e91f0cfaaf120c70$export$4d78d2ee899572ab)();
            (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $1ca9fe6154565c83$export$cf152400b58b8e65)({
            challengeName: response.ChallengeName,
            challengeParameters: response.ChallengeParameters,
            availableChallenges: "AvailableChallenges" in response ? response.AvailableChallenges : undefined
        });
    } catch (error) {
        (0, $af24ca9998616e43$export$ddfd5a0262ce9df3)();
        (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)();
        (0, $609100932f10eceb$export$5b3890f50cd4853f)(error);
        const result = (0, $1ca9fe6154565c83$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in
 *
 * @param input -  The SignInInput object
 * @returns SignInOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException }
 *  - Cognito service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $2cb9c637e17f5e83$export$9670d83f11d4b64a(input) {
    // Here we want to reset the store but not reassign the callback.
    // The callback is reset when the underlying promise resolves or rejects.
    // With the advent of session based sign in, this guarantees that the signIn API initiates a new auth flow,
    // regardless of whether it is called for a user currently engaged in an active auto sign in session.
    (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)(false);
    const authFlowType = input.options?.authFlowType;
    await (0, $1ca9fe6154565c83$export$8061cd07f982ef08)();
    switch(authFlowType){
        case "USER_SRP_AUTH":
            return (0, $23eafbcadeebb6d2$export$728178cf826a5ab9)(input);
        case "USER_PASSWORD_AUTH":
            return (0, $dd2292507d1980a8$export$200af5a623414b2b)(input);
        case "CUSTOM_WITHOUT_SRP":
            return (0, $c97fbb3fa2c54de2$export$7f948971bcf643ff)(input);
        case "CUSTOM_WITH_SRP":
            return (0, $eea874a375b73269$export$2c0317ed1bbb0787)(input);
        case "USER_AUTH":
            return (0, $277b04e5e6d5a136$export$fcfa00cf0f5ec937)(input);
        default:
            return (0, $23eafbcadeebb6d2$export$728178cf826a5ab9)(input);
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $761398897f4408f5$export$d1b63878dfcc70a6() {
    return (0, $d9009b35813b573c$export$a3858a9a153cffc7).Auth.clearCredentials();
}


















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3921b3ba76f9552f$export$f8a4fedaab76b065 = async (store)=>{
    await store.clearOAuthData();
    (0, $8165b6923e40c4bf$export$66561e66d62991d0).clearTokens();
    await (0, $761398897f4408f5$export$d1b63878dfcc70a6)();
    (0, $c9802061728ce106$export$8c41bb232f1008b1).dispatch("auth", {
        event: "signedOut"
    }, "Auth", (0, $c9802061728ce106$export$aadf71dd9875dd20));
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a955d12a9fd50322$export$a673d54799039714 = async (url)=>{
    if (!window?.location) return;
    // enforce HTTPS
    window.location.href = url.replace("http://", "https://");
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** @internal */ function $1f553bf159d1f595$export$93832c3affb240d3(redirects, preferredRedirectUrl) {
    if (preferredRedirectUrl) {
        const redirectUrl = redirects?.find((redirect)=>redirect === preferredRedirectUrl);
        if (!redirectUrl) throw 0, $d78d124ef376faa5$export$41a56a70fc1a4962;
        return redirectUrl;
    } else {
        const redirectUrlFromTheSameOrigin = redirects?.find($1f553bf159d1f595$var$isSameOriginAndPathName) ?? redirects?.find($1f553bf159d1f595$var$isTheSameDomain);
        const redirectUrlFromDifferentOrigin = redirects?.find($1f553bf159d1f595$var$isHttps) ?? redirects?.find($1f553bf159d1f595$var$isHttp);
        if (redirectUrlFromTheSameOrigin) return redirectUrlFromTheSameOrigin;
        else if (redirectUrlFromDifferentOrigin) throw 0, $d78d124ef376faa5$export$c01b4acd6291e035;
        throw 0, $d78d124ef376faa5$export$60b68b138a52e5ae;
    }
}
// origin + pathname => https://example.com/app
const $1f553bf159d1f595$var$isSameOriginAndPathName = (redirect)=>redirect.startsWith(// eslint-disable-next-line no-constant-binary-expression
    String((window.location.origin + window.location.pathname) ?? "/"));
// domain => outlook.live.com, github.com
const $1f553bf159d1f595$var$isTheSameDomain = (redirect)=>redirect.includes(String(window.location.hostname));
const $1f553bf159d1f595$var$isHttp = (redirect)=>redirect.startsWith("http://");
const $1f553bf159d1f595$var$isHttps = (redirect)=>redirect.startsWith("https://");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2c9d40c3a431c601$export$a20426d3d43ad21f = async (authConfig, preferPrivateSession = false, redirectUrl)=>{
    (0, $d0b404dc65adc192$export$c13e6dbaf90a8e5f)(authConfig);
    const { loginWith: loginWith , userPoolClientId: userPoolClientId  } = authConfig;
    const { domain: domain , redirectSignOut: redirectSignOut  } = loginWith.oauth;
    const signoutUri = (0, $1f553bf159d1f595$export$93832c3affb240d3)(redirectSignOut, redirectUrl);
    const oAuthLogoutEndpoint = `https://${domain}/logout?${Object.entries({
        client_id: userPoolClientId,
        logout_uri: encodeURIComponent(signoutUri)
    }).map(([k, v])=>`${k}=${v}`).join("&")}`;
    return (0, $a955d12a9fd50322$export$a673d54799039714)(oAuthLogoutEndpoint);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $db781626f98e890f$export$74290142c99a2f64 = async (cognitoConfig, store, tokenOrchestrator, redirectUrl)=>{
    const { isOAuthSignIn: isOAuthSignIn  } = await store.loadOAuthSignIn();
    const oauthMetadata = await tokenOrchestrator.getOAuthMetadata();
    // Clear everything before attempting to visted logout endpoint since the current application
    // state could be wiped away on redirect
    await (0, $3921b3ba76f9552f$export$f8a4fedaab76b065)(store);
    // The isOAuthSignIn flag is propagated by the oAuthToken store which manages oauth keys in local storage only.
    // These keys are used to determine if a user is in an inflight or signedIn oauth states.
    // However, this behavior represents an issue when 2 apps share the same set of tokens in Cookie storage because the app that didn't
    // start the OAuth will not have access to the oauth keys.
    // A heuristic solution is to add oauth metadata to the tokenOrchestrator which will have access to the underlying
    // storage mechanism that is used by Amplify.
    if (isOAuthSignIn || oauthMetadata?.oauthSignIn) // On web, this will always end up being a void action
    return (0, $2c9d40c3a431c601$export$a20426d3d43ad21f)(cognitoConfig, false, redirectUrl);
};

















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $fca192693ad21855$export$93ed00c43cc3ad50 = (config)=>(0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $2c989c9ee9688ddf$export$10f11e95d7a96f7b), (0, $644eb7a063c0ce65$export$1113413e6e842bef)("RevokeToken"), (0, $70b030255b6cf783$export$8159795418a3e796)(), {
        ...(0, $ab5c45a15b3ed82d$export$22a3716e7860147a),
        ...config
    });











// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $37ba81a975736b4f$export$9ebd23b04fdf4c3a = (config)=>(0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $2c989c9ee9688ddf$export$10f11e95d7a96f7b), (0, $644eb7a063c0ce65$export$1113413e6e842bef)("GlobalSignOut"), (0, $70b030255b6cf783$export$8159795418a3e796)(), {
        ...(0, $ab5c45a15b3ed82d$export$22a3716e7860147a),
        ...config
    });



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e0d56740eddbd6fc$var$logger = new (0, $cda4d9e419200573$export$ba6a9c7ac8291f7f)("Auth");
/**
 * Signs a user out
 *
 * @param input - The SignOutInput object
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $e0d56740eddbd6fc$export$b0ac3a1c242cb1ea(input) {
    const cognitoConfig = (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(cognitoConfig);
    if (input?.global) await $e0d56740eddbd6fc$var$globalSignOut(cognitoConfig);
    else await $e0d56740eddbd6fc$var$clientSignOut(cognitoConfig);
    let hasOAuthConfig;
    try {
        (0, $d0b404dc65adc192$export$c13e6dbaf90a8e5f)(cognitoConfig);
        hasOAuthConfig = true;
    } catch (err) {
        hasOAuthConfig = false;
    }
    if (hasOAuthConfig) {
        const oAuthStore = new (0, $52c2ee4fd5af8dee$export$9b2cef5d94f9b6e8)((0, $c1a7077392f3b8b2$export$586b30dcaeecb901));
        oAuthStore.setAuthConfig(cognitoConfig);
        const { type: type  } = await (0, $db781626f98e890f$export$74290142c99a2f64)(cognitoConfig, oAuthStore, (0, $8165b6923e40c4bf$export$66561e66d62991d0), input?.oauth?.redirectUrl) ?? {};
        if (type === "error") throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: (0, $d78d124ef376faa5$export$625255707e22459c),
            message: `An error occurred when attempting to log out from OAuth provider.`
        });
    } else {
        // complete sign out
        (0, $8165b6923e40c4bf$export$66561e66d62991d0).clearTokens();
        await (0, $761398897f4408f5$export$d1b63878dfcc70a6)();
        (0, $c9802061728ce106$export$8c41bb232f1008b1).dispatch("auth", {
            event: "signedOut"
        }, "Auth", (0, $c9802061728ce106$export$aadf71dd9875dd20));
    }
}
async function $e0d56740eddbd6fc$var$clientSignOut(cognitoConfig) {
    try {
        const { userPoolEndpoint: userPoolEndpoint , userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = cognitoConfig;
        const authTokens = await (0, $8165b6923e40c4bf$export$66561e66d62991d0).getTokenStore().loadTokens();
        (0, $45fe96cf99d947f4$export$be38b2d22222d505)(authTokens);
        if ($e0d56740eddbd6fc$var$isSessionRevocable(authTokens.accessToken)) {
            const revokeToken = (0, $fca192693ad21855$export$93ed00c43cc3ad50)({
                endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
                    endpointOverride: userPoolEndpoint
                })
            });
            await revokeToken({
                region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId),
                userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).SignOut)
            }, {
                ClientId: userPoolClientId,
                Token: authTokens.refreshToken
            });
        }
    } catch (err) {
        // this shouldn't throw
        $e0d56740eddbd6fc$var$logger.debug("Client signOut error caught but will proceed with token removal");
    }
}
async function $e0d56740eddbd6fc$var$globalSignOut(cognitoConfig) {
    try {
        const { userPoolEndpoint: userPoolEndpoint , userPoolId: userPoolId  } = cognitoConfig;
        const authTokens = await (0, $8165b6923e40c4bf$export$66561e66d62991d0).getTokenStore().loadTokens();
        (0, $45fe96cf99d947f4$export$77712ea5882cac9f)(authTokens);
        const globalSignOutClient = (0, $37ba81a975736b4f$export$9ebd23b04fdf4c3a)({
            endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        await globalSignOutClient({
            region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId),
            userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).SignOut)
        }, {
            AccessToken: authTokens.accessToken.toString()
        });
    } catch (err) {
        // it should not throw
        $e0d56740eddbd6fc$var$logger.debug("Global signOut error caught but will proceed with token removal");
    }
}
const $e0d56740eddbd6fc$var$isSessionRevocable = (token)=>!!token?.payload?.origin_jti;













// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e92a233c003b80cf$var$MAX_AUTOSIGNIN_POLLING_MS = 180000;
function $e92a233c003b80cf$export$385d6b43f72ecccf(signInInput) {
    const stopHubListener = (0, $c9802061728ce106$export$45dde0743a4c8d6e).listen("auth-internal", async ({ payload: payload  })=>{
        switch(payload.event){
            case "confirmSignUp":
                {
                    const response = payload.data;
                    if (response?.isSignUpComplete) {
                        (0, $c9802061728ce106$export$45dde0743a4c8d6e).dispatch("auth-internal", {
                            event: "autoSignIn"
                        });
                        (0, $84ab96e5fb6bfc37$export$7dcbf67a23c27835)($e92a233c003b80cf$var$autoSignInWithCode(signInInput));
                        stopHubListener();
                    }
                }
        }
    });
    // This will stop the listener if confirmSignUp is not resolved.
    const timeOutId = setTimeout(()=>{
        stopHubListener();
        clearTimeout(timeOutId);
        (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)();
    }, $e92a233c003b80cf$var$MAX_AUTOSIGNIN_POLLING_MS);
}
function $e92a233c003b80cf$var$debounce(fun, delay) {
    let timer;
    return (args)=>{
        if (!timer) fun(...args);
        clearTimeout(timer);
        timer = setTimeout(()=>{
            timer = undefined;
        }, delay);
    };
}
function $e92a233c003b80cf$var$handleAutoSignInWithLink(signInInput, resolve, reject) {
    const start = Date.now();
    const autoSignInPollingIntervalId = setInterval(async ()=>{
        const elapsedTime = Date.now() - start;
        const maxTime = $e92a233c003b80cf$var$MAX_AUTOSIGNIN_POLLING_MS;
        if (elapsedTime > maxTime) {
            clearInterval(autoSignInPollingIntervalId);
            reject(new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
                name: (0, $d78d124ef376faa5$export$fe46a12932d2550a),
                message: "The account was not confirmed on time.",
                recoverySuggestion: "Try to verify your account by clicking the link sent your email or phone and then login manually."
            }));
            (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)();
        } else try {
            const signInOutput = await (0, $2cb9c637e17f5e83$export$9670d83f11d4b64a)(signInInput);
            if (signInOutput.nextStep.signInStep !== "CONFIRM_SIGN_UP") {
                resolve(signInOutput);
                clearInterval(autoSignInPollingIntervalId);
                (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)();
            }
        } catch (error) {
            clearInterval(autoSignInPollingIntervalId);
            reject(error);
            (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)();
        }
    }, 5000);
}
const $e92a233c003b80cf$var$debouncedAutoSignInWithLink = $e92a233c003b80cf$var$debounce($e92a233c003b80cf$var$handleAutoSignInWithLink, 300);
const $e92a233c003b80cf$var$debouncedAutoSignWithCodeOrUserConfirmed = $e92a233c003b80cf$var$debounce($e92a233c003b80cf$var$handleAutoSignInWithCodeOrUserConfirmed, 300);
function $e92a233c003b80cf$export$feaed4858b71e8a(signInInput) {
    return async ()=>{
        return new Promise((resolve, reject)=>{
            $e92a233c003b80cf$var$debouncedAutoSignInWithLink([
                signInInput,
                resolve,
                reject
            ]);
        });
    };
}
async function $e92a233c003b80cf$var$handleAutoSignInWithCodeOrUserConfirmed(signInInput, resolve, reject) {
    try {
        const output = signInInput?.options?.authFlowType === "USER_AUTH" ? await (0, $277b04e5e6d5a136$export$fcfa00cf0f5ec937)(signInInput) : await (0, $2cb9c637e17f5e83$export$9670d83f11d4b64a)(signInInput);
        resolve(output);
        (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)();
    } catch (error) {
        reject(error);
        (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)();
    }
}
function $e92a233c003b80cf$var$autoSignInWithCode(signInInput) {
    return async ()=>{
        return new Promise((resolve, reject)=>{
            $e92a233c003b80cf$var$debouncedAutoSignWithCodeOrUserConfirmed([
                signInInput,
                resolve,
                reject
            ]);
        });
    };
}
const $e92a233c003b80cf$export$9ec2c3d010185172 = $e92a233c003b80cf$var$autoSignInWithCode;


















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $079242b1c0134bbf$export$f9d992c2ce90154a = ()=>async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, $209f6e497b3a00cd$export$be467dfcc0538e25)(response);
            (0, $609100932f10eceb$export$5b3890f50cd4853f)(error);
            if (// Missing Password Error
            // 1 validation error detected: Value at 'password'failed to satisfy constraint: Member must not be null
            error.name === (0, $c13b5be9426121ff$export$d0816902ed99fce6).InvalidParameterException && /'password'/.test(error.message) && /Member must not be null/.test(error.message)) {
                const name = (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignUpPassword;
                const { message: message , recoverySuggestion: recoverySuggestion  } = (0, $7ccba6b199ab94b3$export$195137955146d376)[name];
                throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
                    name: name,
                    message: message,
                    recoverySuggestion: recoverySuggestion
                });
            }
            throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
                name: error.name,
                message: error.message
            });
        }
        return (0, $209f6e497b3a00cd$export$759bcb35b0d1bf81)(response);
    };
const $079242b1c0134bbf$export$99fa98564ba4db04 = (config)=>(0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $2c989c9ee9688ddf$export$10f11e95d7a96f7b), (0, $644eb7a063c0ce65$export$1113413e6e842bef)("SignUp"), $079242b1c0134bbf$export$f9d992c2ce90154a(), {
        ...(0, $ab5c45a15b3ed82d$export$22a3716e7860147a),
        ...config
    });






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Creates a user
 *
 * @param input - The SignUpInput object
 * @returns SignUpOutput
 * @throws service: {@link SignUpException } - Cognito service errors thrown during the sign-up process.
 * @throws validation: {@link AuthValidationErrorCode } - Validation errors thrown either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $b163cbe6f8b04bf5$export$cf64224bcd829024(input) {
    const { username: username , password: password , options: options  } = input;
    const authConfig = (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signUpVerificationMethod = authConfig?.signUpVerificationMethod ?? "code";
    const { clientMetadata: clientMetadata , validationData: validationData , autoSignIn: autoSignIn  } = input.options ?? {};
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!username, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignUpUsername);
    const signInServiceOptions = typeof autoSignIn !== "boolean" ? autoSignIn : undefined;
    const signInInput = {
        username: username,
        options: signInServiceOptions
    };
    // if the authFlowType is 'CUSTOM_WITHOUT_SRP' then we don't include the password
    if (signInServiceOptions?.authFlowType !== "CUSTOM_WITHOUT_SRP") signInInput.password = password;
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId , userPoolEndpoint: userPoolEndpoint  } = authConfig;
    const signUpClient = (0, $079242b1c0134bbf$export$99fa98564ba4db04)({
        endpointResolver: (0, $c09f0e38e47b8a60$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const signUpClientInput = {
        Username: username,
        Password: undefined,
        UserAttributes: options?.userAttributes && (0, $26de5e277ff0a29a$export$720a7caa078a04b0)(options?.userAttributes),
        ClientMetadata: clientMetadata,
        ValidationData: validationData && (0, $26de5e277ff0a29a$export$720a7caa078a04b0)(validationData),
        ClientId: userPoolClientId,
        UserContextData: (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
            username: username,
            userPoolId: userPoolId,
            userPoolClientId: userPoolClientId
        })
    };
    if (password) signUpClientInput.Password = password;
    const { UserSub: userId , CodeDeliveryDetails: cdd , UserConfirmed: userConfirmed , Session: session  } = await signUpClient({
        region: (0, $e76389a51923234d$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).SignUp)
    }, signUpClientInput);
    if (signInServiceOptions || autoSignIn === true) {
        (0, $da6c6b387e94c6c2$export$ef87a9980a3566ca).dispatch({
            type: "START"
        });
        (0, $da6c6b387e94c6c2$export$ef87a9980a3566ca).dispatch({
            type: "SET_USERNAME",
            value: username
        });
        (0, $da6c6b387e94c6c2$export$ef87a9980a3566ca).dispatch({
            type: "SET_SESSION",
            value: session
        });
    }
    const codeDeliveryDetails = {
        destination: cdd?.Destination,
        deliveryMedium: cdd?.DeliveryMedium,
        attributeName: cdd?.AttributeName
    };
    const isSignUpComplete = !!userConfirmed;
    const isAutoSignInStarted = (0, $da6c6b387e94c6c2$export$ef87a9980a3566ca).getState().active;
    // Sign Up Complete
    // No Confirm Sign In Step Required
    if (isSignUpComplete) {
        if (isAutoSignInStarted) {
            (0, $84ab96e5fb6bfc37$export$7dcbf67a23c27835)((0, $e92a233c003b80cf$export$9ec2c3d010185172)(signInInput));
            return {
                isSignUpComplete: true,
                nextStep: {
                    signUpStep: "COMPLETE_AUTO_SIGN_IN"
                },
                userId: userId
            };
        }
        return {
            isSignUpComplete: true,
            nextStep: {
                signUpStep: "DONE"
            },
            userId: userId
        };
    }
    // Sign Up Not Complete
    // Confirm Sign Up Step Required
    if (isAutoSignInStarted) {
        // Confirmation Via Link Occurs In Separate Context
        // AutoSignIn Fn Will Initiate Polling Once Executed
        if (signUpVerificationMethod === "link") {
            (0, $84ab96e5fb6bfc37$export$7dcbf67a23c27835)((0, $e92a233c003b80cf$export$feaed4858b71e8a)(signInInput));
            return {
                isSignUpComplete: false,
                nextStep: {
                    signUpStep: "COMPLETE_AUTO_SIGN_IN",
                    codeDeliveryDetails: codeDeliveryDetails
                },
                userId: userId
            };
        }
        // Confirmation Via Code Occurs In Same Context
        // AutoSignIn Next Step Will Be Returned From Confirm Sign Up
        (0, $e92a233c003b80cf$export$385d6b43f72ecccf)(signInInput);
    }
    return {
        isSignUpComplete: false,
        nextStep: {
            signUpStep: "CONFIRM_SIGN_UP",
            codeDeliveryDetails: codeDeliveryDetails
        },
        userId: userId
    };
}


const $9bbe216c50eeb619$var$awsmobile = {
    aws_project_region: "us-east-1",
    aws_cognito_region: "us-east-1",
    aws_user_pools_id: "us-east-1_[FILL_IN_THE_BLANK]",
    aws_user_pools_web_client_id: "[FILL_IN_THE_BLANK]",
    oauth: {},
    aws_cognito_username_attributes: [
        "EMAIL"
    ],
    aws_cognito_social_providers: [],
    aws_cognito_signup_attributes: [
        "EMAIL"
    ],
    aws_cognito_verification_mechanisms: [
        "EMAIL"
    ]
};
var $9bbe216c50eeb619$export$2e2bcd8739ae039 = $9bbe216c50eeb619$var$awsmobile;


// Context
// Intervals are pretty darn tricky in React; if you're not careful, you'll wind up with a "stale" interval, one which can't access current values of state or props.
// This hook allows us to sidestep that confusion, and it also gives us a superpower: we can modify the delay without having to worry about stopping and starting the interval.
// I learned about this hook from Dan in his blog post (https://overreacted.io/making-setinterval-declarative-with-react-hooks/) on the subject, and he does a fantastic job explaining what all this funkiness is and why you need it. He explains it better than I would be able to, so if you're curious how it works, read his blog post all about it!
// I did make one significant change to his version: My version of the hook returns the interval ID, similar to window.setInterval. This allows you to cancel the interval imperatively, if you need to. Note that this is an escape hatch: the primary declarative way to cancel the interval is to set the delay equal to null.
// Link to this headingUsage
// useInterval looks quite a bit like setInterval in its usage:
// JS
// useInterval(() => {
//   console.log('I fire every second!');
// }, 1000);
// Here's an example of a "Stopwatch" component. useInterval lets us track how much time has elapsed since the user has started the stopwatch.
// JSX
// const Stopwatch = () => {
//   const [status, setStatus] = React.useState('idle');
//   const [timeElapsed, setTimeElapsed] = React.useState(0);
//   useInterval(
//     () => {
//       setTimeElapsed((timeElapsed) => timeElapsed + 1);
//     },
//     status === 'running' ? 1000 : null
//   );
//   const toggle = () => {
//     setTimeElapsed(0);
//     setStatus((status) => (status === 'running' ? 'idle' : 'running'));
//   };
//   return (
//     <>
//       Time Elapsed: {timeElapsed} second(s)
//       <button onClick={toggle}>
//         {status === 'running' ? 'Stop' : 'Start'}
//       </button>
//     </>
//   );
// };

var $exYeM = parcelRequire("exYeM");
function $ea8c1bc85a530331$var$useInterval(callback, delay) {
    const intervalRef = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
    const savedCallback = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(callback);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const tick = ()=>savedCallback.current();
        if (typeof delay === "number") {
            intervalRef.current = window.setInterval(tick, delay);
            return ()=>window.clearInterval(intervalRef.current);
        }
    }, [
        delay
    ]);
    return intervalRef;
}
var $ea8c1bc85a530331$export$2e2bcd8739ae039 = $ea8c1bc85a530331$var$useInterval;


(0, $15c60452aaf7d22d$export$11ac3725994bec7b).configure((0, $9bbe216c50eeb619$export$2e2bcd8739ae039));
const $5d80ae41f2d7c184$export$38ee920e59704589 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext();
// const ENDPOINT = process.env.REACT_APP_TASKS_API;
// const AUTH_ENDPOINT = process.env.REACT_APP_TASKS_API;
// const API_KEY = process.env.REACT_APP_API_KEY;
function $5d80ae41f2d7c184$var$UserProvider({ children: children  }) {
    const [isAuthenticated, setIsAuthenticated] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [authUpdated, setAuthUpdated] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(0);
    const [user, setUser] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const [token, setToken] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    const [isAuthModalOpen, setIsAuthModalOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [infiniteScrollToken, setInfiniteScrollToken] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    const [stats, setStats] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    const [name, setName] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const fetchToken = async ()=>{
        try {
            const { tokens: tokens  } = await (0, $56b943a689c803eb$export$39430dfe49142ae)({
                forceRefresh: true
            });
            const idToken = tokens.idToken.toString();
            setToken(idToken);
        } catch (err) {
            setIsAuthenticated(false);
        }
    };
    (0, $ea8c1bc85a530331$export$2e2bcd8739ae039)(fetchToken, isAuthenticated ? 3600000 : null);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const getUserData = async ()=>{
            try {
                const { username: username , userId: userId , signInDetails: signInDetails  } = await (0, $06d09becd613c1b3$export$e5432d4c8eb97ea7)();
                const userAttributes = await (0, $d5dec7a857031cfa$export$5dc95ecf3f16c6c9)();
                setIsAuthenticated(true);
                setUser(username);
                setName(userAttributes["given_name"]);
                const { tokens: tokens  } = await (0, $56b943a689c803eb$export$39430dfe49142ae)({
                    forceRefresh: true
                });
                const idToken = tokens.idToken.toString();
                setToken(idToken);
            } catch (err) {
                //
                setIsAuthenticated(false);
            }
        };
        getUserData();
    }, [
        authUpdated
    ]);
    // const deleteQuery = async (queryId) => {
    //   const oldQuery = userQueries.filter((query) => {
    //     return query.MATRIX_SHAREID.S === queryId;
    //   })[0];
    //   const oldUlid = oldQuery.MATRIX_ULID.S;
    //   setUserQueries((oldValue) => {
    //     return oldValue.filter((query) => {
    //       return query.MATRIX_SHAREID.S !== queryId;
    //     });
    //   });
    //   const URL = AUTH_ENDPOINT + `query?id=${queryId}&ulid=${oldUlid}`;
    //   const HEADERS = {
    //     'Content-Type': 'application/json',
    //     Authorization: token,
    //   };
    //   const request = new Request(URL, {
    //     method: 'DELETE',
    //     headers: HEADERS,
    //     timeout: 100000,
    //   });
    //   const response = await fetch(request);
    //   const json = await response.json();
    // };
    // const deleteSequence = async (sequenceId) => {
    //   const oldSequence = userSequences.filter((sequence) => {
    //     return sequence.id === sequenceId;
    //   })[0];
    //   const sequenceTitle = oldSequence.name;
    //   const payload = { title: sequenceTitle };
    //   const URL = AUTH_ENDPOINT + `sequence`;
    //   const HEADERS = {
    //     'Content-Type': 'application/json',
    //     Authorization: token,
    //   };
    //   const request = new Request(URL, {
    //     method: 'DELETE',
    //     headers: HEADERS,
    //     body: JSON.stringify(payload),
    //     timeout: 100000,
    //   });
    //   const response = await fetch(request);
    //   const json = await response.json();
    // };
    const handleLogout = async ()=>{
        try {
            await (0, $e0d56740eddbd6fc$export$b0ac3a1c242cb1ea)();
            setIsAuthenticated(false);
            setUser("");
            setName("");
            setAuthUpdated((oldValue)=>oldValue + 1);
        } catch (err) {
        //
        }
    };
    const handleLogin = async (email, password)=>{
        try {
            const input = {
                username: email,
                password: password
            };
            const response = await (0, $2cb9c637e17f5e83$export$9670d83f11d4b64a)(input);
            setAuthUpdated((oldValue)=>oldValue + 1);
        } catch (err) {
        //
        }
    };
    const handleSignUp = async (email, password)=>{
        try {
            const input = {
                username: email,
                password: password,
                options: {
                    userAttributes: {
                        email: email
                    }
                }
            };
            const signUpResponse = await (0, $b163cbe6f8b04bf5$export$cf64224bcd829024)(input);
        } catch (err) {
        //
        }
    };
    const handleConfirmSignUp = async (email, code)=>{
        try {
            const { isSignUpComplete: isSignUpComplete , nextStep: nextStep  } = await (0, $e8e960606449d760$export$2ce39ab6662e8c24)({
                username: email,
                confirmationCode: code
            });
            setAuthUpdated((oldValue)=>oldValue + 1);
        } catch (error) {
        //
        }
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($5d80ae41f2d7c184$export$38ee920e59704589.Provider, {
        value: {
            isAuthenticated: isAuthenticated,
            setIsAuthenticated: setIsAuthenticated,
            user: user,
            handleLogout: handleLogout,
            handleLogin: handleLogin,
            handleSignUp: handleSignUp,
            handleConfirmSignUp: handleConfirmSignUp,
            isAuthModalOpen: isAuthModalOpen,
            setIsAuthModalOpen: setIsAuthModalOpen,
            token: token,
            stats: stats,
            name: name
        },
        children: children
    });
}
var $5d80ae41f2d7c184$export$2e2bcd8739ae039 = $5d80ae41f2d7c184$var$UserProvider;







var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
// packages/core/primitive/src/primitive.tsx
function $a20bcd1655f7f422$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}


// packages/react/compose-refs/src/composeRefs.tsx

var $exYeM = parcelRequire("exYeM");
function $a0301a3b12ffad9c$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $a0301a3b12ffad9c$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $a0301a3b12ffad9c$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $a0301a3b12ffad9c$var$setRef(refs[i], null);
            }
        };
    };
}
function $a0301a3b12ffad9c$export$c7b2cbe3552a0d05(...refs) {
    return $exYeM.useCallback($a0301a3b12ffad9c$export$43e446d32b3d21af(...refs), refs);
}


// packages/react/context/src/createContext.tsx

var $exYeM = parcelRequire("exYeM");

function $e1a745ecb8941240$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $exYeM.createContext(defaultContext);
    const Provider = (props)=>{
        const { children: children , ...context } = props;
        const value = $exYeM.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = $exYeM.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function $e1a745ecb8941240$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $exYeM.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope: scope , children: children , ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $exYeM.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $exYeM.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $exYeM.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $exYeM.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $e1a745ecb8941240$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $e1a745ecb8941240$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope , scopeName: scopeName  })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $exYeM.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}


// packages/react/id/src/id.tsx

var $exYeM = parcelRequire("exYeM");
// packages/react/use-layout-effect/src/useLayoutEffect.tsx

var $exYeM = parcelRequire("exYeM");
var $96a334e7374a91f2$export$e5c5a5f917a5871c = Boolean(globalThis?.document) ? $exYeM.useLayoutEffect : ()=>{};


var $6e53b15deb1e14e9$var$useReactId = $exYeM["useId".toString()] || (()=>void 0);
var $6e53b15deb1e14e9$var$count = 0;
function $6e53b15deb1e14e9$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $exYeM.useState($6e53b15deb1e14e9$var$useReactId());
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($6e53b15deb1e14e9$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}


// packages/react/use-controllable-state/src/useControllableState.tsx

var $exYeM = parcelRequire("exYeM");
// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $exYeM = parcelRequire("exYeM");
function $cec6513cd2787f04$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $exYeM.useRef(callback);
    $exYeM.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $exYeM.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


function $ceaa710ce91b202b$export$6f32135080cb4c3({ prop: prop , defaultProp: defaultProp , onChange: onChange = ()=>{}  }) {
    const [uncontrolledProp, setUncontrolledProp] = $ceaa710ce91b202b$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onChange);
    const setValue = $exYeM.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value2 !== prop) handleChange(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $ceaa710ce91b202b$var$useUncontrolledState({ defaultProp: defaultProp , onChange: onChange  }) {
    const uncontrolledState = $exYeM.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = $exYeM.useRef(value);
    const handleChange = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onChange);
    $exYeM.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}



var $exYeM = parcelRequire("exYeM");

// packages/react/primitive/src/Primitive.tsx

var $exYeM = parcelRequire("exYeM");

// packages/react/slot/src/Slot.tsx

var $exYeM = parcelRequire("exYeM");


var $8d4dfd758f40b63f$export$8c6ed5c666ac1360 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = $exYeM.Children.toArray(children);
    const slottable = childrenArray.find($8d4dfd758f40b63f$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($exYeM.Children.count(newElement) > 1) return $exYeM.Children.only(null);
                return $exYeM.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($8d4dfd758f40b63f$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $exYeM.isValidElement(newElement) ? $exYeM.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($8d4dfd758f40b63f$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$8d4dfd758f40b63f$export$8c6ed5c666ac1360.displayName = "Slot";
var $8d4dfd758f40b63f$var$SlotClone = $exYeM.forwardRef((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if ($exYeM.isValidElement(children)) {
        const childrenRef = $8d4dfd758f40b63f$var$getElementRef(children);
        return $exYeM.cloneElement(children, {
            ...$8d4dfd758f40b63f$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $a0301a3b12ffad9c$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $exYeM.Children.count(children) > 1 ? $exYeM.Children.only(null) : null;
});
$8d4dfd758f40b63f$var$SlotClone.displayName = "SlotClone";
var $8d4dfd758f40b63f$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: children
    });
};
function $8d4dfd758f40b63f$var$isSlottable(child) {
    return $exYeM.isValidElement(child) && child.type === $8d4dfd758f40b63f$export$d9f1ccf0bdb05d45;
}
function $8d4dfd758f40b63f$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $8d4dfd758f40b63f$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $8d4dfd758f40b63f$export$be92b6f5f03c0fe9 = $8d4dfd758f40b63f$export$8c6ed5c666ac1360;



var $9b1158d53fe98b0a$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $9b1158d53fe98b0a$export$250ffa63cdc0d034 = $9b1158d53fe98b0a$var$NODES.reduce((primitive, node)=>{
    const Node = $exYeM.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? (0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $9b1158d53fe98b0a$export$6d1a0317bde7de7f(target, event) {
    if (target) $97dc602bd7e23afa$exports.flushSync(()=>target.dispatchEvent(event));
}
var $9b1158d53fe98b0a$export$be92b6f5f03c0fe9 = $9b1158d53fe98b0a$export$250ffa63cdc0d034;




// packages/react/use-escape-keydown/src/useEscapeKeydown.tsx

var $exYeM = parcelRequire("exYeM");

function $34fe34d34d8734af$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
    const onEscapeKeyDown = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    $exYeM.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}



"use client";
var $0516f19b588c56c0$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $0516f19b588c56c0$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $0516f19b588c56c0$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $0516f19b588c56c0$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $0516f19b588c56c0$var$originalBodyPointerEvents;
var $0516f19b588c56c0$var$DismissableLayerContext = $exYeM.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var $0516f19b588c56c0$export$177fb62ff3ec1f22 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , ...layerProps } = props;
    const context = $exYeM.useContext($0516f19b588c56c0$var$DismissableLayerContext);
    const [node, setNode] = $exYeM.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $exYeM.useState({});
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $0516f19b588c56c0$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const focusOutside = $0516f19b588c56c0$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    (0, $34fe34d34d8734af$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $exYeM.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $0516f19b588c56c0$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $0516f19b588c56c0$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $0516f19b588c56c0$var$originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $exYeM.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $0516f19b588c56c0$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $exYeM.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($0516f19b588c56c0$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($0516f19b588c56c0$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$0516f19b588c56c0$export$177fb62ff3ec1f22.displayName = $0516f19b588c56c0$var$DISMISSABLE_LAYER_NAME;
var $0516f19b588c56c0$var$BRANCH_NAME = "DismissableLayerBranch";
var $0516f19b588c56c0$export$4d5eb2109db14228 = $exYeM.forwardRef((props, forwardedRef)=>{
    const context = $exYeM.useContext($0516f19b588c56c0$var$DismissableLayerContext);
    const ref = $exYeM.useRef(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $exYeM.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
});
$0516f19b588c56c0$export$4d5eb2109db14228.displayName = $0516f19b588c56c0$var$BRANCH_NAME;
function $0516f19b588c56c0$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
    const handlePointerDownOutside = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $exYeM.useRef(false);
    const handleClickRef = $exYeM.useRef(()=>{});
    $exYeM.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    $0516f19b588c56c0$var$handleAndDispatchCustomEvent($0516f19b588c56c0$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $0516f19b588c56c0$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $exYeM.useRef(false);
    $exYeM.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $0516f19b588c56c0$var$handleAndDispatchCustomEvent($0516f19b588c56c0$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $0516f19b588c56c0$var$dispatchUpdate() {
    const event = new CustomEvent($0516f19b588c56c0$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $0516f19b588c56c0$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete  }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $9b1158d53fe98b0a$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $0516f19b588c56c0$export$be92b6f5f03c0fe9 = $0516f19b588c56c0$export$177fb62ff3ec1f22;
var $0516f19b588c56c0$export$aecb2ddcb55c95be = $0516f19b588c56c0$export$4d5eb2109db14228;



var $exYeM = parcelRequire("exYeM");




"use client";
var $0d95d7873b2aecf3$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $0d95d7873b2aecf3$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $0d95d7873b2aecf3$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $0d95d7873b2aecf3$var$FOCUS_SCOPE_NAME = "FocusScope";
var $0d95d7873b2aecf3$export$20e40289641fbbb6 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false , trapped: trapped = false , onMountAutoFocus: onMountAutoFocusProp , onUnmountAutoFocus: onUnmountAutoFocusProp , ...scopeProps } = props;
    const [container, setContainer] = $exYeM.useState(null);
    const onMountAutoFocus = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $exYeM.useRef(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = $exYeM.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $exYeM.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $0d95d7873b2aecf3$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $0d95d7873b2aecf3$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $0d95d7873b2aecf3$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $exYeM.useEffect(()=>{
        if (container) {
            $0d95d7873b2aecf3$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($0d95d7873b2aecf3$var$AUTOFOCUS_ON_MOUNT, $0d95d7873b2aecf3$var$EVENT_OPTIONS);
                container.addEventListener($0d95d7873b2aecf3$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $0d95d7873b2aecf3$var$focusFirst($0d95d7873b2aecf3$var$removeLinks($0d95d7873b2aecf3$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $0d95d7873b2aecf3$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($0d95d7873b2aecf3$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($0d95d7873b2aecf3$var$AUTOFOCUS_ON_UNMOUNT, $0d95d7873b2aecf3$var$EVENT_OPTIONS);
                    container.addEventListener($0d95d7873b2aecf3$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $0d95d7873b2aecf3$var$focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener($0d95d7873b2aecf3$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $0d95d7873b2aecf3$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $exYeM.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $0d95d7873b2aecf3$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $0d95d7873b2aecf3$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $0d95d7873b2aecf3$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$0d95d7873b2aecf3$export$20e40289641fbbb6.displayName = $0d95d7873b2aecf3$var$FOCUS_SCOPE_NAME;
function $0d95d7873b2aecf3$var$focusFirst(candidates, { select: select = false  } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $0d95d7873b2aecf3$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $0d95d7873b2aecf3$var$getTabbableEdges(container) {
    const candidates = $0d95d7873b2aecf3$var$getTabbableCandidates(container);
    const first = $0d95d7873b2aecf3$var$findVisible(candidates, container);
    const last = $0d95d7873b2aecf3$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $0d95d7873b2aecf3$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $0d95d7873b2aecf3$var$findVisible(elements, container) {
    for (const element of elements){
        if (!$0d95d7873b2aecf3$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $0d95d7873b2aecf3$var$isHidden(node, { upTo: upTo  }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $0d95d7873b2aecf3$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $0d95d7873b2aecf3$var$focus(element, { select: select = false  } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $0d95d7873b2aecf3$var$isSelectableInput(element) && select) element.select();
    }
}
var $0d95d7873b2aecf3$var$focusScopesStack = $0d95d7873b2aecf3$var$createFocusScopesStack();
function $0d95d7873b2aecf3$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $0d95d7873b2aecf3$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $0d95d7873b2aecf3$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
function $0d95d7873b2aecf3$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $0d95d7873b2aecf3$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var $0d95d7873b2aecf3$export$be92b6f5f03c0fe9 = $0d95d7873b2aecf3$export$20e40289641fbbb6;



var $exYeM = parcelRequire("exYeM");




"use client";
var $965ca2171585ad7a$var$PORTAL_NAME = "Portal";
var $965ca2171585ad7a$export$602eac185826482c = $exYeM.forwardRef((props, forwardedRef)=>{
    const { container: containerProp , ...portalProps } = props;
    const [mounted, setMounted] = $exYeM.useState(false);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? (0, (/*@__PURE__*/$parcel$interopDefault($97dc602bd7e23afa$exports))).createPortal(/* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$965ca2171585ad7a$export$602eac185826482c.displayName = $965ca2171585ad7a$var$PORTAL_NAME;
var $965ca2171585ad7a$export$be92b6f5f03c0fe9 = $965ca2171585ad7a$export$602eac185826482c;



var $exYeM = parcelRequire("exYeM");


"use client";
function $4a876f8b5705075b$var$useStateMachine(initialState, machine) {
    return $exYeM.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// packages/react/presence/src/Presence.tsx
var $4a876f8b5705075b$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present , children: children  } = props;
    const presence = $4a876f8b5705075b$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $exYeM.Children.only(children);
    const ref = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(presence.ref, $4a876f8b5705075b$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $exYeM.cloneElement(child, {
        ref: ref
    }) : null;
};
$4a876f8b5705075b$export$99c2b779aa4e8b8b.displayName = "Presence";
function $4a876f8b5705075b$var$usePresence(present) {
    const [node, setNode] = $exYeM.useState();
    const stylesRef = $exYeM.useRef({});
    const prevPresentRef = $exYeM.useRef(present);
    const prevAnimationNameRef = $exYeM.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $4a876f8b5705075b$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $exYeM.useEffect(()=>{
        const currentAnimationName = $4a876f8b5705075b$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $4a876f8b5705075b$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $4a876f8b5705075b$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $4a876f8b5705075b$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $exYeM.useCallback((node2)=>{
            if (node2) stylesRef.current = getComputedStyle(node2);
            setNode(node2);
        }, [])
    };
}
function $4a876f8b5705075b$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $4a876f8b5705075b$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}




var $exYeM = parcelRequire("exYeM");
"use client";
var $c12fde423b091e9b$var$count = 0;
function $c12fde423b091e9b$export$ac5b58043b79449b(props) {
    $c12fde423b091e9b$export$b7ece24a22aeda8c();
    return props.children;
}
function $c12fde423b091e9b$export$b7ece24a22aeda8c() {
    $exYeM.useEffect(()=>{
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", edgeGuards[0] ?? $c12fde423b091e9b$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", edgeGuards[1] ?? $c12fde423b091e9b$var$createFocusGuard());
        $c12fde423b091e9b$var$count++;
        return ()=>{
            if ($c12fde423b091e9b$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $c12fde423b091e9b$var$count--;
        };
    }, []);
}
function $c12fde423b091e9b$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}
var $c12fde423b091e9b$export$be92b6f5f03c0fe9 = $c12fde423b091e9b$export$ac5b58043b79449b;




var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
var $a424de23c132f073$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $a424de23c132f073$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $a424de23c132f073$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $a424de23c132f073$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";



var $exYeM = parcelRequire("exYeM");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $584d39a8643d937a$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $exYeM = parcelRequire("exYeM");
function $d00d56265ba92762$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $exYeM.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $d221d2c5d570aa1d$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $exYeM.useLayoutEffect : $exYeM.useEffect;
var $d221d2c5d570aa1d$var$currentValues = new WeakMap();
function $d221d2c5d570aa1d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $d00d56265ba92762$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $584d39a8643d937a$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $d221d2c5d570aa1d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $d221d2c5d570aa1d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $584d39a8643d937a$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $584d39a8643d937a$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $d221d2c5d570aa1d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



function $f527f4cfb322b92a$var$ItoI(a) {
    return a;
}
function $f527f4cfb322b92a$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $f527f4cfb322b92a$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $f527f4cfb322b92a$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $f527f4cfb322b92a$var$ItoI;
    return $f527f4cfb322b92a$var$innerCreateMedium(defaults, middleware);
}
function $f527f4cfb322b92a$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $f527f4cfb322b92a$var$innerCreateMedium(null);
    medium.options = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $4fc5d5f926eb9841$export$e27363444bedfeac = (0, $f527f4cfb322b92a$export$e13ec7dd7a14088d)();


var $6c2939159ce57a12$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $6c2939159ce57a12$export$22940b497e769dee = $exYeM.forwardRef(function(props, parentRef) {
    var ref = $exYeM.useRef(null);
    var _a = $exYeM.useState({
        onScrollCapture: $6c2939159ce57a12$var$nothing,
        onWheelCapture: $6c2939159ce57a12$var$nothing,
        onTouchMoveCapture: $6c2939159ce57a12$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $d221d2c5d570aa1d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, rest), callbacks);
    return $exYeM.createElement($exYeM.Fragment, null, enabled && $exYeM.createElement(SideCar, {
        sideCar: (0, $4fc5d5f926eb9841$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $exYeM.cloneElement($exYeM.Children.only(children), (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $exYeM.createElement(Container, (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$6c2939159ce57a12$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$6c2939159ce57a12$export$22940b497e769dee.classNames = {
    fullWidth: (0, $a424de23c132f073$export$898e37bbd2a0ae4e),
    zeroRight: (0, $a424de23c132f073$export$1da7500147d4bc3)
};




var $exYeM = parcelRequire("exYeM");
var $20ca6eb20b4dc049$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $exYeM.createElement(Target, (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, rest));
};
$20ca6eb20b4dc049$var$SideCar.isSideCarExport = true;
function $20ca6eb20b4dc049$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $20ca6eb20b4dc049$var$SideCar;
}




var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
var $c01c422d43bc8e57$var$currentNonce;
var $c01c422d43bc8e57$export$c5f670b24c0ae95a = function(nonce) {
    $c01c422d43bc8e57$var$currentNonce = nonce;
};
var $c01c422d43bc8e57$export$2b85b721e524d74b = function() {
    if ($c01c422d43bc8e57$var$currentNonce) return $c01c422d43bc8e57$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $00191a54979f785d$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $c01c422d43bc8e57$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $00191a54979f785d$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $00191a54979f785d$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $00191a54979f785d$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $00191a54979f785d$var$makeStyleTag()) {
                    $00191a54979f785d$var$injectStyles(stylesheet, style);
                    $00191a54979f785d$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $071c3d40780405a9$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $00191a54979f785d$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $exYeM.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $3d3e09c66c873f3e$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $071c3d40780405a9$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $8c733fa2685d08ec$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $8c733fa2685d08ec$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $8c733fa2685d08ec$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $8c733fa2685d08ec$var$parse(left),
        $8c733fa2685d08ec$var$parse(top),
        $8c733fa2685d08ec$var$parse(right)
    ];
};
var $8c733fa2685d08ec$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $8c733fa2685d08ec$export$efed13b5d0ca3386;
    var offsets = $8c733fa2685d08ec$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $b8129a946e86d087$var$Style = (0, $3d3e09c66c873f3e$export$c1248ee86ba532c8)();
var $b8129a946e86d087$export$65254d5f26cb9564 = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $b8129a946e86d087$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $a424de23c132f073$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($b8129a946e86d087$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $a424de23c132f073$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $a424de23c132f073$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $a424de23c132f073$export$1da7500147d4bc3), " .").concat((0, $a424de23c132f073$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $a424de23c132f073$export$898e37bbd2a0ae4e), " .").concat((0, $a424de23c132f073$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($b8129a946e86d087$export$65254d5f26cb9564, "] {\n    ").concat((0, $a424de23c132f073$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $b8129a946e86d087$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($b8129a946e86d087$export$65254d5f26cb9564) || "0", 10);
    return isFinite(counter) ? counter : 0;
};
var $b8129a946e86d087$export$a1939b1f9f9b02dc = function() {
    $exYeM.useEffect(function() {
        document.body.setAttribute($b8129a946e86d087$export$65254d5f26cb9564, ($b8129a946e86d087$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $b8129a946e86d087$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($b8129a946e86d087$export$65254d5f26cb9564);
            else document.body.setAttribute($b8129a946e86d087$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $b8129a946e86d087$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
    $b8129a946e86d087$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $exYeM.useMemo(function() {
        return (0, $8c733fa2685d08ec$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $exYeM.createElement($b8129a946e86d087$var$Style, {
        styles: $b8129a946e86d087$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $00c689171e355a98$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $00c689171e355a98$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $00c689171e355a98$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $00c689171e355a98$var$options, $00c689171e355a98$var$options);
    // @ts-ignore
    window.removeEventListener("test", $00c689171e355a98$var$options, $00c689171e355a98$var$options);
} catch (err) {
    $00c689171e355a98$var$passiveSupported = false;
}
var $00c689171e355a98$export$10a6e88623fa9454 = $00c689171e355a98$var$passiveSupported ? {
    passive: false
} : false;


var $895262f629112328$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $895262f629112328$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$895262f629112328$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $895262f629112328$var$elementCouldBeVScrolled = function(node) {
    return $895262f629112328$var$elementCanBeScrolled(node, "overflowY");
};
var $895262f629112328$var$elementCouldBeHScrolled = function(node) {
    return $895262f629112328$var$elementCanBeScrolled(node, "overflowX");
};
var $895262f629112328$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $895262f629112328$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $895262f629112328$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $895262f629112328$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $895262f629112328$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $895262f629112328$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $895262f629112328$var$elementCouldBeVScrolled(node) : $895262f629112328$var$elementCouldBeHScrolled(node);
};
var $895262f629112328$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $895262f629112328$var$getVScrollVariables(node) : $895262f629112328$var$getHScrollVariables(node);
};
var $895262f629112328$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $895262f629112328$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $895262f629112328$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $895262f629112328$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($895262f629112328$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) target = target.host;
        else target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $e11a1edcdcbdc39d$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $e11a1edcdcbdc39d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $e11a1edcdcbdc39d$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $e11a1edcdcbdc39d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $e11a1edcdcbdc39d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $e11a1edcdcbdc39d$var$idCounter = 0;
var $e11a1edcdcbdc39d$var$lockStack = [];
function $e11a1edcdcbdc39d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $exYeM.useRef([]);
    var touchStartRef = $exYeM.useRef([
        0,
        0
    ]);
    var activeAxis = $exYeM.useRef();
    var id = $exYeM.useState($e11a1edcdcbdc39d$var$idCounter++)[0];
    var Style = $exYeM.useState((0, $3d3e09c66c873f3e$export$c1248ee86ba532c8))[0];
    var lastProps = $exYeM.useRef(props);
    $exYeM.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $exYeM.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $3433e5a3eb89c040$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($e11a1edcdcbdc39d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $exYeM.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2 || event.type === "wheel" && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $e11a1edcdcbdc39d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $895262f629112328$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $895262f629112328$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $895262f629112328$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $exYeM.useCallback(function(_event) {
        var event = _event;
        if (!$e11a1edcdcbdc39d$var$lockStack.length || $e11a1edcdcbdc39d$var$lockStack[$e11a1edcdcbdc39d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $e11a1edcdcbdc39d$export$39efaa2ca254a28d(event) : $e11a1edcdcbdc39d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $e11a1edcdcbdc39d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($e11a1edcdcbdc39d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $exYeM.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $e11a1edcdcbdc39d$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $exYeM.useCallback(function(event) {
        touchStartRef.current = $e11a1edcdcbdc39d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $exYeM.useCallback(function(event) {
        shouldCancel(event.type, $e11a1edcdcbdc39d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $exYeM.useCallback(function(event) {
        shouldCancel(event.type, $e11a1edcdcbdc39d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $exYeM.useEffect(function() {
        $e11a1edcdcbdc39d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $00c689171e355a98$export$10a6e88623fa9454));
        return function() {
            $e11a1edcdcbdc39d$var$lockStack = $e11a1edcdcbdc39d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $00c689171e355a98$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $exYeM.createElement($exYeM.Fragment, null, inert ? $exYeM.createElement(Style, {
        styles: $e11a1edcdcbdc39d$var$generateStyle(id)
    }) : null, removeScrollBar ? $exYeM.createElement((0, $b8129a946e86d087$export$9aa43b459c5ae9b9), {
        gapMode: props.gapMode
    }) : null);
}
function $e11a1edcdcbdc39d$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $5f000f9080e28e0a$export$2e2bcd8739ae039 = (0, $20ca6eb20b4dc049$export$6cacc8fb0a9b94ce)((0, $4fc5d5f926eb9841$export$e27363444bedfeac), (0, $e11a1edcdcbdc39d$export$a09dbff87b5da2d));


var $471317fac98e876e$var$ReactRemoveScroll = $exYeM.forwardRef(function(props, ref) {
    return $exYeM.createElement((0, $6c2939159ce57a12$export$22940b497e769dee), (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $5f000f9080e28e0a$export$2e2bcd8739ae039)
    }));
});
$471317fac98e876e$var$ReactRemoveScroll.classNames = (0, $6c2939159ce57a12$export$22940b497e769dee).classNames;
var $471317fac98e876e$export$2e2bcd8739ae039 = $471317fac98e876e$var$ReactRemoveScroll;


var $ed7fbe99f365bc63$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $ed7fbe99f365bc63$var$counterMap = new WeakMap();
var $ed7fbe99f365bc63$var$uncontrolledNodes = new WeakMap();
var $ed7fbe99f365bc63$var$markerMap = {};
var $ed7fbe99f365bc63$var$lockCount = 0;
var $ed7fbe99f365bc63$var$unwrapHost = function(node) {
    return node && (node.host || $ed7fbe99f365bc63$var$unwrapHost(node.parentNode));
};
var $ed7fbe99f365bc63$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $ed7fbe99f365bc63$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $ed7fbe99f365bc63$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $ed7fbe99f365bc63$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$ed7fbe99f365bc63$var$markerMap[markerName]) $ed7fbe99f365bc63$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $ed7fbe99f365bc63$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($ed7fbe99f365bc63$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $ed7fbe99f365bc63$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $ed7fbe99f365bc63$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            } catch (e) {
                console.error("aria-hidden: cannot operate on ", node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $ed7fbe99f365bc63$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $ed7fbe99f365bc63$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $ed7fbe99f365bc63$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$ed7fbe99f365bc63$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $ed7fbe99f365bc63$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $ed7fbe99f365bc63$var$lockCount--;
        if (!$ed7fbe99f365bc63$var$lockCount) {
            // clear
            $ed7fbe99f365bc63$var$counterMap = new WeakMap();
            $ed7fbe99f365bc63$var$counterMap = new WeakMap();
            $ed7fbe99f365bc63$var$uncontrolledNodes = new WeakMap();
            $ed7fbe99f365bc63$var$markerMap = {};
        }
    };
};
var $ed7fbe99f365bc63$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $ed7fbe99f365bc63$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $ed7fbe99f365bc63$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $ed7fbe99f365bc63$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $ed7fbe99f365bc63$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $ed7fbe99f365bc63$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $ed7fbe99f365bc63$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $ed7fbe99f365bc63$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($ed7fbe99f365bc63$export$cc95fea82d705fca() ? $ed7fbe99f365bc63$export$59151cc8db999a24 : $ed7fbe99f365bc63$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};




"use client";
var $d624d4ffa9e1ab8a$var$DIALOG_NAME = "Dialog";
var [$d624d4ffa9e1ab8a$var$createDialogContext, $d624d4ffa9e1ab8a$export$cc702773b8ea3e41] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($d624d4ffa9e1ab8a$var$DIALOG_NAME);
var [$d624d4ffa9e1ab8a$var$DialogProvider, $d624d4ffa9e1ab8a$var$useDialogContext] = $d624d4ffa9e1ab8a$var$createDialogContext($d624d4ffa9e1ab8a$var$DIALOG_NAME);
var $d624d4ffa9e1ab8a$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog , children: children , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , modal: modal = true  } = props;
    const triggerRef = $exYeM.useRef(null);
    const contentRef = $exYeM.useRef(null);
    const [open = false, setOpen] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        titleId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        descriptionId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $exYeM.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: children
    });
};
$d624d4ffa9e1ab8a$export$3ddf2d174ce01153.displayName = $d624d4ffa9e1ab8a$var$DIALOG_NAME;
var $d624d4ffa9e1ab8a$var$TRIGGER_NAME = "DialogTrigger";
var $d624d4ffa9e1ab8a$export$2e1e1122cf0cba88 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...triggerProps } = props;
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $d624d4ffa9e1ab8a$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
});
$d624d4ffa9e1ab8a$export$2e1e1122cf0cba88.displayName = $d624d4ffa9e1ab8a$var$TRIGGER_NAME;
var $d624d4ffa9e1ab8a$var$PORTAL_NAME = "DialogPortal";
var [$d624d4ffa9e1ab8a$var$PortalProvider, $d624d4ffa9e1ab8a$var$usePortalContext] = $d624d4ffa9e1ab8a$var$createDialogContext($d624d4ffa9e1ab8a$var$PORTAL_NAME, {
    forceMount: void 0
});
var $d624d4ffa9e1ab8a$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog , forceMount: forceMount , children: children , container: container  } = props;
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount,
        children: $exYeM.Children.map(children, (child)=>/* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $965ca2171585ad7a$export$602eac185826482c), {
                    asChild: true,
                    container: container,
                    children: child
                })
            }))
    });
};
$d624d4ffa9e1ab8a$export$dad7c95542bacce0.displayName = $d624d4ffa9e1ab8a$var$PORTAL_NAME;
var $d624d4ffa9e1ab8a$var$OVERLAY_NAME = "DialogOverlay";
var $d624d4ffa9e1ab8a$export$bd1d06c79be19e17 = $exYeM.forwardRef((props, forwardedRef)=>{
    const portalContext = $d624d4ffa9e1ab8a$var$usePortalContext($d624d4ffa9e1ab8a$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...overlayProps } = props;
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$var$DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
});
$d624d4ffa9e1ab8a$export$bd1d06c79be19e17.displayName = $d624d4ffa9e1ab8a$var$OVERLAY_NAME;
var $d624d4ffa9e1ab8a$var$DialogOverlayImpl = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...overlayProps } = props;
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$OVERLAY_NAME, __scopeDialog);
    return(// Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $471317fac98e876e$export$2e2bcd8739ae039), {
        as: (0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360),
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ],
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
            "data-state": $d624d4ffa9e1ab8a$var$getState(context.open),
            ...overlayProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
});
var $d624d4ffa9e1ab8a$var$CONTENT_NAME = "DialogContent";
var $d624d4ffa9e1ab8a$export$b6d9565de1e068cf = $exYeM.forwardRef((props, forwardedRef)=>{
    const portalContext = $d624d4ffa9e1ab8a$var$usePortalContext($d624d4ffa9e1ab8a$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...contentProps } = props;
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$var$DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$var$DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$d624d4ffa9e1ab8a$export$b6d9565de1e068cf.displayName = $d624d4ffa9e1ab8a$var$CONTENT_NAME;
var $d624d4ffa9e1ab8a$var$DialogContentModal = $exYeM.forwardRef((props, forwardedRef)=>{
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = $exYeM.useRef(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef);
    $exYeM.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $ed7fbe99f365bc63$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$var$DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            event.preventDefault();
            context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    });
});
var $d624d4ffa9e1ab8a$var$DialogContentNonModal = $exYeM.forwardRef((props, forwardedRef)=>{
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = $exYeM.useRef(false);
    const hasPointerDownOutsideRef = $exYeM.useRef(false);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$var$DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $d624d4ffa9e1ab8a$var$DialogContentImpl = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , trapFocus: trapFocus , onOpenAutoFocus: onOpenAutoFocus , onCloseAutoFocus: onCloseAutoFocus , ...contentProps } = props;
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$CONTENT_NAME, __scopeDialog);
    const contentRef = $exYeM.useRef(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    (0, $c12fde423b091e9b$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $0d95d7873b2aecf3$export$20e40289641fbbb6), {
                asChild: true,
                loop: true,
                trapped: trapFocus,
                onMountAutoFocus: onOpenAutoFocus,
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $0516f19b588c56c0$export$177fb62ff3ec1f22), {
                    role: "dialog",
                    id: context.contentId,
                    "aria-describedby": context.descriptionId,
                    "aria-labelledby": context.titleId,
                    "data-state": $d624d4ffa9e1ab8a$var$getState(context.open),
                    ...contentProps,
                    ref: composedRefs,
                    onDismiss: ()=>context.onOpenChange(false)
                })
            }),
            /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$var$TitleWarning, {
                        titleId: context.titleId
                    }),
                    /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$var$DescriptionWarning, {
                        contentRef: contentRef,
                        descriptionId: context.descriptionId
                    })
                ]
            })
        ]
    });
});
var $d624d4ffa9e1ab8a$var$TITLE_NAME = "DialogTitle";
var $d624d4ffa9e1ab8a$export$16f7638e4a34b909 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...titleProps } = props;
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
});
$d624d4ffa9e1ab8a$export$16f7638e4a34b909.displayName = $d624d4ffa9e1ab8a$var$TITLE_NAME;
var $d624d4ffa9e1ab8a$var$DESCRIPTION_NAME = "DialogDescription";
var $d624d4ffa9e1ab8a$export$94e94c2ec2c954d5 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...descriptionProps } = props;
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$d624d4ffa9e1ab8a$export$94e94c2ec2c954d5.displayName = $d624d4ffa9e1ab8a$var$DESCRIPTION_NAME;
var $d624d4ffa9e1ab8a$var$CLOSE_NAME = "DialogClose";
var $d624d4ffa9e1ab8a$export$fba2fb7cd781b7ac = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...closeProps } = props;
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$d624d4ffa9e1ab8a$export$fba2fb7cd781b7ac.displayName = $d624d4ffa9e1ab8a$var$CLOSE_NAME;
function $d624d4ffa9e1ab8a$var$getState(open) {
    return open ? "open" : "closed";
}
var $d624d4ffa9e1ab8a$var$TITLE_WARNING_NAME = "DialogTitleWarning";
var [$d624d4ffa9e1ab8a$export$69b62a49393917d6, $d624d4ffa9e1ab8a$var$useWarningContext] = (0, $e1a745ecb8941240$export$fd42f52fd3ae1109)($d624d4ffa9e1ab8a$var$TITLE_WARNING_NAME, {
    contentName: $d624d4ffa9e1ab8a$var$CONTENT_NAME,
    titleName: $d624d4ffa9e1ab8a$var$TITLE_NAME,
    docsSlug: "dialog"
});
var $d624d4ffa9e1ab8a$var$TitleWarning = ({ titleId: titleId  })=>{
    const titleWarningContext = $d624d4ffa9e1ab8a$var$useWarningContext($d624d4ffa9e1ab8a$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    $exYeM.useEffect(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) console.error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
var $d624d4ffa9e1ab8a$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
var $d624d4ffa9e1ab8a$var$DescriptionWarning = ({ contentRef: contentRef , descriptionId: descriptionId  })=>{
    const descriptionWarningContext = $d624d4ffa9e1ab8a$var$useWarningContext($d624d4ffa9e1ab8a$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    $exYeM.useEffect(()=>{
        const describedById = contentRef.current?.getAttribute("aria-describedby");
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
var $d624d4ffa9e1ab8a$export$be92b6f5f03c0fe9 = $d624d4ffa9e1ab8a$export$3ddf2d174ce01153;
var $d624d4ffa9e1ab8a$export$41fb9f06171c75f4 = $d624d4ffa9e1ab8a$export$2e1e1122cf0cba88;
var $d624d4ffa9e1ab8a$export$602eac185826482c = $d624d4ffa9e1ab8a$export$dad7c95542bacce0;
var $d624d4ffa9e1ab8a$export$c6fdb837b070b4ff = $d624d4ffa9e1ab8a$export$bd1d06c79be19e17;
var $d624d4ffa9e1ab8a$export$7c6e2c02157bb7d2 = $d624d4ffa9e1ab8a$export$b6d9565de1e068cf;
var $d624d4ffa9e1ab8a$export$f99233281efd08a0 = $d624d4ffa9e1ab8a$export$16f7638e4a34b909;
var $d624d4ffa9e1ab8a$export$393edc798c47379d = $d624d4ffa9e1ab8a$export$94e94c2ec2c954d5;
var $d624d4ffa9e1ab8a$export$f39c2d165cd861fe = $d624d4ffa9e1ab8a$export$fba2fb7cd781b7ac;






var $exYeM = parcelRequire("exYeM");



var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");




"use client";
function $ac7c84a01af4e06e$export$c74125a8e3af6bb2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope , children: children  } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref,
            children: children
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children  } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360), {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children , ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
        const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}








// packages/react/direction/src/Direction.tsx

var $exYeM = parcelRequire("exYeM");

var $9cee77c98b858c29$var$DirectionContext = $exYeM.createContext(void 0);
var $9cee77c98b858c29$export$c760c09fdd558351 = (props)=>{
    const { dir: dir , children: children  } = props;
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($9cee77c98b858c29$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
};
function $9cee77c98b858c29$export$b39126d51d94e6f3(localDir) {
    const globalDir = $exYeM.useContext($9cee77c98b858c29$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
var $9cee77c98b858c29$export$2881499e37b75b9a = $9cee77c98b858c29$export$c760c09fdd558351;



"use client";
var $71edc3b1c9a6f9c6$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var $71edc3b1c9a6f9c6$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $71edc3b1c9a6f9c6$var$GROUP_NAME = "RovingFocusGroup";
var [$71edc3b1c9a6f9c6$var$Collection, $71edc3b1c9a6f9c6$var$useCollection, $71edc3b1c9a6f9c6$var$createCollectionScope] = (0, $ac7c84a01af4e06e$export$c74125a8e3af6bb2)($71edc3b1c9a6f9c6$var$GROUP_NAME);
var [$71edc3b1c9a6f9c6$var$createRovingFocusGroupContext, $71edc3b1c9a6f9c6$export$c7109489551a4f4] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($71edc3b1c9a6f9c6$var$GROUP_NAME, [
    $71edc3b1c9a6f9c6$var$createCollectionScope
]);
var [$71edc3b1c9a6f9c6$var$RovingFocusProvider, $71edc3b1c9a6f9c6$var$useRovingFocusContext] = $71edc3b1c9a6f9c6$var$createRovingFocusGroupContext($71edc3b1c9a6f9c6$var$GROUP_NAME);
var $71edc3b1c9a6f9c6$export$8699f7c8af148338 = $exYeM.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($71edc3b1c9a6f9c6$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup,
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($71edc3b1c9a6f9c6$var$Collection.Slot, {
            scope: props.__scopeRovingFocusGroup,
            children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($71edc3b1c9a6f9c6$var$RovingFocusGroupImpl, {
                ...props,
                ref: forwardedRef
            })
        })
    });
});
$71edc3b1c9a6f9c6$export$8699f7c8af148338.displayName = $71edc3b1c9a6f9c6$var$GROUP_NAME;
var $71edc3b1c9a6f9c6$var$RovingFocusGroupImpl = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , orientation: orientation , loop: loop = false , dir: dir , currentTabStopId: currentTabStopIdProp , defaultCurrentTabStopId: defaultCurrentTabStopId , onCurrentTabStopIdChange: onCurrentTabStopIdChange , onEntryFocus: onEntryFocus , preventScrollOnEntryFocus: preventScrollOnEntryFocus = false , ...groupProps } = props;
    const ref = $exYeM.useRef(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $9cee77c98b858c29$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = $exYeM.useState(false);
    const handleEntryFocus = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $71edc3b1c9a6f9c6$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = $exYeM.useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = $exYeM.useState(0);
    $exYeM.useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($71edc3b1c9a6f9c6$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($71edc3b1c9a6f9c6$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($71edc3b1c9a6f9c6$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: $exYeM.useCallback((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: $exYeM.useCallback(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: $exYeM.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: $exYeM.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), []),
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
            tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
            "data-orientation": orientation,
            ...groupProps,
            ref: composedRefs,
            style: {
                outline: "none",
                ...props.style
            },
            onMouseDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
                isClickFocusRef.current = true;
            }),
            onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
                const isKeyboardFocus = !isClickFocusRef.current;
                if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                    const entryFocusEvent = new CustomEvent($71edc3b1c9a6f9c6$var$ENTRY_FOCUS, $71edc3b1c9a6f9c6$var$EVENT_OPTIONS);
                    event.currentTarget.dispatchEvent(entryFocusEvent);
                    if (!entryFocusEvent.defaultPrevented) {
                        const items = getItems().filter((item)=>item.focusable);
                        const activeItem = items.find((item)=>item.active);
                        const currentItem = items.find((item)=>item.id === currentTabStopId);
                        const candidateItems = [
                            activeItem,
                            currentItem,
                            ...items
                        ].filter(Boolean);
                        const candidateNodes = candidateItems.map((item)=>item.ref.current);
                        $71edc3b1c9a6f9c6$var$focusFirst(candidateNodes, preventScrollOnEntryFocus);
                    }
                }
                isClickFocusRef.current = false;
            }),
            onBlur: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
        })
    });
});
var $71edc3b1c9a6f9c6$var$ITEM_NAME = "RovingFocusGroupItem";
var $71edc3b1c9a6f9c6$export$ab9df7c53fe8454 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , focusable: focusable = true , active: active = false , tabStopId: tabStopId , ...itemProps } = props;
    const autoId = (0, $6e53b15deb1e14e9$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $71edc3b1c9a6f9c6$var$useRovingFocusContext($71edc3b1c9a6f9c6$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $71edc3b1c9a6f9c6$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd , onFocusableItemRemove: onFocusableItemRemove  } = context;
    $exYeM.useEffect(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($71edc3b1c9a6f9c6$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active,
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
                if (!focusable) event.preventDefault();
                else context.onItemFocus(id);
            }),
            onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
            onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if (event.key === "Tab" && event.shiftKey) {
                    context.onItemShiftTab();
                    return;
                }
                if (event.target !== event.currentTarget) return;
                const focusIntent = $71edc3b1c9a6f9c6$var$getFocusIntent(event, context.orientation, context.dir);
                if (focusIntent !== void 0) {
                    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                    event.preventDefault();
                    const items = getItems().filter((item)=>item.focusable);
                    let candidateNodes = items.map((item)=>item.ref.current);
                    if (focusIntent === "last") candidateNodes.reverse();
                    else if (focusIntent === "prev" || focusIntent === "next") {
                        if (focusIntent === "prev") candidateNodes.reverse();
                        const currentIndex = candidateNodes.indexOf(event.currentTarget);
                        candidateNodes = context.loop ? $71edc3b1c9a6f9c6$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                    }
                    setTimeout(()=>$71edc3b1c9a6f9c6$var$focusFirst(candidateNodes));
                }
            })
        })
    });
});
$71edc3b1c9a6f9c6$export$ab9df7c53fe8454.displayName = $71edc3b1c9a6f9c6$var$ITEM_NAME;
var $71edc3b1c9a6f9c6$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $71edc3b1c9a6f9c6$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $71edc3b1c9a6f9c6$var$getFocusIntent(event, orientation, dir) {
    const key = $71edc3b1c9a6f9c6$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return void 0;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return void 0;
    return $71edc3b1c9a6f9c6$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $71edc3b1c9a6f9c6$var$focusFirst(candidates, preventScroll = false) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus({
            preventScroll: preventScroll
        });
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function $71edc3b1c9a6f9c6$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var $71edc3b1c9a6f9c6$export$be92b6f5f03c0fe9 = $71edc3b1c9a6f9c6$export$8699f7c8af148338;
var $71edc3b1c9a6f9c6$export$6d08773d2e66f8f2 = $71edc3b1c9a6f9c6$export$ab9df7c53fe8454;








"use client";
var $7fe50bc4532e8371$var$TABS_NAME = "Tabs";
var [$7fe50bc4532e8371$var$createTabsContext, $7fe50bc4532e8371$export$355f5bd209d7b13a] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($7fe50bc4532e8371$var$TABS_NAME, [
    (0, $71edc3b1c9a6f9c6$export$c7109489551a4f4)
]);
var $7fe50bc4532e8371$var$useRovingFocusGroupScope = (0, $71edc3b1c9a6f9c6$export$c7109489551a4f4)();
var [$7fe50bc4532e8371$var$TabsProvider, $7fe50bc4532e8371$var$useTabsContext] = $7fe50bc4532e8371$var$createTabsContext($7fe50bc4532e8371$var$TABS_NAME);
var $7fe50bc4532e8371$export$b2539bed5023c21c = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: valueProp , onValueChange: onValueChange , defaultValue: defaultValue , orientation: orientation = "horizontal" , dir: dir , activationMode: activationMode = "automatic" , ...tabsProps } = props;
    const direction = (0, $9cee77c98b858c29$export$b39126d51d94e6f3)(dir);
    const [value, setValue] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue
    });
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($7fe50bc4532e8371$var$TabsProvider, {
        scope: __scopeTabs,
        baseId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        value: value,
        onValueChange: setValue,
        orientation: orientation,
        dir: direction,
        activationMode: activationMode,
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
            dir: direction,
            "data-orientation": orientation,
            ...tabsProps,
            ref: forwardedRef
        })
    });
});
$7fe50bc4532e8371$export$b2539bed5023c21c.displayName = $7fe50bc4532e8371$var$TABS_NAME;
var $7fe50bc4532e8371$var$TAB_LIST_NAME = "TabsList";
var $7fe50bc4532e8371$export$9712d22edc0d78c1 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , loop: loop = true , ...listProps } = props;
    const context = $7fe50bc4532e8371$var$useTabsContext($7fe50bc4532e8371$var$TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = $7fe50bc4532e8371$var$useRovingFocusGroupScope(__scopeTabs);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($71edc3b1c9a6f9c6$export$be92b6f5f03c0fe9, {
        asChild: true,
        ...rovingFocusGroupScope,
        orientation: context.orientation,
        dir: context.dir,
        loop: loop,
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
            role: "tablist",
            "aria-orientation": context.orientation,
            ...listProps,
            ref: forwardedRef
        })
    });
});
$7fe50bc4532e8371$export$9712d22edc0d78c1.displayName = $7fe50bc4532e8371$var$TAB_LIST_NAME;
var $7fe50bc4532e8371$var$TRIGGER_NAME = "TabsTrigger";
var $7fe50bc4532e8371$export$8114b9fdfdf9f3ba = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: value , disabled: disabled = false , ...triggerProps } = props;
    const context = $7fe50bc4532e8371$var$useTabsContext($7fe50bc4532e8371$var$TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = $7fe50bc4532e8371$var$useRovingFocusGroupScope(__scopeTabs);
    const triggerId = $7fe50bc4532e8371$var$makeTriggerId(context.baseId, value);
    const contentId = $7fe50bc4532e8371$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($71edc3b1c9a6f9c6$export$6d08773d2e66f8f2, {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !disabled,
        active: isSelected,
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, {
            type: "button",
            role: "tab",
            "aria-selected": isSelected,
            "aria-controls": contentId,
            "data-state": isSelected ? "active" : "inactive",
            "data-disabled": disabled ? "" : void 0,
            disabled: disabled,
            id: triggerId,
            ...triggerProps,
            ref: forwardedRef,
            onMouseDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
                if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
                else event.preventDefault();
            }),
            onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if ([
                    " ",
                    "Enter"
                ].includes(event.key)) context.onValueChange(value);
            }),
            onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocus, ()=>{
                const isAutomaticActivation = context.activationMode !== "manual";
                if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
            })
        })
    });
});
$7fe50bc4532e8371$export$8114b9fdfdf9f3ba.displayName = $7fe50bc4532e8371$var$TRIGGER_NAME;
var $7fe50bc4532e8371$var$CONTENT_NAME = "TabsContent";
var $7fe50bc4532e8371$export$bd905d70e8fd2ebb = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: value , forceMount: forceMount , children: children , ...contentProps } = props;
    const context = $7fe50bc4532e8371$var$useTabsContext($7fe50bc4532e8371$var$CONTENT_NAME, __scopeTabs);
    const triggerId = $7fe50bc4532e8371$var$makeTriggerId(context.baseId, value);
    const contentId = $7fe50bc4532e8371$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = $exYeM.useRef(isSelected);
    $exYeM.useEffect(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || isSelected,
        children: ({ present: present  })=>/* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
                "data-state": isSelected ? "active" : "inactive",
                "data-orientation": context.orientation,
                role: "tabpanel",
                "aria-labelledby": triggerId,
                hidden: !present,
                id: contentId,
                tabIndex: 0,
                ...contentProps,
                ref: forwardedRef,
                style: {
                    ...props.style,
                    animationDuration: isMountAnimationPreventedRef.current ? "0s" : void 0
                },
                children: present && children
            })
    });
});
$7fe50bc4532e8371$export$bd905d70e8fd2ebb.displayName = $7fe50bc4532e8371$var$CONTENT_NAME;
function $7fe50bc4532e8371$var$makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function $7fe50bc4532e8371$var$makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
var $7fe50bc4532e8371$export$be92b6f5f03c0fe9 = $7fe50bc4532e8371$export$b2539bed5023c21c;
var $7fe50bc4532e8371$export$54c2e3dc7acea9f5 = $7fe50bc4532e8371$export$9712d22edc0d78c1;
var $7fe50bc4532e8371$export$41fb9f06171c75f4 = $7fe50bc4532e8371$export$8114b9fdfdf9f3ba;
var $7fe50bc4532e8371$export$7c6e2c02157bb7d2 = $7fe50bc4532e8371$export$bd905d70e8fd2ebb;


const $bd57f7f38adb375b$var$AuthDialog = ()=>{
    const [email, setEmail] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const [password, setPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const [confirmPassword, setConfirmPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const { handleLogin: handleLogin , handleSignUp: handleSignUp , handleConfirmSignUp: handleConfirmSignUp , setIsAuthModalOpen: setIsAuthModalOpen  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $5d80ae41f2d7c184$export$38ee920e59704589));
    const [dialogOpen, setDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [code, setCode] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const [awaitingConfirmation, setAwaitingConfirmation] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const passwordIsLongEnough = password.length >= 8;
    const passwordContainsNumber = /\d/.test(password);
    const passwordContainsSpecialCharacter = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password);
    const passwordContainsUppercase = /[A-Z]/.test(password);
    const passwordContainsLowercase = /[a-z]/.test(password);
    const passwordMatchesConfirm = password === confirmPassword && password.length > 0;
    const passwordIsValid = passwordIsLongEnough && passwordContainsNumber && passwordContainsSpecialCharacter && passwordContainsUppercase && passwordContainsLowercase && passwordMatchesConfirm;
    function handleLoginAttempt() {
        handleLogin(email, password);
        setDialogOpen(false);
        setIsAuthModalOpen(false);
    }
    function handleSignUpAttempt() {
        if (!passwordIsValid) {
            window.alert("Password is not valid! Review the requirements!");
            return;
        }
        if (email === "") {
            window.alert("Email not valid!");
            return;
        }
        handleSignUp(email, password);
        setAwaitingConfirmation(true);
    }
    function handleConfirmSignUpAttempt() {
        handleConfirmSignUp(email, code);
        setAwaitingConfirmation(false);
        setTimeout(()=>{
            handleLogin(email, password);
        }, 1000);
        setDialogOpen(false);
        setIsAuthModalOpen(false);
    }
    const signUpForm = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                className: "Text",
                children: "Create an account!"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$393edc798c47379d, {
                className: "AuthDialogDescription"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                className: "Fieldset",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                        className: "Label",
                        htmlFor: "email",
                        children: "Email"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                        value: email,
                        onChange: (e)=>setEmail(e.target.value),
                        className: "Input",
                        id: "email",
                        type: "email"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                className: "Fieldset",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                        className: "Label",
                        htmlFor: "password",
                        children: "Password"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                        value: password,
                        onChange: (e)=>setPassword(e.target.value),
                        className: "Input",
                        id: "password",
                        type: "password"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                className: "Fieldset",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                        className: "Label",
                        htmlFor: "confirmpassword",
                        children: "Confirm Password"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                        value: confirmPassword,
                        onChange: (e)=>setConfirmPassword(e.target.value),
                        className: "Input",
                        id: "password",
                        type: "password"
                    })
                ]
            }),
            passwordIsLongEnough ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">= 8 characters long"
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "< 8 characters long!"
            }),
            passwordContainsNumber ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">=1 number"
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "<1 number!"
            }),
            passwordContainsSpecialCharacter ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">=1 special character"
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "<1 special character"
            }),
            passwordContainsUppercase ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">=1 uppercase letter"
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "<1 uppercase letter"
            }),
            passwordContainsLowercase ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">=1 lowercase letter"
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "<1 lowercase letter"
            }),
            passwordMatchesConfirm ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: "Password matches confirm"
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "Password & confirm don't match"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    display: "flex",
                    marginTop: 20,
                    justifyContent: "flex-end"
                },
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                    onClick: handleSignUpAttempt,
                    className: "Button green",
                    children: "Sign Up"
                })
            })
        ]
    });
    const confirmForm = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                className: "Text",
                children: `Enter Confirmation Code Sent to ${email}`
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$393edc798c47379d, {
                className: "AuthDialogDescription"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                className: "Fieldset",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                        className: "Label",
                        htmlFor: "code",
                        children: "Confirmation Code"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                        value: code,
                        onChange: (e)=>setCode(e.target.value),
                        className: "Input",
                        id: "code",
                        type: "text"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    display: "flex",
                    marginTop: 20,
                    justifyContent: "flex-end"
                },
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                    onClick: handleConfirmSignUpAttempt,
                    className: "Button green",
                    children: "Confirm"
                })
            })
        ]
    });
    const signUpTabContent = awaitingConfirmation ? confirmForm : signUpForm;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($d624d4ffa9e1ab8a$export$be92b6f5f03c0fe9, {
        open: dialogOpen,
        onOpenChange: ()=>{
            setDialogOpen((oldValue)=>{
                setIsAuthModalOpen(!oldValue);
                return !oldValue;
            });
        },
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$41fb9f06171c75f4, {
                asChild: true,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                    className: "Button violet",
                    children: "Login"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($d624d4ffa9e1ab8a$export$602eac185826482c, {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$c6fdb837b070b4ff, {
                        className: "AuthDialogOverlay"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$7c6e2c02157bb7d2, {
                        className: "AuthDialogContent",
                        asChild: true,
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($7fe50bc4532e8371$export$be92b6f5f03c0fe9, {
                            className: "TabsRoot",
                            defaultValue: "tab1",
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($7fe50bc4532e8371$export$54c2e3dc7acea9f5, {
                                    className: "TabsList",
                                    "aria-label": "Manage your account",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($7fe50bc4532e8371$export$41fb9f06171c75f4, {
                                            className: "TabsTrigger",
                                            value: "tab1",
                                            children: "Log In"
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($7fe50bc4532e8371$export$41fb9f06171c75f4, {
                                            className: "TabsTrigger",
                                            value: "tab2",
                                            children: "Sign Up"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($7fe50bc4532e8371$export$7c6e2c02157bb7d2, {
                                    className: "TabsContent",
                                    value: "tab1",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                                            className: "Text",
                                            children: "Your username is your email."
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                                            className: "Fieldset",
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                                    className: "Label",
                                                    htmlFor: "email",
                                                    children: "Email"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                                    value: email,
                                                    onChange: (e)=>setEmail(e.target.value),
                                                    className: "Input",
                                                    id: "email",
                                                    type: "email"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                                            className: "Fieldset",
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                                    className: "Label",
                                                    htmlFor: "password",
                                                    children: "Password"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                                    value: password,
                                                    onChange: (e)=>setPassword(e.target.value),
                                                    className: "Input",
                                                    id: "password",
                                                    type: "password"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                            style: {
                                                display: "flex",
                                                marginTop: 20,
                                                justifyContent: "flex-end"
                                            },
                                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                                onClick: handleLoginAttempt,
                                                className: "Button green",
                                                children: "Log In"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($7fe50bc4532e8371$export$7c6e2c02157bb7d2, {
                                    className: "TabsContent",
                                    value: "tab2",
                                    children: signUpTabContent
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $bd57f7f38adb375b$export$2e2bcd8739ae039 = $bd57f7f38adb375b$var$AuthDialog;




// import ProjectDialog from '../ProjectDialog';
// import ProjectDropdown from '../ProjectDropdown';
function $89e428441ac6e5f2$var$NavBar() {
    //const { isAuthenticated, handleLogout } = React.useContext(UserContext);
    const { setProjects: setProjects , setProjectTasksWereRequested: setProjectTasksWereRequested , setProjectTasksWereFetched: setProjectTasksWereFetched  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $b0893505d0f7ae16$export$58d75f9829cbe158));
    function handleSelectValue(selection) {
        setProjects((oldValue)=>oldValue.includes(selection) ? oldValue : [
                ...oldValue,
                selection
            ]);
        setProjectTasksWereRequested(true);
        setProjectTasksWereFetched(false);
    }
    // const LoginLogout = isAuthenticated ? (
    //   <NavItem onClick={handleLogout}>Logout</NavItem>
    // ) : (
    //   <NavItem>
    //     <AuthDialog />
    //   </NavItem>
    // );
    // const AddProject = (
    //   <NavItem>
    //     <ProjectDialog />
    //   </NavItem>
    // );
    const settingsSVG = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-settings",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            })
        ]
    });
    const volumeMutedSVG = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-volume",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("polygon", {
            points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
        })
    });
    const volumeOnSVG = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-volume-2",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("polygon", {
                points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M15.54 8.46a5 5 0 0 1 0 7.07"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M19.07 4.93a10 10 0 0 1 0 14.14"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($89e428441ac6e5f2$var$FlexWrapper, {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($89e428441ac6e5f2$var$NavItem, {
                children: volumeOnSVG
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($89e428441ac6e5f2$var$NavItem, {
                children: "About"
            })
        ]
    });
}
var $89e428441ac6e5f2$export$2e2bcd8739ae039 = $89e428441ac6e5f2$var$NavBar;
const $89e428441ac6e5f2$var$FlexWrapper = (0, $93948c98236af5c1$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  align-self: flex-end;
  gap: 10px;
`;
const $89e428441ac6e5f2$var$NavItem = (0, $93948c98236af5c1$export$2e2bcd8739ae039).button`
  background-color: var(--number-box-background-color);
  color: var(--number-box-font-color);
  border-left: 1px solid var(--number-box-border-color);
  border-bottom: 1px solid var(--number-box-border-color);
  border-right: 1px solid var(--number-box-border-color);
  &:hover {
    background-color: var(--number-box-border-color);
    color: red;
  }
  /* width: 100px; */
  display: flex;
  padding: 2px 6px;
  /* height: 50px; */
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: inherit;

  a {
    text-decoration: none;
    color: inherit;
  }
`; // --number-box-hover-background-color: hsl(240, 10%, 85%);
 // --matrix-cell-background-color: hsl(240, 50%, 93%);
 // --action-box-background-color: hsl(240 10% 95% / 50%);
 // --action-box-hover-background-color: hsl(240 10% 85% / 50%);
 // --action-box-hover-font-color: hsl(240 90% 50% / 50%);
 // --action-box-font-color: hsl(240 65% 40% / 50%);
 // --action-box-border-color: hsl(240 65% 65% / 50%);
 // --bubble-hover-background-color: hsl(240, 100%, 50%);
 // --number-box-hover-font-color: hsl(240, 100%, 50%);
 // --bubble-hover-border-color: hsl(240, 100%, 90%);
 // --number-box-border-radius: 8px;
 // --header-color: hsl(240, 85%, 35%);
 // --active-button-color: hsl(240, 85%, 35%);
 // --hover-button-color: hsl(240, 60%, 55%);
 // --mode-button-selected: hsl(240, 85%, 35%);





function $ce2bbf7743ae7f98$var$Header() {
    const { randomItem: randomItem , setApiWasRequested: setApiWasRequested , setRequestWasHandled: setRequestWasHandled  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $b0893505d0f7ae16$export$58d75f9829cbe158));
    function handleClick() {
        console.log("handling click");
        setApiWasRequested(true);
        setRequestWasHandled(false);
    }
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $89e428441ac6e5f2$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("header", {
                className: `${$55016c398784f6a3$export$38e42c68cf43b5d4} ${(0, $55016c398784f6a3$export$385906a4ef528034)}`,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h1", {
                    children: "James Shapiro"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("span", {
                children: [
                    "Invisible",
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                        className: $55016c398784f6a3$export$69d0d1846105bbd3,
                        children: "PLACEHOLDER"
                    }),
                    "placeholder",
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                        className: $55016c398784f6a3$export$69d0d1846105bbd3,
                        children: "DEMO"
                    }),
                    "Demo"
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($ce2bbf7743ae7f98$var$Button, {
                onClick: handleClick,
                children: "Invoke API (see console)"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("span", {
                children: [
                    "Random Data Context Item: ",
                    randomItem
                ]
            })
        ]
    });
}
var $ce2bbf7743ae7f98$export$2e2bcd8739ae039 = $ce2bbf7743ae7f98$var$Header;
const $ce2bbf7743ae7f98$var$Button = (0, $93948c98236af5c1$export$2e2bcd8739ae039).button`
  padding: 20px;
  background-color: hsl(217, 100%, 61%);
  color: white;
  width: fit-content;
  border-radius: 8px;
  margin: 100px auto;
  border: 2px solid black;
`;




parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
function $a99fe579ed49bdad$var$WakeLocker() {
    const wakeLockRef = (0, $exYeM.useRef)(null);
    // Function to request the wake lock
    const requestWakeLock = async ()=>{
        try {
            const wakeLock = await navigator.wakeLock.request("screen");
            wakeLockRef.current = wakeLock;
            // Listen for release events
            wakeLock.addEventListener("release", ()=>{
                console.log("Wake Lock was released");
            });
            console.log("Wake Lock acquired");
        } catch (err) {
            console.error(`${err.name}, ${err.message}`);
        }
    };
    // Function to release the wake lock
    const releaseWakeLock = async ()=>{
        if (wakeLockRef.current !== null) {
            await wakeLockRef.current.release();
            wakeLockRef.current = null;
            console.log("Wake Lock released manually");
        }
    };
    // Handle visibility change
    const handleVisibilityChange = ()=>{
        if (document.visibilityState === "visible") requestWakeLock();
        else releaseWakeLock();
    };
    (0, $exYeM.useEffect)(()=>{
        // Initial wake lock request
        requestWakeLock();
        // Listen for visibility change
        document.addEventListener("visibilitychange", handleVisibilityChange);
        // Cleanup function to release the lock and remove listeners
        return ()=>{
            releaseWakeLock();
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);
    return null;
}
var $a99fe579ed49bdad$export$2e2bcd8739ae039 = $a99fe579ed49bdad$var$WakeLocker;






var $exYeM = parcelRequire("exYeM");




var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $8f4069742e98d682$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
const $8f4069742e98d682$var$COLUMNS = "abcdefgh".split("");
const $8f4069742e98d682$var$START_POSITION_OBJECT = {
    a8: "bR",
    b8: "bN",
    c8: "bB",
    d8: "bQ",
    e8: "bK",
    f8: "bB",
    g8: "bN",
    h8: "bR",
    a7: "bP",
    b7: "bP",
    c7: "bP",
    d7: "bP",
    e7: "bP",
    f7: "bP",
    g7: "bP",
    h7: "bP",
    a2: "wP",
    b2: "wP",
    c2: "wP",
    d2: "wP",
    e2: "wP",
    f2: "wP",
    g2: "wP",
    h2: "wP",
    a1: "wR",
    b1: "wN",
    c1: "wB",
    d1: "wQ",
    e1: "wK",
    f1: "wB",
    g1: "wN",
    h1: "wR"
};
const $8f4069742e98d682$var$WHITE_COLUMN_VALUES = {
    a: 0,
    b: 1,
    c: 2,
    d: 3,
    e: 4,
    f: 5,
    g: 6,
    h: 7
};
const $8f4069742e98d682$var$BLACK_COLUMN_VALUES = {
    a: 7,
    b: 6,
    c: 5,
    d: 4,
    e: 3,
    f: 2,
    g: 1,
    h: 0
};
const $8f4069742e98d682$var$WHITE_ROWS = [
    7,
    6,
    5,
    4,
    3,
    2,
    1,
    0
];
const $8f4069742e98d682$var$BLACK_ROWS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7
];
// https://commons.wikimedia.org/wiki/Category:SVG_chess_pieces
// By en:User:Cburnett - Own work
// This W3C - unspecified vector image was created with Inkscape., CC BY - SA 3.0, https://commons.wikimedia.org/w/index.php?curid=1499810
const $8f4069742e98d682$var$defaultPieces = {
    wP: (0, $7ead0b1397a835ed$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "m 22.5,9 c -2.21,0 -4,1.79 -4,4 0,0.89 0.29,1.71 0.78,2.38 C 17.33,16.5 16,18.59 16,21 c 0,2.03 0.94,3.84 2.41,5.03 C 15.41,27.09 11,31.58 11,39.5 H 34 C 34,31.58 29.59,27.09 26.59,26.03 28.06,24.84 29,23.03 29,21 29,18.59 27.67,16.5 25.72,15.38 26.21,14.71 26.5,13.89 26.5,13 c 0,-2.21 -1.79,-4 -4,-4 z",
            style: {
                opacity: "1",
                fill: "#ffffff",
                fillOpacity: "1",
                fillRule: "nonzero",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "miter",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        })
    })),
    wR: (0, $7ead0b1397a835ed$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $7ead0b1397a835ed$exports.jsxs)("g", Object.assign({
            style: {
                opacity: "1",
                fill: "#ffffff",
                fillOpacity: "1",
                fillRule: "evenodd",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 9,39 L 36,39 L 36,36 L 9,36 L 9,39 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 12,36 L 12,32 L 33,32 L 33,36 L 12,36 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 11,14 L 11,9 L 15,9 L 15,11 L 20,11 L 20,9 L 25,9 L 25,11 L 30,11 L 30,9 L 34,9 L 34,14",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 34,14 L 31,17 L 14,17 L 11,14"
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 31,17 L 31,29.5 L 14,29.5 L 14,17",
                    style: {
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 31,29.5 L 32.5,32 L 12.5,32 L 14,29.5"
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 11,14 L 34,14",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinejoin: "miter"
                    }
                })
            ]
        }))
    })),
    wN: (0, $7ead0b1397a835ed$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $7ead0b1397a835ed$exports.jsxs)("g", Object.assign({
            style: {
                opacity: "1",
                fill: "none",
                fillOpacity: "1",
                fillRule: "evenodd",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 22,10 C 32.5,11 38.5,18 38,39 L 15,39 C 15,30 25,32.5 23,18",
                    style: {
                        fill: "#ffffff",
                        stroke: "#000000"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 24,18 C 24.38,20.91 18.45,25.37 16,27 C 13,29 13.18,31.34 11,31 C 9.958,30.06 12.41,27.96 11,28 C 10,28 11.19,29.23 10,30 C 9,30 5.997,31 6,26 C 6,24 12,14 12,14 C 12,14 13.89,12.1 14,10.5 C 13.27,9.506 13.5,8.5 13.5,7.5 C 14.5,6.5 16.5,10 16.5,10 L 18.5,10 C 18.5,10 19.28,8.008 21,7 C 22,7 22,10 22,10",
                    style: {
                        fill: "#ffffff",
                        stroke: "#000000"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 9.5 25.5 A 0.5 0.5 0 1 1 8.5,25.5 A 0.5 0.5 0 1 1 9.5 25.5 z",
                    style: {
                        fill: "#000000",
                        stroke: "#000000"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 15 15.5 A 0.5 1.5 0 1 1  14,15.5 A 0.5 1.5 0 1 1  15 15.5 z",
                    transform: "matrix(0.866,0.5,-0.5,0.866,9.693,-5.173)",
                    style: {
                        fill: "#000000",
                        stroke: "#000000"
                    }
                })
            ]
        }))
    })),
    wB: (0, $7ead0b1397a835ed$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $7ead0b1397a835ed$exports.jsxs)("g", Object.assign({
            style: {
                opacity: "1",
                fill: "none",
                fillRule: "evenodd",
                fillOpacity: "1",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $7ead0b1397a835ed$exports.jsxs)("g", Object.assign({
                    style: {
                        fill: "#ffffff",
                        stroke: "#000000",
                        strokeLinecap: "butt"
                    }
                }, {
                    children: [
                        (0, $7ead0b1397a835ed$exports.jsx)("path", {
                            d: "M 9,36 C 12.39,35.03 19.11,36.43 22.5,34 C 25.89,36.43 32.61,35.03 36,36 C 36,36 37.65,36.54 39,38 C 38.32,38.97 37.35,38.99 36,38.5 C 32.61,37.53 25.89,38.96 22.5,37.5 C 19.11,38.96 12.39,37.53 9,38.5 C 7.65,38.99 6.68,38.97 6,38 C 7.35,36.54 9,36 9,36 z"
                        }),
                        (0, $7ead0b1397a835ed$exports.jsx)("path", {
                            d: "M 15,32 C 17.5,34.5 27.5,34.5 30,32 C 30.5,30.5 30,30 30,30 C 30,27.5 27.5,26 27.5,26 C 33,24.5 33.5,14.5 22.5,10.5 C 11.5,14.5 12,24.5 17.5,26 C 17.5,26 15,27.5 15,30 C 15,30 14.5,30.5 15,32 z"
                        }),
                        (0, $7ead0b1397a835ed$exports.jsx)("path", {
                            d: "M 25 8 A 2.5 2.5 0 1 1  20,8 A 2.5 2.5 0 1 1  25 8 z"
                        })
                    ]
                })),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 17.5,26 L 27.5,26 M 15,30 L 30,30 M 22.5,15.5 L 22.5,20.5 M 20,18 L 25,18",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinejoin: "miter"
                    }
                })
            ]
        }))
    })),
    wQ: (0, $7ead0b1397a835ed$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $7ead0b1397a835ed$exports.jsxs)("g", Object.assign({
            style: {
                fill: "#ffffff",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinejoin: "round"
            }
        }, {
            children: [
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 9,26 C 17.5,24.5 30,24.5 36,26 L 38.5,13.5 L 31,25 L 30.7,10.9 L 25.5,24.5 L 22.5,10 L 19.5,24.5 L 14.3,10.9 L 14,25 L 6.5,13.5 L 9,26 z"
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 9,26 C 9,28 10.5,28 11.5,30 C 12.5,31.5 12.5,31 12,33.5 C 10.5,34.5 11,36 11,36 C 9.5,37.5 11,38.5 11,38.5 C 17.5,39.5 27.5,39.5 34,38.5 C 34,38.5 35.5,37.5 34,36 C 34,36 34.5,34.5 33,33.5 C 32.5,31 32.5,31.5 33.5,30 C 34.5,28 36,28 36,26 C 27.5,24.5 17.5,24.5 9,26 z"
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 11.5,30 C 15,29 30,29 33.5,30",
                    style: {
                        fill: "none"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 12,33.5 C 18,32.5 27,32.5 33,33.5",
                    style: {
                        fill: "none"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "6",
                    cy: "12",
                    r: "2"
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "14",
                    cy: "9",
                    r: "2"
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "22.5",
                    cy: "8",
                    r: "2"
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "31",
                    cy: "9",
                    r: "2"
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "39",
                    cy: "12",
                    r: "2"
                })
            ]
        }))
    })),
    wK: (0, $7ead0b1397a835ed$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $7ead0b1397a835ed$exports.jsxs)("g", Object.assign({
            style: {
                fill: "none",
                fillOpacity: "1",
                fillRule: "evenodd",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 22.5,11.63 L 22.5,6",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 20,8 L 25,8",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 22.5,25 C 22.5,25 27,17.5 25.5,14.5 C 25.5,14.5 24.5,12 22.5,12 C 20.5,12 19.5,14.5 19.5,14.5 C 18,17.5 22.5,25 22.5,25",
                    style: {
                        fill: "#ffffff",
                        stroke: "#000000",
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 12.5,37 C 18,40.5 27,40.5 32.5,37 L 32.5,30 C 32.5,30 41.5,25.5 38.5,19.5 C 34.5,13 25,16 22.5,23.5 L 22.5,27 L 22.5,23.5 C 20,16 10.5,13 6.5,19.5 C 3.5,25.5 12.5,30 12.5,30 L 12.5,37",
                    style: {
                        fill: "#ffffff",
                        stroke: "#000000"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 12.5,30 C 18,27 27,27 32.5,30",
                    style: {
                        fill: "none",
                        stroke: "#000000"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 12.5,33.5 C 18,30.5 27,30.5 32.5,33.5",
                    style: {
                        fill: "none",
                        stroke: "#000000"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 12.5,37 C 18,34 27,34 32.5,37",
                    style: {
                        fill: "none",
                        stroke: "#000000"
                    }
                })
            ]
        }))
    })),
    bP: (0, $7ead0b1397a835ed$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "m 22.5,9 c -2.21,0 -4,1.79 -4,4 0,0.89 0.29,1.71 0.78,2.38 C 17.33,16.5 16,18.59 16,21 c 0,2.03 0.94,3.84 2.41,5.03 C 15.41,27.09 11,31.58 11,39.5 H 34 C 34,31.58 29.59,27.09 26.59,26.03 28.06,24.84 29,23.03 29,21 29,18.59 27.67,16.5 25.72,15.38 26.21,14.71 26.5,13.89 26.5,13 c 0,-2.21 -1.79,-4 -4,-4 z",
            style: {
                opacity: "1",
                fill: "#000000",
                fillOpacity: "1",
                fillRule: "nonzero",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "miter",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        })
    })),
    bR: (0, $7ead0b1397a835ed$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $7ead0b1397a835ed$exports.jsxs)("g", Object.assign({
            style: {
                opacity: "1",
                fill: "#000000",
                fillOpacity: "1",
                fillRule: "evenodd",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 9,39 L 36,39 L 36,36 L 9,36 L 9,39 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 12.5,32 L 14,29.5 L 31,29.5 L 32.5,32 L 12.5,32 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 12,36 L 12,32 L 33,32 L 33,36 L 12,36 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 14,29.5 L 14,16.5 L 31,16.5 L 31,29.5 L 14,29.5 z ",
                    style: {
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 14,16.5 L 11,14 L 34,14 L 31,16.5 L 14,16.5 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 11,14 L 11,9 L 15,9 L 15,11 L 20,11 L 20,9 L 25,9 L 25,11 L 30,11 L 30,9 L 34,9 L 34,14 L 11,14 z ",
                    style: {
                        strokeLinecap: "butt"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 12,35.5 L 33,35.5 L 33,35.5",
                    style: {
                        fill: "none",
                        stroke: "#ffffff",
                        strokeWidth: "1",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 13,31.5 L 32,31.5",
                    style: {
                        fill: "none",
                        stroke: "#ffffff",
                        strokeWidth: "1",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 14,29.5 L 31,29.5",
                    style: {
                        fill: "none",
                        stroke: "#ffffff",
                        strokeWidth: "1",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 14,16.5 L 31,16.5",
                    style: {
                        fill: "none",
                        stroke: "#ffffff",
                        strokeWidth: "1",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 11,14 L 34,14",
                    style: {
                        fill: "none",
                        stroke: "#ffffff",
                        strokeWidth: "1",
                        strokeLinejoin: "miter"
                    }
                })
            ]
        }))
    })),
    bN: (0, $7ead0b1397a835ed$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $7ead0b1397a835ed$exports.jsxs)("g", Object.assign({
            style: {
                opacity: "1",
                fill: "none",
                fillOpacity: "1",
                fillRule: "evenodd",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 22,10 C 32.5,11 38.5,18 38,39 L 15,39 C 15,30 25,32.5 23,18",
                    style: {
                        fill: "#000000",
                        stroke: "#000000"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 24,18 C 24.38,20.91 18.45,25.37 16,27 C 13,29 13.18,31.34 11,31 C 9.958,30.06 12.41,27.96 11,28 C 10,28 11.19,29.23 10,30 C 9,30 5.997,31 6,26 C 6,24 12,14 12,14 C 12,14 13.89,12.1 14,10.5 C 13.27,9.506 13.5,8.5 13.5,7.5 C 14.5,6.5 16.5,10 16.5,10 L 18.5,10 C 18.5,10 19.28,8.008 21,7 C 22,7 22,10 22,10",
                    style: {
                        fill: "#000000",
                        stroke: "#000000"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 9.5 25.5 A 0.5 0.5 0 1 1 8.5,25.5 A 0.5 0.5 0 1 1 9.5 25.5 z",
                    style: {
                        fill: "#ffffff",
                        stroke: "#ffffff"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 15 15.5 A 0.5 1.5 0 1 1  14,15.5 A 0.5 1.5 0 1 1  15 15.5 z",
                    transform: "matrix(0.866,0.5,-0.5,0.866,9.693,-5.173)",
                    style: {
                        fill: "#ffffff",
                        stroke: "#ffffff"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 24.55,10.4 L 24.1,11.85 L 24.6,12 C 27.75,13 30.25,14.49 32.5,18.75 C 34.75,23.01 35.75,29.06 35.25,39 L 35.2,39.5 L 37.45,39.5 L 37.5,39 C 38,28.94 36.62,22.15 34.25,17.66 C 31.88,13.17 28.46,11.02 25.06,10.5 L 24.55,10.4 z ",
                    style: {
                        fill: "#ffffff",
                        stroke: "none"
                    }
                })
            ]
        }))
    })),
    bB: (0, $7ead0b1397a835ed$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $7ead0b1397a835ed$exports.jsxs)("g", Object.assign({
            style: {
                opacity: "1",
                fill: "none",
                fillRule: "evenodd",
                fillOpacity: "1",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $7ead0b1397a835ed$exports.jsxs)("g", Object.assign({
                    style: {
                        fill: "#000000",
                        stroke: "#000000",
                        strokeLinecap: "butt"
                    }
                }, {
                    children: [
                        (0, $7ead0b1397a835ed$exports.jsx)("path", {
                            d: "M 9,36 C 12.39,35.03 19.11,36.43 22.5,34 C 25.89,36.43 32.61,35.03 36,36 C 36,36 37.65,36.54 39,38 C 38.32,38.97 37.35,38.99 36,38.5 C 32.61,37.53 25.89,38.96 22.5,37.5 C 19.11,38.96 12.39,37.53 9,38.5 C 7.65,38.99 6.68,38.97 6,38 C 7.35,36.54 9,36 9,36 z"
                        }),
                        (0, $7ead0b1397a835ed$exports.jsx)("path", {
                            d: "M 15,32 C 17.5,34.5 27.5,34.5 30,32 C 30.5,30.5 30,30 30,30 C 30,27.5 27.5,26 27.5,26 C 33,24.5 33.5,14.5 22.5,10.5 C 11.5,14.5 12,24.5 17.5,26 C 17.5,26 15,27.5 15,30 C 15,30 14.5,30.5 15,32 z"
                        }),
                        (0, $7ead0b1397a835ed$exports.jsx)("path", {
                            d: "M 25 8 A 2.5 2.5 0 1 1  20,8 A 2.5 2.5 0 1 1  25 8 z"
                        })
                    ]
                })),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 17.5,26 L 27.5,26 M 15,30 L 30,30 M 22.5,15.5 L 22.5,20.5 M 20,18 L 25,18",
                    style: {
                        fill: "none",
                        stroke: "#ffffff",
                        strokeLinejoin: "miter"
                    }
                })
            ]
        }))
    })),
    bQ: (0, $7ead0b1397a835ed$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $7ead0b1397a835ed$exports.jsxs)("g", Object.assign({
            style: {
                fill: "#000000",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }
        }, {
            children: [
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 9,26 C 17.5,24.5 30,24.5 36,26 L 38.5,13.5 L 31,25 L 30.7,10.9 L 25.5,24.5 L 22.5,10 L 19.5,24.5 L 14.3,10.9 L 14,25 L 6.5,13.5 L 9,26 z",
                    style: {
                        strokeLinecap: "butt",
                        fill: "#000000"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "m 9,26 c 0,2 1.5,2 2.5,4 1,1.5 1,1 0.5,3.5 -1.5,1 -1,2.5 -1,2.5 -1.5,1.5 0,2.5 0,2.5 6.5,1 16.5,1 23,0 0,0 1.5,-1 0,-2.5 0,0 0.5,-1.5 -1,-2.5 -0.5,-2.5 -0.5,-2 0.5,-3.5 1,-2 2.5,-2 2.5,-4 -8.5,-1.5 -18.5,-1.5 -27,0 z"
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 11.5,30 C 15,29 30,29 33.5,30"
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "m 12,33.5 c 6,-1 15,-1 21,0"
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "6",
                    cy: "12",
                    r: "2"
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "14",
                    cy: "9",
                    r: "2"
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "22.5",
                    cy: "8",
                    r: "2"
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "31",
                    cy: "9",
                    r: "2"
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "39",
                    cy: "12",
                    r: "2"
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 11,38.5 A 35,35 1 0 0 34,38.5",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinecap: "butt"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsxs)("g", Object.assign({
                    style: {
                        fill: "none",
                        stroke: "#ffffff"
                    }
                }, {
                    children: [
                        (0, $7ead0b1397a835ed$exports.jsx)("path", {
                            d: "M 11,29 A 35,35 1 0 1 34,29"
                        }),
                        (0, $7ead0b1397a835ed$exports.jsx)("path", {
                            d: "M 12.5,31.5 L 32.5,31.5"
                        }),
                        (0, $7ead0b1397a835ed$exports.jsx)("path", {
                            d: "M 11.5,34.5 A 35,35 1 0 0 33.5,34.5"
                        }),
                        (0, $7ead0b1397a835ed$exports.jsx)("path", {
                            d: "M 10.5,37.5 A 35,35 1 0 0 34.5,37.5"
                        })
                    ]
                }))
            ]
        }))
    })),
    bK: (0, $7ead0b1397a835ed$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "45",
        height: "45"
    }, {
        children: (0, $7ead0b1397a835ed$exports.jsxs)("g", Object.assign({
            style: {
                fill: "none",
                fillOpacity: "1",
                fillRule: "evenodd",
                stroke: "#000000",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "4",
                strokeDasharray: "none",
                strokeOpacity: "1"
            }
        }, {
            children: [
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 22.5,11.63 L 22.5,6",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinejoin: "miter"
                    },
                    id: "path6570"
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 22.5,25 C 22.5,25 27,17.5 25.5,14.5 C 25.5,14.5 24.5,12 22.5,12 C 20.5,12 19.5,14.5 19.5,14.5 C 18,17.5 22.5,25 22.5,25",
                    style: {
                        fill: "#000000",
                        fillOpacity: "1",
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 12.5,37 C 18,40.5 27,40.5 32.5,37 L 32.5,30 C 32.5,30 41.5,25.5 38.5,19.5 C 34.5,13 25,16 22.5,23.5 L 22.5,27 L 22.5,23.5 C 20,16 10.5,13 6.5,19.5 C 3.5,25.5 12.5,30 12.5,30 L 12.5,37",
                    style: {
                        fill: "#000000",
                        stroke: "#000000"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 20,8 L 25,8",
                    style: {
                        fill: "none",
                        stroke: "#000000",
                        strokeLinejoin: "miter"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 32,29.5 C 32,29.5 40.5,25.5 38.03,19.85 C 34.15,14 25,18 22.5,24.5 L 22.5,26.6 L 22.5,24.5 C 20,18 10.85,14 6.97,19.85 C 4.5,25.5 13,29.5 13,29.5",
                    style: {
                        fill: "none",
                        stroke: "#ffffff"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M 12.5,30 C 18,27 27,27 32.5,30 M 12.5,33.5 C 18,30.5 27,30.5 32.5,33.5 M 12.5,37 C 18,34 27,34 32.5,37",
                    style: {
                        fill: "none",
                        stroke: "#ffffff"
                    }
                })
            ]
        }))
    }))
};
/**
 * Retrieves the coordinates at the centre of the requested square, relative to the top left of the board (0, 0).
 */ function $8f4069742e98d682$var$getRelativeCoords(boardOrientation, boardWidth, square) {
    const squareWidth = boardWidth / 8;
    const columns = boardOrientation === "white" ? $8f4069742e98d682$var$WHITE_COLUMN_VALUES : $8f4069742e98d682$var$BLACK_COLUMN_VALUES;
    const rows = boardOrientation === "white" ? $8f4069742e98d682$var$WHITE_ROWS : $8f4069742e98d682$var$BLACK_ROWS;
    const x = columns[square[0]] * squareWidth + squareWidth / 2;
    const y = rows[parseInt(square[1], 10) - 1] * squareWidth + squareWidth / 2;
    return {
        x: x,
        y: y
    };
}
/**
 * Returns whether the passed position is different from the start position.
 */ function $8f4069742e98d682$var$isDifferentFromStart(newPosition) {
    let isDifferent = false;
    Object.keys($8f4069742e98d682$var$START_POSITION_OBJECT).forEach((square)=>{
        if (newPosition[square] !== $8f4069742e98d682$var$START_POSITION_OBJECT[square]) isDifferent = true;
    });
    Object.keys(newPosition).forEach((square)=>{
        if ($8f4069742e98d682$var$START_POSITION_OBJECT[square] !== newPosition[square]) isDifferent = true;
    });
    return isDifferent;
}
/**
 * Returns what pieces have been added and what pieces have been removed between board positions.
 */ function $8f4069742e98d682$var$getPositionDifferences(currentPosition, newPosition) {
    const difference = {
        removed: {},
        added: {}
    };
    // removed from current
    Object.keys(currentPosition).forEach((square)=>{
        if (newPosition[square] !== currentPosition[square]) difference.removed[square] = currentPosition[square];
    });
    // added from new
    Object.keys(newPosition).forEach((square)=>{
        if (currentPosition[square] !== newPosition[square]) difference.added[square] = newPosition[square];
    });
    return difference;
}
/**
 * Converts a fen string or existing position object to a position object.
 */ function $8f4069742e98d682$var$convertPositionToObject(position) {
    if (position === "start") return $8f4069742e98d682$var$START_POSITION_OBJECT;
    if (typeof position === "string") // attempt to convert fen to position object
    return $8f4069742e98d682$var$fenToObj(position);
    return position;
}
/**
 * Converts a fen string to a position object.
 */ function $8f4069742e98d682$var$fenToObj(fen) {
    if (!$8f4069742e98d682$var$isValidFen(fen)) return {};
    // cut off any move, castling, etc info from the end. we're only interested in position information
    fen = fen.replace(/ .+$/, "");
    const rows = fen.split("/");
    const position = {};
    let currentRow = 8;
    for(let i = 0; i < 8; i++){
        const row = rows[i].split("");
        let colIdx = 0;
        // loop through each character in the FEN section
        for(let j = 0; j < row.length; j++)// number / empty squares
        if (row[j].search(/[1-8]/) !== -1) {
            const numEmptySquares = parseInt(row[j], 10);
            colIdx = colIdx + numEmptySquares;
        } else {
            // piece
            const square = $8f4069742e98d682$var$COLUMNS[colIdx] + currentRow;
            position[square] = $8f4069742e98d682$var$fenToPieceCode(row[j]);
            colIdx = colIdx + 1;
        }
        currentRow = currentRow - 1;
    }
    return position;
}
/**
 * Returns whether string is valid fen notation.
 */ function $8f4069742e98d682$var$isValidFen(fen) {
    // cut off any move, castling, etc info from the end. we're only interested in position information
    fen = fen.replace(/ .+$/, "");
    // expand the empty square numbers to just 1s
    fen = $8f4069742e98d682$var$expandFenEmptySquares(fen);
    // fen should be 8 sections separated by slashes
    const chunks = fen.split("/");
    if (chunks.length !== 8) return false;
    // check each section
    for(let i = 0; i < 8; i++){
        if (chunks[i].length !== 8 || chunks[i].search(/[^kqrnbpKQRNBP1]/) !== -1) return false;
    }
    return true;
}
/**
 * Expand out fen notation to countable characters for validation
 */ function $8f4069742e98d682$var$expandFenEmptySquares(fen) {
    return fen.replace(/8/g, "11111111").replace(/7/g, "1111111").replace(/6/g, "111111").replace(/5/g, "11111").replace(/4/g, "1111").replace(/3/g, "111").replace(/2/g, "11");
}
/**
 * Convert fen piece code to camel case notation. e.g. bP, wK.
 */ function $8f4069742e98d682$var$fenToPieceCode(piece) {
    // black piece
    if (piece.toLowerCase() === piece) return "b" + piece.toUpperCase();
    // white piece
    return "w" + piece.toUpperCase();
}
const $8f4069742e98d682$var$useArrows = (customArrows, areArrowsAllowed = true, onArrowsChange, customArrowColor)=>{
    // arrows passed programatically to `ChessBoard` as a react prop
    const [customArrowsSet, setCustomArrows] = (0, $exYeM.useState)([]);
    // arrows drawn with mouse by user on the board
    const [arrows, setArrows] = (0, $exYeM.useState)([]);
    // active arrow which user draws while dragging mouse
    const [newArrow, setNewArrow] = (0, $exYeM.useState)();
    // handle external `customArrows` props changes
    (0, $exYeM.useEffect)(()=>{
        if (Array.isArray(customArrows)) {
            // so that custom arrows overwrite temporary arrows
            clearArrows();
            setCustomArrows(//filter out arrows which starts and ends in the same square
            customArrows === null || customArrows === void 0 ? void 0 : customArrows.filter((arrow)=>arrow[0] !== arrow[1]));
        }
    }, [
        customArrows
    ]);
    // callback when arrows changed after user interaction
    (0, $exYeM.useEffect)(()=>{
        onArrowsChange === null || onArrowsChange === void 0 || onArrowsChange(arrows);
    }, [
        arrows
    ]);
    // function clears all arrows drawed by user
    function clearArrows() {
        setArrows([]);
        setNewArrow(undefined);
    }
    const drawNewArrow = (fromSquare, toSquare)=>{
        if (!areArrowsAllowed) return;
        setNewArrow([
            fromSquare,
            toSquare,
            customArrowColor
        ]);
    };
    const allBoardArrows = [
        ...arrows,
        ...customArrowsSet
    ];
    const onArrowDrawEnd = (fromSquare, toSquare)=>{
        if (fromSquare === toSquare || !areArrowsAllowed) return;
        let arrowsCopy;
        const newArrow = [
            fromSquare,
            toSquare,
            customArrowColor
        ];
        const isNewArrowUnique = allBoardArrows.every(([arrowFrom, arrowTo])=>{
            return !(arrowFrom === fromSquare && arrowTo === toSquare);
        });
        // add the newArrow to arrows array if it is unique
        if (isNewArrowUnique) arrowsCopy = [
            ...arrows,
            newArrow
        ];
        else arrowsCopy = arrows.filter(([arrowFrom, arrowTo])=>{
            return !(arrowFrom === fromSquare && arrowTo === toSquare);
        });
        setNewArrow(undefined);
        setArrows(arrowsCopy);
    };
    return {
        arrows: allBoardArrows,
        newArrow: newArrow,
        clearArrows: clearArrows,
        drawNewArrow: drawNewArrow,
        setArrows: setArrows,
        onArrowDrawEnd: onArrowDrawEnd
    };
};
const $8f4069742e98d682$var$ChessboardContext = (0, $exYeM.createContext)({});
const $8f4069742e98d682$var$useChessboard = ()=>(0, $exYeM.useContext)($8f4069742e98d682$var$ChessboardContext);
const $8f4069742e98d682$var$ChessboardProvider = (0, $exYeM.forwardRef)(({ allowDragOutsideBoard: allowDragOutsideBoard = true , animationDuration: animationDuration = 300 , areArrowsAllowed: areArrowsAllowed = true , arePiecesDraggable: arePiecesDraggable = true , arePremovesAllowed: arePremovesAllowed = false , autoPromoteToQueen: autoPromoteToQueen = false , boardOrientation: boardOrientation = "white" , boardWidth: boardWidth , children: children , clearPremovesOnRightClick: clearPremovesOnRightClick = true , customArrows: customArrows , customArrowColor: customArrowColor = "rgb(255,170,0)" , customBoardStyle: customBoardStyle , customNotationStyle: customNotationStyle , customDarkSquareStyle: customDarkSquareStyle = {
    backgroundColor: "#B58863"
} , customDropSquareStyle: customDropSquareStyle = {
    boxShadow: "inset 0 0 1px 6px rgba(255,255,255,0.75)"
} , customLightSquareStyle: customLightSquareStyle = {
    backgroundColor: "#F0D9B5"
} , customPieces: customPieces , customPremoveDarkSquareStyle: customPremoveDarkSquareStyle = {
    backgroundColor: "#A42323"
} , customPremoveLightSquareStyle: customPremoveLightSquareStyle = {
    backgroundColor: "#BD2828"
} , customSquare: customSquare = "div" , customSquareStyles: customSquareStyles , dropOffBoardAction: dropOffBoardAction = "snapback" , id: id = 0 , isDraggablePiece: isDraggablePiece = ()=>true , getPositionObject: getPositionObject = ()=>{} , onArrowsChange: onArrowsChange = ()=>{} , onDragOverSquare: onDragOverSquare = ()=>{} , onMouseOutSquare: onMouseOutSquare = ()=>{} , onMouseOverSquare: onMouseOverSquare = ()=>{} , onPieceClick: onPieceClick = ()=>{} , onPieceDragBegin: onPieceDragBegin = ()=>{} , onPieceDragEnd: onPieceDragEnd = ()=>{} , onPieceDrop: onPieceDrop = ()=>true , onPieceDropOffBoard: onPieceDropOffBoard = ()=>{} , onPromotionCheck: onPromotionCheck = (sourceSquare, targetSquare, piece)=>{
    return (piece === "wP" && sourceSquare[1] === "7" && targetSquare[1] === "8" || piece === "bP" && sourceSquare[1] === "2" && targetSquare[1] === "1") && Math.abs(sourceSquare.charCodeAt(0) - targetSquare.charCodeAt(0)) <= 1;
} , onPromotionPieceSelect: onPromotionPieceSelect = ()=>true , onSparePieceDrop: onSparePieceDrop = ()=>true , onSquareClick: onSquareClick = ()=>{} , onSquareRightClick: onSquareRightClick = ()=>{} , position: position = "start" , promotionDialogVariant: promotionDialogVariant = "default" , promotionToSquare: promotionToSquare = null , showBoardNotation: showBoardNotation = true , showPromotionDialog: showPromotionDialog = false , snapToCursor: snapToCursor = true  }, ref)=>{
    // position stored and displayed on board
    const [currentPosition, setCurrentPosition] = (0, $exYeM.useState)($8f4069742e98d682$var$convertPositionToObject(position));
    // calculated differences between current and incoming positions
    const [positionDifferences, setPositionDifferences] = (0, $exYeM.useState)({
        removed: {},
        added: {}
    });
    // colour of last piece moved to determine if premoving
    const [lastPieceColour, setLastPieceColour] = (0, $exYeM.useState)(undefined);
    // show / hide promotion dialog
    const [showPromoteDialog, setShowPromoteDialog] = (0, $exYeM.useState)(showPromotionDialog && !autoPromoteToQueen);
    // which square a pawn is being promoted to
    const [promoteFromSquare, setPromoteFromSquare] = (0, $exYeM.useState)(null);
    const [promoteToSquare, setPromoteToSquare] = (0, $exYeM.useState)(promotionToSquare);
    // current premoves
    const [premoves, setPremoves] = (0, $exYeM.useState)([]);
    // ref used to access current value during timeouts (closures)
    const premovesRef = (0, $exYeM.useRef)(premoves);
    // current right mouse down square
    const [currentRightClickDown, setCurrentRightClickDown] = (0, $exYeM.useState)();
    // chess pieces/styling
    const [chessPieces, setChessPieces] = (0, $exYeM.useState)(Object.assign(Object.assign({}, $8f4069742e98d682$var$defaultPieces), customPieces));
    // whether the last move was a manual drop or not
    const [wasManualDrop, setWasManualDrop] = (0, $exYeM.useState)(false);
    // the most recent timeout whilst waiting for animation to complete
    const [previousTimeout, setPreviousTimeout] = (0, $exYeM.useState)();
    // if currently waiting for an animation to finish
    const [isWaitingForAnimation, setIsWaitingForAnimation] = (0, $exYeM.useState)(false);
    // last square dragged over for checking in touch events
    const [lastSquareDraggedOver, setLastSquareDraggedOver] = (0, $exYeM.useState)(null);
    // open clearPremoves() to allow user to call on undo/reset/whenever
    (0, $exYeM.useImperativeHandle)(ref, ()=>({
            clearPremoves (clearLastPieceColour = true) {
                clearPremoves(clearLastPieceColour);
            }
        }));
    // handle custom pieces change
    (0, $exYeM.useEffect)(()=>{
        setChessPieces(Object.assign(Object.assign({}, $8f4069742e98d682$var$defaultPieces), customPieces));
    }, [
        customPieces
    ]);
    // handle promote changes
    (0, $exYeM.useEffect)(()=>{
        setShowPromoteDialog(showPromotionDialog);
        setPromoteToSquare(promotionToSquare);
    }, [
        promotionToSquare,
        showPromotionDialog
    ]);
    // handle external position change
    (0, $exYeM.useEffect)(()=>{
        var _a, _b, _c;
        // clear any open promotion dialogs
        clearPromotion();
        const newPosition = $8f4069742e98d682$var$convertPositionToObject(position);
        const differences = $8f4069742e98d682$var$getPositionDifferences(currentPosition, newPosition);
        const newPieceColour = ((_a = Object.keys(differences.added)) === null || _a === void 0 ? void 0 : _a.length) <= 2 ? (_c = (_b = Object.entries(differences.added)) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c[1][0] : undefined;
        // external move has come in before animation is over
        // cancel animation and immediately update position
        if (isWaitingForAnimation) {
            setCurrentPosition(newPosition);
            setIsWaitingForAnimation(false);
            arePremovesAllowed && attemptPremove(newPieceColour);
            if (previousTimeout) clearTimeout(previousTimeout);
        } else // move was made using drag and drop
        if (wasManualDrop) {
            setCurrentPosition(newPosition);
            setIsWaitingForAnimation(false);
            arePremovesAllowed && attemptPremove(newPieceColour);
        } else {
            // move was made by external position change
            // if position === start then don't override newPieceColour
            // needs isDifferentFromStart in scenario where premoves have been cleared upon board reset but first move is made by computer, the last move colour would need to be updated
            if ($8f4069742e98d682$var$isDifferentFromStart(newPosition) && lastPieceColour !== undefined) setLastPieceColour(newPieceColour);
            else if (!$8f4069742e98d682$var$isDifferentFromStart(newPosition)) // position === start, likely a board reset. set to black to allow black to make premoves on first move
            setLastPieceColour("b");
            else setLastPieceColour(undefined);
            setPositionDifferences(differences);
            // animate external move
            setIsWaitingForAnimation(true);
            const newTimeout = setTimeout(()=>{
                setCurrentPosition(newPosition);
                setIsWaitingForAnimation(false);
                arePremovesAllowed && attemptPremove(newPieceColour);
            }, animationDuration);
            setPreviousTimeout(newTimeout);
        }
        // reset manual drop, ready for next move to be made by user or external
        setWasManualDrop(false);
        // inform latest position information
        getPositionObject(newPosition);
        // clear arrows
        clearArrows();
        // clear timeout on unmount
        return ()=>{
            clearTimeout(previousTimeout);
        };
    }, [
        position
    ]);
    const { arrows: arrows , newArrow: newArrow , clearArrows: clearArrows , drawNewArrow: drawNewArrow , onArrowDrawEnd: onArrowDrawEnd  } = $8f4069742e98d682$var$useArrows(customArrows, areArrowsAllowed, onArrowsChange, customArrowColor);
    // handle drop position change
    function handleSetPosition(sourceSq, targetSq, piece, wasManualDropOverride) {
        // if dropped back down, don't do anything
        if (sourceSq === targetSq) return;
        clearArrows();
        // if second move is made for same colour, or there are still premoves queued, then this move needs to be added to premove queue instead of played
        // premoves length check for colour is added in because white could make 3 premoves, and then black responds to the first move (changing the last piece colour) and then white pre-moves again
        if (arePremovesAllowed && isWaitingForAnimation || arePremovesAllowed && (lastPieceColour === piece[0] || premovesRef.current.filter((p)=>p.piece[0] === piece[0]).length > 0)) {
            const oldPremoves = [
                ...premovesRef.current
            ];
            oldPremoves.push({
                sourceSq: sourceSq,
                targetSq: targetSq,
                piece: piece
            });
            premovesRef.current = oldPremoves;
            setPremoves([
                ...oldPremoves
            ]);
            clearPromotion();
            return;
        }
        // if transitioning, don't allow new drop
        if (!arePremovesAllowed && isWaitingForAnimation) return;
        const newOnDropPosition = Object.assign({}, currentPosition);
        setWasManualDrop(!!wasManualDropOverride);
        setLastPieceColour(piece[0]);
        // if onPieceDrop function provided, execute it, position must be updated externally and captured by useEffect above for this move to show on board
        if (onPieceDrop.length) {
            const isValidMove = onPieceDrop(sourceSq, targetSq, piece);
            if (!isValidMove) {
                clearPremoves();
                setWasManualDrop(false);
            }
        } else {
            // delete source piece
            delete newOnDropPosition[sourceSq];
            // add piece in new position
            newOnDropPosition[targetSq] = piece;
            setCurrentPosition(newOnDropPosition);
        }
        clearPromotion();
        // inform latest position information
        getPositionObject(newOnDropPosition);
    }
    function deletePieceFromSquare(square) {
        const positionCopy = Object.assign({}, currentPosition);
        delete positionCopy[square];
        setCurrentPosition(positionCopy);
        // inform latest position information
        getPositionObject(positionCopy);
    }
    function attemptPremove(newPieceColour) {
        if (premovesRef.current.length === 0) return;
        // get current value of premove as this is called in a timeout so value may have changed since timeout was set
        const premove = premovesRef.current[0];
        // if premove is a differing colour to last move made, then this move can be made
        if (premove.piece[0] !== undefined && premove.piece[0] !== newPieceColour && onPieceDrop.length) {
            setLastPieceColour(premove.piece[0]);
            setWasManualDrop(true); // pre-move doesn't need animation
            const isValidMove = onPieceDrop(premove.sourceSq, premove.targetSq, premove.piece);
            // premove was successful and can be removed from queue
            if (isValidMove) {
                const oldPremoves = [
                    ...premovesRef.current
                ];
                oldPremoves.shift();
                premovesRef.current = oldPremoves;
                setPremoves([
                    ...oldPremoves
                ]);
            } else // premove wasn't successful, clear premove queue
            clearPremoves();
        }
    }
    function handleSparePieceDrop(piece, targetSq) {
        const isValidDrop = onSparePieceDrop(piece, targetSq);
        if (!isValidDrop) return;
        const newOnDropPosition = Object.assign({}, currentPosition);
        // add piece in new position
        newOnDropPosition[targetSq] = piece;
        setCurrentPosition(newOnDropPosition);
        // inform latest position information
        getPositionObject(newOnDropPosition);
    }
    function clearPremoves(clearLastPieceColour = true) {
        // don't clear when right clicking to clear, otherwise you won't be able to premove again before next go
        if (clearLastPieceColour) setLastPieceColour(undefined);
        premovesRef.current = [];
        setPremoves([]);
    }
    function clearPromotion() {
        setPromoteFromSquare(null);
        setPromoteToSquare(null);
        setShowPromoteDialog(false);
    }
    function onRightClickDown(square) {
        setCurrentRightClickDown(square);
    }
    function onRightClickUp(square) {
        if (currentRightClickDown) // same square, don't draw an arrow, but do clear premoves and run onSquareRightClick
        {
            if (currentRightClickDown === square) {
                setCurrentRightClickDown(undefined);
                clearPremovesOnRightClick && clearPremoves(false);
                onSquareRightClick(square);
                return;
            }
        } else setCurrentRightClickDown(undefined);
    }
    function clearCurrentRightClickDown() {
        setCurrentRightClickDown(undefined);
    }
    const ChessboardProviderContextValue = {
        allowDragOutsideBoard: allowDragOutsideBoard,
        animationDuration: animationDuration,
        arePiecesDraggable: arePiecesDraggable,
        arePremovesAllowed: arePremovesAllowed,
        arrows: arrows,
        autoPromoteToQueen: autoPromoteToQueen,
        boardOrientation: boardOrientation,
        boardWidth: boardWidth,
        chessPieces: chessPieces,
        clearArrows: clearArrows,
        clearCurrentRightClickDown: clearCurrentRightClickDown,
        currentPosition: currentPosition,
        currentRightClickDown: currentRightClickDown,
        customArrowColor: customArrowColor,
        customBoardStyle: customBoardStyle,
        customDarkSquareStyle: customDarkSquareStyle,
        customDropSquareStyle: customDropSquareStyle,
        customLightSquareStyle: customLightSquareStyle,
        customNotationStyle: customNotationStyle,
        customPremoveDarkSquareStyle: customPremoveDarkSquareStyle,
        customPremoveLightSquareStyle: customPremoveLightSquareStyle,
        customSquare: customSquare,
        customSquareStyles: customSquareStyles,
        deletePieceFromSquare: deletePieceFromSquare,
        drawNewArrow: drawNewArrow,
        dropOffBoardAction: dropOffBoardAction,
        handleSetPosition: handleSetPosition,
        handleSparePieceDrop: handleSparePieceDrop,
        id: id,
        isDraggablePiece: isDraggablePiece,
        isWaitingForAnimation: isWaitingForAnimation,
        lastPieceColour: lastPieceColour,
        lastSquareDraggedOver: lastSquareDraggedOver,
        newArrow: newArrow,
        onArrowDrawEnd: onArrowDrawEnd,
        onDragOverSquare: onDragOverSquare,
        onMouseOutSquare: onMouseOutSquare,
        onMouseOverSquare: onMouseOverSquare,
        onPieceClick: onPieceClick,
        onPieceDragBegin: onPieceDragBegin,
        onPieceDragEnd: onPieceDragEnd,
        onPieceDrop: onPieceDrop,
        onPieceDropOffBoard: onPieceDropOffBoard,
        onPromotionCheck: onPromotionCheck,
        onPromotionPieceSelect: onPromotionPieceSelect,
        onRightClickDown: onRightClickDown,
        onRightClickUp: onRightClickUp,
        onSparePieceDrop: onSparePieceDrop,
        onSquareClick: onSquareClick,
        positionDifferences: positionDifferences,
        premoves: premoves,
        promoteFromSquare: promoteFromSquare,
        promoteToSquare: promoteToSquare,
        promotionDialogVariant: promotionDialogVariant,
        setLastSquareDraggedOver: setLastSquareDraggedOver,
        setPromoteFromSquare: setPromoteFromSquare,
        setPromoteToSquare: setPromoteToSquare,
        setShowPromoteDialog: setShowPromoteDialog,
        showBoardNotation: showBoardNotation,
        showPromoteDialog: showPromoteDialog,
        snapToCursor: snapToCursor
    };
    return (0, $7ead0b1397a835ed$exports.jsx)($8f4069742e98d682$var$ChessboardContext.Provider, Object.assign({
        value: ChessboardProviderContextValue
    }, {
        children: children
    }));
});
function $8f4069742e98d682$var$Notation({ row: row , col: col  }) {
    const { boardOrientation: boardOrientation , boardWidth: boardWidth , customDarkSquareStyle: customDarkSquareStyle , customLightSquareStyle: customLightSquareStyle , customNotationStyle: customNotationStyle  } = $8f4069742e98d682$var$useChessboard();
    const whiteColor = customLightSquareStyle.backgroundColor;
    const blackColor = customDarkSquareStyle.backgroundColor;
    const isRow = col === 0;
    const isColumn = row === 7;
    const isBottomLeftSquare = isRow && isColumn;
    function getRow() {
        return boardOrientation === "white" ? 8 - row : row + 1;
    }
    function getColumn() {
        return boardOrientation === "black" ? $8f4069742e98d682$var$COLUMNS[7 - col] : $8f4069742e98d682$var$COLUMNS[col];
    }
    function renderBottomLeft() {
        return (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
            children: [
                (0, $7ead0b1397a835ed$exports.jsx)("div", Object.assign({
                    style: Object.assign(Object.assign({
                        zIndex: 3,
                        position: "absolute"
                    }, {
                        color: whiteColor
                    }), $8f4069742e98d682$var$numericStyle(boardWidth, customNotationStyle))
                }, {
                    children: getRow()
                })),
                (0, $7ead0b1397a835ed$exports.jsx)("div", Object.assign({
                    style: Object.assign(Object.assign({
                        zIndex: 3,
                        position: "absolute"
                    }, {
                        color: whiteColor
                    }), $8f4069742e98d682$var$alphaStyle(boardWidth, customNotationStyle))
                }, {
                    children: getColumn()
                }))
            ]
        });
    }
    function renderLetters() {
        return (0, $7ead0b1397a835ed$exports.jsx)("div", Object.assign({
            style: Object.assign(Object.assign({
                userSelect: "none",
                zIndex: 3,
                position: "absolute"
            }, {
                color: col % 2 !== 0 ? blackColor : whiteColor
            }), $8f4069742e98d682$var$alphaStyle(boardWidth, customNotationStyle))
        }, {
            children: getColumn()
        }));
    }
    function renderNumbers() {
        return (0, $7ead0b1397a835ed$exports.jsx)("div", Object.assign({
            style: Object.assign(Object.assign({
                userSelect: "none",
                zIndex: 3,
                position: "absolute"
            }, boardOrientation === "black" ? {
                color: row % 2 === 0 ? blackColor : whiteColor
            } : {
                color: row % 2 === 0 ? blackColor : whiteColor
            }), $8f4069742e98d682$var$numericStyle(boardWidth, customNotationStyle))
        }, {
            children: getRow()
        }));
    }
    if (isBottomLeftSquare) return renderBottomLeft();
    if (isColumn) return renderLetters();
    if (isRow) return renderNumbers();
    return null;
}
const $8f4069742e98d682$var$alphaStyle = (width, customNotationStyle)=>Object.assign({
        alignSelf: "flex-end",
        paddingLeft: width / 8 - width / 48,
        fontSize: width / 48
    }, customNotationStyle);
const $8f4069742e98d682$var$numericStyle = (width, customNotationStyle)=>Object.assign({
        alignSelf: "flex-start",
        paddingRight: width / 8 - width / 48,
        fontSize: width / 48
    }, customNotationStyle);
/**
 * Create the React Context
 */ const $8f4069742e98d682$var$DndContext = (0, $exYeM.createContext)({
    dragDropManager: undefined
});
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $8f4069742e98d682$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $8f4069742e98d682$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $8f4069742e98d682$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $8f4069742e98d682$var$ActionTypes = {
    INIT: "@@redux/INIT" + $8f4069742e98d682$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $8f4069742e98d682$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $8f4069742e98d682$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $8f4069742e98d682$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $8f4069742e98d682$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($8f4069742e98d682$var$isDate(val)) return "date";
    if ($8f4069742e98d682$var$isError(val)) return "error";
    var constructorName = $8f4069742e98d682$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $8f4069742e98d682$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $8f4069742e98d682$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $8f4069742e98d682$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $8f4069742e98d682$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $8f4069742e98d682$var$createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($8f4069742e98d682$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($8f4069742e98d682$var$formatProdErrorMessage(1));
        return enhancer($8f4069742e98d682$var$createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($8f4069742e98d682$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($8f4069742e98d682$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($8f4069742e98d682$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($8f4069742e98d682$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($8f4069742e98d682$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$8f4069742e98d682$var$isPlainObject(action)) throw new Error($8f4069742e98d682$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($8f4069742e98d682$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($8f4069742e98d682$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($8f4069742e98d682$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $8f4069742e98d682$var$ActionTypes.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($8f4069742e98d682$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$8f4069742e98d682$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $8f4069742e98d682$var$ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$8f4069742e98d682$var$$$observable] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $8f4069742e98d682$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function $8f4069742e98d682$var$isCrushed() {}
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ function $8f4069742e98d682$var$invariant(condition, format, ...args) {
    if ($8f4069742e98d682$var$isProduction()) {
        if (format === undefined) throw new Error("invariant requires an error message argument");
    }
    if (!condition) {
        let error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            let argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1 // we don't care about invariant's own frame
        ;
        throw error;
    }
}
function $8f4069742e98d682$var$isProduction() {
    return typeof $4acf49f6c3e67aec$exports !== "undefined" && true;
}
// cheap lodash replacements
/**
 * drop-in replacement for _.get
 * @param obj
 * @param path
 * @param defaultValue
 */ function $8f4069742e98d682$var$get(obj, path, defaultValue) {
    return path.split(".").reduce((a, c)=>a && a[c] ? a[c] : defaultValue || null, obj);
}
/**
 * drop-in replacement for _.without
 */ function $8f4069742e98d682$var$without$1(items, item) {
    return items.filter((i)=>i !== item);
}
/**
 * drop-in replacement for _.isString
 * @param input
 */ function $8f4069742e98d682$var$isObject(input) {
    return typeof input === "object";
}
/**
 * replacement for _.xor
 * @param itemsA
 * @param itemsB
 */ function $8f4069742e98d682$var$xor(itemsA, itemsB) {
    const map = new Map();
    const insertItem = (item)=>{
        map.set(item, map.has(item) ? map.get(item) + 1 : 1);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    map.forEach((count, key)=>{
        if (count === 1) result.push(key);
    });
    return result;
}
/**
 * replacement for _.intersection
 * @param itemsA
 * @param itemsB
 */ function $8f4069742e98d682$var$intersection(itemsA, itemsB) {
    return itemsA.filter((t)=>itemsB.indexOf(t) > -1);
}
const $8f4069742e98d682$var$INIT_COORDS = "dnd-core/INIT_COORDS";
const $8f4069742e98d682$var$BEGIN_DRAG = "dnd-core/BEGIN_DRAG";
const $8f4069742e98d682$var$PUBLISH_DRAG_SOURCE = "dnd-core/PUBLISH_DRAG_SOURCE";
const $8f4069742e98d682$var$HOVER = "dnd-core/HOVER";
const $8f4069742e98d682$var$DROP = "dnd-core/DROP";
const $8f4069742e98d682$var$END_DRAG = "dnd-core/END_DRAG";
function $8f4069742e98d682$var$setClientOffset(clientOffset, sourceClientOffset) {
    return {
        type: $8f4069742e98d682$var$INIT_COORDS,
        payload: {
            sourceClientOffset: sourceClientOffset || null,
            clientOffset: clientOffset || null
        }
    };
}
const $8f4069742e98d682$var$ResetCoordinatesAction = {
    type: $8f4069742e98d682$var$INIT_COORDS,
    payload: {
        clientOffset: null,
        sourceClientOffset: null
    }
};
function $8f4069742e98d682$var$createBeginDrag(manager) {
    return function beginDrag(sourceIds = [], options = {
        publishSource: true
    }) {
        const { publishSource: publishSource = true , clientOffset: clientOffset , getSourceClientOffset: getSourceClientOffset  } = options;
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        // Initialize the coordinates using the client offset
        manager.dispatch($8f4069742e98d682$var$setClientOffset(clientOffset));
        $8f4069742e98d682$var$verifyInvariants$1(sourceIds, monitor, registry);
        // Get the draggable source
        const sourceId = $8f4069742e98d682$var$getDraggableSource(sourceIds, monitor);
        if (sourceId == null) {
            manager.dispatch($8f4069742e98d682$var$ResetCoordinatesAction);
            return;
        }
        // Get the source client offset
        let sourceClientOffset = null;
        if (clientOffset) {
            if (!getSourceClientOffset) throw new Error("getSourceClientOffset must be defined");
            $8f4069742e98d682$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
            sourceClientOffset = getSourceClientOffset(sourceId);
        }
        // Initialize the full coordinates
        manager.dispatch($8f4069742e98d682$var$setClientOffset(clientOffset, sourceClientOffset));
        const source = registry.getSource(sourceId);
        const item = source.beginDrag(monitor, sourceId);
        // If source.beginDrag returns null, this is an indicator to cancel the drag
        if (item == null) return undefined;
        $8f4069742e98d682$var$verifyItemIsObject(item);
        registry.pinSource(sourceId);
        const itemType = registry.getSourceType(sourceId);
        return {
            type: $8f4069742e98d682$var$BEGIN_DRAG,
            payload: {
                itemType: itemType,
                item: item,
                sourceId: sourceId,
                clientOffset: clientOffset || null,
                sourceClientOffset: sourceClientOffset || null,
                isSourcePublic: !!publishSource
            }
        };
    };
}
function $8f4069742e98d682$var$verifyInvariants$1(sourceIds, monitor, registry) {
    $8f4069742e98d682$var$invariant(!monitor.isDragging(), "Cannot call beginDrag while dragging.");
    sourceIds.forEach(function(sourceId) {
        $8f4069742e98d682$var$invariant(registry.getSource(sourceId), "Expected sourceIds to be registered.");
    });
}
function $8f4069742e98d682$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
    $8f4069742e98d682$var$invariant(typeof getSourceClientOffset === "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function $8f4069742e98d682$var$verifyItemIsObject(item) {
    $8f4069742e98d682$var$invariant($8f4069742e98d682$var$isObject(item), "Item must be an object.");
}
function $8f4069742e98d682$var$getDraggableSource(sourceIds, monitor) {
    let sourceId = null;
    for(let i = sourceIds.length - 1; i >= 0; i--)if (monitor.canDragSource(sourceIds[i])) {
        sourceId = sourceIds[i];
        break;
    }
    return sourceId;
}
function $8f4069742e98d682$var$_defineProperty$4(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8f4069742e98d682$var$_objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $8f4069742e98d682$var$_defineProperty$4(target, key, source[key]);
        });
    }
    return target;
}
function $8f4069742e98d682$var$createDrop(manager) {
    return function drop(options = {}) {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $8f4069742e98d682$var$verifyInvariants(monitor);
        const targetIds = $8f4069742e98d682$var$getDroppableTargets(monitor);
        // Multiple actions are dispatched here, which is why this doesn't return an action
        targetIds.forEach((targetId, index)=>{
            const dropResult = $8f4069742e98d682$var$determineDropResult(targetId, index, registry, monitor);
            const action = {
                type: $8f4069742e98d682$var$DROP,
                payload: {
                    dropResult: $8f4069742e98d682$var$_objectSpread$4({}, options, dropResult)
                }
            };
            manager.dispatch(action);
        });
    };
}
function $8f4069742e98d682$var$verifyInvariants(monitor) {
    $8f4069742e98d682$var$invariant(monitor.isDragging(), "Cannot call drop while not dragging.");
    $8f4069742e98d682$var$invariant(!monitor.didDrop(), "Cannot call drop twice during one drag operation.");
}
function $8f4069742e98d682$var$determineDropResult(targetId, index, registry, monitor) {
    const target = registry.getTarget(targetId);
    let dropResult = target ? target.drop(monitor, targetId) : undefined;
    $8f4069742e98d682$var$verifyDropResultType(dropResult);
    if (typeof dropResult === "undefined") dropResult = index === 0 ? {} : monitor.getDropResult();
    return dropResult;
}
function $8f4069742e98d682$var$verifyDropResultType(dropResult) {
    $8f4069742e98d682$var$invariant(typeof dropResult === "undefined" || $8f4069742e98d682$var$isObject(dropResult), "Drop result must either be an object or undefined.");
}
function $8f4069742e98d682$var$getDroppableTargets(monitor) {
    const targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    return targetIds;
}
function $8f4069742e98d682$var$createEndDrag(manager) {
    return function endDrag() {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $8f4069742e98d682$var$verifyIsDragging(monitor);
        const sourceId = monitor.getSourceId();
        if (sourceId != null) {
            const source = registry.getSource(sourceId, true);
            source.endDrag(monitor, sourceId);
            registry.unpinSource();
        }
        return {
            type: $8f4069742e98d682$var$END_DRAG
        };
    };
}
function $8f4069742e98d682$var$verifyIsDragging(monitor) {
    $8f4069742e98d682$var$invariant(monitor.isDragging(), "Cannot call endDrag while not dragging.");
}
function $8f4069742e98d682$var$matchesType(targetType, draggedItemType) {
    if (draggedItemType === null) return targetType === null;
    return Array.isArray(targetType) ? targetType.some((t)=>t === draggedItemType) : targetType === draggedItemType;
}
function $8f4069742e98d682$var$createHover(manager) {
    return function hover(targetIdsArg, { clientOffset: clientOffset  } = {}) {
        $8f4069742e98d682$var$verifyTargetIdsIsArray(targetIdsArg);
        const targetIds = targetIdsArg.slice(0);
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        const draggedItemType = monitor.getItemType();
        $8f4069742e98d682$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
        $8f4069742e98d682$var$checkInvariants(targetIds, monitor, registry);
        $8f4069742e98d682$var$hoverAllTargets(targetIds, monitor, registry);
        return {
            type: $8f4069742e98d682$var$HOVER,
            payload: {
                targetIds: targetIds,
                clientOffset: clientOffset || null
            }
        };
    };
}
function $8f4069742e98d682$var$verifyTargetIdsIsArray(targetIdsArg) {
    $8f4069742e98d682$var$invariant(Array.isArray(targetIdsArg), "Expected targetIds to be an array.");
}
function $8f4069742e98d682$var$checkInvariants(targetIds, monitor, registry) {
    $8f4069742e98d682$var$invariant(monitor.isDragging(), "Cannot call hover while not dragging.");
    $8f4069742e98d682$var$invariant(!monitor.didDrop(), "Cannot call hover after drop.");
    for(let i = 0; i < targetIds.length; i++){
        const targetId = targetIds[i];
        $8f4069742e98d682$var$invariant(targetIds.lastIndexOf(targetId) === i, "Expected targetIds to be unique in the passed array.");
        const target = registry.getTarget(targetId);
        $8f4069742e98d682$var$invariant(target, "Expected targetIds to be registered.");
    }
}
function $8f4069742e98d682$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for(let i = targetIds.length - 1; i >= 0; i--){
        const targetId = targetIds[i];
        const targetType = registry.getTargetType(targetId);
        if (!$8f4069742e98d682$var$matchesType(targetType, draggedItemType)) targetIds.splice(i, 1);
    }
}
function $8f4069742e98d682$var$hoverAllTargets(targetIds, monitor, registry) {
    // Finally call hover on all matching targets.
    targetIds.forEach(function(targetId) {
        const target = registry.getTarget(targetId);
        target.hover(monitor, targetId);
    });
}
function $8f4069742e98d682$var$createPublishDragSource(manager) {
    return function publishDragSource() {
        const monitor = manager.getMonitor();
        if (monitor.isDragging()) return {
            type: $8f4069742e98d682$var$PUBLISH_DRAG_SOURCE
        };
        return;
    };
}
function $8f4069742e98d682$var$createDragDropActions(manager) {
    return {
        beginDrag: $8f4069742e98d682$var$createBeginDrag(manager),
        publishDragSource: $8f4069742e98d682$var$createPublishDragSource(manager),
        hover: $8f4069742e98d682$var$createHover(manager),
        drop: $8f4069742e98d682$var$createDrop(manager),
        endDrag: $8f4069742e98d682$var$createEndDrag(manager)
    };
}
class $8f4069742e98d682$var$DragDropManagerImpl {
    receiveBackend(backend) {
        this.backend = backend;
    }
    getMonitor() {
        return this.monitor;
    }
    getBackend() {
        return this.backend;
    }
    getRegistry() {
        return this.monitor.registry;
    }
    getActions() {
        /* eslint-disable-next-line @typescript-eslint/no-this-alias */ const manager = this;
        const { dispatch: dispatch  } = this.store;
        function bindActionCreator(actionCreator) {
            return (...args)=>{
                const action = actionCreator.apply(manager, args);
                if (typeof action !== "undefined") dispatch(action);
            };
        }
        const actions = $8f4069742e98d682$var$createDragDropActions(this);
        return Object.keys(actions).reduce((boundActions, key)=>{
            const action = actions[key];
            boundActions[key] = bindActionCreator(action);
            return boundActions;
        }, {});
    }
    dispatch(action) {
        this.store.dispatch(action);
    }
    constructor(store, monitor){
        this.isSetUp = false;
        this.handleRefCountChange = ()=>{
            const shouldSetUp = this.store.getState().refCount > 0;
            if (this.backend) {
                if (shouldSetUp && !this.isSetUp) {
                    this.backend.setup();
                    this.isSetUp = true;
                } else if (!shouldSetUp && this.isSetUp) {
                    this.backend.teardown();
                    this.isSetUp = false;
                }
            }
        };
        this.store = store;
        this.monitor = monitor;
        store.subscribe(this.handleRefCountChange);
    }
}
/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */ function $8f4069742e98d682$var$add(a, b) {
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
}
/**
 * Coordinate subtraction
 * @param a The first coordinate
 * @param b The second coordinate
 */ function $8f4069742e98d682$var$subtract(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
/**
 * Returns the cartesian distance of the drag source component's position, based on its position
 * at the time when the current drag operation has started, and the movement difference.
 *
 * Returns null if no item is being dragged.
 *
 * @param state The offset state to compute from
 */ function $8f4069742e98d682$var$getSourceClientOffset(state) {
    const { clientOffset: clientOffset , initialClientOffset: initialClientOffset , initialSourceClientOffset: initialSourceClientOffset  } = state;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) return null;
    return $8f4069742e98d682$var$subtract($8f4069742e98d682$var$add(clientOffset, initialSourceClientOffset), initialClientOffset);
}
/**
 * Determines the x,y offset between the client offset and the initial client offset
 *
 * @param state The offset state to compute from
 */ function $8f4069742e98d682$var$getDifferenceFromInitialOffset(state) {
    const { clientOffset: clientOffset , initialClientOffset: initialClientOffset  } = state;
    if (!clientOffset || !initialClientOffset) return null;
    return $8f4069742e98d682$var$subtract(clientOffset, initialClientOffset);
}
const $8f4069742e98d682$var$NONE = [];
const $8f4069742e98d682$var$ALL = [];
$8f4069742e98d682$var$NONE.__IS_NONE__ = true;
$8f4069742e98d682$var$ALL.__IS_ALL__ = true;
/**
 * Determines if the given handler IDs are dirty or not.
 *
 * @param dirtyIds The set of dirty handler ids
 * @param handlerIds The set of handler ids to check
 */ function $8f4069742e98d682$var$areDirty(dirtyIds, handlerIds) {
    if (dirtyIds === $8f4069742e98d682$var$NONE) return false;
    if (dirtyIds === $8f4069742e98d682$var$ALL || typeof handlerIds === "undefined") return true;
    const commonIds = $8f4069742e98d682$var$intersection(handlerIds, dirtyIds);
    return commonIds.length > 0;
}
class $8f4069742e98d682$var$DragDropMonitorImpl {
    subscribeToStateChange(listener, options = {}) {
        const { handlerIds: handlerIds  } = options;
        $8f4069742e98d682$var$invariant(typeof listener === "function", "listener must be a function.");
        $8f4069742e98d682$var$invariant(typeof handlerIds === "undefined" || Array.isArray(handlerIds), "handlerIds, when specified, must be an array of strings.");
        let prevStateId = this.store.getState().stateId;
        const handleChange = ()=>{
            const state = this.store.getState();
            const currentStateId = state.stateId;
            try {
                const canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !$8f4069742e98d682$var$areDirty(state.dirtyHandlerIds, handlerIds);
                if (!canSkipListener) listener();
            } finally{
                prevStateId = currentStateId;
            }
        };
        return this.store.subscribe(handleChange);
    }
    subscribeToOffsetChange(listener) {
        $8f4069742e98d682$var$invariant(typeof listener === "function", "listener must be a function.");
        let previousState = this.store.getState().dragOffset;
        const handleChange = ()=>{
            const nextState = this.store.getState().dragOffset;
            if (nextState === previousState) return;
            previousState = nextState;
            listener();
        };
        return this.store.subscribe(handleChange);
    }
    canDragSource(sourceId) {
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId);
        $8f4069742e98d682$var$invariant(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (this.isDragging()) return false;
        return source.canDrag(this, sourceId);
    }
    canDropOnTarget(targetId) {
        // undefined on initial render
        if (!targetId) return false;
        const target = this.registry.getTarget(targetId);
        $8f4069742e98d682$var$invariant(target, `Expected to find a valid target. targetId=${targetId}`);
        if (!this.isDragging() || this.didDrop()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        return $8f4069742e98d682$var$matchesType(targetType, draggedItemType) && target.canDrop(this, targetId);
    }
    isDragging() {
        return Boolean(this.getItemType());
    }
    isDraggingSource(sourceId) {
        // undefined on initial render
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId, true);
        $8f4069742e98d682$var$invariant(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (!this.isDragging() || !this.isSourcePublic()) return false;
        const sourceType = this.registry.getSourceType(sourceId);
        const draggedItemType = this.getItemType();
        if (sourceType !== draggedItemType) return false;
        return source.isDragging(this, sourceId);
    }
    isOverTarget(targetId, options = {
        shallow: false
    }) {
        // undefined on initial render
        if (!targetId) return false;
        const { shallow: shallow  } = options;
        if (!this.isDragging()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        if (draggedItemType && !$8f4069742e98d682$var$matchesType(targetType, draggedItemType)) return false;
        const targetIds = this.getTargetIds();
        if (!targetIds.length) return false;
        const index = targetIds.indexOf(targetId);
        if (shallow) return index === targetIds.length - 1;
        else return index > -1;
    }
    getItemType() {
        return this.store.getState().dragOperation.itemType;
    }
    getItem() {
        return this.store.getState().dragOperation.item;
    }
    getSourceId() {
        return this.store.getState().dragOperation.sourceId;
    }
    getTargetIds() {
        return this.store.getState().dragOperation.targetIds;
    }
    getDropResult() {
        return this.store.getState().dragOperation.dropResult;
    }
    didDrop() {
        return this.store.getState().dragOperation.didDrop;
    }
    isSourcePublic() {
        return Boolean(this.store.getState().dragOperation.isSourcePublic);
    }
    getInitialClientOffset() {
        return this.store.getState().dragOffset.initialClientOffset;
    }
    getInitialSourceClientOffset() {
        return this.store.getState().dragOffset.initialSourceClientOffset;
    }
    getClientOffset() {
        return this.store.getState().dragOffset.clientOffset;
    }
    getSourceClientOffset() {
        return $8f4069742e98d682$var$getSourceClientOffset(this.store.getState().dragOffset);
    }
    getDifferenceFromInitialOffset() {
        return $8f4069742e98d682$var$getDifferenceFromInitialOffset(this.store.getState().dragOffset);
    }
    constructor(store, registry){
        this.store = store;
        this.registry = registry;
    }
}
// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ const $8f4069742e98d682$var$scope = typeof $parcel$global !== "undefined" ? $parcel$global : self;
const $8f4069742e98d682$var$BrowserMutationObserver = $8f4069742e98d682$var$scope.MutationObserver || $8f4069742e98d682$var$scope.WebKitMutationObserver;
function $8f4069742e98d682$var$makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        const timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        const intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function $8f4069742e98d682$var$makeRequestCallFromMutationObserver(callback) {
    let toggle = 1;
    const observer = new $8f4069742e98d682$var$BrowserMutationObserver(callback);
    const node = document.createTextNode("");
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
const $8f4069742e98d682$var$makeRequestCall = typeof $8f4069742e98d682$var$BrowserMutationObserver === "function" ? // They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
$8f4069742e98d682$var$makeRequestCallFromMutationObserver : // 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.
// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396
// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
$8f4069742e98d682$var$makeRequestCallFromTimer;
class $8f4069742e98d682$var$AsapQueue {
    // Use the fastest means possible to execute a task in its own turn, with
    // priority over other events including IO, animation, reflow, and redraw
    // events in browsers.
    //
    // An exception thrown by a task will permanently interrupt the processing of
    // subsequent tasks. The higher level `asap` function ensures that if an
    // exception is thrown by a task, that the task queue will continue flushing as
    // soon as possible, but if you use `rawAsap` directly, you are responsible to
    // either ensure that no exceptions are thrown from your task, or to manually
    // call `rawAsap.requestFlush` if an exception is thrown.
    enqueueTask(task) {
        const { queue: q , requestFlush: requestFlush  } = this;
        if (!q.length) {
            requestFlush();
            this.flushing = true;
        }
        // Equivalent to push, but avoids a function call.
        q[q.length] = task;
    }
    constructor(){
        this.queue = [];
        // We queue errors to ensure they are thrown in right order (FIFO).
        // Array-as-queue is good enough here, since we are just dealing with exceptions.
        this.pendingErrors = [];
        // Once a flush has been requested, no further calls to `requestFlush` are
        // necessary until the next `flush` completes.
        // @ts-ignore
        this.flushing = false;
        // The position of the next task to execute in the task queue. This is
        // preserved between calls to `flush` so that it can be resumed if
        // a task throws an exception.
        this.index = 0;
        // If a task schedules additional tasks recursively, the task queue can grow
        // unbounded. To prevent memory exhaustion, the task queue will periodically
        // truncate already-completed tasks.
        this.capacity = 1024;
        // The flush function processes all tasks that have been scheduled with
        // `rawAsap` unless and until one of those tasks throws an exception.
        // If a task throws an exception, `flush` ensures that its state will remain
        // consistent and will resume where it left off when called again.
        // However, `flush` does not make any arrangements to be called again if an
        // exception is thrown.
        this.flush = ()=>{
            const { queue: q  } = this;
            while(this.index < q.length){
                const currentIndex = this.index;
                // Advance the index before calling the task. This ensures that we will
                // begin flushing on the next task the task throws an error.
                this.index++;
                q[currentIndex].call();
                // Prevent leaking memory for long chains of recursive calls to `asap`.
                // If we call `asap` within tasks scheduled by `asap`, the queue will
                // grow, but to avoid an O(n) walk for every task we execute, we don't
                // shift tasks off the queue after they have been executed.
                // Instead, we periodically shift 1024 tasks off the queue.
                if (this.index > this.capacity) {
                    // Manually shift all values starting at the index back to the
                    // beginning of the queue.
                    for(let scan = 0, newLength = q.length - this.index; scan < newLength; scan++)q[scan] = q[scan + this.index];
                    q.length -= this.index;
                    this.index = 0;
                }
            }
            q.length = 0;
            this.index = 0;
            this.flushing = false;
        };
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        this.registerPendingError = (err)=>{
            this.pendingErrors.push(err);
            this.requestErrorThrow();
        };
        // `requestFlush` requests that the high priority event queue be flushed as
        // soon as possible.
        // This is useful to prevent an error thrown in a task from stalling the event
        // queue if the exception handled by Node.js’s
        // `process.on("uncaughtException")` or by a domain.
        // `requestFlush` is implemented using a strategy based on data collected from
        // every available SauceLabs Selenium web driver worker at time of writing.
        // https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
        this.requestFlush = $8f4069742e98d682$var$makeRequestCall(this.flush);
        this.requestErrorThrow = $8f4069742e98d682$var$makeRequestCallFromTimer(()=>{
            // Throw first error
            if (this.pendingErrors.length) throw this.pendingErrors.shift();
        });
    }
} // The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html
// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.
// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }
// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.
// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }
// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.
// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.
// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// // its existence.
// rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer
// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
// `call`, just like a function.
class $8f4069742e98d682$var$RawTask {
    call() {
        try {
            this.task && this.task();
        } catch (error) {
            this.onError(error);
        } finally{
            this.task = null;
            this.release(this);
        }
    }
    constructor(onError, release){
        this.onError = onError;
        this.release = release;
        this.task = null;
    }
}
class $8f4069742e98d682$var$TaskFactory {
    create(task) {
        const tasks = this.freeTasks;
        const t1 = tasks.length ? tasks.pop() : new $8f4069742e98d682$var$RawTask(this.onError, (t)=>tasks[tasks.length] = t);
        t1.task = task;
        return t1;
    }
    constructor(onError){
        this.onError = onError;
        this.freeTasks = [];
    }
}
const $8f4069742e98d682$var$asapQueue = new $8f4069742e98d682$var$AsapQueue();
const $8f4069742e98d682$var$taskFactory = new $8f4069742e98d682$var$TaskFactory($8f4069742e98d682$var$asapQueue.registerPendingError);
/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */ function $8f4069742e98d682$var$asap(task) {
    $8f4069742e98d682$var$asapQueue.enqueueTask($8f4069742e98d682$var$taskFactory.create(task));
}
const $8f4069742e98d682$var$ADD_SOURCE = "dnd-core/ADD_SOURCE";
const $8f4069742e98d682$var$ADD_TARGET = "dnd-core/ADD_TARGET";
const $8f4069742e98d682$var$REMOVE_SOURCE = "dnd-core/REMOVE_SOURCE";
const $8f4069742e98d682$var$REMOVE_TARGET = "dnd-core/REMOVE_TARGET";
function $8f4069742e98d682$var$addSource(sourceId) {
    return {
        type: $8f4069742e98d682$var$ADD_SOURCE,
        payload: {
            sourceId: sourceId
        }
    };
}
function $8f4069742e98d682$var$addTarget(targetId) {
    return {
        type: $8f4069742e98d682$var$ADD_TARGET,
        payload: {
            targetId: targetId
        }
    };
}
function $8f4069742e98d682$var$removeSource(sourceId) {
    return {
        type: $8f4069742e98d682$var$REMOVE_SOURCE,
        payload: {
            sourceId: sourceId
        }
    };
}
function $8f4069742e98d682$var$removeTarget(targetId) {
    return {
        type: $8f4069742e98d682$var$REMOVE_TARGET,
        payload: {
            targetId: targetId
        }
    };
}
function $8f4069742e98d682$var$validateSourceContract(source) {
    $8f4069742e98d682$var$invariant(typeof source.canDrag === "function", "Expected canDrag to be a function.");
    $8f4069742e98d682$var$invariant(typeof source.beginDrag === "function", "Expected beginDrag to be a function.");
    $8f4069742e98d682$var$invariant(typeof source.endDrag === "function", "Expected endDrag to be a function.");
}
function $8f4069742e98d682$var$validateTargetContract(target) {
    $8f4069742e98d682$var$invariant(typeof target.canDrop === "function", "Expected canDrop to be a function.");
    $8f4069742e98d682$var$invariant(typeof target.hover === "function", "Expected hover to be a function.");
    $8f4069742e98d682$var$invariant(typeof target.drop === "function", "Expected beginDrag to be a function.");
}
function $8f4069742e98d682$var$validateType(type, allowArray) {
    if (allowArray && Array.isArray(type)) {
        type.forEach((t)=>$8f4069742e98d682$var$validateType(t, false));
        return;
    }
    $8f4069742e98d682$var$invariant(typeof type === "string" || typeof type === "symbol", allowArray ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}
var $8f4069742e98d682$var$HandlerRole;
(function(HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})($8f4069742e98d682$var$HandlerRole || ($8f4069742e98d682$var$HandlerRole = {}));
let $8f4069742e98d682$var$nextUniqueId = 0;
function $8f4069742e98d682$var$getNextUniqueId() {
    return $8f4069742e98d682$var$nextUniqueId++;
}
function $8f4069742e98d682$var$getNextHandlerId(role) {
    const id = $8f4069742e98d682$var$getNextUniqueId().toString();
    switch(role){
        case $8f4069742e98d682$var$HandlerRole.SOURCE:
            return `S${id}`;
        case $8f4069742e98d682$var$HandlerRole.TARGET:
            return `T${id}`;
        default:
            throw new Error(`Unknown Handler Role: ${role}`);
    }
}
function $8f4069742e98d682$var$parseRoleFromHandlerId(handlerId) {
    switch(handlerId[0]){
        case "S":
            return $8f4069742e98d682$var$HandlerRole.SOURCE;
        case "T":
            return $8f4069742e98d682$var$HandlerRole.TARGET;
        default:
            throw new Error(`Cannot parse handler ID: ${handlerId}`);
    }
}
function $8f4069742e98d682$var$mapContainsValue(map, searchValue) {
    const entries = map.entries();
    let isDone = false;
    do {
        const { done: done , value: [, value]  } = entries.next();
        if (value === searchValue) return true;
        isDone = !!done;
    }while (!isDone);
    return false;
}
class $8f4069742e98d682$var$HandlerRegistryImpl {
    addSource(type, source) {
        $8f4069742e98d682$var$validateType(type);
        $8f4069742e98d682$var$validateSourceContract(source);
        const sourceId = this.addHandler($8f4069742e98d682$var$HandlerRole.SOURCE, type, source);
        this.store.dispatch($8f4069742e98d682$var$addSource(sourceId));
        return sourceId;
    }
    addTarget(type, target) {
        $8f4069742e98d682$var$validateType(type, true);
        $8f4069742e98d682$var$validateTargetContract(target);
        const targetId = this.addHandler($8f4069742e98d682$var$HandlerRole.TARGET, type, target);
        this.store.dispatch($8f4069742e98d682$var$addTarget(targetId));
        return targetId;
    }
    containsHandler(handler) {
        return $8f4069742e98d682$var$mapContainsValue(this.dragSources, handler) || $8f4069742e98d682$var$mapContainsValue(this.dropTargets, handler);
    }
    getSource(sourceId, includePinned = false) {
        $8f4069742e98d682$var$invariant(this.isSourceId(sourceId), "Expected a valid source ID.");
        const isPinned = includePinned && sourceId === this.pinnedSourceId;
        const source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
        return source;
    }
    getTarget(targetId) {
        $8f4069742e98d682$var$invariant(this.isTargetId(targetId), "Expected a valid target ID.");
        return this.dropTargets.get(targetId);
    }
    getSourceType(sourceId) {
        $8f4069742e98d682$var$invariant(this.isSourceId(sourceId), "Expected a valid source ID.");
        return this.types.get(sourceId);
    }
    getTargetType(targetId) {
        $8f4069742e98d682$var$invariant(this.isTargetId(targetId), "Expected a valid target ID.");
        return this.types.get(targetId);
    }
    isSourceId(handlerId) {
        const role = $8f4069742e98d682$var$parseRoleFromHandlerId(handlerId);
        return role === $8f4069742e98d682$var$HandlerRole.SOURCE;
    }
    isTargetId(handlerId) {
        const role = $8f4069742e98d682$var$parseRoleFromHandlerId(handlerId);
        return role === $8f4069742e98d682$var$HandlerRole.TARGET;
    }
    removeSource(sourceId) {
        $8f4069742e98d682$var$invariant(this.getSource(sourceId), "Expected an existing source.");
        this.store.dispatch($8f4069742e98d682$var$removeSource(sourceId));
        $8f4069742e98d682$var$asap(()=>{
            this.dragSources.delete(sourceId);
            this.types.delete(sourceId);
        });
    }
    removeTarget(targetId) {
        $8f4069742e98d682$var$invariant(this.getTarget(targetId), "Expected an existing target.");
        this.store.dispatch($8f4069742e98d682$var$removeTarget(targetId));
        this.dropTargets.delete(targetId);
        this.types.delete(targetId);
    }
    pinSource(sourceId) {
        const source = this.getSource(sourceId);
        $8f4069742e98d682$var$invariant(source, "Expected an existing source.");
        this.pinnedSourceId = sourceId;
        this.pinnedSource = source;
    }
    unpinSource() {
        $8f4069742e98d682$var$invariant(this.pinnedSource, "No source is pinned at the time.");
        this.pinnedSourceId = null;
        this.pinnedSource = null;
    }
    addHandler(role, type, handler) {
        const id = $8f4069742e98d682$var$getNextHandlerId(role);
        this.types.set(id, type);
        if (role === $8f4069742e98d682$var$HandlerRole.SOURCE) this.dragSources.set(id, handler);
        else if (role === $8f4069742e98d682$var$HandlerRole.TARGET) this.dropTargets.set(id, handler);
        return id;
    }
    constructor(store){
        this.types = new Map();
        this.dragSources = new Map();
        this.dropTargets = new Map();
        this.pinnedSourceId = null;
        this.pinnedSource = null;
        this.store = store;
    }
}
const $8f4069742e98d682$var$strictEquality = (a, b)=>a === b;
/**
 * Determine if two cartesian coordinate offsets are equal
 * @param offsetA
 * @param offsetB
 */ function $8f4069742e98d682$var$areCoordsEqual(offsetA, offsetB) {
    if (!offsetA && !offsetB) return true;
    else if (!offsetA || !offsetB) return false;
    else return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}
/**
 * Determines if two arrays of items are equal
 * @param a The first array of items
 * @param b The second array of items
 */ function $8f4069742e98d682$var$areArraysEqual(a, b, isEqual = $8f4069742e98d682$var$strictEquality) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (!isEqual(a[i], b[i])) return false;
    }
    return true;
}
function $8f4069742e98d682$var$reduce$5(_state = $8f4069742e98d682$var$NONE, action) {
    switch(action.type){
        case $8f4069742e98d682$var$HOVER:
            break;
        case $8f4069742e98d682$var$ADD_SOURCE:
        case $8f4069742e98d682$var$ADD_TARGET:
        case $8f4069742e98d682$var$REMOVE_TARGET:
        case $8f4069742e98d682$var$REMOVE_SOURCE:
            return $8f4069742e98d682$var$NONE;
        case $8f4069742e98d682$var$BEGIN_DRAG:
        case $8f4069742e98d682$var$PUBLISH_DRAG_SOURCE:
        case $8f4069742e98d682$var$END_DRAG:
        case $8f4069742e98d682$var$DROP:
        default:
            return $8f4069742e98d682$var$ALL;
    }
    const { targetIds: targetIds = [] , prevTargetIds: prevTargetIds = []  } = action.payload;
    const result = $8f4069742e98d682$var$xor(targetIds, prevTargetIds);
    const didChange = result.length > 0 || !$8f4069742e98d682$var$areArraysEqual(targetIds, prevTargetIds);
    if (!didChange) return $8f4069742e98d682$var$NONE;
    // Check the target ids at the innermost position. If they are valid, add them
    // to the result
    const prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    const innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) result.push(prevInnermostTargetId);
        if (innermostTargetId) result.push(innermostTargetId);
    }
    return result;
}
function $8f4069742e98d682$var$_defineProperty$3(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8f4069742e98d682$var$_objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $8f4069742e98d682$var$_defineProperty$3(target, key, source[key]);
        });
    }
    return target;
}
const $8f4069742e98d682$var$initialState$1 = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
};
function $8f4069742e98d682$var$reduce$4(state = $8f4069742e98d682$var$initialState$1, action) {
    const { payload: payload  } = action;
    switch(action.type){
        case $8f4069742e98d682$var$INIT_COORDS:
        case $8f4069742e98d682$var$BEGIN_DRAG:
            return {
                initialSourceClientOffset: payload.sourceClientOffset,
                initialClientOffset: payload.clientOffset,
                clientOffset: payload.clientOffset
            };
        case $8f4069742e98d682$var$HOVER:
            if ($8f4069742e98d682$var$areCoordsEqual(state.clientOffset, payload.clientOffset)) return state;
            return $8f4069742e98d682$var$_objectSpread$3({}, state, {
                clientOffset: payload.clientOffset
            });
        case $8f4069742e98d682$var$END_DRAG:
        case $8f4069742e98d682$var$DROP:
            return $8f4069742e98d682$var$initialState$1;
        default:
            return state;
    }
}
function $8f4069742e98d682$var$_defineProperty$2(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8f4069742e98d682$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $8f4069742e98d682$var$_defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
const $8f4069742e98d682$var$initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
};
function $8f4069742e98d682$var$reduce$3(state = $8f4069742e98d682$var$initialState, action) {
    const { payload: payload  } = action;
    switch(action.type){
        case $8f4069742e98d682$var$BEGIN_DRAG:
            return $8f4069742e98d682$var$_objectSpread$2({}, state, {
                itemType: payload.itemType,
                item: payload.item,
                sourceId: payload.sourceId,
                isSourcePublic: payload.isSourcePublic,
                dropResult: null,
                didDrop: false
            });
        case $8f4069742e98d682$var$PUBLISH_DRAG_SOURCE:
            return $8f4069742e98d682$var$_objectSpread$2({}, state, {
                isSourcePublic: true
            });
        case $8f4069742e98d682$var$HOVER:
            return $8f4069742e98d682$var$_objectSpread$2({}, state, {
                targetIds: payload.targetIds
            });
        case $8f4069742e98d682$var$REMOVE_TARGET:
            if (state.targetIds.indexOf(payload.targetId) === -1) return state;
            return $8f4069742e98d682$var$_objectSpread$2({}, state, {
                targetIds: $8f4069742e98d682$var$without$1(state.targetIds, payload.targetId)
            });
        case $8f4069742e98d682$var$DROP:
            return $8f4069742e98d682$var$_objectSpread$2({}, state, {
                dropResult: payload.dropResult,
                didDrop: true,
                targetIds: []
            });
        case $8f4069742e98d682$var$END_DRAG:
            return $8f4069742e98d682$var$_objectSpread$2({}, state, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
            });
        default:
            return state;
    }
}
function $8f4069742e98d682$var$reduce$2(state = 0, action) {
    switch(action.type){
        case $8f4069742e98d682$var$ADD_SOURCE:
        case $8f4069742e98d682$var$ADD_TARGET:
            return state + 1;
        case $8f4069742e98d682$var$REMOVE_SOURCE:
        case $8f4069742e98d682$var$REMOVE_TARGET:
            return state - 1;
        default:
            return state;
    }
}
function $8f4069742e98d682$var$reduce$1(state = 0) {
    return state + 1;
}
function $8f4069742e98d682$var$_defineProperty$1(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8f4069742e98d682$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $8f4069742e98d682$var$_defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function $8f4069742e98d682$var$reduce(state = {}, action) {
    return {
        dirtyHandlerIds: $8f4069742e98d682$var$reduce$5(state.dirtyHandlerIds, {
            type: action.type,
            payload: $8f4069742e98d682$var$_objectSpread$1({}, action.payload, {
                prevTargetIds: $8f4069742e98d682$var$get(state, "dragOperation.targetIds", [])
            })
        }),
        dragOffset: $8f4069742e98d682$var$reduce$4(state.dragOffset, action),
        refCount: $8f4069742e98d682$var$reduce$2(state.refCount, action),
        dragOperation: $8f4069742e98d682$var$reduce$3(state.dragOperation, action),
        stateId: $8f4069742e98d682$var$reduce$1(state.stateId)
    };
}
function $8f4069742e98d682$var$createDragDropManager(backendFactory, globalContext, backendOptions = {}, debugMode = false) {
    const store = $8f4069742e98d682$var$makeStoreInstance(debugMode);
    const monitor = new $8f4069742e98d682$var$DragDropMonitorImpl(store, new $8f4069742e98d682$var$HandlerRegistryImpl(store));
    const manager = new $8f4069742e98d682$var$DragDropManagerImpl(store, monitor);
    const backend = backendFactory(manager, globalContext, backendOptions);
    manager.receiveBackend(backend);
    return manager;
}
function $8f4069742e98d682$var$makeStoreInstance(debugMode) {
    // TODO: if we ever make a react-native version of this,
    // we'll need to consider how to pull off dev-tooling
    const reduxDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__;
    return $8f4069742e98d682$var$createStore($8f4069742e98d682$var$reduce, debugMode && reduxDevTools && reduxDevTools({
        name: "dnd-core",
        instanceId: "dnd-core"
    }));
}
function $8f4069742e98d682$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8f4069742e98d682$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8f4069742e98d682$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
let $8f4069742e98d682$var$refCount = 0;
const $8f4069742e98d682$var$INSTANCE_SYM = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
var $8f4069742e98d682$var$DndProvider = /*#__PURE__*/ (0, $exYeM.memo)(function DndProvider(_param) {
    var { children: children  } = _param, props = $8f4069742e98d682$var$_objectWithoutProperties(_param, [
        "children"
    ]);
    const [manager, isGlobalInstance] = $8f4069742e98d682$var$getDndContextValue(props) // memoized from props
    ;
    /**
		 * If the global context was used to store the DND context
		 * then where theres no more references to it we should
		 * clean it up to avoid memory leaks
		 */ (0, $exYeM.useEffect)(()=>{
        if (isGlobalInstance) {
            const context = $8f4069742e98d682$var$getGlobalContext();
            ++$8f4069742e98d682$var$refCount;
            return ()=>{
                if (--$8f4069742e98d682$var$refCount === 0) context[$8f4069742e98d682$var$INSTANCE_SYM] = null;
            };
        }
        return;
    }, []);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($8f4069742e98d682$var$DndContext.Provider, {
        value: manager,
        children: children
    });
});
function $8f4069742e98d682$var$getDndContextValue(props) {
    if ("manager" in props) {
        const manager = {
            dragDropManager: props.manager
        };
        return [
            manager,
            false
        ];
    }
    const manager = $8f4069742e98d682$var$createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
    const isGlobalInstance = !props.context;
    return [
        manager,
        isGlobalInstance
    ];
}
function $8f4069742e98d682$var$createSingletonDndContext(backend, context = $8f4069742e98d682$var$getGlobalContext(), options, debugMode) {
    const ctx = context;
    if (!ctx[$8f4069742e98d682$var$INSTANCE_SYM]) ctx[$8f4069742e98d682$var$INSTANCE_SYM] = {
        dragDropManager: $8f4069742e98d682$var$createDragDropManager(backend, context, options, debugMode)
    };
    return ctx[$8f4069742e98d682$var$INSTANCE_SYM];
}
function $8f4069742e98d682$var$getGlobalContext() {
    return typeof $parcel$global !== "undefined" ? $parcel$global : window;
}
// do not edit .js files directly - edit src/index.jst
var $8f4069742e98d682$var$fastDeepEqual = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};
// suppress the useLayoutEffect warning on server side.
const $8f4069742e98d682$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect);
/**
 *
 * @param monitor The monitor to collect state from
 * @param collect The collecting function
 * @param onUpdate A method to invoke when updates occur
 */ function $8f4069742e98d682$var$useCollector(monitor, collect, onUpdate) {
    const [collected, setCollected] = (0, $exYeM.useState)(()=>collect(monitor));
    const updateCollected = (0, $exYeM.useCallback)(()=>{
        const nextValue = collect(monitor);
        // This needs to be a deep-equality check because some monitor-collected values
        // include XYCoord objects that may be equivalent, but do not have instance equality.
        if (!$8f4069742e98d682$var$fastDeepEqual(collected, nextValue)) {
            setCollected(nextValue);
            if (onUpdate) onUpdate();
        }
    }, [
        collected,
        monitor,
        onUpdate
    ]);
    // update the collected properties after react renders.
    // Note that the "Dustbin Stress Test" fails if this is not
    // done when the component updates
    $8f4069742e98d682$var$useIsomorphicLayoutEffect(updateCollected);
    return [
        collected,
        updateCollected
    ];
}
function $8f4069742e98d682$var$useMonitorOutput(monitor, collect, onCollect) {
    const [collected, updateCollected] = $8f4069742e98d682$var$useCollector(monitor, collect, onCollect);
    $8f4069742e98d682$var$useIsomorphicLayoutEffect(function subscribeToMonitorStateChange() {
        const handlerId = monitor.getHandlerId();
        if (handlerId == null) return;
        return monitor.subscribeToStateChange(updateCollected, {
            handlerIds: [
                handlerId
            ]
        });
    }, [
        monitor,
        updateCollected
    ]);
    return collected;
}
function $8f4069742e98d682$var$useCollectedProps(collector, monitor, connector) {
    return $8f4069742e98d682$var$useMonitorOutput(monitor, collector || (()=>({})), ()=>connector.reconnect());
}
function $8f4069742e98d682$var$useOptionalFactory(arg, deps) {
    const memoDeps = [
        ...deps || []
    ];
    if (deps == null && typeof arg !== "function") memoDeps.push(arg);
    return (0, $exYeM.useMemo)(()=>{
        return typeof arg === "function" ? arg() : arg;
    }, memoDeps);
}
function $8f4069742e98d682$var$useConnectDragSource(connector) {
    return (0, $exYeM.useMemo)(()=>connector.hooks.dragSource(), [
        connector
    ]);
}
function $8f4069742e98d682$var$useConnectDragPreview(connector) {
    return (0, $exYeM.useMemo)(()=>connector.hooks.dragPreview(), [
        connector
    ]);
}
let $8f4069742e98d682$var$isCallingCanDrag = false;
let $8f4069742e98d682$var$isCallingIsDragging = false;
class $8f4069742e98d682$var$DragSourceMonitorImpl {
    receiveHandlerId(sourceId) {
        this.sourceId = sourceId;
    }
    getHandlerId() {
        return this.sourceId;
    }
    canDrag() {
        $8f4069742e98d682$var$invariant(!$8f4069742e98d682$var$isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            $8f4069742e98d682$var$isCallingCanDrag = true;
            return this.internalMonitor.canDragSource(this.sourceId);
        } finally{
            $8f4069742e98d682$var$isCallingCanDrag = false;
        }
    }
    isDragging() {
        if (!this.sourceId) return false;
        $8f4069742e98d682$var$invariant(!$8f4069742e98d682$var$isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            $8f4069742e98d682$var$isCallingIsDragging = true;
            return this.internalMonitor.isDraggingSource(this.sourceId);
        } finally{
            $8f4069742e98d682$var$isCallingIsDragging = false;
        }
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    isDraggingSource(sourceId) {
        return this.internalMonitor.isDraggingSource(sourceId);
    }
    isOverTarget(targetId, options) {
        return this.internalMonitor.isOverTarget(targetId, options);
    }
    getTargetIds() {
        return this.internalMonitor.getTargetIds();
    }
    isSourcePublic() {
        return this.internalMonitor.isSourcePublic();
    }
    getSourceId() {
        return this.internalMonitor.getSourceId();
    }
    subscribeToOffsetChange(listener) {
        return this.internalMonitor.subscribeToOffsetChange(listener);
    }
    canDragSource(sourceId) {
        return this.internalMonitor.canDragSource(sourceId);
    }
    canDropOnTarget(targetId) {
        return this.internalMonitor.canDropOnTarget(targetId);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.sourceId = null;
        this.internalMonitor = manager.getMonitor();
    }
}
let $8f4069742e98d682$var$isCallingCanDrop = false;
class $8f4069742e98d682$var$DropTargetMonitorImpl {
    receiveHandlerId(targetId) {
        this.targetId = targetId;
    }
    getHandlerId() {
        return this.targetId;
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    canDrop() {
        // Cut out early if the target id has not been set. This should prevent errors
        // where the user has an older version of dnd-core like in
        // https://github.com/react-dnd/react-dnd/issues/1310
        if (!this.targetId) return false;
        $8f4069742e98d682$var$invariant(!$8f4069742e98d682$var$isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
        try {
            $8f4069742e98d682$var$isCallingCanDrop = true;
            return this.internalMonitor.canDropOnTarget(this.targetId);
        } finally{
            $8f4069742e98d682$var$isCallingCanDrop = false;
        }
    }
    isOver(options) {
        if (!this.targetId) return false;
        return this.internalMonitor.isOverTarget(this.targetId, options);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.targetId = null;
        this.internalMonitor = manager.getMonitor();
    }
}
function $8f4069742e98d682$var$registerTarget(type, target, manager) {
    const registry = manager.getRegistry();
    const targetId = registry.addTarget(type, target);
    return [
        targetId,
        ()=>registry.removeTarget(targetId)
    ];
}
function $8f4069742e98d682$var$registerSource(type, source, manager) {
    const registry = manager.getRegistry();
    const sourceId = registry.addSource(type, source);
    return [
        sourceId,
        ()=>registry.removeSource(sourceId)
    ];
}
function $8f4069742e98d682$var$shallowEqual(objA, objB, compare, compareContext) {
    let compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (compareResult !== void 0) return !!compareResult;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(let idx = 0; idx < keysA.length; idx++){
        const key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        const valueA = objA[key];
        const valueB = objB[key];
        compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (compareResult === false || compareResult === void 0 && valueA !== valueB) return false;
    }
    return true;
}
function $8f4069742e98d682$var$isRef(obj) {
    return obj !== null && typeof obj === "object" && Object.prototype.hasOwnProperty.call(obj, "current");
}
function $8f4069742e98d682$var$throwIfCompositeComponentElement(element) {
    // Custom components can no longer be wrapped directly in React DnD 2.0
    // so that we don't need to depend on findDOMNode() from react-dom.
    if (typeof element.type === "string") return;
    const displayName = element.type.displayName || element.type.name || "the component";
    throw new Error("Only native element nodes can now be passed to React DnD connectors." + `You can either wrap ${displayName} into a <div>, or turn it into a ` + "drag source or a drop target itself.");
}
function $8f4069742e98d682$var$wrapHookToRecognizeElement(hook) {
    return (elementOrNode = null, options = null)=>{
        // When passed a node, call the hook straight away.
        if (!(0, $exYeM.isValidElement)(elementOrNode)) {
            const node = elementOrNode;
            hook(node, options);
            // return the node so it can be chained (e.g. when within callback refs
            // <div ref={node => connectDragSource(connectDropTarget(node))}/>
            return node;
        }
        // If passed a ReactElement, clone it and attach this function as a ref.
        // This helps us achieve a neat API where user doesn't even know that refs
        // are being used under the hood.
        const element = elementOrNode;
        $8f4069742e98d682$var$throwIfCompositeComponentElement(element);
        // When no options are passed, use the hook directly
        const ref = options ? (node)=>hook(node, options) : hook;
        return $8f4069742e98d682$var$cloneWithRef(element, ref);
    };
}
function $8f4069742e98d682$var$wrapConnectorHooks(hooks) {
    const wrappedHooks = {};
    Object.keys(hooks).forEach((key)=>{
        const hook = hooks[key];
        // ref objects should be passed straight through without wrapping
        if (key.endsWith("Ref")) wrappedHooks[key] = hooks[key];
        else {
            const wrappedHook = $8f4069742e98d682$var$wrapHookToRecognizeElement(hook);
            wrappedHooks[key] = ()=>wrappedHook;
        }
    });
    return wrappedHooks;
}
function $8f4069742e98d682$var$setRef(ref, node) {
    if (typeof ref === "function") ref(node);
    else ref.current = node;
}
function $8f4069742e98d682$var$cloneWithRef(element, newRef) {
    const previousRef = element.ref;
    $8f4069742e98d682$var$invariant(typeof previousRef !== "string", "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs");
    if (!previousRef) // When there is no ref on the element, use the new ref directly
    return (0, $exYeM.cloneElement)(element, {
        ref: newRef
    });
    else return (0, $exYeM.cloneElement)(element, {
        ref: (node)=>{
            $8f4069742e98d682$var$setRef(previousRef, node);
            $8f4069742e98d682$var$setRef(newRef, node);
        }
    });
}
class $8f4069742e98d682$var$SourceConnector {
    receiveHandlerId(newHandlerId) {
        if (this.handlerId === newHandlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get connectTarget() {
        return this.dragSource;
    }
    get dragSourceOptions() {
        return this.dragSourceOptionsInternal;
    }
    set dragSourceOptions(options) {
        this.dragSourceOptionsInternal = options;
    }
    get dragPreviewOptions() {
        return this.dragPreviewOptionsInternal;
    }
    set dragPreviewOptions(options) {
        this.dragPreviewOptionsInternal = options;
    }
    reconnect() {
        const didChange = this.reconnectDragSource();
        this.reconnectDragPreview(didChange);
    }
    reconnectDragSource() {
        const dragSource = this.dragSource;
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
        if (didChange) this.disconnectDragSource();
        if (!this.handlerId) return didChange;
        if (!dragSource) {
            this.lastConnectedDragSource = dragSource;
            return didChange;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragSource = dragSource;
            this.lastConnectedDragSourceOptions = this.dragSourceOptions;
            this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
        }
        return didChange;
    }
    reconnectDragPreview(forceDidChange = false) {
        const dragPreview = this.dragPreview;
        // if nothing has changed then don't resubscribe
        const didChange = forceDidChange || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
        if (didChange) this.disconnectDragPreview();
        if (!this.handlerId) return;
        if (!dragPreview) {
            this.lastConnectedDragPreview = dragPreview;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragPreview = dragPreview;
            this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
            this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
        }
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didConnectedDragSourceChange() {
        return this.lastConnectedDragSource !== this.dragSource;
    }
    didConnectedDragPreviewChange() {
        return this.lastConnectedDragPreview !== this.dragPreview;
    }
    didDragSourceOptionsChange() {
        return !$8f4069742e98d682$var$shallowEqual(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    }
    didDragPreviewOptionsChange() {
        return !$8f4069742e98d682$var$shallowEqual(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    }
    disconnectDragSource() {
        if (this.dragSourceUnsubscribe) {
            this.dragSourceUnsubscribe();
            this.dragSourceUnsubscribe = undefined;
        }
    }
    disconnectDragPreview() {
        if (this.dragPreviewUnsubscribe) {
            this.dragPreviewUnsubscribe();
            this.dragPreviewUnsubscribe = undefined;
            this.dragPreviewNode = null;
            this.dragPreviewRef = null;
        }
    }
    get dragSource() {
        return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
    }
    get dragPreview() {
        return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
    }
    clearDragSource() {
        this.dragSourceNode = null;
        this.dragSourceRef = null;
    }
    clearDragPreview() {
        this.dragPreviewNode = null;
        this.dragPreviewRef = null;
    }
    constructor(backend){
        this.hooks = $8f4069742e98d682$var$wrapConnectorHooks({
            dragSource: (node, options)=>{
                this.clearDragSource();
                this.dragSourceOptions = options || null;
                if ($8f4069742e98d682$var$isRef(node)) this.dragSourceRef = node;
                else this.dragSourceNode = node;
                this.reconnectDragSource();
            },
            dragPreview: (node, options)=>{
                this.clearDragPreview();
                this.dragPreviewOptions = options || null;
                if ($8f4069742e98d682$var$isRef(node)) this.dragPreviewRef = node;
                else this.dragPreviewNode = node;
                this.reconnectDragPreview();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dragSourceRef = null;
        this.dragSourceOptionsInternal = null;
        // The drag preview may either be attached via ref or connect function
        this.dragPreviewRef = null;
        this.dragPreviewOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDragSource = null;
        this.lastConnectedDragSourceOptions = null;
        this.lastConnectedDragPreview = null;
        this.lastConnectedDragPreviewOptions = null;
        this.backend = backend;
    }
}
class $8f4069742e98d682$var$TargetConnector {
    get connectTarget() {
        return this.dropTarget;
    }
    reconnect() {
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
        if (didChange) this.disconnectDropTarget();
        const dropTarget = this.dropTarget;
        if (!this.handlerId) return;
        if (!dropTarget) {
            this.lastConnectedDropTarget = dropTarget;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDropTarget = dropTarget;
            this.lastConnectedDropTargetOptions = this.dropTargetOptions;
            this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
        }
    }
    receiveHandlerId(newHandlerId) {
        if (newHandlerId === this.handlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get dropTargetOptions() {
        return this.dropTargetOptionsInternal;
    }
    set dropTargetOptions(options) {
        this.dropTargetOptionsInternal = options;
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didDropTargetChange() {
        return this.lastConnectedDropTarget !== this.dropTarget;
    }
    didOptionsChange() {
        return !$8f4069742e98d682$var$shallowEqual(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    }
    disconnectDropTarget() {
        if (this.unsubscribeDropTarget) {
            this.unsubscribeDropTarget();
            this.unsubscribeDropTarget = undefined;
        }
    }
    get dropTarget() {
        return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
    }
    clearDropTarget() {
        this.dropTargetRef = null;
        this.dropTargetNode = null;
    }
    constructor(backend){
        this.hooks = $8f4069742e98d682$var$wrapConnectorHooks({
            dropTarget: (node, options)=>{
                this.clearDropTarget();
                this.dropTargetOptions = options;
                if ($8f4069742e98d682$var$isRef(node)) this.dropTargetRef = node;
                else this.dropTargetNode = node;
                this.reconnect();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dropTargetRef = null;
        this.dropTargetOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDropTarget = null;
        this.lastConnectedDropTargetOptions = null;
        this.backend = backend;
    }
}
/**
 * A hook to retrieve the DragDropManager from Context
 */ function $8f4069742e98d682$var$useDragDropManager() {
    const { dragDropManager: dragDropManager  } = (0, $exYeM.useContext)($8f4069742e98d682$var$DndContext);
    $8f4069742e98d682$var$invariant(dragDropManager != null, "Expected drag drop context");
    return dragDropManager;
}
function $8f4069742e98d682$var$useDragSourceConnector(dragSourceOptions, dragPreviewOptions) {
    const manager = $8f4069742e98d682$var$useDragDropManager();
    const connector = (0, $exYeM.useMemo)(()=>new $8f4069742e98d682$var$SourceConnector(manager.getBackend()), [
        manager
    ]);
    $8f4069742e98d682$var$useIsomorphicLayoutEffect(()=>{
        connector.dragSourceOptions = dragSourceOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragSource();
    }, [
        connector,
        dragSourceOptions
    ]);
    $8f4069742e98d682$var$useIsomorphicLayoutEffect(()=>{
        connector.dragPreviewOptions = dragPreviewOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragPreview();
    }, [
        connector,
        dragPreviewOptions
    ]);
    return connector;
}
function $8f4069742e98d682$var$useDragSourceMonitor() {
    const manager = $8f4069742e98d682$var$useDragDropManager();
    return (0, $exYeM.useMemo)(()=>new $8f4069742e98d682$var$DragSourceMonitorImpl(manager), [
        manager
    ]);
}
class $8f4069742e98d682$var$DragSourceImpl {
    beginDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        let result = null;
        if (typeof spec.item === "object") result = spec.item;
        else if (typeof spec.item === "function") result = spec.item(monitor);
        else result = {};
        return result !== null && result !== void 0 ? result : null;
    }
    canDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (typeof spec.canDrag === "boolean") return spec.canDrag;
        else if (typeof spec.canDrag === "function") return spec.canDrag(monitor);
        else return true;
    }
    isDragging(globalMonitor, target) {
        const spec = this.spec;
        const monitor = this.monitor;
        const { isDragging: isDragging  } = spec;
        return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
    }
    endDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        const connector = this.connector;
        const { end: end  } = spec;
        if (end) end(monitor.getItem(), monitor);
        connector.reconnect();
    }
    constructor(spec, monitor, connector){
        this.spec = spec;
        this.monitor = monitor;
        this.connector = connector;
    }
}
function $8f4069742e98d682$var$useDragSource(spec, monitor, connector) {
    const handler = (0, $exYeM.useMemo)(()=>new $8f4069742e98d682$var$DragSourceImpl(spec, monitor, connector), [
        monitor,
        connector
    ]);
    (0, $exYeM.useEffect)(()=>{
        handler.spec = spec;
    }, [
        spec
    ]);
    return handler;
}
function $8f4069742e98d682$var$useDragType(spec) {
    return (0, $exYeM.useMemo)(()=>{
        const result = spec.type;
        $8f4069742e98d682$var$invariant(result != null, "spec.type must be defined");
        return result;
    }, [
        spec
    ]);
}
function $8f4069742e98d682$var$useRegisteredDragSource(spec, monitor, connector) {
    const manager = $8f4069742e98d682$var$useDragDropManager();
    const handler = $8f4069742e98d682$var$useDragSource(spec, monitor, connector);
    const itemType = $8f4069742e98d682$var$useDragType(spec);
    $8f4069742e98d682$var$useIsomorphicLayoutEffect(function registerDragSource() {
        if (itemType != null) {
            const [handlerId, unregister] = $8f4069742e98d682$var$registerSource(itemType, handler, manager);
            monitor.receiveHandlerId(handlerId);
            connector.receiveHandlerId(handlerId);
            return unregister;
        }
        return;
    }, [
        manager,
        monitor,
        connector,
        handler,
        itemType
    ]);
}
/**
 * useDragSource hook
 * @param sourceSpec The drag source specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */ function $8f4069742e98d682$var$useDrag(specArg, deps) {
    const spec = $8f4069742e98d682$var$useOptionalFactory(specArg, deps);
    $8f4069742e98d682$var$invariant(!spec.begin, `useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)`);
    const monitor = $8f4069742e98d682$var$useDragSourceMonitor();
    const connector = $8f4069742e98d682$var$useDragSourceConnector(spec.options, spec.previewOptions);
    $8f4069742e98d682$var$useRegisteredDragSource(spec, monitor, connector);
    return [
        $8f4069742e98d682$var$useCollectedProps(spec.collect, monitor, connector),
        $8f4069742e98d682$var$useConnectDragSource(connector),
        $8f4069742e98d682$var$useConnectDragPreview(connector)
    ];
}
/**
 * useDragLayer Hook
 * @param collector The property collector
 */ function $8f4069742e98d682$var$useDragLayer(collect) {
    const dragDropManager = $8f4069742e98d682$var$useDragDropManager();
    const monitor = dragDropManager.getMonitor();
    const [collected, updateCollected] = $8f4069742e98d682$var$useCollector(monitor, collect);
    (0, $exYeM.useEffect)(()=>monitor.subscribeToOffsetChange(updateCollected));
    (0, $exYeM.useEffect)(()=>monitor.subscribeToStateChange(updateCollected));
    return collected;
}
function $8f4069742e98d682$var$useConnectDropTarget(connector) {
    return (0, $exYeM.useMemo)(()=>connector.hooks.dropTarget(), [
        connector
    ]);
}
function $8f4069742e98d682$var$useDropTargetConnector(options) {
    const manager = $8f4069742e98d682$var$useDragDropManager();
    const connector = (0, $exYeM.useMemo)(()=>new $8f4069742e98d682$var$TargetConnector(manager.getBackend()), [
        manager
    ]);
    $8f4069742e98d682$var$useIsomorphicLayoutEffect(()=>{
        connector.dropTargetOptions = options || null;
        connector.reconnect();
        return ()=>connector.disconnectDropTarget();
    }, [
        options
    ]);
    return connector;
}
function $8f4069742e98d682$var$useDropTargetMonitor() {
    const manager = $8f4069742e98d682$var$useDragDropManager();
    return (0, $exYeM.useMemo)(()=>new $8f4069742e98d682$var$DropTargetMonitorImpl(manager), [
        manager
    ]);
}
/**
 * Internal utility hook to get an array-version of spec.accept.
 * The main utility here is that we aren't creating a new array on every render if a non-array spec.accept is passed in.
 * @param spec
 */ function $8f4069742e98d682$var$useAccept(spec) {
    const { accept: accept  } = spec;
    return (0, $exYeM.useMemo)(()=>{
        $8f4069742e98d682$var$invariant(spec.accept != null, "accept must be defined");
        return Array.isArray(accept) ? accept : [
            accept
        ];
    }, [
        accept
    ]);
}
class $8f4069742e98d682$var$DropTargetImpl {
    canDrop() {
        const spec = this.spec;
        const monitor = this.monitor;
        return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
    }
    hover() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.hover) spec.hover(monitor.getItem(), monitor);
    }
    drop() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.drop) return spec.drop(monitor.getItem(), monitor);
        return;
    }
    constructor(spec, monitor){
        this.spec = spec;
        this.monitor = monitor;
    }
}
function $8f4069742e98d682$var$useDropTarget(spec, monitor) {
    const dropTarget = (0, $exYeM.useMemo)(()=>new $8f4069742e98d682$var$DropTargetImpl(spec, monitor), [
        monitor
    ]);
    (0, $exYeM.useEffect)(()=>{
        dropTarget.spec = spec;
    }, [
        spec
    ]);
    return dropTarget;
}
function $8f4069742e98d682$var$useRegisteredDropTarget(spec, monitor, connector) {
    const manager = $8f4069742e98d682$var$useDragDropManager();
    const dropTarget = $8f4069742e98d682$var$useDropTarget(spec, monitor);
    const accept = $8f4069742e98d682$var$useAccept(spec);
    $8f4069742e98d682$var$useIsomorphicLayoutEffect(function registerDropTarget() {
        const [handlerId, unregister] = $8f4069742e98d682$var$registerTarget(accept, dropTarget, manager);
        monitor.receiveHandlerId(handlerId);
        connector.receiveHandlerId(handlerId);
        return unregister;
    }, [
        manager,
        monitor,
        dropTarget,
        connector,
        accept.map((a)=>a.toString()).join("|")
    ]);
}
/**
 * useDropTarget Hook
 * @param spec The drop target specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */ function $8f4069742e98d682$var$useDrop(specArg, deps) {
    const spec = $8f4069742e98d682$var$useOptionalFactory(specArg, deps);
    const monitor = $8f4069742e98d682$var$useDropTargetMonitor();
    const connector = $8f4069742e98d682$var$useDropTargetConnector(spec.options);
    $8f4069742e98d682$var$useRegisteredDropTarget(spec, monitor, connector);
    return [
        $8f4069742e98d682$var$useCollectedProps(spec.collect, monitor, connector),
        $8f4069742e98d682$var$useConnectDropTarget(connector)
    ];
}
// cheap lodash replacements
function $8f4069742e98d682$var$memoize(fn) {
    let result = null;
    const memoized = ()=>{
        if (result == null) result = fn();
        return result;
    };
    return memoized;
}
/**
 * drop-in replacement for _.without
 */ function $8f4069742e98d682$var$without(items, item) {
    return items.filter((i)=>i !== item);
}
function $8f4069742e98d682$var$union(itemsA, itemsB) {
    const set = new Set();
    const insertItem = (item)=>set.add(item);
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    set.forEach((key)=>result.push(key));
    return result;
}
class $8f4069742e98d682$var$EnterLeaveCounter {
    enter(enteringNode) {
        const previousLength = this.entered.length;
        const isNodeEntered = (node)=>this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
        this.entered = $8f4069742e98d682$var$union(this.entered.filter(isNodeEntered), [
            enteringNode
        ]);
        return previousLength === 0 && this.entered.length > 0;
    }
    leave(leavingNode) {
        const previousLength = this.entered.length;
        this.entered = $8f4069742e98d682$var$without(this.entered.filter(this.isNodeInDocument), leavingNode);
        return previousLength > 0 && this.entered.length === 0;
    }
    reset() {
        this.entered = [];
    }
    constructor(isNodeInDocument){
        this.entered = [];
        this.isNodeInDocument = isNodeInDocument;
    }
}
class $8f4069742e98d682$var$NativeDragSource {
    initializeExposedProperties() {
        Object.keys(this.config.exposeProperties).forEach((property)=>{
            Object.defineProperty(this.item, property, {
                configurable: true,
                enumerable: true,
                get () {
                    // eslint-disable-next-line no-console
                    console.warn(`Browser doesn't allow reading "${property}" until the drop event.`);
                    return null;
                }
            });
        });
    }
    loadDataTransfer(dataTransfer) {
        if (dataTransfer) {
            const newProperties = {};
            Object.keys(this.config.exposeProperties).forEach((property)=>{
                const propertyFn = this.config.exposeProperties[property];
                if (propertyFn != null) newProperties[property] = {
                    value: propertyFn(dataTransfer, this.config.matchesTypes),
                    configurable: true,
                    enumerable: true
                };
            });
            Object.defineProperties(this.item, newProperties);
        }
    }
    canDrag() {
        return true;
    }
    beginDrag() {
        return this.item;
    }
    isDragging(monitor, handle) {
        return handle === monitor.getSourceId();
    }
    endDrag() {
    // empty
    }
    constructor(config){
        this.config = config;
        this.item = {};
        this.initializeExposedProperties();
    }
}
const $8f4069742e98d682$var$FILE = "__NATIVE_FILE__";
const $8f4069742e98d682$var$URL = "__NATIVE_URL__";
const $8f4069742e98d682$var$TEXT = "__NATIVE_TEXT__";
const $8f4069742e98d682$var$HTML = "__NATIVE_HTML__";
var $8f4069742e98d682$var$NativeTypes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    FILE: $8f4069742e98d682$var$FILE,
    HTML: $8f4069742e98d682$var$HTML,
    TEXT: $8f4069742e98d682$var$TEXT,
    URL: $8f4069742e98d682$var$URL
});
function $8f4069742e98d682$var$getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
    const result = typesToTry.reduce((resultSoFar, typeToTry)=>resultSoFar || dataTransfer.getData(typeToTry), "");
    return result != null ? result : defaultValue;
}
const $8f4069742e98d682$var$nativeTypesConfig = {
    [$8f4069742e98d682$var$FILE]: {
        exposeProperties: {
            files: (dataTransfer)=>Array.prototype.slice.call(dataTransfer.files),
            items: (dataTransfer)=>dataTransfer.items,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Files"
        ]
    },
    [$8f4069742e98d682$var$HTML]: {
        exposeProperties: {
            html: (dataTransfer, matchesTypes)=>$8f4069742e98d682$var$getDataFromDataTransfer(dataTransfer, matchesTypes, ""),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Html",
            "text/html"
        ]
    },
    [$8f4069742e98d682$var$URL]: {
        exposeProperties: {
            urls: (dataTransfer, matchesTypes)=>$8f4069742e98d682$var$getDataFromDataTransfer(dataTransfer, matchesTypes, "").split("\n"),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Url",
            "text/uri-list"
        ]
    },
    [$8f4069742e98d682$var$TEXT]: {
        exposeProperties: {
            text: (dataTransfer, matchesTypes)=>$8f4069742e98d682$var$getDataFromDataTransfer(dataTransfer, matchesTypes, ""),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Text",
            "text/plain"
        ]
    }
};
function $8f4069742e98d682$var$createNativeDragSource(type, dataTransfer) {
    const config = $8f4069742e98d682$var$nativeTypesConfig[type];
    if (!config) throw new Error(`native type ${type} has no configuration`);
    const result = new $8f4069742e98d682$var$NativeDragSource(config);
    result.loadDataTransfer(dataTransfer);
    return result;
}
function $8f4069742e98d682$var$matchNativeItemType(dataTransfer) {
    if (!dataTransfer) return null;
    const dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return Object.keys($8f4069742e98d682$var$nativeTypesConfig).filter((nativeItemType)=>{
        const typeConfig = $8f4069742e98d682$var$nativeTypesConfig[nativeItemType];
        if (!(typeConfig === null || typeConfig === void 0 ? void 0 : typeConfig.matchesTypes)) return false;
        return typeConfig.matchesTypes.some((t)=>dataTransferTypes.indexOf(t) > -1);
    })[0] || null;
}
const $8f4069742e98d682$var$isFirefox = $8f4069742e98d682$var$memoize(()=>/firefox/i.test(navigator.userAgent));
const $8f4069742e98d682$var$isSafari = $8f4069742e98d682$var$memoize(()=>Boolean(window.safari));
class $8f4069742e98d682$var$MonotonicInterpolant {
    interpolate(x) {
        const { xs: xs , ys: ys , c1s: c1s , c2s: c2s , c3s: c3s  } = this;
        // The rightmost point in the dataset should give an exact result
        let i = xs.length - 1;
        if (x === xs[i]) return ys[i];
        // Search for the interval x is in, returning the corresponding y if x is one of the original xs
        let low = 0;
        let high = c3s.length - 1;
        let mid;
        while(low <= high){
            mid = Math.floor(0.5 * (low + high));
            const xHere = xs[mid];
            if (xHere < x) low = mid + 1;
            else if (xHere > x) high = mid - 1;
            else return ys[mid];
        }
        i = Math.max(0, high);
        // Interpolate
        const diff = x - xs[i];
        const diffSq = diff * diff;
        return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    }
    constructor(xs, ys){
        const { length: length  } = xs;
        // Rearrange xs and ys so that xs is sorted
        const indexes = [];
        for(let i = 0; i < length; i++)indexes.push(i);
        indexes.sort((a, b)=>xs[a] < xs[b] ? -1 : 1);
        const dxs = [];
        const ms = [];
        let dx;
        let dy;
        for(let i1 = 0; i1 < length - 1; i1++){
            dx = xs[i1 + 1] - xs[i1];
            dy = ys[i1 + 1] - ys[i1];
            dxs.push(dx);
            ms.push(dy / dx);
        }
        // Get degree-1 coefficients
        const c1s = [
            ms[0]
        ];
        for(let i2 = 0; i2 < dxs.length - 1; i2++){
            const m2 = ms[i2];
            const mNext = ms[i2 + 1];
            if (m2 * mNext <= 0) c1s.push(0);
            else {
                dx = dxs[i2];
                const dxNext = dxs[i2 + 1];
                const common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
            }
        }
        c1s.push(ms[ms.length - 1]);
        // Get degree-2 and degree-3 coefficients
        const c2s = [];
        const c3s = [];
        let m;
        for(let i3 = 0; i3 < c1s.length - 1; i3++){
            m = ms[i3];
            const c1 = c1s[i3];
            const invDx = 1 / dxs[i3];
            const common = c1 + c1s[i3 + 1] - m - m;
            c2s.push((m - c1 - common) * invDx);
            c3s.push(common * invDx * invDx);
        }
        this.xs = xs;
        this.ys = ys;
        this.c1s = c1s;
        this.c2s = c2s;
        this.c3s = c3s;
    }
}
const $8f4069742e98d682$var$ELEMENT_NODE$1 = 1;
function $8f4069742e98d682$var$getNodeClientOffset$1(node) {
    const el = node.nodeType === $8f4069742e98d682$var$ELEMENT_NODE$1 ? node : node.parentElement;
    if (!el) return null;
    const { top: top , left: left  } = el.getBoundingClientRect();
    return {
        x: left,
        y: top
    };
}
function $8f4069742e98d682$var$getEventClientOffset$1(e) {
    return {
        x: e.clientX,
        y: e.clientY
    };
}
function $8f4069742e98d682$var$isImageNode(node) {
    var ref;
    return node.nodeName === "IMG" && ($8f4069742e98d682$var$isFirefox() || !((ref = document.documentElement) === null || ref === void 0 ? void 0 : ref.contains(node)));
}
function $8f4069742e98d682$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    let dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    let dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
    // Work around @2x coordinate discrepancies in browsers
    if ($8f4069742e98d682$var$isSafari() && isImage) {
        dragPreviewHeight /= window.devicePixelRatio;
        dragPreviewWidth /= window.devicePixelRatio;
    }
    return {
        dragPreviewWidth: dragPreviewWidth,
        dragPreviewHeight: dragPreviewHeight
    };
}
function $8f4069742e98d682$var$getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    const isImage = $8f4069742e98d682$var$isImageNode(dragPreview);
    const dragPreviewNode = isImage ? sourceNode : dragPreview;
    const dragPreviewNodeOffsetFromClient = $8f4069742e98d682$var$getNodeClientOffset$1(dragPreviewNode);
    const offsetFromDragPreview = {
        x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
        y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
    };
    const { offsetWidth: sourceWidth , offsetHeight: sourceHeight  } = sourceNode;
    const { anchorX: anchorX , anchorY: anchorY  } = anchorPoint;
    const { dragPreviewWidth: dragPreviewWidth , dragPreviewHeight: dragPreviewHeight  } = $8f4069742e98d682$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight);
    const calculateYOffset = ()=>{
        const interpolantY = new $8f4069742e98d682$var$MonotonicInterpolant([
            0,
            0.5,
            1
        ], [
            // Dock to the top
            offsetFromDragPreview.y,
            // Align at the center
            offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
            // Dock to the bottom
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight
        ]);
        let y = interpolantY.interpolate(anchorY);
        // Work around Safari 8 positioning bug
        if ($8f4069742e98d682$var$isSafari() && isImage) // We'll have to wait for @3x to see if this is entirely correct
        y += (window.devicePixelRatio - 1) * dragPreviewHeight;
        return y;
    };
    const calculateXOffset = ()=>{
        // Interpolate coordinates depending on anchor point
        // If you know a simpler way to do this, let me know
        const interpolantX = new $8f4069742e98d682$var$MonotonicInterpolant([
            0,
            0.5,
            1
        ], [
            // Dock to the left
            offsetFromDragPreview.x,
            // Align at the center
            offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
            // Dock to the right
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth
        ]);
        return interpolantX.interpolate(anchorX);
    };
    // Force offsets if specified in the options.
    const { offsetX: offsetX , offsetY: offsetY  } = offsetPoint;
    const isManualOffsetX = offsetX === 0 || offsetX;
    const isManualOffsetY = offsetY === 0 || offsetY;
    return {
        x: isManualOffsetX ? offsetX : calculateXOffset(),
        y: isManualOffsetY ? offsetY : calculateYOffset()
    };
}
let $8f4069742e98d682$var$OptionsReader$1 = class OptionsReader {
    get window() {
        if (this.globalContext) return this.globalContext;
        else if (typeof window !== "undefined") return window;
        return undefined;
    }
    get document() {
        var ref;
        if ((ref = this.globalContext) === null || ref === void 0 ? void 0 : ref.document) return this.globalContext.document;
        else if (this.window) return this.window.document;
        else return undefined;
    }
    get rootElement() {
        var ref;
        return ((ref = this.optionsArgs) === null || ref === void 0 ? void 0 : ref.rootElement) || this.window;
    }
    constructor(globalContext, options){
        this.ownerDocument = null;
        this.globalContext = globalContext;
        this.optionsArgs = options;
    }
};
function $8f4069742e98d682$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8f4069742e98d682$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $8f4069742e98d682$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
class $8f4069742e98d682$var$HTML5BackendImpl {
    /**
	 * Generate profiling statistics for the HTML5Backend.
	 */ profile() {
        var ref, ref1;
        return {
            sourcePreviewNodes: this.sourcePreviewNodes.size,
            sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
            sourceNodeOptions: this.sourceNodeOptions.size,
            sourceNodes: this.sourceNodes.size,
            dragStartSourceIds: ((ref = this.dragStartSourceIds) === null || ref === void 0 ? void 0 : ref.length) || 0,
            dropTargetIds: this.dropTargetIds.length,
            dragEnterTargetIds: this.dragEnterTargetIds.length,
            dragOverTargetIds: ((ref1 = this.dragOverTargetIds) === null || ref1 === void 0 ? void 0 : ref1.length) || 0
        };
    }
    // public for test
    get window() {
        return this.options.window;
    }
    get document() {
        return this.options.document;
    }
    /**
	 * Get the root element to use for event subscriptions
	 */ get rootElement() {
        return this.options.rootElement;
    }
    setup() {
        const root = this.rootElement;
        if (root === undefined) return;
        if (root.__isReactDndBackendSetUp) throw new Error("Cannot have two HTML5 backends at the same time.");
        root.__isReactDndBackendSetUp = true;
        this.addEventListeners(root);
    }
    teardown() {
        const root = this.rootElement;
        if (root === undefined) return;
        root.__isReactDndBackendSetUp = false;
        this.removeEventListeners(this.rootElement);
        this.clearCurrentDragSourceNode();
        if (this.asyncEndDragFrameId) {
            var ref;
            (ref = this.window) === null || ref === void 0 || ref.cancelAnimationFrame(this.asyncEndDragFrameId);
        }
    }
    connectDragPreview(sourceId, node, options) {
        this.sourcePreviewNodeOptions.set(sourceId, options);
        this.sourcePreviewNodes.set(sourceId, node);
        return ()=>{
            this.sourcePreviewNodes.delete(sourceId);
            this.sourcePreviewNodeOptions.delete(sourceId);
        };
    }
    connectDragSource(sourceId, node, options) {
        this.sourceNodes.set(sourceId, node);
        this.sourceNodeOptions.set(sourceId, options);
        const handleDragStart = (e)=>this.handleDragStart(e, sourceId);
        const handleSelectStart = (e)=>this.handleSelectStart(e);
        node.setAttribute("draggable", "true");
        node.addEventListener("dragstart", handleDragStart);
        node.addEventListener("selectstart", handleSelectStart);
        return ()=>{
            this.sourceNodes.delete(sourceId);
            this.sourceNodeOptions.delete(sourceId);
            node.removeEventListener("dragstart", handleDragStart);
            node.removeEventListener("selectstart", handleSelectStart);
            node.setAttribute("draggable", "false");
        };
    }
    connectDropTarget(targetId, node) {
        const handleDragEnter = (e)=>this.handleDragEnter(e, targetId);
        const handleDragOver = (e)=>this.handleDragOver(e, targetId);
        const handleDrop = (e)=>this.handleDrop(e, targetId);
        node.addEventListener("dragenter", handleDragEnter);
        node.addEventListener("dragover", handleDragOver);
        node.addEventListener("drop", handleDrop);
        return ()=>{
            node.removeEventListener("dragenter", handleDragEnter);
            node.removeEventListener("dragover", handleDragOver);
            node.removeEventListener("drop", handleDrop);
        };
    }
    addEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.addEventListener) return;
        target.addEventListener("dragstart", this.handleTopDragStart);
        target.addEventListener("dragstart", this.handleTopDragStartCapture, true);
        target.addEventListener("dragend", this.handleTopDragEndCapture, true);
        target.addEventListener("dragenter", this.handleTopDragEnter);
        target.addEventListener("dragenter", this.handleTopDragEnterCapture, true);
        target.addEventListener("dragleave", this.handleTopDragLeaveCapture, true);
        target.addEventListener("dragover", this.handleTopDragOver);
        target.addEventListener("dragover", this.handleTopDragOverCapture, true);
        target.addEventListener("drop", this.handleTopDrop);
        target.addEventListener("drop", this.handleTopDropCapture, true);
    }
    removeEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.removeEventListener) return;
        target.removeEventListener("dragstart", this.handleTopDragStart);
        target.removeEventListener("dragstart", this.handleTopDragStartCapture, true);
        target.removeEventListener("dragend", this.handleTopDragEndCapture, true);
        target.removeEventListener("dragenter", this.handleTopDragEnter);
        target.removeEventListener("dragenter", this.handleTopDragEnterCapture, true);
        target.removeEventListener("dragleave", this.handleTopDragLeaveCapture, true);
        target.removeEventListener("dragover", this.handleTopDragOver);
        target.removeEventListener("dragover", this.handleTopDragOverCapture, true);
        target.removeEventListener("drop", this.handleTopDrop);
        target.removeEventListener("drop", this.handleTopDropCapture, true);
    }
    getCurrentSourceNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
        return $8f4069742e98d682$var$_objectSpread({
            dropEffect: this.altKeyPressed ? "copy" : "move"
        }, sourceNodeOptions || {});
    }
    getCurrentDropEffect() {
        if (this.isDraggingNativeItem()) // It makes more sense to default to 'copy' for native resources
        return "copy";
        return this.getCurrentSourceNodeOptions().dropEffect;
    }
    getCurrentSourcePreviewNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
        return $8f4069742e98d682$var$_objectSpread({
            anchorX: 0.5,
            anchorY: 0.5,
            captureDraggingState: false
        }, sourcePreviewNodeOptions || {});
    }
    isDraggingNativeItem() {
        const itemType = this.monitor.getItemType();
        return Object.keys($8f4069742e98d682$var$NativeTypes).some((key)=>$8f4069742e98d682$var$NativeTypes[key] === itemType);
    }
    beginDragNativeItem(type, dataTransfer) {
        this.clearCurrentDragSourceNode();
        this.currentNativeSource = $8f4069742e98d682$var$createNativeDragSource(type, dataTransfer);
        this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
        this.actions.beginDrag([
            this.currentNativeHandle
        ]);
    }
    setCurrentDragSourceNode(node) {
        this.clearCurrentDragSourceNode();
        this.currentDragSourceNode = node;
        // A timeout of > 0 is necessary to resolve Firefox issue referenced
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        const MOUSE_MOVE_TIMEOUT = 1000;
        // Receiving a mouse event in the middle of a dragging operation
        // means it has ended and the drag source node disappeared from DOM,
        // so the browser didn't dispatch the dragend event.
        //
        // We need to wait before we start listening for mousemove events.
        // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
        // immediately in some browsers.
        //
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        //
        this.mouseMoveTimeoutTimer = setTimeout(()=>{
            var ref;
            return (ref = this.rootElement) === null || ref === void 0 ? void 0 : ref.addEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true);
        }, MOUSE_MOVE_TIMEOUT);
    }
    clearCurrentDragSourceNode() {
        if (this.currentDragSourceNode) {
            this.currentDragSourceNode = null;
            if (this.rootElement) {
                var ref;
                (ref = this.window) === null || ref === void 0 || ref.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
                this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true);
            }
            this.mouseMoveTimeoutTimer = null;
            return true;
        }
        return false;
    }
    handleDragStart(e, sourceId) {
        if (e.defaultPrevented) return;
        if (!this.dragStartSourceIds) this.dragStartSourceIds = [];
        this.dragStartSourceIds.unshift(sourceId);
    }
    handleDragEnter(_e, targetId) {
        this.dragEnterTargetIds.unshift(targetId);
    }
    handleDragOver(_e, targetId) {
        if (this.dragOverTargetIds === null) this.dragOverTargetIds = [];
        this.dragOverTargetIds.unshift(targetId);
    }
    handleDrop(_e, targetId) {
        this.dropTargetIds.unshift(targetId);
    }
    constructor(manager, globalContext, options){
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.sourceNodes = new Map();
        this.sourceNodeOptions = new Map();
        this.dragStartSourceIds = null;
        this.dropTargetIds = [];
        this.dragEnterTargetIds = [];
        this.currentNativeSource = null;
        this.currentNativeHandle = null;
        this.currentDragSourceNode = null;
        this.altKeyPressed = false;
        this.mouseMoveTimeoutTimer = null;
        this.asyncEndDragFrameId = null;
        this.dragOverTargetIds = null;
        this.lastClientOffset = null;
        this.hoverRafId = null;
        this.getSourceClientOffset = (sourceId)=>{
            const source = this.sourceNodes.get(sourceId);
            return source && $8f4069742e98d682$var$getNodeClientOffset$1(source) || null;
        };
        this.endDragNativeItem = ()=>{
            if (!this.isDraggingNativeItem()) return;
            this.actions.endDrag();
            if (this.currentNativeHandle) this.registry.removeSource(this.currentNativeHandle);
            this.currentNativeHandle = null;
            this.currentNativeSource = null;
        };
        this.isNodeInDocument = (node)=>{
            // Check the node either in the main document or in the current context
            return Boolean(node && this.document && this.document.body && this.document.body.contains(node));
        };
        this.endDragIfSourceWasRemovedFromDOM = ()=>{
            const node = this.currentDragSourceNode;
            if (node == null || this.isNodeInDocument(node)) return;
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) this.actions.endDrag();
            this.cancelHover();
        };
        this.scheduleHover = (dragOverTargetIds)=>{
            if (this.hoverRafId === null && typeof requestAnimationFrame !== "undefined") this.hoverRafId = requestAnimationFrame(()=>{
                if (this.monitor.isDragging()) this.actions.hover(dragOverTargetIds || [], {
                    clientOffset: this.lastClientOffset
                });
                this.hoverRafId = null;
            });
        };
        this.cancelHover = ()=>{
            if (this.hoverRafId !== null && typeof cancelAnimationFrame !== "undefined") {
                cancelAnimationFrame(this.hoverRafId);
                this.hoverRafId = null;
            }
        };
        this.handleTopDragStartCapture = ()=>{
            this.clearCurrentDragSourceNode();
            this.dragStartSourceIds = [];
        };
        this.handleTopDragStart = (e)=>{
            if (e.defaultPrevented) return;
            const { dragStartSourceIds: dragStartSourceIds  } = this;
            this.dragStartSourceIds = null;
            const clientOffset = $8f4069742e98d682$var$getEventClientOffset$1(e);
            // Avoid crashing if we missed a drop event or our previous drag died
            if (this.monitor.isDragging()) {
                this.actions.endDrag();
                this.cancelHover();
            }
            // Don't publish the source just yet (see why below)
            this.actions.beginDrag(dragStartSourceIds || [], {
                publishSource: false,
                getSourceClientOffset: this.getSourceClientOffset,
                clientOffset: clientOffset
            });
            const { dataTransfer: dataTransfer  } = e;
            const nativeType = $8f4069742e98d682$var$matchNativeItemType(dataTransfer);
            if (this.monitor.isDragging()) {
                if (dataTransfer && typeof dataTransfer.setDragImage === "function") {
                    // Use custom drag image if user specifies it.
                    // If child drag source refuses drag but parent agrees,
                    // use parent's node as drag image. Neither works in IE though.
                    const sourceId = this.monitor.getSourceId();
                    const sourceNode = this.sourceNodes.get(sourceId);
                    const dragPreview = this.sourcePreviewNodes.get(sourceId) || sourceNode;
                    if (dragPreview) {
                        const { anchorX: anchorX , anchorY: anchorY , offsetX: offsetX , offsetY: offsetY  } = this.getCurrentSourcePreviewNodeOptions();
                        const anchorPoint = {
                            anchorX: anchorX,
                            anchorY: anchorY
                        };
                        const offsetPoint = {
                            offsetX: offsetX,
                            offsetY: offsetY
                        };
                        const dragPreviewOffset = $8f4069742e98d682$var$getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                    }
                }
                try {
                    // Firefox won't drag without setting data
                    dataTransfer === null || dataTransfer === void 0 || dataTransfer.setData("application/json", {});
                } catch (err) {
                // IE doesn't support MIME types in setData
                }
                // Store drag source node so we can check whether
                // it is removed from DOM and trigger endDrag manually.
                this.setCurrentDragSourceNode(e.target);
                // Now we are ready to publish the drag source.. or are we not?
                const { captureDraggingState: captureDraggingState  } = this.getCurrentSourcePreviewNodeOptions();
                if (!captureDraggingState) // Usually we want to publish it in the next tick so that browser
                // is able to screenshot the current (not yet dragging) state.
                //
                // It also neatly avoids a situation where render() returns null
                // in the same tick for the source element, and browser freaks out.
                setTimeout(()=>this.actions.publishDragSource(), 0);
                else // In some cases the user may want to override this behavior, e.g.
                // to work around IE not supporting custom drag previews.
                //
                // When using a custom drag layer, the only way to prevent
                // the default drag preview from drawing in IE is to screenshot
                // the dragging state in which the node itself has zero opacity
                // and height. In this case, though, returning null from render()
                // will abruptly end the dragging, which is not obvious.
                //
                // This is the reason such behavior is strictly opt-in.
                this.actions.publishDragSource();
            } else if (nativeType) // A native item (such as URL) dragged from inside the document
            this.beginDragNativeItem(nativeType);
            else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute("draggable"))) // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
            // Just let it drag. It's a native type (URL or text) and will be picked up in
            // dragenter handler.
            return;
            else // If by this time no drag source reacted, tell browser not to drag.
            e.preventDefault();
        };
        this.handleTopDragEndCapture = ()=>{
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) // Firefox can dispatch this event in an infinite loop
            // if dragend handler does something like showing an alert.
            // Only proceed if we have not handled it already.
            this.actions.endDrag();
            this.cancelHover();
        };
        this.handleTopDragEnterCapture = (e)=>{
            this.dragEnterTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            }
            const isFirstEnter = this.enterLeaveCounter.enter(e.target);
            if (!isFirstEnter || this.monitor.isDragging()) return;
            const { dataTransfer: dataTransfer  } = e;
            const nativeType = $8f4069742e98d682$var$matchNativeItemType(dataTransfer);
            if (nativeType) // A native item (such as file or URL) dragged from outside the document
            this.beginDragNativeItem(nativeType, dataTransfer);
        };
        this.handleTopDragEnter = (e)=>{
            const { dragEnterTargetIds: dragEnterTargetIds  } = this;
            this.dragEnterTargetIds = [];
            if (!this.monitor.isDragging()) // This is probably a native item type we don't understand.
            return;
            this.altKeyPressed = e.altKey;
            // If the target changes position as the result of `dragenter`, `dragover` might still
            // get dispatched despite target being no longer there. The easy solution is to check
            // whether there actually is a target before firing `hover`.
            if (dragEnterTargetIds.length > 0) this.actions.hover(dragEnterTargetIds, {
                clientOffset: $8f4069742e98d682$var$getEventClientOffset$1(e)
            });
            const canDrop = dragEnterTargetIds.some((targetId)=>this.monitor.canDropOnTarget(targetId));
            if (canDrop) {
                // IE requires this to fire dragover events
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = this.getCurrentDropEffect();
            }
        };
        this.handleTopDragOverCapture = (e)=>{
            this.dragOverTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            }
        };
        this.handleTopDragOver = (e)=>{
            const { dragOverTargetIds: dragOverTargetIds  } = this;
            this.dragOverTargetIds = [];
            if (!this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                // Prevent default "drop and blow away the whole document" action.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = "none";
                return;
            }
            this.altKeyPressed = e.altKey;
            this.lastClientOffset = $8f4069742e98d682$var$getEventClientOffset$1(e);
            this.scheduleHover(dragOverTargetIds);
            const canDrop = (dragOverTargetIds || []).some((targetId)=>this.monitor.canDropOnTarget(targetId));
            if (canDrop) {
                // Show user-specified drop effect.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = this.getCurrentDropEffect();
            } else if (this.isDraggingNativeItem()) // Don't show a nice cursor but still prevent default
            // "drop and blow away the whole document" action.
            e.preventDefault();
            else {
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = "none";
            }
        };
        this.handleTopDragLeaveCapture = (e)=>{
            if (this.isDraggingNativeItem()) e.preventDefault();
            const isLastLeave = this.enterLeaveCounter.leave(e.target);
            if (!isLastLeave) return;
            if (this.isDraggingNativeItem()) setTimeout(()=>this.endDragNativeItem(), 0);
            this.cancelHover();
        };
        this.handleTopDropCapture = (e)=>{
            this.dropTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                e.preventDefault();
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            } else if ($8f4069742e98d682$var$matchNativeItemType(e.dataTransfer)) // Dragging some elements, like <a> and <img> may still behave like a native drag event,
            // even if the current drag event matches a user-defined type.
            // Stop the default behavior when we're not expecting a native item to be dropped.
            e.preventDefault();
            this.enterLeaveCounter.reset();
        };
        this.handleTopDrop = (e)=>{
            const { dropTargetIds: dropTargetIds  } = this;
            this.dropTargetIds = [];
            this.actions.hover(dropTargetIds, {
                clientOffset: $8f4069742e98d682$var$getEventClientOffset$1(e)
            });
            this.actions.drop({
                dropEffect: this.getCurrentDropEffect()
            });
            if (this.isDraggingNativeItem()) this.endDragNativeItem();
            else if (this.monitor.isDragging()) this.actions.endDrag();
            this.cancelHover();
        };
        this.handleSelectStart = (e)=>{
            const target = e.target;
            // Only IE requires us to explicitly say
            // we want drag drop operation to start
            if (typeof target.dragDrop !== "function") return;
            // Inputs and textareas should be selectable
            if (target.tagName === "INPUT" || target.tagName === "SELECT" || target.tagName === "TEXTAREA" || target.isContentEditable) return;
            // For other targets, ask IE
            // to enable drag and drop
            e.preventDefault();
            target.dragDrop();
        };
        this.options = new $8f4069742e98d682$var$OptionsReader$1(globalContext, options);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();
        this.enterLeaveCounter = new $8f4069742e98d682$var$EnterLeaveCounter(this.isNodeInDocument);
    }
}
let $8f4069742e98d682$var$emptyImage;
function $8f4069742e98d682$var$getEmptyImage() {
    if (!$8f4069742e98d682$var$emptyImage) {
        $8f4069742e98d682$var$emptyImage = new Image();
        $8f4069742e98d682$var$emptyImage.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
    }
    return $8f4069742e98d682$var$emptyImage;
}
const $8f4069742e98d682$var$HTML5Backend = function createBackend(manager, context, options) {
    return new $8f4069742e98d682$var$HTML5BackendImpl(manager, context, options);
};
function $8f4069742e98d682$var$Piece({ isPremovedPiece: isPremovedPiece = false , piece: piece , square: square , squares: squares  }) {
    const { animationDuration: animationDuration , arePiecesDraggable: arePiecesDraggable , boardWidth: boardWidth , boardOrientation: boardOrientation , chessPieces: chessPieces , currentPosition: currentPosition , deletePieceFromSquare: deletePieceFromSquare , dropOffBoardAction: dropOffBoardAction , id: id , isDraggablePiece: isDraggablePiece , isWaitingForAnimation: isWaitingForAnimation , onPieceClick: onPieceClick , onPieceDragBegin: onPieceDragBegin , onPieceDragEnd: onPieceDragEnd , onPieceDropOffBoard: onPieceDropOffBoard , onPromotionCheck: onPromotionCheck , positionDifferences: positionDifferences  } = $8f4069742e98d682$var$useChessboard();
    const [pieceStyle, setPieceStyle] = (0, $exYeM.useState)({
        opacity: 1,
        zIndex: 5,
        touchAction: "none",
        cursor: arePiecesDraggable && isDraggablePiece({
            piece: piece,
            sourceSquare: square
        }) ? "-webkit-grab" : "default"
    });
    const [{ canDrag: canDrag , isDragging: isDragging  }, drag, dragPreview] = $8f4069742e98d682$var$useDrag(()=>({
            type: "piece",
            item: ()=>{
                onPieceDragBegin(piece, square);
                return {
                    piece: piece,
                    square: square,
                    id: id
                };
            },
            end: (item, monitor)=>{
                onPieceDragEnd(piece, square);
                const wasDropOutsideTheBoard = !monitor.didDrop();
                if (wasDropOutsideTheBoard) {
                    if (dropOffBoardAction === "trash") deletePieceFromSquare(square);
                    onPieceDropOffBoard === null || onPieceDropOffBoard === void 0 || onPieceDropOffBoard(square, piece);
                }
            },
            collect: (monitor)=>({
                    canDrag: isDraggablePiece({
                        piece: piece,
                        sourceSquare: square
                    }),
                    isDragging: !!monitor.isDragging()
                })
        }), [
        piece,
        square,
        currentPosition,
        id
    ]);
    // hide the default preview
    dragPreview($8f4069742e98d682$var$getEmptyImage(), {
        captureDraggingState: true
    });
    // hide piece on drag
    (0, $exYeM.useEffect)(()=>{
        setPieceStyle((oldPieceStyle)=>Object.assign(Object.assign({}, oldPieceStyle), {
                opacity: isDragging ? 0 : 1
            }));
    }, [
        isDragging
    ]);
    // new move has come in
    // if waiting for animation, then animation has started and we can perform animation
    // we need to head towards where we need to go, we are the source, we are heading towards the target
    (0, $exYeM.useEffect)(()=>{
        var _a;
        const removedPiece = (_a = positionDifferences.removed) === null || _a === void 0 ? void 0 : _a[square];
        // return as null and not loaded yet
        if (!positionDifferences.added || !removedPiece) return;
        // check if piece matches or if removed piece was a pawn and new square is on 1st or 8th rank (promotion)
        const newSquare = Object.entries(positionDifferences.added).find(([s, p])=>p === removedPiece || onPromotionCheck(square, s, removedPiece));
        // we can perform animation if our square was in removed, AND the matching piece is in added AND this isn't a premoved piece
        if (isWaitingForAnimation && removedPiece && newSquare && !isPremovedPiece) {
            const sourceSq = square;
            const targetSq = newSquare[0];
            if (sourceSq && targetSq) {
                const squareWidth = boardWidth / 8;
                setPieceStyle((oldPieceStyle)=>Object.assign(Object.assign({}, oldPieceStyle), {
                        transform: `translate(${(boardOrientation === "black" ? -1 : 1) * (targetSq.charCodeAt(0) - sourceSq.charCodeAt(0)) * squareWidth}px, ${(boardOrientation === "black" ? -1 : 1) * (Number(sourceSq[1]) - Number(targetSq[1])) * squareWidth}px)`,
                        transition: `transform ${animationDuration}ms`,
                        zIndex: 6
                    }));
            }
        }
    }, [
        positionDifferences
    ]);
    // translate to their own positions (repaint on undo)
    (0, $exYeM.useEffect)(()=>{
        const { sourceSq: sourceSq  } = getSingleSquareCoordinates();
        if (sourceSq) setPieceStyle((oldPieceStyle)=>Object.assign(Object.assign({}, oldPieceStyle), {
                transform: `translate(${0}px, ${0}px)`,
                transition: `transform ${0}ms`
            }));
    }, [
        currentPosition
    ]);
    // update is piece draggable
    (0, $exYeM.useEffect)(()=>{
        setPieceStyle((oldPieceStyle)=>Object.assign(Object.assign({}, oldPieceStyle), {
                cursor: arePiecesDraggable && isDraggablePiece({
                    piece: piece,
                    sourceSquare: square
                }) ? "-webkit-grab" : "default"
            }));
    }, [
        square,
        currentPosition,
        arePiecesDraggable
    ]);
    function getSingleSquareCoordinates() {
        return {
            sourceSq: squares[square]
        };
    }
    return (0, $7ead0b1397a835ed$exports.jsx)("div", Object.assign({
        ref: arePiecesDraggable && canDrag ? drag : null,
        onClick: ()=>onPieceClick(piece, square),
        "data-piece": piece,
        style: pieceStyle
    }, {
        children: typeof chessPieces[piece] === "function" ? chessPieces[piece]({
            squareWidth: boardWidth / 8,
            isDragging: isDragging,
            square: square
        }) : (0, $7ead0b1397a835ed$exports.jsx)("svg", Object.assign({
            viewBox: "1 1 43 43",
            width: boardWidth / 8,
            height: boardWidth / 8,
            style: {
                display: "block"
            }
        }, {
            children: (0, $7ead0b1397a835ed$exports.jsx)("g", {
                children: chessPieces[piece]
            })
        }))
    }));
}
function $8f4069742e98d682$var$Square({ square: square , squareColor: squareColor , setSquares: setSquares , squareHasPremove: squareHasPremove , children: children  }) {
    const squareRef = (0, $exYeM.useRef)(null);
    const { autoPromoteToQueen: autoPromoteToQueen , boardWidth: boardWidth , boardOrientation: boardOrientation , clearArrows: clearArrows , currentPosition: currentPosition , currentRightClickDown: currentRightClickDown , customBoardStyle: customBoardStyle , customDarkSquareStyle: customDarkSquareStyle , customDropSquareStyle: customDropSquareStyle , customLightSquareStyle: customLightSquareStyle , customPremoveDarkSquareStyle: customPremoveDarkSquareStyle , customPremoveLightSquareStyle: customPremoveLightSquareStyle , customSquare: CustomSquare , customSquareStyles: customSquareStyles , drawNewArrow: drawNewArrow , handleSetPosition: handleSetPosition , handleSparePieceDrop: handleSparePieceDrop , isWaitingForAnimation: isWaitingForAnimation , lastPieceColour: lastPieceColour , lastSquareDraggedOver: lastSquareDraggedOver , onArrowDrawEnd: onArrowDrawEnd , onDragOverSquare: onDragOverSquare , onMouseOutSquare: onMouseOutSquare , onMouseOverSquare: onMouseOverSquare , onPieceDrop: onPieceDrop , onPromotionCheck: onPromotionCheck , onRightClickDown: onRightClickDown , onRightClickUp: onRightClickUp , onSquareClick: onSquareClick , setLastSquareDraggedOver: setLastSquareDraggedOver , setPromoteFromSquare: setPromoteFromSquare , setPromoteToSquare: setPromoteToSquare , setShowPromoteDialog: setShowPromoteDialog  } = $8f4069742e98d682$var$useChessboard();
    const [{ isOver: isOver  }, drop] = $8f4069742e98d682$var$useDrop(()=>({
            accept: "piece",
            drop: handleDrop,
            collect: (monitor)=>({
                    isOver: !!monitor.isOver()
                })
        }), [
        square,
        currentPosition,
        onPieceDrop,
        isWaitingForAnimation,
        lastPieceColour
    ]);
    function handleDrop(item) {
        if (item.isSpare) {
            handleSparePieceDrop(item.piece, square);
            return;
        }
        if (onPromotionCheck(item.square, square, item.piece)) {
            if (autoPromoteToQueen) handleSetPosition(item.square, square, item.piece[0] === "w" ? "wQ" : "bQ");
            else {
                setPromoteFromSquare(item.square);
                setPromoteToSquare(square);
                setShowPromoteDialog(true);
            }
        } else handleSetPosition(item.square, square, item.piece, true);
    }
    (0, $exYeM.useEffect)(()=>{
        if (squareRef.current) {
            const { x: x , y: y  } = squareRef.current.getBoundingClientRect();
            setSquares((oldSquares)=>Object.assign(Object.assign({}, oldSquares), {
                    [square]: {
                        x: x,
                        y: y
                    }
                }));
        }
    }, [
        boardWidth,
        boardOrientation
    ]);
    const defaultSquareStyle = Object.assign(Object.assign(Object.assign(Object.assign({}, $8f4069742e98d682$var$borderRadius(square, boardOrientation, customBoardStyle)), squareColor === "black" ? customDarkSquareStyle : customLightSquareStyle), squareHasPremove && (squareColor === "black" ? customPremoveDarkSquareStyle : customPremoveLightSquareStyle)), isOver && customDropSquareStyle);
    return (0, $7ead0b1397a835ed$exports.jsx)("div", Object.assign({
        ref: drop,
        style: defaultSquareStyle,
        "data-square-color": squareColor,
        "data-square": square,
        onTouchMove: (e)=>{
            var _a;
            // Handle touch events on tablet and mobile not covered by onMouseOver/onDragEnter
            const touchLocation = e.touches[0];
            const touchElement = document.elementsFromPoint(touchLocation.clientX, touchLocation.clientY);
            const draggedOverSquare = (_a = touchElement === null || touchElement === void 0 ? void 0 : touchElement.find((el)=>el.getAttribute("data-square"))) === null || _a === void 0 ? void 0 : _a.getAttribute("data-square");
            if (draggedOverSquare && draggedOverSquare !== lastSquareDraggedOver) {
                setLastSquareDraggedOver(draggedOverSquare);
                onDragOverSquare(draggedOverSquare);
            }
        },
        onMouseOver: (e)=>{
            // noop if moving from child of square into square.
            if (e.buttons === 2 && currentRightClickDown) drawNewArrow(currentRightClickDown, square);
            if (e.relatedTarget && e.currentTarget.contains(e.relatedTarget)) return;
            onMouseOverSquare(square);
        },
        onMouseOut: (e)=>{
            // noop if moving from square into a child of square.
            if (e.relatedTarget && e.currentTarget.contains(e.relatedTarget)) return;
            onMouseOutSquare(square);
        },
        onMouseDown: (e)=>{
            if (e.button === 2) onRightClickDown(square);
        },
        onMouseUp: (e)=>{
            if (e.button === 2) {
                if (currentRightClickDown) onArrowDrawEnd(currentRightClickDown, square);
                onRightClickUp(square);
            }
        },
        onDragEnter: ()=>onDragOverSquare(square),
        onClick: ()=>{
            const piece = currentPosition[square];
            onSquareClick(square, piece);
            clearArrows();
        },
        onContextMenu: (e)=>{
            e.preventDefault();
        }
    }, {
        children: typeof CustomSquare === "string" ? (0, $7ead0b1397a835ed$exports.jsx)(CustomSquare, Object.assign({
            // Type is too complex to properly evaluate, so ignore this line.
            // @ts-ignore
            ref: squareRef,
            style: Object.assign(Object.assign(Object.assign({}, $8f4069742e98d682$var$size(boardWidth)), $8f4069742e98d682$var$center), !squareHasPremove && (customSquareStyles === null || customSquareStyles === void 0 ? void 0 : customSquareStyles[square]))
        }, {
            children: children
        })) : (0, $7ead0b1397a835ed$exports.jsx)(CustomSquare, Object.assign({
            ref: squareRef,
            square: square,
            squareColor: squareColor,
            style: Object.assign(Object.assign(Object.assign({}, $8f4069742e98d682$var$size(boardWidth)), $8f4069742e98d682$var$center), !squareHasPremove && (customSquareStyles === null || customSquareStyles === void 0 ? void 0 : customSquareStyles[square]))
        }, {
            children: children
        }))
    }));
}
const $8f4069742e98d682$var$center = {
    display: "flex",
    justifyContent: "center"
};
const $8f4069742e98d682$var$size = (width)=>({
        width: width / 8,
        height: width / 8
    });
const $8f4069742e98d682$var$borderRadius = (square, boardOrientation, customBoardStyle)=>{
    if (!(customBoardStyle === null || customBoardStyle === void 0 ? void 0 : customBoardStyle.borderRadius)) return {};
    if (square === "a1") return boardOrientation === "white" ? {
        borderBottomLeftRadius: customBoardStyle.borderRadius
    } : {
        borderTopRightRadius: customBoardStyle.borderRadius
    };
    if (square === "a8") return boardOrientation === "white" ? {
        borderTopLeftRadius: customBoardStyle.borderRadius
    } : {
        borderBottomRightRadius: customBoardStyle.borderRadius
    };
    if (square === "h1") return boardOrientation === "white" ? {
        borderBottomRightRadius: customBoardStyle.borderRadius
    } : {
        borderTopLeftRadius: customBoardStyle.borderRadius
    };
    if (square === "h8") return boardOrientation === "white" ? {
        borderTopRightRadius: customBoardStyle.borderRadius
    } : {
        borderBottomLeftRadius: customBoardStyle.borderRadius
    };
    return {};
};
function $8f4069742e98d682$var$Squares() {
    const [squares, setSquares] = (0, $exYeM.useState)({});
    const { arePremovesAllowed: arePremovesAllowed , boardOrientation: boardOrientation , boardWidth: boardWidth , currentPosition: currentPosition , id: id , premoves: premoves , showBoardNotation: showBoardNotation  } = $8f4069742e98d682$var$useChessboard();
    const premovesHistory = (0, $exYeM.useMemo)(()=>{
        const result = [];
        // if premoves aren't allowed, don't waste time on calculations
        if (!arePremovesAllowed) return [];
        premoves.forEach((premove, index)=>{
            const { sourceSq: sourceSq , targetSq: targetSq , piece: piece  } = premove;
            // determine if the premove is made by an already premoved piece
            const relatedPremovedPiece = result.find((p)=>{
                var _a;
                return p.piece === piece && ((_a = p.premovesRoute.at(-1)) === null || _a === void 0 ? void 0 : _a.targetSq) === sourceSq;
            });
            // if premove has been made by already premoved piece then write the move to its `premovesRoute` field to be able find its final destination later
            if (relatedPremovedPiece) relatedPremovedPiece.premovesRoute.push({
                sourceSq: sourceSq,
                targetSq: targetSq,
                index: index
            });
            else result.push({
                piece: piece,
                // index is useful for scenarios where two or more pieces are targeting the same square
                premovesRoute: [
                    {
                        sourceSq: sourceSq,
                        targetSq: targetSq,
                        index: index
                    }
                ]
            });
        });
        return result;
    }, [
        premoves
    ]);
    return (0, $7ead0b1397a835ed$exports.jsx)("div", Object.assign({
        "data-boardid": id
    }, {
        children: [
            ...Array(8)
        ].map((_, r)=>{
            return (0, $7ead0b1397a835ed$exports.jsx)("div", Object.assign({
                style: {
                    display: "flex",
                    flexWrap: "nowrap",
                    width: boardWidth
                }
            }, {
                children: [
                    ...Array(8)
                ].map((_, c)=>{
                    const square = boardOrientation === "black" ? $8f4069742e98d682$var$COLUMNS[7 - c] + (r + 1) : $8f4069742e98d682$var$COLUMNS[c] + (8 - r);
                    const squareColor = c % 2 === r % 2 ? "white" : "black";
                    const squareHasPremove = premoves.find((p)=>p.sourceSq === square || p.targetSq === square);
                    const squareHasPremoveTarget = premovesHistory.filter(({ premovesRoute: premovesRoute  })=>{
                        var _a;
                        return ((_a = premovesRoute.at(-1)) === null || _a === void 0 ? void 0 : _a.targetSq) === square;
                    })//the premoved piece with the higher index will be shown, as it is the latest one
                    .sort((a, b)=>{
                        var _a, _b;
                        return ((_a = b.premovesRoute.at(-1)) === null || _a === void 0 ? void 0 : _a.index) - ((_b = a.premovesRoute.at(-1)) === null || _b === void 0 ? void 0 : _b.index);
                    }).at(0);
                    return (0, $7ead0b1397a835ed$exports.jsxs)($8f4069742e98d682$var$Square, Object.assign({
                        square: square,
                        squareColor: squareColor,
                        setSquares: setSquares,
                        squareHasPremove: !!squareHasPremove
                    }, {
                        children: [
                            !squareHasPremove && currentPosition[square] && (0, $7ead0b1397a835ed$exports.jsx)($8f4069742e98d682$var$Piece, {
                                piece: currentPosition[square],
                                square: square,
                                squares: squares
                            }),
                            squareHasPremoveTarget && (0, $7ead0b1397a835ed$exports.jsx)($8f4069742e98d682$var$Piece, {
                                isPremovedPiece: true,
                                piece: squareHasPremoveTarget.piece,
                                square: square,
                                squares: squares
                            }),
                            showBoardNotation && (0, $7ead0b1397a835ed$exports.jsx)($8f4069742e98d682$var$Notation, {
                                row: r,
                                col: c
                            })
                        ]
                    }), `${c}${r}`);
                })
            }), r.toString());
        })
    }));
}
const $8f4069742e98d682$var$Arrows = ()=>{
    const { arrows: arrows , newArrow: newArrow , boardOrientation: boardOrientation , boardWidth: boardWidth , customArrowColor: primaryArrowCollor  } = $8f4069742e98d682$var$useChessboard();
    const arrowsList = [
        ...arrows,
        newArrow
    ].filter(Boolean);
    return (0, $7ead0b1397a835ed$exports.jsx)("svg", Object.assign({
        width: boardWidth,
        height: boardWidth,
        style: {
            position: "absolute",
            top: "0",
            left: "0",
            pointerEvents: "none",
            zIndex: "10"
        }
    }, {
        children: arrowsList.map((arrow, i)=>{
            const [arrowStartField, arrowEndField, arrowColor] = arrow;
            if (arrowStartField === arrowEndField) return null;
            const from = $8f4069742e98d682$var$getRelativeCoords(boardOrientation, boardWidth, arrowStartField);
            const to = $8f4069742e98d682$var$getRelativeCoords(boardOrientation, boardWidth, arrowEndField);
            let ARROW_LENGTH_REDUCER = boardWidth / 32;
            const isArrowActive = i === arrows.length;
            // if there are different arrows targeting the same square make their length a bit shorter
            if (arrows.some((restArrow)=>restArrow[0] !== arrowStartField && restArrow[1] === arrowEndField) && !isArrowActive) ARROW_LENGTH_REDUCER = boardWidth / 16;
            const dx = to.x - from.x;
            const dy = to.y - from.y;
            const r = Math.hypot(dy, dx);
            const end = {
                x: from.x + dx * (r - ARROW_LENGTH_REDUCER) / r,
                y: from.y + dy * (r - ARROW_LENGTH_REDUCER) / r
            };
            return (0, $7ead0b1397a835ed$exports.jsxs)((0, $exYeM.Fragment), {
                children: [
                    (0, $7ead0b1397a835ed$exports.jsx)("marker", Object.assign({
                        id: `arrowhead-${i}`,
                        markerWidth: "2",
                        markerHeight: "2.5",
                        refX: "1.25",
                        refY: "1.25",
                        orient: "auto"
                    }, {
                        children: (0, $7ead0b1397a835ed$exports.jsx)("polygon", {
                            points: "0.3 0, 2 1.25, 0.3 2.5",
                            fill: arrowColor !== null && arrowColor !== void 0 ? arrowColor : primaryArrowCollor
                        })
                    })),
                    (0, $7ead0b1397a835ed$exports.jsx)("line", {
                        x1: from.x,
                        y1: from.y,
                        x2: end.x,
                        y2: end.y,
                        opacity: isArrowActive ? "0.5" : "0.65",
                        stroke: arrowColor !== null && arrowColor !== void 0 ? arrowColor : primaryArrowCollor,
                        strokeWidth: isArrowActive ? 0.9 * boardWidth / 40 : boardWidth / 40,
                        markerEnd: `url(#arrowhead-${i})`
                    })
                ]
            }, `${arrowStartField}-${arrowEndField}${isArrowActive ? "-active" : ""}`);
        })
    }));
};
function $8f4069742e98d682$var$PromotionOption({ option: option  }) {
    const [isHover, setIsHover] = (0, $exYeM.useState)(false);
    const { boardWidth: boardWidth , chessPieces: chessPieces , customDarkSquareStyle: customDarkSquareStyle , customLightSquareStyle: customLightSquareStyle , handleSetPosition: handleSetPosition , onPromotionPieceSelect: onPromotionPieceSelect , promoteFromSquare: promoteFromSquare , promoteToSquare: promoteToSquare , promotionDialogVariant: promotionDialogVariant  } = $8f4069742e98d682$var$useChessboard();
    const backgroundColor = ()=>{
        switch(option[1]){
            case "Q":
                return customDarkSquareStyle.backgroundColor;
            case "R":
                return customLightSquareStyle.backgroundColor;
            case "N":
                return promotionDialogVariant === "default" ? customLightSquareStyle.backgroundColor : customDarkSquareStyle.backgroundColor;
            case "B":
                return promotionDialogVariant === "default" ? customDarkSquareStyle.backgroundColor : customLightSquareStyle.backgroundColor;
        }
    };
    return (0, $7ead0b1397a835ed$exports.jsx)("div", Object.assign({
        onClick: ()=>{
            if (onPromotionPieceSelect(option, promoteFromSquare !== null && promoteFromSquare !== void 0 ? promoteFromSquare : undefined, promoteToSquare !== null && promoteToSquare !== void 0 ? promoteToSquare : undefined)) handleSetPosition(promoteFromSquare, promoteToSquare, option, true);
        },
        onMouseOver: ()=>setIsHover(true),
        onMouseOut: ()=>setIsHover(false),
        "data-piece": option,
        style: {
            cursor: "pointer",
            backgroundColor: isHover ? backgroundColor() : `${backgroundColor()}aa`,
            borderRadius: "4px",
            transition: "all 0.1s ease-out"
        }
    }, {
        children: typeof chessPieces[option] === "function" ? (0, $7ead0b1397a835ed$exports.jsx)("div", Object.assign({
            style: {
                transition: "all 0.1s ease-out",
                transform: isHover ? "scale(1)" : "scale(0.85)"
            }
        }, {
            children: chessPieces[option]({
                squareWidth: boardWidth / 8,
                isDragging: false
            })
        })) : (0, $7ead0b1397a835ed$exports.jsx)("svg", Object.assign({
            viewBox: "1 1 43 43",
            width: boardWidth / 8,
            height: boardWidth / 8,
            style: {
                transition: "all 0.1s ease-out",
                transform: isHover ? "scale(1)" : "scale(0.85)"
            }
        }, {
            children: (0, $7ead0b1397a835ed$exports.jsx)("g", {
                children: chessPieces[option]
            })
        }))
    }));
}
function $8f4069742e98d682$var$PromotionDialog() {
    const { boardOrientation: boardOrientation , boardWidth: boardWidth , promotionDialogVariant: promotionDialogVariant , promoteToSquare: promoteToSquare  } = $8f4069742e98d682$var$useChessboard();
    const promotePieceColor = (promoteToSquare === null || promoteToSquare === void 0 ? void 0 : promoteToSquare[1]) === "1" ? "b" : "w";
    const promotionOptions = [
        `${promotePieceColor !== null && promotePieceColor !== void 0 ? promotePieceColor : "w"}Q`,
        `${promotePieceColor !== null && promotePieceColor !== void 0 ? promotePieceColor : "w"}R`,
        `${promotePieceColor !== null && promotePieceColor !== void 0 ? promotePieceColor : "w"}N`,
        `${promotePieceColor !== null && promotePieceColor !== void 0 ? promotePieceColor : "w"}B`
    ];
    const dialogStyles = {
        default: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            transform: `translate(${-boardWidth / 8}px, ${-boardWidth / 8}px)`
        },
        vertical: {
            transform: `translate(${-boardWidth / 16}px, ${-boardWidth / 16}px)`
        },
        modal: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transform: `translate(0px, ${3 * boardWidth / 8}px)`,
            width: "100%",
            height: `${boardWidth / 4}px`,
            top: 0,
            backgroundColor: "white",
            left: 0
        }
    };
    const dialogCoords = $8f4069742e98d682$var$getRelativeCoords(boardOrientation, boardWidth, promoteToSquare || "a8");
    return (0, $7ead0b1397a835ed$exports.jsx)("div", Object.assign({
        style: Object.assign({
            position: "absolute",
            top: `${dialogCoords === null || dialogCoords === void 0 ? void 0 : dialogCoords.y}px`,
            left: `${dialogCoords === null || dialogCoords === void 0 ? void 0 : dialogCoords.x}px`,
            zIndex: 1000
        }, dialogStyles[promotionDialogVariant]),
        title: "Choose promotion piece"
    }, {
        children: promotionOptions.map((option)=>(0, $7ead0b1397a835ed$exports.jsx)($8f4069742e98d682$var$PromotionOption, {
                option: option
            }, option))
    }));
}
const $8f4069742e98d682$var$errorImage = {
    whiteKing: (0, $7ead0b1397a835ed$exports.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        style: {
            shapeRendering: "geometricPrecision",
            textRendering: "geometricPrecision",
            imageRendering: "crisp-edges"
        },
        viewBox: "0 0 4210 12970",
        x: "0px",
        y: "0px",
        fillRule: "evenodd",
        clipRule: "evenodd",
        width: "250",
        height: "250"
    }, {
        children: (0, $7ead0b1397a835ed$exports.jsx)("g", {
            children: (0, $7ead0b1397a835ed$exports.jsx)("path", {
                style: {
                    fill: "black",
                    fillRule: "nonzero"
                },
                d: "M2105 0c169,0 286,160 249,315l200 0c-172,266 -231,479 -256,792 315,-24 530,-86 792,-255l0 897c-265,-171 -479,-231 -792,-256 18,234 75,495 185,682l339 0c233,0 369,269 225,456l545 0 -595 1916c130,94 158,275 59,402 465,0 416,568 51,568l-334 0 465 2867 332 0c250,0 381,306 199,485 162,63 273,220 273,399l0 633 168 0 0 475c-1403,0 -2807,0 -4210,0l0 -475 167 0 0 -633c0,-179 112,-336 274,-399 -181,-178 -52,-485 199,-485l332 0 465 -2867 -335 0c-353,0 -418,-568 51,-568 -98,-127 -70,-308 59,-402l-594 -1916c181,0 363,0 545,0 -144,-187 -9,-456 225,-456l339 0c110,-187 167,-448 185,-682 -315,25 -530,87 -793,256l0 -897c266,171 480,231 793,255 -25,-315 -87,-529 -256,-792l199 0c-36,-155 81,-315 250,-315zm-1994 10012l0 253 3988 0 0 -253c-1330,0 -2659,0 -3988,0zm484 -1060c-174,0 -316,142 -316,316l0 633 3652 0 0 -633c0,-174 -142,-316 -316,-316 -1007,0 -2013,0 -3020,0zm45 -457c-230,0 -225,345 0,345l2930 0c230,0 225,-345 0,-345 -977,0 -1953,0 -2930,0zm2020 -2978l-1111 0 -465 2867 2041 0 -465 -2867zm-1558 -456c-229,0 -224,345 0,345 669,0 1337,0 2005,0 230,0 225,-345 0,-345 -668,0 -1336,0 -2005,0zm1730 -457l-1454 0c-229,0 -224,345 0,345l1454 0c229,0 224,-345 0,-345zm-2064 -1862l544 1751c529,0 1057,0 1586,0l544 -1751c-892,0 -1783,0 -2674,0zm1085 -567l504 0c-126,-247 -163,-526 -177,-800 273,15 553,52 800,177l0 -504c-247,126 -527,163 -800,177 14,-273 51,-552 177,-799 -168,0 -336,0 -504,0 125,247 162,526 177,799 -274,-14 -553,-51 -800,-177l0 504c247,-125 527,-162 800,-177 -15,274 -52,553 -177,800zm969 111l-1434 0c-230,0 -225,345 0,345l1434 0c230,0 225,-345 0,-345zm-717 -2175c-105,0 -175,109 -133,204l266 0c42,-96 -30,-205 -133,-204z"
            })
        })
    }))
};
function $8f4069742e98d682$var$ErrorBoundary({ children: children  }) {
    try {
        return (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
            children: children
        });
    } catch (error) {
        console.log(error);
        return (0, $7ead0b1397a835ed$exports.jsx)($8f4069742e98d682$var$WhiteKing, {
            showError: true
        });
    }
}
function $8f4069742e98d682$var$WhiteKing({ showError: showError = false  }) {
    return (0, $7ead0b1397a835ed$exports.jsxs)("div", Object.assign({
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
        }
    }, {
        children: [
            (0, $7ead0b1397a835ed$exports.jsx)("div", Object.assign({
                style: {
                    width: 250,
                    height: 250,
                    transform: "rotate(90deg)"
                }
            }, {
                children: $8f4069742e98d682$var$errorImage.whiteKing
            })),
            showError && (0, $7ead0b1397a835ed$exports.jsx)("h1", {
                children: "Something went wrong"
            })
        ]
    }));
}
function $8f4069742e98d682$var$Board() {
    const boardRef = (0, $exYeM.useRef)(null);
    const { boardWidth: boardWidth , clearCurrentRightClickDown: clearCurrentRightClickDown , onPromotionPieceSelect: onPromotionPieceSelect , setShowPromoteDialog: setShowPromoteDialog , showPromoteDialog: showPromoteDialog , customBoardStyle: customBoardStyle  } = $8f4069742e98d682$var$useChessboard();
    (0, $exYeM.useEffect)(()=>{
        function handleClickOutside(event) {
            if (boardRef.current && !boardRef.current.contains(event.target)) clearCurrentRightClickDown();
        }
        document.addEventListener("mouseup", handleClickOutside);
        return ()=>{
            document.removeEventListener("mouseup", handleClickOutside);
        };
    }, []);
    return boardWidth ? (0, $7ead0b1397a835ed$exports.jsx)("div", Object.assign({
        style: {
            perspective: "1000px"
        }
    }, {
        children: (0, $7ead0b1397a835ed$exports.jsxs)("div", Object.assign({
            ref: boardRef,
            style: Object.assign(Object.assign({
                position: "relative"
            }, $8f4069742e98d682$var$boardStyles(boardWidth)), customBoardStyle)
        }, {
            children: [
                (0, $7ead0b1397a835ed$exports.jsx)($8f4069742e98d682$var$Squares, {}),
                (0, $7ead0b1397a835ed$exports.jsx)($8f4069742e98d682$var$Arrows, {}),
                showPromoteDialog && (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                    children: [
                        (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            onClick: ()=>{
                                setShowPromoteDialog(false);
                                onPromotionPieceSelect === null || onPromotionPieceSelect === void 0 || onPromotionPieceSelect();
                            },
                            style: {
                                position: "absolute",
                                top: "0",
                                left: "0",
                                zIndex: "100",
                                backgroundColor: "rgba(22,21,18,.7)",
                                width: boardWidth,
                                height: boardWidth
                            }
                        }),
                        (0, $7ead0b1397a835ed$exports.jsx)($8f4069742e98d682$var$PromotionDialog, {})
                    ]
                })
            ]
        }))
    })) : (0, $7ead0b1397a835ed$exports.jsx)($8f4069742e98d682$var$WhiteKing, {});
}
const $8f4069742e98d682$var$boardStyles = (width)=>({
        cursor: "default",
        height: width,
        width: width
    });
var $8f4069742e98d682$var$ListenerType;
(function(ListenerType) {
    ListenerType["mouse"] = "mouse";
    ListenerType["touch"] = "touch";
    ListenerType["keyboard"] = "keyboard";
})($8f4069742e98d682$var$ListenerType || ($8f4069742e98d682$var$ListenerType = {}));
class $8f4069742e98d682$var$OptionsReader {
    get delay() {
        var _delay;
        return (_delay = this.args.delay) !== null && _delay !== void 0 ? _delay : 0;
    }
    get scrollAngleRanges() {
        return this.args.scrollAngleRanges;
    }
    get getDropTargetElementsAtPoint() {
        return this.args.getDropTargetElementsAtPoint;
    }
    get ignoreContextMenu() {
        var _ignoreContextMenu;
        return (_ignoreContextMenu = this.args.ignoreContextMenu) !== null && _ignoreContextMenu !== void 0 ? _ignoreContextMenu : false;
    }
    get enableHoverOutsideTarget() {
        var _enableHoverOutsideTarget;
        return (_enableHoverOutsideTarget = this.args.enableHoverOutsideTarget) !== null && _enableHoverOutsideTarget !== void 0 ? _enableHoverOutsideTarget : false;
    }
    get enableKeyboardEvents() {
        var _enableKeyboardEvents;
        return (_enableKeyboardEvents = this.args.enableKeyboardEvents) !== null && _enableKeyboardEvents !== void 0 ? _enableKeyboardEvents : false;
    }
    get enableMouseEvents() {
        var _enableMouseEvents;
        return (_enableMouseEvents = this.args.enableMouseEvents) !== null && _enableMouseEvents !== void 0 ? _enableMouseEvents : false;
    }
    get enableTouchEvents() {
        var _enableTouchEvents;
        return (_enableTouchEvents = this.args.enableTouchEvents) !== null && _enableTouchEvents !== void 0 ? _enableTouchEvents : true;
    }
    get touchSlop() {
        return this.args.touchSlop || 0;
    }
    get delayTouchStart() {
        var ref, ref1;
        var ref2, ref3;
        return (ref3 = (ref2 = (ref = this.args) === null || ref === void 0 ? void 0 : ref.delayTouchStart) !== null && ref2 !== void 0 ? ref2 : (ref1 = this.args) === null || ref1 === void 0 ? void 0 : ref1.delay) !== null && ref3 !== void 0 ? ref3 : 0;
    }
    get delayMouseStart() {
        var ref, ref4;
        var ref5, ref6;
        return (ref6 = (ref5 = (ref = this.args) === null || ref === void 0 ? void 0 : ref.delayMouseStart) !== null && ref5 !== void 0 ? ref5 : (ref4 = this.args) === null || ref4 === void 0 ? void 0 : ref4.delay) !== null && ref6 !== void 0 ? ref6 : 0;
    }
    get window() {
        if (this.context && this.context.window) return this.context.window;
        else if (typeof window !== "undefined") return window;
        return undefined;
    }
    get document() {
        var ref;
        if ((ref = this.context) === null || ref === void 0 ? void 0 : ref.document) return this.context.document;
        if (this.window) return this.window.document;
        return undefined;
    }
    get rootElement() {
        var ref;
        return ((ref = this.args) === null || ref === void 0 ? void 0 : ref.rootElement) || this.document;
    }
    constructor(args, context){
        this.args = args;
        this.context = context;
    }
}
function $8f4069742e98d682$var$distance(x1, y1, x2, y2) {
    return Math.sqrt(Math.pow(Math.abs(x2 - x1), 2) + Math.pow(Math.abs(y2 - y1), 2));
}
function $8f4069742e98d682$var$inAngleRanges(x1, y1, x2, y2, angleRanges) {
    if (!angleRanges) return false;
    const angle = Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI + 180;
    for(let i = 0; i < angleRanges.length; ++i){
        const ar = angleRanges[i];
        if (ar && (ar.start == null || angle >= ar.start) && (ar.end == null || angle <= ar.end)) return true;
    }
    return false;
}
// Used for MouseEvent.buttons (note the s on the end).
const $8f4069742e98d682$var$MouseButtons = {
    Left: 1,
    Right: 2,
    Center: 4
};
// Used for e.button (note the lack of an s on the end).
const $8f4069742e98d682$var$MouseButton = {
    Left: 0,
    Center: 1,
    Right: 2
};
/**
 * Only touch events and mouse events where the left button is pressed should initiate a drag.
 * @param {MouseEvent | TouchEvent} e The event
 */ function $8f4069742e98d682$var$eventShouldStartDrag(e) {
    // For touch events, button will be undefined. If e.button is defined,
    // then it should be MouseButton.Left.
    return e.button === undefined || e.button === $8f4069742e98d682$var$MouseButton.Left;
}
/**
 * Only touch events and mouse events where the left mouse button is no longer held should end a drag.
 * It's possible the user mouse downs with the left mouse button, then mouse down and ups with the right mouse button.
 * We don't want releasing the right mouse button to end the drag.
 * @param {MouseEvent | TouchEvent} e The event
 */ function $8f4069742e98d682$var$eventShouldEndDrag(e) {
    // Touch events will have buttons be undefined, while mouse events will have e.buttons's left button
    // bit field unset if the left mouse button has been released
    return e.buttons === undefined || (e.buttons & $8f4069742e98d682$var$MouseButtons.Left) === 0;
}
function $8f4069742e98d682$var$isTouchEvent(e) {
    return !!e.targetTouches;
}
const $8f4069742e98d682$var$ELEMENT_NODE = 1;
function $8f4069742e98d682$var$getNodeClientOffset(node) {
    const el = node.nodeType === $8f4069742e98d682$var$ELEMENT_NODE ? node : node.parentElement;
    if (!el) return undefined;
    const { top: top , left: left  } = el.getBoundingClientRect();
    return {
        x: left,
        y: top
    };
}
function $8f4069742e98d682$var$getEventClientTouchOffset(e, lastTargetTouchFallback) {
    if (e.targetTouches.length === 1) return $8f4069742e98d682$var$getEventClientOffset(e.targetTouches[0]);
    else if (lastTargetTouchFallback && e.touches.length === 1) {
        if (e.touches[0].target === lastTargetTouchFallback.target) return $8f4069742e98d682$var$getEventClientOffset(e.touches[0]);
    }
    return;
}
function $8f4069742e98d682$var$getEventClientOffset(e, lastTargetTouchFallback) {
    if ($8f4069742e98d682$var$isTouchEvent(e)) return $8f4069742e98d682$var$getEventClientTouchOffset(e, lastTargetTouchFallback);
    else return {
        x: e.clientX,
        y: e.clientY
    };
}
const $8f4069742e98d682$var$supportsPassive = (()=>{
    // simular to jQuery's test
    let supported = false;
    try {
        addEventListener("test", ()=>{
        // do nothing
        }, Object.defineProperty({}, "passive", {
            get () {
                supported = true;
                return true;
            }
        }));
    } catch (e) {
    // do nothing
    }
    return supported;
})();
const $8f4069742e98d682$var$eventNames = {
    [$8f4069742e98d682$var$ListenerType.mouse]: {
        start: "mousedown",
        move: "mousemove",
        end: "mouseup",
        contextmenu: "contextmenu"
    },
    [$8f4069742e98d682$var$ListenerType.touch]: {
        start: "touchstart",
        move: "touchmove",
        end: "touchend"
    },
    [$8f4069742e98d682$var$ListenerType.keyboard]: {
        keydown: "keydown"
    }
};
class $8f4069742e98d682$var$TouchBackendImpl {
    /**
	 * Generate profiling statistics for the HTML5Backend.
	 */ profile() {
        var ref;
        return {
            sourceNodes: this.sourceNodes.size,
            sourcePreviewNodes: this.sourcePreviewNodes.size,
            sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
            targetNodes: this.targetNodes.size,
            dragOverTargetIds: ((ref = this.dragOverTargetIds) === null || ref === void 0 ? void 0 : ref.length) || 0
        };
    }
    // public for test
    get document() {
        return this.options.document;
    }
    setup() {
        const root = this.options.rootElement;
        if (!root) return;
        $8f4069742e98d682$var$invariant(!$8f4069742e98d682$var$TouchBackendImpl.isSetUp, "Cannot have two Touch backends at the same time.");
        $8f4069742e98d682$var$TouchBackendImpl.isSetUp = true;
        this.addEventListener(root, "start", this.getTopMoveStartHandler());
        this.addEventListener(root, "start", this.handleTopMoveStartCapture, true);
        this.addEventListener(root, "move", this.handleTopMove);
        this.addEventListener(root, "move", this.handleTopMoveCapture, true);
        this.addEventListener(root, "end", this.handleTopMoveEndCapture, true);
        if (this.options.enableMouseEvents && !this.options.ignoreContextMenu) this.addEventListener(root, "contextmenu", this.handleTopMoveEndCapture);
        if (this.options.enableKeyboardEvents) this.addEventListener(root, "keydown", this.handleCancelOnEscape, true);
    }
    teardown() {
        const root = this.options.rootElement;
        if (!root) return;
        $8f4069742e98d682$var$TouchBackendImpl.isSetUp = false;
        this._mouseClientOffset = {};
        this.removeEventListener(root, "start", this.handleTopMoveStartCapture, true);
        this.removeEventListener(root, "start", this.handleTopMoveStart);
        this.removeEventListener(root, "move", this.handleTopMoveCapture, true);
        this.removeEventListener(root, "move", this.handleTopMove);
        this.removeEventListener(root, "end", this.handleTopMoveEndCapture, true);
        if (this.options.enableMouseEvents && !this.options.ignoreContextMenu) this.removeEventListener(root, "contextmenu", this.handleTopMoveEndCapture);
        if (this.options.enableKeyboardEvents) this.removeEventListener(root, "keydown", this.handleCancelOnEscape, true);
        this.uninstallSourceNodeRemovalObserver();
    }
    addEventListener(subject, event, handler, capture = false) {
        const options = $8f4069742e98d682$var$supportsPassive ? {
            capture: capture,
            passive: false
        } : capture;
        this.listenerTypes.forEach(function(listenerType) {
            const evt = $8f4069742e98d682$var$eventNames[listenerType][event];
            if (evt) subject.addEventListener(evt, handler, options);
        });
    }
    removeEventListener(subject, event, handler, capture = false) {
        const options = $8f4069742e98d682$var$supportsPassive ? {
            capture: capture,
            passive: false
        } : capture;
        this.listenerTypes.forEach(function(listenerType) {
            const evt = $8f4069742e98d682$var$eventNames[listenerType][event];
            if (evt) subject.removeEventListener(evt, handler, options);
        });
    }
    connectDragSource(sourceId, node) {
        const handleMoveStart = this.handleMoveStart.bind(this, sourceId);
        this.sourceNodes.set(sourceId, node);
        this.addEventListener(node, "start", handleMoveStart);
        return ()=>{
            this.sourceNodes.delete(sourceId);
            this.removeEventListener(node, "start", handleMoveStart);
        };
    }
    connectDragPreview(sourceId, node, options) {
        this.sourcePreviewNodeOptions.set(sourceId, options);
        this.sourcePreviewNodes.set(sourceId, node);
        return ()=>{
            this.sourcePreviewNodes.delete(sourceId);
            this.sourcePreviewNodeOptions.delete(sourceId);
        };
    }
    connectDropTarget(targetId, node) {
        const root = this.options.rootElement;
        if (!this.document || !root) return ()=>{
        /* noop */ };
        const handleMove = (e)=>{
            if (!this.document || !root || !this.monitor.isDragging()) return;
            let coords;
            /**
			 * Grab the coordinates for the current mouse/touch position
			 */ switch(e.type){
                case $8f4069742e98d682$var$eventNames.mouse.move:
                    coords = {
                        x: e.clientX,
                        y: e.clientY
                    };
                    break;
                case $8f4069742e98d682$var$eventNames.touch.move:
                    var ref, ref1;
                    coords = {
                        x: ((ref = e.touches[0]) === null || ref === void 0 ? void 0 : ref.clientX) || 0,
                        y: ((ref1 = e.touches[0]) === null || ref1 === void 0 ? void 0 : ref1.clientY) || 0
                    };
                    break;
            }
            /**
			 * Use the coordinates to grab the element the drag ended on.
			 * If the element is the same as the target node (or any of it's children) then we have hit a drop target and can handle the move.
			 */ const droppedOn = coords != null ? this.document.elementFromPoint(coords.x, coords.y) : undefined;
            const childMatch = droppedOn && node.contains(droppedOn);
            if (droppedOn === node || childMatch) return this.handleMove(e, targetId);
        };
        /**
		 * Attaching the event listener to the body so that touchmove will work while dragging over multiple target elements.
		 */ this.addEventListener(this.document.body, "move", handleMove);
        this.targetNodes.set(targetId, node);
        return ()=>{
            if (this.document) {
                this.targetNodes.delete(targetId);
                this.removeEventListener(this.document.body, "move", handleMove);
            }
        };
    }
    getTopMoveStartHandler() {
        if (!this.options.delayTouchStart && !this.options.delayMouseStart) return this.handleTopMoveStart;
        return this.handleTopMoveStartDelay;
    }
    installSourceNodeRemovalObserver(node) {
        this.uninstallSourceNodeRemovalObserver();
        this.draggedSourceNode = node;
        this.draggedSourceNodeRemovalObserver = new MutationObserver(()=>{
            if (node && !node.parentElement) {
                this.resurrectSourceNode();
                this.uninstallSourceNodeRemovalObserver();
            }
        });
        if (!node || !node.parentElement) return;
        this.draggedSourceNodeRemovalObserver.observe(node.parentElement, {
            childList: true
        });
    }
    resurrectSourceNode() {
        if (this.document && this.draggedSourceNode) {
            this.draggedSourceNode.style.display = "none";
            this.draggedSourceNode.removeAttribute("data-reactid");
            this.document.body.appendChild(this.draggedSourceNode);
        }
    }
    uninstallSourceNodeRemovalObserver() {
        if (this.draggedSourceNodeRemovalObserver) this.draggedSourceNodeRemovalObserver.disconnect();
        this.draggedSourceNodeRemovalObserver = undefined;
        this.draggedSourceNode = undefined;
    }
    constructor(manager, context, options){
        this.getSourceClientOffset = (sourceId)=>{
            const element = this.sourceNodes.get(sourceId);
            return element && $8f4069742e98d682$var$getNodeClientOffset(element);
        };
        this.handleTopMoveStartCapture = (e)=>{
            if (!$8f4069742e98d682$var$eventShouldStartDrag(e)) return;
            this.moveStartSourceIds = [];
        };
        this.handleMoveStart = (sourceId)=>{
            // Just because we received an event doesn't necessarily mean we need to collect drag sources.
            // We only collect start collecting drag sources on touch and left mouse events.
            if (Array.isArray(this.moveStartSourceIds)) this.moveStartSourceIds.unshift(sourceId);
        };
        this.handleTopMoveStart = (e)=>{
            if (!$8f4069742e98d682$var$eventShouldStartDrag(e)) return;
            // Don't prematurely preventDefault() here since it might:
            // 1. Mess up scrolling
            // 2. Mess up long tap (which brings up context menu)
            // 3. If there's an anchor link as a child, tap won't be triggered on link
            const clientOffset = $8f4069742e98d682$var$getEventClientOffset(e);
            if (clientOffset) {
                if ($8f4069742e98d682$var$isTouchEvent(e)) this.lastTargetTouchFallback = e.targetTouches[0];
                this._mouseClientOffset = clientOffset;
            }
            this.waitingForDelay = false;
        };
        this.handleTopMoveStartDelay = (e)=>{
            if (!$8f4069742e98d682$var$eventShouldStartDrag(e)) return;
            const delay = e.type === $8f4069742e98d682$var$eventNames.touch.start ? this.options.delayTouchStart : this.options.delayMouseStart;
            this.timeout = setTimeout(this.handleTopMoveStart.bind(this, e), delay);
            this.waitingForDelay = true;
        };
        this.handleTopMoveCapture = ()=>{
            this.dragOverTargetIds = [];
        };
        this.handleMove = (_evt, targetId)=>{
            if (this.dragOverTargetIds) this.dragOverTargetIds.unshift(targetId);
        };
        this.handleTopMove = (e1)=>{
            if (this.timeout) clearTimeout(this.timeout);
            if (!this.document || this.waitingForDelay) return;
            const { moveStartSourceIds: moveStartSourceIds , dragOverTargetIds: dragOverTargetIds  } = this;
            const enableHoverOutsideTarget = this.options.enableHoverOutsideTarget;
            const clientOffset = $8f4069742e98d682$var$getEventClientOffset(e1, this.lastTargetTouchFallback);
            if (!clientOffset) return;
            // If the touch move started as a scroll, or is is between the scroll angles
            if (this._isScrolling || !this.monitor.isDragging() && $8f4069742e98d682$var$inAngleRanges(this._mouseClientOffset.x || 0, this._mouseClientOffset.y || 0, clientOffset.x, clientOffset.y, this.options.scrollAngleRanges)) {
                this._isScrolling = true;
                return;
            }
            // If we're not dragging and we've moved a little, that counts as a drag start
            if (!this.monitor.isDragging() && // eslint-disable-next-line no-prototype-builtins
            this._mouseClientOffset.hasOwnProperty("x") && moveStartSourceIds && $8f4069742e98d682$var$distance(this._mouseClientOffset.x || 0, this._mouseClientOffset.y || 0, clientOffset.x, clientOffset.y) > (this.options.touchSlop ? this.options.touchSlop : 0)) {
                this.moveStartSourceIds = undefined;
                this.actions.beginDrag(moveStartSourceIds, {
                    clientOffset: this._mouseClientOffset,
                    getSourceClientOffset: this.getSourceClientOffset,
                    publishSource: false
                });
            }
            if (!this.monitor.isDragging()) return;
            const sourceNode = this.sourceNodes.get(this.monitor.getSourceId());
            this.installSourceNodeRemovalObserver(sourceNode);
            this.actions.publishDragSource();
            if (e1.cancelable) e1.preventDefault();
            // Get the node elements of the hovered DropTargets
            const dragOverTargetNodes = (dragOverTargetIds || []).map((key)=>this.targetNodes.get(key)).filter((e)=>!!e);
            // Get the a ordered list of nodes that are touched by
            const elementsAtPoint = this.options.getDropTargetElementsAtPoint ? this.options.getDropTargetElementsAtPoint(clientOffset.x, clientOffset.y, dragOverTargetNodes) : this.document.elementsFromPoint(clientOffset.x, clientOffset.y);
            // Extend list with parents that are not receiving elementsFromPoint events (size 0 elements and svg groups)
            const elementsAtPointExtended = [];
            for(const nodeId in elementsAtPoint){
                // eslint-disable-next-line no-prototype-builtins
                if (!elementsAtPoint.hasOwnProperty(nodeId)) continue;
                let currentNode = elementsAtPoint[nodeId];
                if (currentNode != null) elementsAtPointExtended.push(currentNode);
                while(currentNode){
                    currentNode = currentNode.parentElement;
                    if (currentNode && elementsAtPointExtended.indexOf(currentNode) === -1) elementsAtPointExtended.push(currentNode);
                }
            }
            const orderedDragOverTargetIds = elementsAtPointExtended // Filter off nodes that arent a hovered DropTargets nodes
            .filter((node)=>dragOverTargetNodes.indexOf(node) > -1) // Map back the nodes elements to targetIds
            .map((node)=>this._getDropTargetId(node)) // Filter off possible null rows
            .filter((node)=>!!node).filter((id, index, ids)=>ids.indexOf(id) === index);
            // Invoke hover for drop targets when source node is still over and pointer is outside
            if (enableHoverOutsideTarget) for(const targetId in this.targetNodes){
                const targetNode = this.targetNodes.get(targetId);
                if (sourceNode && targetNode && targetNode.contains(sourceNode) && orderedDragOverTargetIds.indexOf(targetId) === -1) {
                    orderedDragOverTargetIds.unshift(targetId);
                    break;
                }
            }
            // Reverse order because dnd-core reverse it before calling the DropTarget drop methods
            orderedDragOverTargetIds.reverse();
            this.actions.hover(orderedDragOverTargetIds, {
                clientOffset: clientOffset
            });
        };
        /**
	 *
	 * visible for testing
	 */ this._getDropTargetId = (node)=>{
            const keys = this.targetNodes.keys();
            let next = keys.next();
            while(next.done === false){
                const targetId = next.value;
                if (node === this.targetNodes.get(targetId)) return targetId;
                else next = keys.next();
            }
            return undefined;
        };
        this.handleTopMoveEndCapture = (e)=>{
            this._isScrolling = false;
            this.lastTargetTouchFallback = undefined;
            if (!$8f4069742e98d682$var$eventShouldEndDrag(e)) return;
            if (!this.monitor.isDragging() || this.monitor.didDrop()) {
                this.moveStartSourceIds = undefined;
                return;
            }
            if (e.cancelable) e.preventDefault();
            this._mouseClientOffset = {};
            this.uninstallSourceNodeRemovalObserver();
            this.actions.drop();
            this.actions.endDrag();
        };
        this.handleCancelOnEscape = (e)=>{
            if (e.key === "Escape" && this.monitor.isDragging()) {
                this._mouseClientOffset = {};
                this.uninstallSourceNodeRemovalObserver();
                this.actions.endDrag();
            }
        };
        this.options = new $8f4069742e98d682$var$OptionsReader(options, context);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.sourceNodes = new Map();
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.targetNodes = new Map();
        this.listenerTypes = [];
        this._mouseClientOffset = {};
        this._isScrolling = false;
        if (this.options.enableMouseEvents) this.listenerTypes.push($8f4069742e98d682$var$ListenerType.mouse);
        if (this.options.enableTouchEvents) this.listenerTypes.push($8f4069742e98d682$var$ListenerType.touch);
        if (this.options.enableKeyboardEvents) this.listenerTypes.push($8f4069742e98d682$var$ListenerType.keyboard);
    }
}
const $8f4069742e98d682$var$TouchBackend = function createBackend(manager, context = {}, options = {}) {
    return new $8f4069742e98d682$var$TouchBackendImpl(manager, context, options);
};
const $8f4069742e98d682$var$ChessboardDnDContext = (0, $exYeM.createContext)({
    isCustomDndProviderSet: false
});
const $8f4069742e98d682$var$EmptyProvider = ({ children: children  })=>{
    return (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: children
    });
};
const $8f4069742e98d682$export$5058efb00df7de8c = ({ children: children , backend: backend , context: context , options: options , debugMode: debugMode  })=>{
    return (0, $7ead0b1397a835ed$exports.jsx)($8f4069742e98d682$var$ChessboardDnDContext.Provider, Object.assign({
        value: {
            isCustomDndProviderSet: true
        }
    }, {
        children: (0, $7ead0b1397a835ed$exports.jsx)($8f4069742e98d682$var$DndProvider, Object.assign({
            backend: backend || ("ontouchstart" in window ? $8f4069742e98d682$var$TouchBackend : $8f4069742e98d682$var$HTML5Backend),
            context: context,
            options: options,
            debugMode: debugMode !== null && debugMode !== void 0 ? debugMode : false
        }, {
            children: children
        }))
    }));
};
const $8f4069742e98d682$var$ChessboardDnDRoot = ({ customDndBackend: customDndBackend , customDndBackendOptions: customDndBackendOptions , children: children  })=>{
    const [clientWindow, setClientWindow] = (0, $exYeM.useState)();
    const [backendSet, setBackendSet] = (0, $exYeM.useState)(false);
    const [isMobile, setIsMobile] = (0, $exYeM.useState)(false);
    const { isCustomDndProviderSet: isCustomDndProviderSet  } = (0, $exYeM.useContext)($8f4069742e98d682$var$ChessboardDnDContext);
    (0, $exYeM.useEffect)(()=>{
        setIsMobile("ontouchstart" in window);
        setBackendSet(true);
        setClientWindow(window);
    }, []);
    // in case we already wrapped `<Chessboard/>`  with `<DnDProvider/>` we don't need to create a new one
    const DnDWrapper = isCustomDndProviderSet ? $8f4069742e98d682$var$EmptyProvider : $8f4069742e98d682$var$DndProvider;
    if (!backendSet) return null;
    return clientWindow ? (0, $7ead0b1397a835ed$exports.jsx)(DnDWrapper, Object.assign({
        backend: customDndBackend || (isMobile ? $8f4069742e98d682$var$TouchBackend : $8f4069742e98d682$var$HTML5Backend),
        context: clientWindow,
        options: customDndBackend ? customDndBackendOptions : undefined
    }, {
        children: children
    })) : (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: children
    });
};
function $8f4069742e98d682$var$CustomDragLayer({ boardContainer: boardContainer  }) {
    const { boardWidth: boardWidth , chessPieces: chessPieces , id: id , snapToCursor: snapToCursor , allowDragOutsideBoard: allowDragOutsideBoard  } = $8f4069742e98d682$var$useChessboard();
    const collectedProps = $8f4069742e98d682$var$useDragLayer((monitor)=>({
            item: monitor.getItem(),
            clientOffset: monitor.getClientOffset(),
            sourceClientOffset: monitor.getSourceClientOffset(),
            isDragging: monitor.isDragging()
        }));
    const { isDragging: isDragging , item: item , clientOffset: clientOffset , sourceClientOffset: sourceClientOffset  } = collectedProps;
    const getItemStyle = (0, $exYeM.useCallback)((clientOffset, sourceClientOffset)=>{
        if (!clientOffset || !sourceClientOffset) return {
            display: "none"
        };
        let { x: x , y: y  } = snapToCursor ? clientOffset : sourceClientOffset;
        const halfSquareWidth = boardWidth / 8 / 2;
        if (snapToCursor) {
            x -= halfSquareWidth;
            y -= halfSquareWidth;
        }
        if (!allowDragOutsideBoard) {
            const { left: left , top: top  } = boardContainer;
            // half square so the piece reaches the board
            const maxLeft = left - halfSquareWidth;
            const maxTop = top - halfSquareWidth;
            const maxRight = left + boardWidth - halfSquareWidth;
            const maxBottom = top + boardWidth - halfSquareWidth;
            x = Math.max(maxLeft, Math.min(x, maxRight));
            y = Math.max(maxTop, Math.min(y, maxBottom));
        }
        const transform = `translate(${x}px, ${y}px)`;
        return {
            transform: transform,
            WebkitTransform: transform,
            touchAction: "none"
        };
    }, [
        boardWidth,
        allowDragOutsideBoard,
        snapToCursor,
        boardContainer
    ]);
    return isDragging && item.id === id ? (0, $7ead0b1397a835ed$exports.jsx)("div", Object.assign({
        style: {
            position: "fixed",
            pointerEvents: "none",
            zIndex: 10,
            left: 0,
            top: 0
        }
    }, {
        children: (0, $7ead0b1397a835ed$exports.jsx)("div", Object.assign({
            style: getItemStyle(clientOffset, sourceClientOffset)
        }, {
            children: typeof chessPieces[item.piece] === "function" ? chessPieces[item.piece]({
                squareWidth: boardWidth / 8,
                isDragging: true
            }) : (0, $7ead0b1397a835ed$exports.jsx)("svg", Object.assign({
                viewBox: "1 1 43 43",
                width: boardWidth / 8,
                height: boardWidth / 8
            }, {
                children: (0, $7ead0b1397a835ed$exports.jsx)("g", {
                    children: chessPieces[item.piece]
                })
            }))
        }))
    })) : null;
}
const $8f4069742e98d682$export$10d0f5ecf473d343 = ({ piece: piece , width: width , customPieceJSX: customPieceJSX , dndId: dndId  })=>{
    const renderPiece = customPieceJSX !== null && customPieceJSX !== void 0 ? customPieceJSX : $8f4069742e98d682$var$defaultPieces[piece];
    const [{ canDrag: canDrag , isDragging: isDragging  }, drag, dragPreview] = $8f4069742e98d682$var$useDrag(()=>({
            type: "piece",
            item: ()=>{
                return {
                    piece: piece,
                    isSpare: true,
                    id: dndId
                };
            },
            collect: (monitor)=>({
                    canDrag: true,
                    isDragging: !!monitor.isDragging()
                })
        }), [
        piece,
        dndId
    ]);
    // hide the default preview
    dragPreview($8f4069742e98d682$var$getEmptyImage(), {
        captureDraggingState: true
    });
    return (0, $7ead0b1397a835ed$exports.jsx)("div", Object.assign({
        ref: canDrag ? drag : null,
        "data-piece": piece,
        style: {
            cursor: "move"
        }
    }, {
        children: typeof renderPiece === "function" ? renderPiece({
            squareWidth: width,
            isDragging: isDragging
        }) : (0, $7ead0b1397a835ed$exports.jsx)("svg", Object.assign({
            viewBox: "1 1 43 43",
            width: width,
            height: width
        }, {
            children: (0, $7ead0b1397a835ed$exports.jsx)("g", {
                children: renderPiece
            })
        }))
    }));
};
const $8f4069742e98d682$export$2b996ae5040ad8f1 = (0, $exYeM.forwardRef)((props, ref)=>{
    const { customDndBackend: customDndBackend , customDndBackendOptions: customDndBackendOptions , onBoardWidthChange: onBoardWidthChange  } = props, otherProps = $8f4069742e98d682$var$__rest(props, [
        "customDndBackend",
        "customDndBackendOptions",
        "onBoardWidthChange"
    ]);
    const [boardWidth, setBoardWidth] = (0, $exYeM.useState)(props.boardWidth);
    const boardRef = (0, $exYeM.useRef)(null);
    const boardContainerRef = (0, $exYeM.useRef)(null);
    const [boardContainerPos, setBoardContainerPos] = (0, $exYeM.useState)({
        left: 0,
        top: 0
    });
    const metrics = (0, $exYeM.useMemo)(()=>{
        var _a;
        return (_a = boardRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    }, [
        boardRef.current
    ]);
    (0, $exYeM.useEffect)(()=>{
        boardWidth && (onBoardWidthChange === null || onBoardWidthChange === void 0 || onBoardWidthChange(boardWidth));
    }, [
        boardWidth
    ]);
    (0, $exYeM.useEffect)(()=>{
        setBoardContainerPos({
            left: (metrics === null || metrics === void 0 ? void 0 : metrics.left) ? metrics === null || metrics === void 0 ? void 0 : metrics.left : 0,
            top: (metrics === null || metrics === void 0 ? void 0 : metrics.top) ? metrics === null || metrics === void 0 ? void 0 : metrics.top : 0
        });
    }, [
        metrics
    ]);
    (0, $exYeM.useEffect)(()=>{
        var _a;
        if (props.boardWidth === undefined && ((_a = boardRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth)) {
            const resizeObserver = new ResizeObserver(()=>{
                var _a;
                setBoardWidth((_a = boardRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth);
            });
            resizeObserver.observe(boardRef.current);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, [
        boardRef.current
    ]);
    return (0, $7ead0b1397a835ed$exports.jsx)($8f4069742e98d682$var$ErrorBoundary, {
        children: (0, $7ead0b1397a835ed$exports.jsxs)("div", Object.assign({
            ref: boardContainerRef,
            style: {
                display: "flex",
                flexDirection: "column",
                width: "100%"
            }
        }, {
            children: [
                (0, $7ead0b1397a835ed$exports.jsx)("div", {
                    ref: boardRef,
                    style: {
                        width: "100%"
                    }
                }),
                (0, $7ead0b1397a835ed$exports.jsx)($8f4069742e98d682$var$ChessboardDnDRoot, Object.assign({
                    customDndBackend: customDndBackend,
                    customDndBackendOptions: customDndBackendOptions
                }, {
                    children: boardWidth && (0, $7ead0b1397a835ed$exports.jsxs)($8f4069742e98d682$var$ChessboardProvider, Object.assign({
                        boardWidth: boardWidth
                    }, otherProps, {
                        ref: ref
                    }, {
                        children: [
                            (0, $7ead0b1397a835ed$exports.jsx)($8f4069742e98d682$var$CustomDragLayer, {
                                boardContainer: boardContainerPos
                            }),
                            (0, $7ead0b1397a835ed$exports.jsx)($8f4069742e98d682$var$Board, {})
                        ]
                    }))
                }))
            ]
        }))
    });
});




var $exYeM = parcelRequire("exYeM");
function $a7e91ff6d63b9f9e$var$_extends() {
    return $a7e91ff6d63b9f9e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a7e91ff6d63b9f9e$var$_extends.apply(null, arguments);
}
function $a7e91ff6d63b9f9e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $a7e91ff6d63b9f9e$var$useOnMount(callback) {
    (0, $exYeM.useEffect)(callback, []);
}
var $a7e91ff6d63b9f9e$var$_excluded = [
    "id",
    "volume",
    "playbackRate",
    "soundEnabled",
    "interrupt",
    "onload"
];

function $a7e91ff6d63b9f9e$export$a34349420ba3cec8(src, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$volume = _ref.volume, volume = _ref$volume === void 0 ? 1 : _ref$volume, _ref$playbackRate = _ref.playbackRate, playbackRate = _ref$playbackRate === void 0 ? 1 : _ref$playbackRate, _ref$soundEnabled = _ref.soundEnabled, soundEnabled = _ref$soundEnabled === void 0 ? true : _ref$soundEnabled, _ref$interrupt = _ref.interrupt, interrupt = _ref$interrupt === void 0 ? false : _ref$interrupt, onload = _ref.onload, delegated = $a7e91ff6d63b9f9e$var$_objectWithoutPropertiesLoose(_ref, $a7e91ff6d63b9f9e$var$_excluded);
    var HowlConstructor = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
    var isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null), duration = _React$useState[0], setDuration = _React$useState[1];
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null), sound = _React$useState2[0], setSound = _React$useState2[1];
    var handleLoad = function handleLoad() {
        if (typeof onload === "function") // @ts-ignore
        onload.call(this);
        if (isMounted.current) // @ts-ignore
        setDuration(this.duration() * 1000);
        // @ts-ignore
        setSound(this);
    };
    // We want to lazy-load Howler, since sounds can't play on load anyway.
    $a7e91ff6d63b9f9e$var$useOnMount(function() {
        (parcelRequire("8dQlw")).then(function(mod) {
            if (!isMounted.current) {
                var _mod$Howl;
                // Depending on the module system used, `mod` might hold
                // the export directly, or it might be under `default`.
                HowlConstructor.current = (_mod$Howl = mod.Howl) !== null && _mod$Howl !== void 0 ? _mod$Howl : mod["default"].Howl;
                isMounted.current = true;
                new HowlConstructor.current($a7e91ff6d63b9f9e$var$_extends({
                    src: Array.isArray(src) ? src : [
                        src
                    ],
                    volume: volume,
                    rate: playbackRate,
                    onload: handleLoad
                }, delegated));
            }
        });
        return function() {
            isMounted.current = false;
        };
    });
    // When the `src` changes, we have to do a whole thing where we recreate
    // the Howl instance. This is because Howler doesn't expose a way to
    // tweak the sound
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(function() {
        if (HowlConstructor.current && sound) setSound(new HowlConstructor.current($a7e91ff6d63b9f9e$var$_extends({
            src: Array.isArray(src) ? src : [
                src
            ],
            volume: volume,
            onload: handleLoad
        }, delegated)));
    // The linter wants to run this effect whenever ANYTHING changes,
    // but very specifically I only want to recreate the Howl instance
    // when the `src` changes. Other changes should have no effect.
    // Passing array to the useEffect dependencies list will result in
    // ifinite loop so we need to stringify it, for more details check
    // https://github.com/facebook/react/issues/14476#issuecomment-471199055
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(src)
    ]);
    // Whenever volume/playbackRate are changed, change those properties
    // on the sound instance.
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(function() {
        if (sound) {
            sound.volume(volume);
            sound.rate(playbackRate);
        }
    // A weird bug means that including the `sound` here can trigger an
    // error on unmount, where the state loses track of the sprites??
    // No idea, but anyway I don't need to re-run this if only the `sound`
    // changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        volume,
        playbackRate
    ]);
    var play = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(function(options) {
        if (typeof options === "undefined") options = {};
        if (!sound || !soundEnabled && !options.forceSoundEnabled) return;
        if (interrupt) sound.stop();
        if (options.playbackRate) sound.rate(options.playbackRate);
        sound.play(options.id);
    }, [
        sound,
        soundEnabled,
        interrupt
    ]);
    var stop = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(function(id) {
        if (!sound) return;
        sound.stop(id);
    }, [
        sound
    ]);
    var pause = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(function(id) {
        if (!sound) return;
        sound.pause(id);
    }, [
        sound
    ]);
    var returnedValue = [
        play,
        {
            sound: sound,
            stop: stop,
            pause: pause,
            duration: duration
        }
    ];
    return returnedValue;
}
var $a7e91ff6d63b9f9e$export$2e2bcd8739ae039 = $a7e91ff6d63b9f9e$export$a34349420ba3cec8;


var $a2873df0e1b0147a$exports = {};


$a2873df0e1b0147a$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + (parcelRequire("iE7OH")).resolve("lBdyG");


var $dd50a18cb90120b3$exports = {};


$dd50a18cb90120b3$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + (parcelRequire("iE7OH")).resolve("c3drR");





const $5c0184adcefda2ca$var$ENDPOINT = "https://[TODO_ADD_API_HERE].execute-api.us-east-1.amazonaws.com/dev/";
function $5c0184adcefda2ca$var$Board({ initialOrientation: initialOrientation , boardId: boardId  }) {
    const [validateMove, setValidateMove] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(true);
    const [playMoveSound] = (0, $a7e91ff6d63b9f9e$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($a2873df0e1b0147a$exports))));
    const [playCaptureSound] = (0, $a7e91ff6d63b9f9e$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($dd50a18cb90120b3$exports))));
    const [orientation, setOrientation] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(initialOrientation);
    const [triggerFirstMove, setTriggerFirstMove] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(0);
    const [plans, setPlans] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState([]);
    console.log("reloading");
    const { resetAll: resetAll , notes: notes , toggle: toggle , tags: tags , isPlanningMode: isPlanningMode , isMistake: isMistake , setIsPlanningMode: setIsPlanningMode , setIsMistake: setIsMistake , setPlayerSolvedExercise: setPlayerSolvedExercise , setPlayerFailedExercise: setPlayerFailedExercise , setNumCorrectExercisePlan: setNumCorrectExercisePlan , exercisePlans: exercisePlans , setExercisePlans: setExercisePlans , moveHistory: moveHistory , setMoveHistory: setMoveHistory , selectedMove: selectedMove , setSelectedMove: setSelectedMove , chess: chess , positionFen: positionFen , setPositionFen: setPositionFen  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $b0893505d0f7ae16$export$58d75f9829cbe158));
    const [lastStateBeforePlanning, setLastStateBeforePlanning] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState({
        lastFenBeforePlanning: chess.fen(),
        lastMoveBeforePlanning: null
    });
    const [nextCorrectMove, setNextCorrectMove] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    // const { token } = React.useContext(UserContext);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const initialFen = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1";
    }, [
        orientation,
        tags,
        triggerFirstMove
    ]);
    const resetBoard = ()=>{
        const newGame = new (0, $aa246c147a5ff844$export$a4d6ea685c300d39)();
        setPositionFen(newGame.fen());
        chess.reset();
        setTriggerFirstMove((prev)=>(prev + 1) % 100);
        setPlans([]);
        setIsPlanningMode(false);
        setIsMistake(false);
        resetAll();
    };
    const flipBoard = ()=>{
        setOrientation((prevOrientation)=>{
            return prevOrientation === "white" ? "black" : "white";
        });
    };
    const handlePieceDrop = (sourceSquare, targetSquare)=>{
        try {
            if (validateMove && !isPlanningMode) {
                const moveData = {
                    from: sourceSquare,
                    to: targetSquare,
                    promotion: "q"
                };
                setLastStateBeforePlanning({
                    lastFenBeforePlanning: chess.fen(),
                    lastMoveBeforePlanning: moveData
                });
                let move = chess.move(moveData);
                if (move) {
                    console.log(`move=${JSON.stringify(move)}`);
                    setMoveHistory((previous)=>{
                        return [
                            ...previous,
                            move.san
                        ];
                    });
                    if (move.flags.includes("c")) playCaptureSound();
                    else playMoveSound();
                    setPositionFen(chess.fen());
                    return true;
                } else return false;
            }
        } catch (error) {
            console.log("Error making move:", error);
            return false;
        }
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($5c0184adcefda2ca$var$Div, {
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8f4069742e98d682$export$2b996ae5040ad8f1), {
                id: boardId,
                onPieceDrop: handlePieceDrop,
                position: positionFen,
                dropOffBoardAction: "snapback",
                boardOrientation: orientation,
                allowDragOutsideBoard: !validateMove
            })
        })
    });
}
var $5c0184adcefda2ca$export$2e2bcd8739ae039 = $5c0184adcefda2ca$var$Board;
const $5c0184adcefda2ca$var$Button = (0, $93948c98236af5c1$export$2e2bcd8739ae039).button`
  padding: 5px;
  background-color: lightgrey;
  margin: 2px;
  margin-top: 10px;
  margin-right: 3px;
  border-radius: 5px;
  font-weight: bold;
  border: 2px solid black;
`;
const $5c0184adcefda2ca$var$Div = (0, $93948c98236af5c1$export$2e2bcd8739ae039).div`
  width: 99%;
`;






var $exYeM = parcelRequire("exYeM");



function $df67e871f2d6d0f9$var$MoveTable() {
    const { moveHistory: moveHistory , selectedMove: selectedMove , setSelectedMove: setSelectedMove  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $b0893505d0f7ae16$export$58d75f9829cbe158));
    const formatMove = (move)=>{
        return move.replace(/N/g, "♞") // Knight
        .replace(/B/g, "♝") // Bishop
        .replace(/R/g, "♜") // Rook
        .replace(/Q/g, "♛") // Queen
        .replace(/K/g, "♚"); // King
    };
    // Process moves into pairs
    const movePairs = [];
    for(let i = 0; i < moveHistory.length; i += 2)movePairs.push({
        whiteDisplay: moveHistory[i] ? formatMove(moveHistory[i]) : "",
        whiteSan: moveHistory[i],
        blackDisplay: moveHistory[i + 1] ? formatMove(moveHistory[i + 1]) : "",
        blackSan: moveHistory[i + 1]
    });
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($df67e871f2d6d0f9$var$StyledTable, {
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("tbody", {
            children: movePairs.map((pair, index)=>{
                return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($df67e871f2d6d0f9$var$StyledRow, {
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($df67e871f2d6d0f9$var$StyledMoveIndexCell, {
                            children: index + 1
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($df67e871f2d6d0f9$var$StyledCell, {
                            isiconmove: /^[NBRQK]/.test(pair.whiteSan),
                            children: pair.whiteDisplay
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($df67e871f2d6d0f9$var$StyledCell, {
                            isiconmove: /^[NBRQK]/.test(pair.blackSan),
                            children: pair.blackDisplay
                        })
                    ]
                }, index);
            })
        })
    });
}
var $df67e871f2d6d0f9$export$2e2bcd8739ae039 = $df67e871f2d6d0f9$var$MoveTable;
const $df67e871f2d6d0f9$var$StyledTable = (0, $93948c98236af5c1$export$2e2bcd8739ae039).table`
  width: 100%;
  padding-top: 60px;
`;
const $df67e871f2d6d0f9$var$StyledRow = (0, $93948c98236af5c1$export$2e2bcd8739ae039).tr`
  display: flex;
`;
const $df67e871f2d6d0f9$var$StyledMoveIndexCell = (0, $93948c98236af5c1$export$2e2bcd8739ae039).td`
  flex: 1;
  background-color: #302e2c;
  color: #6b6b6b;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
`;
const $df67e871f2d6d0f9$var$StyledCell = (0, $93948c98236af5c1$export$2e2bcd8739ae039).td`
  flex: 10;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: ${(p)=>p.isiconmove ? "15px" : "20px"};
  background-color: #262421;
  color: #bababa;
  cursor: pointer;
  &:hover {
    background-color: #3692e7;
    color: #ffffff;
  }
  &:last-child:empty {
    cursor: default;
    background-color: #262421;
  }
`;





function $8afca7df5ddc3462$export$3af29c0efb268f04(componentFactory) {
    if (typeof Proxy === "undefined") return componentFactory;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const deprecatedFactoryFunction = (...args)=>{
        return componentFactory(...args);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return componentFactory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, componentFactory(key));
            return componentCache.get(key);
        }
    });
}


function $0c915d7372d9814d$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}



const $6f683bc80c6d969e$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


function $423df1fac2a0b98a$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}


/**
 * Decides if the supplied variable is variant label
 */ function $a36779356b36fa8a$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $1527d424ce16b34c$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $1527d424ce16b34c$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $1527d424ce16b34c$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $1527d424ce16b34c$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


function $730ab9aa0424fb5a$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $1527d424ce16b34c$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


const $46d8d186c05e43b0$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $46d8d186c05e43b0$export$1405a65085f40b9 = [
    "initial",
    ...$46d8d186c05e43b0$export$16e45afcc206d3a8
];



/**
 * Generate a list of every possible transform key.
 */ const $da211e07316d6e39$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $da211e07316d6e39$export$7b42a0094fb00b6e = new Set($da211e07316d6e39$export$280dc01950909d86);


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $bfda710cf857a073$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $bfda710cf857a073$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;



const $d51b9411f6ccbbd1$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $d51b9411f6ccbbd1$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $d51b9411f6ccbbd1$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $d51b9411f6ccbbd1$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $d51b9411f6ccbbd1$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes  })=>{
    if (keyframes.length > 2) return $d51b9411f6ccbbd1$var$keyframesTransition;
    else if ((0, $da211e07316d6e39$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $d51b9411f6ccbbd1$var$criticallyDampedSpring(keyframes[1]) : $d51b9411f6ccbbd1$var$underDampedSpring;
    return $d51b9411f6ccbbd1$var$ease;
};


function $32a29353ee2b3961$export$7c1391340308742e(transition, key) {
    return transition ? transition[key] || transition["default"] || transition : undefined;
}


const $3cdabdabfda62d22$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};


const $f006002175d4313e$export$888a3d84909f9e3d = {
    current: false
};


const $511bcb3f09b5d5d2$var$isNotNull = (value)=>value !== null;
function $511bcb3f09b5d5d2$export$14de59408fad90b(keyframes, { repeat: repeat , repeatType: repeatType = "loop"  }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($511bcb3f09b5d5d2$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}


const $6975d23d92ef960e$export$8793edee2d425525 = (any)=>any;


let $eb4f3ac792fc5529$export$491112666e282270 = (0, $6975d23d92ef960e$export$8793edee2d425525);
let $eb4f3ac792fc5529$export$f5708dca728d7177 = (0, $6975d23d92ef960e$export$8793edee2d425525);
var $eb4f3ac792fc5529$var$check, $eb4f3ac792fc5529$var$message, $eb4f3ac792fc5529$var$check1, $eb4f3ac792fc5529$var$message1;






function $734cfe98781f7335$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $2c4ecd0dc095867d$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $2c4ecd0dc095867d$var$maxElapsed = 40;
function $2c4ecd0dc095867d$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = $2c4ecd0dc095867d$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $734cfe98781f7335$export$b995e5e85f5c8289)(flagRunNextFrame);
        return acc;
    }, {});
    const { read: read , resolveKeyframes: resolveKeyframes , update: update , preRender: preRender , render: render , postRender: postRender  } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $3cdabdabfda62d22$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $2c4ecd0dc095867d$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $2c4ecd0dc095867d$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < $2c4ecd0dc095867d$export$71ecace0a033b35a.length; i++)steps[$2c4ecd0dc095867d$export$71ecace0a033b35a[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $301e135f87ffeb5c$export$2cef06c20297c17d , cancel: $301e135f87ffeb5c$export$ec99c0ef4978dccb , state: $301e135f87ffeb5c$export$fff89137e9e818ce , steps: $301e135f87ffeb5c$export$1811c3a7e3af92f0  } = (0, $2c4ecd0dc095867d$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $6975d23d92ef960e$export$8793edee2d425525), true);



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $3737dbfe96debfa1$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $3737dbfe96debfa1$var$subdivisionPrecision = 0.0000001;
const $3737dbfe96debfa1$var$subdivisionMaxIterations = 12;
function $3737dbfe96debfa1$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $3737dbfe96debfa1$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $3737dbfe96debfa1$var$subdivisionPrecision && ++i < $3737dbfe96debfa1$var$subdivisionMaxIterations);
    return currentT;
}
function $3737dbfe96debfa1$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $6975d23d92ef960e$export$8793edee2d425525;
    const getTForX = (aX)=>$3737dbfe96debfa1$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $3737dbfe96debfa1$var$calcBezier(getTForX(t), mY1, mY2);
}


// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $491548cdece44f33$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $5a530d260e29c865$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $d8f936f95fb21cba$export$77edfce482316a60 = /*@__PURE__*/ (0, $3737dbfe96debfa1$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $d8f936f95fb21cba$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $5a530d260e29c865$export$2c07eeff45156d4d)($d8f936f95fb21cba$export$77edfce482316a60);
const $d8f936f95fb21cba$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $491548cdece44f33$export$f946554fb8aeaf0d)($d8f936f95fb21cba$export$b01116c84cdfe1a2);


const $e12b7a3993b78d59$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $d8f936f95fb21cba$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $2c3e49d3e54725d4$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $2c3e49d3e54725d4$export$c8d67a19199d1a50 = (0, $5a530d260e29c865$export$2c07eeff45156d4d)($2c3e49d3e54725d4$export$e444123e42d03385);
const $2c3e49d3e54725d4$export$30d3455eee55bed5 = (0, $491548cdece44f33$export$f946554fb8aeaf0d)($2c3e49d3e54725d4$export$e444123e42d03385);


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $dc25af1e857ab50f$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $79eb9ac4c2b846cb$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $dc25af1e857ab50f$export$ade84c85e44a6cb1)(value);
    else return true;
}



/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $fe062db003bcffb8$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);


const $7788fac55eb8bc79$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $7788fac55eb8bc79$export$9de1236619d9e756 = /*@__PURE__*/ $7788fac55eb8bc79$var$checkStringStartsWith("--");
const $7788fac55eb8bc79$var$startsAsVariableToken = /*@__PURE__*/ $7788fac55eb8bc79$var$checkStringStartsWith("var(--");
const $7788fac55eb8bc79$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $7788fac55eb8bc79$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $7788fac55eb8bc79$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $7788fac55eb8bc79$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;


/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $43d08db277fd08bd$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $43d08db277fd08bd$export$b9f0c1f373aee2b0(current) {
    const match = $43d08db277fd08bd$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $43d08db277fd08bd$var$maxDepth = 4;
function $43d08db277fd08bd$export$289398774300c991(current, element, depth = 1) {
    (0, $eb4f3ac792fc5529$export$f5708dca728d7177)(depth <= $43d08db277fd08bd$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $43d08db277fd08bd$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $fe062db003bcffb8$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $7788fac55eb8bc79$export$31f9caa2600b5723)(fallback) ? $43d08db277fd08bd$export$289398774300c991(fallback, element, depth + 1) : fallback;
}




const $b55556710a8b54c0$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $3b3d1d8d17c11467$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $3b3d1d8d17c11467$export$58f0f39f63f3cf42 = {
    ...$3b3d1d8d17c11467$export$98e628dec113755e,
    transform: (v)=>(0, $b55556710a8b54c0$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $3b3d1d8d17c11467$export$dcdf75081b88279d = {
    ...$3b3d1d8d17c11467$export$98e628dec113755e,
    default: 1
};


const $e8f3e6c5adc69edc$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $e8f3e6c5adc69edc$export$41fc368e1a942b97 = /*@__PURE__*/ $e8f3e6c5adc69edc$var$createUnitType("deg");
const $e8f3e6c5adc69edc$export$626336c2cd4b14de = /*@__PURE__*/ $e8f3e6c5adc69edc$var$createUnitType("%");
const $e8f3e6c5adc69edc$export$91c0eda1d06bf008 = /*@__PURE__*/ $e8f3e6c5adc69edc$var$createUnitType("px");
const $e8f3e6c5adc69edc$export$f91e8c45a95a32f2 = /*@__PURE__*/ $e8f3e6c5adc69edc$var$createUnitType("vh");
const $e8f3e6c5adc69edc$export$aed3d7b7d206c196 = /*@__PURE__*/ $e8f3e6c5adc69edc$var$createUnitType("vw");
const $e8f3e6c5adc69edc$export$44e2e1705876d7ed = {
    ...$e8f3e6c5adc69edc$export$626336c2cd4b14de,
    parse: (v)=>$e8f3e6c5adc69edc$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$e8f3e6c5adc69edc$export$626336c2cd4b14de.transform(v * 100)
};


const $c21fcd3807f5d2f0$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $c21fcd3807f5d2f0$export$8e5250d1aa9bf370 = (v)=>v === (0, $3b3d1d8d17c11467$export$98e628dec113755e) || v === (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008);
const $c21fcd3807f5d2f0$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $c21fcd3807f5d2f0$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform  })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $c21fcd3807f5d2f0$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $c21fcd3807f5d2f0$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $c21fcd3807f5d2f0$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $c21fcd3807f5d2f0$var$nonTranslationalTransformKeys = (0, $da211e07316d6e39$export$280dc01950909d86).filter((key)=>!$c21fcd3807f5d2f0$var$transformKeys.has(key));
function $c21fcd3807f5d2f0$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $c21fcd3807f5d2f0$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $c21fcd3807f5d2f0$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x  }, { paddingLeft: paddingLeft = "0" , paddingRight: paddingRight = "0"  })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y  }, { paddingTop: paddingTop = "0" , paddingBottom: paddingBottom = "0"  })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top  })=>parseFloat(top),
    left: (_bbox, { left: left  })=>parseFloat(left),
    bottom: ({ y: y  }, { top: top  })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x  }, { left: left  })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $c21fcd3807f5d2f0$var$getTranslateFromMatrix(4, 13),
    y: $c21fcd3807f5d2f0$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$c21fcd3807f5d2f0$export$781d46a8aa670d52.translateX = $c21fcd3807f5d2f0$export$781d46a8aa670d52.x;
$c21fcd3807f5d2f0$export$781d46a8aa670d52.translateY = $c21fcd3807f5d2f0$export$781d46a8aa670d52.y;




/**
 * Tests a provided value against a ValueType
 */ const $0a85921ea474cb14$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $e8457b7d67ceabe9$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $b2fd586ec5020ed9$export$d176691c1998a1f5 = [
    (0, $3b3d1d8d17c11467$export$98e628dec113755e),
    (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    (0, $e8f3e6c5adc69edc$export$626336c2cd4b14de),
    (0, $e8f3e6c5adc69edc$export$41fc368e1a942b97),
    (0, $e8f3e6c5adc69edc$export$aed3d7b7d206c196),
    (0, $e8f3e6c5adc69edc$export$f91e8c45a95a32f2),
    (0, $e8457b7d67ceabe9$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $b2fd586ec5020ed9$export$eefdd52e3ccae428 = (v)=>$b2fd586ec5020ed9$export$d176691c1998a1f5.find((0, $0a85921ea474cb14$export$6eae4d0a6a7ca7cd)(v));




const $80c84fe89f88d202$var$toResolve = new Set();
let $80c84fe89f88d202$var$isScheduled = false;
let $80c84fe89f88d202$var$anyNeedsMeasurement = false;
function $80c84fe89f88d202$var$measureAllKeyframes() {
    if ($80c84fe89f88d202$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($80c84fe89f88d202$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $c21fcd3807f5d2f0$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $80c84fe89f88d202$var$anyNeedsMeasurement = false;
    $80c84fe89f88d202$var$isScheduled = false;
    $80c84fe89f88d202$var$toResolve.forEach((resolver)=>resolver.complete());
    $80c84fe89f88d202$var$toResolve.clear();
}
function $80c84fe89f88d202$var$readAllKeyframes() {
    $80c84fe89f88d202$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $80c84fe89f88d202$var$anyNeedsMeasurement = true;
    });
}
function $80c84fe89f88d202$export$78b96d2a12593b05() {
    $80c84fe89f88d202$var$readAllKeyframes();
    $80c84fe89f88d202$var$measureAllKeyframes();
}
class $80c84fe89f88d202$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $80c84fe89f88d202$var$toResolve.add(this);
            if (!$80c84fe89f88d202$var$isScheduled) {
                $80c84fe89f88d202$var$isScheduled = true;
                (0, $301e135f87ffeb5c$export$2cef06c20297c17d).read($80c84fe89f88d202$var$readAllKeyframes);
                (0, $301e135f87ffeb5c$export$2cef06c20297c17d).resolveKeyframes($80c84fe89f88d202$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes , name: name , element: element , motionValue: motionValue  } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $80c84fe89f88d202$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $80c84fe89f88d202$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}




// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $768c31a3879f2c57$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $4122cae77e65c07d$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;


function $36222ac70a17c442$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $8973c9cec19078c2$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $75e61ee5dd842e4f$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $8973c9cec19078c2$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $36222ac70a17c442$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $75e61ee5dd842e4f$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $4122cae77e65c07d$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $85af50c0409e6514$var$clampRgbUnit = (v)=>(0, $b55556710a8b54c0$export$7d15b64cf5a3a4c4)(0, 255, v);
const $85af50c0409e6514$export$7a99c86b5b1f4c9e = {
    ...(0, $3b3d1d8d17c11467$export$98e628dec113755e),
    transform: (v)=>Math.round($85af50c0409e6514$var$clampRgbUnit(v))
};
const $85af50c0409e6514$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $75e61ee5dd842e4f$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $75e61ee5dd842e4f$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red , green: green , blue: blue , alpha: alpha$1 = 1  })=>"rgba(" + $85af50c0409e6514$export$7a99c86b5b1f4c9e.transform(red) + ", " + $85af50c0409e6514$export$7a99c86b5b1f4c9e.transform(green) + ", " + $85af50c0409e6514$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $768c31a3879f2c57$export$83d2e9e3e4ee39ed)((0, $3b3d1d8d17c11467$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $aeb63d9188419d43$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $aeb63d9188419d43$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $75e61ee5dd842e4f$export$2c8400d58aca05e)("#"),
    parse: $aeb63d9188419d43$var$parseHex,
    transform: (0, $85af50c0409e6514$export$4e46ac54fc82cf3b).transform
};






const $849448f5a3a709c4$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $75e61ee5dd842e4f$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $75e61ee5dd842e4f$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue , saturation: saturation , lightness: lightness , alpha: alpha$1 = 1  })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $e8f3e6c5adc69edc$export$626336c2cd4b14de).transform((0, $768c31a3879f2c57$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $e8f3e6c5adc69edc$export$626336c2cd4b14de).transform((0, $768c31a3879f2c57$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $768c31a3879f2c57$export$83d2e9e3e4ee39ed)((0, $3b3d1d8d17c11467$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $9aa3b4c939055303$export$35e9368ef982300f = {
    test: (v)=>(0, $85af50c0409e6514$export$4e46ac54fc82cf3b).test(v) || (0, $aeb63d9188419d43$export$834dfc94dde4b3d8).test(v) || (0, $849448f5a3a709c4$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $85af50c0409e6514$export$4e46ac54fc82cf3b).test(v)) return (0, $85af50c0409e6514$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $849448f5a3a709c4$export$810b04175080204c).test(v)) return (0, $849448f5a3a709c4$export$810b04175080204c).parse(v);
        else return (0, $aeb63d9188419d43$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $85af50c0409e6514$export$4e46ac54fc82cf3b).transform(v) : (0, $849448f5a3a709c4$export$810b04175080204c).transform(v);
    }
};


const $bef77bdf8d47ab47$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;




function $20185419c445ef46$var$test(v) {
    var _a, _b;
    return isNaN(v) && typeof v === "string" && (((_a = v.match((0, $4122cae77e65c07d$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $bef77bdf8d47ab47$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $20185419c445ef46$var$NUMBER_TOKEN = "number";
const $20185419c445ef46$var$COLOR_TOKEN = "color";
const $20185419c445ef46$var$VAR_TOKEN = "var";
const $20185419c445ef46$var$VAR_FUNCTION_TOKEN = "var(";
const $20185419c445ef46$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $20185419c445ef46$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $20185419c445ef46$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($20185419c445ef46$var$complexRegex, (parsedValue)=>{
        if ((0, $9aa3b4c939055303$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($20185419c445ef46$var$COLOR_TOKEN);
            values.push((0, $9aa3b4c939055303$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($20185419c445ef46$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($20185419c445ef46$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($20185419c445ef46$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $20185419c445ef46$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($20185419c445ef46$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $20185419c445ef46$var$parseComplexValue(v) {
    return $20185419c445ef46$export$b61fc7c44bf646d5(v).values;
}
function $20185419c445ef46$var$createTransformer(source) {
    const { split: split , types: types  } = $20185419c445ef46$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $20185419c445ef46$var$NUMBER_TOKEN) output += (0, $768c31a3879f2c57$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $20185419c445ef46$var$COLOR_TOKEN) output += (0, $9aa3b4c939055303$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $20185419c445ef46$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $20185419c445ef46$var$getAnimatableNone(v) {
    const parsed = $20185419c445ef46$var$parseComplexValue(v);
    const transformer = $20185419c445ef46$var$createTransformer(v);
    return transformer(parsed.map($20185419c445ef46$var$convertNumbersToZero));
}
const $20185419c445ef46$export$83a0e34f1302825b = {
    test: $20185419c445ef46$var$test,
    parse: $20185419c445ef46$var$parseComplexValue,
    createTransformer: $20185419c445ef46$var$createTransformer,
    getAnimatableNone: $20185419c445ef46$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $c9578b271c7cac5c$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $c9578b271c7cac5c$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $4122cae77e65c07d$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $c9578b271c7cac5c$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $c9578b271c7cac5c$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $c9578b271c7cac5c$export$3dea766d36a8935f = {
    ...(0, $20185419c445ef46$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($c9578b271c7cac5c$var$functionRegex);
        return functions ? functions.map($c9578b271c7cac5c$var$applyDefaultFilter).join(" ") : v;
    }
};







const $85cc9c955d29f087$export$2fb74b0a4e7d7c4a = {
    // Border props
    borderWidth: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    borderTopWidth: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    borderRightWidth: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    borderRadius: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    radius: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    maxWidth: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    height: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    maxHeight: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    top: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    right: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    bottom: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    left: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    paddingTop: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    paddingRight: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    paddingBottom: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    paddingLeft: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    margin: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    marginTop: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    marginRight: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    marginBottom: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    marginLeft: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008)
};




const $8311694046599622$export$f2e4285fee37e26 = {
    rotate: (0, $e8f3e6c5adc69edc$export$41fc368e1a942b97),
    rotateX: (0, $e8f3e6c5adc69edc$export$41fc368e1a942b97),
    rotateY: (0, $e8f3e6c5adc69edc$export$41fc368e1a942b97),
    rotateZ: (0, $e8f3e6c5adc69edc$export$41fc368e1a942b97),
    scale: $3b3d1d8d17c11467$export$dcdf75081b88279d,
    scaleX: (0, $3b3d1d8d17c11467$export$dcdf75081b88279d),
    scaleY: (0, $3b3d1d8d17c11467$export$dcdf75081b88279d),
    scaleZ: (0, $3b3d1d8d17c11467$export$dcdf75081b88279d),
    skew: (0, $e8f3e6c5adc69edc$export$41fc368e1a942b97),
    skewX: (0, $e8f3e6c5adc69edc$export$41fc368e1a942b97),
    skewY: (0, $e8f3e6c5adc69edc$export$41fc368e1a942b97),
    distance: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    translateX: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    translateY: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    translateZ: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    x: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    y: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    z: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    perspective: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    transformPerspective: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    opacity: (0, $3b3d1d8d17c11467$export$58f0f39f63f3cf42),
    originX: (0, $e8f3e6c5adc69edc$export$44e2e1705876d7ed),
    originY: (0, $e8f3e6c5adc69edc$export$44e2e1705876d7ed),
    originZ: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008)
};



const $d16ea4f0603eeb66$export$7d260a2a5f8bc19e = {
    ...(0, $3b3d1d8d17c11467$export$98e628dec113755e),
    transform: Math.round
};


const $0d74cfa63198be03$export$eec14432cd1cb67b = {
    ...(0, $85cc9c955d29f087$export$2fb74b0a4e7d7c4a),
    ...(0, $8311694046599622$export$f2e4285fee37e26),
    zIndex: (0, $d16ea4f0603eeb66$export$7d260a2a5f8bc19e),
    size: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    // SVG
    fillOpacity: (0, $3b3d1d8d17c11467$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $3b3d1d8d17c11467$export$58f0f39f63f3cf42),
    numOctaves: (0, $d16ea4f0603eeb66$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $10ea5fd01401393b$export$98cd7c72c5a731fb = {
    ...(0, $0d74cfa63198be03$export$eec14432cd1cb67b),
    color: // Color props
    $9aa3b4c939055303$export$35e9368ef982300f,
    backgroundColor: (0, $9aa3b4c939055303$export$35e9368ef982300f),
    outlineColor: (0, $9aa3b4c939055303$export$35e9368ef982300f),
    fill: (0, $9aa3b4c939055303$export$35e9368ef982300f),
    stroke: (0, $9aa3b4c939055303$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $9aa3b4c939055303$export$35e9368ef982300f),
    borderTopColor: (0, $9aa3b4c939055303$export$35e9368ef982300f),
    borderRightColor: (0, $9aa3b4c939055303$export$35e9368ef982300f),
    borderBottomColor: (0, $9aa3b4c939055303$export$35e9368ef982300f),
    borderLeftColor: (0, $9aa3b4c939055303$export$35e9368ef982300f),
    filter: $c9578b271c7cac5c$export$3dea766d36a8935f,
    WebkitFilter: (0, $c9578b271c7cac5c$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $10ea5fd01401393b$export$67d1babe0338d23b = (key)=>$10ea5fd01401393b$export$98cd7c72c5a731fb[key];


function $f39674aa42131bf6$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $10ea5fd01401393b$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $c9578b271c7cac5c$export$3dea766d36a8935f)) defaultValueType = (0, $20185419c445ef46$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $3f14005f681887c7$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $3f14005f681887c7$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$3f14005f681887c7$var$invalidTemplates.has(keyframe) && (0, $20185419c445ef46$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $f39674aa42131bf6$export$cea0cedcb94873b5)(name, animatableTemplate);
}


class $891e5637f91f7d52$export$4983792d11b61017 extends (0, $80c84fe89f88d202$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes , element: element , name: name  } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $7788fac55eb8bc79$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $43d08db277fd08bd$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $c21fcd3807f5d2f0$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $b2fd586ec5020ed9$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $b2fd586ec5020ed9$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $c21fcd3807f5d2f0$export$8e5250d1aa9bf370)(originType) && (0, $c21fcd3807f5d2f0$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes , name: name  } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $79eb9ac4c2b846cb$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $3f14005f681887c7$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element , unresolvedKeyframes: unresolvedKeyframes , name: name  } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $c21fcd3807f5d2f0$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element , name: name , unresolvedKeyframes: unresolvedKeyframes  } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $c21fcd3807f5d2f0$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}




function $be3cf26b78f9cfed$export$6ab7812f1bac68be(type) {
    return typeof type === "function";
}




let $960d9779faf6f40c$var$now;
function $960d9779faf6f40c$var$clearTime() {
    $960d9779faf6f40c$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $960d9779faf6f40c$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($960d9779faf6f40c$var$now === undefined) $960d9779faf6f40c$export$2da9be4cfdb689b1.set((0, $301e135f87ffeb5c$export$fff89137e9e818ce).isProcessing || (0, $3cdabdabfda62d22$export$dd826089e3c5e502).useManualTiming ? (0, $301e135f87ffeb5c$export$fff89137e9e818ce).timestamp : performance.now());
        return $960d9779faf6f40c$var$now;
    },
    set: (newTime)=>{
        $960d9779faf6f40c$var$now = newTime;
        queueMicrotask($960d9779faf6f40c$var$clearTime);
    }
};







/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $ad3409c8def06c51$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $20185419c445ef46$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $1f73039afafc0199$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $1f73039afafc0199$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $ad3409c8def06c51$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $ad3409c8def06c51$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $eb4f3ac792fc5529$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $1f73039afafc0199$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $be3cf26b78f9cfed$export$6ab7812f1bac68be)(type)) && velocity;
}



/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $ed332976403bd896$var$MAX_RESOLVE_DELAY = 40;
class $ed332976403bd896$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true , delay: delay = 0 , type: type = "keyframes" , repeat: repeat = 0 , repeatDelay: repeatDelay = 0 , repeatType: repeatType = "loop" , ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.createdAt = (0, $960d9779faf6f40c$export$2da9be4cfdb689b1).now();
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * This method uses the createdAt and resolvedAt to calculate the
     * animation startTime. *Ideally*, we would use the createdAt time as t=0
     * as the following frame would then be the first frame of the animation in
     * progress, which would feel snappier.
     *
     * However, if there's a delay (main thread work) between the creation of
     * the animation and the first commited frame, we prefer to use resolvedAt
     * to avoid a sudden jump into the animation.
     */ calcStartTime() {
        if (!this.resolvedAt) return this.createdAt;
        return this.resolvedAt - this.createdAt > $ed332976403bd896$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt;
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $80c84fe89f88d202$export$78b96d2a12593b05)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.resolvedAt = (0, $960d9779faf6f40c$export$2da9be4cfdb689b1).now();
        this.hasAttemptedResolve = true;
        const { name: name , type: type , velocity: velocity , delay: delay , onComplete: onComplete , onUpdate: onUpdate , isGenerator: isGenerator  } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $1f73039afafc0199$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $f006002175d4313e$export$888a3d84909f9e3d).current || !delay) {
                onUpdate === null || onUpdate === void 0 || onUpdate((0, $511bcb3f09b5d5d2$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 || onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    flatten() {
        this.options.type = "keyframes";
        this.options.ease = "linear";
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $98fa8bab6764d451$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};


const $95a8a30344d28284$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += easing((0, $98fa8bab6764d451$export$504d7abb21fa8c9)(0, numPoints - 1, i)) + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};



/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $802cd06bac70029a$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $0ea446648b330676$var$velocitySampleDuration = 5; // ms
function $0ea446648b330676$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $0ea446648b330676$var$velocitySampleDuration, 0);
    return (0, $802cd06bac70029a$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $9b421a96566a2985$export$86436497e7b05d16 = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};


const $13cfb88998c1052a$var$safeMin = 0.001;
function $13cfb88998c1052a$export$b15f158dc6d6f458({ duration: duration = (0, $9b421a96566a2985$export$86436497e7b05d16).duration , bounce: bounce = (0, $9b421a96566a2985$export$86436497e7b05d16).bounce , velocity: velocity = (0, $9b421a96566a2985$export$86436497e7b05d16).velocity , mass: mass = (0, $9b421a96566a2985$export$86436497e7b05d16).mass  }) {
    let envelope;
    let derivative;
    (0, $eb4f3ac792fc5529$export$491112666e282270)(duration <= (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)((0, $9b421a96566a2985$export$86436497e7b05d16).maxDuration), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $b55556710a8b54c0$export$7d15b64cf5a3a4c4)((0, $9b421a96566a2985$export$86436497e7b05d16).minDamping, (0, $9b421a96566a2985$export$86436497e7b05d16).maxDamping, dampingRatio);
    duration = (0, $b55556710a8b54c0$export$7d15b64cf5a3a4c4)((0, $9b421a96566a2985$export$86436497e7b05d16).minDuration, (0, $9b421a96566a2985$export$86436497e7b05d16).maxDuration, (0, $bfda710cf857a073$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $13cfb88998c1052a$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $13cfb88998c1052a$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $13cfb88998c1052a$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $13cfb88998c1052a$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$13cfb88998c1052a$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $13cfb88998c1052a$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, $9b421a96566a2985$export$86436497e7b05d16).stiffness,
        damping: (0, $9b421a96566a2985$export$86436497e7b05d16).damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $13cfb88998c1052a$var$rootIterations = 12;
function $13cfb88998c1052a$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $13cfb88998c1052a$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $13cfb88998c1052a$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $2c9655bdaefca666$export$f4ff70a5b4808fd8 = 20000;
function $2c9655bdaefca666$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $2c9655bdaefca666$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $2c9655bdaefca666$export$f4ff70a5b4808fd8 ? Infinity : duration;
}




const $9c2b8560de502fe4$var$durationKeys = [
    "duration",
    "bounce"
];
const $9c2b8560de502fe4$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $9c2b8560de502fe4$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $9c2b8560de502fe4$var$getSpringOptions(options) {
    let springOptions = {
        velocity: (0, $9b421a96566a2985$export$86436497e7b05d16).velocity,
        stiffness: (0, $9b421a96566a2985$export$86436497e7b05d16).stiffness,
        damping: (0, $9b421a96566a2985$export$86436497e7b05d16).damping,
        mass: (0, $9b421a96566a2985$export$86436497e7b05d16).mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$9c2b8560de502fe4$var$isSpringType(options, $9c2b8560de502fe4$var$physicsKeys) && $9c2b8560de502fe4$var$isSpringType(options, $9c2b8560de502fe4$var$durationKeys)) {
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $b55556710a8b54c0$export$7d15b64cf5a3a4c4)(0.05, 1, 1 - options.bounce) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: (0, $9b421a96566a2985$export$86436497e7b05d16).mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = (0, $13cfb88998c1052a$export$b15f158dc6d6f458)(options);
            springOptions = {
                ...springOptions,
                ...derived,
                mass: (0, $9b421a96566a2985$export$86436497e7b05d16).mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $9c2b8560de502fe4$export$b36281d89752ae66(optionsOrVisualDuration = (0, $9b421a96566a2985$export$86436497e7b05d16).visualDuration, bounce = (0, $9b421a96566a2985$export$86436497e7b05d16).bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed , restDelta: restDelta  } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness , damping: damping , mass: mass , duration: duration , velocity: velocity , isResolvedFromDuration: isResolvedFromDuration  } = $9c2b8560de502fe4$var$getSpringOptions({
        ...options,
        velocity: -(0, $bfda710cf857a073$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $bfda710cf857a073$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, $9b421a96566a2985$export$86436497e7b05d16).restSpeed.granular : (0, $9b421a96566a2985$export$86436497e7b05d16).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, $9b421a96566a2985$export$86436497e7b05d16).restDelta.granular : (0, $9b421a96566a2985$export$86436497e7b05d16).restDelta.default);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $13cfb88998c1052a$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $0ea446648b330676$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $2c9655bdaefca666$export$cbdd6b3d40ea54e2)(generator), (0, $2c9655bdaefca666$export$f4ff70a5b4808fd8));
            const easing = (0, $95a8a30344d28284$export$66d3851e2b1ec912)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        }
    };
    return generator;
}




function $385208c905445c33$export$ee3ff3a17106998({ keyframes: keyframes , velocity: velocity = 0.0 , power: power = 0.8 , timeConstant: timeConstant = 325 , bounceDamping: bounceDamping = 10 , bounceStiffness: bounceStiffness = 500 , modifyTarget: modifyTarget , min: min , max: max , restDelta: restDelta = 0.5 , restSpeed: restSpeed  }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $9c2b8560de502fe4$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $0ea446648b330676$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $c8b74045bf313d3a$export$929e5a82286172a6 = /*@__PURE__*/ (0, $3737dbfe96debfa1$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $c8b74045bf313d3a$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $3737dbfe96debfa1$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $c8b74045bf313d3a$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $3737dbfe96debfa1$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $aeb97d5b77acc966$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};








const $775b0dd2cff56849$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


const $88c8bfe8b7e57b27$var$easingLookup = {
    linear: (0, $6975d23d92ef960e$export$8793edee2d425525),
    easeIn: $c8b74045bf313d3a$export$929e5a82286172a6,
    easeInOut: $c8b74045bf313d3a$export$c07234257a03d5e9,
    easeOut: $c8b74045bf313d3a$export$57636bb43b1ccbb0,
    circIn: $2c3e49d3e54725d4$export$e444123e42d03385,
    circInOut: $2c3e49d3e54725d4$export$30d3455eee55bed5,
    circOut: $2c3e49d3e54725d4$export$c8d67a19199d1a50,
    backIn: $d8f936f95fb21cba$export$b01116c84cdfe1a2,
    backInOut: $d8f936f95fb21cba$export$ddc5fd596f6c71b2,
    backOut: $d8f936f95fb21cba$export$77edfce482316a60,
    anticipate: $e12b7a3993b78d59$export$6b0af63b873d419e
};
const $88c8bfe8b7e57b27$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $775b0dd2cff56849$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $eb4f3ac792fc5529$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $3737dbfe96debfa1$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $eb4f3ac792fc5529$export$f5708dca728d7177)($88c8bfe8b7e57b27$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $88c8bfe8b7e57b27$var$easingLookup[definition];
    }
    return definition;
};



/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $3e3ea55737c24d5c$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $3e3ea55737c24d5c$export$a4627e546088548d = (...transformers)=>transformers.reduce($3e3ea55737c24d5c$var$combineFunctions);




/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $588ba3a890ebeea1$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};




// Adapted from https://gist.github.com/mjackson/5311256
function $f2fd9537b9736456$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $f2fd9537b9736456$export$6ae64dbcd6bfc33e({ hue: hue , saturation: saturation , lightness: lightness , alpha: alpha  }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $f2fd9537b9736456$var$hueToRgb(p, q, hue + 1 / 3);
        green = $f2fd9537b9736456$var$hueToRgb(p, q, hue);
        blue = $f2fd9537b9736456$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





function $84d949ffc7ebc4e9$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}


// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $01245b4a979f486f$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $01245b4a979f486f$var$colorTypes = [
    (0, $aeb63d9188419d43$export$834dfc94dde4b3d8),
    (0, $85af50c0409e6514$export$4e46ac54fc82cf3b),
    (0, $849448f5a3a709c4$export$810b04175080204c)
];
const $01245b4a979f486f$var$getColorType = (v)=>$01245b4a979f486f$var$colorTypes.find((type)=>type.test(v));
function $01245b4a979f486f$var$asRGBA(color) {
    const type = $01245b4a979f486f$var$getColorType(color);
    (0, $eb4f3ac792fc5529$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $849448f5a3a709c4$export$810b04175080204c)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $f2fd9537b9736456$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $01245b4a979f486f$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $01245b4a979f486f$var$asRGBA(from);
    const toRGBA = $01245b4a979f486f$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $84d949ffc7ebc4e9$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $01245b4a979f486f$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $01245b4a979f486f$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $01245b4a979f486f$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $85af50c0409e6514$export$4e46ac54fc82cf3b).transform(blended);
    };
};







const $ec496a39a81ed2a5$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $ec496a39a81ed2a5$export$fed62ccc3fb1a568(origin, target) {
    if ($ec496a39a81ed2a5$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}



function $c4df8059f4d4f707$var$mixNumber(a, b) {
    return (p)=>(0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $c4df8059f4d4f707$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $c4df8059f4d4f707$var$mixNumber;
    else if (typeof a === "string") return (0, $7788fac55eb8bc79$export$31f9caa2600b5723)(a) ? (0, $84d949ffc7ebc4e9$export$a6f92d4bae65c0f1) : (0, $9aa3b4c939055303$export$35e9368ef982300f).test(a) ? (0, $01245b4a979f486f$export$51e568cf5c039bac) : $c4df8059f4d4f707$export$65516310a87d8205;
    else if (Array.isArray(a)) return $c4df8059f4d4f707$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $9aa3b4c939055303$export$35e9368ef982300f).test(a) ? (0, $01245b4a979f486f$export$51e568cf5c039bac) : $c4df8059f4d4f707$export$ebc23b6840c51ba1;
    return 0, $84d949ffc7ebc4e9$export$a6f92d4bae65c0f1;
}
function $c4df8059f4d4f707$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$c4df8059f4d4f707$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $c4df8059f4d4f707$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $c4df8059f4d4f707$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $c4df8059f4d4f707$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $c4df8059f4d4f707$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $20185419c445ef46$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $20185419c445ef46$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $20185419c445ef46$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $ec496a39a81ed2a5$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $ec496a39a81ed2a5$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $ec496a39a81ed2a5$export$fed62ccc3fb1a568)(origin, target);
        return (0, $3e3ea55737c24d5c$export$a4627e546088548d)($c4df8059f4d4f707$export$3bbefa2f402845c4($c4df8059f4d4f707$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $eb4f3ac792fc5529$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $84d949ffc7ebc4e9$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $db0fe8fe6e0bf583$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $c4df8059f4d4f707$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}


function $7a8f7810cf7f62f1$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $db0fe8fe6e0bf583$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $6975d23d92ef960e$export$8793edee2d425525) : ease;
            mixer = (0, $3e3ea55737c24d5c$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $7a8f7810cf7f62f1$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true , ease: ease , mixer: mixer  } = {}) {
    const inputLength = input.length;
    (0, $eb4f3ac792fc5529$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && input[0] === input[1]) return ()=>output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $7a8f7810cf7f62f1$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $98fa8bab6764d451$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $b55556710a8b54c0$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $c3be58b89be3196b$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $98fa8bab6764d451$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $514a1d36e18c8614$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $c3be58b89be3196b$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $14aaf33a81a363c0$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $a21436596a4cb4a3$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $c8b74045bf313d3a$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $a21436596a4cb4a3$export$d25ddfdf17c3ad3e({ duration: duration = 300 , keyframes: keyframeValues , times: times , ease: ease = "easeInOut"  }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $aeb97d5b77acc966$export$216948827bbdc797)(ease) ? ease.map((0, $88c8bfe8b7e57b27$export$ef97fe084f156ca4)) : (0, $88c8bfe8b7e57b27$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $14aaf33a81a363c0$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $514a1d36e18c8614$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $7a8f7810cf7f62f1$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $a21436596a4cb4a3$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}











const $f493cd23202dddb3$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp  })=>update(timestamp);
    return {
        start: ()=>(0, $301e135f87ffeb5c$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $301e135f87ffeb5c$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $301e135f87ffeb5c$export$fff89137e9e818ce).isProcessing ? (0, $301e135f87ffeb5c$export$fff89137e9e818ce).timestamp : (0, $960d9779faf6f40c$export$2da9be4cfdb689b1).now()
    };
};




const $bdbd2d344da3cfef$var$generators = {
    decay: (0, $385208c905445c33$export$ee3ff3a17106998),
    inertia: $385208c905445c33$export$ee3ff3a17106998,
    tween: (0, $a21436596a4cb4a3$export$d25ddfdf17c3ad3e),
    keyframes: (0, $a21436596a4cb4a3$export$d25ddfdf17c3ad3e),
    spring: $9c2b8560de502fe4$export$b36281d89752ae66
};
const $bdbd2d344da3cfef$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $bdbd2d344da3cfef$export$fd98d9cca67a58bc extends (0, $ed332976403bd896$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop  } = this.options;
            onStop && onStop();
        };
        const { name: name , motionValue: motionValue , element: element , keyframes: keyframes  } = this.options;
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $80c84fe89f88d202$export$74d34ca3182f1750);
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    flatten() {
        super.flatten();
        // If we've already resolved the animation, re-initialise it
        if (this._resolved) Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes" , repeat: repeat = 0 , repeatDelay: repeatDelay = 0 , repeatType: repeatType , velocity: velocity = 0  } = this.options;
        const generatorFactory = (0, $be3cf26b78f9cfed$export$6ab7812f1bac68be)(type) ? type : $bdbd2d344da3cfef$var$generators[type] || (0, $a21436596a4cb4a3$export$d25ddfdf17c3ad3e);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $a21436596a4cb4a3$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $3e3ea55737c24d5c$export$a4627e546088548d)($bdbd2d344da3cfef$var$percentToProgress, (0, $db0fe8fe6e0bf583$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $2c9655bdaefca666$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration  } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true  } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved  } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes  } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe , generator: generator , mirroredGenerator: mirroredGenerator , mapPercentToKeyframes: mapPercentToKeyframes , keyframes: keyframes , calculatedDuration: calculatedDuration , totalDuration: totalDuration , resolvedDuration: resolvedDuration  } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay , repeat: repeat , repeatType: repeatType , repeatDelay: repeatDelay , onUpdate: onUpdate  } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $b55556710a8b54c0$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done  } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $511bcb3f09b5d5d2$export$14de59408fad90b)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved  } = this;
        return resolved ? (0, $bfda710cf857a073$export$f64c3bfbc58eec0f)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $bfda710cf857a073$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $bfda710cf857a073$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $f493cd23202dddb3$export$c1033964b5ad7fef) , onPlay: onPlay , startTime: startTime  } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        else if (this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete  } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $bdbd2d344da3cfef$export$ee9b76de7353d815(options) {
    return new $bdbd2d344da3cfef$export$fd98d9cca67a58bc(options);
}


/**
 * A list of values that can be hardware-accelerated.
 */ const $2f9d901ba241375b$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);




function $14eb16b16cce0ebe$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $7524ecb9376af507$export$e3ad02c335474dee = {
    linearEasing: undefined
};


function $3373657c642c2ef3$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $14eb16b16cce0ebe$export$7c73462e0d25e514)(callback);
    return ()=>{
        var _a;
        return (_a = (0, $7524ecb9376af507$export$e3ad02c335474dee)[supportsFlag]) !== null && _a !== void 0 ? _a : memoized();
    };
}


const $93e152a0a07a2840$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $3373657c642c2ef3$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");


function $d454d8d346a47741$export$fcdd8f3f2160beda(easing) {
    return Boolean(typeof easing === "function" && (0, $93e152a0a07a2840$export$866c1d07a1ac2ab)() || !easing || typeof easing === "string" && (easing in $d454d8d346a47741$export$2cf569f5e2221176 || (0, $93e152a0a07a2840$export$866c1d07a1ac2ab)()) || (0, $775b0dd2cff56849$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($d454d8d346a47741$export$fcdd8f3f2160beda));
}
const $d454d8d346a47741$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $d454d8d346a47741$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ $d454d8d346a47741$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ $d454d8d346a47741$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ $d454d8d346a47741$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ $d454d8d346a47741$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $d454d8d346a47741$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function" && (0, $93e152a0a07a2840$export$866c1d07a1ac2ab)()) return (0, $95a8a30344d28284$export$66d3851e2b1ec912)(easing, duration);
    else if ((0, $775b0dd2cff56849$export$ff43f99925d7366b)(easing)) return $d454d8d346a47741$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$d454d8d346a47741$export$916ea73bcd3a6030(segmentEasing, duration) || $d454d8d346a47741$export$2cf569f5e2221176.easeOut);
    else return $d454d8d346a47741$export$2cf569f5e2221176[easing];
}


function $0717cb5fef3b9569$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0 , duration: duration = 300 , repeat: repeat = 0 , repeatType: repeatType = "loop" , ease: ease = "easeInOut" , times: times  } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $d454d8d346a47741$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



function $cd91592bfc8c823e$export$5bd0fcbc73622e13(animation, timeline) {
    animation.timeline = timeline;
    animation.onfinish = null;
}





const $b565a440f4be3b9e$export$51ea9b46fb7a8c5d = /*@__PURE__*/ (0, $14eb16b16cce0ebe$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));


/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $a16b4fc0114fb32a$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $a16b4fc0114fb32a$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $a16b4fc0114fb32a$var$requiresPregeneratedKeyframes(options) {
    return (0, $be3cf26b78f9cfed$export$6ab7812f1bac68be)(options.type) || options.type === "spring" || !(0, $d454d8d346a47741$export$fcdd8f3f2160beda)(options.ease);
}
function $a16b4fc0114fb32a$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $bdbd2d344da3cfef$export$fd98d9cca67a58bc)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $a16b4fc0114fb32a$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $a16b4fc0114fb32a$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $a16b4fc0114fb32a$var$sampleDelta,
        ease: "linear"
    };
}
const $a16b4fc0114fb32a$var$unsupportedEasingFunctions = {
    anticipate: $e12b7a3993b78d59$export$6b0af63b873d419e,
    backInOut: $d8f936f95fb21cba$export$ddc5fd596f6c71b2,
    circInOut: $2c3e49d3e54725d4$export$30d3455eee55bed5
};
function $a16b4fc0114fb32a$var$isUnsupportedEase(key) {
    return key in $a16b4fc0114fb32a$var$unsupportedEasingFunctions;
}
class $a16b4fc0114fb32a$export$2a45abb4e6513325 extends (0, $ed332976403bd896$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        const { name: name , motionValue: motionValue , element: element , keyframes: keyframes  } = this.options;
        this.resolver = new (0, $891e5637f91f7d52$export$4983792d11b61017)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration: duration = 300 , times: times , ease: ease , type: type , motionValue: motionValue , name: name , startTime: startTime  } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
        /**
         * If the user has provided an easing function name that isn't supported
         * by WAAPI (like "anticipate"), we need to provide the corressponding
         * function. This will later get converted to a linear() easing function.
         */ if (typeof ease === "string" && (0, $93e152a0a07a2840$export$866c1d07a1ac2ab)() && $a16b4fc0114fb32a$var$isUnsupportedEase(ease)) ease = $a16b4fc0114fb32a$var$unsupportedEasingFunctions[ease];
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($a16b4fc0114fb32a$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete , onUpdate: onUpdate , motionValue: motionValue , element: element , ...options } = this.options;
            const pregeneratedAnimation = $a16b4fc0114fb32a$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $0717cb5fef3b9569$export$d896de52f97cb615)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        if (this.pendingTimeline) {
            (0, $cd91592bfc8c823e$export$5bd0fcbc73622e13)(animation, this.pendingTimeline);
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete  } = this.options;
            motionValue.set((0, $511bcb3f09b5d5d2$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved  } = this;
        if (!resolved) return 0;
        const { duration: duration  } = resolved;
        return (0, $bfda710cf857a073$export$f64c3bfbc58eec0f)(duration);
    }
    get time() {
        const { resolved: resolved  } = this;
        if (!resolved) return 0;
        const { animation: animation  } = resolved;
        return (0, $bfda710cf857a073$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved  } = this;
        if (!resolved) return;
        const { animation: animation  } = resolved;
        animation.currentTime = (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        const { resolved: resolved  } = this;
        if (!resolved) return 1;
        const { animation: animation  } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved  } = this;
        if (!resolved) return;
        const { animation: animation  } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved  } = this;
        if (!resolved) return "idle";
        const { animation: animation  } = resolved;
        return animation.playState;
    }
    get startTime() {
        const { resolved: resolved  } = this;
        if (!resolved) return null;
        const { animation: animation  } = resolved;
        // Coerce to number as TypeScript incorrectly types this
        // as CSSNumberish
        return animation.startTime;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved  } = this;
            if (!resolved) return 0, $6975d23d92ef960e$export$8793edee2d425525;
            const { animation: animation  } = resolved;
            (0, $cd91592bfc8c823e$export$5bd0fcbc73622e13)(animation, timeline);
        }
        return 0, $6975d23d92ef960e$export$8793edee2d425525;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved  } = this;
        if (!resolved) return;
        const { animation: animation  } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved  } = this;
        if (!resolved) return;
        const { animation: animation  } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved: resolved  } = this;
        if (!resolved) return;
        const { animation: animation , keyframes: keyframes , duration: duration , type: type , ease: ease , times: times  } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue , onUpdate: onUpdate , onComplete: onComplete , element: element , ...options } = this.options;
            const sampleAnimation = new (0, $bdbd2d344da3cfef$export$fd98d9cca67a58bc)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $a16b4fc0114fb32a$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $a16b4fc0114fb32a$var$sampleDelta);
        }
        const { onStop: onStop  } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved: resolved  } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved  } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue , name: name , repeatDelay: repeatDelay , repeatType: repeatType , damping: damping , type: type  } = options;
        return (0, $b565a440f4be3b9e$export$51ea9b46fb7a8c5d)() && name && (0, $2f9d901ba241375b$export$a27eefbd8fb5e404).has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}




const $86e86c2597ba3556$export$20d68f04f30763a5 = (0, $14eb16b16cce0ebe$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);


class $3abee9a5ece0b64c$export$c1e41718f71efe41 {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline, fallback) {
        const subscriptions = this.animations.map((animation)=>{
            if ((0, $86e86c2597ba3556$export$20d68f04f30763a5)() && animation.attachTimeline) return animation.attachTimeline(timeline);
            else return fallback(animation);
        });
        return ()=>{
            subscriptions.forEach((cancel, i)=>{
                cancel && cancel();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    flatten() {
        this.runAll("flatten");
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $17d17a0e09288119$export$ca8e47dc8ed5a9d7({ when: when , delay: _delay , delayChildren: delayChildren , staggerChildren: staggerChildren , staggerDirection: staggerDirection , repeat: repeat , repeatType: repeatType , repeatDelay: repeatDelay , from: from , elapsed: elapsed , ...transition }) {
    return !!Object.keys(transition).length;
}


const $b414a5ed52d2ead3$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $32a29353ee2b3961$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0  } = transition;
        elapsed = elapsed - (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $17d17a0e09288119$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $d51b9411f6ccbbd1$export$262124b154b9f1c0)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $f006002175d4313e$export$888a3d84909f9e3d).current || (0, $3cdabdabfda62d22$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $511bcb3f09b5d5d2$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $301e135f87ffeb5c$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $3abee9a5ece0b64c$export$c1e41718f71efe41)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $a16b4fc0114fb32a$export$2a45abb4e6513325).supports(options)) return new (0, $a16b4fc0114fb32a$export$2a45abb4e6513325)(options);
        else return new (0, $bdbd2d344da3cfef$export$fd98d9cca67a58bc)(options);
    };



const $0d15acf980467e42$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $0d15acf980467e42$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $6f683bc80c6d969e$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};


function $d2a9bfd104bd5453$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $d2a9bfd104bd5453$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $d2a9bfd104bd5453$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $97358bb0f01597b3$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $d2a9bfd104bd5453$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $d2a9bfd104bd5453$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}






/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $4b2846f88af5423d$var$MAX_VELOCITY_DELTA = 30;
const $4b2846f88af5423d$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $4b2846f88af5423d$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $4b2846f88af5423d$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.15.0";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $960d9779faf6f40c$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $960d9779faf6f40c$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $4b2846f88af5423d$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $97358bb0f01597b3$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $301e135f87ffeb5c$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($4b2846f88af5423d$export$67fcd818a264039d.current) $4b2846f88af5423d$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $960d9779faf6f40c$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $4b2846f88af5423d$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $4b2846f88af5423d$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $802cd06bac70029a$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $4b2846f88af5423d$export$ce8bdc721e76545f(init, options) {
    return new $4b2846f88af5423d$export$8cea36d14ee64562(init, options);
}



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $e4befcaa41a4f540$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $4b2846f88af5423d$export$ce8bdc721e76545f)(value));
}
function $e4befcaa41a4f540$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $730ab9aa0424fb5a$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {} , transition: transition = {} , ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $0d15acf980467e42$export$5485128c47bd48bb)(target[key]);
        $e4befcaa41a4f540$var$setMotionValue(visualElement, key, value);
    }
}



/**
 * Convert camelCase to dash-case properties.
 */ const $ccc055b4a72c1347$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();


const $99c2b47e65be39f1$export$ed7b8fa9dbf0105d = "framerAppearId";
const $99c2b47e65be39f1$export$8592e1c077c890a6 = "data-" + (0, $ccc055b4a72c1347$export$9fd24a634729c672)($99c2b47e65be39f1$export$ed7b8fa9dbf0105d);


function $a2e0096f48bfe337$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $99c2b47e65be39f1$export$8592e1c077c890a6];
}


const $65e8d3d378a9947e$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);


function $78c97899e24aca1c$export$98397f3adbf6259f(value) {
    return Boolean((0, $65e8d3d378a9947e$export$605d60a2578142d3)(value) && value.add);
}


function $fe6568ba6a5a8ee5$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $78c97899e24aca1c$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $63d62870b9fa1dce$var$shouldBlockAnimation({ protectedKeys: protectedKeys , needsAnimating: needsAnimating  }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $63d62870b9fa1dce$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0 , transitionOverride: transitionOverride , type: type  } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition() , transitionEnd: transitionEnd , ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $63d62870b9fa1dce$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $32a29353ee2b3961$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $a2e0096f48bfe337$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $301e135f87ffeb5c$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $fe6568ba6a5a8ee5$export$3ac5aed310be0bee)(visualElement, key);
        value.start((0, $b414a5ed52d2ead3$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $da211e07316d6e39$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $301e135f87ffeb5c$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $e4befcaa41a4f540$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}




function $f24a58bcb9fc172f$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $730ab9aa0424fb5a$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {}  } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $63d62870b9fa1dce$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0 , staggerChildren: staggerChildren , staggerDirection: staggerDirection  } = transition;
        return $f24a58bcb9fc172f$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when  } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $f24a58bcb9fc172f$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($f24a58bcb9fc172f$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($f24a58bcb9fc172f$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $f24a58bcb9fc172f$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $e364f8e011fb793b$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $f24a58bcb9fc172f$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $f24a58bcb9fc172f$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $730ab9aa0424fb5a$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $63d62870b9fa1dce$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}




const $2d899736d6d992a2$var$numVariantProps = (0, $46d8d186c05e43b0$export$1405a65085f40b9).length;
function $2d899736d6d992a2$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $2d899736d6d992a2$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $2d899736d6d992a2$var$numVariantProps; i++){
        const name = (0, $46d8d186c05e43b0$export$1405a65085f40b9)[i];
        const prop = visualElement.props[name];
        if ((0, $a36779356b36fa8a$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
    }
    return context;
}


const $b147b3fbcf8b2fc8$var$reversePriorityOrder = [
    ...(0, $46d8d186c05e43b0$export$16e45afcc206d3a8)
].reverse();
const $b147b3fbcf8b2fc8$var$numAnimationTypes = (0, $46d8d186c05e43b0$export$16e45afcc206d3a8).length;
function $b147b3fbcf8b2fc8$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation , options: options  })=>(0, $e364f8e011fb793b$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $b147b3fbcf8b2fc8$export$bb53502b7a672aa8(visualElement) {
    let animate = $b147b3fbcf8b2fc8$var$animateList(visualElement);
    let state = $b147b3fbcf8b2fc8$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $730ab9aa0424fb5a$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition , transitionEnd: transitionEnd , ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props  } = visualElement;
        const context = (0, $2d899736d6d992a2$export$6669f52f7ffa343b)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $b147b3fbcf8b2fc8$var$numAnimationTypes; i++){
            const type = $b147b3fbcf8b2fc8$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $a36779356b36fa8a$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $0c915d7372d9814d$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $b147b3fbcf8b2fc8$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {}  } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $6f683bc80c6d969e$export$9153ad4c4999f4a0)(next) && (0, $6f683bc80c6d969e$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $423df1fac2a0b98a$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $b147b3fbcf8b2fc8$var$createState();
            isInitialRender = true;
        }
    };
}
function $b147b3fbcf8b2fc8$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $423df1fac2a0b98a$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $b147b3fbcf8b2fc8$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $b147b3fbcf8b2fc8$var$createState() {
    return {
        animate: $b147b3fbcf8b2fc8$var$createTypeState(true),
        whileInView: $b147b3fbcf8b2fc8$var$createTypeState(),
        whileHover: $b147b3fbcf8b2fc8$var$createTypeState(),
        whileTap: $b147b3fbcf8b2fc8$var$createTypeState(),
        whileDrag: $b147b3fbcf8b2fc8$var$createTypeState(),
        whileFocus: $b147b3fbcf8b2fc8$var$createTypeState(),
        exit: $b147b3fbcf8b2fc8$var$createTypeState()
    };
}


class $c280630d94a7df00$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


class $4c042cb37597b7b9$export$b45b3fe5caabdca extends (0, $c280630d94a7df00$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $b147b3fbcf8b2fc8$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate  } = this.node.getProps();
        if ((0, $0c915d7372d9814d$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate  } = this.node.getProps();
        const { animate: prevAnimate  } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
}



let $1d482825f4aa3400$var$id = 0;
class $1d482825f4aa3400$export$4989d1eb6104cc6c extends (0, $c280630d94a7df00$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $1d482825f4aa3400$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent , onExitComplete: onExitComplete  } = this.node.presenceContext;
        const { isPresent: prevIsPresent  } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register  } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $7170ce59c2debd45$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $4c042cb37597b7b9$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $1d482825f4aa3400$export$4989d1eb6104cc6c)
    }
};





const $2a2fa9f429e20624$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $2a2fa9f429e20624$export$1b3dd616664938e4() {
    return $2a2fa9f429e20624$export$9e9bc3c487fccc00.x || $2a2fa9f429e20624$export$9e9bc3c487fccc00.y;
}


function $fd9c2b17909918eb$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    var _a;
    if (elementOrSelector instanceof Element) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) // TODO: Refactor to utils package
        // invariant(
        //     Boolean(scope.current),
        //     "Scope provided, but no element detected."
        // )
        root = scope.current;
        const elements = (_a = selectorCache === null || selectorCache === void 0 ? void 0 : selectorCache[elementOrSelector]) !== null && _a !== void 0 ? _a : root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}


function $c9710ee94546c886$export$edc0ace9d5e7e842(elementOrSelector, options) {
    const elements = (0, $fd9c2b17909918eb$export$90ceba2564a894f8)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal
    };
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}


/**
 * Filter out events that are not pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $d31b8a36e1731954$var$filterEvents(callback) {
    return (event)=>{
        if (event.pointerType === "touch" || (0, $2a2fa9f429e20624$export$1b3dd616664938e4)()) return;
        callback(event);
    };
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $d31b8a36e1731954$export$3f60957f5dbf3876(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, $c9710ee94546c886$export$edc0ace9d5e7e842)(elementOrSelector, options);
    const onPointerEnter = $d31b8a36e1731954$var$filterEvents((enterEvent)=>{
        const { target: target  } = enterEvent;
        const onHoverEnd = onHoverStart(enterEvent);
        if (!onHoverEnd || !target) return;
        const onPointerLeave = $d31b8a36e1731954$var$filterEvents((leaveEvent)=>{
            onHoverEnd(leaveEvent);
            target.removeEventListener("pointerleave", onPointerLeave);
        });
        target.addEventListener("pointerleave", onPointerLeave, eventOptions);
    });
    elements.forEach((element)=>{
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
    });
    return cancel;
}



const $03b1f4ad63bbdd2a$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};



const $a8d4d0c2a5ae7cfa$export$7987404a4e35b84b = new WeakSet();


/**
 * Filter out events that are not "Enter" keys.
 */ function $2a5797327d27b1e0$var$filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $2a5797327d27b1e0$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const $2a5797327d27b1e0$export$4b5790288fe12a79 = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = $2a5797327d27b1e0$var$filterEvents(()=>{
        if ((0, $a8d4d0c2a5ae7cfa$export$7987404a4e35b84b).has(element)) return;
        $2a5797327d27b1e0$var$firePointerEvent(element, "down");
        const handleKeyup = $2a5797327d27b1e0$var$filterEvents(()=>{
            $2a5797327d27b1e0$var$firePointerEvent(element, "up");
        });
        const handleBlur = ()=>$2a5797327d27b1e0$var$firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};


const $2db7149ca38be98c$var$focusableElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
function $2db7149ca38be98c$export$5f6976e2f961e8b7(element) {
    return $2db7149ca38be98c$var$focusableElements.has(element.tagName) || element.tabIndex !== -1;
}


/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $0049c1ffab9d8a6d$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $0049c1ffab9d8a6d$export$e841ada32ff745b(parent, child.parentElement);
};



/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $f444734fe50af5ec$var$isValidPressEvent(event) {
    return (0, $03b1f4ad63bbdd2a$export$a4cf9c8a4b063a6e)(event) && !(0, $2a2fa9f429e20624$export$1b3dd616664938e4)();
}
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $f444734fe50af5ec$export$dbe9198142dace0c(elementOrSelector, onPressStart, options = {}) {
    const [elements, eventOptions, cancelEvents] = (0, $c9710ee94546c886$export$edc0ace9d5e7e842)(elementOrSelector, options);
    const startPress = (startEvent)=>{
        const element = startEvent.currentTarget;
        if (!$f444734fe50af5ec$var$isValidPressEvent(startEvent) || (0, $a8d4d0c2a5ae7cfa$export$7987404a4e35b84b).has(element)) return;
        (0, $a8d4d0c2a5ae7cfa$export$7987404a4e35b84b).add(element);
        const onPressEnd = onPressStart(startEvent);
        const onPointerEnd = (endEvent, success)=>{
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if (!$f444734fe50af5ec$var$isValidPressEvent(endEvent) || !(0, $a8d4d0c2a5ae7cfa$export$7987404a4e35b84b).has(element)) return;
            (0, $a8d4d0c2a5ae7cfa$export$7987404a4e35b84b).delete(element);
            if (onPressEnd) onPressEnd(endEvent, {
                success: success
            });
        };
        const onPointerUp = (upEvent)=>{
            onPointerEnd(upEvent, options.useGlobalTarget || (0, $0049c1ffab9d8a6d$export$e841ada32ff745b)(element, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    elements.forEach((element)=>{
        if (!(0, $2db7149ca38be98c$export$5f6976e2f961e8b7)(element)) element.tabIndex = 0;
        const target = options.useGlobalTarget ? window : element;
        target.addEventListener("pointerdown", startPress, eventOptions);
        element.addEventListener("focus", (event)=>(0, $2a5797327d27b1e0$export$4b5790288fe12a79)(event, eventOptions), eventOptions);
    });
    return cancelEvents;
}





function $b0c162f708e82302$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $2a2fa9f429e20624$export$9e9bc3c487fccc00)[axis]) return null;
        else {
            (0, $2a2fa9f429e20624$export$9e9bc3c487fccc00)[axis] = true;
            return ()=>{
                (0, $2a2fa9f429e20624$export$9e9bc3c487fccc00)[axis] = false;
            };
        }
    } else {
        if ((0, $2a2fa9f429e20624$export$9e9bc3c487fccc00).x || (0, $2a2fa9f429e20624$export$9e9bc3c487fccc00).y) return null;
        else {
            (0, $2a2fa9f429e20624$export$9e9bc3c487fccc00).x = (0, $2a2fa9f429e20624$export$9e9bc3c487fccc00).y = true;
            return ()=>{
                (0, $2a2fa9f429e20624$export$9e9bc3c487fccc00).x = (0, $2a2fa9f429e20624$export$9e9bc3c487fccc00).y = false;
            };
        }
    }
}







function $19290b72856733e8$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const $19290b72856733e8$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $03b1f4ad63bbdd2a$export$a4cf9c8a4b063a6e)(event) && handler(event, $19290b72856733e8$export$12f84bb882d06e1a(event));
};



function $a8c57a49f398792d$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}



function $a3b5ca0718993d16$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $a8c57a49f398792d$export$b1d829ddf82884aa)(target, eventName, (0, $19290b72856733e8$export$c404e80f92c98d29)(handler), options);
}



const $4139a982bce3ebbd$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $4139a982bce3ebbd$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $4139a982bce3ebbd$export$9f17032d917177de(a.x, b.x);
    const yDelta = $4139a982bce3ebbd$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $8f5d92e6e3694ff2$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint , contextWindow: contextWindow , dragSnapToOrigin: dragSnapToOrigin = false  } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $8f5d92e6e3694ff2$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $4139a982bce3ebbd$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point  } = info;
            const { timestamp: timestamp  } = (0, $301e135f87ffeb5c$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart , onMove: onMove  } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $8f5d92e6e3694ff2$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $301e135f87ffeb5c$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd , onSessionEnd: onSessionEnd , resumeAnimation: resumeAnimation  } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $8f5d92e6e3694ff2$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $8f5d92e6e3694ff2$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $03b1f4ad63bbdd2a$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $19290b72856733e8$export$12f84bb882d06e1a)(event);
        const initialInfo = $8f5d92e6e3694ff2$var$transformPoint(info, this.transformPagePoint);
        const { point: point  } = initialInfo;
        const { timestamp: timestamp  } = (0, $301e135f87ffeb5c$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart  } = handlers;
        onSessionStart && onSessionStart(event, $8f5d92e6e3694ff2$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $3e3ea55737c24d5c$export$a4627e546088548d)((0, $a3b5ca0718993d16$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $a3b5ca0718993d16$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $a3b5ca0718993d16$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $301e135f87ffeb5c$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $8f5d92e6e3694ff2$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $8f5d92e6e3694ff2$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $8f5d92e6e3694ff2$var$getPanInfo({ point: point  }, history) {
    return {
        point: point,
        delta: $8f5d92e6e3694ff2$var$subtractPoint(point, $8f5d92e6e3694ff2$var$lastDevicePoint(history)),
        offset: $8f5d92e6e3694ff2$var$subtractPoint(point, $8f5d92e6e3694ff2$var$startDevicePoint(history)),
        velocity: $8f5d92e6e3694ff2$var$getVelocity(history, 0.1)
    };
}
function $8f5d92e6e3694ff2$var$startDevicePoint(history) {
    return history[0];
}
function $8f5d92e6e3694ff2$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $8f5d92e6e3694ff2$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $8f5d92e6e3694ff2$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $bfda710cf857a073$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}


function $7be42aa7b9b2349b$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}





const $a1e42a4af2333fb7$var$SCALE_PRECISION = 0.0001;
const $a1e42a4af2333fb7$var$SCALE_MIN = 1 - $a1e42a4af2333fb7$var$SCALE_PRECISION;
const $a1e42a4af2333fb7$var$SCALE_MAX = 1 + $a1e42a4af2333fb7$var$SCALE_PRECISION;
const $a1e42a4af2333fb7$var$TRANSLATE_PRECISION = 0.01;
const $a1e42a4af2333fb7$var$TRANSLATE_MIN = 0 - $a1e42a4af2333fb7$var$TRANSLATE_PRECISION;
const $a1e42a4af2333fb7$var$TRANSLATE_MAX = 0 + $a1e42a4af2333fb7$var$TRANSLATE_PRECISION;
function $a1e42a4af2333fb7$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $a1e42a4af2333fb7$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $a1e42a4af2333fb7$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $a1e42a4af2333fb7$export$c1c127004b72a37(target) / $a1e42a4af2333fb7$export$c1c127004b72a37(source);
    delta.translate = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $a1e42a4af2333fb7$var$SCALE_MIN && delta.scale <= $a1e42a4af2333fb7$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $a1e42a4af2333fb7$var$TRANSLATE_MIN && delta.translate <= $a1e42a4af2333fb7$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $a1e42a4af2333fb7$export$c0d25e96fc67d310(delta, source, target, origin) {
    $a1e42a4af2333fb7$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $a1e42a4af2333fb7$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $a1e42a4af2333fb7$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $a1e42a4af2333fb7$export$c1c127004b72a37(relative);
}
function $a1e42a4af2333fb7$export$426154f9d100f99(target, relative, parent) {
    $a1e42a4af2333fb7$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $a1e42a4af2333fb7$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $a1e42a4af2333fb7$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $a1e42a4af2333fb7$export$c1c127004b72a37(layout);
}
function $a1e42a4af2333fb7$export$2785bfcc929c5650(target, layout, parent) {
    $a1e42a4af2333fb7$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $a1e42a4af2333fb7$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $80b0c15e89836697$export$b3c764d3fca3ffe3(point, { min: min , max: max  }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $80b0c15e89836697$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $80b0c15e89836697$export$4e9195bf7793bc78(layoutBox, { top: top , left: left , bottom: bottom , right: right  }) {
    return {
        x: $80b0c15e89836697$export$690c180aa5775042(layoutBox.x, left, right),
        y: $80b0c15e89836697$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $80b0c15e89836697$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $80b0c15e89836697$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $80b0c15e89836697$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $80b0c15e89836697$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $80b0c15e89836697$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(source);
    const targetLength = (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $98fa8bab6764d451$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $98fa8bab6764d451$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $b55556710a8b54c0$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $80b0c15e89836697$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $80b0c15e89836697$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $80b0c15e89836697$export$7c5eaef8f4723d22(dragElastic = $80b0c15e89836697$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $80b0c15e89836697$export$a3366d3bac43a742;
    return {
        x: $80b0c15e89836697$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $80b0c15e89836697$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $80b0c15e89836697$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $80b0c15e89836697$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $80b0c15e89836697$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $80b0c15e89836697$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $704cbd53c53f9d5c$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $704cbd53c53f9d5c$export$3d227df54007d73a = ()=>({
        x: $704cbd53c53f9d5c$export$ff25708b37f72782(),
        y: $704cbd53c53f9d5c$export$ff25708b37f72782()
    });
const $704cbd53c53f9d5c$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $704cbd53c53f9d5c$export$6459fc9e86be362e = ()=>({
        x: $704cbd53c53f9d5c$export$6db76765312617ac(),
        y: $704cbd53c53f9d5c$export$6db76765312617ac()
    });


function $2c62bc0ac9269350$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $51f4355a9b48a0fa$export$d3955c6a8f65a36b({ top: top , left: left , right: right , bottom: bottom  }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $51f4355a9b48a0fa$export$b6b9cd4198191a47({ x: x , y: y  }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $51f4355a9b48a0fa$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $43492ab836cff22d$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $43492ab836cff22d$export$bdf30dca883ea463({ scale: scale , scaleX: scaleX , scaleY: scaleY  }) {
    return !$43492ab836cff22d$var$isIdentityScale(scale) || !$43492ab836cff22d$var$isIdentityScale(scaleX) || !$43492ab836cff22d$var$isIdentityScale(scaleY);
}
function $43492ab836cff22d$export$a545127cf1fbb600(values) {
    return $43492ab836cff22d$export$bdf30dca883ea463(values) || $43492ab836cff22d$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $43492ab836cff22d$export$bf80f5f8f4dc327f(values) {
    return $43492ab836cff22d$var$is2DTranslate(values.x) || $43492ab836cff22d$var$is2DTranslate(values.y);
}
function $43492ab836cff22d$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $3cadfa9c5538c02d$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $3cadfa9c5538c02d$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $3cadfa9c5538c02d$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $3cadfa9c5538c02d$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $3cadfa9c5538c02d$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $3cadfa9c5538c02d$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $3cadfa9c5538c02d$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $3cadfa9c5538c02d$export$d80074982803af5c(box, { x: x , y: y  }) {
    $3cadfa9c5538c02d$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $3cadfa9c5538c02d$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $3cadfa9c5538c02d$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $3cadfa9c5538c02d$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $3cadfa9c5538c02d$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement  } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $3cadfa9c5538c02d$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $3cadfa9c5538c02d$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $43492ab836cff22d$export$a545127cf1fbb600)(node.latestValues)) $3cadfa9c5538c02d$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $3cadfa9c5538c02d$var$TREE_SCALE_SNAP_MAX && treeScale.x > $3cadfa9c5538c02d$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $3cadfa9c5538c02d$var$TREE_SCALE_SNAP_MAX && treeScale.y > $3cadfa9c5538c02d$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $3cadfa9c5538c02d$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $3cadfa9c5538c02d$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $3cadfa9c5538c02d$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $3cadfa9c5538c02d$export$58b16271041fbfb(box, transform) {
    $3cadfa9c5538c02d$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $3cadfa9c5538c02d$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $5df6dc38d07b7e46$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $51f4355a9b48a0fa$export$d3955c6a8f65a36b)((0, $51f4355a9b48a0fa$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $5df6dc38d07b7e46$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $5df6dc38d07b7e46$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll  } = rootProjectionNode;
    if (scroll) {
        (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/motiondivision/motion/issues/2270
const $332a2655753b90cb$export$d533d84f9871c879 = ({ current: current  })=>{
    return current ? current.ownerDocument.defaultView : null;
};




const $8c2f26a6b37d6dc9$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $8c2f26a6b37d6dc9$export$86bff71f18910307 {
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false  } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext  } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin  } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $19290b72856733e8$export$12f84bb882d06e1a)(event).point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag , dragPropagation: dragPropagation , onDragStart: onDragStart  } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, $b0c162f708e82302$export$64d8a3fd7eb621d5)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $e8f3e6c5adc69edc$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection  } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            (0, $fe6568ba6a5a8ee5$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState  } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation , dragDirectionLock: dragDirectionLock , onDirectionLock: onDirectionLock , onDrag: onDrag  } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset: offset  } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $8c2f26a6b37d6dc9$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin  } = this.getProps();
        this.panSession = new (0, $8f5d92e6e3694ff2$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $332a2655753b90cb$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity  } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd  } = this.getProps();
        if (onDragEnd) (0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection , animationState: animationState  } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation  } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag  } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$8c2f26a6b37d6dc9$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $80b0c15e89836697$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints , dragElastic: dragElastic  } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $7be42aa7b9b2349b$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $80b0c15e89836697$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $80b0c15e89836697$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $80b0c15e89836697$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints , onMeasureDragConstraints: onMeasureDragConstraints  } = this.getProps();
        if (!constraints || !(0, $7be42aa7b9b2349b$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $eb4f3ac792fc5529$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection  } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $5df6dc38d07b7e46$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $80b0c15e89836697$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $51f4355a9b48a0fa$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $51f4355a9b48a0fa$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag , dragMomentum: dragMomentum , dragElastic: dragElastic , dragTransition: dragTransition , dragSnapToOrigin: dragSnapToOrigin , onDragTransitionEnd: onDragTransitionEnd  } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
            if (!$8c2f26a6b37d6dc9$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $fe6568ba6a5a8ee5$export$3ac5aed310be0bee)(this.visualElement, axis);
        return axisValue.start((0, $b414a5ed52d2ead3$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
            const { drag: drag  } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$8c2f26a6b37d6dc9$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection  } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min , max: max  } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag , dragConstraints: dragConstraints  } = this.getProps();
        const { projection: projection  } = this.visualElement;
        if (!(0, $7be42aa7b9b2349b$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $80b0c15e89836697$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate  } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
            if (!$8c2f26a6b37d6dc9$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min , max: max  } = this.constraints[axis];
            axisValue.set((0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $8c2f26a6b37d6dc9$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $a3b5ca0718993d16$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag , dragListener: dragListener = true  } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints  } = this.getProps();
            if ((0, $7be42aa7b9b2349b$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection  } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $301e135f87ffeb5c$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $a8c57a49f398792d$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta , hasLayoutChanged: hasLayoutChanged  })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false , dragDirectionLock: dragDirectionLock = false , dragPropagation: dragPropagation = false , dragConstraints: dragConstraints = false , dragElastic: dragElastic = (0, $80b0c15e89836697$export$a3366d3bac43a742) , dragMomentum: dragMomentum = true  } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $8c2f26a6b37d6dc9$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $8c2f26a6b37d6dc9$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $aedcddc2627aa96c$export$5d97dc2872682820 extends (0, $c280630d94a7df00$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $6975d23d92ef960e$export$8793edee2d425525);
        this.removeListeners = (0, $6975d23d92ef960e$export$8793edee2d425525);
        this.controls = new (0, $8c2f26a6b37d6dc9$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls  } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $6975d23d92ef960e$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $07770208fc6498da$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $07770208fc6498da$export$b4f8f1ee75ce5859 extends (0, $c280630d94a7df00$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $6975d23d92ef960e$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $8f5d92e6e3694ff2$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $332a2655753b90cb$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart , onPanStart: onPanStart , onPan: onPan , onPanEnd: onPanEnd  } = this.node.getProps();
        return {
            onSessionStart: $07770208fc6498da$var$asyncHandler(onPanSessionStart),
            onStart: $07770208fc6498da$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $a3b5ca0718993d16$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}




var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
"use client";
/**
 * @public
 */ const $32835478aabc17b5$export$f224e4635b6f8ce2 = (0, $exYeM.createContext)(null);


/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $eecb2e495db1f2fd$export$2a8c16d82a0a0e26() {
    const context = (0, $exYeM.useContext)((0, $32835478aabc17b5$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent , onExitComplete: onExitComplete , register: register  } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $exYeM.useId)();
    (0, $exYeM.useEffect)(()=>register(id), []);
    const safeToRemove = (0, $exYeM.useCallback)(()=>onExitComplete && onExitComplete(id), [
        id,
        onExitComplete
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $eecb2e495db1f2fd$export$8249053f690ea39a() {
    return $eecb2e495db1f2fd$export$ee27c052bca048fb((0, $exYeM.useContext)((0, $32835478aabc17b5$export$f224e4635b6f8ce2)));
}
function $eecb2e495db1f2fd$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}



var $exYeM = parcelRequire("exYeM");
"use client";
const $0d8fa753a19a110b$export$a3579ca508007a95 = (0, $exYeM.createContext)({});



var $exYeM = parcelRequire("exYeM");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $df9c3e45a16d5ebc$export$da5f7b802957459a = (0, $exYeM.createContext)({});


/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $d92fcbc1a711d121$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $58b16b9942e44958$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $58b16b9942e44958$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $58b16b9942e44958$export$fafff692be55225d(latest, node.target.x);
        const y = $58b16b9942e44958$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $011a5e472cdf5fa8$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale , projectionDelta: projectionDelta  })=>{
        const original = latest;
        const shadow = (0, $20185419c445ef46$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $20185419c445ef46$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};


const $93099dc5c3aa7524$export$91ddd985b97788d1 = {};
function $93099dc5c3aa7524$export$de9e7791c71225fd(correctors) {
    Object.assign($93099dc5c3aa7524$export$91ddd985b97788d1, correctors);
}



const { schedule: $a1ef008917ac1826$export$bb76eed83315504c , cancel: $a1ef008917ac1826$export$3252729004b8456e  } = (0, $2c4ecd0dc095867d$export$510b0596a933801a)(queueMicrotask, false);



"use client";
class $c3c24be56499347e$var$MeasureLayoutWithContext extends (0, $exYeM.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement , layoutGroup: layoutGroup , switchLayoutGroup: switchLayoutGroup , layoutId: layoutId  } = this.props;
        const { projection: projection  } = visualElement;
        (0, $93099dc5c3aa7524$export$de9e7791c71225fd)($c3c24be56499347e$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $d92fcbc1a711d121$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency , visualElement: visualElement , drag: drag , isPresent: isPresent  } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection  } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $a1ef008917ac1826$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement , layoutGroup: layoutGroup , switchLayoutGroup: promoteContext  } = this.props;
        const { projection: projection  } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove  } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $c3c24be56499347e$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $eecb2e495db1f2fd$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $exYeM.useContext)((0, $0d8fa753a19a110b$export$a3579ca508007a95));
    return (0, $7ead0b1397a835ed$exports.jsx)($c3c24be56499347e$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $exYeM.useContext)((0, $df9c3e45a16d5ebc$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $c3c24be56499347e$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $58b16b9942e44958$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $58b16b9942e44958$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $58b16b9942e44958$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $58b16b9942e44958$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $58b16b9942e44958$export$5eafb6257a5844c),
    boxShadow: (0, $011a5e472cdf5fa8$export$eb0bc629e74dcf8)
};








const $b0eff65bd8993999$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $b0eff65bd8993999$var$numBorders = $b0eff65bd8993999$var$borders.length;
const $b0eff65bd8993999$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $b0eff65bd8993999$var$isPx = (value)=>typeof value === "number" || (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008).test(value);
function $b0eff65bd8993999$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $b0eff65bd8993999$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, 0, $b0eff65bd8993999$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $b0eff65bd8993999$var$numBorders; i++){
        const borderLabel = `border${$b0eff65bd8993999$var$borders[i]}Radius`;
        let followRadius = $b0eff65bd8993999$var$getRadius(follow, borderLabel);
        let leadRadius = $b0eff65bd8993999$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $b0eff65bd8993999$var$isPx(followRadius) === $b0eff65bd8993999$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)($b0eff65bd8993999$var$asNumber(followRadius), $b0eff65bd8993999$var$asNumber(leadRadius), progress), 0);
            if ((0, $e8f3e6c5adc69edc$export$626336c2cd4b14de).test(leadRadius) || (0, $e8f3e6c5adc69edc$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $b0eff65bd8993999$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $b0eff65bd8993999$var$easeCrossfadeIn = /*@__PURE__*/ $b0eff65bd8993999$var$compress(0, 0.5, (0, $2c3e49d3e54725d4$export$c8d67a19199d1a50));
const $b0eff65bd8993999$var$easeCrossfadeOut = /*@__PURE__*/ $b0eff65bd8993999$var$compress(0.5, 0.95, (0, $6975d23d92ef960e$export$8793edee2d425525));
function $b0eff65bd8993999$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $98fa8bab6764d451$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $350541e2d10af992$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $350541e2d10af992$export$c53fd88f45d77e4b(box, originBox) {
    $350541e2d10af992$export$a0230ae482601ae8(box.x, originBox.x);
    $350541e2d10af992$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $350541e2d10af992$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $e3be0578d1881dff$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $3cadfa9c5538c02d$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $3cadfa9c5538c02d$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $e3be0578d1881dff$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $e8f3e6c5adc69edc$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $e3be0578d1881dff$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $e3be0578d1881dff$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $e3be0578d1881dff$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $e3be0578d1881dff$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $e3be0578d1881dff$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $e3be0578d1881dff$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $e3be0578d1881dff$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $e3be0578d1881dff$export$42b76f1d0d16d5b(box.x, transforms, $e3be0578d1881dff$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $e3be0578d1881dff$export$42b76f1d0d16d5b(box.y, transforms, $e3be0578d1881dff$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $62d95540b2cf82c6$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $62d95540b2cf82c6$export$a7ec7642fe550fb6(delta) {
    return $62d95540b2cf82c6$var$isAxisDeltaZero(delta.x) && $62d95540b2cf82c6$var$isAxisDeltaZero(delta.y);
}
function $62d95540b2cf82c6$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $62d95540b2cf82c6$export$8d5cf76bb7daff09(a, b) {
    return $62d95540b2cf82c6$export$7a9a6f114ddd0fdb(a.x, b.x) && $62d95540b2cf82c6$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $62d95540b2cf82c6$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $62d95540b2cf82c6$export$ef641b782d85522(a, b) {
    return $62d95540b2cf82c6$export$22adf28bfca1c186(a.x, b.x) && $62d95540b2cf82c6$export$22adf28bfca1c186(a.y, b.y);
}
function $62d95540b2cf82c6$export$c5706146bc63213(box) {
    return (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(box.x) / (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(box.y);
}
function $62d95540b2cf82c6$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $b677bc2ebc452ee9$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $d2a9bfd104bd5453$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $d2a9bfd104bd5453$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade  } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options , resumingFrom: resumingFrom  } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $e1a92a4c0809d32f$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective , rotate: rotate , rotateX: rotateX , rotateY: rotateY , skewX: skewX , skewY: skewY  } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $80818efe87296e52$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $06918006e178146a$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $d2a9bfd104bd5453$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $d2a9bfd104bd5453$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $80818efe87296e52$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}




/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $a6687c7d507e2d36$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $65e8d3d378a9947e$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $0d15acf980467e42$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}






/**
 * Timeout defined in ms
 */ function $ada4fe415778225f$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $960d9779faf6f40c$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp  })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $301e135f87ffeb5c$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $301e135f87ffeb5c$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $301e135f87ffeb5c$export$ec99c0ef4978dccb)(checkElapsed);
}
function $ada4fe415778225f$export$fcd451ca460f8a2a(callback, timeout) {
    return $ada4fe415778225f$export$1391212d75b2ee65(callback, (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(timeout));
}



function $02609ec916d1eee0$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $991c7d0bcacd699c$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $65e8d3d378a9947e$export$605d60a2578142d3)(value) ? value : (0, $4b2846f88af5423d$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $b414a5ed52d2ead3$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}









const $691a2a8b4741efa1$var$metrics = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
const $691a2a8b4741efa1$var$isDebug = typeof window !== "undefined" && window.MotionDebug !== undefined;
const $691a2a8b4741efa1$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $691a2a8b4741efa1$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $691a2a8b4741efa1$var$animationTarget = 1000;
let $691a2a8b4741efa1$var$id = 0;
function $691a2a8b4741efa1$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues  } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $691a2a8b4741efa1$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement  } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $a2e0096f48bfe337$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout , layoutId: layoutId  } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $301e135f87ffeb5c$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent  } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $691a2a8b4741efa1$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $691a2a8b4741efa1$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener , defaultParent: defaultParent , measureScroll: measureScroll , checkIsScrollRoot: checkIsScrollRoot , resetTransform: resetTransform  }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $691a2a8b4741efa1$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ($691a2a8b4741efa1$var$isDebug) $691a2a8b4741efa1$var$metrics.totalNodes = $691a2a8b4741efa1$var$metrics.resolvedTargetDeltas = $691a2a8b4741efa1$var$metrics.recalculatedProjection = 0;
                this.nodes.forEach($691a2a8b4741efa1$export$131f2f0cc5fe9609);
                this.nodes.forEach($691a2a8b4741efa1$var$resolveTargetDelta);
                this.nodes.forEach($691a2a8b4741efa1$var$calcProjection);
                this.nodes.forEach($691a2a8b4741efa1$export$c2664f37bc951031);
                if ($691a2a8b4741efa1$var$isDebug) window.MotionDebug.record($691a2a8b4741efa1$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $06918006e178146a$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $97358bb0f01597b3$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $02609ec916d1eee0$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId , layout: layout , visualElement: visualElement  } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $ada4fe415778225f$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $d92fcbc1a711d121$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $d92fcbc1a711d121$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($691a2a8b4741efa1$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta , hasLayoutChanged: hasLayoutChanged , hasRelativeTargetChanged: hasRelativeTargetChanged , layout: newLayout  })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $691a2a8b4741efa1$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart , onLayoutAnimationComplete: onLayoutAnimationComplete  } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $62d95540b2cf82c6$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $32a29353ee2b3961$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $691a2a8b4741efa1$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $301e135f87ffeb5c$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($691a2a8b4741efa1$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement  } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $691a2a8b4741efa1$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId , layout: layout  } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($691a2a8b4741efa1$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($691a2a8b4741efa1$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($691a2a8b4741efa1$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($691a2a8b4741efa1$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($691a2a8b4741efa1$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $960d9779faf6f40c$export$2da9be4cfdb689b1).now();
            (0, $301e135f87ffeb5c$export$fff89137e9e818ce).delta = (0, $b55556710a8b54c0$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $301e135f87ffeb5c$export$fff89137e9e818ce).timestamp);
            (0, $301e135f87ffeb5c$export$fff89137e9e818ce).timestamp = now;
            (0, $301e135f87ffeb5c$export$fff89137e9e818ce).isProcessing = true;
            (0, $301e135f87ffeb5c$export$1811c3a7e3af92f0).update.process((0, $301e135f87ffeb5c$export$fff89137e9e818ce));
            (0, $301e135f87ffeb5c$export$1811c3a7e3af92f0).preRender.process((0, $301e135f87ffeb5c$export$fff89137e9e818ce));
            (0, $301e135f87ffeb5c$export$1811c3a7e3af92f0).render.process((0, $301e135f87ffeb5c$export$fff89137e9e818ce));
            (0, $301e135f87ffeb5c$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $a1ef008917ac1826$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($691a2a8b4741efa1$var$clearSnapshot);
            this.sharedNodes.forEach($691a2a8b4741efa1$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $301e135f87ffeb5c$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement  } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $62d95540b2cf82c6$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $43492ab836cff22d$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $691a2a8b4741efa1$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            var _a;
            const { visualElement: visualElement  } = this.options;
            if (!visualElement) return (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) || this.path.some($691a2a8b4741efa1$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll  } = this.root;
                if (scroll) {
                    (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            var _a;
            const boxWithoutScroll = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            (0, $350541e2d10af992$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll , options: options  } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $350541e2d10af992$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            (0, $350541e2d10af992$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $3cadfa9c5538c02d$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $43492ab836cff22d$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $3cadfa9c5538c02d$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $43492ab836cff22d$export$a545127cf1fbb600)(this.latestValues)) (0, $3cadfa9c5538c02d$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            (0, $350541e2d10af992$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $43492ab836cff22d$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $43492ab836cff22d$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $350541e2d10af992$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $e3be0578d1881dff$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $43492ab836cff22d$export$a545127cf1fbb600)(this.latestValues)) (0, $e3be0578d1881dff$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $301e135f87ffeb5c$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout , layoutId: layoutId  } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $301e135f87ffeb5c$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    (0, $a1e42a4af2333fb7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $350541e2d10af992$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $a1e42a4af2333fb7$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $350541e2d10af992$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $3cadfa9c5538c02d$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $350541e2d10af992$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    (0, $a1e42a4af2333fb7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $350541e2d10af992$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ($691a2a8b4741efa1$var$isDebug) $691a2a8b4741efa1$var$metrics.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $43492ab836cff22d$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $43492ab836cff22d$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $301e135f87ffeb5c$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout , layoutId: layoutId  } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $350541e2d10af992$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $3cadfa9c5538c02d$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            }
            const { target: target  } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $350541e2d10af992$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $350541e2d10af992$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $a1e42a4af2333fb7$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $62d95540b2cf82c6$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $62d95540b2cf82c6$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ($691a2a8b4741efa1$var$isDebug) $691a2a8b4741efa1$var$metrics.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a;
            (_a = this.options.visualElement) === null || _a === void 0 || _a.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $704cbd53c53f9d5c$export$3d227df54007d73a)();
            this.projectionDelta = (0, $704cbd53c53f9d5c$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $704cbd53c53f9d5c$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $704cbd53c53f9d5c$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($691a2a8b4741efa1$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $691a2a8b4741efa1$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $691a2a8b4741efa1$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $a1e42a4af2333fb7$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $691a2a8b4741efa1$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $62d95540b2cf82c6$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    (0, $350541e2d10af992$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $b0eff65bd8993999$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $301e135f87ffeb5c$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $301e135f87ffeb5c$export$2cef06c20297c17d).update(()=>{
                (0, $d92fcbc1a711d121$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $991c7d0bcacd699c$export$335a17c977067b99)(0, $691a2a8b4741efa1$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($691a2a8b4741efa1$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms , target: target , layout: layout , latestValues: latestValues  } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $691a2a8b4741efa1$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                const xLength = (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $350541e2d10af992$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $3cadfa9c5538c02d$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $a1e42a4af2333fb7$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $b677bc2ebc452ee9$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId  } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId  } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId  } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset , transition: transition , preserveFollowOpacity: preserveFollowOpacity  } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement  } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues  } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $691a2a8b4741efa1$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $691a2a8b4741efa1$var$transformAxes.length; i++){
                $691a2a8b4741efa1$var$resetDistortingTransform(`rotate${$691a2a8b4741efa1$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $691a2a8b4741efa1$var$resetDistortingTransform(`skew${$691a2a8b4741efa1$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $691a2a8b4741efa1$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $a6687c7d507e2d36$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $a6687c7d507e2d36$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $43492ab836cff22d$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $e1a92a4c0809d32f$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x , y: y  } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $93099dc5c3aa7524$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct , applyTo: applyTo  } = (0, $93099dc5c3aa7524$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $a6687c7d507e2d36$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($691a2a8b4741efa1$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $691a2a8b4741efa1$var$updateLayout(node) {
    node.updateLayout();
}
function $691a2a8b4741efa1$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout , measuredBox: measuredLayout  } = node.layout;
        const { animationType: animationType  } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($691a2a8b4741efa1$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $704cbd53c53f9d5c$export$3d227df54007d73a)();
        (0, $a1e42a4af2333fb7$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $704cbd53c53f9d5c$export$3d227df54007d73a)();
        if (isShared) (0, $a1e42a4af2333fb7$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $a1e42a4af2333fb7$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $62d95540b2cf82c6$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot , layout: parentLayout  } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    (0, $a1e42a4af2333fb7$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    (0, $a1e42a4af2333fb7$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $62d95540b2cf82c6$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete  } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $691a2a8b4741efa1$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ($691a2a8b4741efa1$var$isDebug) $691a2a8b4741efa1$var$metrics.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $691a2a8b4741efa1$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $691a2a8b4741efa1$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $691a2a8b4741efa1$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $691a2a8b4741efa1$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $691a2a8b4741efa1$var$resetTransformStyle(node) {
    const { visualElement: visualElement  } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $691a2a8b4741efa1$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $691a2a8b4741efa1$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $691a2a8b4741efa1$var$calcProjection(node) {
    node.calcProjection();
}
function $691a2a8b4741efa1$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $691a2a8b4741efa1$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $691a2a8b4741efa1$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $691a2a8b4741efa1$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $691a2a8b4741efa1$export$6ffd3e6ae339a132(output, from, to, p) {
    $691a2a8b4741efa1$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $691a2a8b4741efa1$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $691a2a8b4741efa1$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $691a2a8b4741efa1$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $691a2a8b4741efa1$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $691a2a8b4741efa1$var$roundPoint = $691a2a8b4741efa1$var$userAgentContains("applewebkit/") && !$691a2a8b4741efa1$var$userAgentContains("chrome/") ? Math.round : (0, $6975d23d92ef960e$export$8793edee2d425525);
function $691a2a8b4741efa1$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $691a2a8b4741efa1$var$roundPoint(axis.min);
    axis.max = $691a2a8b4741efa1$var$roundPoint(axis.max);
}
function $691a2a8b4741efa1$var$roundBox(box) {
    $691a2a8b4741efa1$var$roundAxis(box.x);
    $691a2a8b4741efa1$var$roundAxis(box.y);
}
function $691a2a8b4741efa1$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $a1e42a4af2333fb7$export$28d0384c4b79bde2)((0, $62d95540b2cf82c6$export$c5706146bc63213)(snapshot), (0, $62d95540b2cf82c6$export$c5706146bc63213)(layout), 0.2);
}
function $691a2a8b4741efa1$var$checkNodeWasScrollRoot(node) {
    var _a;
    return node !== node.root && ((_a = node.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot);
}




const $26dc2139c924a231$export$2d029a49a09b6177 = (0, $691a2a8b4741efa1$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $a8c57a49f398792d$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $89f9370edb229af5$export$b91509fcf893b648 = {
    current: undefined
};
const $89f9370edb229af5$export$b61a9eb3dbde8858 = (0, $691a2a8b4741efa1$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$89f9370edb229af5$export$b91509fcf893b648.current) {
            const documentNode = new (0, $26dc2139c924a231$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $89f9370edb229af5$export$b91509fcf893b648.current = documentNode;
        }
        return $89f9370edb229af5$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $be25e9ea22024a07$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $07770208fc6498da$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $aedcddc2627aa96c$export$5d97dc2872682820),
        ProjectionNode: (0, $89f9370edb229af5$export$b61a9eb3dbde8858),
        MeasureLayout: $c3c24be56499347e$export$779f5fb01ad751cd
    }
};






function $4eb998171579f70f$var$handleHoverEvent(node, event, lifecycle) {
    const { props: props  } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $19290b72856733e8$export$12f84bb882d06e1a)(event)));
}
class $4eb998171579f70f$export$93a81ea037eac456 extends (0, $c280630d94a7df00$export$6e91cf7616333d5) {
    mount() {
        const { current: current  } = this.node;
        if (!current) return;
        this.unmount = (0, $d31b8a36e1731954$export$3f60957f5dbf3876)(current, (startEvent)=>{
            $4eb998171579f70f$var$handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>$4eb998171579f70f$var$handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}





class $f67fa3b39a62de2d$export$d4826db40d47595b extends (0, $c280630d94a7df00$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $3e3ea55737c24d5c$export$a4627e546088548d)((0, $a8c57a49f398792d$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $a8c57a49f398792d$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}






function $b8443dc0347df040$var$handlePressEvent(node, event, lifecycle) {
    const { props: props  } = node;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $19290b72856733e8$export$12f84bb882d06e1a)(event)));
}
class $b8443dc0347df040$export$f026abdbba7f0c9e extends (0, $c280630d94a7df00$export$6e91cf7616333d5) {
    mount() {
        const { current: current  } = this.node;
        if (!current) return;
        this.unmount = (0, $f444734fe50af5ec$export$dbe9198142dace0c)(current, (startEvent)=>{
            $b8443dc0347df040$var$handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success: success  })=>$b8443dc0347df040$var$handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: this.node.props.globalTapTarget
        });
    }
    unmount() {}
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $6e6be83e8d5cf4f5$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $6e6be83e8d5cf4f5$var$observers = new WeakMap();
const $6e6be83e8d5cf4f5$var$fireObserverCallback = (entry)=>{
    const callback = $6e6be83e8d5cf4f5$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $6e6be83e8d5cf4f5$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($6e6be83e8d5cf4f5$var$fireObserverCallback);
};
function $6e6be83e8d5cf4f5$var$initIntersectionObserver({ root: root , ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$6e6be83e8d5cf4f5$var$observers.has(lookupRoot)) $6e6be83e8d5cf4f5$var$observers.set(lookupRoot, {});
    const rootObservers = $6e6be83e8d5cf4f5$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($6e6be83e8d5cf4f5$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $6e6be83e8d5cf4f5$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $6e6be83e8d5cf4f5$var$initIntersectionObserver(options);
    $6e6be83e8d5cf4f5$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $6e6be83e8d5cf4f5$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $da2908b1137e754a$var$thresholdNames = {
    some: 0,
    all: 1
};
class $da2908b1137e754a$export$150851c8cc2f0c72 extends (0, $c280630d94a7df00$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {}  } = this.node.getProps();
        const { root: root , margin: rootMargin , amount: amount = "some" , once: once  } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $da2908b1137e754a$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting  } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter , onViewportLeave: onViewportLeave  } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $6e6be83e8d5cf4f5$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props , prevProps: prevProps  } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($da2908b1137e754a$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $da2908b1137e754a$var$hasViewportOptionChanged({ viewport: viewport = {}  }, { viewport: prevViewport = {}  } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $60b1baafc37a77f3$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $da2908b1137e754a$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $b8443dc0347df040$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $f67fa3b39a62de2d$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $4eb998171579f70f$export$93a81ea037eac456)
    }
};




const $f035b7047036e216$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $89f9370edb229af5$export$b61a9eb3dbde8858),
        MeasureLayout: $c3c24be56499347e$export$779f5fb01ad751cd
    }
};




var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
"use client";
/**
 * @public
 */ const $2d642de93cca1124$export$22a697fb29aac98d = (0, $exYeM.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $exYeM = parcelRequire("exYeM");
"use client";
const $9a6e4e852eb4f373$export$2285bbca2c666415 = (0, $exYeM.createContext)({});



var $exYeM = parcelRequire("exYeM");



var $exYeM = parcelRequire("exYeM");
const $c763d68aeba74b31$export$4e09c449d6c407f7 = typeof window !== "undefined";


const $0e2d049f2abcd2c9$export$700979bc83e7db82 = (0, $c763d68aeba74b31$export$4e09c449d6c407f7) ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect);



var $exYeM = parcelRequire("exYeM");
"use client";
const $1cdfc9563e072a56$export$40f10139ecf1f171 = (0, $exYeM.createContext)({
    strict: false
});







function $d1d2872af74835eb$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    var _a, _b;
    const { visualElement: parent  } = (0, $exYeM.useContext)((0, $9a6e4e852eb4f373$export$2285bbca2c666415));
    const lazyContext = (0, $exYeM.useContext)((0, $1cdfc9563e072a56$export$40f10139ecf1f171));
    const presenceContext = (0, $exYeM.useContext)((0, $32835478aabc17b5$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $exYeM.useContext)((0, $2d642de93cca1124$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $exYeM.useRef)(null);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $exYeM.useContext)((0, $df9c3e45a16d5ebc$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $d1d2872af74835eb$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $exYeM.useRef)(false);
    (0, $exYeM.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $99c2b47e65be39f1$export$8592e1c077c890a6];
    const wantsHandoff = (0, $exYeM.useRef)(Boolean(optimisedAppearId) && !((_a = window.MotionHandoffIsComplete) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId)) && ((_b = window.MotionHasOptimisedAnimation) === null || _b === void 0 ? void 0 : _b.call(window, optimisedAppearId)));
    (0, $0e2d049f2abcd2c9$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        (0, $a1ef008917ac1826$export$bb76eed83315504c).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $exYeM.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                var _a;
                (_a = window.MotionHandoffMarkAsComplete) === null || _a === void 0 || _a.call(window, optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
    });
    return visualElement;
}
function $d1d2872af74835eb$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId , layout: layout , drag: drag , dragConstraints: dragConstraints , layoutScroll: layoutScroll , layoutRoot: layoutRoot  } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $d1d2872af74835eb$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $7be42aa7b9b2349b$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $d1d2872af74835eb$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $d1d2872af74835eb$var$getClosestProjectingNode(visualElement.parent);
}



var $exYeM = parcelRequire("exYeM");

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $3e0b35cdea07cd56$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $exYeM.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $7be42aa7b9b2349b$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $exYeM = parcelRequire("exYeM");





function $6d3c07e99f9f7e5a$export$4b3c3bd8d910d78d(props) {
    return (0, $0c915d7372d9814d$export$aa71198ceeaf53ce)(props.animate) || (0, $46d8d186c05e43b0$export$1405a65085f40b9).some((name)=>(0, $a36779356b36fa8a$export$720b90e312cea233)(props[name]));
}
function $6d3c07e99f9f7e5a$export$ce46fa4165cdec40(props) {
    return Boolean($6d3c07e99f9f7e5a$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $d9dc1d37927f1414$export$12fc32fc096a04a3(props, context) {
    if ((0, $6d3c07e99f9f7e5a$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial , animate: animate  } = props;
        return {
            initial: initial === false || (0, $a36779356b36fa8a$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $a36779356b36fa8a$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $1fba5faa46b4b8c9$export$c5638d843b37a176(props) {
    const { initial: initial , animate: animate  } = (0, $d9dc1d37927f1414$export$12fc32fc096a04a3)(props, (0, $exYeM.useContext)((0, $9a6e4e852eb4f373$export$2285bbca2c666415)));
    return (0, $exYeM.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $1fba5faa46b4b8c9$var$variantLabelsAsDependency(initial),
        $1fba5faa46b4b8c9$var$variantLabelsAsDependency(animate)
    ]);
}
function $1fba5faa46b4b8c9$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $f7fe4e10b799a8b2$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $f7fe4e10b799a8b2$export$65570e08d843624d = {};
for(const key in $f7fe4e10b799a8b2$var$featureProps)$f7fe4e10b799a8b2$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$f7fe4e10b799a8b2$var$featureProps[key].some((name)=>!!props[name])
};


function $ffc510cd2c0997fc$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $f7fe4e10b799a8b2$export$65570e08d843624d)[key] = {
        ...(0, $f7fe4e10b799a8b2$export$65570e08d843624d)[key],
        ...features[key]
    };
}





const $352246c6734b361d$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");




"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $002ee5308395fa07$export$c3ad4a902bccc2d8({ preloadedFeatures: preloadedFeatures , createVisualElement: createVisualElement , useRender: useRender , useVisualState: useVisualState , Component: Component  }) {
    preloadedFeatures && (0, $ffc510cd2c0997fc$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $exYeM.useContext)((0, $2d642de93cca1124$export$22a697fb29aac98d)),
            ...props,
            layoutId: $002ee5308395fa07$var$useLayoutId(props)
        };
        const { isStatic: isStatic  } = configAndProps;
        const context = (0, $1fba5faa46b4b8c9$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $c763d68aeba74b31$export$4e09c449d6c407f7)) {
            $002ee5308395fa07$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $002ee5308395fa07$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $d1d2872af74835eb$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $7ead0b1397a835ed$exports.jsxs)((0, $9a6e4e852eb4f373$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $7ead0b1397a835ed$exports.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $3e0b35cdea07cd56$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    const ForwardRefMotionComponent = (0, $exYeM.forwardRef)(MotionComponent);
    ForwardRefMotionComponent[0, $352246c6734b361d$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $002ee5308395fa07$var$useLayoutId({ layoutId: layoutId  }) {
    const layoutGroupId = (0, $exYeM.useContext)((0, $0d8fa753a19a110b$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $002ee5308395fa07$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $exYeM.useContext)((0, $1cdfc9563e072a56$export$40f10139ecf1f171)).strict;
}
function $002ee5308395fa07$var$getProjectionFunctionality(props) {
    const { drag: drag , layout: layout  } = (0, $f7fe4e10b799a8b2$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}


/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $3382724af6d1489a$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $9c5a7490b01b42fd$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $3382724af6d1489a$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}



function $4d3a9c3652fbcbe3$export$1a32bf6229c258c0(element, { style: style , vars: vars  }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $53f5831d8ff6fe26$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $6ecc69af052e005d$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $4d3a9c3652fbcbe3$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $53f5831d8ff6fe26$export$28931db5d57958e5).has(key) ? (0, $ccc055b4a72c1347$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $57cc9ca03e37ffaf$export$6d27ce8e3de1c3cf(key, { layout: layout , layoutId: layoutId  }) {
    return (0, $da211e07316d6e39$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $93099dc5c3aa7524$export$91ddd985b97788d1)[key] || key === "opacity");
}



function $e87aa36d3552d0b1$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style  } = props;
    const newValues = {};
    for(const key in style)if ((0, $65e8d3d378a9947e$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $65e8d3d378a9947e$export$605d60a2578142d3)(prevProps.style[key]) || (0, $57cc9ca03e37ffaf$export$6d27ce8e3de1c3cf)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}



function $4c74588f3910fe04$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $e87aa36d3552d0b1$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $65e8d3d378a9947e$export$605d60a2578142d3)(props[key]) || (0, $65e8d3d378a9947e$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $da211e07316d6e39$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $exYeM = parcelRequire("exYeM");




var $exYeM = parcelRequire("exYeM");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $73d7e626f45c1838$export$fe4300aa8eebea86(init) {
    const ref = (0, $exYeM.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}





function $30ccd5a4894de23b$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps , createRenderState: createRenderState , onMount: onMount  }, props, context, presenceContext) {
    const state = {
        latestValues: $30ccd5a4894de23b$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $30ccd5a4894de23b$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $exYeM.useContext)((0, $9a6e4e852eb4f373$export$2285bbca2c666415));
        const presenceContext = (0, $exYeM.useContext)((0, $32835478aabc17b5$export$f224e4635b6f8ce2));
        const make = ()=>$30ccd5a4894de23b$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $73d7e626f45c1838$export$fe4300aa8eebea86)(make);
    };
function $30ccd5a4894de23b$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $a6687c7d507e2d36$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial , animate: animate  } = props;
    const isControllingVariants$1 = (0, $6d3c07e99f9f7e5a$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $6d3c07e99f9f7e5a$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $0c915d7372d9814d$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $1527d424ce16b34c$export$d68f140c4d9b48bc)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd , transition: transition , ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}


const $43cb856997daead8$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


const $93153305d91bad5b$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $43cb856997daead8$export$8940b483cf52eeda)(),
        attrs: {}
    });



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $6a51529d989adf9c$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};



const $9384da345cfe955b$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $9384da345cfe955b$var$numTransforms = (0, $da211e07316d6e39$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $9384da345cfe955b$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $9384da345cfe955b$var$numTransforms; i++){
        const key = (0, $da211e07316d6e39$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $6a51529d989adf9c$export$453ef540a9a1bd6b)(value, (0, $0d74cfa63198be03$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $9384da345cfe955b$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}






function $d5a7ccaf3657bbce$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style , vars: vars , transformOrigin: transformOrigin  } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $da211e07316d6e39$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $7788fac55eb8bc79$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $6a51529d989adf9c$export$453ef540a9a1bd6b)(value, (0, $0d74cfa63198be03$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $9384da345cfe955b$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%" , originY: originY = "50%" , originZ: originZ = 0  } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}



function $de9ca7d9f74b1dc4$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $de9ca7d9f74b1dc4$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $de9ca7d9f74b1dc4$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $de9ca7d9f74b1dc4$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $ecef2446ddaf0120$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $ecef2446ddaf0120$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $ecef2446ddaf0120$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $ecef2446ddaf0120$var$dashKeys : $ecef2446ddaf0120$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $22afbc6679b4fb16$export$5475d24f125d7053(state, { attrX: attrX , attrY: attrY , attrScale: attrScale , originX: originX , originY: originY , pathLength: pathLength , pathSpacing: pathSpacing = 1 , pathOffset: pathOffset = 0 , // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $d5a7ccaf3657bbce$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs , style: style , dimensions: dimensions  } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $de9ca7d9f74b1dc4$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $ecef2446ddaf0120$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}


const $e49695f00398c04d$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";



const $a38e3c634edf90c1$export$44dabd3fae512e85 = {
    useVisualState: (0, $30ccd5a4894de23b$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $4c74588f3910fe04$export$16da615486abaa45),
        createRenderState: (0, $93153305d91bad5b$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState , latestValues: latestValues  })=>{
            (0, $301e135f87ffeb5c$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $301e135f87ffeb5c$export$2cef06c20297c17d).render(()=>{
                (0, $22afbc6679b4fb16$export$5475d24f125d7053)(renderState, latestValues, (0, $e49695f00398c04d$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $6ecc69af052e005d$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $7e738ddebc5e1ace$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $30ccd5a4894de23b$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $e87aa36d3552d0b1$export$16da615486abaa45,
        createRenderState: (0, $43cb856997daead8$export$8940b483cf52eeda)
    })
};



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");




function $582c92f88e1a1e68$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $65e8d3d378a9947e$export$605d60a2578142d3)(source[key]) && !(0, $57cc9ca03e37ffaf$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $582c92f88e1a1e68$var$useInitialMotionValues({ transformTemplate: transformTemplate  }, visualState) {
    return (0, $exYeM.useMemo)(()=>{
        const state = (0, $43cb856997daead8$export$8940b483cf52eeda)();
        (0, $d5a7ccaf3657bbce$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $582c92f88e1a1e68$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $582c92f88e1a1e68$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $582c92f88e1a1e68$var$useInitialMotionValues(props, visualState));
    return style;
}
function $582c92f88e1a1e68$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $582c92f88e1a1e68$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $1f4002463fc06750$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $1f4002463fc06750$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $1f4002463fc06750$var$validMotionProps.has(key);
}


let $a52b0ca54619c60e$var$shouldForward = (key)=>!(0, $1f4002463fc06750$export$2f9c46555243bf04)(key);
function $a52b0ca54619c60e$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $a52b0ca54619c60e$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $1f4002463fc06750$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $a52b0ca54619c60e$export$59d6962c470509a5((parcelRequire("3U6by")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $a52b0ca54619c60e$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($a52b0ca54619c60e$var$shouldForward(key) || forwardMotionProps === true && (0, $1f4002463fc06750$export$2f9c46555243bf04)(key) || !isDom && !(0, $1f4002463fc06750$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $exYeM = parcelRequire("exYeM");




function $678da409a301bad8$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $exYeM.useMemo)(()=>{
        const state = (0, $93153305d91bad5b$export$41be8b43e1c4d4f9)();
        (0, $22afbc6679b4fb16$export$5475d24f125d7053)(state, visualState, (0, $e49695f00398c04d$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $582c92f88e1a1e68$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $9f5d406889886ff1$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues  }, isStatic)=>{
        const useVisualProps = (0, $9c5a7490b01b42fd$export$88f3fc2fd3766989)(Component) ? (0, $678da409a301bad8$export$84309c4f53cb1bd5) : (0, $582c92f88e1a1e68$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $a52b0ca54619c60e$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $exYeM.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children  } = props;
        const renderedChildren = (0, $exYeM.useMemo)(()=>(0, $65e8d3d378a9947e$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $exYeM.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}


function $6bc3566853bd9151$export$d86feac869a7f0d5(preloadedFeatures, createVisualElement) {
    return function createMotionComponent(Component, { forwardMotionProps: forwardMotionProps  } = {
        forwardMotionProps: false
    }) {
        const baseConfig = (0, $9c5a7490b01b42fd$export$88f3fc2fd3766989)(Component) ? (0, $a38e3c634edf90c1$export$44dabd3fae512e85) : (0, $7e738ddebc5e1ace$export$e13ea21d87ea57c8);
        const config = {
            ...baseConfig,
            preloadedFeatures: preloadedFeatures,
            useRender: (0, $9f5d406889886ff1$export$5d29104eefd89cc8)(forwardMotionProps),
            createVisualElement: createVisualElement,
            Component: Component
        };
        return (0, $002ee5308395fa07$export$c3ad4a902bccc2d8)(config);
    };
}



var $exYeM = parcelRequire("exYeM");








// Does this device prefer reduced motion? Returns `null` server-side.
const $51b97d8ce853ec4e$export$ff7706047246b98b = {
    current: null
};
const $51b97d8ce853ec4e$export$6476d16e2fd2d0db = {
    current: false
};


function $aec9488d77744f8a$export$ca9f41fb23dded3d() {
    (0, $51b97d8ce853ec4e$export$6476d16e2fd2d0db).current = true;
    if (!(0, $c763d68aeba74b31$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $51b97d8ce853ec4e$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $51b97d8ce853ec4e$export$ff7706047246b98b).current = false;
}











function $36e186eef14354e1$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $65e8d3d378a9947e$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $65e8d3d378a9947e$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $4b2846f88af5423d$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $4b2846f88af5423d$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}





const $2a8cc64b32f75635$export$bc2a978a17abfdde = new WeakMap();









/**
 * A list of all ValueTypes
 */ const $b271d9f56e72d485$var$valueTypes = [
    ...(0, $b2fd586ec5020ed9$export$d176691c1998a1f5),
    (0, $9aa3b4c939055303$export$35e9368ef982300f),
    (0, $20185419c445ef46$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $b271d9f56e72d485$export$950e7e59ea1ffed7 = (v)=>$b271d9f56e72d485$var$valueTypes.find((0, $0a85921ea474cb14$export$6eae4d0a6a7ca7cd)(v));







const $47882417e3714d5d$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $47882417e3714d5d$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent , props: props , presenceContext: presenceContext , reducedMotionConfig: reducedMotionConfig , blockInitialAnimation: blockInitialAnimation , visualState: visualState  }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $80c84fe89f88d202$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $960d9779faf6f40c$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $301e135f87ffeb5c$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues , renderState: renderState  } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $6d3c07e99f9f7e5a$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $6d3c07e99f9f7e5a$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange , ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $65e8d3d378a9947e$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $2a8cc64b32f75635$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $51b97d8ce853ec4e$export$6476d16e2fd2d0db).current) (0, $aec9488d77744f8a$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $51b97d8ce853ec4e$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $2a8cc64b32f75635$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $301e135f87ffeb5c$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $301e135f87ffeb5c$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $da211e07316d6e39$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $301e135f87ffeb5c$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $f7fe4e10b799a8b2$export$65570e08d843624d){
            const featureDefinition = (0, $f7fe4e10b799a8b2$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled , Feature: FeatureConstructor  } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $47882417e3714d5d$var$propEventHandlers.length; i++){
            const key = $47882417e3714d5d$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $36e186eef14354e1$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $4b2846f88af5423d$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $fe062db003bcffb8$export$65583ed5a868f2d9)(value) || (0, $dc25af1e857ab50f$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $b271d9f56e72d485$export$950e7e59ea1ffed7)(value) && (0, $20185419c445ef46$export$83a0e34f1302825b).test(target)) value = (0, $f39674aa42131bf6$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $65e8d3d378a9947e$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $65e8d3d378a9947e$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial  } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $1527d424ce16b34c$export$d68f140c4d9b48bc)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $65e8d3d378a9947e$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $97358bb0f01597b3$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}




class $8825121c87528f05$export$e49735c2a366bdc7 extends (0, $47882417e3714d5d$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $891e5637f91f7d52$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars , style: style  }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children  } = this.props;
        if ((0, $65e8d3d378a9947e$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}


function $b877597daa557132$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $b877597daa557132$export$23fea75b03ac16b3 extends (0, $8825121c87528f05$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $4d3a9c3652fbcbe3$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $da211e07316d6e39$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $10ea5fd01401393b$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $b877597daa557132$export$3735103072e4a80(instance);
            const value = ((0, $7788fac55eb8bc79$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint  }) {
        return (0, $5df6dc38d07b7e46$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $d5a7ccaf3657bbce$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $e87aa36d3552d0b1$export$16da615486abaa45)(props, prevProps, visualElement);
    }
}












class $83f9c44d75db63b5$export$86bcdffbaf733d84 extends (0, $8825121c87528f05$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $da211e07316d6e39$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $10ea5fd01401393b$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $53f5831d8ff6fe26$export$28931db5d57958e5).has(key) ? (0, $ccc055b4a72c1347$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $4c74588f3910fe04$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $22afbc6679b4fb16$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $6ecc69af052e005d$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $e49695f00398c04d$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $38a6ac1b54bc169a$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $9c5a7490b01b42fd$export$88f3fc2fd3766989)(Component) ? new (0, $83f9c44d75db63b5$export$86bcdffbaf733d84)(options) : new (0, $b877597daa557132$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $exYeM.Fragment)
    });
};


const $32294d7c46943a4b$export$46b7e4b9dc6110c3 = /*@__PURE__*/ (0, $6bc3566853bd9151$export$d86feac869a7f0d5)({
    ...(0, $7170ce59c2debd45$export$7f9953c70dacfd7f),
    ...(0, $60b1baafc37a77f3$export$e5b72898e5a201f1),
    ...(0, $be25e9ea22024a07$export$d7d5d435647ed5a0),
    ...(0, $f035b7047036e216$export$b3219800bda33a1f)
}, (0, $38a6ac1b54bc169a$export$56ba0183203348f5));


const $b69fff25ce30e449$export$e25e478948902b8b = /*@__PURE__*/ (0, $8afca7df5ddc3462$export$3af29c0efb268f04)((0, $32294d7c46943a4b$export$46b7e4b9dc6110c3));


function $015b2e8c7c0a3e59$var$Body() {
    const { moveHistory: moveHistory  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $b0893505d0f7ae16$export$58d75f9829cbe158));
    var whiteToMove = moveHistory.length % 2 === 0;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($015b2e8c7c0a3e59$var$Content, {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($015b2e8c7c0a3e59$var$Wrapper2, {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($015b2e8c7c0a3e59$var$BoardWrapper, {
                        layout: true,
                        initial: {
                            flex: 70,
                            marginTop: "0",
                            opacity: 1
                        },
                        animate: {
                            flex: whiteToMove ? 70 : 60,
                            marginTop: whiteToMove ? "0" : "50px",
                            opacity: whiteToMove ? 1.0 : 0.65
                        },
                        transition: {
                            duration: 0.5
                        },
                        flex: whiteToMove ? 70 : 60,
                        marginTop: whiteToMove ? "0" : "50px",
                        opacity: whiteToMove ? 1.0 : 0.65,
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5c0184adcefda2ca$export$2e2bcd8739ae039), {
                            boardId: "1",
                            initialOrientation: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($015b2e8c7c0a3e59$var$BoardWrapper, {
                        layout: true,
                        initial: {
                            flex: 60,
                            marginTop: "50px",
                            opacity: 0.65
                        },
                        animate: {
                            flex: whiteToMove ? 60 : 70,
                            marginTop: whiteToMove ? "50px" : "0",
                            opacity: whiteToMove ? 0.65 : 1
                        },
                        transition: {
                            duration: 0.5
                        },
                        flex: whiteToMove ? 60 : 70,
                        marginTop: whiteToMove ? "50px" : "0",
                        opacity: whiteToMove ? 0.65 : 1,
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5c0184adcefda2ca$export$2e2bcd8739ae039), {
                            boardId: "2",
                            initialOrientation: "black"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($015b2e8c7c0a3e59$var$MoveTableWrapper, {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $df67e871f2d6d0f9$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
const $015b2e8c7c0a3e59$var$ToMoveWrapper = (0, $93948c98236af5c1$export$2e2bcd8739ae039).span`
  color: white;
`;
const $015b2e8c7c0a3e59$var$Wrapper2 = (0, $93948c98236af5c1$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;
`;
const $015b2e8c7c0a3e59$var$BoardWrapper = (0, $93948c98236af5c1$export$2e2bcd8739ae039)((0, $b69fff25ce30e449$export$e25e478948902b8b).div)`
  flex: ${(props)=>props.flex};
  background-color: #161512;
  padding-top: 60px;
  padding-left: 50px;
  padding-right: 50px;
`;
const $015b2e8c7c0a3e59$var$MoveTableWrapper = (0, $93948c98236af5c1$export$2e2bcd8739ae039).div`
  flex: 15;
  background-color: #161512;
`;
const $015b2e8c7c0a3e59$var$Content = (0, $93948c98236af5c1$export$2e2bcd8739ae039).div`
  display: flex;
  height: 100%;
`;
var $015b2e8c7c0a3e59$export$2e2bcd8739ae039 = $015b2e8c7c0a3e59$var$Body;





function $adee9df12d2c2787$var$App() {
    return(// <UserProvider>
    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0893505d0f7ae16$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($adee9df12d2c2787$var$Wrapper, {
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a99fe579ed49bdad$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $015b2e8c7c0a3e59$export$2e2bcd8739ae039), {})
            ]
        })
    }));
}
var $adee9df12d2c2787$export$2e2bcd8739ae039 = $adee9df12d2c2787$var$App;
const $adee9df12d2c2787$var$Wrapper = (0, $93948c98236af5c1$export$2e2bcd8739ae039).div`
  background-color: #161512;
  height: 100%;
`;






const $b8f9b7833fa37166$var$root = (0, $7bd215913159ea08$export$882461b6382ed46c)(document.querySelector("#root"));
$b8f9b7833fa37166$var$root.render(/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adee9df12d2c2787$export$2e2bcd8739ae039), {}));

})();
//# sourceMappingURL=index.cd975318.js.map
